/* This file is auto-generated. Do not modify it directly! */            

import * as Generated from "./types";

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '../utils/custom-apollo-hooks';
const defaultOptions = {} as const;
export const ImageFragmentDoc = /*#__PURE__*/ gql`
    fragment Image on Image {
  id
  url
  ref
}
    `;
export const MetadataUserFragmentDoc = /*#__PURE__*/ gql`
    fragment MetadataUser on User {
  __typename
  id
  ref
  name
}
    `;
export const MetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment Metadata on Metadata {
  origin
  createdAt
  updatedAt
  scheduledForDeletion
  createdBy {
    ...MetadataUser
  }
  updatedBy {
    ...MetadataUser
  }
}
    ${MetadataUserFragmentDoc}`;
export const BrandSearchLinkRowFragmentDoc = /*#__PURE__*/ gql`
    fragment BrandSearchLinkRow on BrandSearchLink {
  __typename
  id
  ref
  active
  title
  url
  description
  keywords
  brand {
    id
    ref
    name
  }
  poster {
    ...Image
  }
  metadata {
    ...Metadata
  }
}
    ${ImageFragmentDoc}
${MetadataFragmentDoc}`;
export const CarouselRowFragmentDoc = /*#__PURE__*/ gql`
    fragment CarouselRow on Carousel {
  id
  ref
  startsAt
  metadata {
    createdBy {
      ...MetadataUser
    }
  }
}
    ${MetadataUserFragmentDoc}`;
export const SlideRowFragmentDoc = /*#__PURE__*/ gql`
    fragment SlideRow on Slide {
  id
  ref
  title
  metadata {
    updatedAt
  }
  active
}
    `;
export const CountryOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment CountryOption on Country {
  __typename
  id
  ref
  name
  alpha2
}
    `;
export const ClockRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ClockRow on Clock {
  id
  ref
  metadata {
    ...Metadata
  }
  range {
    startsAt
    endsAt
  }
  showtimes
  technos
  amenity
  seatingStyle
  sound
  entity {
    __typename
    ... on Movie {
      id
      ref
      title
      productionYear
    }
  }
  theater {
    __typename
    id
    ref
    code
    country {
      ...CountryOption
      preferredClockFormat
    }
  }
}
    ${MetadataFragmentDoc}
${CountryOptionFragmentDoc}`;
export const CompanyTheaterFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyTheater on Theater {
  id
  code
  name
  openingStatus
  country {
    ...CountryOption
  }
  coordinates {
    latitude
    longitude
  }
  location {
    address
    zip
    city
    country
    state
    county
  }
}
    ${CountryOptionFragmentDoc}`;
export const CompanyOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyOption on Company {
  __typename
  id
  ref
  name
  country {
    ...CountryOption
  }
  activeOnBrands {
    ref
  }
}
    ${CountryOptionFragmentDoc}`;
export const DuplicateEntityLightFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateEntityLight on DuplicateEntity {
  __typename
  ... on Company {
    ...CompanyOption
  }
  ... on Movie {
    ref
    title
  }
  ... on Series {
    ref
    title
  }
  ... on Person {
    ref
    lastName
    firstName
  }
  ... on DeletedEntity {
    ref
    source {
      typename
      ref
    }
  }
}
    ${CompanyOptionFragmentDoc}`;
export const CopyrightIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyrightIdentity on Copyright {
  id
  name
}
    `;
export const ImageLocalizedIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageLocalizedIdentity on ImageLocaleData {
  __typename
  id
  ref
  title
  description
  locale
}
    `;
export const ImageDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageDetails on Image {
  id
  url
  ref
  height
  width
  mime
  size
  copyrightName
  copyrights {
    ...CopyrightIdentity
  }
  b2bCopyrightName
  b2bCopyrights {
    ...CopyrightIdentity
  }
  brandData(brandId: $brandId) @include(if: $withBrand) {
    id
    copyrightName
    copyrights {
      ...CopyrightIdentity
    }
    active
  }
  localizedData(localeId: $localeId) @include(if: $withLocale) {
    ...ImageLocalizedIdentity
  }
  relatedEntities {
    __typename
    ... on Movie {
      id
      ref
      title
    }
    ... on Series {
      id
      ref
      title
    }
    ... on SeriesSeason {
      id
      ref
      number
      series {
        id
        ref
        title
      }
    }
    ... on FestivalEdition {
      id
      ref
      name
      editionNumber
      year
      festival {
        id
        ref
        name
      }
    }
    ... on SeriesEpisode {
      id
      ref
      optionalTitle: title
      number
      series {
        id
        ref
        title
      }
      season {
        id
        ref
        number
      }
    }
    ... on Person {
      id
      ref
      firstName
      lastName
    }
  }
}
    ${CopyrightIdentityFragmentDoc}
${ImageLocalizedIdentityFragmentDoc}`;
export const ImageSuggestedLinksCastingFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageSuggestedLinksCasting on PersonCredits {
  role
  activity
  person {
    __typename
    id
    ref
    firstName
    lastName
  }
}
    `;
export const ImportWizardDashboardTotalsFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportWizardDashboardTotals on ImportWizardDashboardTotals {
  launched
  completed
  failed
  answered
  answeredAtLlmOrBrowser
  llmRuns
  localizedRuns
  localizationErrors
  llmCostUsd
  llmInputTokens
  llmOutputTokens
  durationMedianMs
  durationP95Ms
  localizationCostUsd
  localizationInputTokens
  localizationOutputTokens
  localizationDurationMedianMs
}
    `;
export const ImportWizardRunEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportWizardRunEntity on Entity {
  __typename
  id
  ... on Movie {
    ref
    title
  }
  ... on Series {
    ref
    title
  }
  ... on SeriesSeason {
    ref
    number
    series {
      id
      ref
      title
    }
  }
  ... on SeriesEpisode {
    ref
    number
    episodeTitle: title
    series {
      id
      ref
      title
    }
    season {
      id
      ref
      number
    }
  }
}
    `;
export const ImportConfigurationRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportConfigurationRow on ImportConfiguration {
  id
  enabled
  crawler {
    id
    name
    countries {
      ...CountryOption
    }
  }
  sourceId
  theaterMatcher
  entityMatcher
  nextRun
  lastRun {
    id
    status
    startTime
  }
  inheritsScreenAttributes
  linksOnly
  moviesOnly
  entity {
    __typename
    ... on Theater {
      name
      ref
    }
    ... on Company {
      ...CompanyOption
    }
  }
}
    ${CountryOptionFragmentDoc}
${CompanyOptionFragmentDoc}`;
export const ImportConfigurationIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportConfigurationIdentity on ImportConfiguration {
  id
  crawler {
    name
    notes
  }
  sourceId
  uri
  entityMatcher
  theaterMatcher
  enabled
  interval
  nextRun
  fetchedDays
  gathertimesTimeout
  inheritsScreenAttributes
  linksOnly
  moviesOnly
  parameters
  entity {
    __typename
    ... on Company {
      id
      ref
      name
      companyCountry: country {
        ...CountryOption
      }
    }
    ... on Theater {
      id
      ref
      name
      showtimeSource
      openingStatus
      temporaryClosure {
        startsAt
        endsAt
        message
      }
      location {
        city
        zip
      }
      country {
        ...CountryOption
      }
      parent {
        ...CompanyOption
      }
    }
  }
}
    ${CountryOptionFragmentDoc}
${CompanyOptionFragmentDoc}`;
export const ImportCrawlerWithConfigurationRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportCrawlerWithConfigurationRow on ImportCrawler {
  id
  name
  type
  countries {
    ...CountryOption
  }
  tags
  configurations(limit: -1) {
    totalCount
    nodes {
      id
      ...ImportConfigurationIdentity
    }
  }
}
    ${CountryOptionFragmentDoc}
${ImportConfigurationIdentityFragmentDoc}`;
export const ImportCrawlerRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportCrawlerRow on ImportCrawler {
  id
  name
  type
  countries {
    ...CountryOption
  }
  tags
  notes
  parameters
  defaultConfiguration {
    uri
    theaterMatcher
    entityMatcher
    parameters
  }
}
    ${CountryOptionFragmentDoc}`;
export const LocaleOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment LocaleOption on Locale {
  id
  ref
  name
  syncFromBrand {
    id
    ref
    name
  }
}
    `;
export const BrandOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment BrandOption on Brand {
  __typename
  id
  ref
  name
  redirectionDomain
  locale {
    ...LocaleOption
  }
  imageConfiguration {
    imageTypes
    defaultValue
  }
}
    ${LocaleOptionFragmentDoc}`;
export const IClubFragmentDoc = /*#__PURE__*/ gql`
    fragment IClub on Club {
  __typename
  id
  name
  code
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const IBrandEntityClubFragmentDoc = /*#__PURE__*/ gql`
    fragment IBrandEntityClub on BrandEntityClub {
  __typename
  id
  seen
  approved
  club {
    ...IClub
  }
  brand {
    ...BrandOption
  }
  rating {
    excellent
    good
    average
    bad
  }
}
    ${IClubFragmentDoc}
${BrandOptionFragmentDoc}`;
export const MovieClubsFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieClubs on Movie {
  __typename
  id
  clubs(brandIds: $brandIds, clubIds: $clubIds) {
    ...IBrandEntityClub
  }
}
    ${IBrandEntityClubFragmentDoc}`;
export const SeriesClubsFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesClubs on Series {
  __typename
  id
  clubs(brandIds: $brandIds, clubIds: $clubIds) {
    ...IBrandEntityClub
  }
}
    ${IBrandEntityClubFragmentDoc}`;
export const MovieAdditionalInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieAdditionalInfo on Movie {
  id
  runtime {
    hours
    minutes
  }
  genres
  budget
  budgetValue
  budgetCurrency
  budgetOld
  countries {
    id
    name
  }
  languages
  projections
  color
  projection
  production
  sound
}
    `;
export const MovieTabFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieTab on MovieBrandedContent {
  tabs {
    index
    title
    contentJson
  }
}
    `;
export const MovieIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieIdentity on Movie {
  id
  title
  productionYear
  type
  poster {
    ...Image
  }
  keywords
  additionalTags
}
    ${ImageFragmentDoc}`;
export const MovieMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieMetadata on Movie {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const MovieMetadataNavFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieMetadataNav on Movie {
  title
  activeOnBrands {
    ref
  }
}
    `;
export const MovieMetadataEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieMetadataEntity on Movie {
  __typename
  id
  brandsData(brandIds: $brandIds) @include(if: $includeBrandData) {
    title
  }
  localesData(locales: $localeIds) @include(if: $includeLocalesData) {
    title
  }
  ...MovieMetadata
  ...MovieMetadataNav
  type
}
    ${MovieMetadataFragmentDoc}
${MovieMetadataNavFragmentDoc}`;
export const MovieSimilarEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieSimilarEntity on Entity {
  __typename
  id
  ... on Movie {
    ref
    title
  }
  ... on Series {
    ref
    title
  }
}
    `;
export const MovieSyncInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieSyncInfo on Movie {
  id
  foxproSync {
    create3D
    createImax
  }
}
    `;
export const MovieTechnicalInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieTechnicalInfo on Movie {
  id
  color
  projection
  production
  sound
}
    `;
export const NewsTrackingFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsTracking on News {
  tracking
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const NewsRowFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsRow on News {
  id
  active
  ref
  title
  universe
  type
  publicationStatus
  publicationDate
  metadata {
    ...Metadata
  }
  brand {
    ...BrandOption
    timezone
  }
  authors {
    id
    author {
      __typename
      id
      ref
      name
    }
  }
}
    ${MetadataFragmentDoc}
${BrandOptionFragmentDoc}`;
export const PersonFilmographyEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonFilmographyEntity on Filmography {
  entity {
    __typename
    ... on Movie {
      id
      ref
      title
    }
    ... on Series {
      id
      ref
      title
    }
    ... on SeriesSeason {
      id
      ref
      series {
        id
        ref
        title
      }
      number
    }
    ... on SeriesEpisode {
      id
      ref
      episodeTitle: title
      number
      series {
        id
        ref
        title
      }
      season {
        id
        ref
        number
      }
    }
  }
}
    `;
export const RedirectionRuleRowFragmentDoc = /*#__PURE__*/ gql`
    fragment RedirectionRuleRow on RedirectionRule {
  __typename
  id
  ref
  active
  kind
  mode
  cloudflareState
  sourcePattern
  targetPattern
  sourceEntity
  targetEntity
  startAt
  endAt
  brand {
    ...BrandOption
  }
  metadata {
    ...Metadata
  }
}
    ${BrandOptionFragmentDoc}
${MetadataFragmentDoc}`;
export const RedirectionRuleChainRewriteFragmentDoc = /*#__PURE__*/ gql`
    fragment RedirectionRuleChainRewrite on RedirectionRuleChainRewrite {
  rule {
    id
    ref
  }
  rowIndex
  source
  previousTarget
  newTarget
  path
  warnings
}
    `;
export const RedirectionRuleExportRowFragmentDoc = /*#__PURE__*/ gql`
    fragment RedirectionRuleExportRow on RedirectionRule {
  active
  mode
  sourcePattern
  targetPattern
  startAt
  endAt
  brand {
    ref
  }
}
    `;
export const PresetRowFragmentDoc = /*#__PURE__*/ gql`
    fragment PresetRow on Preset {
  id
  name
  universes
}
    `;
export const TeamRowFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamRow on Team {
  id
  ref
  name
  locales {
    id
    name
  }
  brands {
    id
    name
  }
  countries {
    id
    name
  }
}
    `;
export const TeamOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamOption on Team {
  id
  name
}
    `;
export const EpisodeIdentitySeasonFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeIdentitySeason on SeriesSeason {
  id
  ref
  number
}
    `;
export const SearchSeriesSeasonFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchSeriesSeason on SeriesSeason {
  __typename
  id
  ref
  number
  originalPremiere
  status
  series {
    __typename
    id
    ref
    originalPremiere
    title
  }
}
    `;
export const EpisodeIdentitySeriesFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeIdentitySeries on Series {
  id
  ref
  title
}
    `;
export const EpisodeIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeIdentity on SeriesEpisode {
  __typename
  id
  ref
  title
  number
  season {
    ...EpisodeIdentitySeason
    ...SearchSeriesSeason
  }
  series {
    ...EpisodeIdentitySeries
  }
  metadata {
    ...Metadata
  }
}
    ${EpisodeIdentitySeasonFragmentDoc}
${SearchSeriesSeasonFragmentDoc}
${EpisodeIdentitySeriesFragmentDoc}
${MetadataFragmentDoc}`;
export const SeoDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SeoData on EntitySeoData {
  isAutonomouslyActivable
  active
  canActivate
  browsable
  title
  alternateTitle
  description
  brand {
    id
    ref
  }
}
    `;
export const SeriesEpisodeWithSeoFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesEpisodeWithSeo on SeriesEpisode {
  id
  ...EpisodeIdentity
  seoData(brandId: $brandId) @include(if: $includeBrandData) {
    ...SeoData
  }
}
    ${EpisodeIdentityFragmentDoc}
${SeoDataFragmentDoc}`;
export const SeasonIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonIdentity on SeriesSeason {
  id
  ref
  number
  originalPremiere
  originalFinale
  status
  poster {
    ...Image
  }
  series {
    id
    ref
    title
  }
  metadata {
    ...Metadata
  }
}
    ${ImageFragmentDoc}
${MetadataFragmentDoc}`;
export const SeriesSeasonWithSeoFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSeasonWithSeo on SeriesSeason {
  id
  ...SeasonIdentity
  seoData(brandId: $brandId) @include(if: $includeBrandData) {
    ...SeoData
  }
}
    ${SeasonIdentityFragmentDoc}
${SeoDataFragmentDoc}`;
export const SeriesMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesMetadata on Series {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SeriesMetadataNavFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesMetadataNav on Series {
  title
  activeOnBrands {
    ref
  }
}
    `;
export const SeriesMetadataEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesMetadataEntity on Series {
  __typename
  id
  ref
  title
  brandsData(brandIds: $brandIds) @include(if: $includeBrandData) {
    title
  }
  localesData(locales: $localeIds) @include(if: $includeLocalesData) {
    title
  }
  ...SeriesMetadata
  ...SeriesMetadataNav
}
    ${SeriesMetadataFragmentDoc}
${SeriesMetadataNavFragmentDoc}`;
export const SeriesQuickAccessIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesQuickAccessIdentity on Series {
  __typename
  id
  ref
}
    `;
export const SeriesSeasonQuickAccessIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSeasonQuickAccessIdentity on SeriesSeason {
  __typename
  id
  ref
  number
}
    `;
export const EpisodeQuickAccessIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeQuickAccessIdentity on SeriesEpisode {
  __typename
  id
  ref
  title
  number
}
    `;
export const SeriesSeasonEpisodesQuickAccessRowFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSeasonEpisodesQuickAccessRow on SeriesSeason {
  ...SeriesSeasonQuickAccessIdentity
  episodes(limit: $subEpisodesLimit, offset: 0) {
    totalCount
    nodes {
      ...EpisodeQuickAccessIdentity
    }
  }
}
    ${SeriesSeasonQuickAccessIdentityFragmentDoc}
${EpisodeQuickAccessIdentityFragmentDoc}`;
export const SeriesSeasonRowFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSeasonRow on SeriesSeason {
  __typename
  episodes(limit: 0) {
    totalCount
  }
  ...SeasonIdentity
  seoData(brandId: $brandId) @include(if: $includeBrandData) {
    ...SeoData
  }
}
    ${SeasonIdentityFragmentDoc}
${SeoDataFragmentDoc}`;
export const SeriesSeasonEpisodesRowFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSeasonEpisodesRow on SeriesSeason {
  __typename
  episodes(limit: $limit, offset: $offset) {
    totalCount
    nodes {
      __typename
      ...EpisodeIdentity
      seoData(brandId: $brandId) @include(if: $includeBrandData) {
        ...SeoData
      }
    }
  }
  ...SeasonIdentity
  seoData(brandId: $brandId) @include(if: $includeBrandData) {
    ...SeoData
  }
}
    ${EpisodeIdentityFragmentDoc}
${SeoDataFragmentDoc}
${SeasonIdentityFragmentDoc}`;
export const EpisodeFromSeriesNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeFromSeriesNodes on SeriesEpisode {
  __typename
  ...EpisodeIdentity
  seoData(brandId: $brandId) @include(if: $includeBrandData) {
    ...SeoData
  }
}
    ${EpisodeIdentityFragmentDoc}
${SeoDataFragmentDoc}`;
export const EpisodeFromSeriesSeasonFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeFromSeriesSeason on SeriesSeason {
  __typename
  ref
  episodes(limit: $limit, offset: $offset) {
    totalCount
    nodes {
      ...EpisodeFromSeriesNodes
    }
  }
}
    ${EpisodeFromSeriesNodesFragmentDoc}`;
export const SeasonFromSeriesNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonFromSeriesNodes on SeriesSeason {
  ...SeriesSeasonEpisodesRow
  ...EpisodeFromSeriesSeason
}
    ${SeriesSeasonEpisodesRowFragmentDoc}
${EpisodeFromSeriesSeasonFragmentDoc}`;
export const SeasonFromSeriesFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonFromSeries on Series {
  __typename
  seasons(limit: $limit, offset: $offset) {
    totalCount
    nodes {
      ...SeasonFromSeriesNodes
    }
  }
}
    ${SeasonFromSeriesNodesFragmentDoc}`;
export const EpisodeFromSeriesFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeFromSeries on Series {
  __typename
  specialEpisodes: episodes(limit: $limit, offset: $offset, filter: ORPHANS) {
    totalCount
    nodes {
      ...EpisodeFromSeriesNodes
    }
  }
}
    ${EpisodeFromSeriesNodesFragmentDoc}`;
export const CreatedImageFragmentDoc = /*#__PURE__*/ gql`
    fragment CreatedImage on Image {
  id
  url
  ref
}
    `;
export const ConnectionIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ConnectionIdentity on EntityLink {
  source {
    __typename
    id
    ... on Movie {
      ref
      title
    }
    ... on Series {
      ref
      title
    }
  }
  target {
    __typename
    id
    ... on Movie {
      ref
      title
    }
    ... on Series {
      ref
      title
    }
  }
  linkType
  rank
}
    `;
export const MainCreditFragmentDoc = /*#__PURE__*/ gql`
    fragment MainCredit on PersonCredits {
  id
  person {
    __typename
    id
    ref
    firstName
    lastName
  }
  role
  voice {
    __typename
    id
    ref
    firstName
    lastName
  }
}
    `;
export const LocalCastingDetailFragmentDoc = /*#__PURE__*/ gql`
    fragment LocalCastingDetail on EntityHasPersonLocalized {
  id
  voice {
    __typename
    id
    ref
    firstName
    lastName
  }
  role
  locale {
    ...LocaleOption
  }
}
    ${LocaleOptionFragmentDoc}`;
export const LocalCastingFragmentDoc = /*#__PURE__*/ gql`
    fragment LocalCasting on PersonCredits {
  id
  localeData(limit: 30) {
    totalCount
    nodes {
      ...LocalCastingDetail
    }
  }
}
    ${LocalCastingDetailFragmentDoc}`;
export const ImageListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageListItem on Image {
  id
  url
  type
  ref
  activeOnBrands {
    ref
  }
  b2bAvailable
}
    `;
export const EntityImageListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityImageListItem on Image {
  title
  __typename
  ...ImageListItem
  isMainPosterOfEntity(entityId: $entityId) @include(if: $withMainPoster)
  isMainBrandedPoster(entityId: $entityId, brandId: $brandId) @include(if: $withMainBrandedPoster)
  isMainLocalizedPoster(entityId: $entityId, localeId: $localeId) @include(if: $withMainLocalizedPoster)
  hasLocalizedData(localeId: $localeId)
}
    ${ImageListItemFragmentDoc}`;
export const EntityImageItemFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityImageItem on ImageReference {
  image {
    ...EntityImageListItem
  }
  rank
}
    ${EntityImageListItemFragmentDoc}`;
export const EntityReleaseListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityReleaseListItem on EntityRelease {
  id
  ref
  country {
    ...CountryOption
  }
  releasedAt
  type
  flags
  limitedLocalization {
    id
    type
    name
    code
  }
  certificate {
    id
    label
    code
    country {
      ...CountryOption
    }
    limitedLocalization {
      id
      type
      name
      code
    }
  }
  limitedCompany {
    ...CompanyOption
  }
  distributors {
    ...CompanyOption
  }
}
    ${CountryOptionFragmentDoc}
${CompanyOptionFragmentDoc}`;
export const ViewerInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment ViewerInfo on User {
  id
  ref
  email
  name
  allowedLocales {
    ...LocaleOption
  }
  allowedBrands {
    ...BrandOption
  }
}
    ${LocaleOptionFragmentDoc}
${BrandOptionFragmentDoc}`;
export const ViewerPreferencesFragmentDoc = /*#__PURE__*/ gql`
    fragment ViewerPreferences on User {
  defaultBrand {
    ...BrandOption
    language
  }
  defaultCountry {
    ...CountryOption
    language
  }
  defaultLocale {
    ...LocaleOption
    language
  }
}
    ${BrandOptionFragmentDoc}
${CountryOptionFragmentDoc}
${LocaleOptionFragmentDoc}`;
export const ViewerDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ViewerData on User {
  ...ViewerInfo
  ...ViewerPreferences
}
    ${ViewerInfoFragmentDoc}
${ViewerPreferencesFragmentDoc}`;
export const EmergenceSlideFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceSlide on Slide {
  id
  ref
  title
  active
}
    `;
export const EmergenceNewsFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceNews on News {
  id
  ref
  title
  active
  publicationStatus
}
    `;
export const EmergenceVideoLegacyFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceVideoLegacy on VideoLegacy {
  id
  ref
  active
  optionalTitle: title
  generatedTitle
}
    `;
export const EmergenceTargetFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceTarget on SpecialOperationTarget {
  id
  rank
  target
  startsAt
  endsAt
  data
  entity {
    __typename
    ...EmergenceSlide
    ...EmergenceNews
    ...EmergenceVideoLegacy
  }
}
    ${EmergenceSlideFragmentDoc}
${EmergenceNewsFragmentDoc}
${EmergenceVideoLegacyFragmentDoc}`;
export const MovieSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieSearchEntity on Movie {
  __typename
  id
  ref
  title
  productionYear
  genres
  poster {
    path
    ref
  }
  brandData(brandId: $brandId) @include(if: $includeBrandData) {
    title
    brand {
      ...BrandOption
    }
    poster {
      path
      ref
    }
  }
  localeData(locale: $localeId) @include(if: $includeLocaleData) {
    title
    poster {
      path
      ref
    }
  }
  credits(limit: 30) {
    nodes {
      person {
        id
        lastName
        firstName
      }
    }
  }
  activeOnBrands {
    ref
  }
}
    ${BrandOptionFragmentDoc}`;
export const SeriesSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSearchEntity on Series {
  __typename
  id
  ref
  title
  genres
  originalPremiere
  status
  poster {
    path
    ref
  }
  brandData(brandId: $brandId) @include(if: $includeBrandData) {
    title
    brand {
      ...BrandOption
    }
    poster {
      path
      ref
    }
  }
  credits(limit: 30) {
    nodes {
      person {
        id
        lastName
        firstName
      }
    }
  }
  activeOnBrands {
    ref
  }
}
    ${BrandOptionFragmentDoc}`;
export const NewsSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsSearchEntity on News {
  id
  ref
  title
}
    `;
export const SlideSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SlideSearchEntity on Slide {
  id
  ref
  title
}
    `;
export const VideoLegacySearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoLegacySearchEntity on VideoLegacy {
  __typename
  id
  ref
  videoTitle: title
  generatedTitle
}
    `;
export const SpecialOperationHasTargetFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationHasTarget on SpecialOperationTarget {
  id
  rank
  target
  startsAt
  endsAt
  data
  entity {
    __typename
    ... on Movie {
      ...MovieSearchEntity
    }
    ... on Series {
      ...SeriesSearchEntity
    }
    ... on News {
      ...NewsSearchEntity
    }
    ... on Slide {
      ...SlideSearchEntity
    }
    ... on Video {
      ...VideoLegacySearchEntity
    }
  }
}
    ${MovieSearchEntityFragmentDoc}
${SeriesSearchEntityFragmentDoc}
${NewsSearchEntityFragmentDoc}
${SlideSearchEntityFragmentDoc}
${VideoLegacySearchEntityFragmentDoc}`;
export const BannerHpDataFragmentDoc = /*#__PURE__*/ gql`
    fragment BannerHpData on BannerHPData {
  link_desktop
  link_mobile
  medias {
    desktop
    mobile
  }
}
    `;
export const Club300DataFragmentDoc = /*#__PURE__*/ gql`
    fragment Club300Data on Club300Data {
  _placeholder
}
    `;
export const EmergenceMovieDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceMovieData on EmergenceMovieData {
  distribution
  provider
  release_date
}
    `;
export const EmergenceSeriesDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceSeriesData on EmergenceSeriesData {
  provider
  release_date
}
    `;
export const EmergenceSvodDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceSVODData on EmergenceSVODData {
  provider
  release_date
}
    `;
export const EmergenceTheaterDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceTheaterData on EmergenceTheaterData {
  release_date
}
    `;
export const MobileDdayDataFragmentDoc = /*#__PURE__*/ gql`
    fragment MobileDdayData on MobileDdayData {
  dday_campaign
  dday_movie_id
  dday_movie_list_id
  dday_movie_list_title
  dday_force_uppercase_headers
  dday_nav_background_color_light
  dday_nav_background_color_dark
  dday_nav_font_color_light
  dday_nav_font_color_dark
  dday_main_color_light
  dday_main_color_dark
  dday_title_spacing_between_letters
  dday_title_see_more_title_displayed
  dday_background_color
  dday_force_theme_light
  dday_force_theme_dark
  dday_status_bar_icons_light
  dday_status_bar_icons_dark
  dday_segmented_color_light
  dday_segmented_color_dark
  dday_segmented_selected_font_color_light
  dday_segmented_selected_font_color_dark
  dday_date
  dday_last_date
  dday_assets_version
  dday_font_url
  dday_font_size
  dday_movie_background_url
  dday_movie_background_id
  dday_movie_logo_url
  dday_movie_logo_id
  dday_splash_background_url
  dday_splash_background_id
  dday_splash_logo_url
  dday_splash_logo_id
  dday_splashscreen_status_bar_color_style
  dday_splashscreen_activity_color
}
    `;
export const RollerHomeDataFragmentDoc = /*#__PURE__*/ gql`
    fragment RollerHomeData on RollerHomeData {
  title
}
    `;
export const SponsoredAutocompleteDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SponsoredAutocompleteData on SponsoredAutocompleteData {
  release_date
}
    `;
export const TicketAnchorDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TicketAnchorData on TicketAnchorData {
  cta_text_after_release
  cta_text_before_release
  display_showtimes
  link
  medias {
    desktop
    desktopHp
    mobile
  }
  release_date
  slots
  text_after_release
  text_before_release
  text_color
}
    `;
export const SpecialOperationDataInnerFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationDataInner on SpecialOperationData {
  __typename
  ... on BannerHPData {
    ...BannerHpData
  }
  ... on CanalHomeData {
    heading1
    heading2
    heading3
  }
  ... on ClassiqueHomeData {
    heading1
    heading2
    heading3
    link1_label
    link1_url
    link2_label
    link2_url
  }
  ... on Club300Data {
    ...Club300Data
  }
  ... on DisneyHomeData {
    medias {
      native_grand_angle {
        image_url
        url
      }
    }
  }
  ... on DolbyHomeData {
    _placeholder
  }
  ... on EmergenceMovieData {
    ...EmergenceMovieData
  }
  ... on EmergenceSeriesData {
    ...EmergenceSeriesData
  }
  ... on EmergenceSVODData {
    ...EmergenceSVODData
  }
  ... on EmergenceTheaterData {
    ...EmergenceTheaterData
  }
  ... on FestivalSectionData {
    festivalEditionId
    festivalId
    playlist {
      key
      value {
        movies
        series
      }
    }
  }
  ... on FilmesOnlineData {
    heading1
    heading2
    heading3
    heading4
    heading5
    heading6
    heading7
    heading8
    heading9
    heading10
  }
  ... on IMAXHomeData {
    _placeholder
  }
  ... on IndelebileHomeData {
    heading1
    heading2
    heading3
  }
  ... on M6HomeData {
    heading1
    heading2
    heading3
  }
  ... on MaxHomeData {
    heading1
    heading2
    heading3
  }
  ... on MobileDdayData {
    ...MobileDdayData
  }
  ... on NovelasHomeData {
    _placeholder
  }
  ... on RollerHomeData {
    ...RollerHomeData
  }
  ... on SponsoredAutocompleteData {
    ...SponsoredAutocompleteData
  }
  ... on TF1HomeData {
    heading1
    heading2
    heading3
  }
  ... on TicketAnchorData {
    ...TicketAnchorData
  }
  ... on VODHomeData {
    heading1
    heading2
  }
}
    ${BannerHpDataFragmentDoc}
${Club300DataFragmentDoc}
${EmergenceMovieDataFragmentDoc}
${EmergenceSeriesDataFragmentDoc}
${EmergenceSvodDataFragmentDoc}
${EmergenceTheaterDataFragmentDoc}
${MobileDdayDataFragmentDoc}
${RollerHomeDataFragmentDoc}
${SponsoredAutocompleteDataFragmentDoc}
${TicketAnchorDataFragmentDoc}`;
export const SpecialOperationDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationData on SpecialOperation {
  data {
    ...SpecialOperationDataInner
  }
}
    ${SpecialOperationDataInnerFragmentDoc}`;
export const SpecialOperationItemFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationItem on SpecialOperation {
  id
  ref
  active
  code
  name
  startsAt
  endsAt
  brand {
    ...BrandOption
  }
  entity {
    __typename
    ... on Movie {
      id
      ref
    }
  }
  ...SpecialOperationData
}
    ${BrandOptionFragmentDoc}
${SpecialOperationDataFragmentDoc}`;
export const ScreenRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ScreenRow on Screen {
  id
  ref
  number
  name
  seats
  flags {
    accessibility
    comfort
    experience
    food
    picture
    restriction
    service
    sound
  }
}
    `;
export const TheaterNextOpeningFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterNextOpening on TheaterNextOpening {
  startsAt
  message
}
    `;
export const TheaterAdditionalInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterAdditionalInfo on Theater {
  id
  email
  movieLine
  timezone
  openingStatus
  temporaryClosure {
    startsAt
    endsAt
    message
  }
  phone
  websiteUrl
  androidUrl
  iosUrl
  showtimesUrl
  showtimesAlternateUrl
  note
  nextOpening {
    ...TheaterNextOpening
  }
  displayName
  showtimeSource
  foundedAt
  showtimesGatheringMethod
  showtimesGatheringMethodCode
  showtimesGatheringMethodPriority
}
    ${TheaterNextOpeningFragmentDoc}`;
export const TheaterChainFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterChain on Company {
  ...CompanyOption
  activities
}
    ${CompanyOptionFragmentDoc}`;
export const TheaterCountryFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterCountry on Country {
  ...CountryOption
}
    ${CountryOptionFragmentDoc}`;
export const TheaterIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterIdentity on Theater {
  id
  name
  logo {
    ...Image
  }
  parent {
    ref
    ...TheaterChain
  }
  country {
    ...TheaterCountry
  }
  foundedAt
}
    ${ImageFragmentDoc}
${TheaterChainFragmentDoc}
${TheaterCountryFragmentDoc}`;
export const ClosureFragmentDoc = /*#__PURE__*/ gql`
    fragment Closure on Theater {
  closed
  temporaryClosure {
    startsAt
    endsAt
    message
  }
}
    `;
export const VideoCopyrightFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoCopyright on Video {
  id
  copyrightName
  copyrights {
    ...CopyrightIdentity
  }
}
    ${CopyrightIdentityFragmentDoc}`;
export const VideoFilesFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoFiles on Video {
  __typename
  id
  ref
  videoFiles {
    id
    width
    height
    path
    cdnUrl
    formats
    metadata {
      ...Metadata
    }
  }
  snapshot {
    id
    url
  }
  ... on VideoLegacy {
    dailymotionUrl
    youtubeUrl
    defaultYoutubeChannelId
    dailymotionChannelId
    youtubeChannels {
      id
      label
    }
    brand {
      ...BrandOption
    }
  }
}
    ${MetadataFragmentDoc}
${BrandOptionFragmentDoc}`;
export const VideoEmbedCodeFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoEmbedCode on Video {
  __typename
  id
  embedCode
}
    `;
export const VideoLanguageAndSubtitleB2BFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoLanguageAndSubtitleB2B on VideoB2B {
  __typename
  id
  language
  subtitle
}
    `;
export const VideoLanguageAndSubtitleLegacyFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoLanguageAndSubtitleLegacy on VideoLegacy {
  __typename
  id
  language
  subtitle
  brand {
    __typename
    id
    ref
    language
  }
}
    `;
export const LocalizationIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment LocalizationIdentity on Localization {
  id
  name
  code
  type
  parent {
    id
    name
    code
    type
  }
}
    `;
export const CertificateIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment CertificateIdentity on Certificate {
  __typename
  id
  ref
  rank
  active
  code
  label
  country {
    ...CountryOption
  }
  metadata {
    ...Metadata
  }
  limitedLocalization {
    ...LocalizationIdentity
  }
}
    ${CountryOptionFragmentDoc}
${MetadataFragmentDoc}
${LocalizationIdentityFragmentDoc}`;
export const VideoRestrictionsFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoRestrictions on Video {
  __typename
  id
  validity {
    validity_from
    validity_to
  }
  certificate {
    ...CertificateIdentity
  }
  ... on VideoLegacy {
    dailymotionUrl
    brand {
      country {
        id
      }
    }
  }
}
    ${CertificateIdentityFragmentDoc}`;
export const VideoRelatedEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoRelatedEntity on VideoLinkableEntity {
  __typename
  ... on Movie {
    id
    ref
    movieTitle: title
  }
  ... on Series {
    id
    ref
    seriesTitle: title
  }
  ... on Person {
    id
    ref
    firstName
    lastName
    formalName
  }
  ... on SeriesEpisode {
    id
    ref
    number
    series {
      id
      ref
      title
    }
    season {
      id
      ref
      number
    }
    title
  }
  ... on SeriesSeason {
    id
    ref
    number
    series {
      id
      ref
      title
    }
  }
  ... on Festival {
    id
    ref
    festivalName: name
  }
  ... on FestivalEdition {
    id
    ref
    editionName: name
    editionNumber
    year
    festival {
      id
      festivalName: name
      ref
    }
  }
}
    `;
export const VideoRelatedEntitiesFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoRelatedEntities on Video {
  id
  relatedEntities {
    ...VideoRelatedEntity
  }
}
    ${VideoRelatedEntityFragmentDoc}`;
export const VideoSuggestedTitleFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoSuggestedTitle on Video {
  id
  suggestedTitle
}
    `;
export const VideoIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoIdentity on Video {
  __typename
  id
  ref
  title
  generatedTitle
  active
  snapshot {
    __typename
    id
    title
    path
    url
  }
  type
  duration {
    hours
    minutes
    seconds
  }
  description
  copyrightName
  copyrights {
    ...CopyrightIdentity
  }
  startsAt
  endsAt
  metadata {
    updatedAt
  }
  embedCode
  restrictions
  language
  subtitle
  ... on VideoB2B {
    rawId
    __typename
    previewVideoFile {
      cdnUrl
    }
    certificate {
      ...CertificateIdentity
    }
  }
  ... on VideoLegacy {
    rawId
    __typename
    previewVideoFile {
      cdnUrl
    }
    brand {
      ...BrandOption
      language
    }
    certificate {
      ...CertificateIdentity
    }
    universe
    alt {
      videoEncoder {
        status
        createdAt
        updatedAt
      }
    }
  }
}
    ${CopyrightIdentityFragmentDoc}
${CertificateIdentityFragmentDoc}
${BrandOptionFragmentDoc}`;
export const VideoEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoEntity on Video {
  metadata {
    ...Metadata
  }
  ...VideoIdentity
}
    ${MetadataFragmentDoc}
${VideoIdentityFragmentDoc}`;
export const AuthorSeoDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AuthorSeoData on Author {
  id
  seoData {
    isAutonomouslyActivable
    browsable
    title
    description
  }
}
    `;
export const SocialLinksFragmentDoc = /*#__PURE__*/ gql`
    fragment SocialLinks on SocialLinks {
  facebook
  bluesky
  instagram
  letterboxd
  linkedin
  pinterest
  snapchat
  tiktok
  threads
  tumblr
  twitter
  vk
  wechat
  whatsapp
  youtube
}
    `;
export const AuthorLinksFragmentDoc = /*#__PURE__*/ gql`
    fragment AuthorLinks on Author {
  id
  links {
    ...SocialLinks
  }
}
    ${SocialLinksFragmentDoc}`;
export const AuthorMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment AuthorMetadata on Author {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const AuthorIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment AuthorIdentity on Author {
  id
  ref
  name
  brand {
    ...BrandOption
  }
  position
  user {
    id
    name
    email
  }
  socialUser {
    legacyID
  }
  startDate
  stopDate
  avatar {
    id
    url
    ref
  }
  shortBio
  longBio
}
    ${BrandOptionFragmentDoc}`;
export const AuthorSignatureFragmentDoc = /*#__PURE__*/ gql`
    fragment AuthorSignature on AuthorSignature {
  id
  name
  signature
}
    `;
export const BoxofficeIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment BoxofficeIdentity on TemporalBoxoffice {
  id
  value
  cumulative
  copyCount
  estimate
  movie {
    __typename
    ref
    id
    title
  }
  range {
    startsAt
    endsAt
  }
  country {
    ...CountryOption
  }
}
    ${CountryOptionFragmentDoc}`;
export const CarouselSlideFragmentDoc = /*#__PURE__*/ gql`
    fragment CarouselSlide on CarouselHasSlide {
  id
  rank
  node: slide {
    id
    ref
    title
  }
}
    `;
export const CarouselSlidesFragmentDoc = /*#__PURE__*/ gql`
    fragment CarouselSlides on Carousel {
  id
  brand {
    ...BrandOption
  }
  slides {
    id
    ...CarouselSlide
  }
}
    ${BrandOptionFragmentDoc}
${CarouselSlideFragmentDoc}`;
export const CarouselMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment CarouselMetadata on Carousel {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const CarouselIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment CarouselIdentity on Carousel {
  id
  ref
  target
  startsAt
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const SlideMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment SlideMetadata on Slide {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SlideIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SlideIdentity on Slide {
  id
  brand {
    ...BrandOption
  }
  active
  title
  description
  link {
    url
    blank
  }
  poster {
    ...Image
  }
}
    ${BrandOptionFragmentDoc}
${ImageFragmentDoc}`;
export const SlideParentFragmentDoc = /*#__PURE__*/ gql`
    fragment SlideParent on CarouselHasSlide {
  id
  rank
  node: carousel {
    id
    ref
    target
    startsAt
  }
}
    `;
export const SlidePlanningFragmentDoc = /*#__PURE__*/ gql`
    fragment SlidePlanning on Slide {
  id
  parents {
    id
    ...SlideParent
  }
}
    ${SlideParentFragmentDoc}`;
export const ClockMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment ClockMetadata on Clock {
  id
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ClockIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ClockIdentity on Clock {
  id
  ref
  subtitlesLanguage
  language
  seatingStyle
  amenity
  range {
    startsAt
    endsAt
  }
  theater {
    __typename
    id
    ref
    code
    country {
      ...CountryOption
      showtimeReleaseDay
      preferredClockFormat
    }
    name
  }
  screen {
    id
    name
  }
  entity {
    __typename
    ... on Movie {
      id
      title
      ref
    }
  }
  showtimes
  technos
  sound
  comment
}
    ${CountryOptionFragmentDoc}`;
export const ClockTheaterFragmentDoc = /*#__PURE__*/ gql`
    fragment ClockTheater on Theater {
  __typename
  id
  ref
  code
  name
  parent {
    __typename
    id
    ref
    name
  }
  location {
    city
  }
  openingStatus
  showtimeSource
  country {
    ...CountryOption
    showtimeReleaseDay
    preferredClockFormat
  }
}
    ${CountryOptionFragmentDoc}`;
export const CompanyLinksFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyLinks on Company {
  __typename
  ...CompanyOption
  links {
    ...SocialLinks
  }
}
    ${CompanyOptionFragmentDoc}
${SocialLinksFragmentDoc}`;
export const CompanyFullIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyFullIdentity on Company {
  __typename
  ...CompanyOption
  foundedAt
  activities
  closed
  providerAsFavorite
  country {
    ...CountryOption
  }
  parent {
    ...CompanyOption
  }
  logo {
    id
    url
    ref
  }
  email
  websiteUrl
  androidUrl
  iosUrl
  phone
  note
  description
  data {
    approvals {
      cnc {
        number
      }
    }
    sourceName
    allowMatchingTypeOverrides
  }
}
    ${CompanyOptionFragmentDoc}
${CountryOptionFragmentDoc}`;
export const CompanyAddressFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyAddress on Company {
  __typename
  id
  country {
    ...CountryOption
  }
  coordinates {
    latitude
    longitude
  }
  location {
    address
    address2
    zip
    city
    state
    county
    country
  }
}
    ${CountryOptionFragmentDoc}`;
export const CompanyMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyMetadata on Company {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const CompanyRelationFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyRelation on Company {
  ...CompanyOption
  activities
}
    ${CompanyOptionFragmentDoc}`;
export const CompanyRelationshipsFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyRelationships on Company {
  ...CompanyOption
  parent {
    ...CompanyRelation
  }
  children {
    ...CompanyRelation
  }
}
    ${CompanyOptionFragmentDoc}
${CompanyRelationFragmentDoc}`;
export const CompanyActivitySubactivityFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyActivitySubactivity on CompanyActivitySubactivity {
  activity
  subactivities
}
    `;
export const CompanyStaffIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyStaffIdentity on CompanyStaff {
  ref
  id
  rank
  active
  companyId
  firstName
  lastName
  name
  department
  title
  email
  workPhone
  mobilePhone
  company {
    ref
  }
  copyCompanies: linkedCompanies(linkType: COPY_PARTNER) {
    id
    name
  }
  pubCompanies: linkedCompanies(linkType: PUB_PARTNER) {
    id
    name
  }
}
    `;
export const CompanyStaffMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyStaffMetadata on CompanyStaff {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const CompanySeodataFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanySeodata on Company {
  seoData(brandId: $brandId) {
    ...SeoData
  }
}
    ${SeoDataFragmentDoc}`;
export const CountryIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment CountryIdentity on Country {
  ...CountryOption
  alpha3
  preferredClockFormat
}
    ${CountryOptionFragmentDoc}`;
export const CountryMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment CountryMetadata on Country {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const DuplicateCompanyBrandDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateCompanyBrandData on CompanyBrandData {
  description
  name
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const DuplicateEntitySeoDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateEntitySeoData on EntitySeoData {
  isAutonomouslyActivable
  browsable
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const DuplicateMovieBrandDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateMovieBrandData on MovieBrandData {
  synopsis
  synopsisShort
  poster {
    id
  }
  brand {
    ...BrandOption
  }
  title
}
    ${BrandOptionFragmentDoc}`;
export const DuplicateSeriesBrandDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateSeriesBrandData on SeriesBrandData {
  synopsis
  synopsisShort
  poster {
    id
  }
  brand {
    ...BrandOption
  }
  title
}
    ${BrandOptionFragmentDoc}`;
export const DuplicatePersonBrandDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicatePersonBrandData on PersonBrandData {
  biography
  biographyShort
  poster {
    id
  }
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const DuplicateEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateEntity on DuplicateEntity {
  __typename
  ... on Company {
    ...CompanyOption
    logo {
      id
    }
    activeOnBrands {
      ref
    }
    brandsData {
      ...DuplicateCompanyBrandData
    }
    seoAttributes {
      ...DuplicateEntitySeoData
    }
  }
  ... on Movie {
    ref
    id
    title
    releases(limit: 1, type: ONLINE_SVOD) {
      totalCount
    }
    activeOnBrands {
      ref
    }
    movieBrandsData: brandsData {
      ...DuplicateMovieBrandData
    }
    seoAttributes {
      ...DuplicateEntitySeoData
    }
    externalIDs(source: "cinemasource") {
      type
      alts
    }
  }
  ... on Series {
    ref
    id
    title
    releases(limit: 1, type: ONLINE_SVOD) {
      totalCount
    }
    activeOnBrands {
      ref
    }
    seriesBrandsData: brandsData {
      ...DuplicateSeriesBrandData
    }
    seoAttributes {
      ...DuplicateEntitySeoData
    }
  }
  ... on Person {
    ref
    id
    lastName
    firstName
    activeOnBrands {
      ref
    }
    brandsData {
      ...DuplicatePersonBrandData
    }
    seoAttributes {
      ...DuplicateEntitySeoData
    }
  }
  ... on DeletedEntity {
    ref
    id
    source {
      typename
      ref
    }
  }
}
    ${CompanyOptionFragmentDoc}
${DuplicateCompanyBrandDataFragmentDoc}
${DuplicateEntitySeoDataFragmentDoc}
${DuplicateMovieBrandDataFragmentDoc}
${DuplicateSeriesBrandDataFragmentDoc}
${DuplicatePersonBrandDataFragmentDoc}`;
export const DuplicateIdentityWinnerFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateIdentityWinner on DuplicateEntity {
  ... on Company {
    ...CompanyOption
  }
  ... on Movie {
    id
  }
  ... on Person {
    id
  }
  ... on Series {
    id
  }
  ... on DeletedEntity {
    id
  }
}
    ${CompanyOptionFragmentDoc}`;
export const DuplicateIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateIdentity on Duplicate {
  id
  status
  priority
  comment
  firstEntity {
    ...DuplicateEntity
  }
  secondEntity {
    ...DuplicateEntity
  }
  winner {
    ...DuplicateIdentityWinner
  }
}
    ${DuplicateEntityFragmentDoc}
${DuplicateIdentityWinnerFragmentDoc}`;
export const DuplicateMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment DuplicateMetadata on Duplicate {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const FestivalCompetitionMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalCompetitionMetadata on FestivalCompetition {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const FestivalCompetitionIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalCompetitionIdentity on FestivalCompetition {
  id
  ref
  name
  localizedData(locale: $locale) {
    name
  }
  festival {
    ref
    name
  }
  active
  display
}
    `;
export const FestivalEditionCompetitionIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalEditionCompetitionIdentity on FestivalEditionCompetition {
  id
  festivalCompetition {
    ...FestivalCompetitionIdentity
  }
  festival {
    ref
    name
  }
  active
  rank
}
    ${FestivalCompetitionIdentityFragmentDoc}`;
export const FestivalEditionCompetitionSearchFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalEditionCompetitionSearch on FestivalEditionCompetitionSearchResult {
  name
  festivalCompetition {
    id
  }
  edition {
    editionNumber
    year
  }
  localizedData {
    name
  }
}
    `;
export const FestivalEditionIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalEditionIdentity on FestivalEdition {
  id
  ref
  localizedData(locale: $locale) {
    name
  }
  festival {
    __typename
    id
    ref
    name
  }
  active
  year
  editionNumber
  poster {
    ...Image
  }
  name
  startsAt
  endsAt
}
    ${ImageFragmentDoc}`;
export const FestivalEditionCompetitionMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalEditionCompetitionMetadata on FestivalEditionCompetition {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const FestivalJuryFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalJury on FestivalJury {
  id
  ref
  role
  rank
  person {
    __typename
    ref
    firstName
    lastName
  }
}
    `;
export const FestivalEditionMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalEditionMetadata on FestivalEdition {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const FestivalIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalIdentity on Festival {
  id
  active
  ref
  name
  type
  theme
  country {
    ...CountryOption
  }
  localization {
    id
    name
    type
  }
  localizedData(locale: $locale) {
    name
    synopsis
  }
  poster {
    ...Image
  }
  keywords
}
    ${CountryOptionFragmentDoc}
${ImageFragmentDoc}`;
export const FestivalAwardFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalAward on FestivalAward {
  __typename
  id
  ref
  active
  festival {
    id
    ref
    name
    localizedData(locale: $locale) {
      name
      synopsis
    }
  }
  name
  rank
  nominees {
    entity {
      __typename
      ... on Movie {
        id
        ref
        title
        localeData(locale: $locale) {
          title
        }
      }
      ... on Series {
        id
        ref
        title
        localeData(locale: $locale) {
          title
        }
      }
    }
    persons {
      __typename
      id
      ref
      firstName
      lastName
    }
  }
  localizedData(locale: $locale) {
    name
  }
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const FestivalSelectionFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalSelection on FestivalSelection {
  id
  ref
  festivalCompetitionId
  awards {
    ...FestivalAward
  }
  nominees {
    entity {
      ... on Movie {
        __typename
        id
        ref
        title
        localeData(locale: $locale) {
          title
        }
      }
      ... on Series {
        __typename
        id
        ref
        title
        localeData(locale: $locale) {
          title
        }
      }
    }
    persons {
      __typename
      id
      ref
      firstName
      lastName
    }
  }
}
    ${FestivalAwardFragmentDoc}`;
export const ApplicationIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ApplicationIdentity on Application {
  id
  name
  active
  ref
  origin
  metadata {
    createdAt
  }
}
    `;
export const ApplicationRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ApplicationRow on Application {
  ref
  ...ApplicationIdentity
}
    ${ApplicationIdentityFragmentDoc}`;
export const FestivalMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalMetadata on Festival {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ImageEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageEntity on ImageLinkableEntity {
  __typename
  ... on Movie {
    id
    ref
    title
  }
  ... on Series {
    id
    ref
    title
  }
  ... on Person {
    id
    ref
    firstName
    lastName
  }
  ... on SeriesSeason {
    id
    ref
    number
    series {
      id
      ref
      title
    }
  }
  ... on FestivalEdition {
    __typename
    id
    ref
    name
    editionNumber
    year
    festival {
      __typename
      id
      ref
      name
    }
  }
  ... on SeriesEpisode {
    id
    ref
    episodeNumber: number
    season {
      id
      ref
      number
    }
    series {
      id
      ref
      title
    }
  }
}
    `;
export const ImageFullIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageFullIdentity on Image {
  id
  ref
  url
  path
  type
  copyrightName
  copyrights {
    ...CopyrightIdentity
  }
  mime
  size
  width
  height
}
    ${CopyrightIdentityFragmentDoc}`;
export const ImageMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageMetadata on Image {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ImageMetadataNavFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageMetadataNav on Image {
  title
  activeOnBrands {
    ref
  }
}
    `;
export const ImportConfigurationStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportConfigurationStats on ImportConfiguration {
  id
  averageDuration
}
    `;
export const ImportRunRowStepFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportRunRowStep on ImportRunStep {
  name
  status
  error
  extra
}
    `;
export const ImportRunRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportRunRow on ImportRun {
  id
  status
  startTime
  endTime
  configuration {
    id
    crawler {
      name
    }
    sourceId
  }
  stats {
    totalShowtimes
    insertedShowtimes
    matchedShowtimes
    removedShowtimes
    unmatchedShowtimes
    ignoredShowtimes
    importedMovies
    importedTheaters
  }
  steps {
    ...ImportRunRowStep
  }
  crawlExportFile
  crawlMovieExportFile
}
    ${ImportRunRowStepFragmentDoc}`;
export const LocaleIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment LocaleIdentity on Locale {
  __typename
  id
  ref
  name
  syncFromBrand {
    ...BrandOption
  }
  country {
    ...CountryOption
  }
  limitedLocalization {
    ...LocalizationIdentity
  }
  metadata {
    ...Metadata
  }
}
    ${BrandOptionFragmentDoc}
${CountryOptionFragmentDoc}
${LocalizationIdentityFragmentDoc}
${MetadataFragmentDoc}`;
export const JumpLinkFragmentDoc = /*#__PURE__*/ gql`
    fragment JumpLink on JumpLink {
  __typename
  id
  ref
  sourceUrl
  targetDomainUrl
  generatedUrl
  partner
  data
  company {
    __typename
    id
    ref
    name
    logo {
      id
      url
      ref
    }
    activities
  }
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ProductSourceCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment ProductSourceCompany on Company {
  id
  data {
    sourceName
    allowMatchingTypeOverrides
  }
}
    `;
export const ProductSourceStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment ProductSourceStats on ProductSourceStats {
  __typename
  id
  sourceName
  unmatchedTotal
  company {
    ...ProductSourceCompany
  }
}
    ${ProductSourceCompanyFragmentDoc}`;
export const ProductSourceChannelOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment ProductSourceChannelOption on ProductSourceChannel {
  __typename
  id
  channel
  stats {
    unmatchedTotal
  }
}
    `;
export const MatchingMovieFragmentDoc = /*#__PURE__*/ gql`
    fragment MatchingMovie on Movie {
  __typename
  id
  title
  ref
  productionYear
  credits(limit: 1, activities: [DIRECTION_DIRECTOR]) {
    nodes {
      person {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export const MatchingSeriesFragmentDoc = /*#__PURE__*/ gql`
    fragment MatchingSeries on Series {
  __typename
  id
  title
  originalPremiere
  ref
  credits(limit: 1, activities: [DIRECTION_DIRECTOR]) {
    nodes {
      person {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export const IgnoredShowtimeSourceRowFragmentDoc = /*#__PURE__*/ gql`
    fragment IgnoredShowtimeSourceRow on IgnoredShowtimeSource {
  sourceType
  sourceName
  sourceId
  title
}
    `;
export const IncompleteShowtimeSourceRowFragmentDoc = /*#__PURE__*/ gql`
    fragment IncompleteShowtimeSourceRow on IncompleteShowtimeSource {
  sourceName
  sourceId
  showId
  titles
  count
  entityInfos {
    url
    images {
      url
      name
      type
      display
    }
    rating
    summary
    trailer
  }
  entityInfosRaw
}
    `;
export const MatchedShowtimeEntityRowFragmentDoc = /*#__PURE__*/ gql`
    fragment MatchedShowtimeEntityRow on MatchedShowtimeEntity {
  sourceName
  sourceId
  entity {
    __typename
    id
    ... on Movie {
      id
      ref
      title
    }
  }
}
    `;
export const MatchedShowtimeTheaterRowFragmentDoc = /*#__PURE__*/ gql`
    fragment MatchedShowtimeTheaterRow on MatchedShowtimeTheater {
  sourceName
  sourceId
  theater {
    __typename
    id
    ref
    code
    name
    country {
      ...CountryOption
    }
  }
}
    ${CountryOptionFragmentDoc}`;
export const ShowtimeTheatersSearchRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ShowtimeTheatersSearchRow on Theater {
  id
  ref
  name
  country {
    ...CountryOption
  }
  parent {
    ...CompanyOption
  }
}
    ${CountryOptionFragmentDoc}
${CompanyOptionFragmentDoc}`;
export const UnmatchedTheaterRowFragmentDoc = /*#__PURE__*/ gql`
    fragment UnmatchedTheaterRow on UnmatchedTheater {
  sourceName
  sourceId
  name
  data
}
    `;
export const UnmatchedMovieRowFragmentDoc = /*#__PURE__*/ gql`
    fragment UnmatchedMovieRow on UnmatchedMovie {
  sourceName
  sourceId
  title
  data
}
    `;
export const MovieLocalizedDataFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieLocalizedData on MovieLocaleData {
  title
  synopsis
  synopsisShort
  url
  notes
  poster {
    ...Image
  }
  quad: image(type: QUAD) {
    id
    url
    ref
  }
}
    ${ImageFragmentDoc}`;
export const MovieFullIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieFullIdentity on Movie {
  id
  ref
  title
  productionYear
  type
  runtime {
    hours
    minutes
  }
  budget
  languages
  genres
  color
  production
  projection
  sound
  countries {
    id
    name
  }
  poster {
    ...Image
  }
  keywords
}
    ${ImageFragmentDoc}`;
export const MovieReleaseMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieReleaseMetadata on EntityRelease {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const MovieReleaseNavFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieReleaseNav on EntityRelease {
  entity {
    __typename
    ... on Movie {
      id
      ref
      title
    }
  }
}
    `;
export const CertificateFragmentDoc = /*#__PURE__*/ gql`
    fragment Certificate on Certificate {
  id
  ref
  code
  label
  country {
    ...CountryOption
  }
  limitedLocalization {
    ...LocalizationIdentity
  }
}
    ${CountryOptionFragmentDoc}
${LocalizationIdentityFragmentDoc}`;
export const MovieReleaseFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieRelease on EntityRelease {
  id
  type
  flags
  releasedAt
  releasedAtTime
  unreleasedAt
  notReleasedYet
  limitedCompany {
    ...CompanyOption
  }
  limitedLocalization {
    ...LocalizationIdentity
  }
  country {
    ...CountryOption
    hasLocalCertificates
  }
  distributors {
    ...CompanyOption
  }
  certificate {
    ...Certificate
  }
  visaNumber
  techInfo
  openingEstimate
  advisory
}
    ${CompanyOptionFragmentDoc}
${LocalizationIdentityFragmentDoc}
${CountryOptionFragmentDoc}
${CertificateFragmentDoc}`;
export const MovieSeodataFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieSeodata on Movie {
  seoData(brandId: $brandId) {
    ...SeoData
  }
}
    ${SeoDataFragmentDoc}`;
export const MovieVersionFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieVersion on MovieVersion {
  id
  version
  runtime {
    hours
    minutes
  }
  label
}
    `;
export const NewsEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsEntity on NewsLinkableEntity {
  __typename
  ... on Movie {
    id
    ref
    title
  }
  ... on Series {
    id
    ref
    title
  }
  ... on Person {
    id
    ref
    firstName
    lastName
  }
  ... on SeriesSeason {
    id
    ref
    number
    series {
      id
      ref
      title
    }
  }
  ... on Festival {
    id
    ref
    festivalName: name
  }
  ... on FestivalEdition {
    id
    ref
    editionName: name
    year
    festival {
      ref
      festivalName: name
    }
  }
  ... on SeriesEpisode {
    id
    ref
    episodeNumber: number
    season {
      id
      ref
      number
    }
    series {
      id
      ref
      title
    }
  }
  ... on News {
    id
    ref
  }
}
    `;
export const NewsAuthorsFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsAuthors on News {
  id
  brand {
    ...BrandOption
  }
  authors {
    id
    rank
    author {
      id
      ref
      name
      shortBio
    }
    signature {
      id
      signature
    }
  }
}
    ${BrandOptionFragmentDoc}`;
export const NewsIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsIdentity on News {
  id
  ref
  brand {
    ...BrandOption
  }
  title
  socialTitle
  type
  universe
  keywords
  category
  credits
  headline
}
    ${BrandOptionFragmentDoc}`;
export const NewsMainImageFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsMainImage on News {
  id
  poster {
    ...Image
    copyrightName
    copyrights {
      ...CopyrightIdentity
    }
  }
}
    ${ImageFragmentDoc}
${CopyrightIdentityFragmentDoc}`;
export const NewsMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsMetadata on News {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const NewsNavigationDataFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsNavigationData on News {
  seoHidden
  onlyOnSocialSite
}
    `;
export const NewsPagesFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsPages on News {
  id
  pages {
    id
    number
    title
    video {
      __typename
      id
      active
      ref
      title
      generatedTitle
    }
  }
}
    `;
export const PublishableEntityFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PublishableEntityFragment on PublishableEntityInterface {
  publicationStatus
  publicationDate
  publications {
    startsAt
    endsAt
    status
  }
  isUpdatedWhenPublished
}
    `;
export const NewsPublicationsFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsPublications on News {
  ...PublishableEntityFragment
}
    ${PublishableEntityFragmentFragmentDoc}`;
export const NewsSeoAttributesFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsSeoAttributes on News {
  seoAttributes {
    title
    subtitle
    description
  }
}
    `;
export const NewsSlidesFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsSlides on News {
  id
  ref
  universe
  brand {
    ...BrandOption
  }
  slideshowSlides {
    id
    number
    title
  }
}
    ${BrandOptionFragmentDoc}`;
export const NewsTagListFragmentDoc = /*#__PURE__*/ gql`
    fragment NewsTagList on News {
  id
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const SlideshowSlideIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SlideshowSlideIdentity on SlideshowSlide {
  id
  number
  title
  body
  image {
    id
    url
    ref
    copyrightName
    copyrights {
      ...CopyrightIdentity
    }
  }
  brand {
    ...BrandOption
  }
  news {
    id
    ref
  }
}
    ${CopyrightIdentityFragmentDoc}
${BrandOptionFragmentDoc}`;
export const SearchAuthorFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchAuthor on Author {
  id
  name
  shortBio
  signatures {
    id
    name
    signature
  }
}
    `;
export const PersonImagesImportReportSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonImagesImportReportSummary on PersonImageImportReport {
  __typename
  id
  status
  failureReason
  launchedAt
  source
  sourceId
  confidence
  detail
  limit
  candidatesCount
  importedCount
  metadata {
    createdBy {
      id
      name
    }
  }
}
    `;
export const PersonImagesImportReportFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonImagesImportReport on PersonImageImportReport {
  ...PersonImagesImportReportSummary
  candidates {
    id
    url
    thumbnailUrl
    qualities
    width
    height
    type
    category
    title
    pageUrl
    credit
    license
  }
  outcomes {
    url
    status
    message
  }
}
    ${PersonImagesImportReportSummaryFragmentDoc}`;
export const PersonMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonMetadata on Person {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const PersonFullIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonFullIdentity on Person {
  id
  ref
  firstName
  lastName
  formalName
  gender
  poster {
    ...Image
    copyrights {
      ...CopyrightIdentity
    }
    copyrightName
  }
  birthDate
  deathDate
  keywords
  countries {
    ...CountryOption
  }
}
    ${ImageFragmentDoc}
${CopyrightIdentityFragmentDoc}
${CountryOptionFragmentDoc}`;
export const PersonNicknameFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonNickname on PersonNickname {
  id
  nickname
  gender
}
    `;
export const PersonNicknamesFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonNicknames on Person {
  id
  nicknames {
    ...PersonNickname
  }
}
    ${PersonNicknameFragmentDoc}`;
export const PersonSeodataFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonSeodata on Person {
  seoData(brandId: $brandId) {
    ...SeoData
  }
}
    ${SeoDataFragmentDoc}`;
export const EditorialReviewFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReview on EditorialReview {
  id
  title
}
    `;
export const PressReviewRowFragmentDoc = /*#__PURE__*/ gql`
    fragment PressReviewRow on PressReview {
  __typename
  id
  ref
  active
  rating
  company {
    __typename
    id
    ref
    name
  }
  author
  entity {
    __typename
    ... on Movie {
      id
      ref
      title
    }
    ... on Series {
      id
      ref
      title
    }
    ... on SeriesSeason {
      id
      number
      ref
      series {
        id
        ref
        originalPremiere
        title
      }
    }
  }
  metadata {
    createdAt
  }
}
    `;
export const ScreenFlagsFragmentDoc = /*#__PURE__*/ gql`
    fragment ScreenFlags on Screen {
  id
  flags {
    accessibility
    comfort
    experience
    food
    picture
    projection
    restriction
    service
    sound
  }
}
    `;
export const ScreenMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment ScreenMetadata on Screen {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ScreenIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ScreenIdentity on Screen {
  id
  name
  number
  size {
    width
    unit
  }
}
    `;
export const ScreenNavFragmentDoc = /*#__PURE__*/ gql`
    fragment ScreenNav on Screen {
  theater {
    __typename
    id
    ref
    code
    name
    country {
      ...CountryOption
    }
  }
}
    ${CountryOptionFragmentDoc}`;
export const ScreenSeatsFragmentDoc = /*#__PURE__*/ gql`
    fragment ScreenSeats on Screen {
  id
  seats
}
    `;
export const PresetIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment PresetIdentity on Preset {
  id
  name
  universes
}
    `;
export const PresetMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment PresetMetadata on Preset {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const PresetPermissionsFragmentDoc = /*#__PURE__*/ gql`
    fragment PresetPermissions on Preset {
  id
  permissions
}
    `;
export const PresetUsersFragmentDoc = /*#__PURE__*/ gql`
    fragment PresetUsers on Preset {
  id
  users {
    id
    ref
    active
    name
    presets {
      id
    }
  }
}
    `;
export const TeamMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamMetadata on Team {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const PresetOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment PresetOption on Preset {
  id
  name
}
    `;
export const UserIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment UserIdentity on User {
  id
  ref
  name
  email
  active
  application
  admin
  presets {
    ...PresetOption
  }
  allowedBrands {
    ...BrandOption
  }
  allowedNewsScopes
}
    ${PresetOptionFragmentDoc}
${BrandOptionFragmentDoc}`;
export const TeamIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamIdentity on Team {
  id
  ref
  name
  locales {
    ...LocaleOption
  }
  brands {
    ...BrandOption
  }
  countries {
    ...CountryOption
  }
}
    ${LocaleOptionFragmentDoc}
${BrandOptionFragmentDoc}
${CountryOptionFragmentDoc}`;
export const UserMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment UserMetadata on User {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const UserPermissionsFragmentDoc = /*#__PURE__*/ gql`
    fragment UserPermissions on User {
  id
  presets {
    id
    permissions
  }
  permissions
}
    `;
export const UserRolesFragmentDoc = /*#__PURE__*/ gql`
    fragment UserRoles on User {
  id
  rights {
    team {
      id
      name
    }
    preset {
      id
      name
    }
  }
}
    `;
export const UserPreferencesFragmentDoc = /*#__PURE__*/ gql`
    fragment UserPreferences on User {
  id
  defaultBrand {
    ...BrandOption
  }
  defaultCountry {
    ...CountryOption
  }
  defaultLocale {
    ...LocaleOption
  }
}
    ${BrandOptionFragmentDoc}
${CountryOptionFragmentDoc}
${LocaleOptionFragmentDoc}`;
export const EpisodeBrandIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeBrandIdentity on SeriesEpisode {
  __typename
  ...EpisodeIdentity
  seoData(brandId: $brandId) @include(if: $includeBrandData) {
    ...SeoData
  }
}
    ${EpisodeIdentityFragmentDoc}
${SeoDataFragmentDoc}`;
export const EpisodeMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeMetadata on SeriesEpisode {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const EpisodeMetadataNavFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeMetadataNav on SeriesEpisode {
  series {
    ref
    title
  }
  season {
    ref
    number
  }
  number
  activeOnBrands {
    ref
  }
}
    `;
export const EpisodeReleaseMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeReleaseMetadata on EntityRelease {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const EpisodeReleaseNavFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeReleaseNav on EntityRelease {
  entity {
    ... on SeriesEpisode {
      id
      ref
      title
      series {
        id
        title
      }
      season {
        id
        number
      }
    }
  }
}
    `;
export const EpisodeReleaseFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeRelease on EntityRelease {
  id
  ref
  type
  flags
  releasedAt
  releasedAtTime
  unreleasedAt
  notReleasedYet
  limitedCompany {
    ...CompanyOption
  }
  limitedLocalization {
    ...LocalizationIdentity
  }
  country {
    ...CountryOption
  }
  distributors {
    ...CompanyOption
  }
  techInfo
}
    ${CompanyOptionFragmentDoc}
${LocalizationIdentityFragmentDoc}
${CountryOptionFragmentDoc}`;
export const EpisodeSeodataFragmentDoc = /*#__PURE__*/ gql`
    fragment EpisodeSeodata on SeriesEpisode {
  seoData(brandId: $brandId) {
    ...SeoData
  }
}
    ${SeoDataFragmentDoc}`;
export const SeasonMetadataNavFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonMetadataNav on SeriesSeason {
  series {
    title
  }
  activeOnBrands {
    ref
  }
  number
}
    `;
export const SeasonMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonMetadata on SeriesSeason {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SeasonReleaseNavFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonReleaseNav on EntityRelease {
  entity {
    ... on SeriesSeason {
      id
      number
      series {
        id
        title
      }
    }
  }
}
    `;
export const SeasonReleaseMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonReleaseMetadata on EntityRelease {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SeasonReleaseFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonRelease on EntityRelease {
  id
  type
  flags
  releasedAt
  releasedAtTime
  unreleasedAt
  notReleasedYet
  limitedLocalization {
    ...LocalizationIdentity
  }
  limitedCompany {
    ...CompanyOption
  }
  country {
    ...CountryOption
  }
  distributors {
    ...CompanyOption
  }
  techInfo
}
    ${LocalizationIdentityFragmentDoc}
${CompanyOptionFragmentDoc}
${CountryOptionFragmentDoc}`;
export const SeasonSeodataFragmentDoc = /*#__PURE__*/ gql`
    fragment SeasonSeodata on SeriesSeason {
  seoData(brandId: $brandId) {
    ...SeoData
  }
}
    ${SeoDataFragmentDoc}`;
export const SeriesAdditionalInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesAdditionalInfo on Series {
  baseRuntime
  genres
  countries {
    id
    name
  }
  originalPremiere
  originalFinale
  premiereChannel {
    ...CompanyOption
  }
}
    ${CompanyOptionFragmentDoc}`;
export const SeriesEntityLinkListFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesEntityLinkList on Series {
  title
  entityLinks {
    target {
      __typename
      ... on Entity {
        id
      }
      ... on Movie {
        title
        ref
      }
      ... on Series {
        title
        ref
      }
    }
    linkType
  }
}
    `;
export const SeriesIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesIdentity on Series {
  id
  ref
  title
  type
  status
  credits(limit: 1, activities: [PRODUCTION_EXECUTIVE_PRODUCER]) {
    nodes {
      person {
        ref
        firstName
        lastName
      }
    }
  }
  poster {
    ...Image
  }
  keywords
}
    ${ImageFragmentDoc}`;
export const SeriesReleaseMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesReleaseMetadata on EntityRelease {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SeriesReleaseNavFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesReleaseNav on EntityRelease {
  entity {
    ... on Series {
      id
      title
    }
  }
}
    `;
export const SeriesReleaseFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesRelease on EntityRelease {
  id
  type
  flags
  releasedAt
  releasedAtTime
  unreleasedAt
  notReleasedYet
  limitedCompany {
    ...CompanyOption
  }
  limitedLocalization {
    ...LocalizationIdentity
  }
  country {
    ...CountryOption
  }
  distributors {
    ...CompanyOption
  }
  certificate {
    ...Certificate
  }
  advisory
  techInfo
}
    ${CompanyOptionFragmentDoc}
${LocalizationIdentityFragmentDoc}
${CountryOptionFragmentDoc}
${CertificateFragmentDoc}`;
export const SeriesSeodataFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSeodata on Series {
  seoData(brandId: $brandId) {
    ...SeoData
  }
}
    ${SeoDataFragmentDoc}`;
export const SeoAttributesBrowsableFragmentDoc = /*#__PURE__*/ gql`
    fragment SeoAttributesBrowsable on EntitySeoData {
  browsable
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const SearchPersonFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchPerson on Person {
  __typename
  id
  ref
  lastName
  firstName
  deathDate
  poster {
    path
  }
  countries {
    name
  }
  activeOnBrands {
    ref
  }
  activities
  seoAttributes: seoAttributes(brandIds: [$brandId]) @include(if: $withSeoAttributes) {
    ...SeoAttributesBrowsable
  }
}
    ${SeoAttributesBrowsableFragmentDoc}`;
export const PersonWithSeoMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonWithSeoMetadata on Person {
  ...SearchPerson
  seoData(brandId: $brandId) @include(if: $includeBrandData) {
    ...SeoData
  }
}
    ${SearchPersonFragmentDoc}
${SeoDataFragmentDoc}`;
export const CreditFragmentDoc = /*#__PURE__*/ gql`
    fragment Credit on PersonCredits {
  __typename
  id
  active
  person {
    ...PersonWithSeoMetadata
  }
  rank
  role
  metadata {
    ...Metadata
  }
  voice {
    ...PersonWithSeoMetadata
  }
  localeData(locale: $locale, limit: $limit) @include(if: $showLocaleData) {
    nodes {
      ...LocalCastingDetail
    }
  }
}
    ${PersonWithSeoMetadataFragmentDoc}
${MetadataFragmentDoc}
${LocalCastingDetailFragmentDoc}`;
export const CreditLimitedFragmentDoc = /*#__PURE__*/ gql`
    fragment CreditLimited on PersonCredits {
  __typename
  id
  person {
    __typename
    id
    ref
    firstName
    lastName
    activeOnBrands {
      id
      ref
    }
    seoData(brandId: $brandId) @include(if: $includeBrandData) {
      ...SeoData
    }
  }
  activity
  rank
}
    ${SeoDataFragmentDoc}`;
export const EntityAltsFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityAlts on Entity {
  __typename
  id
  externalIDs {
    type
    alts
  }
}
    `;
export const EntityBrandDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityBrandData on Brandable {
  activeOnBrands {
    ref
  }
}
    `;
export const EntitiesCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment EntitiesCompany on EntityCompany {
  id
  company {
    id
    ref
    name
  }
  rank
  activity
}
    `;
export const EntityTagFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityTag on EntityTag {
  id
  rank
  tag {
    id
    ref
    name
    type
    active
    brand {
      ...BrandOption
    }
  }
  entity {
    __typename
    ... on Company {
      id
      rawId
      ref
      name
      title: name
    }
    ... on Person {
      id
      rawId
      ref
      firstName
      lastName
    }
    ... on SeriesSeason {
      id
      rawId
      ref
      number
    }
    ... on SeriesEpisode {
      id
      rawId
      ref
      episodeTitle: title
    }
    ... on Slide {
      id
      rawId
      ref
      title
    }
    ... on Theater {
      id
      rawId
      ref
      name
    }
    ... on Movie {
      __typename
      id
      rawId
      ref
      title
    }
    ... on Series {
      __typename
      id
      rawId
      ref
      title
    }
    ... on News {
      __typename
      id
      rawId
      ref
      title
    }
  }
}
    ${BrandOptionFragmentDoc}`;
export const EntityTriviaFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityTrivia on EntityTrivia {
  id
  ref
  rank
  trivia {
    __typename
    id
    ref
    active
    title
    body
    metadata {
      ...Metadata
    }
    relatedEntities {
      __typename
      ... on Movie {
        id
        ref
        title
      }
      ... on Series {
        id
        ref
        title
      }
      ... on SeriesSeason {
        id
        ref
        number
        series {
          id
          ref
          title
        }
      }
      ... on SeriesEpisode {
        ref
        id
        __typename
        number
        series {
          ref
          id
          title
        }
        season {
          ref
        }
      }
      ... on Person {
        ref
        id
        lastName
        firstName
      }
    }
  }
}
    ${MetadataFragmentDoc}`;
export const FestivalSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalSearchEntity on Festival {
  id
  ref
  name
}
    `;
export const EntityVideoFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityVideo on EntityHasVideo {
  video {
    __typename
    relatedEntities {
      ...VideoRelatedEntity
    }
    id
    ref
    title
    generatedTitle
    active
    language
    description
    duration {
      hours
      minutes
      seconds
    }
    startsAt
    endsAt
    snapshot {
      path
      url
    }
    type
    ... on VideoLegacy {
      brand {
        ...BrandOption
      }
    }
  }
  rank
}
    ${VideoRelatedEntityFragmentDoc}
${BrandOptionFragmentDoc}`;
export const LocalCertificateIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment LocalCertificateIdentity on EntityLocalRelease {
  localization {
    id
    name
    type
    country {
      ...CountryOption
    }
  }
  certificate {
    id
    ref
    label
    code
  }
  advisory
}
    ${CountryOptionFragmentDoc}`;
export const PersonCreditsImportLlmCallFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonCreditsImportLlmCall on PersonCreditsImportLlmCall {
  provider
  model
  inputTokens
  outputTokens
  durationMs
  costUsd
  error
}
    `;
export const PersonCreditsImportPersonFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonCreditsImportPerson on Person {
  __typename
  id
  ref
  firstName
  lastName
  birthDate
  deathDate
  countries {
    id
    name
    alpha2
  }
  activities
  poster {
    id
    path
  }
}
    `;
export const PersonCreditsImportReportFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonCreditsImportReport on PersonCreditsImportReport {
  __typename
  id
  status
  failureReason
  launchedAt
  finishedAt
  source
  metadata {
    createdBy {
      id
      name
    }
  }
  outcome
  answeredBy
  counts {
    linked
    matched
    ambiguous
    unknown
    extraneous
  }
  stats {
    durationMs
    requests
    bytesReceived
    resolutionDurationMs
    resolutionRequests
    levels {
      level
      name
      outcome
      durationMs
      requests
      bytesReceived
      creditsCount
      detail
      llmInputTokens
      llm {
        ...PersonCreditsImportLlmCall
      }
    }
    llm {
      ...PersonCreditsImportLlmCall
    }
  }
  localization {
    locale
    localeId
    outcome
    detail
    durationMs
    rolesAsked
    rolesLocalized
    llm {
      ...PersonCreditsImportLlmCall
    }
  }
  resolution {
    __typename
    confidence
    sourceId
    source
    detail
    candidates {
      id
      title
      year
      kind
    }
  }
  entries {
    __typename
    status
    name
    category
    role
    localizedRole
    externalPersonId
    order
    suggestedActivity
    gender
    isVoice
    linkKind
    linkLocale
    linkedPerson {
      ...PersonCreditsImportPerson
    }
    candidates {
      ...PersonCreditsImportPerson
    }
    credit {
      __typename
      id
      activity
      rank
      role
    }
  }
}
    ${PersonCreditsImportLlmCallFragmentDoc}
${PersonCreditsImportPersonFragmentDoc}`;
export const PersonCreditsImportReportSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonCreditsImportReportSummary on PersonCreditsImportReport {
  __typename
  id
  status
  launchedAt
  source
  outcome
  sections
  resolution {
    __typename
    confidence
    source
  }
  stats {
    levels {
      level
      name
      outcome
      creditsCount
    }
  }
  metadata {
    createdBy {
      id
      name
    }
  }
}
    `;
export const PersonSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonSearchEntity on Person {
  __typename
  id
  ref
  lastName
  firstName
  deathDate
  countries {
    name
  }
  poster {
    path
    ref
  }
  activeOnBrands {
    ref
  }
}
    `;
export const SearchEntitiesMovieFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchEntitiesMovie on Movie {
  id
  ref
  title
  productionYear
  poster {
    id
    path
  }
}
    `;
export const SearchEntitiesSeriesFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchEntitiesSeries on Series {
  id
  ref
  title
  originalPremiere
  poster {
    id
    path
  }
}
    `;
export const SearchEntitiesSeriesSeasonFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchEntitiesSeriesSeason on SeriesSeason {
  id
  ref
  number
  series {
    __typename
    id
    title
  }
  poster {
    id
    path
  }
}
    `;
export const SearchEntitiesNewsFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchEntitiesNews on News {
  id
  ref
  title
  poster {
    id
    path
  }
}
    `;
export const SearchEntitiesPersonFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchEntitiesPerson on Person {
  id
  ref
  firstName
  lastName
  poster {
    id
    path
  }
}
    `;
export const SearchEntitiesCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchEntitiesCompany on Company {
  ...CompanyOption
}
    ${CompanyOptionFragmentDoc}`;
export const SearchEntitiesEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchEntitiesEntity on Entity {
  __typename
  ...SearchEntitiesMovie
  ...SearchEntitiesSeries
  ...SearchEntitiesSeriesSeason
  ...SearchEntitiesNews
  ...SearchEntitiesPerson
  ...SearchEntitiesCompany
}
    ${SearchEntitiesMovieFragmentDoc}
${SearchEntitiesSeriesFragmentDoc}
${SearchEntitiesSeriesSeasonFragmentDoc}
${SearchEntitiesNewsFragmentDoc}
${SearchEntitiesPersonFragmentDoc}
${SearchEntitiesCompanyFragmentDoc}`;
export const SearchFestivalEditionFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchFestivalEdition on FestivalEdition {
  id
  ref
  name
  year
  editionNumber
  poster {
    url
  }
  festival {
    name
  }
}
    `;
export const SearchFestivalFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchFestival on Festival {
  id
  ref
  name
  poster {
    url
  }
  country {
    locale {
      id
    }
  }
  latestFestivalEdition {
    poster {
      url
    }
  }
}
    `;
export const SearchSeriesEpisodeFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchSeriesEpisode on SeriesEpisode {
  __typename
  id
  ref
  number
  title
  brandData(brandId: $brandId) @include(if: $includeBrandData) {
    title
  }
  series {
    __typename
    id
    ref
    originalPremiere
    title
  }
  season {
    __typename
    id
    ref
    number
  }
}
    `;
export const SearchTheaterFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchTheater on Theater {
  __typename
  id
  ref
  code
  name
  location {
    city
    zip
  }
  country {
    ...CountryOption
  }
  parent {
    ...CompanyOption
  }
  openingStatus
}
    ${CountryOptionFragmentDoc}
${CompanyOptionFragmentDoc}`;
export const SecureUserOptionFragmentDoc = /*#__PURE__*/ gql`
    fragment SecureUserOption on User {
  id
  name
  email
}
    `;
export const SearchVideoFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchVideo on VideoLegacy {
  __typename
  id
  ref
  title
  optionalTitle: title
  generatedTitle
  active
}
    `;
export const TheaterSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterSearchEntity on Theater {
  __typename
  id
  ref
  code
  name
  logo {
    ref
    path
  }
  theaterCountry: country {
    ...CountryOption
  }
}
    ${CountryOptionFragmentDoc}`;
export const SeriesSeasonSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesSeasonSearchEntity on SeriesSeason {
  __typename
  id
  ref
  number
  originalPremiere
  status
  poster {
    path
    url
  }
  credits(limit: 30) {
    nodes {
      person {
        id
        lastName
        firstName
      }
    }
  }
  brandData(brandId: $brandId) @include(if: $includeBrandData) {
    poster {
      path
      ref
    }
  }
  series {
    __typename
    id
    ref
    originalPremiere
    title
  }
}
    `;
export const SeriesEpisodeSearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SeriesEpisodeSearchEntity on SeriesEpisode {
  __typename
  id
  ref
  number
  episodeTitle: title
  series {
    __typename
    id
    ref
    originalPremiere
    title
  }
  credits(limit: 30) {
    nodes {
      person {
        id
        lastName
        firstName
      }
    }
  }
  season {
    __typename
    id
    ref
    number
  }
  brandData(brandId: $brandId) @include(if: $includeBrandData) {
    title
  }
}
    `;
export const RatingIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment RatingIdentity on UserRating {
  id
  ref
  rawId
  active
  metadata {
    updatedAt
    createdAt
  }
  rating
  brand {
    ...BrandOption
  }
  entity {
    __typename
    ... on Movie {
      ...MovieSearchEntity
    }
    ... on Series {
      ...SeriesSearchEntity
    }
    ... on SeriesSeason {
      ...SeriesSeasonSearchEntity
      ...SearchSeriesSeason
    }
    ... on SeriesEpisode {
      ...SeriesEpisodeSearchEntity
    }
  }
  review {
    id
    ref
    rawId
    status
    body
    stats {
      wilsonScore
      rating
      helpfulCount
      unhelpfulCount
    }
  }
  user {
    id
    rawId
    ref
    nickname
    email
    metadata {
      createdAt
    }
    stats {
      database {
        ratingCount
        reviewCount
      }
    }
  }
}
    ${BrandOptionFragmentDoc}
${MovieSearchEntityFragmentDoc}
${SeriesSearchEntityFragmentDoc}
${SeriesSeasonSearchEntityFragmentDoc}
${SearchSeriesSeasonFragmentDoc}
${SeriesEpisodeSearchEntityFragmentDoc}`;
export const TagIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment TagIdentity on Tag {
  __typename
  id
  ref
  rawId
  name
  active
  type
  metadata {
    updatedAt
  }
  scope
  data {
    seo {
      friendly
    }
  }
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const TagMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment TagMetadata on Tag {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const TagSeoFragmentDoc = /*#__PURE__*/ gql`
    fragment TagSeo on Tag {
  id
  active
  data {
    seo {
      friendly
      browsable
      topRanking
      scope {
        userRating {
          movie {
            title
            subTitle
            description
          }
          series {
            title
            subTitle
            description
          }
        }
        pressRating {
          movie {
            title
            subTitle
            description
          }
          series {
            title
            subTitle
            description
          }
        }
        popularity {
          movie {
            title
            subTitle
            description
          }
          series {
            title
            subTitle
            description
          }
        }
        ranking {
          movie {
            title
            subTitle
            description
          }
          series {
            title
            subTitle
            description
          }
        }
      }
    }
  }
}
    `;
export const TagFragmentDoc = /*#__PURE__*/ gql`
    fragment Tag on Tag {
  id
  name
}
    `;
export const SpecialOperationBrandFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationBrand on Brand {
  ...BrandOption
  country {
    id
  }
}
    ${BrandOptionFragmentDoc}`;
export const CompanySearchEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanySearchEntity on Company {
  ...CompanyOption
  logo {
    ref
    path
  }
  activities
  activeOnBrands {
    ref
  }
}
    ${CompanyOptionFragmentDoc}`;
export const SpecialOperationEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationEntity on SpecialOperationEntity {
  __typename
  ... on Movie {
    ...MovieSearchEntity
  }
  ... on Series {
    ...SeriesSearchEntity
  }
  ... on SeriesSeason {
    ...SeriesSeasonSearchEntity
  }
  ... on Company {
    ...CompanySearchEntity
  }
  ... on News {
    ...NewsSearchEntity
  }
  ... on Slide {
    ...SlideSearchEntity
  }
}
    ${MovieSearchEntityFragmentDoc}
${SeriesSearchEntityFragmentDoc}
${SeriesSeasonSearchEntityFragmentDoc}
${CompanySearchEntityFragmentDoc}
${NewsSearchEntityFragmentDoc}
${SlideSearchEntityFragmentDoc}`;
export const SpecialOperationMetadataFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationMetadataFields on Metadata {
  ...Metadata
}
    ${MetadataFragmentDoc}`;
export const CanalHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment CanalHomeSpecialOperation on CanalHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const BannerHpSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment BannerHPSpecialOperation on BannerHPSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const ClassiqueHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment ClassiqueHomeSpecialOperation on ClassiqueHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const DolbyHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment DolbyHomeSpecialOperation on DolbyHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const DisneyHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment DisneyHomeSpecialOperation on DisneyHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const EmergenceMovieSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceMovieSpecialOperation on EmergenceMovieSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const EmergenceSeriesSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceSeriesSpecialOperation on EmergenceSeriesSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const EmergenceSvodSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceSVODSpecialOperation on EmergenceSVODSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const EmergenceTheaterSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment EmergenceTheaterSpecialOperation on EmergenceTheaterSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const FestivalSectionSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment FestivalSectionSpecialOperation on FestivalSectionSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const FilmesOnlineSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment FilmesOnlineSpecialOperation on FilmesOnlineSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const IndelebileHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment IndelebileHomeSpecialOperation on IndelebileHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const ImaxHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment IMAXHomeSpecialOperation on IMAXHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const MaxHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment MaxHomeSpecialOperation on MaxHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const M6HomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment M6HomeSpecialOperation on M6HomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const MobileDdaySpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment MobileDdaySpecialOperation on MobileDdaySpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const NovelasHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment NovelasHomeSpecialOperation on NovelasHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const RollerHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment RollerHomeSpecialOperation on RollerHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const SpecialOperationAdditionalInfosFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationAdditionalInfos on SpecialOperation {
  id
  ref
  name
  ...SpecialOperationData
  entity {
    __typename
    ... on Movie {
      id
      title
    }
  }
}
    ${SpecialOperationDataFragmentDoc}`;
export const SpecialOperationCustoFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationCusto on SpecialOperation {
  id
  ref
  ...SpecialOperationData
}
    ${SpecialOperationDataFragmentDoc}`;
export const SpecialOperationMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationMetadata on SpecialOperation {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SpecialOperationSlotsFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperationSlots on SpecialOperation {
  id
  ref
  slots
}
    `;
export const SpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment SpecialOperation on SpecialOperation {
  id
  name
  ref
  rawId
  code
  active
  missingRequiredFields
  startsAt
  endsAt
  brand {
    ...BrandOption
    country {
      id
    }
  }
  slots
  entity {
    __typename
    ... on Movie {
      ...MovieSearchEntity
    }
    ... on Series {
      ...SeriesSearchEntity
    }
    ... on SeriesSeason {
      ...SeriesSeasonSearchEntity
    }
    ... on Company {
      ...CompanySearchEntity
    }
    ... on News {
      ...NewsSearchEntity
    }
    ... on Slide {
      ...SlideSearchEntity
    }
  }
  ...SpecialOperationData
}
    ${BrandOptionFragmentDoc}
${MovieSearchEntityFragmentDoc}
${SeriesSearchEntityFragmentDoc}
${SeriesSeasonSearchEntityFragmentDoc}
${CompanySearchEntityFragmentDoc}
${NewsSearchEntityFragmentDoc}
${SlideSearchEntityFragmentDoc}
${SpecialOperationDataFragmentDoc}`;
export const SponsoredAutocompleteSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment SponsoredAutocompleteSpecialOperation on SponsoredAutocompleteSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const Tf1HomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment TF1HomeSpecialOperation on TF1HomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const TicketAnchorSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment TicketAnchorSpecialOperation on TicketAnchorSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const VodHomeSpecialOperationFragmentDoc = /*#__PURE__*/ gql`
    fragment VODHomeSpecialOperation on VODHomeSpecialOperation {
  id
  name
  ref
  rawId
  code
  startsAt
  endsAt
  brand {
    ...SpecialOperationBrand
  }
  entity {
    ...SpecialOperationEntity
  }
  data {
    ...SpecialOperationDataInner
  }
  metadata {
    ...SpecialOperationMetadataFields
  }
}
    ${SpecialOperationBrandFragmentDoc}
${SpecialOperationEntityFragmentDoc}
${SpecialOperationDataInnerFragmentDoc}
${SpecialOperationMetadataFieldsFragmentDoc}`;
export const TheaterAddressFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterAddress on Theater {
  id
  country {
    ...CountryOption
  }
  coordinates {
    latitude
    longitude
  }
  location {
    address
    address2
    zip
    city
    state
    county
    country
  }
}
    ${CountryOptionFragmentDoc}`;
export const TheaterAffiliationFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterAffiliation on Theater {
  __typename
  id
  market
  affiliatedTo {
    ...CompanyOption
  }
  tradeGroup {
    ...CompanyOption
  }
  pointOfSale {
    ...CompanyOption
  }
  scheduledTypology
  country {
    ...CountryOption
  }
}
    ${CompanyOptionFragmentDoc}
${CountryOptionFragmentDoc}`;
export const TheaterFareFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterFare on Fare {
  id
  name
  comment
  price
  currency
  screens {
    id
    name
  }
  rank
}
    `;
export const TheaterFareListFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterFareList on Theater {
  id
  fares(limit: 100) {
    totalCount
    nodes {
      ...TheaterFare
    }
  }
}
    ${TheaterFareFragmentDoc}`;
export const TheaterFlagsFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterFlags on Theater {
  flags {
    payment
    service
  }
}
    `;
export const TheaterLinksFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterLinks on Theater {
  id
  links {
    ...SocialLinks
  }
}
    ${SocialLinksFragmentDoc}`;
export const TheaterFullIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterFullIdentity on Theater {
  id
  code
  name
  foundedAt
  movieLine
  timezone
  parent {
    id
    ref
    name
    activities
  }
  country {
    ...CountryOption
  }
  logo {
    id
    url
    ref
  }
  closed
  displayName
  temporaryClosure {
    message
    startsAt
    endsAt
  }
  nextOpening {
    startsAt
    message
  }
  email
  phone
  websiteUrl
  androidUrl
  iosUrl
  showtimesUrl
  showtimesAlternateUrl
  showtimeSource
  showtimesGatheringMethod
  showtimesGatheringMethodCode
  showtimesGatheringMethodPriority
  note
  openingStatus
}
    ${CountryOptionFragmentDoc}`;
export const TheaterMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterMetadata on Theater {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const TheaterSeodataFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterSeodata on Theater {
  seoData(brandId: $brandId) {
    ...SeoData
  }
}
    ${SeoDataFragmentDoc}`;
export const TheaterTicketingFragmentDoc = /*#__PURE__*/ gql`
    fragment TheaterTicketing on Theater {
  id
  ticketing {
    useAtom
    useMovieTickets
  }
}
    `;
export const TriviaEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment TriviaEntity on TriviaLinkableEntity {
  __typename
  ... on Movie {
    id
    ref
    title
  }
  ... on Series {
    id
    ref
    title
  }
  ... on SeriesSeason {
    id
    ref
    number
    series {
      id
      ref
      title
    }
  }
  ... on SeriesEpisode {
    ref
    id
    __typename
    number
    series {
      ref
      id
      title
    }
    season {
      ref
    }
  }
  ... on Person {
    id
    ref
    firstName
    lastName
  }
}
    `;
export const TriviaIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment TriviaIdentity on Trivia {
  id
  rawId
  ref
  active
  title
  type
  body
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const VideoEncoderIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoEncoderIdentity on VideoEncoderType {
  id
  platform
  channelId
  fileCount
  canRetry
  status
  statusText
  cancelError
  isCancelPending
  isLinked
  createdAt
  updatedAt
}
    `;
export const VideoAltIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoAltIdentity on VideoAltType {
  dailymotion
  youtube {
    id
    channelId
    channelLabel
  }
  videoEncoder {
    ...VideoEncoderIdentity
  }
}
    ${VideoEncoderIdentityFragmentDoc}`;
export const VideoAltFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoAlt on Video {
  alt {
    ...VideoAltIdentity
  }
}
    ${VideoAltIdentityFragmentDoc}`;
export const VideoRankFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoRank on Video {
  rankRelatedEntities(entityId: $entityId) {
    rank
    entity {
      __typename
      ... on Movie {
        id
        ref
        title
      }
      ... on Series {
        id
        ref
        title
      }
      ... on SeriesSeason {
        id
        ref
        number
        series {
          id
          ref
          title
        }
      }
      ... on SeriesEpisode {
        id
        ref
        number
        series {
          id
          ref
          title
        }
        season {
          id
          ref
          number
        }
      }
      ... on Person {
        id
        ref
        firstName
        lastName
      }
      ... on Festival {
        id
      }
      ... on FestivalEdition {
        id
      }
    }
  }
}
    `;
export const VideoMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment VideoMetadata on Video {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const WidgetIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment WidgetIdentity on Widget {
  id
  ref
  name
  type
  url
}
    `;
export const TokenUserFragmentDoc = /*#__PURE__*/ gql`
    fragment TokenUser on SocialUser {
  id
  nickname
}
    `;
export const CustomerIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment CustomerIdentity on Customer {
  id
  name
  graphBackendEndpoint
  active
  comment
  ref
}
    `;
export const TokenScopeFragmentDoc = /*#__PURE__*/ gql`
    fragment TokenScope on Scope {
  id
  ref
  name
  customer {
    ...CustomerIdentity
  }
}
    ${CustomerIdentityFragmentDoc}`;
export const TokenIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment TokenIdentity on Token {
  id
  ref
  uuid
  metadata {
    createdAt
  }
  expiresAt
  active
  lastCheckedAt
  token
  comment
  application {
    ...ApplicationIdentity
  }
  user {
    ...TokenUser
  }
  scope {
    ...TokenScope
    customer {
      ...CustomerIdentity
    }
  }
}
    ${ApplicationIdentityFragmentDoc}
${TokenUserFragmentDoc}
${TokenScopeFragmentDoc}
${CustomerIdentityFragmentDoc}`;
export const MatchedProductFragmentDoc = /*#__PURE__*/ gql`
    fragment MatchedProduct on MatchedProduct {
  id
  name
  type
  url
}
    `;
export const IgnoredProductFragmentDoc = /*#__PURE__*/ gql`
    fragment IgnoredProduct on IgnoredProduct {
  id
  sourceId
  title
  type
  metadata {
    createdAt
    createdBy {
      ...MetadataUser
    }
  }
}
    ${MetadataUserFragmentDoc}`;
export const UnknownProductFragmentDoc = /*#__PURE__*/ gql`
    fragment UnknownProduct on UnknownProduct {
  id
  entityType
  title
  type
  sourceChannelName
  url
  imageUrl
  matchingData {
    title
    episodeTitle
    seasonNumber
    episodeNumber
    releasedAt
    releasedAtTime
    unreleasedAt
    info
    productionYear
    actors
    directors
    runtime
  }
}
    `;
export const MovieLocaleDataInfosFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieLocaleDataInfos on MovieLocaleData {
  title
  poster {
    url
  }
}
    `;
export const MovieLocaleDataFragmentDoc = /*#__PURE__*/ gql`
    fragment MovieLocaleData on Movie {
  localeData(name: $locale) {
    ...MovieLocaleDataInfos
  }
}
    ${MovieLocaleDataInfosFragmentDoc}`;
export const ShowtimeEntityInfosFragmentDoc = /*#__PURE__*/ gql`
    fragment ShowtimeEntityInfos on Movie {
  title
  genres
  poster {
    url
  }
  credits(limit: 1, activities: [DIRECTION_DIRECTOR]) {
    nodes {
      person {
        id
        ref
        firstName
        lastName
      }
    }
  }
  localesData {
    locale
    title
    poster {
      url
    }
  }
  countries {
    id
    ref
    name
  }
}
    `;
export const ShowtimeEntityLocaleDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ShowtimeEntityLocaleData on Movie {
  localeData(name: $locale) {
    title
    poster {
      url
    }
  }
}
    `;
export const ShowtimeEntityRowFragmentDoc = /*#__PURE__*/ gql`
    fragment ShowtimeEntityRow on Movie {
  id
  ref
  title
  productionYear
  credits(limit: 1, activities: [DIRECTION_DIRECTOR]) {
    nodes {
      person {
        id
        firstName
        lastName
        ref
      }
    }
  }
  usLocale: localeData(name: "en_US") {
    title
  }
}
    `;
export const CustomerMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment CustomerMetadata on Customer {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const CustomerQueryFragmentDoc = /*#__PURE__*/ gql`
    fragment CustomerQuery on CustomerQuery {
  id
  name
  ref
  template
  metadata {
    createdAt
  }
}
    `;
export const CustomerQueryMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment CustomerQueryMetadata on CustomerQuery {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ScopeIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ScopeIdentity on Scope {
  id
  ref
  name
  customer {
    ...CustomerIdentity
  }
}
    ${CustomerIdentityFragmentDoc}`;
export const ScopeMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment ScopeMetadata on Scope {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ScopeCustomerQueryIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment ScopeCustomerQueryIdentity on ScopeCustomerQuery {
  id
  alias
  config {
    variables
    userVariables
  }
  scope {
    id
    ref
  }
  customerQuery {
    id
    name
  }
}
    `;
export const EditorialReviewAuthorsFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReviewAuthors on EditorialReview {
  id
  brand {
    ...BrandOption
  }
  authors {
    id
    rank
    author {
      id
      ref
      name
    }
    signature {
      id
      signature
    }
  }
}
    ${BrandOptionFragmentDoc}`;
export const EditorialReviewBodyFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReviewBody on EditorialReview {
  id
  brand {
    ...BrandOption
  }
  body
}
    ${BrandOptionFragmentDoc}`;
export const EditorialReviewEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReviewEntity on EditorialReviewEntity {
  __typename
  ... on Movie {
    id
    title
    ref
  }
  ... on Series {
    id
    title
    ref
  }
  ... on SeriesSeason {
    id
    ref
    number
    series {
      id
      ref
      title
    }
  }
}
    `;
export const EditorialReviewIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReviewIdentity on EditorialReview {
  id
  brand {
    ...BrandOption
    timezone
  }
  entity {
    ...EditorialReviewEntity
  }
  title
  active
  bodyShort
  rating
}
    ${BrandOptionFragmentDoc}
${EditorialReviewEntityFragmentDoc}`;
export const EditorialReviewMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReviewMetadata on EditorialReview {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const EditorialReviewPictureFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReviewPicture on EditorialReview {
  id
  picture {
    id
    url
    copyrightName
    copyrights {
      ...CopyrightIdentity
    }
    ref
  }
}
    ${CopyrightIdentityFragmentDoc}`;
export const EditorialReviewPublicationsFragmentDoc = /*#__PURE__*/ gql`
    fragment EditorialReviewPublications on EditorialReview {
  ...PublishableEntityFragment
}
    ${PublishableEntityFragmentFragmentDoc}`;
export const PressReviewEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment PressReviewEntity on PressReviewEntity {
  __typename
  ... on Movie {
    title
    id
    ref
  }
  ... on Series {
    title
    id
    ref
  }
  ... on SeriesSeason {
    id
    number
    ref
    originalPremiere
    status
    series {
      __typename
      id
      ref
      originalPremiere
      title
    }
  }
}
    `;
export const PressReviewIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment PressReviewIdentity on PressReview {
  id
  ref
  active
  metadata {
    updatedAt
    createdAt
  }
  author
  rating
  body
  snippet
  url
  company {
    ...CompanyOption
  }
  brand {
    ...BrandOption
  }
  entity {
    ...PressReviewEntity
  }
}
    ${CompanyOptionFragmentDoc}
${BrandOptionFragmentDoc}
${PressReviewEntityFragmentDoc}`;
export const PressReviewMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment PressReviewMetadata on PressReview {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SelectWellKnownRouteFragmentDoc = /*#__PURE__*/ gql`
    fragment SelectWellKnownRoute on WellKnownWebsiteRoute {
  name
  title
  params {
    name
    value
  }
}
    `;
export const SearchCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchCompany on Company {
  ...CompanyOption
}
    ${CompanyOptionFragmentDoc}`;
export const SearchMovieFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchMovie on Movie {
  __typename
  id
  ref
  title
  productionYear
  poster {
    path
  }
  credits(limit: 1, activities: [DIRECTION_DIRECTOR]) {
    nodes {
      person {
        firstName
        lastName
      }
    }
  }
  genres
  brandsData {
    title
    brand {
      ...BrandOption
    }
  }
  activeOnBrands {
    ref
  }
  seoAttributes: seoAttributes(brandIds: [$brandId]) @include(if: $withSeoAttributes) {
    ...SeoAttributesBrowsable
  }
}
    ${BrandOptionFragmentDoc}
${SeoAttributesBrowsableFragmentDoc}`;
export const SearchNewsFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchNews on News {
  id
  ref
  title
  active
  publicationDate
  publicationStatus
}
    `;
export const SearchSeriesFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchSeries on Series {
  __typename
  id
  ref
  title
  originalPremiere
  poster {
    path
  }
  genres
  brandData(brandId: $brandId) @include(if: $includeBrandData) {
    title
    brand {
      ...BrandOption
    }
  }
  activeOnBrands {
    ref
  }
  seoAttributes: seoAttributes(brandIds: [$brandId]) @include(if: $withSeoAttributes) {
    ...SeoAttributesBrowsable
  }
}
    ${BrandOptionFragmentDoc}
${SeoAttributesBrowsableFragmentDoc}`;
export const WellKnownRouteFragmentDoc = /*#__PURE__*/ gql`
    fragment WellKnownRoute on WellKnownWebsiteRoute {
  ...SelectWellKnownRoute
  type
  mainParam
  entity {
    ... on Company {
      ...SearchCompany
    }
    ... on Movie {
      ...SearchMovie
    }
    ... on News {
      ...SearchNews
    }
    ... on Person {
      ...SearchPerson
    }
    ... on Series {
      ...SearchSeries
    }
    ... on SeriesSeason {
      ...SearchSeriesSeason
    }
  }
}
    ${SelectWellKnownRouteFragmentDoc}
${SearchCompanyFragmentDoc}
${SearchMovieFragmentDoc}
${SearchNewsFragmentDoc}
${SearchPersonFragmentDoc}
${SearchSeriesFragmentDoc}
${SearchSeriesSeasonFragmentDoc}`;
export const ImageReferenceFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageReference on ImageReference {
  image {
    ...Image
  }
  rank
}
    ${ImageFragmentDoc}`;
export const ImageReferenceMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageReferenceMetadata on ImageReference {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const ImageReferenceFromImageHasCategoryFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageReferenceFromImageHasCategory on ImageReference {
  ...ImageReference
  ...ImageReferenceMetadata
  image {
    ...Image
    type
    active
    endDate
    startDate
    tags
    title
  }
  category {
    id
    name
    brand {
      id
      ref
      name
    }
  }
}
    ${ImageReferenceFragmentDoc}
${ImageReferenceMetadataFragmentDoc}
${ImageFragmentDoc}`;
export const ImageHasCategoryFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageHasCategory on ImageHasCategory {
  id
  imageId
  categoryId
  rank
}
    `;
export const SocialMetadataFragmentDoc = /*#__PURE__*/ gql`
    fragment SocialMetadata on SocialUser {
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const SocialStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment SocialStats on SocialUser {
  id
  stats {
    database {
      ratingCount
      reviewCount
      actionCount
      theaterCount
      collectionCount
      followedCollectionCount
      followerCount
      followeeCount
    }
    graphAPI {
      ratingCount
      reviewCount
      actionCount
      theaterCount
      collectionCount
      followedCollectionCount
      followerCount
      followeeCount
    }
  }
}
    `;
export const SocialUserFullIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SocialUserFullIdentity on SocialUser {
  id
  ref
  actito
  active
  avatar
  brand {
    ...BrandOption
  }
  email
  isClub300
  isEULAAccepted
  isEmailValid
  legacyID
  nickname
  socialProviders
}
    ${BrandOptionFragmentDoc}`;
export const SocialUserIdentityFragmentDoc = /*#__PURE__*/ gql`
    fragment SocialUserIdentity on SocialUser {
  id
  ref
  active
  email
  legacyID
  brand {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;
export const BoxofficeReleaseFragmentDoc = /*#__PURE__*/ gql`
    fragment BoxofficeRelease on TemporalBoxoffice {
  id
  value
  cumulative
  copyCount
  estimate
  movie {
    ref
    id
    title
    releases(
      limit: 1
      countryId: $countryId
      type: THEATER
      orderBy: {field: RELEASED_AT, direction: DESC}
    ) {
      nodes {
        country {
          ...CountryOption
        }
        releasedAt
        type
      }
    }
  }
  range {
    startsAt
    endsAt
  }
  country {
    id
    name
    alpha2
  }
}
    ${CountryOptionFragmentDoc}`;
export const ImageCategoryFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageCategory on ImageCategory {
  __typename
  id
  ref
  name
  imageType
  brand {
    id
    ref
    name
  }
  sponsored
  rank
  active
  imagesValidityRange {
    min
    max
    totalHasTtl
    totalWithoutTtl
    hasComingSoon
    hasPlanned
  }
  images(limit: 0) {
    totalCount
  }
  metadata {
    ...Metadata
  }
}
    ${MetadataFragmentDoc}`;
export const CheckUrlDocument = /*#__PURE__*/ gql`
    query checkURL($url: String!) {
  checkURL(url: $url) {
    success
    error
    statusCode
    responseTime
  }
}
    `;

/**
 * __useCheckUrlQuery__
 *
 * To run a query within a React component, call `useCheckUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.CheckUrlQuery, Generated.CheckUrlQueryVariables> & ({ variables: Generated.CheckUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.CheckUrlQuery, Generated.CheckUrlQueryVariables>(CheckUrlDocument, options);
      }
export function useCheckUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.CheckUrlQuery, Generated.CheckUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.CheckUrlQuery, Generated.CheckUrlQueryVariables>(CheckUrlDocument, options);
        }
export function useCheckUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.CheckUrlQuery, Generated.CheckUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.CheckUrlQuery, Generated.CheckUrlQueryVariables>(CheckUrlDocument, options);
        }
export type CheckUrlQueryHookResult = ReturnType<typeof useCheckUrlQuery>;
export type CheckUrlLazyQueryHookResult = ReturnType<typeof useCheckUrlLazyQuery>;
export type CheckUrlSuspenseQueryHookResult = ReturnType<typeof useCheckUrlSuspenseQuery>;
export type CheckUrlQueryResult = Apollo.QueryResult<Generated.CheckUrlQuery, Generated.CheckUrlQueryVariables>;
export const GetFileMetadataDocument = /*#__PURE__*/ gql`
    query getFileMetadata($uploadToken: String!) {
  fileMetadata(uploadToken: $uploadToken) {
    hash
    mimeType
    size
    path
    ressourceURI
    resourceUrl
    imageSize {
      width
      height
    }
  }
}
    `;

/**
 * __useGetFileMetadataQuery__
 *
 * To run a query within a React component, call `useGetFileMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileMetadataQuery({
 *   variables: {
 *      uploadToken: // value for 'uploadToken'
 *   },
 * });
 */
export function useGetFileMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFileMetadataQuery, Generated.GetFileMetadataQueryVariables> & ({ variables: Generated.GetFileMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFileMetadataQuery, Generated.GetFileMetadataQueryVariables>(GetFileMetadataDocument, options);
      }
export function useGetFileMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFileMetadataQuery, Generated.GetFileMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFileMetadataQuery, Generated.GetFileMetadataQueryVariables>(GetFileMetadataDocument, options);
        }
export function useGetFileMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFileMetadataQuery, Generated.GetFileMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFileMetadataQuery, Generated.GetFileMetadataQueryVariables>(GetFileMetadataDocument, options);
        }
export type GetFileMetadataQueryHookResult = ReturnType<typeof useGetFileMetadataQuery>;
export type GetFileMetadataLazyQueryHookResult = ReturnType<typeof useGetFileMetadataLazyQuery>;
export type GetFileMetadataSuspenseQueryHookResult = ReturnType<typeof useGetFileMetadataSuspenseQuery>;
export type GetFileMetadataQueryResult = Apollo.QueryResult<Generated.GetFileMetadataQuery, Generated.GetFileMetadataQueryVariables>;
export const HeaderInfoDocument = /*#__PURE__*/ gql`
    query HeaderInfo {
  viewer {
    id
    ref
    name
    author {
      id
      ref
    }
  }
}
    `;

/**
 * __useHeaderInfoQuery__
 *
 * To run a query within a React component, call `useHeaderInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaderInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.HeaderInfoQuery, Generated.HeaderInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.HeaderInfoQuery, Generated.HeaderInfoQueryVariables>(HeaderInfoDocument, options);
      }
export function useHeaderInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.HeaderInfoQuery, Generated.HeaderInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.HeaderInfoQuery, Generated.HeaderInfoQueryVariables>(HeaderInfoDocument, options);
        }
export function useHeaderInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.HeaderInfoQuery, Generated.HeaderInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.HeaderInfoQuery, Generated.HeaderInfoQueryVariables>(HeaderInfoDocument, options);
        }
export type HeaderInfoQueryHookResult = ReturnType<typeof useHeaderInfoQuery>;
export type HeaderInfoLazyQueryHookResult = ReturnType<typeof useHeaderInfoLazyQuery>;
export type HeaderInfoSuspenseQueryHookResult = ReturnType<typeof useHeaderInfoSuspenseQuery>;
export type HeaderInfoQueryResult = Apollo.QueryResult<Generated.HeaderInfoQuery, Generated.HeaderInfoQueryVariables>;
export const CreateAuthorSignatureDocument = /*#__PURE__*/ gql`
    mutation createAuthorSignature($input: CreateAuthorSignatureInput!) {
  createAuthorSignature(input: $input) {
    id
  }
}
    `;
export type CreateAuthorSignatureMutationFn = Apollo.MutationFunction<Generated.CreateAuthorSignatureMutation, Generated.CreateAuthorSignatureMutationVariables>;

/**
 * __useCreateAuthorSignatureMutation__
 *
 * To run a mutation, you first call `useCreateAuthorSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorSignatureMutation, { data, loading, error }] = useCreateAuthorSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorSignatureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateAuthorSignatureMutation, Generated.CreateAuthorSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateAuthorSignatureMutation, Generated.CreateAuthorSignatureMutationVariables>(CreateAuthorSignatureDocument, options);
      }
export type CreateAuthorSignatureMutationHookResult = ReturnType<typeof useCreateAuthorSignatureMutation>;
export type CreateAuthorSignatureMutationResult = Apollo.MutationResult<Generated.CreateAuthorSignatureMutation>;
export type CreateAuthorSignatureMutationOptions = Apollo.BaseMutationOptions<Generated.CreateAuthorSignatureMutation, Generated.CreateAuthorSignatureMutationVariables>;
export const CreateAuthorDocument = /*#__PURE__*/ gql`
    mutation createAuthor($input: CreateAuthorInput!) {
  createAuthor(input: $input) {
    id
    ref
    user {
      author {
        id
      }
    }
  }
}
    `;
export type CreateAuthorMutationFn = Apollo.MutationFunction<Generated.CreateAuthorMutation, Generated.CreateAuthorMutationVariables>;

/**
 * __useCreateAuthorMutation__
 *
 * To run a mutation, you first call `useCreateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorMutation, { data, loading, error }] = useCreateAuthorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateAuthorMutation, Generated.CreateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateAuthorMutation, Generated.CreateAuthorMutationVariables>(CreateAuthorDocument, options);
      }
export type CreateAuthorMutationHookResult = ReturnType<typeof useCreateAuthorMutation>;
export type CreateAuthorMutationResult = Apollo.MutationResult<Generated.CreateAuthorMutation>;
export type CreateAuthorMutationOptions = Apollo.BaseMutationOptions<Generated.CreateAuthorMutation, Generated.CreateAuthorMutationVariables>;
export const GetAuthorListDocument = /*#__PURE__*/ gql`
    query getAuthorList($limit: Int!, $offset: Int!, $brandId: ID, $search: String) {
  authors(limit: $limit, offset: $offset, brandId: $brandId, search: $search) {
    totalCount
    nodes {
      id
      ref
      name
      user {
        ...MetadataUser
      }
      metadata {
        updatedAt
      }
      brand {
        ...BrandOption
      }
    }
  }
  viewer {
    id
  }
}
    ${MetadataUserFragmentDoc}
${BrandOptionFragmentDoc}`;

/**
 * __useGetAuthorListQuery__
 *
 * To run a query within a React component, call `useGetAuthorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAuthorListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetAuthorListQuery, Generated.GetAuthorListQueryVariables> & ({ variables: Generated.GetAuthorListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetAuthorListQuery, Generated.GetAuthorListQueryVariables>(GetAuthorListDocument, options);
      }
export function useGetAuthorListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetAuthorListQuery, Generated.GetAuthorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetAuthorListQuery, Generated.GetAuthorListQueryVariables>(GetAuthorListDocument, options);
        }
export function useGetAuthorListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetAuthorListQuery, Generated.GetAuthorListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetAuthorListQuery, Generated.GetAuthorListQueryVariables>(GetAuthorListDocument, options);
        }
export type GetAuthorListQueryHookResult = ReturnType<typeof useGetAuthorListQuery>;
export type GetAuthorListLazyQueryHookResult = ReturnType<typeof useGetAuthorListLazyQuery>;
export type GetAuthorListSuspenseQueryHookResult = ReturnType<typeof useGetAuthorListSuspenseQuery>;
export type GetAuthorListQueryResult = Apollo.QueryResult<Generated.GetAuthorListQuery, Generated.GetAuthorListQueryVariables>;
export const GetAuthorSignaturesListDocument = /*#__PURE__*/ gql`
    query getAuthorSignaturesList($authorId: ID!) {
  author(id: $authorId) {
    id
    user {
      id
    }
    signatures {
      ...AuthorSignature
    }
  }
  viewer {
    id
  }
}
    ${AuthorSignatureFragmentDoc}`;

/**
 * __useGetAuthorSignaturesListQuery__
 *
 * To run a query within a React component, call `useGetAuthorSignaturesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorSignaturesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorSignaturesListQuery({
 *   variables: {
 *      authorId: // value for 'authorId'
 *   },
 * });
 */
export function useGetAuthorSignaturesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetAuthorSignaturesListQuery, Generated.GetAuthorSignaturesListQueryVariables> & ({ variables: Generated.GetAuthorSignaturesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetAuthorSignaturesListQuery, Generated.GetAuthorSignaturesListQueryVariables>(GetAuthorSignaturesListDocument, options);
      }
export function useGetAuthorSignaturesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetAuthorSignaturesListQuery, Generated.GetAuthorSignaturesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetAuthorSignaturesListQuery, Generated.GetAuthorSignaturesListQueryVariables>(GetAuthorSignaturesListDocument, options);
        }
export function useGetAuthorSignaturesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetAuthorSignaturesListQuery, Generated.GetAuthorSignaturesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetAuthorSignaturesListQuery, Generated.GetAuthorSignaturesListQueryVariables>(GetAuthorSignaturesListDocument, options);
        }
export type GetAuthorSignaturesListQueryHookResult = ReturnType<typeof useGetAuthorSignaturesListQuery>;
export type GetAuthorSignaturesListLazyQueryHookResult = ReturnType<typeof useGetAuthorSignaturesListLazyQuery>;
export type GetAuthorSignaturesListSuspenseQueryHookResult = ReturnType<typeof useGetAuthorSignaturesListSuspenseQuery>;
export type GetAuthorSignaturesListQueryResult = Apollo.QueryResult<Generated.GetAuthorSignaturesListQuery, Generated.GetAuthorSignaturesListQueryVariables>;
export const UpdateAuthorLinksDocument = /*#__PURE__*/ gql`
    mutation updateAuthorLinks($id: ID!, $links: SocialLinksInput!) {
  updateAuthor(input: {id: $id, links: $links}) {
    id
    ...AuthorLinks
    ...AuthorMetadata
  }
}
    ${AuthorLinksFragmentDoc}
${AuthorMetadataFragmentDoc}`;
export type UpdateAuthorLinksMutationFn = Apollo.MutationFunction<Generated.UpdateAuthorLinksMutation, Generated.UpdateAuthorLinksMutationVariables>;

/**
 * __useUpdateAuthorLinksMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorLinksMutation, { data, loading, error }] = useUpdateAuthorLinksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useUpdateAuthorLinksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateAuthorLinksMutation, Generated.UpdateAuthorLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateAuthorLinksMutation, Generated.UpdateAuthorLinksMutationVariables>(UpdateAuthorLinksDocument, options);
      }
export type UpdateAuthorLinksMutationHookResult = ReturnType<typeof useUpdateAuthorLinksMutation>;
export type UpdateAuthorLinksMutationResult = Apollo.MutationResult<Generated.UpdateAuthorLinksMutation>;
export type UpdateAuthorLinksMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateAuthorLinksMutation, Generated.UpdateAuthorLinksMutationVariables>;
export const GetAuthorDocument = /*#__PURE__*/ gql`
    query getAuthor($ref: ID!) {
  entityByRef(type: AUTHOR, ref: $ref) {
    ... on Author {
      ...AuthorMetadata
      ...AuthorIdentity
      ...AuthorSeoData
      ...AuthorLinks
    }
  }
  viewer {
    id
  }
}
    ${AuthorMetadataFragmentDoc}
${AuthorIdentityFragmentDoc}
${AuthorSeoDataFragmentDoc}
${AuthorLinksFragmentDoc}`;

/**
 * __useGetAuthorQuery__
 *
 * To run a query within a React component, call `useGetAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetAuthorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetAuthorQuery, Generated.GetAuthorQueryVariables> & ({ variables: Generated.GetAuthorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetAuthorQuery, Generated.GetAuthorQueryVariables>(GetAuthorDocument, options);
      }
export function useGetAuthorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetAuthorQuery, Generated.GetAuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetAuthorQuery, Generated.GetAuthorQueryVariables>(GetAuthorDocument, options);
        }
export function useGetAuthorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetAuthorQuery, Generated.GetAuthorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetAuthorQuery, Generated.GetAuthorQueryVariables>(GetAuthorDocument, options);
        }
export type GetAuthorQueryHookResult = ReturnType<typeof useGetAuthorQuery>;
export type GetAuthorLazyQueryHookResult = ReturnType<typeof useGetAuthorLazyQuery>;
export type GetAuthorSuspenseQueryHookResult = ReturnType<typeof useGetAuthorSuspenseQuery>;
export type GetAuthorQueryResult = Apollo.QueryResult<Generated.GetAuthorQuery, Generated.GetAuthorQueryVariables>;
export const UpdateAuthorSeoDataDocument = /*#__PURE__*/ gql`
    mutation updateAuthorSeoData($input: UpdateAuthorSeoDataInput!) {
  updateAuthorSeoData(input: $input) {
    ...AuthorSeoData
    ...AuthorMetadata
  }
}
    ${AuthorSeoDataFragmentDoc}
${AuthorMetadataFragmentDoc}`;
export type UpdateAuthorSeoDataMutationFn = Apollo.MutationFunction<Generated.UpdateAuthorSeoDataMutation, Generated.UpdateAuthorSeoDataMutationVariables>;

/**
 * __useUpdateAuthorSeoDataMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorSeoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorSeoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorSeoDataMutation, { data, loading, error }] = useUpdateAuthorSeoDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorSeoDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateAuthorSeoDataMutation, Generated.UpdateAuthorSeoDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateAuthorSeoDataMutation, Generated.UpdateAuthorSeoDataMutationVariables>(UpdateAuthorSeoDataDocument, options);
      }
export type UpdateAuthorSeoDataMutationHookResult = ReturnType<typeof useUpdateAuthorSeoDataMutation>;
export type UpdateAuthorSeoDataMutationResult = Apollo.MutationResult<Generated.UpdateAuthorSeoDataMutation>;
export type UpdateAuthorSeoDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateAuthorSeoDataMutation, Generated.UpdateAuthorSeoDataMutationVariables>;
export const UpdateAuthorDocument = /*#__PURE__*/ gql`
    mutation updateAuthor($input: UpdateAuthorInput!) {
  updateAuthor(input: $input) {
    ...AuthorMetadata
    ...AuthorIdentity
    user {
      author {
        id
      }
    }
  }
}
    ${AuthorMetadataFragmentDoc}
${AuthorIdentityFragmentDoc}`;
export type UpdateAuthorMutationFn = Apollo.MutationFunction<Generated.UpdateAuthorMutation, Generated.UpdateAuthorMutationVariables>;

/**
 * __useUpdateAuthorMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorMutation, { data, loading, error }] = useUpdateAuthorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateAuthorMutation, Generated.UpdateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateAuthorMutation, Generated.UpdateAuthorMutationVariables>(UpdateAuthorDocument, options);
      }
export type UpdateAuthorMutationHookResult = ReturnType<typeof useUpdateAuthorMutation>;
export type UpdateAuthorMutationResult = Apollo.MutationResult<Generated.UpdateAuthorMutation>;
export type UpdateAuthorMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateAuthorMutation, Generated.UpdateAuthorMutationVariables>;
export const UpdateAuthorSignatureDocument = /*#__PURE__*/ gql`
    mutation updateAuthorSignature($input: UpdateAuthorSignatureInput!) {
  updateAuthorSignature(input: $input) {
    ...AuthorSignature
  }
}
    ${AuthorSignatureFragmentDoc}`;
export type UpdateAuthorSignatureMutationFn = Apollo.MutationFunction<Generated.UpdateAuthorSignatureMutation, Generated.UpdateAuthorSignatureMutationVariables>;

/**
 * __useUpdateAuthorSignatureMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorSignatureMutation, { data, loading, error }] = useUpdateAuthorSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorSignatureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateAuthorSignatureMutation, Generated.UpdateAuthorSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateAuthorSignatureMutation, Generated.UpdateAuthorSignatureMutationVariables>(UpdateAuthorSignatureDocument, options);
      }
export type UpdateAuthorSignatureMutationHookResult = ReturnType<typeof useUpdateAuthorSignatureMutation>;
export type UpdateAuthorSignatureMutationResult = Apollo.MutationResult<Generated.UpdateAuthorSignatureMutation>;
export type UpdateAuthorSignatureMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateAuthorSignatureMutation, Generated.UpdateAuthorSignatureMutationVariables>;
export const AddBoxofficeDocument = /*#__PURE__*/ gql`
    mutation addBoxoffice($input: AddTemporalBoxofficeInput!) {
  addTemporalBoxoffice(input: $input) {
    id
  }
}
    `;
export type AddBoxofficeMutationFn = Apollo.MutationFunction<Generated.AddBoxofficeMutation, Generated.AddBoxofficeMutationVariables>;

/**
 * __useAddBoxofficeMutation__
 *
 * To run a mutation, you first call `useAddBoxofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBoxofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBoxofficeMutation, { data, loading, error }] = useAddBoxofficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBoxofficeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddBoxofficeMutation, Generated.AddBoxofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddBoxofficeMutation, Generated.AddBoxofficeMutationVariables>(AddBoxofficeDocument, options);
      }
export type AddBoxofficeMutationHookResult = ReturnType<typeof useAddBoxofficeMutation>;
export type AddBoxofficeMutationResult = Apollo.MutationResult<Generated.AddBoxofficeMutation>;
export type AddBoxofficeMutationOptions = Apollo.BaseMutationOptions<Generated.AddBoxofficeMutation, Generated.AddBoxofficeMutationVariables>;
export const DeleteBoxofficeDocument = /*#__PURE__*/ gql`
    mutation deleteBoxoffice($id: ID!) {
  deleteTemporalBoxoffice(input: {id: $id}) {
    id
  }
}
    `;
export type DeleteBoxofficeMutationFn = Apollo.MutationFunction<Generated.DeleteBoxofficeMutation, Generated.DeleteBoxofficeMutationVariables>;

/**
 * __useDeleteBoxofficeMutation__
 *
 * To run a mutation, you first call `useDeleteBoxofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoxofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoxofficeMutation, { data, loading, error }] = useDeleteBoxofficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBoxofficeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteBoxofficeMutation, Generated.DeleteBoxofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteBoxofficeMutation, Generated.DeleteBoxofficeMutationVariables>(DeleteBoxofficeDocument, options);
      }
export type DeleteBoxofficeMutationHookResult = ReturnType<typeof useDeleteBoxofficeMutation>;
export type DeleteBoxofficeMutationResult = Apollo.MutationResult<Generated.DeleteBoxofficeMutation>;
export type DeleteBoxofficeMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteBoxofficeMutation, Generated.DeleteBoxofficeMutationVariables>;
export const GetBoxofficeListDocument = /*#__PURE__*/ gql`
    query getBoxofficeList($limit: Int, $offset: Int!, $countryId: ID!, $movieId: ID, $range: DateRangeInput, $rangeOperator: RangeOperator, $orderBy: TemporalBoxofficeOrder) {
  temporalBoxoffices(
    limit: $limit
    offset: $offset
    countryId: $countryId
    movieId: $movieId
    range: $range
    rangeOperator: $rangeOperator
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...BoxofficeIdentity
    }
  }
}
    ${BoxofficeIdentityFragmentDoc}`;

/**
 * __useGetBoxofficeListQuery__
 *
 * To run a query within a React component, call `useGetBoxofficeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoxofficeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoxofficeListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      countryId: // value for 'countryId'
 *      movieId: // value for 'movieId'
 *      range: // value for 'range'
 *      rangeOperator: // value for 'rangeOperator'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetBoxofficeListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetBoxofficeListQuery, Generated.GetBoxofficeListQueryVariables> & ({ variables: Generated.GetBoxofficeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetBoxofficeListQuery, Generated.GetBoxofficeListQueryVariables>(GetBoxofficeListDocument, options);
      }
export function useGetBoxofficeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetBoxofficeListQuery, Generated.GetBoxofficeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetBoxofficeListQuery, Generated.GetBoxofficeListQueryVariables>(GetBoxofficeListDocument, options);
        }
export function useGetBoxofficeListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetBoxofficeListQuery, Generated.GetBoxofficeListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetBoxofficeListQuery, Generated.GetBoxofficeListQueryVariables>(GetBoxofficeListDocument, options);
        }
export type GetBoxofficeListQueryHookResult = ReturnType<typeof useGetBoxofficeListQuery>;
export type GetBoxofficeListLazyQueryHookResult = ReturnType<typeof useGetBoxofficeListLazyQuery>;
export type GetBoxofficeListSuspenseQueryHookResult = ReturnType<typeof useGetBoxofficeListSuspenseQuery>;
export type GetBoxofficeListQueryResult = Apollo.QueryResult<Generated.GetBoxofficeListQuery, Generated.GetBoxofficeListQueryVariables>;
export const UpdateBoxofficeDocument = /*#__PURE__*/ gql`
    mutation updateBoxoffice($input: UpdateTemporalBoxofficeInput!) {
  updateTemporalBoxoffice(input: $input) {
    ...BoxofficeIdentity
  }
}
    ${BoxofficeIdentityFragmentDoc}`;
export type UpdateBoxofficeMutationFn = Apollo.MutationFunction<Generated.UpdateBoxofficeMutation, Generated.UpdateBoxofficeMutationVariables>;

/**
 * __useUpdateBoxofficeMutation__
 *
 * To run a mutation, you first call `useUpdateBoxofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoxofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoxofficeMutation, { data, loading, error }] = useUpdateBoxofficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBoxofficeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateBoxofficeMutation, Generated.UpdateBoxofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateBoxofficeMutation, Generated.UpdateBoxofficeMutationVariables>(UpdateBoxofficeDocument, options);
      }
export type UpdateBoxofficeMutationHookResult = ReturnType<typeof useUpdateBoxofficeMutation>;
export type UpdateBoxofficeMutationResult = Apollo.MutationResult<Generated.UpdateBoxofficeMutation>;
export type UpdateBoxofficeMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateBoxofficeMutation, Generated.UpdateBoxofficeMutationVariables>;
export const BrandSearchLinksListDocument = /*#__PURE__*/ gql`
    query BrandSearchLinksList($offset: Int, $limit: Int, $q: String, $title: String, $brandIds: [ID!]) {
  brandSearchLinks(
    offset: $offset
    limit: $limit
    q: $q
    title: $title
    brandIds: $brandIds
  ) {
    totalCount
    nodes {
      ...BrandSearchLinkRow
    }
  }
}
    ${BrandSearchLinkRowFragmentDoc}`;

/**
 * __useBrandSearchLinksListQuery__
 *
 * To run a query within a React component, call `useBrandSearchLinksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSearchLinksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSearchLinksListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      title: // value for 'title'
 *      brandIds: // value for 'brandIds'
 *   },
 * });
 */
export function useBrandSearchLinksListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.BrandSearchLinksListQuery, Generated.BrandSearchLinksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.BrandSearchLinksListQuery, Generated.BrandSearchLinksListQueryVariables>(BrandSearchLinksListDocument, options);
      }
export function useBrandSearchLinksListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.BrandSearchLinksListQuery, Generated.BrandSearchLinksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.BrandSearchLinksListQuery, Generated.BrandSearchLinksListQueryVariables>(BrandSearchLinksListDocument, options);
        }
export function useBrandSearchLinksListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.BrandSearchLinksListQuery, Generated.BrandSearchLinksListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.BrandSearchLinksListQuery, Generated.BrandSearchLinksListQueryVariables>(BrandSearchLinksListDocument, options);
        }
export type BrandSearchLinksListQueryHookResult = ReturnType<typeof useBrandSearchLinksListQuery>;
export type BrandSearchLinksListLazyQueryHookResult = ReturnType<typeof useBrandSearchLinksListLazyQuery>;
export type BrandSearchLinksListSuspenseQueryHookResult = ReturnType<typeof useBrandSearchLinksListSuspenseQuery>;
export type BrandSearchLinksListQueryResult = Apollo.QueryResult<Generated.BrandSearchLinksListQuery, Generated.BrandSearchLinksListQueryVariables>;
export const DeleteBrandSearchLinkDocument = /*#__PURE__*/ gql`
    mutation DeleteBrandSearchLink($input: DeleteBrandSearchLinkInput!) {
  deleteBrandSearchLink(input: $input) {
    id
    title
    ref
  }
}
    `;
export type DeleteBrandSearchLinkMutationFn = Apollo.MutationFunction<Generated.DeleteBrandSearchLinkMutation, Generated.DeleteBrandSearchLinkMutationVariables>;

/**
 * __useDeleteBrandSearchLinkMutation__
 *
 * To run a mutation, you first call `useDeleteBrandSearchLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandSearchLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandSearchLinkMutation, { data, loading, error }] = useDeleteBrandSearchLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBrandSearchLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteBrandSearchLinkMutation, Generated.DeleteBrandSearchLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteBrandSearchLinkMutation, Generated.DeleteBrandSearchLinkMutationVariables>(DeleteBrandSearchLinkDocument, options);
      }
export type DeleteBrandSearchLinkMutationHookResult = ReturnType<typeof useDeleteBrandSearchLinkMutation>;
export type DeleteBrandSearchLinkMutationResult = Apollo.MutationResult<Generated.DeleteBrandSearchLinkMutation>;
export type DeleteBrandSearchLinkMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteBrandSearchLinkMutation, Generated.DeleteBrandSearchLinkMutationVariables>;
export const CreateBrandSearchLinkDocument = /*#__PURE__*/ gql`
    mutation CreateBrandSearchLink($input: CreateBrandSearchLinkInput!) {
  createBrandSearchLink(input: $input) {
    ...BrandSearchLinkRow
  }
}
    ${BrandSearchLinkRowFragmentDoc}`;
export type CreateBrandSearchLinkMutationFn = Apollo.MutationFunction<Generated.CreateBrandSearchLinkMutation, Generated.CreateBrandSearchLinkMutationVariables>;

/**
 * __useCreateBrandSearchLinkMutation__
 *
 * To run a mutation, you first call `useCreateBrandSearchLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandSearchLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandSearchLinkMutation, { data, loading, error }] = useCreateBrandSearchLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandSearchLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateBrandSearchLinkMutation, Generated.CreateBrandSearchLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateBrandSearchLinkMutation, Generated.CreateBrandSearchLinkMutationVariables>(CreateBrandSearchLinkDocument, options);
      }
export type CreateBrandSearchLinkMutationHookResult = ReturnType<typeof useCreateBrandSearchLinkMutation>;
export type CreateBrandSearchLinkMutationResult = Apollo.MutationResult<Generated.CreateBrandSearchLinkMutation>;
export type CreateBrandSearchLinkMutationOptions = Apollo.BaseMutationOptions<Generated.CreateBrandSearchLinkMutation, Generated.CreateBrandSearchLinkMutationVariables>;
export const UpdateBrandSearchLinkDocument = /*#__PURE__*/ gql`
    mutation UpdateBrandSearchLink($input: UpdateBrandSearchLinkInput!) {
  updateBrandSearchLink(input: $input) {
    ...BrandSearchLinkRow
  }
}
    ${BrandSearchLinkRowFragmentDoc}`;
export type UpdateBrandSearchLinkMutationFn = Apollo.MutationFunction<Generated.UpdateBrandSearchLinkMutation, Generated.UpdateBrandSearchLinkMutationVariables>;

/**
 * __useUpdateBrandSearchLinkMutation__
 *
 * To run a mutation, you first call `useUpdateBrandSearchLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandSearchLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandSearchLinkMutation, { data, loading, error }] = useUpdateBrandSearchLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandSearchLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateBrandSearchLinkMutation, Generated.UpdateBrandSearchLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateBrandSearchLinkMutation, Generated.UpdateBrandSearchLinkMutationVariables>(UpdateBrandSearchLinkDocument, options);
      }
export type UpdateBrandSearchLinkMutationHookResult = ReturnType<typeof useUpdateBrandSearchLinkMutation>;
export type UpdateBrandSearchLinkMutationResult = Apollo.MutationResult<Generated.UpdateBrandSearchLinkMutation>;
export type UpdateBrandSearchLinkMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateBrandSearchLinkMutation, Generated.UpdateBrandSearchLinkMutationVariables>;
export const AddSlideDocument = /*#__PURE__*/ gql`
    mutation addSlide($input: AddSlideInput!) {
  addSlide(input: $input) {
    carousel {
      id
      ...CarouselSlides
    }
  }
}
    ${CarouselSlidesFragmentDoc}`;
export type AddSlideMutationFn = Apollo.MutationFunction<Generated.AddSlideMutation, Generated.AddSlideMutationVariables>;

/**
 * __useAddSlideMutation__
 *
 * To run a mutation, you first call `useAddSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSlideMutation, { data, loading, error }] = useAddSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddSlideMutation, Generated.AddSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddSlideMutation, Generated.AddSlideMutationVariables>(AddSlideDocument, options);
      }
export type AddSlideMutationHookResult = ReturnType<typeof useAddSlideMutation>;
export type AddSlideMutationResult = Apollo.MutationResult<Generated.AddSlideMutation>;
export type AddSlideMutationOptions = Apollo.BaseMutationOptions<Generated.AddSlideMutation, Generated.AddSlideMutationVariables>;
export const CreateCarouselDocument = /*#__PURE__*/ gql`
    mutation createCarousel($input: CreateCarouselInput!) {
  createCarousel(input: $input) {
    ref
    id
  }
}
    `;
export type CreateCarouselMutationFn = Apollo.MutationFunction<Generated.CreateCarouselMutation, Generated.CreateCarouselMutationVariables>;

/**
 * __useCreateCarouselMutation__
 *
 * To run a mutation, you first call `useCreateCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarouselMutation, { data, loading, error }] = useCreateCarouselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarouselMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateCarouselMutation, Generated.CreateCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateCarouselMutation, Generated.CreateCarouselMutationVariables>(CreateCarouselDocument, options);
      }
export type CreateCarouselMutationHookResult = ReturnType<typeof useCreateCarouselMutation>;
export type CreateCarouselMutationResult = Apollo.MutationResult<Generated.CreateCarouselMutation>;
export type CreateCarouselMutationOptions = Apollo.BaseMutationOptions<Generated.CreateCarouselMutation, Generated.CreateCarouselMutationVariables>;
export const CreateSlideDocument = /*#__PURE__*/ gql`
    mutation createSlide($input: CreateSlideInput!) {
  createSlide(input: $input) {
    id
    ref
  }
}
    `;
export type CreateSlideMutationFn = Apollo.MutationFunction<Generated.CreateSlideMutation, Generated.CreateSlideMutationVariables>;

/**
 * __useCreateSlideMutation__
 *
 * To run a mutation, you first call `useCreateSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlideMutation, { data, loading, error }] = useCreateSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSlideMutation, Generated.CreateSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSlideMutation, Generated.CreateSlideMutationVariables>(CreateSlideDocument, options);
      }
export type CreateSlideMutationHookResult = ReturnType<typeof useCreateSlideMutation>;
export type CreateSlideMutationResult = Apollo.MutationResult<Generated.CreateSlideMutation>;
export type CreateSlideMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSlideMutation, Generated.CreateSlideMutationVariables>;
export const DeleteCarouselDocument = /*#__PURE__*/ gql`
    mutation deleteCarousel($input: DeleteCarouselInput!) {
  deleteCarousel(input: $input) {
    id
  }
}
    `;
export type DeleteCarouselMutationFn = Apollo.MutationFunction<Generated.DeleteCarouselMutation, Generated.DeleteCarouselMutationVariables>;

/**
 * __useDeleteCarouselMutation__
 *
 * To run a mutation, you first call `useDeleteCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarouselMutation, { data, loading, error }] = useDeleteCarouselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCarouselMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteCarouselMutation, Generated.DeleteCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteCarouselMutation, Generated.DeleteCarouselMutationVariables>(DeleteCarouselDocument, options);
      }
export type DeleteCarouselMutationHookResult = ReturnType<typeof useDeleteCarouselMutation>;
export type DeleteCarouselMutationResult = Apollo.MutationResult<Generated.DeleteCarouselMutation>;
export type DeleteCarouselMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteCarouselMutation, Generated.DeleteCarouselMutationVariables>;
export const DuplicateCarouselDocument = /*#__PURE__*/ gql`
    mutation duplicateCarousel($input: DuplicateCarouselInput!) {
  duplicateCarousel(input: $input) {
    id
    ref
  }
}
    `;
export type DuplicateCarouselMutationFn = Apollo.MutationFunction<Generated.DuplicateCarouselMutation, Generated.DuplicateCarouselMutationVariables>;

/**
 * __useDuplicateCarouselMutation__
 *
 * To run a mutation, you first call `useDuplicateCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCarouselMutation, { data, loading, error }] = useDuplicateCarouselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateCarouselMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DuplicateCarouselMutation, Generated.DuplicateCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DuplicateCarouselMutation, Generated.DuplicateCarouselMutationVariables>(DuplicateCarouselDocument, options);
      }
export type DuplicateCarouselMutationHookResult = ReturnType<typeof useDuplicateCarouselMutation>;
export type DuplicateCarouselMutationResult = Apollo.MutationResult<Generated.DuplicateCarouselMutation>;
export type DuplicateCarouselMutationOptions = Apollo.BaseMutationOptions<Generated.DuplicateCarouselMutation, Generated.DuplicateCarouselMutationVariables>;
export const GetCarouselListDocument = /*#__PURE__*/ gql`
    query getCarouselList($limit: Int, $offset: Int, $brandId: ID, $target: Tag3D) {
  carousels(limit: $limit, offset: $offset, brandId: $brandId, target: $target) {
    totalCount
    nodes {
      ...CarouselRow
    }
  }
}
    ${CarouselRowFragmentDoc}`;

/**
 * __useGetCarouselListQuery__
 *
 * To run a query within a React component, call `useGetCarouselListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarouselListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarouselListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useGetCarouselListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetCarouselListQuery, Generated.GetCarouselListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCarouselListQuery, Generated.GetCarouselListQueryVariables>(GetCarouselListDocument, options);
      }
export function useGetCarouselListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCarouselListQuery, Generated.GetCarouselListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCarouselListQuery, Generated.GetCarouselListQueryVariables>(GetCarouselListDocument, options);
        }
export function useGetCarouselListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCarouselListQuery, Generated.GetCarouselListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCarouselListQuery, Generated.GetCarouselListQueryVariables>(GetCarouselListDocument, options);
        }
export type GetCarouselListQueryHookResult = ReturnType<typeof useGetCarouselListQuery>;
export type GetCarouselListLazyQueryHookResult = ReturnType<typeof useGetCarouselListLazyQuery>;
export type GetCarouselListSuspenseQueryHookResult = ReturnType<typeof useGetCarouselListSuspenseQuery>;
export type GetCarouselListQueryResult = Apollo.QueryResult<Generated.GetCarouselListQuery, Generated.GetCarouselListQueryVariables>;
export const GetCarouselDocument = /*#__PURE__*/ gql`
    query getCarousel($ref: ID!) {
  carouselByRef(ref: $ref) {
    id
    ...CarouselIdentity
    ...CarouselSlides
    ...CarouselMetadata
  }
}
    ${CarouselIdentityFragmentDoc}
${CarouselSlidesFragmentDoc}
${CarouselMetadataFragmentDoc}`;

/**
 * __useGetCarouselQuery__
 *
 * To run a query within a React component, call `useGetCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarouselQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCarouselQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCarouselQuery, Generated.GetCarouselQueryVariables> & ({ variables: Generated.GetCarouselQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCarouselQuery, Generated.GetCarouselQueryVariables>(GetCarouselDocument, options);
      }
export function useGetCarouselLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCarouselQuery, Generated.GetCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCarouselQuery, Generated.GetCarouselQueryVariables>(GetCarouselDocument, options);
        }
export function useGetCarouselSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCarouselQuery, Generated.GetCarouselQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCarouselQuery, Generated.GetCarouselQueryVariables>(GetCarouselDocument, options);
        }
export type GetCarouselQueryHookResult = ReturnType<typeof useGetCarouselQuery>;
export type GetCarouselLazyQueryHookResult = ReturnType<typeof useGetCarouselLazyQuery>;
export type GetCarouselSuspenseQueryHookResult = ReturnType<typeof useGetCarouselSuspenseQuery>;
export type GetCarouselQueryResult = Apollo.QueryResult<Generated.GetCarouselQuery, Generated.GetCarouselQueryVariables>;
export const GetSlideListDocument = /*#__PURE__*/ gql`
    query getSlideList($limit: Int, $offset: Int, $brandId: ID, $search: String, $createdByUserId: ID, $updatedByUserId: ID, $orderBy: SlideOrder!) {
  slides(
    limit: $limit
    offset: $offset
    brandId: $brandId
    search: $search
    updatedByUserId: $updatedByUserId
    createdByUserId: $createdByUserId
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...SlideRow
    }
  }
}
    ${SlideRowFragmentDoc}`;

/**
 * __useGetSlideListQuery__
 *
 * To run a query within a React component, call `useGetSlideListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      search: // value for 'search'
 *      createdByUserId: // value for 'createdByUserId'
 *      updatedByUserId: // value for 'updatedByUserId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSlideListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSlideListQuery, Generated.GetSlideListQueryVariables> & ({ variables: Generated.GetSlideListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSlideListQuery, Generated.GetSlideListQueryVariables>(GetSlideListDocument, options);
      }
export function useGetSlideListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSlideListQuery, Generated.GetSlideListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSlideListQuery, Generated.GetSlideListQueryVariables>(GetSlideListDocument, options);
        }
export function useGetSlideListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSlideListQuery, Generated.GetSlideListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSlideListQuery, Generated.GetSlideListQueryVariables>(GetSlideListDocument, options);
        }
export type GetSlideListQueryHookResult = ReturnType<typeof useGetSlideListQuery>;
export type GetSlideListLazyQueryHookResult = ReturnType<typeof useGetSlideListLazyQuery>;
export type GetSlideListSuspenseQueryHookResult = ReturnType<typeof useGetSlideListSuspenseQuery>;
export type GetSlideListQueryResult = Apollo.QueryResult<Generated.GetSlideListQuery, Generated.GetSlideListQueryVariables>;
export const GetSlideDocument = /*#__PURE__*/ gql`
    query getSlide($ref: ID!) {
  entityByRef(type: SLIDE, ref: $ref) {
    ... on Slide {
      id
      ...SlideIdentity
      ...SlidePlanning
      ...SlideMetadata
    }
  }
}
    ${SlideIdentityFragmentDoc}
${SlidePlanningFragmentDoc}
${SlideMetadataFragmentDoc}`;

/**
 * __useGetSlideQuery__
 *
 * To run a query within a React component, call `useGetSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSlideQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSlideQuery, Generated.GetSlideQueryVariables> & ({ variables: Generated.GetSlideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSlideQuery, Generated.GetSlideQueryVariables>(GetSlideDocument, options);
      }
export function useGetSlideLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSlideQuery, Generated.GetSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSlideQuery, Generated.GetSlideQueryVariables>(GetSlideDocument, options);
        }
export function useGetSlideSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSlideQuery, Generated.GetSlideQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSlideQuery, Generated.GetSlideQueryVariables>(GetSlideDocument, options);
        }
export type GetSlideQueryHookResult = ReturnType<typeof useGetSlideQuery>;
export type GetSlideLazyQueryHookResult = ReturnType<typeof useGetSlideLazyQuery>;
export type GetSlideSuspenseQueryHookResult = ReturnType<typeof useGetSlideSuspenseQuery>;
export type GetSlideQueryResult = Apollo.QueryResult<Generated.GetSlideQuery, Generated.GetSlideQueryVariables>;
export const MoveSlideDocument = /*#__PURE__*/ gql`
    mutation moveSlide($input: MoveSlideInput!) {
  moveSlide(input: $input) {
    carousel {
      id
      ...CarouselSlides
    }
  }
}
    ${CarouselSlidesFragmentDoc}`;
export type MoveSlideMutationFn = Apollo.MutationFunction<Generated.MoveSlideMutation, Generated.MoveSlideMutationVariables>;

/**
 * __useMoveSlideMutation__
 *
 * To run a mutation, you first call `useMoveSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveSlideMutation, { data, loading, error }] = useMoveSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveSlideMutation, Generated.MoveSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveSlideMutation, Generated.MoveSlideMutationVariables>(MoveSlideDocument, options);
      }
export type MoveSlideMutationHookResult = ReturnType<typeof useMoveSlideMutation>;
export type MoveSlideMutationResult = Apollo.MutationResult<Generated.MoveSlideMutation>;
export type MoveSlideMutationOptions = Apollo.BaseMutationOptions<Generated.MoveSlideMutation, Generated.MoveSlideMutationVariables>;
export const RemoveSlideDocument = /*#__PURE__*/ gql`
    mutation removeSlide($input: RemoveSlideInput!) {
  removeSlide(input: $input) {
    carousel {
      id
      ...CarouselSlides
    }
  }
}
    ${CarouselSlidesFragmentDoc}`;
export type RemoveSlideMutationFn = Apollo.MutationFunction<Generated.RemoveSlideMutation, Generated.RemoveSlideMutationVariables>;

/**
 * __useRemoveSlideMutation__
 *
 * To run a mutation, you first call `useRemoveSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSlideMutation, { data, loading, error }] = useRemoveSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.RemoveSlideMutation, Generated.RemoveSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.RemoveSlideMutation, Generated.RemoveSlideMutationVariables>(RemoveSlideDocument, options);
      }
export type RemoveSlideMutationHookResult = ReturnType<typeof useRemoveSlideMutation>;
export type RemoveSlideMutationResult = Apollo.MutationResult<Generated.RemoveSlideMutation>;
export type RemoveSlideMutationOptions = Apollo.BaseMutationOptions<Generated.RemoveSlideMutation, Generated.RemoveSlideMutationVariables>;
export const UpdateSlideDocument = /*#__PURE__*/ gql`
    mutation updateSlide($input: UpdateSlideInput!) {
  updateSlide(input: $input) {
    id
    ...SlideIdentity
  }
}
    ${SlideIdentityFragmentDoc}`;
export type UpdateSlideMutationFn = Apollo.MutationFunction<Generated.UpdateSlideMutation, Generated.UpdateSlideMutationVariables>;

/**
 * __useUpdateSlideMutation__
 *
 * To run a mutation, you first call `useUpdateSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlideMutation, { data, loading, error }] = useUpdateSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSlideMutation, Generated.UpdateSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSlideMutation, Generated.UpdateSlideMutationVariables>(UpdateSlideDocument, options);
      }
export type UpdateSlideMutationHookResult = ReturnType<typeof useUpdateSlideMutation>;
export type UpdateSlideMutationResult = Apollo.MutationResult<Generated.UpdateSlideMutation>;
export type UpdateSlideMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSlideMutation, Generated.UpdateSlideMutationVariables>;
export const UpdateCarouselDocument = /*#__PURE__*/ gql`
    mutation updateCarousel($input: UpdateCarouselInput!) {
  updateCarousel(input: $input) {
    id
    ...CarouselIdentity
  }
}
    ${CarouselIdentityFragmentDoc}`;
export type UpdateCarouselMutationFn = Apollo.MutationFunction<Generated.UpdateCarouselMutation, Generated.UpdateCarouselMutationVariables>;

/**
 * __useUpdateCarouselMutation__
 *
 * To run a mutation, you first call `useUpdateCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarouselMutation, { data, loading, error }] = useUpdateCarouselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarouselMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCarouselMutation, Generated.UpdateCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCarouselMutation, Generated.UpdateCarouselMutationVariables>(UpdateCarouselDocument, options);
      }
export type UpdateCarouselMutationHookResult = ReturnType<typeof useUpdateCarouselMutation>;
export type UpdateCarouselMutationResult = Apollo.MutationResult<Generated.UpdateCarouselMutation>;
export type UpdateCarouselMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCarouselMutation, Generated.UpdateCarouselMutationVariables>;
export const CreateCertificateDocument = /*#__PURE__*/ gql`
    mutation createCertificate($input: CreateCertificateInput!) {
  createCertificate(input: $input) {
    ...CertificateIdentity
  }
}
    ${CertificateIdentityFragmentDoc}`;
export type CreateCertificateMutationFn = Apollo.MutationFunction<Generated.CreateCertificateMutation, Generated.CreateCertificateMutationVariables>;

/**
 * __useCreateCertificateMutation__
 *
 * To run a mutation, you first call `useCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificateMutation, { data, loading, error }] = useCreateCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateCertificateMutation, Generated.CreateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateCertificateMutation, Generated.CreateCertificateMutationVariables>(CreateCertificateDocument, options);
      }
export type CreateCertificateMutationHookResult = ReturnType<typeof useCreateCertificateMutation>;
export type CreateCertificateMutationResult = Apollo.MutationResult<Generated.CreateCertificateMutation>;
export type CreateCertificateMutationOptions = Apollo.BaseMutationOptions<Generated.CreateCertificateMutation, Generated.CreateCertificateMutationVariables>;
export const DeleteCertificateDocument = /*#__PURE__*/ gql`
    mutation DeleteCertificate($input: DeleteCertificateInput!) {
  deleteCertificate(input: $input) {
    ...CertificateIdentity
  }
}
    ${CertificateIdentityFragmentDoc}`;
export type DeleteCertificateMutationFn = Apollo.MutationFunction<Generated.DeleteCertificateMutation, Generated.DeleteCertificateMutationVariables>;

/**
 * __useDeleteCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificateMutation, { data, loading, error }] = useDeleteCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteCertificateMutation, Generated.DeleteCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteCertificateMutation, Generated.DeleteCertificateMutationVariables>(DeleteCertificateDocument, options);
      }
export type DeleteCertificateMutationHookResult = ReturnType<typeof useDeleteCertificateMutation>;
export type DeleteCertificateMutationResult = Apollo.MutationResult<Generated.DeleteCertificateMutation>;
export type DeleteCertificateMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteCertificateMutation, Generated.DeleteCertificateMutationVariables>;
export const UpdateCertificateDocument = /*#__PURE__*/ gql`
    mutation updateCertificate($input: UpdateCertificateInput!) {
  updateCertificate(input: $input) {
    ...CertificateIdentity
  }
}
    ${CertificateIdentityFragmentDoc}`;
export type UpdateCertificateMutationFn = Apollo.MutationFunction<Generated.UpdateCertificateMutation, Generated.UpdateCertificateMutationVariables>;

/**
 * __useUpdateCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificateMutation, { data, loading, error }] = useUpdateCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCertificateMutation, Generated.UpdateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCertificateMutation, Generated.UpdateCertificateMutationVariables>(UpdateCertificateDocument, options);
      }
export type UpdateCertificateMutationHookResult = ReturnType<typeof useUpdateCertificateMutation>;
export type UpdateCertificateMutationResult = Apollo.MutationResult<Generated.UpdateCertificateMutation>;
export type UpdateCertificateMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCertificateMutation, Generated.UpdateCertificateMutationVariables>;
export const GetCertificatesListDocument = /*#__PURE__*/ gql`
    query getCertificatesList($countryId: ID, $search: String, $limitedLocalizationId: ID, $limit: Int, $offset: Int) {
  certificates(
    countryId: $countryId
    search: $search
    limitedLocalizationId: $limitedLocalizationId
    limit: $limit
    offset: $offset
  ) {
    totalCount
    nodes {
      ...CertificateIdentity
    }
  }
}
    ${CertificateIdentityFragmentDoc}`;

/**
 * __useGetCertificatesListQuery__
 *
 * To run a query within a React component, call `useGetCertificatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificatesListQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      search: // value for 'search'
 *      limitedLocalizationId: // value for 'limitedLocalizationId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCertificatesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetCertificatesListQuery, Generated.GetCertificatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCertificatesListQuery, Generated.GetCertificatesListQueryVariables>(GetCertificatesListDocument, options);
      }
export function useGetCertificatesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCertificatesListQuery, Generated.GetCertificatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCertificatesListQuery, Generated.GetCertificatesListQueryVariables>(GetCertificatesListDocument, options);
        }
export function useGetCertificatesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCertificatesListQuery, Generated.GetCertificatesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCertificatesListQuery, Generated.GetCertificatesListQueryVariables>(GetCertificatesListDocument, options);
        }
export type GetCertificatesListQueryHookResult = ReturnType<typeof useGetCertificatesListQuery>;
export type GetCertificatesListLazyQueryHookResult = ReturnType<typeof useGetCertificatesListLazyQuery>;
export type GetCertificatesListSuspenseQueryHookResult = ReturnType<typeof useGetCertificatesListSuspenseQuery>;
export type GetCertificatesListQueryResult = Apollo.QueryResult<Generated.GetCertificatesListQuery, Generated.GetCertificatesListQueryVariables>;
export const GetCertificateDocument = /*#__PURE__*/ gql`
    query getCertificate($ref: ID!) {
  entityByRef(type: CERTIFICATE, ref: $ref) {
    __typename
    ... on Certificate {
      ...CertificateIdentity
    }
  }
}
    ${CertificateIdentityFragmentDoc}`;

/**
 * __useGetCertificateQuery__
 *
 * To run a query within a React component, call `useGetCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCertificateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCertificateQuery, Generated.GetCertificateQueryVariables> & ({ variables: Generated.GetCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCertificateQuery, Generated.GetCertificateQueryVariables>(GetCertificateDocument, options);
      }
export function useGetCertificateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCertificateQuery, Generated.GetCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCertificateQuery, Generated.GetCertificateQueryVariables>(GetCertificateDocument, options);
        }
export function useGetCertificateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCertificateQuery, Generated.GetCertificateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCertificateQuery, Generated.GetCertificateQueryVariables>(GetCertificateDocument, options);
        }
export type GetCertificateQueryHookResult = ReturnType<typeof useGetCertificateQuery>;
export type GetCertificateLazyQueryHookResult = ReturnType<typeof useGetCertificateLazyQuery>;
export type GetCertificateSuspenseQueryHookResult = ReturnType<typeof useGetCertificateSuspenseQuery>;
export type GetCertificateQueryResult = Apollo.QueryResult<Generated.GetCertificateQuery, Generated.GetCertificateQueryVariables>;
export const CreateClocksDocument = /*#__PURE__*/ gql`
    mutation createClocks($input: CreateClocksInput!) {
  createClocks(input: $input) {
    id
    ref
  }
}
    `;
export type CreateClocksMutationFn = Apollo.MutationFunction<Generated.CreateClocksMutation, Generated.CreateClocksMutationVariables>;

/**
 * __useCreateClocksMutation__
 *
 * To run a mutation, you first call `useCreateClocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClocksMutation, { data, loading, error }] = useCreateClocksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClocksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateClocksMutation, Generated.CreateClocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateClocksMutation, Generated.CreateClocksMutationVariables>(CreateClocksDocument, options);
      }
export type CreateClocksMutationHookResult = ReturnType<typeof useCreateClocksMutation>;
export type CreateClocksMutationResult = Apollo.MutationResult<Generated.CreateClocksMutation>;
export type CreateClocksMutationOptions = Apollo.BaseMutationOptions<Generated.CreateClocksMutation, Generated.CreateClocksMutationVariables>;
export const DeleteClockDocument = /*#__PURE__*/ gql`
    mutation deleteClock($input: DeleteClockInput!) {
  deleteClock(input: $input) {
    id
  }
}
    `;
export type DeleteClockMutationFn = Apollo.MutationFunction<Generated.DeleteClockMutation, Generated.DeleteClockMutationVariables>;

/**
 * __useDeleteClockMutation__
 *
 * To run a mutation, you first call `useDeleteClockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClockMutation, { data, loading, error }] = useDeleteClockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClockMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteClockMutation, Generated.DeleteClockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteClockMutation, Generated.DeleteClockMutationVariables>(DeleteClockDocument, options);
      }
export type DeleteClockMutationHookResult = ReturnType<typeof useDeleteClockMutation>;
export type DeleteClockMutationResult = Apollo.MutationResult<Generated.DeleteClockMutation>;
export type DeleteClockMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteClockMutation, Generated.DeleteClockMutationVariables>;
export const GetClockTheaterDocument = /*#__PURE__*/ gql`
    query getClockTheater($id: ID!) {
  theater(id: $id) {
    __typename
    id
    ...ClockTheater
  }
}
    ${ClockTheaterFragmentDoc}`;

/**
 * __useGetClockTheaterQuery__
 *
 * To run a query within a React component, call `useGetClockTheaterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClockTheaterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClockTheaterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClockTheaterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetClockTheaterQuery, Generated.GetClockTheaterQueryVariables> & ({ variables: Generated.GetClockTheaterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetClockTheaterQuery, Generated.GetClockTheaterQueryVariables>(GetClockTheaterDocument, options);
      }
export function useGetClockTheaterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetClockTheaterQuery, Generated.GetClockTheaterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetClockTheaterQuery, Generated.GetClockTheaterQueryVariables>(GetClockTheaterDocument, options);
        }
export function useGetClockTheaterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetClockTheaterQuery, Generated.GetClockTheaterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetClockTheaterQuery, Generated.GetClockTheaterQueryVariables>(GetClockTheaterDocument, options);
        }
export type GetClockTheaterQueryHookResult = ReturnType<typeof useGetClockTheaterQuery>;
export type GetClockTheaterLazyQueryHookResult = ReturnType<typeof useGetClockTheaterLazyQuery>;
export type GetClockTheaterSuspenseQueryHookResult = ReturnType<typeof useGetClockTheaterSuspenseQuery>;
export type GetClockTheaterQueryResult = Apollo.QueryResult<Generated.GetClockTheaterQuery, Generated.GetClockTheaterQueryVariables>;
export const GetClockListDocument = /*#__PURE__*/ gql`
    query getClockList($limit: Int, $offset: Int, $theaterId: ID, $entityId: ID, $date: Date, $fromDate: Date, $orderBy: ClockOrder!) {
  clocks(
    limit: $limit
    offset: $offset
    theaterId: $theaterId
    entityId: $entityId
    date: $date
    fromDate: $fromDate
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...ClockRow
    }
  }
}
    ${ClockRowFragmentDoc}`;

/**
 * __useGetClockListQuery__
 *
 * To run a query within a React component, call `useGetClockListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClockListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClockListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      theaterId: // value for 'theaterId'
 *      entityId: // value for 'entityId'
 *      date: // value for 'date'
 *      fromDate: // value for 'fromDate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetClockListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetClockListQuery, Generated.GetClockListQueryVariables> & ({ variables: Generated.GetClockListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetClockListQuery, Generated.GetClockListQueryVariables>(GetClockListDocument, options);
      }
export function useGetClockListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetClockListQuery, Generated.GetClockListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetClockListQuery, Generated.GetClockListQueryVariables>(GetClockListDocument, options);
        }
export function useGetClockListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetClockListQuery, Generated.GetClockListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetClockListQuery, Generated.GetClockListQueryVariables>(GetClockListDocument, options);
        }
export type GetClockListQueryHookResult = ReturnType<typeof useGetClockListQuery>;
export type GetClockListLazyQueryHookResult = ReturnType<typeof useGetClockListLazyQuery>;
export type GetClockListSuspenseQueryHookResult = ReturnType<typeof useGetClockListSuspenseQuery>;
export type GetClockListQueryResult = Apollo.QueryResult<Generated.GetClockListQuery, Generated.GetClockListQueryVariables>;
export const GetClockDocument = /*#__PURE__*/ gql`
    query getClock($ref: ID!) {
  clockByRef(ref: $ref) {
    __typename
    ...ClockIdentity
    ...ClockMetadata
  }
}
    ${ClockIdentityFragmentDoc}
${ClockMetadataFragmentDoc}`;

/**
 * __useGetClockQuery__
 *
 * To run a query within a React component, call `useGetClockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClockQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetClockQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetClockQuery, Generated.GetClockQueryVariables> & ({ variables: Generated.GetClockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetClockQuery, Generated.GetClockQueryVariables>(GetClockDocument, options);
      }
export function useGetClockLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetClockQuery, Generated.GetClockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetClockQuery, Generated.GetClockQueryVariables>(GetClockDocument, options);
        }
export function useGetClockSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetClockQuery, Generated.GetClockQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetClockQuery, Generated.GetClockQueryVariables>(GetClockDocument, options);
        }
export type GetClockQueryHookResult = ReturnType<typeof useGetClockQuery>;
export type GetClockLazyQueryHookResult = ReturnType<typeof useGetClockLazyQuery>;
export type GetClockSuspenseQueryHookResult = ReturnType<typeof useGetClockSuspenseQuery>;
export type GetClockQueryResult = Apollo.QueryResult<Generated.GetClockQuery, Generated.GetClockQueryVariables>;
export const TheaterWouldImportShowtimesDocument = /*#__PURE__*/ gql`
    query theaterWouldImportShowtimes($id: ID!) {
  theater(id: $id) {
    wouldImportShowtimes
  }
}
    `;

/**
 * __useTheaterWouldImportShowtimesQuery__
 *
 * To run a query within a React component, call `useTheaterWouldImportShowtimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTheaterWouldImportShowtimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTheaterWouldImportShowtimesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTheaterWouldImportShowtimesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.TheaterWouldImportShowtimesQuery, Generated.TheaterWouldImportShowtimesQueryVariables> & ({ variables: Generated.TheaterWouldImportShowtimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.TheaterWouldImportShowtimesQuery, Generated.TheaterWouldImportShowtimesQueryVariables>(TheaterWouldImportShowtimesDocument, options);
      }
export function useTheaterWouldImportShowtimesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.TheaterWouldImportShowtimesQuery, Generated.TheaterWouldImportShowtimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.TheaterWouldImportShowtimesQuery, Generated.TheaterWouldImportShowtimesQueryVariables>(TheaterWouldImportShowtimesDocument, options);
        }
export function useTheaterWouldImportShowtimesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.TheaterWouldImportShowtimesQuery, Generated.TheaterWouldImportShowtimesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.TheaterWouldImportShowtimesQuery, Generated.TheaterWouldImportShowtimesQueryVariables>(TheaterWouldImportShowtimesDocument, options);
        }
export type TheaterWouldImportShowtimesQueryHookResult = ReturnType<typeof useTheaterWouldImportShowtimesQuery>;
export type TheaterWouldImportShowtimesLazyQueryHookResult = ReturnType<typeof useTheaterWouldImportShowtimesLazyQuery>;
export type TheaterWouldImportShowtimesSuspenseQueryHookResult = ReturnType<typeof useTheaterWouldImportShowtimesSuspenseQuery>;
export type TheaterWouldImportShowtimesQueryResult = Apollo.QueryResult<Generated.TheaterWouldImportShowtimesQuery, Generated.TheaterWouldImportShowtimesQueryVariables>;
export const GetTheaterOptionDocument = /*#__PURE__*/ gql`
    query getTheaterOption($theaterId: ID!) {
  theaterByCode(code: $theaterId) {
    ...SearchTheater
  }
}
    ${SearchTheaterFragmentDoc}`;

/**
 * __useGetTheaterOptionQuery__
 *
 * To run a query within a React component, call `useGetTheaterOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterOptionQuery({
 *   variables: {
 *      theaterId: // value for 'theaterId'
 *   },
 * });
 */
export function useGetTheaterOptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterOptionQuery, Generated.GetTheaterOptionQueryVariables> & ({ variables: Generated.GetTheaterOptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterOptionQuery, Generated.GetTheaterOptionQueryVariables>(GetTheaterOptionDocument, options);
      }
export function useGetTheaterOptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterOptionQuery, Generated.GetTheaterOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterOptionQuery, Generated.GetTheaterOptionQueryVariables>(GetTheaterOptionDocument, options);
        }
export function useGetTheaterOptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterOptionQuery, Generated.GetTheaterOptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterOptionQuery, Generated.GetTheaterOptionQueryVariables>(GetTheaterOptionDocument, options);
        }
export type GetTheaterOptionQueryHookResult = ReturnType<typeof useGetTheaterOptionQuery>;
export type GetTheaterOptionLazyQueryHookResult = ReturnType<typeof useGetTheaterOptionLazyQuery>;
export type GetTheaterOptionSuspenseQueryHookResult = ReturnType<typeof useGetTheaterOptionSuspenseQuery>;
export type GetTheaterOptionQueryResult = Apollo.QueryResult<Generated.GetTheaterOptionQuery, Generated.GetTheaterOptionQueryVariables>;
export const UpdateClockDocument = /*#__PURE__*/ gql`
    mutation updateClock($input: UpdateClockInput!) {
  updateClock(input: $input) {
    ...ClockIdentity
  }
}
    ${ClockIdentityFragmentDoc}`;
export type UpdateClockMutationFn = Apollo.MutationFunction<Generated.UpdateClockMutation, Generated.UpdateClockMutationVariables>;

/**
 * __useUpdateClockMutation__
 *
 * To run a mutation, you first call `useUpdateClockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClockMutation, { data, loading, error }] = useUpdateClockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClockMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateClockMutation, Generated.UpdateClockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateClockMutation, Generated.UpdateClockMutationVariables>(UpdateClockDocument, options);
      }
export type UpdateClockMutationHookResult = ReturnType<typeof useUpdateClockMutation>;
export type UpdateClockMutationResult = Apollo.MutationResult<Generated.UpdateClockMutation>;
export type UpdateClockMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateClockMutation, Generated.UpdateClockMutationVariables>;
export const CreateCompanyDocument = /*#__PURE__*/ gql`
    mutation createCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
    ref
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<Generated.CreateCompanyMutation, Generated.CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateCompanyMutation, Generated.CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateCompanyMutation, Generated.CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<Generated.CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<Generated.CreateCompanyMutation, Generated.CreateCompanyMutationVariables>;
export const AddImageToCompanyDocument = /*#__PURE__*/ gql`
    mutation addImageToCompany($entityId: ID!, $imageId: ID!) {
  addImageToCompany(input: {entityId: $entityId, imageId: $imageId}) {
    ...ImageReference
  }
}
    ${ImageReferenceFragmentDoc}`;
export type AddImageToCompanyMutationFn = Apollo.MutationFunction<Generated.AddImageToCompanyMutation, Generated.AddImageToCompanyMutationVariables>;

/**
 * __useAddImageToCompanyMutation__
 *
 * To run a mutation, you first call `useAddImageToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddImageToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addImageToCompanyMutation, { data, loading, error }] = useAddImageToCompanyMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useAddImageToCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddImageToCompanyMutation, Generated.AddImageToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddImageToCompanyMutation, Generated.AddImageToCompanyMutationVariables>(AddImageToCompanyDocument, options);
      }
export type AddImageToCompanyMutationHookResult = ReturnType<typeof useAddImageToCompanyMutation>;
export type AddImageToCompanyMutationResult = Apollo.MutationResult<Generated.AddImageToCompanyMutation>;
export type AddImageToCompanyMutationOptions = Apollo.BaseMutationOptions<Generated.AddImageToCompanyMutation, Generated.AddImageToCompanyMutationVariables>;
export const CreateCompanyStaffDocument = /*#__PURE__*/ gql`
    mutation createCompanyStaff($input: CreateCompanyStaffInput!) {
  createCompanyStaff(input: $input) {
    id
    ref
  }
}
    `;
export type CreateCompanyStaffMutationFn = Apollo.MutationFunction<Generated.CreateCompanyStaffMutation, Generated.CreateCompanyStaffMutationVariables>;

/**
 * __useCreateCompanyStaffMutation__
 *
 * To run a mutation, you first call `useCreateCompanyStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyStaffMutation, { data, loading, error }] = useCreateCompanyStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyStaffMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateCompanyStaffMutation, Generated.CreateCompanyStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateCompanyStaffMutation, Generated.CreateCompanyStaffMutationVariables>(CreateCompanyStaffDocument, options);
      }
export type CreateCompanyStaffMutationHookResult = ReturnType<typeof useCreateCompanyStaffMutation>;
export type CreateCompanyStaffMutationResult = Apollo.MutationResult<Generated.CreateCompanyStaffMutation>;
export type CreateCompanyStaffMutationOptions = Apollo.BaseMutationOptions<Generated.CreateCompanyStaffMutation, Generated.CreateCompanyStaffMutationVariables>;
export const DeleteCompanyStaffDocument = /*#__PURE__*/ gql`
    mutation deleteCompanyStaff($input: DeleteCompanyStaffInput!) {
  deleteCompanyStaff(input: $input) {
    id
  }
}
    `;
export type DeleteCompanyStaffMutationFn = Apollo.MutationFunction<Generated.DeleteCompanyStaffMutation, Generated.DeleteCompanyStaffMutationVariables>;

/**
 * __useDeleteCompanyStaffMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyStaffMutation, { data, loading, error }] = useDeleteCompanyStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyStaffMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteCompanyStaffMutation, Generated.DeleteCompanyStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteCompanyStaffMutation, Generated.DeleteCompanyStaffMutationVariables>(DeleteCompanyStaffDocument, options);
      }
export type DeleteCompanyStaffMutationHookResult = ReturnType<typeof useDeleteCompanyStaffMutation>;
export type DeleteCompanyStaffMutationResult = Apollo.MutationResult<Generated.DeleteCompanyStaffMutation>;
export type DeleteCompanyStaffMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteCompanyStaffMutation, Generated.DeleteCompanyStaffMutationVariables>;
export const DeleteImageFromCompanyDocument = /*#__PURE__*/ gql`
    mutation deleteImageFromCompany($companyId: ID!, $imageId: ID!) {
  deleteImageFromCompany(input: {companyId: $companyId, imageId: $imageId}) {
    image {
      id
      url
    }
    rank
  }
}
    `;
export type DeleteImageFromCompanyMutationFn = Apollo.MutationFunction<Generated.DeleteImageFromCompanyMutation, Generated.DeleteImageFromCompanyMutationVariables>;

/**
 * __useDeleteImageFromCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteImageFromCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageFromCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageFromCompanyMutation, { data, loading, error }] = useDeleteImageFromCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useDeleteImageFromCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteImageFromCompanyMutation, Generated.DeleteImageFromCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteImageFromCompanyMutation, Generated.DeleteImageFromCompanyMutationVariables>(DeleteImageFromCompanyDocument, options);
      }
export type DeleteImageFromCompanyMutationHookResult = ReturnType<typeof useDeleteImageFromCompanyMutation>;
export type DeleteImageFromCompanyMutationResult = Apollo.MutationResult<Generated.DeleteImageFromCompanyMutation>;
export type DeleteImageFromCompanyMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteImageFromCompanyMutation, Generated.DeleteImageFromCompanyMutationVariables>;
export const GetActivityMappingDocument = /*#__PURE__*/ gql`
    query getActivityMapping {
  companiesActivitySubactivityMapping {
    ...CompanyActivitySubactivity
  }
}
    ${CompanyActivitySubactivityFragmentDoc}`;

/**
 * __useGetActivityMappingQuery__
 *
 * To run a query within a React component, call `useGetActivityMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityMappingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityMappingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetActivityMappingQuery, Generated.GetActivityMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetActivityMappingQuery, Generated.GetActivityMappingQueryVariables>(GetActivityMappingDocument, options);
      }
export function useGetActivityMappingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetActivityMappingQuery, Generated.GetActivityMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetActivityMappingQuery, Generated.GetActivityMappingQueryVariables>(GetActivityMappingDocument, options);
        }
export function useGetActivityMappingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetActivityMappingQuery, Generated.GetActivityMappingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetActivityMappingQuery, Generated.GetActivityMappingQueryVariables>(GetActivityMappingDocument, options);
        }
export type GetActivityMappingQueryHookResult = ReturnType<typeof useGetActivityMappingQuery>;
export type GetActivityMappingLazyQueryHookResult = ReturnType<typeof useGetActivityMappingLazyQuery>;
export type GetActivityMappingSuspenseQueryHookResult = ReturnType<typeof useGetActivityMappingSuspenseQuery>;
export type GetActivityMappingQueryResult = Apollo.QueryResult<Generated.GetActivityMappingQuery, Generated.GetActivityMappingQueryVariables>;
export const GetCompanyBrandedDataDocument = /*#__PURE__*/ gql`
    query getCompanyBrandedData($id: ID!, $brandId: ID!) {
  company(id: $id) {
    id
    brandData(brandId: $brandId) {
      description
      name
    }
  }
}
    `;

/**
 * __useGetCompanyBrandedDataQuery__
 *
 * To run a query within a React component, call `useGetCompanyBrandedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBrandedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBrandedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetCompanyBrandedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyBrandedDataQuery, Generated.GetCompanyBrandedDataQueryVariables> & ({ variables: Generated.GetCompanyBrandedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyBrandedDataQuery, Generated.GetCompanyBrandedDataQueryVariables>(GetCompanyBrandedDataDocument, options);
      }
export function useGetCompanyBrandedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyBrandedDataQuery, Generated.GetCompanyBrandedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyBrandedDataQuery, Generated.GetCompanyBrandedDataQueryVariables>(GetCompanyBrandedDataDocument, options);
        }
export function useGetCompanyBrandedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyBrandedDataQuery, Generated.GetCompanyBrandedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyBrandedDataQuery, Generated.GetCompanyBrandedDataQueryVariables>(GetCompanyBrandedDataDocument, options);
        }
export type GetCompanyBrandedDataQueryHookResult = ReturnType<typeof useGetCompanyBrandedDataQuery>;
export type GetCompanyBrandedDataLazyQueryHookResult = ReturnType<typeof useGetCompanyBrandedDataLazyQuery>;
export type GetCompanyBrandedDataSuspenseQueryHookResult = ReturnType<typeof useGetCompanyBrandedDataSuspenseQuery>;
export type GetCompanyBrandedDataQueryResult = Apollo.QueryResult<Generated.GetCompanyBrandedDataQuery, Generated.GetCompanyBrandedDataQueryVariables>;
export const GetCompanyIdentityDocument = /*#__PURE__*/ gql`
    query getCompanyIdentity($companyId: ID!) {
  company(id: $companyId) {
    ...EntityAlts
    ...CompanyAddress
    ...CompanyFullIdentity
    ...CompanyLinks
    ...CompanyRelationships
    activitiesTree {
      ...CompanyActivitySubactivity
    }
  }
}
    ${EntityAltsFragmentDoc}
${CompanyAddressFragmentDoc}
${CompanyFullIdentityFragmentDoc}
${CompanyLinksFragmentDoc}
${CompanyRelationshipsFragmentDoc}
${CompanyActivitySubactivityFragmentDoc}`;

/**
 * __useGetCompanyIdentityQuery__
 *
 * To run a query within a React component, call `useGetCompanyIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIdentityQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyIdentityQuery, Generated.GetCompanyIdentityQueryVariables> & ({ variables: Generated.GetCompanyIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyIdentityQuery, Generated.GetCompanyIdentityQueryVariables>(GetCompanyIdentityDocument, options);
      }
export function useGetCompanyIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyIdentityQuery, Generated.GetCompanyIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyIdentityQuery, Generated.GetCompanyIdentityQueryVariables>(GetCompanyIdentityDocument, options);
        }
export function useGetCompanyIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyIdentityQuery, Generated.GetCompanyIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyIdentityQuery, Generated.GetCompanyIdentityQueryVariables>(GetCompanyIdentityDocument, options);
        }
export type GetCompanyIdentityQueryHookResult = ReturnType<typeof useGetCompanyIdentityQuery>;
export type GetCompanyIdentityLazyQueryHookResult = ReturnType<typeof useGetCompanyIdentityLazyQuery>;
export type GetCompanyIdentitySuspenseQueryHookResult = ReturnType<typeof useGetCompanyIdentitySuspenseQuery>;
export type GetCompanyIdentityQueryResult = Apollo.QueryResult<Generated.GetCompanyIdentityQuery, Generated.GetCompanyIdentityQueryVariables>;
export const GetCompanyStaffIdentityDocument = /*#__PURE__*/ gql`
    query getCompanyStaffIdentity($ref: ID!) {
  entityByRef(ref: $ref, type: COMPANY_STAFF) {
    __typename
    ... on CompanyStaff {
      ...CompanyStaffIdentity
    }
  }
}
    ${CompanyStaffIdentityFragmentDoc}`;

/**
 * __useGetCompanyStaffIdentityQuery__
 *
 * To run a query within a React component, call `useGetCompanyStaffIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyStaffIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyStaffIdentityQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCompanyStaffIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyStaffIdentityQuery, Generated.GetCompanyStaffIdentityQueryVariables> & ({ variables: Generated.GetCompanyStaffIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyStaffIdentityQuery, Generated.GetCompanyStaffIdentityQueryVariables>(GetCompanyStaffIdentityDocument, options);
      }
export function useGetCompanyStaffIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyStaffIdentityQuery, Generated.GetCompanyStaffIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyStaffIdentityQuery, Generated.GetCompanyStaffIdentityQueryVariables>(GetCompanyStaffIdentityDocument, options);
        }
export function useGetCompanyStaffIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyStaffIdentityQuery, Generated.GetCompanyStaffIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyStaffIdentityQuery, Generated.GetCompanyStaffIdentityQueryVariables>(GetCompanyStaffIdentityDocument, options);
        }
export type GetCompanyStaffIdentityQueryHookResult = ReturnType<typeof useGetCompanyStaffIdentityQuery>;
export type GetCompanyStaffIdentityLazyQueryHookResult = ReturnType<typeof useGetCompanyStaffIdentityLazyQuery>;
export type GetCompanyStaffIdentitySuspenseQueryHookResult = ReturnType<typeof useGetCompanyStaffIdentitySuspenseQuery>;
export type GetCompanyStaffIdentityQueryResult = Apollo.QueryResult<Generated.GetCompanyStaffIdentityQuery, Generated.GetCompanyStaffIdentityQueryVariables>;
export const GetCompanyImagesDocument = /*#__PURE__*/ gql`
    query getCompanyImages($id: ID!, $limit: Int, $offset: Int!) {
  company(id: $id) {
    id
    images(limit: $limit, offset: $offset) {
      totalCount
      nodes {
        ...ImageReference
      }
    }
  }
}
    ${ImageReferenceFragmentDoc}`;

/**
 * __useGetCompanyImagesQuery__
 *
 * To run a query within a React component, call `useGetCompanyImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyImagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCompanyImagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyImagesQuery, Generated.GetCompanyImagesQueryVariables> & ({ variables: Generated.GetCompanyImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyImagesQuery, Generated.GetCompanyImagesQueryVariables>(GetCompanyImagesDocument, options);
      }
export function useGetCompanyImagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyImagesQuery, Generated.GetCompanyImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyImagesQuery, Generated.GetCompanyImagesQueryVariables>(GetCompanyImagesDocument, options);
        }
export function useGetCompanyImagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyImagesQuery, Generated.GetCompanyImagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyImagesQuery, Generated.GetCompanyImagesQueryVariables>(GetCompanyImagesDocument, options);
        }
export type GetCompanyImagesQueryHookResult = ReturnType<typeof useGetCompanyImagesQuery>;
export type GetCompanyImagesLazyQueryHookResult = ReturnType<typeof useGetCompanyImagesLazyQuery>;
export type GetCompanyImagesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyImagesSuspenseQuery>;
export type GetCompanyImagesQueryResult = Apollo.QueryResult<Generated.GetCompanyImagesQuery, Generated.GetCompanyImagesQueryVariables>;
export const GetCompanyListDocument = /*#__PURE__*/ gql`
    query getCompanyList($limit: Int, $offset: Int!, $search: String!, $activities: [CompanyActivity!]!, $additionalTags: [CompanyAdditionalTag!]!, $countryIds: [ID!]!, $orderBy: CompanyOrder!) {
  companies(
    limit: $limit
    offset: $offset
    search: $search
    activities: $activities
    additionalTags: $additionalTags
    countryIds: $countryIds
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ref
      id
      name
      activities
      country {
        ...CountryOption
      }
      parent {
        ...CompanyOption
      }
      metadata {
        createdAt
      }
    }
  }
}
    ${CountryOptionFragmentDoc}
${CompanyOptionFragmentDoc}`;

/**
 * __useGetCompanyListQuery__
 *
 * To run a query within a React component, call `useGetCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      activities: // value for 'activities'
 *      additionalTags: // value for 'additionalTags'
 *      countryIds: // value for 'countryIds'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetCompanyListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyListQuery, Generated.GetCompanyListQueryVariables> & ({ variables: Generated.GetCompanyListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyListQuery, Generated.GetCompanyListQueryVariables>(GetCompanyListDocument, options);
      }
export function useGetCompanyListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyListQuery, Generated.GetCompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyListQuery, Generated.GetCompanyListQueryVariables>(GetCompanyListDocument, options);
        }
export function useGetCompanyListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyListQuery, Generated.GetCompanyListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyListQuery, Generated.GetCompanyListQueryVariables>(GetCompanyListDocument, options);
        }
export type GetCompanyListQueryHookResult = ReturnType<typeof useGetCompanyListQuery>;
export type GetCompanyListLazyQueryHookResult = ReturnType<typeof useGetCompanyListLazyQuery>;
export type GetCompanyListSuspenseQueryHookResult = ReturnType<typeof useGetCompanyListSuspenseQuery>;
export type GetCompanyListQueryResult = Apollo.QueryResult<Generated.GetCompanyListQuery, Generated.GetCompanyListQueryVariables>;
export const GetCompanyTheatersDocument = /*#__PURE__*/ gql`
    query getCompanyTheaters($limit: Int, $offset: Int!, $companyIds: [ID!], $search: String) {
  theaters(
    limit: $limit
    offset: $offset
    companyIds: $companyIds
    search: $search
  ) {
    totalCount
    nodes {
      id
      ...CompanyTheater
    }
  }
}
    ${CompanyTheaterFragmentDoc}`;

/**
 * __useGetCompanyTheatersQuery__
 *
 * To run a query within a React component, call `useGetCompanyTheatersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyTheatersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyTheatersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      companyIds: // value for 'companyIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCompanyTheatersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyTheatersQuery, Generated.GetCompanyTheatersQueryVariables> & ({ variables: Generated.GetCompanyTheatersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyTheatersQuery, Generated.GetCompanyTheatersQueryVariables>(GetCompanyTheatersDocument, options);
      }
export function useGetCompanyTheatersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyTheatersQuery, Generated.GetCompanyTheatersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyTheatersQuery, Generated.GetCompanyTheatersQueryVariables>(GetCompanyTheatersDocument, options);
        }
export function useGetCompanyTheatersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyTheatersQuery, Generated.GetCompanyTheatersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyTheatersQuery, Generated.GetCompanyTheatersQueryVariables>(GetCompanyTheatersDocument, options);
        }
export type GetCompanyTheatersQueryHookResult = ReturnType<typeof useGetCompanyTheatersQuery>;
export type GetCompanyTheatersLazyQueryHookResult = ReturnType<typeof useGetCompanyTheatersLazyQuery>;
export type GetCompanyTheatersSuspenseQueryHookResult = ReturnType<typeof useGetCompanyTheatersSuspenseQuery>;
export type GetCompanyTheatersQueryResult = Apollo.QueryResult<Generated.GetCompanyTheatersQuery, Generated.GetCompanyTheatersQueryVariables>;
export const GetCompanyStaffListDocument = /*#__PURE__*/ gql`
    query getCompanyStaffList($companyId: ID!, $orderBy: CompanyStaffOrder, $limit: Int, $offset: Int!) {
  companyStaffList(
    companyId: $companyId
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    nodes {
      __typename
      ...CompanyStaffIdentity
      ...CompanyStaffMetadata
    }
  }
}
    ${CompanyStaffIdentityFragmentDoc}
${CompanyStaffMetadataFragmentDoc}`;

/**
 * __useGetCompanyStaffListQuery__
 *
 * To run a query within a React component, call `useGetCompanyStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyStaffListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCompanyStaffListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyStaffListQuery, Generated.GetCompanyStaffListQueryVariables> & ({ variables: Generated.GetCompanyStaffListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyStaffListQuery, Generated.GetCompanyStaffListQueryVariables>(GetCompanyStaffListDocument, options);
      }
export function useGetCompanyStaffListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyStaffListQuery, Generated.GetCompanyStaffListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyStaffListQuery, Generated.GetCompanyStaffListQueryVariables>(GetCompanyStaffListDocument, options);
        }
export function useGetCompanyStaffListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyStaffListQuery, Generated.GetCompanyStaffListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyStaffListQuery, Generated.GetCompanyStaffListQueryVariables>(GetCompanyStaffListDocument, options);
        }
export type GetCompanyStaffListQueryHookResult = ReturnType<typeof useGetCompanyStaffListQuery>;
export type GetCompanyStaffListLazyQueryHookResult = ReturnType<typeof useGetCompanyStaffListLazyQuery>;
export type GetCompanyStaffListSuspenseQueryHookResult = ReturnType<typeof useGetCompanyStaffListSuspenseQuery>;
export type GetCompanyStaffListQueryResult = Apollo.QueryResult<Generated.GetCompanyStaffListQuery, Generated.GetCompanyStaffListQueryVariables>;
export const GetCompanyDocument = /*#__PURE__*/ gql`
    query getCompany($ref: ID!) {
  entityByRef(type: COMPANY, ref: $ref) {
    ... on Company {
      ...CompanyOption
      activities
      activeOnBrands {
        ref
      }
      ...CompanyMetadata
    }
  }
}
    ${CompanyOptionFragmentDoc}
${CompanyMetadataFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyQuery, Generated.GetCompanyQueryVariables> & ({ variables: Generated.GetCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyQuery, Generated.GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyQuery, Generated.GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyQuery, Generated.GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export function useGetCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyQuery, Generated.GetCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyQuery, Generated.GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<Generated.GetCompanyQuery, Generated.GetCompanyQueryVariables>;
export const GetCompanyLocalizedDataDocument = /*#__PURE__*/ gql`
    query getCompanyLocalizedData($id: ID!, $locale: ID!) {
  company(id: $id) {
    id
    localeData(localeId: $locale) {
      description
      name
    }
  }
}
    `;

/**
 * __useGetCompanyLocalizedDataQuery__
 *
 * To run a query within a React component, call `useGetCompanyLocalizedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLocalizedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLocalizedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCompanyLocalizedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCompanyLocalizedDataQuery, Generated.GetCompanyLocalizedDataQueryVariables> & ({ variables: Generated.GetCompanyLocalizedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCompanyLocalizedDataQuery, Generated.GetCompanyLocalizedDataQueryVariables>(GetCompanyLocalizedDataDocument, options);
      }
export function useGetCompanyLocalizedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCompanyLocalizedDataQuery, Generated.GetCompanyLocalizedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCompanyLocalizedDataQuery, Generated.GetCompanyLocalizedDataQueryVariables>(GetCompanyLocalizedDataDocument, options);
        }
export function useGetCompanyLocalizedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCompanyLocalizedDataQuery, Generated.GetCompanyLocalizedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCompanyLocalizedDataQuery, Generated.GetCompanyLocalizedDataQueryVariables>(GetCompanyLocalizedDataDocument, options);
        }
export type GetCompanyLocalizedDataQueryHookResult = ReturnType<typeof useGetCompanyLocalizedDataQuery>;
export type GetCompanyLocalizedDataLazyQueryHookResult = ReturnType<typeof useGetCompanyLocalizedDataLazyQuery>;
export type GetCompanyLocalizedDataSuspenseQueryHookResult = ReturnType<typeof useGetCompanyLocalizedDataSuspenseQuery>;
export type GetCompanyLocalizedDataQueryResult = Apollo.QueryResult<Generated.GetCompanyLocalizedDataQuery, Generated.GetCompanyLocalizedDataQueryVariables>;
export const UpdateCompanyAddressDocument = /*#__PURE__*/ gql`
    mutation updateCompanyAddress($entityId: ID!, $coordinates: CoordinatesInput!, $location: LocationInput!) {
  updateEntityLocalization(
    input: {entityId: $entityId, coordinates: $coordinates, location: $location}
  ) {
    ... on Company {
      ...CompanyOption
      ...CompanyAddress
      ...CompanyMetadata
    }
  }
}
    ${CompanyOptionFragmentDoc}
${CompanyAddressFragmentDoc}
${CompanyMetadataFragmentDoc}`;
export type UpdateCompanyAddressMutationFn = Apollo.MutationFunction<Generated.UpdateCompanyAddressMutation, Generated.UpdateCompanyAddressMutationVariables>;

/**
 * __useUpdateCompanyAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAddressMutation, { data, loading, error }] = useUpdateCompanyAddressMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      coordinates: // value for 'coordinates'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUpdateCompanyAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCompanyAddressMutation, Generated.UpdateCompanyAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCompanyAddressMutation, Generated.UpdateCompanyAddressMutationVariables>(UpdateCompanyAddressDocument, options);
      }
export type UpdateCompanyAddressMutationHookResult = ReturnType<typeof useUpdateCompanyAddressMutation>;
export type UpdateCompanyAddressMutationResult = Apollo.MutationResult<Generated.UpdateCompanyAddressMutation>;
export type UpdateCompanyAddressMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCompanyAddressMutation, Generated.UpdateCompanyAddressMutationVariables>;
export const MoveCompanyStaffDocument = /*#__PURE__*/ gql`
    mutation MoveCompanyStaff($input: MoveCompanyStaffInput!) {
  moveCompanyStaff(input: $input) {
    id
    rank
  }
}
    `;
export type MoveCompanyStaffMutationFn = Apollo.MutationFunction<Generated.MoveCompanyStaffMutation, Generated.MoveCompanyStaffMutationVariables>;

/**
 * __useMoveCompanyStaffMutation__
 *
 * To run a mutation, you first call `useMoveCompanyStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCompanyStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCompanyStaffMutation, { data, loading, error }] = useMoveCompanyStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveCompanyStaffMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveCompanyStaffMutation, Generated.MoveCompanyStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveCompanyStaffMutation, Generated.MoveCompanyStaffMutationVariables>(MoveCompanyStaffDocument, options);
      }
export type MoveCompanyStaffMutationHookResult = ReturnType<typeof useMoveCompanyStaffMutation>;
export type MoveCompanyStaffMutationResult = Apollo.MutationResult<Generated.MoveCompanyStaffMutation>;
export type MoveCompanyStaffMutationOptions = Apollo.BaseMutationOptions<Generated.MoveCompanyStaffMutation, Generated.MoveCompanyStaffMutationVariables>;
export const UpdateCompanyBrandedDataDocument = /*#__PURE__*/ gql`
    mutation updateCompanyBrandedData($companyId: ID!, $brandId: ID!, $name: String, $description: String) {
  updateCompanyBrandData(
    input: {companyId: $companyId, brandId: $brandId, name: $name, description: $description}
  ) {
    name
    description
  }
}
    `;
export type UpdateCompanyBrandedDataMutationFn = Apollo.MutationFunction<Generated.UpdateCompanyBrandedDataMutation, Generated.UpdateCompanyBrandedDataMutationVariables>;

/**
 * __useUpdateCompanyBrandedDataMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyBrandedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyBrandedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyBrandedDataMutation, { data, loading, error }] = useUpdateCompanyBrandedDataMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      brandId: // value for 'brandId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateCompanyBrandedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCompanyBrandedDataMutation, Generated.UpdateCompanyBrandedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCompanyBrandedDataMutation, Generated.UpdateCompanyBrandedDataMutationVariables>(UpdateCompanyBrandedDataDocument, options);
      }
export type UpdateCompanyBrandedDataMutationHookResult = ReturnType<typeof useUpdateCompanyBrandedDataMutation>;
export type UpdateCompanyBrandedDataMutationResult = Apollo.MutationResult<Generated.UpdateCompanyBrandedDataMutation>;
export type UpdateCompanyBrandedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCompanyBrandedDataMutation, Generated.UpdateCompanyBrandedDataMutationVariables>;
export const UpdateCompanyIdentityDocument = /*#__PURE__*/ gql`
    mutation updateCompanyIdentity($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    id
    ...CompanyFullIdentity
    ...CompanyMetadata
    activitiesTree {
      activity
      subactivities
    }
  }
}
    ${CompanyFullIdentityFragmentDoc}
${CompanyMetadataFragmentDoc}`;
export type UpdateCompanyIdentityMutationFn = Apollo.MutationFunction<Generated.UpdateCompanyIdentityMutation, Generated.UpdateCompanyIdentityMutationVariables>;

/**
 * __useUpdateCompanyIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyIdentityMutation, { data, loading, error }] = useUpdateCompanyIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCompanyIdentityMutation, Generated.UpdateCompanyIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCompanyIdentityMutation, Generated.UpdateCompanyIdentityMutationVariables>(UpdateCompanyIdentityDocument, options);
      }
export type UpdateCompanyIdentityMutationHookResult = ReturnType<typeof useUpdateCompanyIdentityMutation>;
export type UpdateCompanyIdentityMutationResult = Apollo.MutationResult<Generated.UpdateCompanyIdentityMutation>;
export type UpdateCompanyIdentityMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCompanyIdentityMutation, Generated.UpdateCompanyIdentityMutationVariables>;
export const UpdateCompanyLinksDocument = /*#__PURE__*/ gql`
    mutation updateCompanyLinks($id: ID!, $links: SocialLinksInput!) {
  updateCompany(input: {id: $id, links: $links}) {
    id
    ...CompanyLinks
    ...CompanyMetadata
  }
}
    ${CompanyLinksFragmentDoc}
${CompanyMetadataFragmentDoc}`;
export type UpdateCompanyLinksMutationFn = Apollo.MutationFunction<Generated.UpdateCompanyLinksMutation, Generated.UpdateCompanyLinksMutationVariables>;

/**
 * __useUpdateCompanyLinksMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyLinksMutation, { data, loading, error }] = useUpdateCompanyLinksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useUpdateCompanyLinksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCompanyLinksMutation, Generated.UpdateCompanyLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCompanyLinksMutation, Generated.UpdateCompanyLinksMutationVariables>(UpdateCompanyLinksDocument, options);
      }
export type UpdateCompanyLinksMutationHookResult = ReturnType<typeof useUpdateCompanyLinksMutation>;
export type UpdateCompanyLinksMutationResult = Apollo.MutationResult<Generated.UpdateCompanyLinksMutation>;
export type UpdateCompanyLinksMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCompanyLinksMutation, Generated.UpdateCompanyLinksMutationVariables>;
export const UpdateCompanyInfoDocument = /*#__PURE__*/ gql`
    mutation updateCompanyInfo($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    id
    ...CompanyFullIdentity
    ...CompanyMetadata
  }
}
    ${CompanyFullIdentityFragmentDoc}
${CompanyMetadataFragmentDoc}`;
export type UpdateCompanyInfoMutationFn = Apollo.MutationFunction<Generated.UpdateCompanyInfoMutation, Generated.UpdateCompanyInfoMutationVariables>;

/**
 * __useUpdateCompanyInfoMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyInfoMutation, { data, loading, error }] = useUpdateCompanyInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCompanyInfoMutation, Generated.UpdateCompanyInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCompanyInfoMutation, Generated.UpdateCompanyInfoMutationVariables>(UpdateCompanyInfoDocument, options);
      }
export type UpdateCompanyInfoMutationHookResult = ReturnType<typeof useUpdateCompanyInfoMutation>;
export type UpdateCompanyInfoMutationResult = Apollo.MutationResult<Generated.UpdateCompanyInfoMutation>;
export type UpdateCompanyInfoMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCompanyInfoMutation, Generated.UpdateCompanyInfoMutationVariables>;
export const UpdateCompanyLocalizedDataDocument = /*#__PURE__*/ gql`
    mutation updateCompanyLocalizedData($id: ID!, $localeId: ID!, $name: String, $description: String) {
  updateCompanyLocaleData(
    input: {id: $id, localeId: $localeId, name: $name, description: $description}
  ) {
    name
    description
  }
}
    `;
export type UpdateCompanyLocalizedDataMutationFn = Apollo.MutationFunction<Generated.UpdateCompanyLocalizedDataMutation, Generated.UpdateCompanyLocalizedDataMutationVariables>;

/**
 * __useUpdateCompanyLocalizedDataMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyLocalizedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyLocalizedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyLocalizedDataMutation, { data, loading, error }] = useUpdateCompanyLocalizedDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      localeId: // value for 'localeId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateCompanyLocalizedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCompanyLocalizedDataMutation, Generated.UpdateCompanyLocalizedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCompanyLocalizedDataMutation, Generated.UpdateCompanyLocalizedDataMutationVariables>(UpdateCompanyLocalizedDataDocument, options);
      }
export type UpdateCompanyLocalizedDataMutationHookResult = ReturnType<typeof useUpdateCompanyLocalizedDataMutation>;
export type UpdateCompanyLocalizedDataMutationResult = Apollo.MutationResult<Generated.UpdateCompanyLocalizedDataMutation>;
export type UpdateCompanyLocalizedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCompanyLocalizedDataMutation, Generated.UpdateCompanyLocalizedDataMutationVariables>;
export const UpdateCompanyStaffDocument = /*#__PURE__*/ gql`
    mutation updateCompanyStaff($input: UpdateCompanyStaffInput!) {
  updateCompanyStaff(input: $input) {
    ...CompanyStaffIdentity
  }
}
    ${CompanyStaffIdentityFragmentDoc}`;
export type UpdateCompanyStaffMutationFn = Apollo.MutationFunction<Generated.UpdateCompanyStaffMutation, Generated.UpdateCompanyStaffMutationVariables>;

/**
 * __useUpdateCompanyStaffMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyStaffMutation, { data, loading, error }] = useUpdateCompanyStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyStaffMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCompanyStaffMutation, Generated.UpdateCompanyStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCompanyStaffMutation, Generated.UpdateCompanyStaffMutationVariables>(UpdateCompanyStaffDocument, options);
      }
export type UpdateCompanyStaffMutationHookResult = ReturnType<typeof useUpdateCompanyStaffMutation>;
export type UpdateCompanyStaffMutationResult = Apollo.MutationResult<Generated.UpdateCompanyStaffMutation>;
export type UpdateCompanyStaffMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCompanyStaffMutation, Generated.UpdateCompanyStaffMutationVariables>;
export const GetCountryListDocument = /*#__PURE__*/ gql`
    query getCountryList($limit: Int, $offset: Int!, $search: String!, $orderBy: CountryOrder!) {
  countries(limit: $limit, offset: $offset, name: $search, orderBy: $orderBy) {
    totalCount
    nodes {
      id
      ref
      name
      alpha2
      alpha3
    }
  }
}
    `;

/**
 * __useGetCountryListQuery__
 *
 * To run a query within a React component, call `useGetCountryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetCountryListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCountryListQuery, Generated.GetCountryListQueryVariables> & ({ variables: Generated.GetCountryListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCountryListQuery, Generated.GetCountryListQueryVariables>(GetCountryListDocument, options);
      }
export function useGetCountryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCountryListQuery, Generated.GetCountryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCountryListQuery, Generated.GetCountryListQueryVariables>(GetCountryListDocument, options);
        }
export function useGetCountryListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCountryListQuery, Generated.GetCountryListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCountryListQuery, Generated.GetCountryListQueryVariables>(GetCountryListDocument, options);
        }
export type GetCountryListQueryHookResult = ReturnType<typeof useGetCountryListQuery>;
export type GetCountryListLazyQueryHookResult = ReturnType<typeof useGetCountryListLazyQuery>;
export type GetCountryListSuspenseQueryHookResult = ReturnType<typeof useGetCountryListSuspenseQuery>;
export type GetCountryListQueryResult = Apollo.QueryResult<Generated.GetCountryListQuery, Generated.GetCountryListQueryVariables>;
export const GetCountryByIdDocument = /*#__PURE__*/ gql`
    query getCountryById($id: ID!) {
  country(id: $id) {
    ... on Country {
      ...CountryIdentity
      ...CountryMetadata
    }
  }
}
    ${CountryIdentityFragmentDoc}
${CountryMetadataFragmentDoc}`;

/**
 * __useGetCountryByIdQuery__
 *
 * To run a query within a React component, call `useGetCountryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountryByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCountryByIdQuery, Generated.GetCountryByIdQueryVariables> & ({ variables: Generated.GetCountryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCountryByIdQuery, Generated.GetCountryByIdQueryVariables>(GetCountryByIdDocument, options);
      }
export function useGetCountryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCountryByIdQuery, Generated.GetCountryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCountryByIdQuery, Generated.GetCountryByIdQueryVariables>(GetCountryByIdDocument, options);
        }
export function useGetCountryByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCountryByIdQuery, Generated.GetCountryByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCountryByIdQuery, Generated.GetCountryByIdQueryVariables>(GetCountryByIdDocument, options);
        }
export type GetCountryByIdQueryHookResult = ReturnType<typeof useGetCountryByIdQuery>;
export type GetCountryByIdLazyQueryHookResult = ReturnType<typeof useGetCountryByIdLazyQuery>;
export type GetCountryByIdSuspenseQueryHookResult = ReturnType<typeof useGetCountryByIdSuspenseQuery>;
export type GetCountryByIdQueryResult = Apollo.QueryResult<Generated.GetCountryByIdQuery, Generated.GetCountryByIdQueryVariables>;
export const GetCountryDocument = /*#__PURE__*/ gql`
    query getCountry($ref: ID!) {
  countryByRef(ref: $ref) {
    ... on Country {
      ...CountryIdentity
      ...CountryMetadata
    }
  }
}
    ${CountryIdentityFragmentDoc}
${CountryMetadataFragmentDoc}`;

/**
 * __useGetCountryQuery__
 *
 * To run a query within a React component, call `useGetCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCountryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCountryQuery, Generated.GetCountryQueryVariables> & ({ variables: Generated.GetCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCountryQuery, Generated.GetCountryQueryVariables>(GetCountryDocument, options);
      }
export function useGetCountryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCountryQuery, Generated.GetCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCountryQuery, Generated.GetCountryQueryVariables>(GetCountryDocument, options);
        }
export function useGetCountrySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCountryQuery, Generated.GetCountryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCountryQuery, Generated.GetCountryQueryVariables>(GetCountryDocument, options);
        }
export type GetCountryQueryHookResult = ReturnType<typeof useGetCountryQuery>;
export type GetCountryLazyQueryHookResult = ReturnType<typeof useGetCountryLazyQuery>;
export type GetCountrySuspenseQueryHookResult = ReturnType<typeof useGetCountrySuspenseQuery>;
export type GetCountryQueryResult = Apollo.QueryResult<Generated.GetCountryQuery, Generated.GetCountryQueryVariables>;
export const UpdateCountryDocument = /*#__PURE__*/ gql`
    mutation updateCountry($input: UpdateCountryInput!) {
  updateCountry(input: $input) {
    ...CountryIdentity
    ...CountryMetadata
  }
}
    ${CountryIdentityFragmentDoc}
${CountryMetadataFragmentDoc}`;
export type UpdateCountryMutationFn = Apollo.MutationFunction<Generated.UpdateCountryMutation, Generated.UpdateCountryMutationVariables>;

/**
 * __useUpdateCountryMutation__
 *
 * To run a mutation, you first call `useUpdateCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCountryMutation, { data, loading, error }] = useUpdateCountryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCountryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCountryMutation, Generated.UpdateCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCountryMutation, Generated.UpdateCountryMutationVariables>(UpdateCountryDocument, options);
      }
export type UpdateCountryMutationHookResult = ReturnType<typeof useUpdateCountryMutation>;
export type UpdateCountryMutationResult = Apollo.MutationResult<Generated.UpdateCountryMutation>;
export type UpdateCountryMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCountryMutation, Generated.UpdateCountryMutationVariables>;
export const GetDuplicateListDocument = /*#__PURE__*/ gql`
    query getDuplicateList($limit: Int, $offset: Int!, $status: [DuplicateStatus!], $entityType: DuplicateEntityType, $orderBy: DuplicateOrder, $entityIds: [ID!]) {
  duplicates(
    limit: $limit
    offset: $offset
    status: $status
    entityType: $entityType
    orderBy: $orderBy
    entityIds: $entityIds
  ) {
    totalCount
    nodes {
      id
      ref
      metadata {
        createdAt
        updatedAt
      }
      status
      priority
      firstEntity {
        ...DuplicateEntityLight
      }
      secondEntity {
        ...DuplicateEntityLight
      }
      winner {
        ...DuplicateEntityLight
      }
    }
  }
}
    ${DuplicateEntityLightFragmentDoc}`;

/**
 * __useGetDuplicateListQuery__
 *
 * To run a query within a React component, call `useGetDuplicateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      entityType: // value for 'entityType'
 *      orderBy: // value for 'orderBy'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetDuplicateListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetDuplicateListQuery, Generated.GetDuplicateListQueryVariables> & ({ variables: Generated.GetDuplicateListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetDuplicateListQuery, Generated.GetDuplicateListQueryVariables>(GetDuplicateListDocument, options);
      }
export function useGetDuplicateListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetDuplicateListQuery, Generated.GetDuplicateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetDuplicateListQuery, Generated.GetDuplicateListQueryVariables>(GetDuplicateListDocument, options);
        }
export function useGetDuplicateListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetDuplicateListQuery, Generated.GetDuplicateListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetDuplicateListQuery, Generated.GetDuplicateListQueryVariables>(GetDuplicateListDocument, options);
        }
export type GetDuplicateListQueryHookResult = ReturnType<typeof useGetDuplicateListQuery>;
export type GetDuplicateListLazyQueryHookResult = ReturnType<typeof useGetDuplicateListLazyQuery>;
export type GetDuplicateListSuspenseQueryHookResult = ReturnType<typeof useGetDuplicateListSuspenseQuery>;
export type GetDuplicateListQueryResult = Apollo.QueryResult<Generated.GetDuplicateListQuery, Generated.GetDuplicateListQueryVariables>;
export const UpdateDuplicateDocument = /*#__PURE__*/ gql`
    mutation updateDuplicate($input: UpdateDuplicateInput!) {
  updateDuplicate(input: $input) {
    ...DuplicateIdentity
    ...DuplicateMetadata
  }
}
    ${DuplicateIdentityFragmentDoc}
${DuplicateMetadataFragmentDoc}`;
export type UpdateDuplicateMutationFn = Apollo.MutationFunction<Generated.UpdateDuplicateMutation, Generated.UpdateDuplicateMutationVariables>;

/**
 * __useUpdateDuplicateMutation__
 *
 * To run a mutation, you first call `useUpdateDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDuplicateMutation, { data, loading, error }] = useUpdateDuplicateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateDuplicateMutation, Generated.UpdateDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateDuplicateMutation, Generated.UpdateDuplicateMutationVariables>(UpdateDuplicateDocument, options);
      }
export type UpdateDuplicateMutationHookResult = ReturnType<typeof useUpdateDuplicateMutation>;
export type UpdateDuplicateMutationResult = Apollo.MutationResult<Generated.UpdateDuplicateMutation>;
export type UpdateDuplicateMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateDuplicateMutation, Generated.UpdateDuplicateMutationVariables>;
export const GetDuplicateDocument = /*#__PURE__*/ gql`
    query getDuplicate($id: ID!) {
  duplicate(id: $id) {
    ...DuplicateIdentity
    ...DuplicateMetadata
  }
  brands {
    ref
  }
}
    ${DuplicateIdentityFragmentDoc}
${DuplicateMetadataFragmentDoc}`;

/**
 * __useGetDuplicateQuery__
 *
 * To run a query within a React component, call `useGetDuplicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDuplicateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetDuplicateQuery, Generated.GetDuplicateQueryVariables> & ({ variables: Generated.GetDuplicateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetDuplicateQuery, Generated.GetDuplicateQueryVariables>(GetDuplicateDocument, options);
      }
export function useGetDuplicateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetDuplicateQuery, Generated.GetDuplicateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetDuplicateQuery, Generated.GetDuplicateQueryVariables>(GetDuplicateDocument, options);
        }
export function useGetDuplicateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetDuplicateQuery, Generated.GetDuplicateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetDuplicateQuery, Generated.GetDuplicateQueryVariables>(GetDuplicateDocument, options);
        }
export type GetDuplicateQueryHookResult = ReturnType<typeof useGetDuplicateQuery>;
export type GetDuplicateLazyQueryHookResult = ReturnType<typeof useGetDuplicateLazyQuery>;
export type GetDuplicateSuspenseQueryHookResult = ReturnType<typeof useGetDuplicateSuspenseQuery>;
export type GetDuplicateQueryResult = Apollo.QueryResult<Generated.GetDuplicateQuery, Generated.GetDuplicateQueryVariables>;
export const AddDuplicateDocument = /*#__PURE__*/ gql`
    mutation addDuplicate($input: AddDuplicateInput!) {
  addDuplicate(input: $input) {
    ref
  }
}
    `;
export type AddDuplicateMutationFn = Apollo.MutationFunction<Generated.AddDuplicateMutation, Generated.AddDuplicateMutationVariables>;

/**
 * __useAddDuplicateMutation__
 *
 * To run a mutation, you first call `useAddDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDuplicateMutation, { data, loading, error }] = useAddDuplicateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddDuplicateMutation, Generated.AddDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddDuplicateMutation, Generated.AddDuplicateMutationVariables>(AddDuplicateDocument, options);
      }
export type AddDuplicateMutationHookResult = ReturnType<typeof useAddDuplicateMutation>;
export type AddDuplicateMutationResult = Apollo.MutationResult<Generated.AddDuplicateMutation>;
export type AddDuplicateMutationOptions = Apollo.BaseMutationOptions<Generated.AddDuplicateMutation, Generated.AddDuplicateMutationVariables>;
export const CreateFestivalAwardDocument = /*#__PURE__*/ gql`
    mutation createFestivalAward($input: CreateFestivalAwardInput!) {
  createFestivalAward(input: $input) {
    id
    ref
    name
  }
}
    `;
export type CreateFestivalAwardMutationFn = Apollo.MutationFunction<Generated.CreateFestivalAwardMutation, Generated.CreateFestivalAwardMutationVariables>;

/**
 * __useCreateFestivalAwardMutation__
 *
 * To run a mutation, you first call `useCreateFestivalAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalAwardMutation, { data, loading, error }] = useCreateFestivalAwardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFestivalAwardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFestivalAwardMutation, Generated.CreateFestivalAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFestivalAwardMutation, Generated.CreateFestivalAwardMutationVariables>(CreateFestivalAwardDocument, options);
      }
export type CreateFestivalAwardMutationHookResult = ReturnType<typeof useCreateFestivalAwardMutation>;
export type CreateFestivalAwardMutationResult = Apollo.MutationResult<Generated.CreateFestivalAwardMutation>;
export type CreateFestivalAwardMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFestivalAwardMutation, Generated.CreateFestivalAwardMutationVariables>;
export const CreateFestivalEditionCompetitionDocument = /*#__PURE__*/ gql`
    mutation createFestivalEditionCompetition($input: CreateFestivalEditionCompetitionInput!) {
  createFestivalEditionCompetition(input: $input) {
    id
    ref
  }
}
    `;
export type CreateFestivalEditionCompetitionMutationFn = Apollo.MutationFunction<Generated.CreateFestivalEditionCompetitionMutation, Generated.CreateFestivalEditionCompetitionMutationVariables>;

/**
 * __useCreateFestivalEditionCompetitionMutation__
 *
 * To run a mutation, you first call `useCreateFestivalEditionCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalEditionCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalEditionCompetitionMutation, { data, loading, error }] = useCreateFestivalEditionCompetitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFestivalEditionCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFestivalEditionCompetitionMutation, Generated.CreateFestivalEditionCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFestivalEditionCompetitionMutation, Generated.CreateFestivalEditionCompetitionMutationVariables>(CreateFestivalEditionCompetitionDocument, options);
      }
export type CreateFestivalEditionCompetitionMutationHookResult = ReturnType<typeof useCreateFestivalEditionCompetitionMutation>;
export type CreateFestivalEditionCompetitionMutationResult = Apollo.MutationResult<Generated.CreateFestivalEditionCompetitionMutation>;
export type CreateFestivalEditionCompetitionMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFestivalEditionCompetitionMutation, Generated.CreateFestivalEditionCompetitionMutationVariables>;
export const CopyFestivalEditionDocument = /*#__PURE__*/ gql`
    mutation copyFestivalEdition($input: CopyFestivalEditionInput!) {
  copyFestivalEdition(input: $input) {
    id
    ref
  }
}
    `;
export type CopyFestivalEditionMutationFn = Apollo.MutationFunction<Generated.CopyFestivalEditionMutation, Generated.CopyFestivalEditionMutationVariables>;

/**
 * __useCopyFestivalEditionMutation__
 *
 * To run a mutation, you first call `useCopyFestivalEditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyFestivalEditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyFestivalEditionMutation, { data, loading, error }] = useCopyFestivalEditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyFestivalEditionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CopyFestivalEditionMutation, Generated.CopyFestivalEditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CopyFestivalEditionMutation, Generated.CopyFestivalEditionMutationVariables>(CopyFestivalEditionDocument, options);
      }
export type CopyFestivalEditionMutationHookResult = ReturnType<typeof useCopyFestivalEditionMutation>;
export type CopyFestivalEditionMutationResult = Apollo.MutationResult<Generated.CopyFestivalEditionMutation>;
export type CopyFestivalEditionMutationOptions = Apollo.BaseMutationOptions<Generated.CopyFestivalEditionMutation, Generated.CopyFestivalEditionMutationVariables>;
export const CreateFestivalCompetitionDocument = /*#__PURE__*/ gql`
    mutation createFestivalCompetition($input: CreateFestivalCompetitionInput!) {
  createFestivalCompetition(input: $input) {
    id
    ref
  }
}
    `;
export type CreateFestivalCompetitionMutationFn = Apollo.MutationFunction<Generated.CreateFestivalCompetitionMutation, Generated.CreateFestivalCompetitionMutationVariables>;

/**
 * __useCreateFestivalCompetitionMutation__
 *
 * To run a mutation, you first call `useCreateFestivalCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalCompetitionMutation, { data, loading, error }] = useCreateFestivalCompetitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFestivalCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFestivalCompetitionMutation, Generated.CreateFestivalCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFestivalCompetitionMutation, Generated.CreateFestivalCompetitionMutationVariables>(CreateFestivalCompetitionDocument, options);
      }
export type CreateFestivalCompetitionMutationHookResult = ReturnType<typeof useCreateFestivalCompetitionMutation>;
export type CreateFestivalCompetitionMutationResult = Apollo.MutationResult<Generated.CreateFestivalCompetitionMutation>;
export type CreateFestivalCompetitionMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFestivalCompetitionMutation, Generated.CreateFestivalCompetitionMutationVariables>;
export const CreateFestivalSelectionDocument = /*#__PURE__*/ gql`
    mutation createFestivalSelection($input: CreateFestivalSelectionInput!) {
  createFestivalSelection(input: $input) {
    id
    ref
  }
}
    `;
export type CreateFestivalSelectionMutationFn = Apollo.MutationFunction<Generated.CreateFestivalSelectionMutation, Generated.CreateFestivalSelectionMutationVariables>;

/**
 * __useCreateFestivalSelectionMutation__
 *
 * To run a mutation, you first call `useCreateFestivalSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalSelectionMutation, { data, loading, error }] = useCreateFestivalSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFestivalSelectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFestivalSelectionMutation, Generated.CreateFestivalSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFestivalSelectionMutation, Generated.CreateFestivalSelectionMutationVariables>(CreateFestivalSelectionDocument, options);
      }
export type CreateFestivalSelectionMutationHookResult = ReturnType<typeof useCreateFestivalSelectionMutation>;
export type CreateFestivalSelectionMutationResult = Apollo.MutationResult<Generated.CreateFestivalSelectionMutation>;
export type CreateFestivalSelectionMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFestivalSelectionMutation, Generated.CreateFestivalSelectionMutationVariables>;
export const CreateFestivalEditionDocument = /*#__PURE__*/ gql`
    mutation createFestivalEdition($input: CreateFestivalEditionInput!) {
  createFestivalEdition(input: $input) {
    id
    ref
  }
}
    `;
export type CreateFestivalEditionMutationFn = Apollo.MutationFunction<Generated.CreateFestivalEditionMutation, Generated.CreateFestivalEditionMutationVariables>;

/**
 * __useCreateFestivalEditionMutation__
 *
 * To run a mutation, you first call `useCreateFestivalEditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalEditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalEditionMutation, { data, loading, error }] = useCreateFestivalEditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFestivalEditionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFestivalEditionMutation, Generated.CreateFestivalEditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFestivalEditionMutation, Generated.CreateFestivalEditionMutationVariables>(CreateFestivalEditionDocument, options);
      }
export type CreateFestivalEditionMutationHookResult = ReturnType<typeof useCreateFestivalEditionMutation>;
export type CreateFestivalEditionMutationResult = Apollo.MutationResult<Generated.CreateFestivalEditionMutation>;
export type CreateFestivalEditionMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFestivalEditionMutation, Generated.CreateFestivalEditionMutationVariables>;
export const CreateFestivalDocument = /*#__PURE__*/ gql`
    mutation createFestival($input: CreateFestivalInput!) {
  createFestival(input: $input) {
    id
    ref
  }
}
    `;
export type CreateFestivalMutationFn = Apollo.MutationFunction<Generated.CreateFestivalMutation, Generated.CreateFestivalMutationVariables>;

/**
 * __useCreateFestivalMutation__
 *
 * To run a mutation, you first call `useCreateFestivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalMutation, { data, loading, error }] = useCreateFestivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFestivalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFestivalMutation, Generated.CreateFestivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFestivalMutation, Generated.CreateFestivalMutationVariables>(CreateFestivalDocument, options);
      }
export type CreateFestivalMutationHookResult = ReturnType<typeof useCreateFestivalMutation>;
export type CreateFestivalMutationResult = Apollo.MutationResult<Generated.CreateFestivalMutation>;
export type CreateFestivalMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFestivalMutation, Generated.CreateFestivalMutationVariables>;
export const CreateFestivalJuryDocument = /*#__PURE__*/ gql`
    mutation createFestivalJury($input: CreateFestivalJuryInput!) {
  createFestivalJury(input: $input) {
    id
    ref
  }
}
    `;
export type CreateFestivalJuryMutationFn = Apollo.MutationFunction<Generated.CreateFestivalJuryMutation, Generated.CreateFestivalJuryMutationVariables>;

/**
 * __useCreateFestivalJuryMutation__
 *
 * To run a mutation, you first call `useCreateFestivalJuryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalJuryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalJuryMutation, { data, loading, error }] = useCreateFestivalJuryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFestivalJuryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFestivalJuryMutation, Generated.CreateFestivalJuryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFestivalJuryMutation, Generated.CreateFestivalJuryMutationVariables>(CreateFestivalJuryDocument, options);
      }
export type CreateFestivalJuryMutationHookResult = ReturnType<typeof useCreateFestivalJuryMutation>;
export type CreateFestivalJuryMutationResult = Apollo.MutationResult<Generated.CreateFestivalJuryMutation>;
export type CreateFestivalJuryMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFestivalJuryMutation, Generated.CreateFestivalJuryMutationVariables>;
export const DeleteFestivalAwardDocument = /*#__PURE__*/ gql`
    mutation deleteFestivalAward($input: DeleteFestivalAwardInput!) {
  deleteFestivalAward(input: $input) {
    id
  }
}
    `;
export type DeleteFestivalAwardMutationFn = Apollo.MutationFunction<Generated.DeleteFestivalAwardMutation, Generated.DeleteFestivalAwardMutationVariables>;

/**
 * __useDeleteFestivalAwardMutation__
 *
 * To run a mutation, you first call `useDeleteFestivalAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFestivalAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFestivalAwardMutation, { data, loading, error }] = useDeleteFestivalAwardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFestivalAwardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteFestivalAwardMutation, Generated.DeleteFestivalAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteFestivalAwardMutation, Generated.DeleteFestivalAwardMutationVariables>(DeleteFestivalAwardDocument, options);
      }
export type DeleteFestivalAwardMutationHookResult = ReturnType<typeof useDeleteFestivalAwardMutation>;
export type DeleteFestivalAwardMutationResult = Apollo.MutationResult<Generated.DeleteFestivalAwardMutation>;
export type DeleteFestivalAwardMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteFestivalAwardMutation, Generated.DeleteFestivalAwardMutationVariables>;
export const DeleteFestivalEditionCompetitionDocument = /*#__PURE__*/ gql`
    mutation deleteFestivalEditionCompetition($input: DeleteFestivalEditionCompetitionInput!) {
  deleteFestivalEditionCompetition(input: $input) {
    id
  }
}
    `;
export type DeleteFestivalEditionCompetitionMutationFn = Apollo.MutationFunction<Generated.DeleteFestivalEditionCompetitionMutation, Generated.DeleteFestivalEditionCompetitionMutationVariables>;

/**
 * __useDeleteFestivalEditionCompetitionMutation__
 *
 * To run a mutation, you first call `useDeleteFestivalEditionCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFestivalEditionCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFestivalEditionCompetitionMutation, { data, loading, error }] = useDeleteFestivalEditionCompetitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFestivalEditionCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteFestivalEditionCompetitionMutation, Generated.DeleteFestivalEditionCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteFestivalEditionCompetitionMutation, Generated.DeleteFestivalEditionCompetitionMutationVariables>(DeleteFestivalEditionCompetitionDocument, options);
      }
export type DeleteFestivalEditionCompetitionMutationHookResult = ReturnType<typeof useDeleteFestivalEditionCompetitionMutation>;
export type DeleteFestivalEditionCompetitionMutationResult = Apollo.MutationResult<Generated.DeleteFestivalEditionCompetitionMutation>;
export type DeleteFestivalEditionCompetitionMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteFestivalEditionCompetitionMutation, Generated.DeleteFestivalEditionCompetitionMutationVariables>;
export const DeleteFestivalEditionDocument = /*#__PURE__*/ gql`
    mutation deleteFestivalEdition($input: DeleteFestivalEditionInput!) {
  deleteFestivalEdition(input: $input) {
    id
  }
}
    `;
export type DeleteFestivalEditionMutationFn = Apollo.MutationFunction<Generated.DeleteFestivalEditionMutation, Generated.DeleteFestivalEditionMutationVariables>;

/**
 * __useDeleteFestivalEditionMutation__
 *
 * To run a mutation, you first call `useDeleteFestivalEditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFestivalEditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFestivalEditionMutation, { data, loading, error }] = useDeleteFestivalEditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFestivalEditionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteFestivalEditionMutation, Generated.DeleteFestivalEditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteFestivalEditionMutation, Generated.DeleteFestivalEditionMutationVariables>(DeleteFestivalEditionDocument, options);
      }
export type DeleteFestivalEditionMutationHookResult = ReturnType<typeof useDeleteFestivalEditionMutation>;
export type DeleteFestivalEditionMutationResult = Apollo.MutationResult<Generated.DeleteFestivalEditionMutation>;
export type DeleteFestivalEditionMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteFestivalEditionMutation, Generated.DeleteFestivalEditionMutationVariables>;
export const DeleteFestivalJuryDocument = /*#__PURE__*/ gql`
    mutation deleteFestivalJury($input: DeleteFestivalJuryInput!) {
  deleteFestivalJury(input: $input) {
    id
  }
}
    `;
export type DeleteFestivalJuryMutationFn = Apollo.MutationFunction<Generated.DeleteFestivalJuryMutation, Generated.DeleteFestivalJuryMutationVariables>;

/**
 * __useDeleteFestivalJuryMutation__
 *
 * To run a mutation, you first call `useDeleteFestivalJuryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFestivalJuryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFestivalJuryMutation, { data, loading, error }] = useDeleteFestivalJuryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFestivalJuryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteFestivalJuryMutation, Generated.DeleteFestivalJuryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteFestivalJuryMutation, Generated.DeleteFestivalJuryMutationVariables>(DeleteFestivalJuryDocument, options);
      }
export type DeleteFestivalJuryMutationHookResult = ReturnType<typeof useDeleteFestivalJuryMutation>;
export type DeleteFestivalJuryMutationResult = Apollo.MutationResult<Generated.DeleteFestivalJuryMutation>;
export type DeleteFestivalJuryMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteFestivalJuryMutation, Generated.DeleteFestivalJuryMutationVariables>;
export const DeleteFestivalSelectionDocument = /*#__PURE__*/ gql`
    mutation deleteFestivalSelection($input: DeleteFestivalSelectionInput!) {
  deleteFestivalSelection(input: $input) {
    id
  }
}
    `;
export type DeleteFestivalSelectionMutationFn = Apollo.MutationFunction<Generated.DeleteFestivalSelectionMutation, Generated.DeleteFestivalSelectionMutationVariables>;

/**
 * __useDeleteFestivalSelectionMutation__
 *
 * To run a mutation, you first call `useDeleteFestivalSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFestivalSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFestivalSelectionMutation, { data, loading, error }] = useDeleteFestivalSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFestivalSelectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteFestivalSelectionMutation, Generated.DeleteFestivalSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteFestivalSelectionMutation, Generated.DeleteFestivalSelectionMutationVariables>(DeleteFestivalSelectionDocument, options);
      }
export type DeleteFestivalSelectionMutationHookResult = ReturnType<typeof useDeleteFestivalSelectionMutation>;
export type DeleteFestivalSelectionMutationResult = Apollo.MutationResult<Generated.DeleteFestivalSelectionMutation>;
export type DeleteFestivalSelectionMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteFestivalSelectionMutation, Generated.DeleteFestivalSelectionMutationVariables>;
export const DeleteFestivalDocument = /*#__PURE__*/ gql`
    mutation deleteFestival($input: DeleteFestivalInput!) {
  deleteFestival(input: $input) {
    id
  }
}
    `;
export type DeleteFestivalMutationFn = Apollo.MutationFunction<Generated.DeleteFestivalMutation, Generated.DeleteFestivalMutationVariables>;

/**
 * __useDeleteFestivalMutation__
 *
 * To run a mutation, you first call `useDeleteFestivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFestivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFestivalMutation, { data, loading, error }] = useDeleteFestivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFestivalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteFestivalMutation, Generated.DeleteFestivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteFestivalMutation, Generated.DeleteFestivalMutationVariables>(DeleteFestivalDocument, options);
      }
export type DeleteFestivalMutationHookResult = ReturnType<typeof useDeleteFestivalMutation>;
export type DeleteFestivalMutationResult = Apollo.MutationResult<Generated.DeleteFestivalMutation>;
export type DeleteFestivalMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteFestivalMutation, Generated.DeleteFestivalMutationVariables>;
export const GetFestivalAwardsByRefDocument = /*#__PURE__*/ gql`
    query GetFestivalAwardsByRef($ref: ID!, $orderBy: FestivalSelectionEntityOrder) {
  festivalAwardByRef(ref: $ref) {
    ref
    __typename
    id
    name
    metadata {
      ...Metadata
    }
    festival {
      __typename
      id
      ref
      name
    }
    festivalSelections(orderBy: $orderBy) {
      __typename
      ref
      id
      festivalEdition {
        __typename
        id
        ref
        year
        festival {
          __typename
          id
          ref
          name
        }
      }
      nominees {
        entity {
          __typename
          ... on Movie {
            ref
            title
          }
          ... on Series {
            ref
            title
          }
        }
        persons {
          ref
          __typename
          lastName
          firstName
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}`;

/**
 * __useGetFestivalAwardsByRefQuery__
 *
 * To run a query within a React component, call `useGetFestivalAwardsByRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalAwardsByRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalAwardsByRefQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFestivalAwardsByRefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalAwardsByRefQuery, Generated.GetFestivalAwardsByRefQueryVariables> & ({ variables: Generated.GetFestivalAwardsByRefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalAwardsByRefQuery, Generated.GetFestivalAwardsByRefQueryVariables>(GetFestivalAwardsByRefDocument, options);
      }
export function useGetFestivalAwardsByRefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalAwardsByRefQuery, Generated.GetFestivalAwardsByRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalAwardsByRefQuery, Generated.GetFestivalAwardsByRefQueryVariables>(GetFestivalAwardsByRefDocument, options);
        }
export function useGetFestivalAwardsByRefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalAwardsByRefQuery, Generated.GetFestivalAwardsByRefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalAwardsByRefQuery, Generated.GetFestivalAwardsByRefQueryVariables>(GetFestivalAwardsByRefDocument, options);
        }
export type GetFestivalAwardsByRefQueryHookResult = ReturnType<typeof useGetFestivalAwardsByRefQuery>;
export type GetFestivalAwardsByRefLazyQueryHookResult = ReturnType<typeof useGetFestivalAwardsByRefLazyQuery>;
export type GetFestivalAwardsByRefSuspenseQueryHookResult = ReturnType<typeof useGetFestivalAwardsByRefSuspenseQuery>;
export type GetFestivalAwardsByRefQueryResult = Apollo.QueryResult<Generated.GetFestivalAwardsByRefQuery, Generated.GetFestivalAwardsByRefQueryVariables>;
export const GetFestivalAwardsListDocument = /*#__PURE__*/ gql`
    query getFestivalAwardsList($search: String, $festivalId: ID!, $locale: ID!, $offset: Int, $limit: Int, $orderBy: FestivalAwardOrder) {
  festivalAwards(
    festivalId: $festivalId
    search: $search
    offset: $offset
    limit: $limit
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...FestivalAward
    }
  }
}
    ${FestivalAwardFragmentDoc}`;

/**
 * __useGetFestivalAwardsListQuery__
 *
 * To run a query within a React component, call `useGetFestivalAwardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalAwardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalAwardsListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      festivalId: // value for 'festivalId'
 *      locale: // value for 'locale'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFestivalAwardsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalAwardsListQuery, Generated.GetFestivalAwardsListQueryVariables> & ({ variables: Generated.GetFestivalAwardsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalAwardsListQuery, Generated.GetFestivalAwardsListQueryVariables>(GetFestivalAwardsListDocument, options);
      }
export function useGetFestivalAwardsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalAwardsListQuery, Generated.GetFestivalAwardsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalAwardsListQuery, Generated.GetFestivalAwardsListQueryVariables>(GetFestivalAwardsListDocument, options);
        }
export function useGetFestivalAwardsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalAwardsListQuery, Generated.GetFestivalAwardsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalAwardsListQuery, Generated.GetFestivalAwardsListQueryVariables>(GetFestivalAwardsListDocument, options);
        }
export type GetFestivalAwardsListQueryHookResult = ReturnType<typeof useGetFestivalAwardsListQuery>;
export type GetFestivalAwardsListLazyQueryHookResult = ReturnType<typeof useGetFestivalAwardsListLazyQuery>;
export type GetFestivalAwardsListSuspenseQueryHookResult = ReturnType<typeof useGetFestivalAwardsListSuspenseQuery>;
export type GetFestivalAwardsListQueryResult = Apollo.QueryResult<Generated.GetFestivalAwardsListQuery, Generated.GetFestivalAwardsListQueryVariables>;
export const GetFestivalAndEditionByRefsDocument = /*#__PURE__*/ gql`
    query GetFestivalAndEditionByRefs($festivalRef: ID!, $editionRef: ID!) {
  festival: entityByRef(ref: $festivalRef, type: FESTIVAL) {
    __typename
    ... on Festival {
      id
      ref
    }
  }
  festivalEdition: entityByRef(ref: $editionRef, type: FESTIVAL_EDITION) {
    __typename
    ... on FestivalEdition {
      id
      ref
    }
  }
}
    `;

/**
 * __useGetFestivalAndEditionByRefsQuery__
 *
 * To run a query within a React component, call `useGetFestivalAndEditionByRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalAndEditionByRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalAndEditionByRefsQuery({
 *   variables: {
 *      festivalRef: // value for 'festivalRef'
 *      editionRef: // value for 'editionRef'
 *   },
 * });
 */
export function useGetFestivalAndEditionByRefsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalAndEditionByRefsQuery, Generated.GetFestivalAndEditionByRefsQueryVariables> & ({ variables: Generated.GetFestivalAndEditionByRefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalAndEditionByRefsQuery, Generated.GetFestivalAndEditionByRefsQueryVariables>(GetFestivalAndEditionByRefsDocument, options);
      }
export function useGetFestivalAndEditionByRefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalAndEditionByRefsQuery, Generated.GetFestivalAndEditionByRefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalAndEditionByRefsQuery, Generated.GetFestivalAndEditionByRefsQueryVariables>(GetFestivalAndEditionByRefsDocument, options);
        }
export function useGetFestivalAndEditionByRefsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalAndEditionByRefsQuery, Generated.GetFestivalAndEditionByRefsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalAndEditionByRefsQuery, Generated.GetFestivalAndEditionByRefsQueryVariables>(GetFestivalAndEditionByRefsDocument, options);
        }
export type GetFestivalAndEditionByRefsQueryHookResult = ReturnType<typeof useGetFestivalAndEditionByRefsQuery>;
export type GetFestivalAndEditionByRefsLazyQueryHookResult = ReturnType<typeof useGetFestivalAndEditionByRefsLazyQuery>;
export type GetFestivalAndEditionByRefsSuspenseQueryHookResult = ReturnType<typeof useGetFestivalAndEditionByRefsSuspenseQuery>;
export type GetFestivalAndEditionByRefsQueryResult = Apollo.QueryResult<Generated.GetFestivalAndEditionByRefsQuery, Generated.GetFestivalAndEditionByRefsQueryVariables>;
export const GetFestivalByRefDocument = /*#__PURE__*/ gql`
    query GetFestivalByRef($ref: ID!) {
  festivalByRef(ref: $ref) {
    id
    ref
    name
    poster {
      url
    }
    latestFestivalEdition {
      poster {
        url
      }
      __typename
    }
    country {
      locale {
        id
      }
    }
    __typename
  }
}
    `;

/**
 * __useGetFestivalByRefQuery__
 *
 * To run a query within a React component, call `useGetFestivalByRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalByRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalByRefQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetFestivalByRefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalByRefQuery, Generated.GetFestivalByRefQueryVariables> & ({ variables: Generated.GetFestivalByRefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalByRefQuery, Generated.GetFestivalByRefQueryVariables>(GetFestivalByRefDocument, options);
      }
export function useGetFestivalByRefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalByRefQuery, Generated.GetFestivalByRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalByRefQuery, Generated.GetFestivalByRefQueryVariables>(GetFestivalByRefDocument, options);
        }
export function useGetFestivalByRefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalByRefQuery, Generated.GetFestivalByRefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalByRefQuery, Generated.GetFestivalByRefQueryVariables>(GetFestivalByRefDocument, options);
        }
export type GetFestivalByRefQueryHookResult = ReturnType<typeof useGetFestivalByRefQuery>;
export type GetFestivalByRefLazyQueryHookResult = ReturnType<typeof useGetFestivalByRefLazyQuery>;
export type GetFestivalByRefSuspenseQueryHookResult = ReturnType<typeof useGetFestivalByRefSuspenseQuery>;
export type GetFestivalByRefQueryResult = Apollo.QueryResult<Generated.GetFestivalByRefQuery, Generated.GetFestivalByRefQueryVariables>;
export const GetFestivalDefaultContextDocument = /*#__PURE__*/ gql`
    query getFestivalDefaultContext {
  festivalDefaultLocale: localeByRef(ref: "fr_FR") {
    id
    name
    ref
  }
  festivalDefaultBrand: brandByRef(ref: "AC") {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;

/**
 * __useGetFestivalDefaultContextQuery__
 *
 * To run a query within a React component, call `useGetFestivalDefaultContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalDefaultContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalDefaultContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFestivalDefaultContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalDefaultContextQuery, Generated.GetFestivalDefaultContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalDefaultContextQuery, Generated.GetFestivalDefaultContextQueryVariables>(GetFestivalDefaultContextDocument, options);
      }
export function useGetFestivalDefaultContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalDefaultContextQuery, Generated.GetFestivalDefaultContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalDefaultContextQuery, Generated.GetFestivalDefaultContextQueryVariables>(GetFestivalDefaultContextDocument, options);
        }
export function useGetFestivalDefaultContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalDefaultContextQuery, Generated.GetFestivalDefaultContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalDefaultContextQuery, Generated.GetFestivalDefaultContextQueryVariables>(GetFestivalDefaultContextDocument, options);
        }
export type GetFestivalDefaultContextQueryHookResult = ReturnType<typeof useGetFestivalDefaultContextQuery>;
export type GetFestivalDefaultContextLazyQueryHookResult = ReturnType<typeof useGetFestivalDefaultContextLazyQuery>;
export type GetFestivalDefaultContextSuspenseQueryHookResult = ReturnType<typeof useGetFestivalDefaultContextSuspenseQuery>;
export type GetFestivalDefaultContextQueryResult = Apollo.QueryResult<Generated.GetFestivalDefaultContextQuery, Generated.GetFestivalDefaultContextQueryVariables>;
export const GetFestivalCompetitionMetadataDocument = /*#__PURE__*/ gql`
    query getFestivalCompetitionMetadata($ref: ID!, $locale: ID!) {
  entityByRef(type: FESTIVAL_COMPETITION, ref: $ref) {
    __typename
    ... on FestivalCompetition {
      ...FestivalCompetitionIdentity
      ...FestivalCompetitionMetadata
    }
  }
}
    ${FestivalCompetitionIdentityFragmentDoc}
${FestivalCompetitionMetadataFragmentDoc}`;

/**
 * __useGetFestivalCompetitionMetadataQuery__
 *
 * To run a query within a React component, call `useGetFestivalCompetitionMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalCompetitionMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalCompetitionMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFestivalCompetitionMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalCompetitionMetadataQuery, Generated.GetFestivalCompetitionMetadataQueryVariables> & ({ variables: Generated.GetFestivalCompetitionMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalCompetitionMetadataQuery, Generated.GetFestivalCompetitionMetadataQueryVariables>(GetFestivalCompetitionMetadataDocument, options);
      }
export function useGetFestivalCompetitionMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalCompetitionMetadataQuery, Generated.GetFestivalCompetitionMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalCompetitionMetadataQuery, Generated.GetFestivalCompetitionMetadataQueryVariables>(GetFestivalCompetitionMetadataDocument, options);
        }
export function useGetFestivalCompetitionMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalCompetitionMetadataQuery, Generated.GetFestivalCompetitionMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalCompetitionMetadataQuery, Generated.GetFestivalCompetitionMetadataQueryVariables>(GetFestivalCompetitionMetadataDocument, options);
        }
export type GetFestivalCompetitionMetadataQueryHookResult = ReturnType<typeof useGetFestivalCompetitionMetadataQuery>;
export type GetFestivalCompetitionMetadataLazyQueryHookResult = ReturnType<typeof useGetFestivalCompetitionMetadataLazyQuery>;
export type GetFestivalCompetitionMetadataSuspenseQueryHookResult = ReturnType<typeof useGetFestivalCompetitionMetadataSuspenseQuery>;
export type GetFestivalCompetitionMetadataQueryResult = Apollo.QueryResult<Generated.GetFestivalCompetitionMetadataQuery, Generated.GetFestivalCompetitionMetadataQueryVariables>;
export const GetFestivalEditionByRefDocument = /*#__PURE__*/ gql`
    query getFestivalEditionByRef($ref: ID!) {
  entityByRef(ref: $ref, type: FESTIVAL_EDITION) {
    __typename
    ... on FestivalEdition {
      ...SearchFestivalEdition
    }
  }
}
    ${SearchFestivalEditionFragmentDoc}`;

/**
 * __useGetFestivalEditionByRefQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionByRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionByRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionByRefQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetFestivalEditionByRefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionByRefQuery, Generated.GetFestivalEditionByRefQueryVariables> & ({ variables: Generated.GetFestivalEditionByRefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionByRefQuery, Generated.GetFestivalEditionByRefQueryVariables>(GetFestivalEditionByRefDocument, options);
      }
export function useGetFestivalEditionByRefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionByRefQuery, Generated.GetFestivalEditionByRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionByRefQuery, Generated.GetFestivalEditionByRefQueryVariables>(GetFestivalEditionByRefDocument, options);
        }
export function useGetFestivalEditionByRefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionByRefQuery, Generated.GetFestivalEditionByRefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionByRefQuery, Generated.GetFestivalEditionByRefQueryVariables>(GetFestivalEditionByRefDocument, options);
        }
export type GetFestivalEditionByRefQueryHookResult = ReturnType<typeof useGetFestivalEditionByRefQuery>;
export type GetFestivalEditionByRefLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionByRefLazyQuery>;
export type GetFestivalEditionByRefSuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionByRefSuspenseQuery>;
export type GetFestivalEditionByRefQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionByRefQuery, Generated.GetFestivalEditionByRefQueryVariables>;
export const GetFestivalEditionIdentityDocument = /*#__PURE__*/ gql`
    query getFestivalEditionIdentity($id: ID!, $locale: ID!) {
  festivalEdition(id: $id) {
    ...FestivalEditionIdentity
  }
}
    ${FestivalEditionIdentityFragmentDoc}`;

/**
 * __useGetFestivalEditionIdentityQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFestivalEditionIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionIdentityQuery, Generated.GetFestivalEditionIdentityQueryVariables> & ({ variables: Generated.GetFestivalEditionIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionIdentityQuery, Generated.GetFestivalEditionIdentityQueryVariables>(GetFestivalEditionIdentityDocument, options);
      }
export function useGetFestivalEditionIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionIdentityQuery, Generated.GetFestivalEditionIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionIdentityQuery, Generated.GetFestivalEditionIdentityQueryVariables>(GetFestivalEditionIdentityDocument, options);
        }
export function useGetFestivalEditionIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionIdentityQuery, Generated.GetFestivalEditionIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionIdentityQuery, Generated.GetFestivalEditionIdentityQueryVariables>(GetFestivalEditionIdentityDocument, options);
        }
export type GetFestivalEditionIdentityQueryHookResult = ReturnType<typeof useGetFestivalEditionIdentityQuery>;
export type GetFestivalEditionIdentityLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionIdentityLazyQuery>;
export type GetFestivalEditionIdentitySuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionIdentitySuspenseQuery>;
export type GetFestivalEditionIdentityQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionIdentityQuery, Generated.GetFestivalEditionIdentityQueryVariables>;
export const GetFestivalEditionCompetitionIdsDocument = /*#__PURE__*/ gql`
    query getFestivalEditionCompetitionIds($editionId: ID!) {
  festivalEditionCompetitions(editionId: $editionId) {
    festivalCompetition {
      ref
      name
    }
  }
}
    `;

/**
 * __useGetFestivalEditionCompetitionIdsQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionCompetitionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionCompetitionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionCompetitionIdsQuery({
 *   variables: {
 *      editionId: // value for 'editionId'
 *   },
 * });
 */
export function useGetFestivalEditionCompetitionIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionCompetitionIdsQuery, Generated.GetFestivalEditionCompetitionIdsQueryVariables> & ({ variables: Generated.GetFestivalEditionCompetitionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionCompetitionIdsQuery, Generated.GetFestivalEditionCompetitionIdsQueryVariables>(GetFestivalEditionCompetitionIdsDocument, options);
      }
export function useGetFestivalEditionCompetitionIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionCompetitionIdsQuery, Generated.GetFestivalEditionCompetitionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionCompetitionIdsQuery, Generated.GetFestivalEditionCompetitionIdsQueryVariables>(GetFestivalEditionCompetitionIdsDocument, options);
        }
export function useGetFestivalEditionCompetitionIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionCompetitionIdsQuery, Generated.GetFestivalEditionCompetitionIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionCompetitionIdsQuery, Generated.GetFestivalEditionCompetitionIdsQueryVariables>(GetFestivalEditionCompetitionIdsDocument, options);
        }
export type GetFestivalEditionCompetitionIdsQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionIdsQuery>;
export type GetFestivalEditionCompetitionIdsLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionIdsLazyQuery>;
export type GetFestivalEditionCompetitionIdsSuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionIdsSuspenseQuery>;
export type GetFestivalEditionCompetitionIdsQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionCompetitionIdsQuery, Generated.GetFestivalEditionCompetitionIdsQueryVariables>;
export const GetFestivalEditionAvailableCompetitionsSearchDocument = /*#__PURE__*/ gql`
    query getFestivalEditionAvailableCompetitionsSearch($search: String, $festivalId: ID!, $festivalEditionId: ID) {
  festivalEditionCompetitionsSearch(
    search: $search
    festivalId: $festivalId
    festivalEditionId: $festivalEditionId
    onlyAvailableOnEdition: true
  ) {
    ...FestivalEditionCompetitionSearch
  }
}
    ${FestivalEditionCompetitionSearchFragmentDoc}`;

/**
 * __useGetFestivalEditionAvailableCompetitionsSearchQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionAvailableCompetitionsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionAvailableCompetitionsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionAvailableCompetitionsSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      festivalId: // value for 'festivalId'
 *      festivalEditionId: // value for 'festivalEditionId'
 *   },
 * });
 */
export function useGetFestivalEditionAvailableCompetitionsSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionAvailableCompetitionsSearchQuery, Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables> & ({ variables: Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionAvailableCompetitionsSearchQuery, Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables>(GetFestivalEditionAvailableCompetitionsSearchDocument, options);
      }
export function useGetFestivalEditionAvailableCompetitionsSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionAvailableCompetitionsSearchQuery, Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionAvailableCompetitionsSearchQuery, Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables>(GetFestivalEditionAvailableCompetitionsSearchDocument, options);
        }
export function useGetFestivalEditionAvailableCompetitionsSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionAvailableCompetitionsSearchQuery, Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionAvailableCompetitionsSearchQuery, Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables>(GetFestivalEditionAvailableCompetitionsSearchDocument, options);
        }
export type GetFestivalEditionAvailableCompetitionsSearchQueryHookResult = ReturnType<typeof useGetFestivalEditionAvailableCompetitionsSearchQuery>;
export type GetFestivalEditionAvailableCompetitionsSearchLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionAvailableCompetitionsSearchLazyQuery>;
export type GetFestivalEditionAvailableCompetitionsSearchSuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionAvailableCompetitionsSearchSuspenseQuery>;
export type GetFestivalEditionAvailableCompetitionsSearchQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionAvailableCompetitionsSearchQuery, Generated.GetFestivalEditionAvailableCompetitionsSearchQueryVariables>;
export const GetFestivalEditionCompetitionsDocument = /*#__PURE__*/ gql`
    query getFestivalEditionCompetitions($editionId: ID!, $locale: ID!) {
  festivalEditionCompetitions(editionId: $editionId) {
    __typename
    ...FestivalEditionCompetitionMetadata
    ...FestivalEditionCompetitionIdentity
  }
}
    ${FestivalEditionCompetitionMetadataFragmentDoc}
${FestivalEditionCompetitionIdentityFragmentDoc}`;

/**
 * __useGetFestivalEditionCompetitionsQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionCompetitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionCompetitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionCompetitionsQuery({
 *   variables: {
 *      editionId: // value for 'editionId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFestivalEditionCompetitionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionCompetitionsQuery, Generated.GetFestivalEditionCompetitionsQueryVariables> & ({ variables: Generated.GetFestivalEditionCompetitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionCompetitionsQuery, Generated.GetFestivalEditionCompetitionsQueryVariables>(GetFestivalEditionCompetitionsDocument, options);
      }
export function useGetFestivalEditionCompetitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionCompetitionsQuery, Generated.GetFestivalEditionCompetitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionCompetitionsQuery, Generated.GetFestivalEditionCompetitionsQueryVariables>(GetFestivalEditionCompetitionsDocument, options);
        }
export function useGetFestivalEditionCompetitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionCompetitionsQuery, Generated.GetFestivalEditionCompetitionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionCompetitionsQuery, Generated.GetFestivalEditionCompetitionsQueryVariables>(GetFestivalEditionCompetitionsDocument, options);
        }
export type GetFestivalEditionCompetitionsQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionsQuery>;
export type GetFestivalEditionCompetitionsLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionsLazyQuery>;
export type GetFestivalEditionCompetitionsSuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionsSuspenseQuery>;
export type GetFestivalEditionCompetitionsQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionCompetitionsQuery, Generated.GetFestivalEditionCompetitionsQueryVariables>;
export const GetFestivalEditionListDocument = /*#__PURE__*/ gql`
    query getFestivalEditionList($festivalId: ID!, $limit: Int, $offset: Int!, $locale: ID!, $orderBy: FestivalEditionOrder) {
  festivalEditions(
    festivalId: $festivalId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      __typename
      ...FestivalEditionIdentity
      ...FestivalEditionMetadata
    }
  }
}
    ${FestivalEditionIdentityFragmentDoc}
${FestivalEditionMetadataFragmentDoc}`;

/**
 * __useGetFestivalEditionListQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionListQuery({
 *   variables: {
 *      festivalId: // value for 'festivalId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      locale: // value for 'locale'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFestivalEditionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionListQuery, Generated.GetFestivalEditionListQueryVariables> & ({ variables: Generated.GetFestivalEditionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionListQuery, Generated.GetFestivalEditionListQueryVariables>(GetFestivalEditionListDocument, options);
      }
export function useGetFestivalEditionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionListQuery, Generated.GetFestivalEditionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionListQuery, Generated.GetFestivalEditionListQueryVariables>(GetFestivalEditionListDocument, options);
        }
export function useGetFestivalEditionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionListQuery, Generated.GetFestivalEditionListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionListQuery, Generated.GetFestivalEditionListQueryVariables>(GetFestivalEditionListDocument, options);
        }
export type GetFestivalEditionListQueryHookResult = ReturnType<typeof useGetFestivalEditionListQuery>;
export type GetFestivalEditionListLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionListLazyQuery>;
export type GetFestivalEditionListSuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionListSuspenseQuery>;
export type GetFestivalEditionListQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionListQuery, Generated.GetFestivalEditionListQueryVariables>;
export const GetFestivalIdentityDocument = /*#__PURE__*/ gql`
    query getFestivalIdentity($id: ID!, $locale: ID!) {
  festival(id: $id) {
    ...FestivalIdentity
  }
}
    ${FestivalIdentityFragmentDoc}`;

/**
 * __useGetFestivalIdentityQuery__
 *
 * To run a query within a React component, call `useGetFestivalIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFestivalIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalIdentityQuery, Generated.GetFestivalIdentityQueryVariables> & ({ variables: Generated.GetFestivalIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalIdentityQuery, Generated.GetFestivalIdentityQueryVariables>(GetFestivalIdentityDocument, options);
      }
export function useGetFestivalIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalIdentityQuery, Generated.GetFestivalIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalIdentityQuery, Generated.GetFestivalIdentityQueryVariables>(GetFestivalIdentityDocument, options);
        }
export function useGetFestivalIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalIdentityQuery, Generated.GetFestivalIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalIdentityQuery, Generated.GetFestivalIdentityQueryVariables>(GetFestivalIdentityDocument, options);
        }
export type GetFestivalIdentityQueryHookResult = ReturnType<typeof useGetFestivalIdentityQuery>;
export type GetFestivalIdentityLazyQueryHookResult = ReturnType<typeof useGetFestivalIdentityLazyQuery>;
export type GetFestivalIdentitySuspenseQueryHookResult = ReturnType<typeof useGetFestivalIdentitySuspenseQuery>;
export type GetFestivalIdentityQueryResult = Apollo.QueryResult<Generated.GetFestivalIdentityQuery, Generated.GetFestivalIdentityQueryVariables>;
export const GetFestivalJuryListDocument = /*#__PURE__*/ gql`
    query getFestivalJuryList($festivalId: ID!, $editionId: ID!, $competitionId: ID) {
  festivalJuries(
    festivalId: $festivalId
    editionId: $editionId
    competitionId: $competitionId
  ) {
    ...FestivalJury
  }
}
    ${FestivalJuryFragmentDoc}`;

/**
 * __useGetFestivalJuryListQuery__
 *
 * To run a query within a React component, call `useGetFestivalJuryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalJuryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalJuryListQuery({
 *   variables: {
 *      festivalId: // value for 'festivalId'
 *      editionId: // value for 'editionId'
 *      competitionId: // value for 'competitionId'
 *   },
 * });
 */
export function useGetFestivalJuryListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalJuryListQuery, Generated.GetFestivalJuryListQueryVariables> & ({ variables: Generated.GetFestivalJuryListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalJuryListQuery, Generated.GetFestivalJuryListQueryVariables>(GetFestivalJuryListDocument, options);
      }
export function useGetFestivalJuryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalJuryListQuery, Generated.GetFestivalJuryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalJuryListQuery, Generated.GetFestivalJuryListQueryVariables>(GetFestivalJuryListDocument, options);
        }
export function useGetFestivalJuryListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalJuryListQuery, Generated.GetFestivalJuryListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalJuryListQuery, Generated.GetFestivalJuryListQueryVariables>(GetFestivalJuryListDocument, options);
        }
export type GetFestivalJuryListQueryHookResult = ReturnType<typeof useGetFestivalJuryListQuery>;
export type GetFestivalJuryListLazyQueryHookResult = ReturnType<typeof useGetFestivalJuryListLazyQuery>;
export type GetFestivalJuryListSuspenseQueryHookResult = ReturnType<typeof useGetFestivalJuryListSuspenseQuery>;
export type GetFestivalJuryListQueryResult = Apollo.QueryResult<Generated.GetFestivalJuryListQuery, Generated.GetFestivalJuryListQueryVariables>;
export const GetFestivalEditionMetadataDocument = /*#__PURE__*/ gql`
    query getFestivalEditionMetadata($ref: ID!, $locale: ID!) {
  entityByRef(type: FESTIVAL_EDITION, ref: $ref) {
    __typename
    ... on FestivalEdition {
      id
      ...FestivalEditionIdentity
      ...FestivalEditionMetadata
    }
  }
}
    ${FestivalEditionIdentityFragmentDoc}
${FestivalEditionMetadataFragmentDoc}`;

/**
 * __useGetFestivalEditionMetadataQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFestivalEditionMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionMetadataQuery, Generated.GetFestivalEditionMetadataQueryVariables> & ({ variables: Generated.GetFestivalEditionMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionMetadataQuery, Generated.GetFestivalEditionMetadataQueryVariables>(GetFestivalEditionMetadataDocument, options);
      }
export function useGetFestivalEditionMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionMetadataQuery, Generated.GetFestivalEditionMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionMetadataQuery, Generated.GetFestivalEditionMetadataQueryVariables>(GetFestivalEditionMetadataDocument, options);
        }
export function useGetFestivalEditionMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionMetadataQuery, Generated.GetFestivalEditionMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionMetadataQuery, Generated.GetFestivalEditionMetadataQueryVariables>(GetFestivalEditionMetadataDocument, options);
        }
export type GetFestivalEditionMetadataQueryHookResult = ReturnType<typeof useGetFestivalEditionMetadataQuery>;
export type GetFestivalEditionMetadataLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionMetadataLazyQuery>;
export type GetFestivalEditionMetadataSuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionMetadataSuspenseQuery>;
export type GetFestivalEditionMetadataQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionMetadataQuery, Generated.GetFestivalEditionMetadataQueryVariables>;
export const GetFestivalListDocument = /*#__PURE__*/ gql`
    query getFestivalList($limit: Int, $offset: Int!, $search: String, $orderBy: FestivalOrder!, $countryIds: [ID!]!, $locale: ID!, $themes: [FestivalTheme!]) {
  festivals(
    limit: $limit
    offset: $offset
    search: $search
    orderBy: $orderBy
    countryIds: $countryIds
    themes: $themes
  ) {
    totalCount
    nodes {
      __typename
      ...FestivalIdentity
      ...FestivalMetadata
    }
  }
}
    ${FestivalIdentityFragmentDoc}
${FestivalMetadataFragmentDoc}`;

/**
 * __useGetFestivalListQuery__
 *
 * To run a query within a React component, call `useGetFestivalListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      countryIds: // value for 'countryIds'
 *      locale: // value for 'locale'
 *      themes: // value for 'themes'
 *   },
 * });
 */
export function useGetFestivalListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalListQuery, Generated.GetFestivalListQueryVariables> & ({ variables: Generated.GetFestivalListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalListQuery, Generated.GetFestivalListQueryVariables>(GetFestivalListDocument, options);
      }
export function useGetFestivalListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalListQuery, Generated.GetFestivalListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalListQuery, Generated.GetFestivalListQueryVariables>(GetFestivalListDocument, options);
        }
export function useGetFestivalListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalListQuery, Generated.GetFestivalListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalListQuery, Generated.GetFestivalListQueryVariables>(GetFestivalListDocument, options);
        }
export type GetFestivalListQueryHookResult = ReturnType<typeof useGetFestivalListQuery>;
export type GetFestivalListLazyQueryHookResult = ReturnType<typeof useGetFestivalListLazyQuery>;
export type GetFestivalListSuspenseQueryHookResult = ReturnType<typeof useGetFestivalListSuspenseQuery>;
export type GetFestivalListQueryResult = Apollo.QueryResult<Generated.GetFestivalListQuery, Generated.GetFestivalListQueryVariables>;
export const GetFestivalSelectionsForCompetitionListDocument = /*#__PURE__*/ gql`
    query getFestivalSelectionsForCompetitionList($festivalId: ID!, $editionId: ID!, $competitionId: ID!, $locale: ID!, $orderBy: FestivalSelectionOrder!) {
  festivalSelections(
    festivalId: $festivalId
    editionId: $editionId
    competitionId: $competitionId
    orderBy: $orderBy
  ) {
    ...FestivalSelection
  }
  festivalCompetition: entity(id: $competitionId) {
    __typename
    ... on FestivalCompetition {
      display
    }
  }
}
    ${FestivalSelectionFragmentDoc}`;

/**
 * __useGetFestivalSelectionsForCompetitionListQuery__
 *
 * To run a query within a React component, call `useGetFestivalSelectionsForCompetitionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalSelectionsForCompetitionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalSelectionsForCompetitionListQuery({
 *   variables: {
 *      festivalId: // value for 'festivalId'
 *      editionId: // value for 'editionId'
 *      competitionId: // value for 'competitionId'
 *      locale: // value for 'locale'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFestivalSelectionsForCompetitionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalSelectionsForCompetitionListQuery, Generated.GetFestivalSelectionsForCompetitionListQueryVariables> & ({ variables: Generated.GetFestivalSelectionsForCompetitionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalSelectionsForCompetitionListQuery, Generated.GetFestivalSelectionsForCompetitionListQueryVariables>(GetFestivalSelectionsForCompetitionListDocument, options);
      }
export function useGetFestivalSelectionsForCompetitionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalSelectionsForCompetitionListQuery, Generated.GetFestivalSelectionsForCompetitionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalSelectionsForCompetitionListQuery, Generated.GetFestivalSelectionsForCompetitionListQueryVariables>(GetFestivalSelectionsForCompetitionListDocument, options);
        }
export function useGetFestivalSelectionsForCompetitionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalSelectionsForCompetitionListQuery, Generated.GetFestivalSelectionsForCompetitionListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalSelectionsForCompetitionListQuery, Generated.GetFestivalSelectionsForCompetitionListQueryVariables>(GetFestivalSelectionsForCompetitionListDocument, options);
        }
export type GetFestivalSelectionsForCompetitionListQueryHookResult = ReturnType<typeof useGetFestivalSelectionsForCompetitionListQuery>;
export type GetFestivalSelectionsForCompetitionListLazyQueryHookResult = ReturnType<typeof useGetFestivalSelectionsForCompetitionListLazyQuery>;
export type GetFestivalSelectionsForCompetitionListSuspenseQueryHookResult = ReturnType<typeof useGetFestivalSelectionsForCompetitionListSuspenseQuery>;
export type GetFestivalSelectionsForCompetitionListQueryResult = Apollo.QueryResult<Generated.GetFestivalSelectionsForCompetitionListQuery, Generated.GetFestivalSelectionsForCompetitionListQueryVariables>;
export const GetFestivalMetadataDocument = /*#__PURE__*/ gql`
    query getFestivalMetadata($ref: ID!, $locale: ID!) {
  entityByRef(type: FESTIVAL, ref: $ref) {
    __typename
    ... on Festival {
      id
      ...FestivalIdentity
      ...FestivalMetadata
    }
  }
}
    ${FestivalIdentityFragmentDoc}
${FestivalMetadataFragmentDoc}`;

/**
 * __useGetFestivalMetadataQuery__
 *
 * To run a query within a React component, call `useGetFestivalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFestivalMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalMetadataQuery, Generated.GetFestivalMetadataQueryVariables> & ({ variables: Generated.GetFestivalMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalMetadataQuery, Generated.GetFestivalMetadataQueryVariables>(GetFestivalMetadataDocument, options);
      }
export function useGetFestivalMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalMetadataQuery, Generated.GetFestivalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalMetadataQuery, Generated.GetFestivalMetadataQueryVariables>(GetFestivalMetadataDocument, options);
        }
export function useGetFestivalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalMetadataQuery, Generated.GetFestivalMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalMetadataQuery, Generated.GetFestivalMetadataQueryVariables>(GetFestivalMetadataDocument, options);
        }
export type GetFestivalMetadataQueryHookResult = ReturnType<typeof useGetFestivalMetadataQuery>;
export type GetFestivalMetadataLazyQueryHookResult = ReturnType<typeof useGetFestivalMetadataLazyQuery>;
export type GetFestivalMetadataSuspenseQueryHookResult = ReturnType<typeof useGetFestivalMetadataSuspenseQuery>;
export type GetFestivalMetadataQueryResult = Apollo.QueryResult<Generated.GetFestivalMetadataQuery, Generated.GetFestivalMetadataQueryVariables>;
export const GetFestivalSelectionsListDocument = /*#__PURE__*/ gql`
    query getFestivalSelectionsList($festivalId: ID!, $editionId: ID!, $competitionId: ID, $locale: ID!, $orderBy: FestivalSelectionOrder!) {
  festivalSelections(
    festivalId: $festivalId
    editionId: $editionId
    competitionId: $competitionId
    orderBy: $orderBy
  ) {
    ...FestivalSelection
  }
}
    ${FestivalSelectionFragmentDoc}`;

/**
 * __useGetFestivalSelectionsListQuery__
 *
 * To run a query within a React component, call `useGetFestivalSelectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalSelectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalSelectionsListQuery({
 *   variables: {
 *      festivalId: // value for 'festivalId'
 *      editionId: // value for 'editionId'
 *      competitionId: // value for 'competitionId'
 *      locale: // value for 'locale'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFestivalSelectionsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalSelectionsListQuery, Generated.GetFestivalSelectionsListQueryVariables> & ({ variables: Generated.GetFestivalSelectionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalSelectionsListQuery, Generated.GetFestivalSelectionsListQueryVariables>(GetFestivalSelectionsListDocument, options);
      }
export function useGetFestivalSelectionsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalSelectionsListQuery, Generated.GetFestivalSelectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalSelectionsListQuery, Generated.GetFestivalSelectionsListQueryVariables>(GetFestivalSelectionsListDocument, options);
        }
export function useGetFestivalSelectionsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalSelectionsListQuery, Generated.GetFestivalSelectionsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalSelectionsListQuery, Generated.GetFestivalSelectionsListQueryVariables>(GetFestivalSelectionsListDocument, options);
        }
export type GetFestivalSelectionsListQueryHookResult = ReturnType<typeof useGetFestivalSelectionsListQuery>;
export type GetFestivalSelectionsListLazyQueryHookResult = ReturnType<typeof useGetFestivalSelectionsListLazyQuery>;
export type GetFestivalSelectionsListSuspenseQueryHookResult = ReturnType<typeof useGetFestivalSelectionsListSuspenseQuery>;
export type GetFestivalSelectionsListQueryResult = Apollo.QueryResult<Generated.GetFestivalSelectionsListQuery, Generated.GetFestivalSelectionsListQueryVariables>;
export const UpdateFestivalCompetitionDocument = /*#__PURE__*/ gql`
    mutation updateFestivalCompetition($input: UpdateFestivalCompetitionInput!, $locale: ID!) {
  updateFestivalCompetition(input: $input) {
    __typename
    id
    ...FestivalCompetitionIdentity
    ...FestivalCompetitionMetadata
  }
}
    ${FestivalCompetitionIdentityFragmentDoc}
${FestivalCompetitionMetadataFragmentDoc}`;
export type UpdateFestivalCompetitionMutationFn = Apollo.MutationFunction<Generated.UpdateFestivalCompetitionMutation, Generated.UpdateFestivalCompetitionMutationVariables>;

/**
 * __useUpdateFestivalCompetitionMutation__
 *
 * To run a mutation, you first call `useUpdateFestivalCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFestivalCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFestivalCompetitionMutation, { data, loading, error }] = useUpdateFestivalCompetitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateFestivalCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateFestivalCompetitionMutation, Generated.UpdateFestivalCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateFestivalCompetitionMutation, Generated.UpdateFestivalCompetitionMutationVariables>(UpdateFestivalCompetitionDocument, options);
      }
export type UpdateFestivalCompetitionMutationHookResult = ReturnType<typeof useUpdateFestivalCompetitionMutation>;
export type UpdateFestivalCompetitionMutationResult = Apollo.MutationResult<Generated.UpdateFestivalCompetitionMutation>;
export type UpdateFestivalCompetitionMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateFestivalCompetitionMutation, Generated.UpdateFestivalCompetitionMutationVariables>;
export const MoveFestivalJuryDocument = /*#__PURE__*/ gql`
    mutation moveFestivalJury($input: MoveFestivalJuryInput!) {
  moveFestivalJury(input: $input) {
    id
    rank
  }
}
    `;
export type MoveFestivalJuryMutationFn = Apollo.MutationFunction<Generated.MoveFestivalJuryMutation, Generated.MoveFestivalJuryMutationVariables>;

/**
 * __useMoveFestivalJuryMutation__
 *
 * To run a mutation, you first call `useMoveFestivalJuryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFestivalJuryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFestivalJuryMutation, { data, loading, error }] = useMoveFestivalJuryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveFestivalJuryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveFestivalJuryMutation, Generated.MoveFestivalJuryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveFestivalJuryMutation, Generated.MoveFestivalJuryMutationVariables>(MoveFestivalJuryDocument, options);
      }
export type MoveFestivalJuryMutationHookResult = ReturnType<typeof useMoveFestivalJuryMutation>;
export type MoveFestivalJuryMutationResult = Apollo.MutationResult<Generated.MoveFestivalJuryMutation>;
export type MoveFestivalJuryMutationOptions = Apollo.BaseMutationOptions<Generated.MoveFestivalJuryMutation, Generated.MoveFestivalJuryMutationVariables>;
export const GetFestivalEditionCompetitionsCategoriesDocument = /*#__PURE__*/ gql`
    query getFestivalEditionCompetitionsCategories($editionId: ID!) {
  festivalEditionCompetitions(editionId: $editionId) {
    __typename
    festivalCompetition {
      display
    }
  }
}
    `;

/**
 * __useGetFestivalEditionCompetitionsCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFestivalEditionCompetitionsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFestivalEditionCompetitionsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFestivalEditionCompetitionsCategoriesQuery({
 *   variables: {
 *      editionId: // value for 'editionId'
 *   },
 * });
 */
export function useGetFestivalEditionCompetitionsCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetFestivalEditionCompetitionsCategoriesQuery, Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables> & ({ variables: Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetFestivalEditionCompetitionsCategoriesQuery, Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables>(GetFestivalEditionCompetitionsCategoriesDocument, options);
      }
export function useGetFestivalEditionCompetitionsCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetFestivalEditionCompetitionsCategoriesQuery, Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetFestivalEditionCompetitionsCategoriesQuery, Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables>(GetFestivalEditionCompetitionsCategoriesDocument, options);
        }
export function useGetFestivalEditionCompetitionsCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetFestivalEditionCompetitionsCategoriesQuery, Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetFestivalEditionCompetitionsCategoriesQuery, Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables>(GetFestivalEditionCompetitionsCategoriesDocument, options);
        }
export type GetFestivalEditionCompetitionsCategoriesQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionsCategoriesQuery>;
export type GetFestivalEditionCompetitionsCategoriesLazyQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionsCategoriesLazyQuery>;
export type GetFestivalEditionCompetitionsCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetFestivalEditionCompetitionsCategoriesSuspenseQuery>;
export type GetFestivalEditionCompetitionsCategoriesQueryResult = Apollo.QueryResult<Generated.GetFestivalEditionCompetitionsCategoriesQuery, Generated.GetFestivalEditionCompetitionsCategoriesQueryVariables>;
export const UpdateFestivalAwardDocument = /*#__PURE__*/ gql`
    mutation updateFestivalAward($locale: ID!, $input: UpdateFestivalAwardInput!) {
  updateFestivalAward(input: $input) {
    id
    ...FestivalAward
  }
}
    ${FestivalAwardFragmentDoc}`;
export type UpdateFestivalAwardMutationFn = Apollo.MutationFunction<Generated.UpdateFestivalAwardMutation, Generated.UpdateFestivalAwardMutationVariables>;

/**
 * __useUpdateFestivalAwardMutation__
 *
 * To run a mutation, you first call `useUpdateFestivalAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFestivalAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFestivalAwardMutation, { data, loading, error }] = useUpdateFestivalAwardMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFestivalAwardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateFestivalAwardMutation, Generated.UpdateFestivalAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateFestivalAwardMutation, Generated.UpdateFestivalAwardMutationVariables>(UpdateFestivalAwardDocument, options);
      }
export type UpdateFestivalAwardMutationHookResult = ReturnType<typeof useUpdateFestivalAwardMutation>;
export type UpdateFestivalAwardMutationResult = Apollo.MutationResult<Generated.UpdateFestivalAwardMutation>;
export type UpdateFestivalAwardMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateFestivalAwardMutation, Generated.UpdateFestivalAwardMutationVariables>;
export const UpdateFestivalEditionCompetitionDocument = /*#__PURE__*/ gql`
    mutation updateFestivalEditionCompetition($input: UpdateFestivalEditionCompetitionInput!, $locale: ID!) {
  updateFestivalEditionCompetition(input: $input) {
    __typename
    id
    ...FestivalEditionCompetitionIdentity
    ...FestivalEditionCompetitionMetadata
  }
}
    ${FestivalEditionCompetitionIdentityFragmentDoc}
${FestivalEditionCompetitionMetadataFragmentDoc}`;
export type UpdateFestivalEditionCompetitionMutationFn = Apollo.MutationFunction<Generated.UpdateFestivalEditionCompetitionMutation, Generated.UpdateFestivalEditionCompetitionMutationVariables>;

/**
 * __useUpdateFestivalEditionCompetitionMutation__
 *
 * To run a mutation, you first call `useUpdateFestivalEditionCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFestivalEditionCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFestivalEditionCompetitionMutation, { data, loading, error }] = useUpdateFestivalEditionCompetitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateFestivalEditionCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateFestivalEditionCompetitionMutation, Generated.UpdateFestivalEditionCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateFestivalEditionCompetitionMutation, Generated.UpdateFestivalEditionCompetitionMutationVariables>(UpdateFestivalEditionCompetitionDocument, options);
      }
export type UpdateFestivalEditionCompetitionMutationHookResult = ReturnType<typeof useUpdateFestivalEditionCompetitionMutation>;
export type UpdateFestivalEditionCompetitionMutationResult = Apollo.MutationResult<Generated.UpdateFestivalEditionCompetitionMutation>;
export type UpdateFestivalEditionCompetitionMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateFestivalEditionCompetitionMutation, Generated.UpdateFestivalEditionCompetitionMutationVariables>;
export const UpdateFestivalEditionDocument = /*#__PURE__*/ gql`
    mutation updateFestivalEdition($input: UpdateFestivalEditionInput!, $locale: ID!) {
  updateFestivalEdition(input: $input) {
    id
    ...FestivalEditionIdentity
    ...FestivalEditionMetadata
  }
}
    ${FestivalEditionIdentityFragmentDoc}
${FestivalEditionMetadataFragmentDoc}`;
export type UpdateFestivalEditionMutationFn = Apollo.MutationFunction<Generated.UpdateFestivalEditionMutation, Generated.UpdateFestivalEditionMutationVariables>;

/**
 * __useUpdateFestivalEditionMutation__
 *
 * To run a mutation, you first call `useUpdateFestivalEditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFestivalEditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFestivalEditionMutation, { data, loading, error }] = useUpdateFestivalEditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateFestivalEditionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateFestivalEditionMutation, Generated.UpdateFestivalEditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateFestivalEditionMutation, Generated.UpdateFestivalEditionMutationVariables>(UpdateFestivalEditionDocument, options);
      }
export type UpdateFestivalEditionMutationHookResult = ReturnType<typeof useUpdateFestivalEditionMutation>;
export type UpdateFestivalEditionMutationResult = Apollo.MutationResult<Generated.UpdateFestivalEditionMutation>;
export type UpdateFestivalEditionMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateFestivalEditionMutation, Generated.UpdateFestivalEditionMutationVariables>;
export const UpdateFestivalSelectionDocument = /*#__PURE__*/ gql`
    mutation updateFestivalSelection($locale: ID!, $input: UpdateFestivalSelectionInput!) {
  updateFestivalSelection(input: $input) {
    ...FestivalSelection
  }
}
    ${FestivalSelectionFragmentDoc}`;
export type UpdateFestivalSelectionMutationFn = Apollo.MutationFunction<Generated.UpdateFestivalSelectionMutation, Generated.UpdateFestivalSelectionMutationVariables>;

/**
 * __useUpdateFestivalSelectionMutation__
 *
 * To run a mutation, you first call `useUpdateFestivalSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFestivalSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFestivalSelectionMutation, { data, loading, error }] = useUpdateFestivalSelectionMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFestivalSelectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateFestivalSelectionMutation, Generated.UpdateFestivalSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateFestivalSelectionMutation, Generated.UpdateFestivalSelectionMutationVariables>(UpdateFestivalSelectionDocument, options);
      }
export type UpdateFestivalSelectionMutationHookResult = ReturnType<typeof useUpdateFestivalSelectionMutation>;
export type UpdateFestivalSelectionMutationResult = Apollo.MutationResult<Generated.UpdateFestivalSelectionMutation>;
export type UpdateFestivalSelectionMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateFestivalSelectionMutation, Generated.UpdateFestivalSelectionMutationVariables>;
export const GetImageBrandedDataDocument = /*#__PURE__*/ gql`
    query getImageBrandedData($id: ID!, $brandId: ID!) {
  image(id: $id) {
    id
    type
    brandData(brandId: $brandId) {
      id
      active
      title
      description
      copyrightName
      copyrights {
        ...CopyrightIdentity
      }
      from
      to
    }
  }
}
    ${CopyrightIdentityFragmentDoc}`;

/**
 * __useGetImageBrandedDataQuery__
 *
 * To run a query within a React component, call `useGetImageBrandedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageBrandedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageBrandedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetImageBrandedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageBrandedDataQuery, Generated.GetImageBrandedDataQueryVariables> & ({ variables: Generated.GetImageBrandedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageBrandedDataQuery, Generated.GetImageBrandedDataQueryVariables>(GetImageBrandedDataDocument, options);
      }
export function useGetImageBrandedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageBrandedDataQuery, Generated.GetImageBrandedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageBrandedDataQuery, Generated.GetImageBrandedDataQueryVariables>(GetImageBrandedDataDocument, options);
        }
export function useGetImageBrandedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageBrandedDataQuery, Generated.GetImageBrandedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageBrandedDataQuery, Generated.GetImageBrandedDataQueryVariables>(GetImageBrandedDataDocument, options);
        }
export type GetImageBrandedDataQueryHookResult = ReturnType<typeof useGetImageBrandedDataQuery>;
export type GetImageBrandedDataLazyQueryHookResult = ReturnType<typeof useGetImageBrandedDataLazyQuery>;
export type GetImageBrandedDataSuspenseQueryHookResult = ReturnType<typeof useGetImageBrandedDataSuspenseQuery>;
export type GetImageBrandedDataQueryResult = Apollo.QueryResult<Generated.GetImageBrandedDataQuery, Generated.GetImageBrandedDataQueryVariables>;
export const GetImageB2bDataDocument = /*#__PURE__*/ gql`
    query getImageB2bData($id: ID!) {
  image(id: $id) {
    type
    available: b2bAvailable
    b2bCopyrightName
    b2bCopyrights {
      ...CopyrightIdentity
    }
  }
}
    ${CopyrightIdentityFragmentDoc}`;

/**
 * __useGetImageB2bDataQuery__
 *
 * To run a query within a React component, call `useGetImageB2bDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageB2bDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageB2bDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImageB2bDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageB2bDataQuery, Generated.GetImageB2bDataQueryVariables> & ({ variables: Generated.GetImageB2bDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageB2bDataQuery, Generated.GetImageB2bDataQueryVariables>(GetImageB2bDataDocument, options);
      }
export function useGetImageB2bDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageB2bDataQuery, Generated.GetImageB2bDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageB2bDataQuery, Generated.GetImageB2bDataQueryVariables>(GetImageB2bDataDocument, options);
        }
export function useGetImageB2bDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageB2bDataQuery, Generated.GetImageB2bDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageB2bDataQuery, Generated.GetImageB2bDataQueryVariables>(GetImageB2bDataDocument, options);
        }
export type GetImageB2bDataQueryHookResult = ReturnType<typeof useGetImageB2bDataQuery>;
export type GetImageB2bDataLazyQueryHookResult = ReturnType<typeof useGetImageB2bDataLazyQuery>;
export type GetImageB2bDataSuspenseQueryHookResult = ReturnType<typeof useGetImageB2bDataSuspenseQuery>;
export type GetImageB2bDataQueryResult = Apollo.QueryResult<Generated.GetImageB2bDataQuery, Generated.GetImageB2bDataQueryVariables>;
export const UpdateFestivalDocument = /*#__PURE__*/ gql`
    mutation updateFestival($input: UpdateFestivalInput!, $locale: ID!) {
  updateFestival(input: $input) {
    id
    ...FestivalIdentity
    ...FestivalMetadata
  }
}
    ${FestivalIdentityFragmentDoc}
${FestivalMetadataFragmentDoc}`;
export type UpdateFestivalMutationFn = Apollo.MutationFunction<Generated.UpdateFestivalMutation, Generated.UpdateFestivalMutationVariables>;

/**
 * __useUpdateFestivalMutation__
 *
 * To run a mutation, you first call `useUpdateFestivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFestivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFestivalMutation, { data, loading, error }] = useUpdateFestivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateFestivalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateFestivalMutation, Generated.UpdateFestivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateFestivalMutation, Generated.UpdateFestivalMutationVariables>(UpdateFestivalDocument, options);
      }
export type UpdateFestivalMutationHookResult = ReturnType<typeof useUpdateFestivalMutation>;
export type UpdateFestivalMutationResult = Apollo.MutationResult<Generated.UpdateFestivalMutation>;
export type UpdateFestivalMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateFestivalMutation, Generated.UpdateFestivalMutationVariables>;
export const GetImageDetailsDocument = /*#__PURE__*/ gql`
    query getImageDetails($imageId: ID!, $localeId: ID = "", $brandId: ID = "", $withBrand: Boolean = false, $withLocale: Boolean = false) {
  image(id: $imageId) {
    ...ImageDetails
  }
}
    ${ImageDetailsFragmentDoc}`;

/**
 * __useGetImageDetailsQuery__
 *
 * To run a query within a React component, call `useGetImageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageDetailsQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *      localeId: // value for 'localeId'
 *      brandId: // value for 'brandId'
 *      withBrand: // value for 'withBrand'
 *      withLocale: // value for 'withLocale'
 *   },
 * });
 */
export function useGetImageDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageDetailsQuery, Generated.GetImageDetailsQueryVariables> & ({ variables: Generated.GetImageDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageDetailsQuery, Generated.GetImageDetailsQueryVariables>(GetImageDetailsDocument, options);
      }
export function useGetImageDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageDetailsQuery, Generated.GetImageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageDetailsQuery, Generated.GetImageDetailsQueryVariables>(GetImageDetailsDocument, options);
        }
export function useGetImageDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageDetailsQuery, Generated.GetImageDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageDetailsQuery, Generated.GetImageDetailsQueryVariables>(GetImageDetailsDocument, options);
        }
export type GetImageDetailsQueryHookResult = ReturnType<typeof useGetImageDetailsQuery>;
export type GetImageDetailsLazyQueryHookResult = ReturnType<typeof useGetImageDetailsLazyQuery>;
export type GetImageDetailsSuspenseQueryHookResult = ReturnType<typeof useGetImageDetailsSuspenseQuery>;
export type GetImageDetailsQueryResult = Apollo.QueryResult<Generated.GetImageDetailsQuery, Generated.GetImageDetailsQueryVariables>;
export const GetImageIdentityDocument = /*#__PURE__*/ gql`
    query getImageIdentity($id: ID!) {
  image(id: $id) {
    ...ImageFullIdentity
  }
}
    ${ImageFullIdentityFragmentDoc}`;

/**
 * __useGetImageIdentityQuery__
 *
 * To run a query within a React component, call `useGetImageIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImageIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageIdentityQuery, Generated.GetImageIdentityQueryVariables> & ({ variables: Generated.GetImageIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageIdentityQuery, Generated.GetImageIdentityQueryVariables>(GetImageIdentityDocument, options);
      }
export function useGetImageIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageIdentityQuery, Generated.GetImageIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageIdentityQuery, Generated.GetImageIdentityQueryVariables>(GetImageIdentityDocument, options);
        }
export function useGetImageIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageIdentityQuery, Generated.GetImageIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageIdentityQuery, Generated.GetImageIdentityQueryVariables>(GetImageIdentityDocument, options);
        }
export type GetImageIdentityQueryHookResult = ReturnType<typeof useGetImageIdentityQuery>;
export type GetImageIdentityLazyQueryHookResult = ReturnType<typeof useGetImageIdentityLazyQuery>;
export type GetImageIdentitySuspenseQueryHookResult = ReturnType<typeof useGetImageIdentitySuspenseQuery>;
export type GetImageIdentityQueryResult = Apollo.QueryResult<Generated.GetImageIdentityQuery, Generated.GetImageIdentityQueryVariables>;
export const GetImageListDocument = /*#__PURE__*/ gql`
    query getImageList($limit: Int, $offset: Int!, $orderBy: ImageOrder!, $localeId: ID, $createdByUserId: ID, $updatedByUserId: ID, $imageId: String) {
  images(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    createdByUserId: $createdByUserId
    updatedByUserId: $updatedByUserId
    imageId: $imageId
  ) {
    totalCount
    nodes {
      ...ImageListItem
      hasLocalizedData(localeId: $localeId)
    }
  }
}
    ${ImageListItemFragmentDoc}`;

/**
 * __useGetImageListQuery__
 *
 * To run a query within a React component, call `useGetImageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      localeId: // value for 'localeId'
 *      createdByUserId: // value for 'createdByUserId'
 *      updatedByUserId: // value for 'updatedByUserId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useGetImageListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageListQuery, Generated.GetImageListQueryVariables> & ({ variables: Generated.GetImageListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageListQuery, Generated.GetImageListQueryVariables>(GetImageListDocument, options);
      }
export function useGetImageListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageListQuery, Generated.GetImageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageListQuery, Generated.GetImageListQueryVariables>(GetImageListDocument, options);
        }
export function useGetImageListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageListQuery, Generated.GetImageListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageListQuery, Generated.GetImageListQueryVariables>(GetImageListDocument, options);
        }
export type GetImageListQueryHookResult = ReturnType<typeof useGetImageListQuery>;
export type GetImageListLazyQueryHookResult = ReturnType<typeof useGetImageListLazyQuery>;
export type GetImageListSuspenseQueryHookResult = ReturnType<typeof useGetImageListSuspenseQuery>;
export type GetImageListQueryResult = Apollo.QueryResult<Generated.GetImageListQuery, Generated.GetImageListQueryVariables>;
export const GetImageMetadataDocument = /*#__PURE__*/ gql`
    query getImageMetadata($ref: ID!) {
  entityByRef(type: IMAGE, ref: $ref) {
    ... on Image {
      id
      ...ImageMetadata
      ...ImageMetadataNav
    }
  }
}
    ${ImageMetadataFragmentDoc}
${ImageMetadataNavFragmentDoc}`;

/**
 * __useGetImageMetadataQuery__
 *
 * To run a query within a React component, call `useGetImageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetImageMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageMetadataQuery, Generated.GetImageMetadataQueryVariables> & ({ variables: Generated.GetImageMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageMetadataQuery, Generated.GetImageMetadataQueryVariables>(GetImageMetadataDocument, options);
      }
export function useGetImageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageMetadataQuery, Generated.GetImageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageMetadataQuery, Generated.GetImageMetadataQueryVariables>(GetImageMetadataDocument, options);
        }
export function useGetImageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageMetadataQuery, Generated.GetImageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageMetadataQuery, Generated.GetImageMetadataQueryVariables>(GetImageMetadataDocument, options);
        }
export type GetImageMetadataQueryHookResult = ReturnType<typeof useGetImageMetadataQuery>;
export type GetImageMetadataLazyQueryHookResult = ReturnType<typeof useGetImageMetadataLazyQuery>;
export type GetImageMetadataSuspenseQueryHookResult = ReturnType<typeof useGetImageMetadataSuspenseQuery>;
export type GetImageMetadataQueryResult = Apollo.QueryResult<Generated.GetImageMetadataQuery, Generated.GetImageMetadataQueryVariables>;
export const GetImageRelatedEntitiesListDocument = /*#__PURE__*/ gql`
    query getImageRelatedEntitiesList($id: ID!) {
  image(id: $id) {
    id
    relatedEntities {
      ...ImageEntity
    }
  }
}
    ${ImageEntityFragmentDoc}`;

/**
 * __useGetImageRelatedEntitiesListQuery__
 *
 * To run a query within a React component, call `useGetImageRelatedEntitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageRelatedEntitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageRelatedEntitiesListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImageRelatedEntitiesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageRelatedEntitiesListQuery, Generated.GetImageRelatedEntitiesListQueryVariables> & ({ variables: Generated.GetImageRelatedEntitiesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageRelatedEntitiesListQuery, Generated.GetImageRelatedEntitiesListQueryVariables>(GetImageRelatedEntitiesListDocument, options);
      }
export function useGetImageRelatedEntitiesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageRelatedEntitiesListQuery, Generated.GetImageRelatedEntitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageRelatedEntitiesListQuery, Generated.GetImageRelatedEntitiesListQueryVariables>(GetImageRelatedEntitiesListDocument, options);
        }
export function useGetImageRelatedEntitiesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageRelatedEntitiesListQuery, Generated.GetImageRelatedEntitiesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageRelatedEntitiesListQuery, Generated.GetImageRelatedEntitiesListQueryVariables>(GetImageRelatedEntitiesListDocument, options);
        }
export type GetImageRelatedEntitiesListQueryHookResult = ReturnType<typeof useGetImageRelatedEntitiesListQuery>;
export type GetImageRelatedEntitiesListLazyQueryHookResult = ReturnType<typeof useGetImageRelatedEntitiesListLazyQuery>;
export type GetImageRelatedEntitiesListSuspenseQueryHookResult = ReturnType<typeof useGetImageRelatedEntitiesListSuspenseQuery>;
export type GetImageRelatedEntitiesListQueryResult = Apollo.QueryResult<Generated.GetImageRelatedEntitiesListQuery, Generated.GetImageRelatedEntitiesListQueryVariables>;
export const GetImageSuggestedLinksDocument = /*#__PURE__*/ gql`
    query getImageSuggestedLinks($id: ID!, $limit: Int = 30) {
  entity(id: $id) {
    __typename
    ... on Movie {
      credits(limit: $limit, offset: 0, activities: [ACTOR_ACTOR]) {
        nodes {
          ...ImageSuggestedLinksCasting
        }
      }
    }
    ... on Series {
      credits(
        limit: $limit
        offset: 0
        activities: [STORYLINE_CREATOR, STORYLINE_BASED_ON]
      ) {
        nodes {
          ...ImageSuggestedLinksCasting
        }
      }
    }
    ... on SeriesSeason {
      credits(limit: $limit, offset: 0, activities: [ACTOR_ACTOR]) {
        nodes {
          ...ImageSuggestedLinksCasting
        }
      }
    }
    ... on SeriesEpisode {
      credits(limit: $limit, offset: 0, activities: [ACTOR_ACTOR]) {
        nodes {
          ...ImageSuggestedLinksCasting
        }
      }
      season {
        credits(limit: $limit, offset: 0, activities: [ACTOR_ACTOR]) {
          nodes {
            ...ImageSuggestedLinksCasting
          }
        }
      }
    }
  }
}
    ${ImageSuggestedLinksCastingFragmentDoc}`;

/**
 * __useGetImageSuggestedLinksQuery__
 *
 * To run a query within a React component, call `useGetImageSuggestedLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageSuggestedLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageSuggestedLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetImageSuggestedLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImageSuggestedLinksQuery, Generated.GetImageSuggestedLinksQueryVariables> & ({ variables: Generated.GetImageSuggestedLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageSuggestedLinksQuery, Generated.GetImageSuggestedLinksQueryVariables>(GetImageSuggestedLinksDocument, options);
      }
export function useGetImageSuggestedLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageSuggestedLinksQuery, Generated.GetImageSuggestedLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageSuggestedLinksQuery, Generated.GetImageSuggestedLinksQueryVariables>(GetImageSuggestedLinksDocument, options);
        }
export function useGetImageSuggestedLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageSuggestedLinksQuery, Generated.GetImageSuggestedLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageSuggestedLinksQuery, Generated.GetImageSuggestedLinksQueryVariables>(GetImageSuggestedLinksDocument, options);
        }
export type GetImageSuggestedLinksQueryHookResult = ReturnType<typeof useGetImageSuggestedLinksQuery>;
export type GetImageSuggestedLinksLazyQueryHookResult = ReturnType<typeof useGetImageSuggestedLinksLazyQuery>;
export type GetImageSuggestedLinksSuspenseQueryHookResult = ReturnType<typeof useGetImageSuggestedLinksSuspenseQuery>;
export type GetImageSuggestedLinksQueryResult = Apollo.QueryResult<Generated.GetImageSuggestedLinksQuery, Generated.GetImageSuggestedLinksQueryVariables>;
export const LinkEntityToImageDocument = /*#__PURE__*/ gql`
    mutation linkEntityToImage($input: LinkEntityToImageInput!) {
  linkEntityToImage(input: $input) {
    __typename
  }
}
    `;
export type LinkEntityToImageMutationFn = Apollo.MutationFunction<Generated.LinkEntityToImageMutation, Generated.LinkEntityToImageMutationVariables>;

/**
 * __useLinkEntityToImageMutation__
 *
 * To run a mutation, you first call `useLinkEntityToImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEntityToImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEntityToImageMutation, { data, loading, error }] = useLinkEntityToImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkEntityToImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkEntityToImageMutation, Generated.LinkEntityToImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkEntityToImageMutation, Generated.LinkEntityToImageMutationVariables>(LinkEntityToImageDocument, options);
      }
export type LinkEntityToImageMutationHookResult = ReturnType<typeof useLinkEntityToImageMutation>;
export type LinkEntityToImageMutationResult = Apollo.MutationResult<Generated.LinkEntityToImageMutation>;
export type LinkEntityToImageMutationOptions = Apollo.BaseMutationOptions<Generated.LinkEntityToImageMutation, Generated.LinkEntityToImageMutationVariables>;
export const MoveEntityImageDocument = /*#__PURE__*/ gql`
    mutation moveEntityImage($input: MoveEntityImageInput!) {
  moveEntityImage(input: $input) {
    ...ImageEntity
  }
}
    ${ImageEntityFragmentDoc}`;
export type MoveEntityImageMutationFn = Apollo.MutationFunction<Generated.MoveEntityImageMutation, Generated.MoveEntityImageMutationVariables>;

/**
 * __useMoveEntityImageMutation__
 *
 * To run a mutation, you first call `useMoveEntityImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveEntityImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveEntityImageMutation, { data, loading, error }] = useMoveEntityImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveEntityImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveEntityImageMutation, Generated.MoveEntityImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveEntityImageMutation, Generated.MoveEntityImageMutationVariables>(MoveEntityImageDocument, options);
      }
export type MoveEntityImageMutationHookResult = ReturnType<typeof useMoveEntityImageMutation>;
export type MoveEntityImageMutationResult = Apollo.MutationResult<Generated.MoveEntityImageMutation>;
export type MoveEntityImageMutationOptions = Apollo.BaseMutationOptions<Generated.MoveEntityImageMutation, Generated.MoveEntityImageMutationVariables>;
export const UnlinkEntityFromImageDocument = /*#__PURE__*/ gql`
    mutation unlinkEntityFromImage($input: UnlinkEntityFromImageInput!) {
  unlinkEntityFromImage(input: $input) {
    __typename
  }
}
    `;
export type UnlinkEntityFromImageMutationFn = Apollo.MutationFunction<Generated.UnlinkEntityFromImageMutation, Generated.UnlinkEntityFromImageMutationVariables>;

/**
 * __useUnlinkEntityFromImageMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityFromImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityFromImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityFromImageMutation, { data, loading, error }] = useUnlinkEntityFromImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkEntityFromImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkEntityFromImageMutation, Generated.UnlinkEntityFromImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkEntityFromImageMutation, Generated.UnlinkEntityFromImageMutationVariables>(UnlinkEntityFromImageDocument, options);
      }
export type UnlinkEntityFromImageMutationHookResult = ReturnType<typeof useUnlinkEntityFromImageMutation>;
export type UnlinkEntityFromImageMutationResult = Apollo.MutationResult<Generated.UnlinkEntityFromImageMutation>;
export type UnlinkEntityFromImageMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkEntityFromImageMutation, Generated.UnlinkEntityFromImageMutationVariables>;
export const UpdateImageB2bDataDocument = /*#__PURE__*/ gql`
    mutation updateImageB2bData($input: UpdateImageB2bDataInput!) {
  updateImageB2bData(input: $input) {
    id
    available: b2bAvailable
    b2bCopyrightName
    b2bCopyrights {
      ...CopyrightIdentity
    }
  }
}
    ${CopyrightIdentityFragmentDoc}`;
export type UpdateImageB2bDataMutationFn = Apollo.MutationFunction<Generated.UpdateImageB2bDataMutation, Generated.UpdateImageB2bDataMutationVariables>;

/**
 * __useUpdateImageB2bDataMutation__
 *
 * To run a mutation, you first call `useUpdateImageB2bDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageB2bDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageB2bDataMutation, { data, loading, error }] = useUpdateImageB2bDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageB2bDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImageB2bDataMutation, Generated.UpdateImageB2bDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImageB2bDataMutation, Generated.UpdateImageB2bDataMutationVariables>(UpdateImageB2bDataDocument, options);
      }
export type UpdateImageB2bDataMutationHookResult = ReturnType<typeof useUpdateImageB2bDataMutation>;
export type UpdateImageB2bDataMutationResult = Apollo.MutationResult<Generated.UpdateImageB2bDataMutation>;
export type UpdateImageB2bDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImageB2bDataMutation, Generated.UpdateImageB2bDataMutationVariables>;
export const UpdateImageLocaleDataDocument = /*#__PURE__*/ gql`
    mutation updateImageLocaleData($input: UpdateImageLocaleDataInput!) {
  updateImageLocaleData(input: $input) {
    ...ImageLocalizedIdentity
  }
}
    ${ImageLocalizedIdentityFragmentDoc}`;
export type UpdateImageLocaleDataMutationFn = Apollo.MutationFunction<Generated.UpdateImageLocaleDataMutation, Generated.UpdateImageLocaleDataMutationVariables>;

/**
 * __useUpdateImageLocaleDataMutation__
 *
 * To run a mutation, you first call `useUpdateImageLocaleDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageLocaleDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageLocaleDataMutation, { data, loading, error }] = useUpdateImageLocaleDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageLocaleDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImageLocaleDataMutation, Generated.UpdateImageLocaleDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImageLocaleDataMutation, Generated.UpdateImageLocaleDataMutationVariables>(UpdateImageLocaleDataDocument, options);
      }
export type UpdateImageLocaleDataMutationHookResult = ReturnType<typeof useUpdateImageLocaleDataMutation>;
export type UpdateImageLocaleDataMutationResult = Apollo.MutationResult<Generated.UpdateImageLocaleDataMutation>;
export type UpdateImageLocaleDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImageLocaleDataMutation, Generated.UpdateImageLocaleDataMutationVariables>;
export const UpdateImageBrandedDataDocument = /*#__PURE__*/ gql`
    mutation updateImageBrandedData($input: UpdateImageBrandDataInput!) {
  updateImageBrandData(input: $input) {
    id
    active
    title
    description
    copyrightName
    copyrights {
      ...CopyrightIdentity
    }
    from
    to
    brand {
      ...BrandOption
    }
  }
}
    ${CopyrightIdentityFragmentDoc}
${BrandOptionFragmentDoc}`;
export type UpdateImageBrandedDataMutationFn = Apollo.MutationFunction<Generated.UpdateImageBrandedDataMutation, Generated.UpdateImageBrandedDataMutationVariables>;

/**
 * __useUpdateImageBrandedDataMutation__
 *
 * To run a mutation, you first call `useUpdateImageBrandedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageBrandedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageBrandedDataMutation, { data, loading, error }] = useUpdateImageBrandedDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageBrandedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImageBrandedDataMutation, Generated.UpdateImageBrandedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImageBrandedDataMutation, Generated.UpdateImageBrandedDataMutationVariables>(UpdateImageBrandedDataDocument, options);
      }
export type UpdateImageBrandedDataMutationHookResult = ReturnType<typeof useUpdateImageBrandedDataMutation>;
export type UpdateImageBrandedDataMutationResult = Apollo.MutationResult<Generated.UpdateImageBrandedDataMutation>;
export type UpdateImageBrandedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImageBrandedDataMutation, Generated.UpdateImageBrandedDataMutationVariables>;
export const UpdateImageDocument = /*#__PURE__*/ gql`
    mutation updateImage($input: UpdateImageInput!) {
  updateImage(input: $input) {
    id
    ...ImageFullIdentity
    ...ImageMetadata
  }
}
    ${ImageFullIdentityFragmentDoc}
${ImageMetadataFragmentDoc}`;
export type UpdateImageMutationFn = Apollo.MutationFunction<Generated.UpdateImageMutation, Generated.UpdateImageMutationVariables>;

/**
 * __useUpdateImageMutation__
 *
 * To run a mutation, you first call `useUpdateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageMutation, { data, loading, error }] = useUpdateImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImageMutation, Generated.UpdateImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImageMutation, Generated.UpdateImageMutationVariables>(UpdateImageDocument, options);
      }
export type UpdateImageMutationHookResult = ReturnType<typeof useUpdateImageMutation>;
export type UpdateImageMutationResult = Apollo.MutationResult<Generated.UpdateImageMutation>;
export type UpdateImageMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImageMutation, Generated.UpdateImageMutationVariables>;
export const GetImportWizardDashboardDocument = /*#__PURE__*/ gql`
    query getImportWizardDashboard($from: DateTime!, $to: DateTime!, $timeZone: String!, $source: PersonCreditsImportSource) {
  importWizardDashboard(
    from: $from
    to: $to
    timeZone: $timeZone
    source: $source
  ) {
    totals {
      ...ImportWizardDashboardTotals
    }
    previousTotals {
      ...ImportWizardDashboardTotals
    }
    running {
      active
      stale
    }
    perDay {
      day
      completed
      failed
      llmCostUsd
    }
    byLevel {
      level
      runs
      durationMedianMs
    }
    byModel {
      provider
      model
      runs
      llmCostUsd
    }
    nothingReturned {
      kind
      runs
    }
    bySource {
      source
      runs
    }
    byUser {
      user {
        id
        name
      }
      runs
    }
  }
}
    ${ImportWizardDashboardTotalsFragmentDoc}`;

/**
 * __useGetImportWizardDashboardQuery__
 *
 * To run a query within a React component, call `useGetImportWizardDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportWizardDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportWizardDashboardQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timeZone: // value for 'timeZone'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetImportWizardDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImportWizardDashboardQuery, Generated.GetImportWizardDashboardQueryVariables> & ({ variables: Generated.GetImportWizardDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImportWizardDashboardQuery, Generated.GetImportWizardDashboardQueryVariables>(GetImportWizardDashboardDocument, options);
      }
export function useGetImportWizardDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImportWizardDashboardQuery, Generated.GetImportWizardDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImportWizardDashboardQuery, Generated.GetImportWizardDashboardQueryVariables>(GetImportWizardDashboardDocument, options);
        }
export function useGetImportWizardDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImportWizardDashboardQuery, Generated.GetImportWizardDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImportWizardDashboardQuery, Generated.GetImportWizardDashboardQueryVariables>(GetImportWizardDashboardDocument, options);
        }
export type GetImportWizardDashboardQueryHookResult = ReturnType<typeof useGetImportWizardDashboardQuery>;
export type GetImportWizardDashboardLazyQueryHookResult = ReturnType<typeof useGetImportWizardDashboardLazyQuery>;
export type GetImportWizardDashboardSuspenseQueryHookResult = ReturnType<typeof useGetImportWizardDashboardSuspenseQuery>;
export type GetImportWizardDashboardQueryResult = Apollo.QueryResult<Generated.GetImportWizardDashboardQuery, Generated.GetImportWizardDashboardQueryVariables>;
export const GetImportWizardReportsDocument = /*#__PURE__*/ gql`
    query getImportWizardReports($filter: ImportWizardReportFilter, $order: ImportWizardReportOrder, $offset: Int, $limit: Int) {
  importWizardReports(
    filter: $filter
    order: $order
    offset: $offset
    limit: $limit
  ) {
    totalCount
    nodes {
      id
      status
      failureReason
      outcome
      answeredBy
      launchedAt
      finishedAt
      source
      isRemovedFromHistory
      isStale
      creditsCount
      metadata {
        createdBy {
          id
          name
        }
      }
      stats {
        durationMs
        requests
        llm {
          provider
          model
          inputTokens
          outputTokens
          costUsd
        }
      }
      localization {
        outcome
        durationMs
        llm {
          provider
          model
          inputTokens
          outputTokens
          costUsd
        }
      }
      entity {
        ...ImportWizardRunEntity
      }
    }
  }
}
    ${ImportWizardRunEntityFragmentDoc}`;

/**
 * __useGetImportWizardReportsQuery__
 *
 * To run a query within a React component, call `useGetImportWizardReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportWizardReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportWizardReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetImportWizardReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetImportWizardReportsQuery, Generated.GetImportWizardReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImportWizardReportsQuery, Generated.GetImportWizardReportsQueryVariables>(GetImportWizardReportsDocument, options);
      }
export function useGetImportWizardReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImportWizardReportsQuery, Generated.GetImportWizardReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImportWizardReportsQuery, Generated.GetImportWizardReportsQueryVariables>(GetImportWizardReportsDocument, options);
        }
export function useGetImportWizardReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImportWizardReportsQuery, Generated.GetImportWizardReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImportWizardReportsQuery, Generated.GetImportWizardReportsQueryVariables>(GetImportWizardReportsDocument, options);
        }
export type GetImportWizardReportsQueryHookResult = ReturnType<typeof useGetImportWizardReportsQuery>;
export type GetImportWizardReportsLazyQueryHookResult = ReturnType<typeof useGetImportWizardReportsLazyQuery>;
export type GetImportWizardReportsSuspenseQueryHookResult = ReturnType<typeof useGetImportWizardReportsSuspenseQuery>;
export type GetImportWizardReportsQueryResult = Apollo.QueryResult<Generated.GetImportWizardReportsQuery, Generated.GetImportWizardReportsQueryVariables>;
export const GetImportWizardReportDocument = /*#__PURE__*/ gql`
    query getImportWizardReport($id: ID!) {
  importWizardReport(id: $id) {
    ...PersonCreditsImportReport
    ...PersonCreditsImportReportSummary
    entityType
    entity {
      ...ImportWizardRunEntity
    }
  }
}
    ${PersonCreditsImportReportFragmentDoc}
${PersonCreditsImportReportSummaryFragmentDoc}
${ImportWizardRunEntityFragmentDoc}`;

/**
 * __useGetImportWizardReportQuery__
 *
 * To run a query within a React component, call `useGetImportWizardReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportWizardReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportWizardReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportWizardReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetImportWizardReportQuery, Generated.GetImportWizardReportQueryVariables> & ({ variables: Generated.GetImportWizardReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImportWizardReportQuery, Generated.GetImportWizardReportQueryVariables>(GetImportWizardReportDocument, options);
      }
export function useGetImportWizardReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImportWizardReportQuery, Generated.GetImportWizardReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImportWizardReportQuery, Generated.GetImportWizardReportQueryVariables>(GetImportWizardReportDocument, options);
        }
export function useGetImportWizardReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImportWizardReportQuery, Generated.GetImportWizardReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImportWizardReportQuery, Generated.GetImportWizardReportQueryVariables>(GetImportWizardReportDocument, options);
        }
export type GetImportWizardReportQueryHookResult = ReturnType<typeof useGetImportWizardReportQuery>;
export type GetImportWizardReportLazyQueryHookResult = ReturnType<typeof useGetImportWizardReportLazyQuery>;
export type GetImportWizardReportSuspenseQueryHookResult = ReturnType<typeof useGetImportWizardReportSuspenseQuery>;
export type GetImportWizardReportQueryResult = Apollo.QueryResult<Generated.GetImportWizardReportQuery, Generated.GetImportWizardReportQueryVariables>;
export const GetPersonCreditsImportUnmappedJobsDocument = /*#__PURE__*/ gql`
    query GetPersonCreditsImportUnmappedJobs {
  personCreditsImportUnmappedJobs {
    source
    category
    job
    occurrences
    entities
    fallbackActivity
    lastSeenAt
  }
}
    `;

/**
 * __useGetPersonCreditsImportUnmappedJobsQuery__
 *
 * To run a query within a React component, call `useGetPersonCreditsImportUnmappedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonCreditsImportUnmappedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonCreditsImportUnmappedJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonCreditsImportUnmappedJobsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetPersonCreditsImportUnmappedJobsQuery, Generated.GetPersonCreditsImportUnmappedJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonCreditsImportUnmappedJobsQuery, Generated.GetPersonCreditsImportUnmappedJobsQueryVariables>(GetPersonCreditsImportUnmappedJobsDocument, options);
      }
export function useGetPersonCreditsImportUnmappedJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonCreditsImportUnmappedJobsQuery, Generated.GetPersonCreditsImportUnmappedJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonCreditsImportUnmappedJobsQuery, Generated.GetPersonCreditsImportUnmappedJobsQueryVariables>(GetPersonCreditsImportUnmappedJobsDocument, options);
        }
export function useGetPersonCreditsImportUnmappedJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonCreditsImportUnmappedJobsQuery, Generated.GetPersonCreditsImportUnmappedJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonCreditsImportUnmappedJobsQuery, Generated.GetPersonCreditsImportUnmappedJobsQueryVariables>(GetPersonCreditsImportUnmappedJobsDocument, options);
        }
export type GetPersonCreditsImportUnmappedJobsQueryHookResult = ReturnType<typeof useGetPersonCreditsImportUnmappedJobsQuery>;
export type GetPersonCreditsImportUnmappedJobsLazyQueryHookResult = ReturnType<typeof useGetPersonCreditsImportUnmappedJobsLazyQuery>;
export type GetPersonCreditsImportUnmappedJobsSuspenseQueryHookResult = ReturnType<typeof useGetPersonCreditsImportUnmappedJobsSuspenseQuery>;
export type GetPersonCreditsImportUnmappedJobsQueryResult = Apollo.QueryResult<Generated.GetPersonCreditsImportUnmappedJobsQuery, Generated.GetPersonCreditsImportUnmappedJobsQueryVariables>;
export const CreateImportConfigurationDocument = /*#__PURE__*/ gql`
    mutation CreateImportConfiguration($input: CreateImportConfigurationInput!) {
  createImportConfiguration(input: $input) {
    id
  }
}
    `;
export type CreateImportConfigurationMutationFn = Apollo.MutationFunction<Generated.CreateImportConfigurationMutation, Generated.CreateImportConfigurationMutationVariables>;

/**
 * __useCreateImportConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateImportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportConfigurationMutation, { data, loading, error }] = useCreateImportConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImportConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateImportConfigurationMutation, Generated.CreateImportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateImportConfigurationMutation, Generated.CreateImportConfigurationMutationVariables>(CreateImportConfigurationDocument, options);
      }
export type CreateImportConfigurationMutationHookResult = ReturnType<typeof useCreateImportConfigurationMutation>;
export type CreateImportConfigurationMutationResult = Apollo.MutationResult<Generated.CreateImportConfigurationMutation>;
export type CreateImportConfigurationMutationOptions = Apollo.BaseMutationOptions<Generated.CreateImportConfigurationMutation, Generated.CreateImportConfigurationMutationVariables>;
export const CreateImportConfigurationsFromCsvDocument = /*#__PURE__*/ gql`
    mutation CreateImportConfigurationsFromCSV($input: CreateImportConfigurationsFromCSVInput!) {
  createImportConfigurationsFromCSV(input: $input)
}
    `;
export type CreateImportConfigurationsFromCsvMutationFn = Apollo.MutationFunction<Generated.CreateImportConfigurationsFromCsvMutation, Generated.CreateImportConfigurationsFromCsvMutationVariables>;

/**
 * __useCreateImportConfigurationsFromCsvMutation__
 *
 * To run a mutation, you first call `useCreateImportConfigurationsFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportConfigurationsFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportConfigurationsFromCsvMutation, { data, loading, error }] = useCreateImportConfigurationsFromCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImportConfigurationsFromCsvMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateImportConfigurationsFromCsvMutation, Generated.CreateImportConfigurationsFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateImportConfigurationsFromCsvMutation, Generated.CreateImportConfigurationsFromCsvMutationVariables>(CreateImportConfigurationsFromCsvDocument, options);
      }
export type CreateImportConfigurationsFromCsvMutationHookResult = ReturnType<typeof useCreateImportConfigurationsFromCsvMutation>;
export type CreateImportConfigurationsFromCsvMutationResult = Apollo.MutationResult<Generated.CreateImportConfigurationsFromCsvMutation>;
export type CreateImportConfigurationsFromCsvMutationOptions = Apollo.BaseMutationOptions<Generated.CreateImportConfigurationsFromCsvMutation, Generated.CreateImportConfigurationsFromCsvMutationVariables>;
export const BatchImportConfigurationOperationDocument = /*#__PURE__*/ gql`
    mutation BatchImportConfigurationOperation($input: BatchImportConfigurationOperationInput!) {
  batchImportConfigurationOperation(input: $input) {
    id
    enabled
    nextRun
  }
}
    `;
export type BatchImportConfigurationOperationMutationFn = Apollo.MutationFunction<Generated.BatchImportConfigurationOperationMutation, Generated.BatchImportConfigurationOperationMutationVariables>;

/**
 * __useBatchImportConfigurationOperationMutation__
 *
 * To run a mutation, you first call `useBatchImportConfigurationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchImportConfigurationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchImportConfigurationOperationMutation, { data, loading, error }] = useBatchImportConfigurationOperationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchImportConfigurationOperationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.BatchImportConfigurationOperationMutation, Generated.BatchImportConfigurationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.BatchImportConfigurationOperationMutation, Generated.BatchImportConfigurationOperationMutationVariables>(BatchImportConfigurationOperationDocument, options);
      }
export type BatchImportConfigurationOperationMutationHookResult = ReturnType<typeof useBatchImportConfigurationOperationMutation>;
export type BatchImportConfigurationOperationMutationResult = Apollo.MutationResult<Generated.BatchImportConfigurationOperationMutation>;
export type BatchImportConfigurationOperationMutationOptions = Apollo.BaseMutationOptions<Generated.BatchImportConfigurationOperationMutation, Generated.BatchImportConfigurationOperationMutationVariables>;
export const CreateImportCrawlerDocument = /*#__PURE__*/ gql`
    mutation CreateImportCrawler($input: CreateImportCrawlerInput!) {
  createImportCrawler(input: $input) {
    id
    name
  }
}
    `;
export type CreateImportCrawlerMutationFn = Apollo.MutationFunction<Generated.CreateImportCrawlerMutation, Generated.CreateImportCrawlerMutationVariables>;

/**
 * __useCreateImportCrawlerMutation__
 *
 * To run a mutation, you first call `useCreateImportCrawlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportCrawlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportCrawlerMutation, { data, loading, error }] = useCreateImportCrawlerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImportCrawlerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateImportCrawlerMutation, Generated.CreateImportCrawlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateImportCrawlerMutation, Generated.CreateImportCrawlerMutationVariables>(CreateImportCrawlerDocument, options);
      }
export type CreateImportCrawlerMutationHookResult = ReturnType<typeof useCreateImportCrawlerMutation>;
export type CreateImportCrawlerMutationResult = Apollo.MutationResult<Generated.CreateImportCrawlerMutation>;
export type CreateImportCrawlerMutationOptions = Apollo.BaseMutationOptions<Generated.CreateImportCrawlerMutation, Generated.CreateImportCrawlerMutationVariables>;
export const DeleteImportConfigurationDocument = /*#__PURE__*/ gql`
    mutation DeleteImportConfiguration($input: DeleteImportConfigurationInput!) {
  deleteImportConfiguration(input: $input) {
    id
  }
}
    `;
export type DeleteImportConfigurationMutationFn = Apollo.MutationFunction<Generated.DeleteImportConfigurationMutation, Generated.DeleteImportConfigurationMutationVariables>;

/**
 * __useDeleteImportConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteImportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportConfigurationMutation, { data, loading, error }] = useDeleteImportConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteImportConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteImportConfigurationMutation, Generated.DeleteImportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteImportConfigurationMutation, Generated.DeleteImportConfigurationMutationVariables>(DeleteImportConfigurationDocument, options);
      }
export type DeleteImportConfigurationMutationHookResult = ReturnType<typeof useDeleteImportConfigurationMutation>;
export type DeleteImportConfigurationMutationResult = Apollo.MutationResult<Generated.DeleteImportConfigurationMutation>;
export type DeleteImportConfigurationMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteImportConfigurationMutation, Generated.DeleteImportConfigurationMutationVariables>;
export const DeleteImportShowtimesStatsDocument = /*#__PURE__*/ gql`
    query DeleteImportShowtimesStats($theaterId: ID!, $entityId: ID, $range: DateRangeInput) {
  deleteImportShowtimesStats(
    theaterId: $theaterId
    entityId: $entityId
    range: $range
  ) {
    totalCount
  }
}
    `;

/**
 * __useDeleteImportShowtimesStatsQuery__
 *
 * To run a query within a React component, call `useDeleteImportShowtimesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportShowtimesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteImportShowtimesStatsQuery({
 *   variables: {
 *      theaterId: // value for 'theaterId'
 *      entityId: // value for 'entityId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useDeleteImportShowtimesStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.DeleteImportShowtimesStatsQuery, Generated.DeleteImportShowtimesStatsQueryVariables> & ({ variables: Generated.DeleteImportShowtimesStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.DeleteImportShowtimesStatsQuery, Generated.DeleteImportShowtimesStatsQueryVariables>(DeleteImportShowtimesStatsDocument, options);
      }
export function useDeleteImportShowtimesStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.DeleteImportShowtimesStatsQuery, Generated.DeleteImportShowtimesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.DeleteImportShowtimesStatsQuery, Generated.DeleteImportShowtimesStatsQueryVariables>(DeleteImportShowtimesStatsDocument, options);
        }
export function useDeleteImportShowtimesStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.DeleteImportShowtimesStatsQuery, Generated.DeleteImportShowtimesStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.DeleteImportShowtimesStatsQuery, Generated.DeleteImportShowtimesStatsQueryVariables>(DeleteImportShowtimesStatsDocument, options);
        }
export type DeleteImportShowtimesStatsQueryHookResult = ReturnType<typeof useDeleteImportShowtimesStatsQuery>;
export type DeleteImportShowtimesStatsLazyQueryHookResult = ReturnType<typeof useDeleteImportShowtimesStatsLazyQuery>;
export type DeleteImportShowtimesStatsSuspenseQueryHookResult = ReturnType<typeof useDeleteImportShowtimesStatsSuspenseQuery>;
export type DeleteImportShowtimesStatsQueryResult = Apollo.QueryResult<Generated.DeleteImportShowtimesStatsQuery, Generated.DeleteImportShowtimesStatsQueryVariables>;
export const DeleteImportShowtimesDocument = /*#__PURE__*/ gql`
    mutation DeleteImportShowtimes($input: DeleteImportShowtimesInput!) {
  deleteImportShowtimes(input: $input) {
    totalCount
  }
}
    `;
export type DeleteImportShowtimesMutationFn = Apollo.MutationFunction<Generated.DeleteImportShowtimesMutation, Generated.DeleteImportShowtimesMutationVariables>;

/**
 * __useDeleteImportShowtimesMutation__
 *
 * To run a mutation, you first call `useDeleteImportShowtimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportShowtimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportShowtimesMutation, { data, loading, error }] = useDeleteImportShowtimesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteImportShowtimesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteImportShowtimesMutation, Generated.DeleteImportShowtimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteImportShowtimesMutation, Generated.DeleteImportShowtimesMutationVariables>(DeleteImportShowtimesDocument, options);
      }
export type DeleteImportShowtimesMutationHookResult = ReturnType<typeof useDeleteImportShowtimesMutation>;
export type DeleteImportShowtimesMutationResult = Apollo.MutationResult<Generated.DeleteImportShowtimesMutation>;
export type DeleteImportShowtimesMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteImportShowtimesMutation, Generated.DeleteImportShowtimesMutationVariables>;
export const DeleteImportCrawlerDocument = /*#__PURE__*/ gql`
    mutation deleteImportCrawler($crawlerId: ID!) {
  deleteImportCrawler(input: {crawlerId: $crawlerId}) {
    id
    name
  }
}
    `;
export type DeleteImportCrawlerMutationFn = Apollo.MutationFunction<Generated.DeleteImportCrawlerMutation, Generated.DeleteImportCrawlerMutationVariables>;

/**
 * __useDeleteImportCrawlerMutation__
 *
 * To run a mutation, you first call `useDeleteImportCrawlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportCrawlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportCrawlerMutation, { data, loading, error }] = useDeleteImportCrawlerMutation({
 *   variables: {
 *      crawlerId: // value for 'crawlerId'
 *   },
 * });
 */
export function useDeleteImportCrawlerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteImportCrawlerMutation, Generated.DeleteImportCrawlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteImportCrawlerMutation, Generated.DeleteImportCrawlerMutationVariables>(DeleteImportCrawlerDocument, options);
      }
export type DeleteImportCrawlerMutationHookResult = ReturnType<typeof useDeleteImportCrawlerMutation>;
export type DeleteImportCrawlerMutationResult = Apollo.MutationResult<Generated.DeleteImportCrawlerMutation>;
export type DeleteImportCrawlerMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteImportCrawlerMutation, Generated.DeleteImportCrawlerMutationVariables>;
export const ImportConfigurationDocument = /*#__PURE__*/ gql`
    query ImportConfiguration($id: ID!) {
  importConfiguration(id: $id) {
    id
    metadata {
      ...Metadata
    }
    lastRun {
      ...ImportRunRow
    }
    ...ImportConfigurationIdentity
    ...ImportConfigurationStats
  }
}
    ${MetadataFragmentDoc}
${ImportRunRowFragmentDoc}
${ImportConfigurationIdentityFragmentDoc}
${ImportConfigurationStatsFragmentDoc}`;

/**
 * __useImportConfigurationQuery__
 *
 * To run a query within a React component, call `useImportConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportConfigurationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportConfigurationQuery, Generated.ImportConfigurationQueryVariables> & ({ variables: Generated.ImportConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportConfigurationQuery, Generated.ImportConfigurationQueryVariables>(ImportConfigurationDocument, options);
      }
export function useImportConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportConfigurationQuery, Generated.ImportConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportConfigurationQuery, Generated.ImportConfigurationQueryVariables>(ImportConfigurationDocument, options);
        }
export function useImportConfigurationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportConfigurationQuery, Generated.ImportConfigurationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportConfigurationQuery, Generated.ImportConfigurationQueryVariables>(ImportConfigurationDocument, options);
        }
export type ImportConfigurationQueryHookResult = ReturnType<typeof useImportConfigurationQuery>;
export type ImportConfigurationLazyQueryHookResult = ReturnType<typeof useImportConfigurationLazyQuery>;
export type ImportConfigurationSuspenseQueryHookResult = ReturnType<typeof useImportConfigurationSuspenseQuery>;
export type ImportConfigurationQueryResult = Apollo.QueryResult<Generated.ImportConfigurationQuery, Generated.ImportConfigurationQueryVariables>;
export const ImportConfigurationRunsDocument = /*#__PURE__*/ gql`
    query ImportConfigurationRuns($id: ID!, $limit: Int!, $offset: Int!, $lastStep: ImportRunStepType) {
  importConfiguration(id: $id) {
    id
    runs(lastStep: $lastStep, offset: $offset, limit: $limit) {
      totalCount
      nodes {
        ...ImportRunRow
      }
    }
  }
}
    ${ImportRunRowFragmentDoc}`;

/**
 * __useImportConfigurationRunsQuery__
 *
 * To run a query within a React component, call `useImportConfigurationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportConfigurationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportConfigurationRunsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      lastStep: // value for 'lastStep'
 *   },
 * });
 */
export function useImportConfigurationRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportConfigurationRunsQuery, Generated.ImportConfigurationRunsQueryVariables> & ({ variables: Generated.ImportConfigurationRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportConfigurationRunsQuery, Generated.ImportConfigurationRunsQueryVariables>(ImportConfigurationRunsDocument, options);
      }
export function useImportConfigurationRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportConfigurationRunsQuery, Generated.ImportConfigurationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportConfigurationRunsQuery, Generated.ImportConfigurationRunsQueryVariables>(ImportConfigurationRunsDocument, options);
        }
export function useImportConfigurationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportConfigurationRunsQuery, Generated.ImportConfigurationRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportConfigurationRunsQuery, Generated.ImportConfigurationRunsQueryVariables>(ImportConfigurationRunsDocument, options);
        }
export type ImportConfigurationRunsQueryHookResult = ReturnType<typeof useImportConfigurationRunsQuery>;
export type ImportConfigurationRunsLazyQueryHookResult = ReturnType<typeof useImportConfigurationRunsLazyQuery>;
export type ImportConfigurationRunsSuspenseQueryHookResult = ReturnType<typeof useImportConfigurationRunsSuspenseQuery>;
export type ImportConfigurationRunsQueryResult = Apollo.QueryResult<Generated.ImportConfigurationRunsQuery, Generated.ImportConfigurationRunsQueryVariables>;
export const ImportConfigurationsDocument = /*#__PURE__*/ gql`
    query ImportConfigurations($limit: Int!, $offset: Int!, $crawler: String, $sourceId: String, $countries: [ID!], $enabled: Boolean, $linksOnly: Boolean, $moviesOnly: Boolean, $inheritsScreenAttributes: Boolean, $entityIds: [ID!], $orderBy: ImportConfigurationOrder!) {
  importConfigurations(
    limit: $limit
    offset: $offset
    crawler: $crawler
    sourceId: $sourceId
    countries: $countries
    enabled: $enabled
    linksOnly: $linksOnly
    moviesOnly: $moviesOnly
    inheritsScreenAttributes: $inheritsScreenAttributes
    entityIds: $entityIds
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...ImportConfigurationRow
    }
  }
}
    ${ImportConfigurationRowFragmentDoc}`;

/**
 * __useImportConfigurationsQuery__
 *
 * To run a query within a React component, call `useImportConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportConfigurationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      crawler: // value for 'crawler'
 *      sourceId: // value for 'sourceId'
 *      countries: // value for 'countries'
 *      enabled: // value for 'enabled'
 *      linksOnly: // value for 'linksOnly'
 *      moviesOnly: // value for 'moviesOnly'
 *      inheritsScreenAttributes: // value for 'inheritsScreenAttributes'
 *      entityIds: // value for 'entityIds'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useImportConfigurationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportConfigurationsQuery, Generated.ImportConfigurationsQueryVariables> & ({ variables: Generated.ImportConfigurationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportConfigurationsQuery, Generated.ImportConfigurationsQueryVariables>(ImportConfigurationsDocument, options);
      }
export function useImportConfigurationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportConfigurationsQuery, Generated.ImportConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportConfigurationsQuery, Generated.ImportConfigurationsQueryVariables>(ImportConfigurationsDocument, options);
        }
export function useImportConfigurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportConfigurationsQuery, Generated.ImportConfigurationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportConfigurationsQuery, Generated.ImportConfigurationsQueryVariables>(ImportConfigurationsDocument, options);
        }
export type ImportConfigurationsQueryHookResult = ReturnType<typeof useImportConfigurationsQuery>;
export type ImportConfigurationsLazyQueryHookResult = ReturnType<typeof useImportConfigurationsLazyQuery>;
export type ImportConfigurationsSuspenseQueryHookResult = ReturnType<typeof useImportConfigurationsSuspenseQuery>;
export type ImportConfigurationsQueryResult = Apollo.QueryResult<Generated.ImportConfigurationsQuery, Generated.ImportConfigurationsQueryVariables>;
export const ImportCrawlersWithConfigurationsDocument = /*#__PURE__*/ gql`
    query ImportCrawlersWithConfigurations($limit: Int!, $offset: Int, $orderBy: ImportCrawlerOrder, $name: String, $countries: [ID!], $types: [CrawlerType!], $tags: [String!]) {
  importCrawlers(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    name: $name
    countries: $countries
    types: $types
    tags: $tags
  ) {
    nodes {
      ...ImportCrawlerWithConfigurationRow
    }
    totalCount
  }
}
    ${ImportCrawlerWithConfigurationRowFragmentDoc}`;

/**
 * __useImportCrawlersWithConfigurationsQuery__
 *
 * To run a query within a React component, call `useImportCrawlersWithConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCrawlersWithConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCrawlersWithConfigurationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      name: // value for 'name'
 *      countries: // value for 'countries'
 *      types: // value for 'types'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useImportCrawlersWithConfigurationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportCrawlersWithConfigurationsQuery, Generated.ImportCrawlersWithConfigurationsQueryVariables> & ({ variables: Generated.ImportCrawlersWithConfigurationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportCrawlersWithConfigurationsQuery, Generated.ImportCrawlersWithConfigurationsQueryVariables>(ImportCrawlersWithConfigurationsDocument, options);
      }
export function useImportCrawlersWithConfigurationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportCrawlersWithConfigurationsQuery, Generated.ImportCrawlersWithConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportCrawlersWithConfigurationsQuery, Generated.ImportCrawlersWithConfigurationsQueryVariables>(ImportCrawlersWithConfigurationsDocument, options);
        }
export function useImportCrawlersWithConfigurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportCrawlersWithConfigurationsQuery, Generated.ImportCrawlersWithConfigurationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportCrawlersWithConfigurationsQuery, Generated.ImportCrawlersWithConfigurationsQueryVariables>(ImportCrawlersWithConfigurationsDocument, options);
        }
export type ImportCrawlersWithConfigurationsQueryHookResult = ReturnType<typeof useImportCrawlersWithConfigurationsQuery>;
export type ImportCrawlersWithConfigurationsLazyQueryHookResult = ReturnType<typeof useImportCrawlersWithConfigurationsLazyQuery>;
export type ImportCrawlersWithConfigurationsSuspenseQueryHookResult = ReturnType<typeof useImportCrawlersWithConfigurationsSuspenseQuery>;
export type ImportCrawlersWithConfigurationsQueryResult = Apollo.QueryResult<Generated.ImportCrawlersWithConfigurationsQuery, Generated.ImportCrawlersWithConfigurationsQueryVariables>;
export const ImportCrawlerDocument = /*#__PURE__*/ gql`
    query ImportCrawler($id: ID!) {
  importCrawler(id: $id) {
    ...ImportCrawlerRow
    configurations(limit: -1) {
      totalCount
      nodes {
        id
        ...ImportConfigurationIdentity
      }
    }
    metadata {
      ...Metadata
    }
  }
}
    ${ImportCrawlerRowFragmentDoc}
${ImportConfigurationIdentityFragmentDoc}
${MetadataFragmentDoc}`;

/**
 * __useImportCrawlerQuery__
 *
 * To run a query within a React component, call `useImportCrawlerQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCrawlerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCrawlerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportCrawlerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportCrawlerQuery, Generated.ImportCrawlerQueryVariables> & ({ variables: Generated.ImportCrawlerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportCrawlerQuery, Generated.ImportCrawlerQueryVariables>(ImportCrawlerDocument, options);
      }
export function useImportCrawlerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportCrawlerQuery, Generated.ImportCrawlerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportCrawlerQuery, Generated.ImportCrawlerQueryVariables>(ImportCrawlerDocument, options);
        }
export function useImportCrawlerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportCrawlerQuery, Generated.ImportCrawlerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportCrawlerQuery, Generated.ImportCrawlerQueryVariables>(ImportCrawlerDocument, options);
        }
export type ImportCrawlerQueryHookResult = ReturnType<typeof useImportCrawlerQuery>;
export type ImportCrawlerLazyQueryHookResult = ReturnType<typeof useImportCrawlerLazyQuery>;
export type ImportCrawlerSuspenseQueryHookResult = ReturnType<typeof useImportCrawlerSuspenseQuery>;
export type ImportCrawlerQueryResult = Apollo.QueryResult<Generated.ImportCrawlerQuery, Generated.ImportCrawlerQueryVariables>;
export const ImportCrawlersDocument = /*#__PURE__*/ gql`
    query ImportCrawlers($limit: Int!, $offset: Int, $orderBy: ImportCrawlerOrder) {
  importCrawlers(limit: $limit, offset: $offset, orderBy: $orderBy) {
    nodes {
      ...ImportCrawlerRow
    }
  }
}
    ${ImportCrawlerRowFragmentDoc}`;

/**
 * __useImportCrawlersQuery__
 *
 * To run a query within a React component, call `useImportCrawlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCrawlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCrawlersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useImportCrawlersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportCrawlersQuery, Generated.ImportCrawlersQueryVariables> & ({ variables: Generated.ImportCrawlersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportCrawlersQuery, Generated.ImportCrawlersQueryVariables>(ImportCrawlersDocument, options);
      }
export function useImportCrawlersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportCrawlersQuery, Generated.ImportCrawlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportCrawlersQuery, Generated.ImportCrawlersQueryVariables>(ImportCrawlersDocument, options);
        }
export function useImportCrawlersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportCrawlersQuery, Generated.ImportCrawlersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportCrawlersQuery, Generated.ImportCrawlersQueryVariables>(ImportCrawlersDocument, options);
        }
export type ImportCrawlersQueryHookResult = ReturnType<typeof useImportCrawlersQuery>;
export type ImportCrawlersLazyQueryHookResult = ReturnType<typeof useImportCrawlersLazyQuery>;
export type ImportCrawlersSuspenseQueryHookResult = ReturnType<typeof useImportCrawlersSuspenseQuery>;
export type ImportCrawlersQueryResult = Apollo.QueryResult<Generated.ImportCrawlersQuery, Generated.ImportCrawlersQueryVariables>;
export const ImportMatchersDocument = /*#__PURE__*/ gql`
    query ImportMatchers($sourceType: ShowtimeSourceType!) {
  importMatchers(sourceType: $sourceType)
}
    `;

/**
 * __useImportMatchersQuery__
 *
 * To run a query within a React component, call `useImportMatchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportMatchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportMatchersQuery({
 *   variables: {
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useImportMatchersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportMatchersQuery, Generated.ImportMatchersQueryVariables> & ({ variables: Generated.ImportMatchersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportMatchersQuery, Generated.ImportMatchersQueryVariables>(ImportMatchersDocument, options);
      }
export function useImportMatchersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportMatchersQuery, Generated.ImportMatchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportMatchersQuery, Generated.ImportMatchersQueryVariables>(ImportMatchersDocument, options);
        }
export function useImportMatchersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportMatchersQuery, Generated.ImportMatchersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportMatchersQuery, Generated.ImportMatchersQueryVariables>(ImportMatchersDocument, options);
        }
export type ImportMatchersQueryHookResult = ReturnType<typeof useImportMatchersQuery>;
export type ImportMatchersLazyQueryHookResult = ReturnType<typeof useImportMatchersLazyQuery>;
export type ImportMatchersSuspenseQueryHookResult = ReturnType<typeof useImportMatchersSuspenseQuery>;
export type ImportMatchersQueryResult = Apollo.QueryResult<Generated.ImportMatchersQuery, Generated.ImportMatchersQueryVariables>;
export const ImportRunsDocument = /*#__PURE__*/ gql`
    query ImportRuns($limit: Int!, $offset: Int!, $crawler: String, $sourceId: String, $status: ImportRunStatus, $lastStep: ImportRunStepType, $startTime: DateTime, $endTime: DateTime, $entityId: ID) {
  importRuns(
    limit: $limit
    offset: $offset
    crawler: $crawler
    sourceId: $sourceId
    status: $status
    lastStep: $lastStep
    startTime: $startTime
    endTime: $endTime
    entityId: $entityId
  ) {
    totalCount
    nodes {
      ...ImportRunRow
    }
  }
}
    ${ImportRunRowFragmentDoc}`;

/**
 * __useImportRunsQuery__
 *
 * To run a query within a React component, call `useImportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportRunsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      crawler: // value for 'crawler'
 *      sourceId: // value for 'sourceId'
 *      status: // value for 'status'
 *      lastStep: // value for 'lastStep'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useImportRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ImportRunsQuery, Generated.ImportRunsQueryVariables> & ({ variables: Generated.ImportRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ImportRunsQuery, Generated.ImportRunsQueryVariables>(ImportRunsDocument, options);
      }
export function useImportRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ImportRunsQuery, Generated.ImportRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ImportRunsQuery, Generated.ImportRunsQueryVariables>(ImportRunsDocument, options);
        }
export function useImportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ImportRunsQuery, Generated.ImportRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ImportRunsQuery, Generated.ImportRunsQueryVariables>(ImportRunsDocument, options);
        }
export type ImportRunsQueryHookResult = ReturnType<typeof useImportRunsQuery>;
export type ImportRunsLazyQueryHookResult = ReturnType<typeof useImportRunsLazyQuery>;
export type ImportRunsSuspenseQueryHookResult = ReturnType<typeof useImportRunsSuspenseQuery>;
export type ImportRunsQueryResult = Apollo.QueryResult<Generated.ImportRunsQuery, Generated.ImportRunsQueryVariables>;
export const UpdateImportCrawlerDocument = /*#__PURE__*/ gql`
    mutation UpdateImportCrawler($input: UpdateImportCrawlerInput!) {
  updateImportCrawler(input: $input) {
    ...ImportCrawlerRow
    metadata {
      ...Metadata
    }
  }
}
    ${ImportCrawlerRowFragmentDoc}
${MetadataFragmentDoc}`;
export type UpdateImportCrawlerMutationFn = Apollo.MutationFunction<Generated.UpdateImportCrawlerMutation, Generated.UpdateImportCrawlerMutationVariables>;

/**
 * __useUpdateImportCrawlerMutation__
 *
 * To run a mutation, you first call `useUpdateImportCrawlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportCrawlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportCrawlerMutation, { data, loading, error }] = useUpdateImportCrawlerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImportCrawlerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImportCrawlerMutation, Generated.UpdateImportCrawlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImportCrawlerMutation, Generated.UpdateImportCrawlerMutationVariables>(UpdateImportCrawlerDocument, options);
      }
export type UpdateImportCrawlerMutationHookResult = ReturnType<typeof useUpdateImportCrawlerMutation>;
export type UpdateImportCrawlerMutationResult = Apollo.MutationResult<Generated.UpdateImportCrawlerMutation>;
export type UpdateImportCrawlerMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImportCrawlerMutation, Generated.UpdateImportCrawlerMutationVariables>;
export const UpdateImportConfigurationDocument = /*#__PURE__*/ gql`
    mutation UpdateImportConfiguration($input: UpdateImportConfigurationInput!) {
  updateImportConfiguration(input: $input) {
    id
    ...ImportConfigurationIdentity
    metadata {
      ...Metadata
    }
  }
}
    ${ImportConfigurationIdentityFragmentDoc}
${MetadataFragmentDoc}`;
export type UpdateImportConfigurationMutationFn = Apollo.MutationFunction<Generated.UpdateImportConfigurationMutation, Generated.UpdateImportConfigurationMutationVariables>;

/**
 * __useUpdateImportConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateImportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportConfigurationMutation, { data, loading, error }] = useUpdateImportConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImportConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImportConfigurationMutation, Generated.UpdateImportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImportConfigurationMutation, Generated.UpdateImportConfigurationMutationVariables>(UpdateImportConfigurationDocument, options);
      }
export type UpdateImportConfigurationMutationHookResult = ReturnType<typeof useUpdateImportConfigurationMutation>;
export type UpdateImportConfigurationMutationResult = Apollo.MutationResult<Generated.UpdateImportConfigurationMutation>;
export type UpdateImportConfigurationMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImportConfigurationMutation, Generated.UpdateImportConfigurationMutationVariables>;
export const GetJumpLinksDocument = /*#__PURE__*/ gql`
    query getJumpLinks($limit: Int, $offset: Int!, $orderBy: JumpLinkOrder!, $search: String, $targetDomainUrls: [String!], $sourceUrls: [String!], $partners: [String!], $companyIds: [ID!], $userIds: [ID!]) {
  jumpLinks(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    search: $search
    targetDomainUrls: $targetDomainUrls
    sourceUrls: $sourceUrls
    partners: $partners
    companyIds: $companyIds
    userIds: $userIds
  ) {
    totalCount
    nodes {
      ...JumpLink
    }
  }
}
    ${JumpLinkFragmentDoc}`;

/**
 * __useGetJumpLinksQuery__
 *
 * To run a query within a React component, call `useGetJumpLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJumpLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJumpLinksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      targetDomainUrls: // value for 'targetDomainUrls'
 *      sourceUrls: // value for 'sourceUrls'
 *      partners: // value for 'partners'
 *      companyIds: // value for 'companyIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetJumpLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetJumpLinksQuery, Generated.GetJumpLinksQueryVariables> & ({ variables: Generated.GetJumpLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetJumpLinksQuery, Generated.GetJumpLinksQueryVariables>(GetJumpLinksDocument, options);
      }
export function useGetJumpLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetJumpLinksQuery, Generated.GetJumpLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetJumpLinksQuery, Generated.GetJumpLinksQueryVariables>(GetJumpLinksDocument, options);
        }
export function useGetJumpLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetJumpLinksQuery, Generated.GetJumpLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetJumpLinksQuery, Generated.GetJumpLinksQueryVariables>(GetJumpLinksDocument, options);
        }
export type GetJumpLinksQueryHookResult = ReturnType<typeof useGetJumpLinksQuery>;
export type GetJumpLinksLazyQueryHookResult = ReturnType<typeof useGetJumpLinksLazyQuery>;
export type GetJumpLinksSuspenseQueryHookResult = ReturnType<typeof useGetJumpLinksSuspenseQuery>;
export type GetJumpLinksQueryResult = Apollo.QueryResult<Generated.GetJumpLinksQuery, Generated.GetJumpLinksQueryVariables>;
export const GetJumpPlatformDomainsDocument = /*#__PURE__*/ gql`
    query getJumpPlatformDomains {
  jumpPlatformDomains {
    url
    label
  }
}
    `;

/**
 * __useGetJumpPlatformDomainsQuery__
 *
 * To run a query within a React component, call `useGetJumpPlatformDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJumpPlatformDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJumpPlatformDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJumpPlatformDomainsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetJumpPlatformDomainsQuery, Generated.GetJumpPlatformDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetJumpPlatformDomainsQuery, Generated.GetJumpPlatformDomainsQueryVariables>(GetJumpPlatformDomainsDocument, options);
      }
export function useGetJumpPlatformDomainsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetJumpPlatformDomainsQuery, Generated.GetJumpPlatformDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetJumpPlatformDomainsQuery, Generated.GetJumpPlatformDomainsQueryVariables>(GetJumpPlatformDomainsDocument, options);
        }
export function useGetJumpPlatformDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetJumpPlatformDomainsQuery, Generated.GetJumpPlatformDomainsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetJumpPlatformDomainsQuery, Generated.GetJumpPlatformDomainsQueryVariables>(GetJumpPlatformDomainsDocument, options);
        }
export type GetJumpPlatformDomainsQueryHookResult = ReturnType<typeof useGetJumpPlatformDomainsQuery>;
export type GetJumpPlatformDomainsLazyQueryHookResult = ReturnType<typeof useGetJumpPlatformDomainsLazyQuery>;
export type GetJumpPlatformDomainsSuspenseQueryHookResult = ReturnType<typeof useGetJumpPlatformDomainsSuspenseQuery>;
export type GetJumpPlatformDomainsQueryResult = Apollo.QueryResult<Generated.GetJumpPlatformDomainsQuery, Generated.GetJumpPlatformDomainsQueryVariables>;
export const GenerateJumpLinkDocument = /*#__PURE__*/ gql`
    query generateJumpLink($targetDomainUrl: String!, $sourceUrl: URL!, $companyId: ID, $partner: String, $data: JSON) {
  jumpPlatformEncodedUrl(
    targetDomainUrl: $targetDomainUrl
    sourceUrl: $sourceUrl
    companyId: $companyId
    partner: $partner
    data: $data
  ) {
    ...JumpLink
  }
}
    ${JumpLinkFragmentDoc}`;

/**
 * __useGenerateJumpLinkQuery__
 *
 * To run a query within a React component, call `useGenerateJumpLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateJumpLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateJumpLinkQuery({
 *   variables: {
 *      targetDomainUrl: // value for 'targetDomainUrl'
 *      sourceUrl: // value for 'sourceUrl'
 *      companyId: // value for 'companyId'
 *      partner: // value for 'partner'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateJumpLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GenerateJumpLinkQuery, Generated.GenerateJumpLinkQueryVariables> & ({ variables: Generated.GenerateJumpLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GenerateJumpLinkQuery, Generated.GenerateJumpLinkQueryVariables>(GenerateJumpLinkDocument, options);
      }
export function useGenerateJumpLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GenerateJumpLinkQuery, Generated.GenerateJumpLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GenerateJumpLinkQuery, Generated.GenerateJumpLinkQueryVariables>(GenerateJumpLinkDocument, options);
        }
export function useGenerateJumpLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GenerateJumpLinkQuery, Generated.GenerateJumpLinkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GenerateJumpLinkQuery, Generated.GenerateJumpLinkQueryVariables>(GenerateJumpLinkDocument, options);
        }
export type GenerateJumpLinkQueryHookResult = ReturnType<typeof useGenerateJumpLinkQuery>;
export type GenerateJumpLinkLazyQueryHookResult = ReturnType<typeof useGenerateJumpLinkLazyQuery>;
export type GenerateJumpLinkSuspenseQueryHookResult = ReturnType<typeof useGenerateJumpLinkSuspenseQuery>;
export type GenerateJumpLinkQueryResult = Apollo.QueryResult<Generated.GenerateJumpLinkQuery, Generated.GenerateJumpLinkQueryVariables>;
export const CreateLocaleDocument = /*#__PURE__*/ gql`
    mutation CreateLocale($input: CreateLocaleInput!) {
  createLocale(input: $input) {
    ...LocaleIdentity
  }
}
    ${LocaleIdentityFragmentDoc}`;
export type CreateLocaleMutationFn = Apollo.MutationFunction<Generated.CreateLocaleMutation, Generated.CreateLocaleMutationVariables>;

/**
 * __useCreateLocaleMutation__
 *
 * To run a mutation, you first call `useCreateLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocaleMutation, { data, loading, error }] = useCreateLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateLocaleMutation, Generated.CreateLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateLocaleMutation, Generated.CreateLocaleMutationVariables>(CreateLocaleDocument, options);
      }
export type CreateLocaleMutationHookResult = ReturnType<typeof useCreateLocaleMutation>;
export type CreateLocaleMutationResult = Apollo.MutationResult<Generated.CreateLocaleMutation>;
export type CreateLocaleMutationOptions = Apollo.BaseMutationOptions<Generated.CreateLocaleMutation, Generated.CreateLocaleMutationVariables>;
export const GetLocalesListDocument = /*#__PURE__*/ gql`
    query getLocalesList($search: String, $limit: Int!, $offset: Int!, $countryId: ID, $limitedLocalizationId: ID, $syncFromIdBrand: ID) {
  localesList(
    search: $search
    limit: $limit
    offset: $offset
    countryId: $countryId
    limitedLocalizationId: $limitedLocalizationId
    syncFromIdBrand: $syncFromIdBrand
  ) {
    __typename
    totalCount
    nodes {
      ...LocaleIdentity
    }
  }
}
    ${LocaleIdentityFragmentDoc}`;

/**
 * __useGetLocalesListQuery__
 *
 * To run a query within a React component, call `useGetLocalesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalesListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      countryId: // value for 'countryId'
 *      limitedLocalizationId: // value for 'limitedLocalizationId'
 *      syncFromIdBrand: // value for 'syncFromIdBrand'
 *   },
 * });
 */
export function useGetLocalesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetLocalesListQuery, Generated.GetLocalesListQueryVariables> & ({ variables: Generated.GetLocalesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetLocalesListQuery, Generated.GetLocalesListQueryVariables>(GetLocalesListDocument, options);
      }
export function useGetLocalesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetLocalesListQuery, Generated.GetLocalesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetLocalesListQuery, Generated.GetLocalesListQueryVariables>(GetLocalesListDocument, options);
        }
export function useGetLocalesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetLocalesListQuery, Generated.GetLocalesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetLocalesListQuery, Generated.GetLocalesListQueryVariables>(GetLocalesListDocument, options);
        }
export type GetLocalesListQueryHookResult = ReturnType<typeof useGetLocalesListQuery>;
export type GetLocalesListLazyQueryHookResult = ReturnType<typeof useGetLocalesListLazyQuery>;
export type GetLocalesListSuspenseQueryHookResult = ReturnType<typeof useGetLocalesListSuspenseQuery>;
export type GetLocalesListQueryResult = Apollo.QueryResult<Generated.GetLocalesListQuery, Generated.GetLocalesListQueryVariables>;
export const UpdateLocaleDocument = /*#__PURE__*/ gql`
    mutation UpdateLocale($input: UpdateLocaleInput!) {
  updateLocale(input: $input) {
    ...LocaleIdentity
  }
}
    ${LocaleIdentityFragmentDoc}`;
export type UpdateLocaleMutationFn = Apollo.MutationFunction<Generated.UpdateLocaleMutation, Generated.UpdateLocaleMutationVariables>;

/**
 * __useUpdateLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocaleMutation, { data, loading, error }] = useUpdateLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateLocaleMutation, Generated.UpdateLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateLocaleMutation, Generated.UpdateLocaleMutationVariables>(UpdateLocaleDocument, options);
      }
export type UpdateLocaleMutationHookResult = ReturnType<typeof useUpdateLocaleMutation>;
export type UpdateLocaleMutationResult = Apollo.MutationResult<Generated.UpdateLocaleMutation>;
export type UpdateLocaleMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateLocaleMutation, Generated.UpdateLocaleMutationVariables>;
export const DeleteLocaleDocument = /*#__PURE__*/ gql`
    mutation DeleteLocale($input: DeleteLocaleInput!) {
  deleteLocale(input: $input) {
    id
  }
}
    `;
export type DeleteLocaleMutationFn = Apollo.MutationFunction<Generated.DeleteLocaleMutation, Generated.DeleteLocaleMutationVariables>;

/**
 * __useDeleteLocaleMutation__
 *
 * To run a mutation, you first call `useDeleteLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocaleMutation, { data, loading, error }] = useDeleteLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteLocaleMutation, Generated.DeleteLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteLocaleMutation, Generated.DeleteLocaleMutationVariables>(DeleteLocaleDocument, options);
      }
export type DeleteLocaleMutationHookResult = ReturnType<typeof useDeleteLocaleMutation>;
export type DeleteLocaleMutationResult = Apollo.MutationResult<Generated.DeleteLocaleMutation>;
export type DeleteLocaleMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteLocaleMutation, Generated.DeleteLocaleMutationVariables>;
export const GetLocaleDocument = /*#__PURE__*/ gql`
    query getLocale($id: ID!) {
  locale(id: $id) {
    ...LocaleIdentity
  }
}
    ${LocaleIdentityFragmentDoc}`;

/**
 * __useGetLocaleQuery__
 *
 * To run a query within a React component, call `useGetLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocaleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetLocaleQuery, Generated.GetLocaleQueryVariables> & ({ variables: Generated.GetLocaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetLocaleQuery, Generated.GetLocaleQueryVariables>(GetLocaleDocument, options);
      }
export function useGetLocaleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetLocaleQuery, Generated.GetLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetLocaleQuery, Generated.GetLocaleQueryVariables>(GetLocaleDocument, options);
        }
export function useGetLocaleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetLocaleQuery, Generated.GetLocaleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetLocaleQuery, Generated.GetLocaleQueryVariables>(GetLocaleDocument, options);
        }
export type GetLocaleQueryHookResult = ReturnType<typeof useGetLocaleQuery>;
export type GetLocaleLazyQueryHookResult = ReturnType<typeof useGetLocaleLazyQuery>;
export type GetLocaleSuspenseQueryHookResult = ReturnType<typeof useGetLocaleSuspenseQuery>;
export type GetLocaleQueryResult = Apollo.QueryResult<Generated.GetLocaleQuery, Generated.GetLocaleQueryVariables>;
export const GetEventLogsDocument = /*#__PURE__*/ gql`
    query getEventLogs($limit: Int, $offset: Int, $eventTypes: [EventLogType!], $userId: ID, $from: DateTime, $to: DateTime, $search: String, $orderBy: EventLogOrder) {
  eventLogs(
    limit: $limit
    offset: $offset
    eventTypes: $eventTypes
    userId: $userId
    from: $from
    to: $to
    search: $search
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      id: uuid
      user {
        ...MetadataUser
      }
      eventType
      occuredAt
      label
      payload
    }
  }
}
    ${MetadataUserFragmentDoc}`;

/**
 * __useGetEventLogsQuery__
 *
 * To run a query within a React component, call `useGetEventLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      eventTypes: // value for 'eventTypes'
 *      userId: // value for 'userId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetEventLogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetEventLogsQuery, Generated.GetEventLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEventLogsQuery, Generated.GetEventLogsQueryVariables>(GetEventLogsDocument, options);
      }
export function useGetEventLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEventLogsQuery, Generated.GetEventLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEventLogsQuery, Generated.GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export function useGetEventLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEventLogsQuery, Generated.GetEventLogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEventLogsQuery, Generated.GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export type GetEventLogsQueryHookResult = ReturnType<typeof useGetEventLogsQuery>;
export type GetEventLogsLazyQueryHookResult = ReturnType<typeof useGetEventLogsLazyQuery>;
export type GetEventLogsSuspenseQueryHookResult = ReturnType<typeof useGetEventLogsSuspenseQuery>;
export type GetEventLogsQueryResult = Apollo.QueryResult<Generated.GetEventLogsQuery, Generated.GetEventLogsQueryVariables>;
export const CopyMovieBrandedDataToLocalizedDataDocument = /*#__PURE__*/ gql`
    mutation CopyMovieBrandedDataToLocalizedData($input: CopyMovieBrandedDataToLocalizedDataInput!) {
  copyMovieBrandedDataToLocalizedData(input: $input) {
    ...MovieLocalizedData
  }
}
    ${MovieLocalizedDataFragmentDoc}`;
export type CopyMovieBrandedDataToLocalizedDataMutationFn = Apollo.MutationFunction<Generated.CopyMovieBrandedDataToLocalizedDataMutation, Generated.CopyMovieBrandedDataToLocalizedDataMutationVariables>;

/**
 * __useCopyMovieBrandedDataToLocalizedDataMutation__
 *
 * To run a mutation, you first call `useCopyMovieBrandedDataToLocalizedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyMovieBrandedDataToLocalizedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyMovieBrandedDataToLocalizedDataMutation, { data, loading, error }] = useCopyMovieBrandedDataToLocalizedDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyMovieBrandedDataToLocalizedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CopyMovieBrandedDataToLocalizedDataMutation, Generated.CopyMovieBrandedDataToLocalizedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CopyMovieBrandedDataToLocalizedDataMutation, Generated.CopyMovieBrandedDataToLocalizedDataMutationVariables>(CopyMovieBrandedDataToLocalizedDataDocument, options);
      }
export type CopyMovieBrandedDataToLocalizedDataMutationHookResult = ReturnType<typeof useCopyMovieBrandedDataToLocalizedDataMutation>;
export type CopyMovieBrandedDataToLocalizedDataMutationResult = Apollo.MutationResult<Generated.CopyMovieBrandedDataToLocalizedDataMutation>;
export type CopyMovieBrandedDataToLocalizedDataMutationOptions = Apollo.BaseMutationOptions<Generated.CopyMovieBrandedDataToLocalizedDataMutation, Generated.CopyMovieBrandedDataToLocalizedDataMutationVariables>;
export const CreateMovieVersionDocument = /*#__PURE__*/ gql`
    mutation createMovieVersion($input: CreateMovieVersionInput!) {
  createMovieVersion(input: $input) {
    id
  }
}
    `;
export type CreateMovieVersionMutationFn = Apollo.MutationFunction<Generated.CreateMovieVersionMutation, Generated.CreateMovieVersionMutationVariables>;

/**
 * __useCreateMovieVersionMutation__
 *
 * To run a mutation, you first call `useCreateMovieVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMovieVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMovieVersionMutation, { data, loading, error }] = useCreateMovieVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMovieVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateMovieVersionMutation, Generated.CreateMovieVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateMovieVersionMutation, Generated.CreateMovieVersionMutationVariables>(CreateMovieVersionDocument, options);
      }
export type CreateMovieVersionMutationHookResult = ReturnType<typeof useCreateMovieVersionMutation>;
export type CreateMovieVersionMutationResult = Apollo.MutationResult<Generated.CreateMovieVersionMutation>;
export type CreateMovieVersionMutationOptions = Apollo.BaseMutationOptions<Generated.CreateMovieVersionMutation, Generated.CreateMovieVersionMutationVariables>;
export const CreateMovieShowtimesEmbargoDocument = /*#__PURE__*/ gql`
    mutation createMovieShowtimesEmbargo($input: CreateShowtimesEmbargoInput!) {
  createShowtimesEmbargo(input: $input) {
    id
  }
}
    `;
export type CreateMovieShowtimesEmbargoMutationFn = Apollo.MutationFunction<Generated.CreateMovieShowtimesEmbargoMutation, Generated.CreateMovieShowtimesEmbargoMutationVariables>;

/**
 * __useCreateMovieShowtimesEmbargoMutation__
 *
 * To run a mutation, you first call `useCreateMovieShowtimesEmbargoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMovieShowtimesEmbargoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMovieShowtimesEmbargoMutation, { data, loading, error }] = useCreateMovieShowtimesEmbargoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMovieShowtimesEmbargoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateMovieShowtimesEmbargoMutation, Generated.CreateMovieShowtimesEmbargoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateMovieShowtimesEmbargoMutation, Generated.CreateMovieShowtimesEmbargoMutationVariables>(CreateMovieShowtimesEmbargoDocument, options);
      }
export type CreateMovieShowtimesEmbargoMutationHookResult = ReturnType<typeof useCreateMovieShowtimesEmbargoMutation>;
export type CreateMovieShowtimesEmbargoMutationResult = Apollo.MutationResult<Generated.CreateMovieShowtimesEmbargoMutation>;
export type CreateMovieShowtimesEmbargoMutationOptions = Apollo.BaseMutationOptions<Generated.CreateMovieShowtimesEmbargoMutation, Generated.CreateMovieShowtimesEmbargoMutationVariables>;
export const CreateMovieReleaseDocument = /*#__PURE__*/ gql`
    mutation createMovieRelease($input: AddReleaseToEntityInput!) {
  addReleaseToEntity(input: $input) {
    id
    ref
    entity {
      ... on Movie {
        id
      }
    }
  }
}
    `;
export type CreateMovieReleaseMutationFn = Apollo.MutationFunction<Generated.CreateMovieReleaseMutation, Generated.CreateMovieReleaseMutationVariables>;

/**
 * __useCreateMovieReleaseMutation__
 *
 * To run a mutation, you first call `useCreateMovieReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMovieReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMovieReleaseMutation, { data, loading, error }] = useCreateMovieReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMovieReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateMovieReleaseMutation, Generated.CreateMovieReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateMovieReleaseMutation, Generated.CreateMovieReleaseMutationVariables>(CreateMovieReleaseDocument, options);
      }
export type CreateMovieReleaseMutationHookResult = ReturnType<typeof useCreateMovieReleaseMutation>;
export type CreateMovieReleaseMutationResult = Apollo.MutationResult<Generated.CreateMovieReleaseMutation>;
export type CreateMovieReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.CreateMovieReleaseMutation, Generated.CreateMovieReleaseMutationVariables>;
export const DeleteMovieVersionDocument = /*#__PURE__*/ gql`
    mutation deleteMovieVersion($input: DeleteMovieVersionInput!) {
  deleteMovieVersion(input: $input) {
    id
  }
}
    `;
export type DeleteMovieVersionMutationFn = Apollo.MutationFunction<Generated.DeleteMovieVersionMutation, Generated.DeleteMovieVersionMutationVariables>;

/**
 * __useDeleteMovieVersionMutation__
 *
 * To run a mutation, you first call `useDeleteMovieVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMovieVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMovieVersionMutation, { data, loading, error }] = useDeleteMovieVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMovieVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteMovieVersionMutation, Generated.DeleteMovieVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteMovieVersionMutation, Generated.DeleteMovieVersionMutationVariables>(DeleteMovieVersionDocument, options);
      }
export type DeleteMovieVersionMutationHookResult = ReturnType<typeof useDeleteMovieVersionMutation>;
export type DeleteMovieVersionMutationResult = Apollo.MutationResult<Generated.DeleteMovieVersionMutation>;
export type DeleteMovieVersionMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteMovieVersionMutation, Generated.DeleteMovieVersionMutationVariables>;
export const CreateMovieDocument = /*#__PURE__*/ gql`
    mutation createMovie($input: CreateMovieInput!) {
  createMovie(input: $input) {
    id
    ref
  }
}
    `;
export type CreateMovieMutationFn = Apollo.MutationFunction<Generated.CreateMovieMutation, Generated.CreateMovieMutationVariables>;

/**
 * __useCreateMovieMutation__
 *
 * To run a mutation, you first call `useCreateMovieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMovieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMovieMutation, { data, loading, error }] = useCreateMovieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMovieMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateMovieMutation, Generated.CreateMovieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateMovieMutation, Generated.CreateMovieMutationVariables>(CreateMovieDocument, options);
      }
export type CreateMovieMutationHookResult = ReturnType<typeof useCreateMovieMutation>;
export type CreateMovieMutationResult = Apollo.MutationResult<Generated.CreateMovieMutation>;
export type CreateMovieMutationOptions = Apollo.BaseMutationOptions<Generated.CreateMovieMutation, Generated.CreateMovieMutationVariables>;
export const DeleteMovieShowtimesEmbargoDocument = /*#__PURE__*/ gql`
    mutation deleteMovieShowtimesEmbargo($input: DeleteShowtimesEmbargoInput!) {
  deleteShowtimesEmbargo(input: $input) {
    id
  }
}
    `;
export type DeleteMovieShowtimesEmbargoMutationFn = Apollo.MutationFunction<Generated.DeleteMovieShowtimesEmbargoMutation, Generated.DeleteMovieShowtimesEmbargoMutationVariables>;

/**
 * __useDeleteMovieShowtimesEmbargoMutation__
 *
 * To run a mutation, you first call `useDeleteMovieShowtimesEmbargoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMovieShowtimesEmbargoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMovieShowtimesEmbargoMutation, { data, loading, error }] = useDeleteMovieShowtimesEmbargoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMovieShowtimesEmbargoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteMovieShowtimesEmbargoMutation, Generated.DeleteMovieShowtimesEmbargoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteMovieShowtimesEmbargoMutation, Generated.DeleteMovieShowtimesEmbargoMutationVariables>(DeleteMovieShowtimesEmbargoDocument, options);
      }
export type DeleteMovieShowtimesEmbargoMutationHookResult = ReturnType<typeof useDeleteMovieShowtimesEmbargoMutation>;
export type DeleteMovieShowtimesEmbargoMutationResult = Apollo.MutationResult<Generated.DeleteMovieShowtimesEmbargoMutation>;
export type DeleteMovieShowtimesEmbargoMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteMovieShowtimesEmbargoMutation, Generated.DeleteMovieShowtimesEmbargoMutationVariables>;
export const DeleteMovieDocument = /*#__PURE__*/ gql`
    mutation deleteMovie($input: DeleteEntityInput!) {
  deleteEntity(input: $input) {
    ... on Movie {
      id
      ref
    }
  }
}
    `;
export type DeleteMovieMutationFn = Apollo.MutationFunction<Generated.DeleteMovieMutation, Generated.DeleteMovieMutationVariables>;

/**
 * __useDeleteMovieMutation__
 *
 * To run a mutation, you first call `useDeleteMovieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMovieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMovieMutation, { data, loading, error }] = useDeleteMovieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMovieMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteMovieMutation, Generated.DeleteMovieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteMovieMutation, Generated.DeleteMovieMutationVariables>(DeleteMovieDocument, options);
      }
export type DeleteMovieMutationHookResult = ReturnType<typeof useDeleteMovieMutation>;
export type DeleteMovieMutationResult = Apollo.MutationResult<Generated.DeleteMovieMutation>;
export type DeleteMovieMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteMovieMutation, Generated.DeleteMovieMutationVariables>;
export const GetBrandEntityClubsDocument = /*#__PURE__*/ gql`
    query getBrandEntityClubs($ref: ID!, $entityType: EntityType!, $brandIds: [ID!], $clubIds: [ID!]) {
  entityByRef(type: $entityType, ref: $ref) {
    __typename
    ... on Movie {
      ...MovieClubs
    }
    ... on Series {
      ...SeriesClubs
    }
  }
}
    ${MovieClubsFragmentDoc}
${SeriesClubsFragmentDoc}`;

/**
 * __useGetBrandEntityClubsQuery__
 *
 * To run a query within a React component, call `useGetBrandEntityClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandEntityClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandEntityClubsQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      entityType: // value for 'entityType'
 *      brandIds: // value for 'brandIds'
 *      clubIds: // value for 'clubIds'
 *   },
 * });
 */
export function useGetBrandEntityClubsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetBrandEntityClubsQuery, Generated.GetBrandEntityClubsQueryVariables> & ({ variables: Generated.GetBrandEntityClubsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetBrandEntityClubsQuery, Generated.GetBrandEntityClubsQueryVariables>(GetBrandEntityClubsDocument, options);
      }
export function useGetBrandEntityClubsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetBrandEntityClubsQuery, Generated.GetBrandEntityClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetBrandEntityClubsQuery, Generated.GetBrandEntityClubsQueryVariables>(GetBrandEntityClubsDocument, options);
        }
export function useGetBrandEntityClubsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetBrandEntityClubsQuery, Generated.GetBrandEntityClubsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetBrandEntityClubsQuery, Generated.GetBrandEntityClubsQueryVariables>(GetBrandEntityClubsDocument, options);
        }
export type GetBrandEntityClubsQueryHookResult = ReturnType<typeof useGetBrandEntityClubsQuery>;
export type GetBrandEntityClubsLazyQueryHookResult = ReturnType<typeof useGetBrandEntityClubsLazyQuery>;
export type GetBrandEntityClubsSuspenseQueryHookResult = ReturnType<typeof useGetBrandEntityClubsSuspenseQuery>;
export type GetBrandEntityClubsQueryResult = Apollo.QueryResult<Generated.GetBrandEntityClubsQuery, Generated.GetBrandEntityClubsQueryVariables>;
export const GetMovieAdditionalInfoDocument = /*#__PURE__*/ gql`
    query getMovieAdditionalInfo($id: ID!) {
  movie(id: $id) {
    ...MovieAdditionalInfo
  }
}
    ${MovieAdditionalInfoFragmentDoc}`;

/**
 * __useGetMovieAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useGetMovieAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieAdditionalInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovieAdditionalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieAdditionalInfoQuery, Generated.GetMovieAdditionalInfoQueryVariables> & ({ variables: Generated.GetMovieAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieAdditionalInfoQuery, Generated.GetMovieAdditionalInfoQueryVariables>(GetMovieAdditionalInfoDocument, options);
      }
export function useGetMovieAdditionalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieAdditionalInfoQuery, Generated.GetMovieAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieAdditionalInfoQuery, Generated.GetMovieAdditionalInfoQueryVariables>(GetMovieAdditionalInfoDocument, options);
        }
export function useGetMovieAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieAdditionalInfoQuery, Generated.GetMovieAdditionalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieAdditionalInfoQuery, Generated.GetMovieAdditionalInfoQueryVariables>(GetMovieAdditionalInfoDocument, options);
        }
export type GetMovieAdditionalInfoQueryHookResult = ReturnType<typeof useGetMovieAdditionalInfoQuery>;
export type GetMovieAdditionalInfoLazyQueryHookResult = ReturnType<typeof useGetMovieAdditionalInfoLazyQuery>;
export type GetMovieAdditionalInfoSuspenseQueryHookResult = ReturnType<typeof useGetMovieAdditionalInfoSuspenseQuery>;
export type GetMovieAdditionalInfoQueryResult = Apollo.QueryResult<Generated.GetMovieAdditionalInfoQuery, Generated.GetMovieAdditionalInfoQueryVariables>;
export const GetMovieBoxofficeDocument = /*#__PURE__*/ gql`
    query getMovieBoxoffice($id: ID!) {
  movie(id: $id) {
    id
    totalBoxofficeUs
    totalBoxofficeInternational
  }
}
    `;

/**
 * __useGetMovieBoxofficeQuery__
 *
 * To run a query within a React component, call `useGetMovieBoxofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieBoxofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieBoxofficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovieBoxofficeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieBoxofficeQuery, Generated.GetMovieBoxofficeQueryVariables> & ({ variables: Generated.GetMovieBoxofficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieBoxofficeQuery, Generated.GetMovieBoxofficeQueryVariables>(GetMovieBoxofficeDocument, options);
      }
export function useGetMovieBoxofficeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieBoxofficeQuery, Generated.GetMovieBoxofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieBoxofficeQuery, Generated.GetMovieBoxofficeQueryVariables>(GetMovieBoxofficeDocument, options);
        }
export function useGetMovieBoxofficeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieBoxofficeQuery, Generated.GetMovieBoxofficeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieBoxofficeQuery, Generated.GetMovieBoxofficeQueryVariables>(GetMovieBoxofficeDocument, options);
        }
export type GetMovieBoxofficeQueryHookResult = ReturnType<typeof useGetMovieBoxofficeQuery>;
export type GetMovieBoxofficeLazyQueryHookResult = ReturnType<typeof useGetMovieBoxofficeLazyQuery>;
export type GetMovieBoxofficeSuspenseQueryHookResult = ReturnType<typeof useGetMovieBoxofficeSuspenseQuery>;
export type GetMovieBoxofficeQueryResult = Apollo.QueryResult<Generated.GetMovieBoxofficeQuery, Generated.GetMovieBoxofficeQueryVariables>;
export const GetMovieBrandedContentDocument = /*#__PURE__*/ gql`
    query getMovieBrandedContent($brandId: ID!, $movieId: ID!) {
  movie(id: $movieId) {
    brandData(brandId: $brandId) {
      id
      brandedContent {
        ...MovieTab
      }
    }
  }
}
    ${MovieTabFragmentDoc}`;

/**
 * __useGetMovieBrandedContentQuery__
 *
 * To run a query within a React component, call `useGetMovieBrandedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieBrandedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieBrandedContentQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useGetMovieBrandedContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieBrandedContentQuery, Generated.GetMovieBrandedContentQueryVariables> & ({ variables: Generated.GetMovieBrandedContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieBrandedContentQuery, Generated.GetMovieBrandedContentQueryVariables>(GetMovieBrandedContentDocument, options);
      }
export function useGetMovieBrandedContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieBrandedContentQuery, Generated.GetMovieBrandedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieBrandedContentQuery, Generated.GetMovieBrandedContentQueryVariables>(GetMovieBrandedContentDocument, options);
        }
export function useGetMovieBrandedContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieBrandedContentQuery, Generated.GetMovieBrandedContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieBrandedContentQuery, Generated.GetMovieBrandedContentQueryVariables>(GetMovieBrandedContentDocument, options);
        }
export type GetMovieBrandedContentQueryHookResult = ReturnType<typeof useGetMovieBrandedContentQuery>;
export type GetMovieBrandedContentLazyQueryHookResult = ReturnType<typeof useGetMovieBrandedContentLazyQuery>;
export type GetMovieBrandedContentSuspenseQueryHookResult = ReturnType<typeof useGetMovieBrandedContentSuspenseQuery>;
export type GetMovieBrandedContentQueryResult = Apollo.QueryResult<Generated.GetMovieBrandedContentQuery, Generated.GetMovieBrandedContentQueryVariables>;
export const GetMovieBrandedDataDocument = /*#__PURE__*/ gql`
    query getMovieBrandedData($id: ID!, $brandId: ID!) {
  movie(id: $id) {
    id
    brandData(brandId: $brandId) {
      id
      title
      keywords
      synopsis
      synopsisShort
      poster {
        ...Image
      }
      ruling {
        hasRating
        atRisk
        hasWarningMessage
        hasMandatoryReview
      }
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetMovieBrandedDataQuery__
 *
 * To run a query within a React component, call `useGetMovieBrandedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieBrandedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieBrandedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetMovieBrandedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieBrandedDataQuery, Generated.GetMovieBrandedDataQueryVariables> & ({ variables: Generated.GetMovieBrandedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieBrandedDataQuery, Generated.GetMovieBrandedDataQueryVariables>(GetMovieBrandedDataDocument, options);
      }
export function useGetMovieBrandedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieBrandedDataQuery, Generated.GetMovieBrandedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieBrandedDataQuery, Generated.GetMovieBrandedDataQueryVariables>(GetMovieBrandedDataDocument, options);
        }
export function useGetMovieBrandedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieBrandedDataQuery, Generated.GetMovieBrandedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieBrandedDataQuery, Generated.GetMovieBrandedDataQueryVariables>(GetMovieBrandedDataDocument, options);
        }
export type GetMovieBrandedDataQueryHookResult = ReturnType<typeof useGetMovieBrandedDataQuery>;
export type GetMovieBrandedDataLazyQueryHookResult = ReturnType<typeof useGetMovieBrandedDataLazyQuery>;
export type GetMovieBrandedDataSuspenseQueryHookResult = ReturnType<typeof useGetMovieBrandedDataSuspenseQuery>;
export type GetMovieBrandedDataQueryResult = Apollo.QueryResult<Generated.GetMovieBrandedDataQuery, Generated.GetMovieBrandedDataQueryVariables>;
export const GetMovieCastingDocument = /*#__PURE__*/ gql`
    query getMovieCasting($id: ID!, $limit: Int, $offset: Int!, $locale: ID, $showLocaleData: Boolean!, $brandId: ID!, $includeBrandData: Boolean = false, $withSeoAttributes: Boolean! = false) {
  movie(id: $id) {
    id
    credits(limit: $limit, offset: $offset, activities: [ACTOR_ACTOR]) {
      totalCount
      nodes {
        ...Credit
      }
    }
  }
}
    ${CreditFragmentDoc}`;

/**
 * __useGetMovieCastingQuery__
 *
 * To run a query within a React component, call `useGetMovieCastingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieCastingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieCastingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      locale: // value for 'locale'
 *      showLocaleData: // value for 'showLocaleData'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useGetMovieCastingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieCastingQuery, Generated.GetMovieCastingQueryVariables> & ({ variables: Generated.GetMovieCastingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieCastingQuery, Generated.GetMovieCastingQueryVariables>(GetMovieCastingDocument, options);
      }
export function useGetMovieCastingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieCastingQuery, Generated.GetMovieCastingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieCastingQuery, Generated.GetMovieCastingQueryVariables>(GetMovieCastingDocument, options);
        }
export function useGetMovieCastingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieCastingQuery, Generated.GetMovieCastingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieCastingQuery, Generated.GetMovieCastingQueryVariables>(GetMovieCastingDocument, options);
        }
export type GetMovieCastingQueryHookResult = ReturnType<typeof useGetMovieCastingQuery>;
export type GetMovieCastingLazyQueryHookResult = ReturnType<typeof useGetMovieCastingLazyQuery>;
export type GetMovieCastingSuspenseQueryHookResult = ReturnType<typeof useGetMovieCastingSuspenseQuery>;
export type GetMovieCastingQueryResult = Apollo.QueryResult<Generated.GetMovieCastingQuery, Generated.GetMovieCastingQueryVariables>;
export const GetMovieCompanyDocument = /*#__PURE__*/ gql`
    query getMovieCompany($id: ID!, $limit: Int!, $offset: Int!, $activities: [CompanyActivity!]) {
  movie(id: $id) {
    id
    companies(limit: $limit, offset: $offset, activities: $activities) {
      totalCount
      nodes {
        ...EntitiesCompany
      }
    }
  }
}
    ${EntitiesCompanyFragmentDoc}`;

/**
 * __useGetMovieCompanyQuery__
 *
 * To run a query within a React component, call `useGetMovieCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *   },
 * });
 */
export function useGetMovieCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieCompanyQuery, Generated.GetMovieCompanyQueryVariables> & ({ variables: Generated.GetMovieCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieCompanyQuery, Generated.GetMovieCompanyQueryVariables>(GetMovieCompanyDocument, options);
      }
export function useGetMovieCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieCompanyQuery, Generated.GetMovieCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieCompanyQuery, Generated.GetMovieCompanyQueryVariables>(GetMovieCompanyDocument, options);
        }
export function useGetMovieCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieCompanyQuery, Generated.GetMovieCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieCompanyQuery, Generated.GetMovieCompanyQueryVariables>(GetMovieCompanyDocument, options);
        }
export type GetMovieCompanyQueryHookResult = ReturnType<typeof useGetMovieCompanyQuery>;
export type GetMovieCompanyLazyQueryHookResult = ReturnType<typeof useGetMovieCompanyLazyQuery>;
export type GetMovieCompanySuspenseQueryHookResult = ReturnType<typeof useGetMovieCompanySuspenseQuery>;
export type GetMovieCompanyQueryResult = Apollo.QueryResult<Generated.GetMovieCompanyQuery, Generated.GetMovieCompanyQueryVariables>;
export const GetMovieCreditDocument = /*#__PURE__*/ gql`
    query getMovieCredit($id: ID!, $limit: Int!, $offset: Int!, $activities: [PersonActivity!], $brandId: ID!, $includeBrandData: Boolean = false) {
  movie(id: $id) {
    id
    credits(
      limit: $limit
      offset: $offset
      activities: $activities
      excludeActivities: [ACTOR_ACTOR]
    ) {
      totalCount
      nodes {
        ...CreditLimited
      }
    }
  }
}
    ${CreditLimitedFragmentDoc}`;

/**
 * __useGetMovieCreditQuery__
 *
 * To run a query within a React component, call `useGetMovieCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieCreditQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetMovieCreditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieCreditQuery, Generated.GetMovieCreditQueryVariables> & ({ variables: Generated.GetMovieCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieCreditQuery, Generated.GetMovieCreditQueryVariables>(GetMovieCreditDocument, options);
      }
export function useGetMovieCreditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieCreditQuery, Generated.GetMovieCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieCreditQuery, Generated.GetMovieCreditQueryVariables>(GetMovieCreditDocument, options);
        }
export function useGetMovieCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieCreditQuery, Generated.GetMovieCreditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieCreditQuery, Generated.GetMovieCreditQueryVariables>(GetMovieCreditDocument, options);
        }
export type GetMovieCreditQueryHookResult = ReturnType<typeof useGetMovieCreditQuery>;
export type GetMovieCreditLazyQueryHookResult = ReturnType<typeof useGetMovieCreditLazyQuery>;
export type GetMovieCreditSuspenseQueryHookResult = ReturnType<typeof useGetMovieCreditSuspenseQuery>;
export type GetMovieCreditQueryResult = Apollo.QueryResult<Generated.GetMovieCreditQuery, Generated.GetMovieCreditQueryVariables>;
export const GetMovieExternalIdsDocument = /*#__PURE__*/ gql`
    query getMovieExternalIds($id: ID!) {
  movie(id: $id) {
    id
    ...EntityAlts
  }
}
    ${EntityAltsFragmentDoc}`;

/**
 * __useGetMovieExternalIdsQuery__
 *
 * To run a query within a React component, call `useGetMovieExternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieExternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieExternalIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovieExternalIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieExternalIdsQuery, Generated.GetMovieExternalIdsQueryVariables> & ({ variables: Generated.GetMovieExternalIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieExternalIdsQuery, Generated.GetMovieExternalIdsQueryVariables>(GetMovieExternalIdsDocument, options);
      }
export function useGetMovieExternalIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieExternalIdsQuery, Generated.GetMovieExternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieExternalIdsQuery, Generated.GetMovieExternalIdsQueryVariables>(GetMovieExternalIdsDocument, options);
        }
export function useGetMovieExternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieExternalIdsQuery, Generated.GetMovieExternalIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieExternalIdsQuery, Generated.GetMovieExternalIdsQueryVariables>(GetMovieExternalIdsDocument, options);
        }
export type GetMovieExternalIdsQueryHookResult = ReturnType<typeof useGetMovieExternalIdsQuery>;
export type GetMovieExternalIdsLazyQueryHookResult = ReturnType<typeof useGetMovieExternalIdsLazyQuery>;
export type GetMovieExternalIdsSuspenseQueryHookResult = ReturnType<typeof useGetMovieExternalIdsSuspenseQuery>;
export type GetMovieExternalIdsQueryResult = Apollo.QueryResult<Generated.GetMovieExternalIdsQuery, Generated.GetMovieExternalIdsQueryVariables>;
export const GetMovieIdDocument = /*#__PURE__*/ gql`
    query getMovieId($ref: ID!) {
  entityByRef(type: MOVIE, ref: $ref) {
    __typename
    ... on Movie {
      id
    }
  }
}
    `;

/**
 * __useGetMovieIdQuery__
 *
 * To run a query within a React component, call `useGetMovieIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieIdQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetMovieIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieIdQuery, Generated.GetMovieIdQueryVariables> & ({ variables: Generated.GetMovieIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieIdQuery, Generated.GetMovieIdQueryVariables>(GetMovieIdDocument, options);
      }
export function useGetMovieIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieIdQuery, Generated.GetMovieIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieIdQuery, Generated.GetMovieIdQueryVariables>(GetMovieIdDocument, options);
        }
export function useGetMovieIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieIdQuery, Generated.GetMovieIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieIdQuery, Generated.GetMovieIdQueryVariables>(GetMovieIdDocument, options);
        }
export type GetMovieIdQueryHookResult = ReturnType<typeof useGetMovieIdQuery>;
export type GetMovieIdLazyQueryHookResult = ReturnType<typeof useGetMovieIdLazyQuery>;
export type GetMovieIdSuspenseQueryHookResult = ReturnType<typeof useGetMovieIdSuspenseQuery>;
export type GetMovieIdQueryResult = Apollo.QueryResult<Generated.GetMovieIdQuery, Generated.GetMovieIdQueryVariables>;
export const GetMovieIdentityDocument = /*#__PURE__*/ gql`
    query getMovieIdentity($id: ID!) {
  movie(id: $id) {
    ...MovieIdentity
  }
}
    ${MovieIdentityFragmentDoc}`;

/**
 * __useGetMovieIdentityQuery__
 *
 * To run a query within a React component, call `useGetMovieIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovieIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieIdentityQuery, Generated.GetMovieIdentityQueryVariables> & ({ variables: Generated.GetMovieIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieIdentityQuery, Generated.GetMovieIdentityQueryVariables>(GetMovieIdentityDocument, options);
      }
export function useGetMovieIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieIdentityQuery, Generated.GetMovieIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieIdentityQuery, Generated.GetMovieIdentityQueryVariables>(GetMovieIdentityDocument, options);
        }
export function useGetMovieIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieIdentityQuery, Generated.GetMovieIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieIdentityQuery, Generated.GetMovieIdentityQueryVariables>(GetMovieIdentityDocument, options);
        }
export type GetMovieIdentityQueryHookResult = ReturnType<typeof useGetMovieIdentityQuery>;
export type GetMovieIdentityLazyQueryHookResult = ReturnType<typeof useGetMovieIdentityLazyQuery>;
export type GetMovieIdentitySuspenseQueryHookResult = ReturnType<typeof useGetMovieIdentitySuspenseQuery>;
export type GetMovieIdentityQueryResult = Apollo.QueryResult<Generated.GetMovieIdentityQuery, Generated.GetMovieIdentityQueryVariables>;
export const GetMovieListDocument = /*#__PURE__*/ gql`
    query getMovieList($limit: Int, $offset: Int!, $search: String, $orderBy: MovieOrder, $directorId: ID, $brandIds: [ID!], $brandId: ID!, $localeIds: [ID!], $searchIn: EntitySearchTypes, $searchSensitivity: EntitySearchOptions, $type: MovieType, $includeBrandsData: Boolean = false, $includeLocalesData: Boolean = false, $includeSeoData: Boolean = false) {
  movies(
    limit: $limit
    offset: $offset
    search: $search
    type: $type
    orderBy: $orderBy
    directorId: $directorId
    searchIn: $searchIn
    searchSensitivity: $searchSensitivity
  ) {
    totalCount
    nodes {
      __typename
      id
      ref
      activeOnBrands {
        id
        ref
        name
      }
      title
      type
      poster {
        ...Image
      }
      popularity
      productionYear
      brandsData(brandIds: $brandIds) @include(if: $includeBrandsData) {
        brand {
          ref
        }
        title
      }
      localesData(locales: $localeIds) @include(if: $includeLocalesData) {
        title
        locale
      }
      seoData(brandId: $brandId) @include(if: $includeSeoData) {
        ...SeoData
      }
      credits(limit: 3, activities: [DIRECTION_DIRECTOR]) {
        nodes {
          person {
            __typename
            ref
            firstName
            lastName
          }
        }
      }
      metadata {
        ...Metadata
      }
    }
  }
}
    ${ImageFragmentDoc}
${SeoDataFragmentDoc}
${MetadataFragmentDoc}`;

/**
 * __useGetMovieListQuery__
 *
 * To run a query within a React component, call `useGetMovieListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      directorId: // value for 'directorId'
 *      brandIds: // value for 'brandIds'
 *      brandId: // value for 'brandId'
 *      localeIds: // value for 'localeIds'
 *      searchIn: // value for 'searchIn'
 *      searchSensitivity: // value for 'searchSensitivity'
 *      type: // value for 'type'
 *      includeBrandsData: // value for 'includeBrandsData'
 *      includeLocalesData: // value for 'includeLocalesData'
 *      includeSeoData: // value for 'includeSeoData'
 *   },
 * });
 */
export function useGetMovieListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieListQuery, Generated.GetMovieListQueryVariables> & ({ variables: Generated.GetMovieListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieListQuery, Generated.GetMovieListQueryVariables>(GetMovieListDocument, options);
      }
export function useGetMovieListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieListQuery, Generated.GetMovieListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieListQuery, Generated.GetMovieListQueryVariables>(GetMovieListDocument, options);
        }
export function useGetMovieListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieListQuery, Generated.GetMovieListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieListQuery, Generated.GetMovieListQueryVariables>(GetMovieListDocument, options);
        }
export type GetMovieListQueryHookResult = ReturnType<typeof useGetMovieListQuery>;
export type GetMovieListLazyQueryHookResult = ReturnType<typeof useGetMovieListLazyQuery>;
export type GetMovieListSuspenseQueryHookResult = ReturnType<typeof useGetMovieListSuspenseQuery>;
export type GetMovieListQueryResult = Apollo.QueryResult<Generated.GetMovieListQuery, Generated.GetMovieListQueryVariables>;
export const GetMovieMetadataDocument = /*#__PURE__*/ gql`
    query getMovieMetadata($ref: ID!, $brandIds: [ID!], $localeIds: [ID!], $includeBrandData: Boolean = false, $includeLocalesData: Boolean = false) {
  entityByRef(type: MOVIE, ref: $ref) {
    __typename
    ... on Movie {
      ...MovieMetadataEntity
    }
  }
}
    ${MovieMetadataEntityFragmentDoc}`;

/**
 * __useGetMovieMetadataQuery__
 *
 * To run a query within a React component, call `useGetMovieMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      brandIds: // value for 'brandIds'
 *      localeIds: // value for 'localeIds'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocalesData: // value for 'includeLocalesData'
 *   },
 * });
 */
export function useGetMovieMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieMetadataQuery, Generated.GetMovieMetadataQueryVariables> & ({ variables: Generated.GetMovieMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieMetadataQuery, Generated.GetMovieMetadataQueryVariables>(GetMovieMetadataDocument, options);
      }
export function useGetMovieMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieMetadataQuery, Generated.GetMovieMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieMetadataQuery, Generated.GetMovieMetadataQueryVariables>(GetMovieMetadataDocument, options);
        }
export function useGetMovieMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieMetadataQuery, Generated.GetMovieMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieMetadataQuery, Generated.GetMovieMetadataQueryVariables>(GetMovieMetadataDocument, options);
        }
export type GetMovieMetadataQueryHookResult = ReturnType<typeof useGetMovieMetadataQuery>;
export type GetMovieMetadataLazyQueryHookResult = ReturnType<typeof useGetMovieMetadataLazyQuery>;
export type GetMovieMetadataSuspenseQueryHookResult = ReturnType<typeof useGetMovieMetadataSuspenseQuery>;
export type GetMovieMetadataQueryResult = Apollo.QueryResult<Generated.GetMovieMetadataQuery, Generated.GetMovieMetadataQueryVariables>;
export const GetMovieLocalizedDataDocument = /*#__PURE__*/ gql`
    query getMovieLocalizedData($id: ID!, $locale: ID!) {
  movie(id: $id) {
    id
    localeData(locale: $locale) {
      ...MovieLocalizedData
    }
  }
}
    ${MovieLocalizedDataFragmentDoc}`;

/**
 * __useGetMovieLocalizedDataQuery__
 *
 * To run a query within a React component, call `useGetMovieLocalizedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieLocalizedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieLocalizedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMovieLocalizedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieLocalizedDataQuery, Generated.GetMovieLocalizedDataQueryVariables> & ({ variables: Generated.GetMovieLocalizedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieLocalizedDataQuery, Generated.GetMovieLocalizedDataQueryVariables>(GetMovieLocalizedDataDocument, options);
      }
export function useGetMovieLocalizedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieLocalizedDataQuery, Generated.GetMovieLocalizedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieLocalizedDataQuery, Generated.GetMovieLocalizedDataQueryVariables>(GetMovieLocalizedDataDocument, options);
        }
export function useGetMovieLocalizedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieLocalizedDataQuery, Generated.GetMovieLocalizedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieLocalizedDataQuery, Generated.GetMovieLocalizedDataQueryVariables>(GetMovieLocalizedDataDocument, options);
        }
export type GetMovieLocalizedDataQueryHookResult = ReturnType<typeof useGetMovieLocalizedDataQuery>;
export type GetMovieLocalizedDataLazyQueryHookResult = ReturnType<typeof useGetMovieLocalizedDataLazyQuery>;
export type GetMovieLocalizedDataSuspenseQueryHookResult = ReturnType<typeof useGetMovieLocalizedDataSuspenseQuery>;
export type GetMovieLocalizedDataQueryResult = Apollo.QueryResult<Generated.GetMovieLocalizedDataQuery, Generated.GetMovieLocalizedDataQueryVariables>;
export const GetMoviePersonCreditsImportDocument = /*#__PURE__*/ gql`
    query getMoviePersonCreditsImport($id: ID!, $reportId: ID) {
  movie(id: $id) {
    id
    personCreditsImport(id: $reportId) {
      ...PersonCreditsImportReport
    }
    personCreditsImports {
      ...PersonCreditsImportReportSummary
    }
  }
}
    ${PersonCreditsImportReportFragmentDoc}
${PersonCreditsImportReportSummaryFragmentDoc}`;

/**
 * __useGetMoviePersonCreditsImportQuery__
 *
 * To run a query within a React component, call `useGetMoviePersonCreditsImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoviePersonCreditsImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoviePersonCreditsImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetMoviePersonCreditsImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMoviePersonCreditsImportQuery, Generated.GetMoviePersonCreditsImportQueryVariables> & ({ variables: Generated.GetMoviePersonCreditsImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMoviePersonCreditsImportQuery, Generated.GetMoviePersonCreditsImportQueryVariables>(GetMoviePersonCreditsImportDocument, options);
      }
export function useGetMoviePersonCreditsImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMoviePersonCreditsImportQuery, Generated.GetMoviePersonCreditsImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMoviePersonCreditsImportQuery, Generated.GetMoviePersonCreditsImportQueryVariables>(GetMoviePersonCreditsImportDocument, options);
        }
export function useGetMoviePersonCreditsImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMoviePersonCreditsImportQuery, Generated.GetMoviePersonCreditsImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMoviePersonCreditsImportQuery, Generated.GetMoviePersonCreditsImportQueryVariables>(GetMoviePersonCreditsImportDocument, options);
        }
export type GetMoviePersonCreditsImportQueryHookResult = ReturnType<typeof useGetMoviePersonCreditsImportQuery>;
export type GetMoviePersonCreditsImportLazyQueryHookResult = ReturnType<typeof useGetMoviePersonCreditsImportLazyQuery>;
export type GetMoviePersonCreditsImportSuspenseQueryHookResult = ReturnType<typeof useGetMoviePersonCreditsImportSuspenseQuery>;
export type GetMoviePersonCreditsImportQueryResult = Apollo.QueryResult<Generated.GetMoviePersonCreditsImportQuery, Generated.GetMoviePersonCreditsImportQueryVariables>;
export const GetMovieReleaseDocument = /*#__PURE__*/ gql`
    query getMovieRelease($ref: ID!) {
  releaseByRef(entityType: MOVIE, ref: $ref) {
    ...MovieReleaseNav
    ...MovieRelease
    ...MovieReleaseMetadata
  }
}
    ${MovieReleaseNavFragmentDoc}
${MovieReleaseFragmentDoc}
${MovieReleaseMetadataFragmentDoc}`;

/**
 * __useGetMovieReleaseQuery__
 *
 * To run a query within a React component, call `useGetMovieReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieReleaseQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetMovieReleaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieReleaseQuery, Generated.GetMovieReleaseQueryVariables> & ({ variables: Generated.GetMovieReleaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieReleaseQuery, Generated.GetMovieReleaseQueryVariables>(GetMovieReleaseDocument, options);
      }
export function useGetMovieReleaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieReleaseQuery, Generated.GetMovieReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieReleaseQuery, Generated.GetMovieReleaseQueryVariables>(GetMovieReleaseDocument, options);
        }
export function useGetMovieReleaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieReleaseQuery, Generated.GetMovieReleaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieReleaseQuery, Generated.GetMovieReleaseQueryVariables>(GetMovieReleaseDocument, options);
        }
export type GetMovieReleaseQueryHookResult = ReturnType<typeof useGetMovieReleaseQuery>;
export type GetMovieReleaseLazyQueryHookResult = ReturnType<typeof useGetMovieReleaseLazyQuery>;
export type GetMovieReleaseSuspenseQueryHookResult = ReturnType<typeof useGetMovieReleaseSuspenseQuery>;
export type GetMovieReleaseQueryResult = Apollo.QueryResult<Generated.GetMovieReleaseQuery, Generated.GetMovieReleaseQueryVariables>;
export const MovieSimilaritiesDocument = /*#__PURE__*/ gql`
    query MovieSimilarities($movieId: ID!) {
  movie(id: $movieId) {
    id
    entityLinks(linkType: SIMILAR) {
      target {
        ...MovieSimilarEntity
      }
    }
  }
}
    ${MovieSimilarEntityFragmentDoc}`;

/**
 * __useMovieSimilaritiesQuery__
 *
 * To run a query within a React component, call `useMovieSimilaritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovieSimilaritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovieSimilaritiesQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useMovieSimilaritiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.MovieSimilaritiesQuery, Generated.MovieSimilaritiesQueryVariables> & ({ variables: Generated.MovieSimilaritiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.MovieSimilaritiesQuery, Generated.MovieSimilaritiesQueryVariables>(MovieSimilaritiesDocument, options);
      }
export function useMovieSimilaritiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.MovieSimilaritiesQuery, Generated.MovieSimilaritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.MovieSimilaritiesQuery, Generated.MovieSimilaritiesQueryVariables>(MovieSimilaritiesDocument, options);
        }
export function useMovieSimilaritiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.MovieSimilaritiesQuery, Generated.MovieSimilaritiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.MovieSimilaritiesQuery, Generated.MovieSimilaritiesQueryVariables>(MovieSimilaritiesDocument, options);
        }
export type MovieSimilaritiesQueryHookResult = ReturnType<typeof useMovieSimilaritiesQuery>;
export type MovieSimilaritiesLazyQueryHookResult = ReturnType<typeof useMovieSimilaritiesLazyQuery>;
export type MovieSimilaritiesSuspenseQueryHookResult = ReturnType<typeof useMovieSimilaritiesSuspenseQuery>;
export type MovieSimilaritiesQueryResult = Apollo.QueryResult<Generated.MovieSimilaritiesQuery, Generated.MovieSimilaritiesQueryVariables>;
export const GetMovieShowtimesEmbargosDocument = /*#__PURE__*/ gql`
    query getMovieShowtimesEmbargos($movieId: ID!) {
  movie(id: $movieId) {
    id
    showtimesEmbargos {
      id
      country {
        ...CountryOption
      }
      publicAt
      bookableAt
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useGetMovieShowtimesEmbargosQuery__
 *
 * To run a query within a React component, call `useGetMovieShowtimesEmbargosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieShowtimesEmbargosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieShowtimesEmbargosQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useGetMovieShowtimesEmbargosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieShowtimesEmbargosQuery, Generated.GetMovieShowtimesEmbargosQueryVariables> & ({ variables: Generated.GetMovieShowtimesEmbargosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieShowtimesEmbargosQuery, Generated.GetMovieShowtimesEmbargosQueryVariables>(GetMovieShowtimesEmbargosDocument, options);
      }
export function useGetMovieShowtimesEmbargosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieShowtimesEmbargosQuery, Generated.GetMovieShowtimesEmbargosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieShowtimesEmbargosQuery, Generated.GetMovieShowtimesEmbargosQueryVariables>(GetMovieShowtimesEmbargosDocument, options);
        }
export function useGetMovieShowtimesEmbargosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieShowtimesEmbargosQuery, Generated.GetMovieShowtimesEmbargosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieShowtimesEmbargosQuery, Generated.GetMovieShowtimesEmbargosQueryVariables>(GetMovieShowtimesEmbargosDocument, options);
        }
export type GetMovieShowtimesEmbargosQueryHookResult = ReturnType<typeof useGetMovieShowtimesEmbargosQuery>;
export type GetMovieShowtimesEmbargosLazyQueryHookResult = ReturnType<typeof useGetMovieShowtimesEmbargosLazyQuery>;
export type GetMovieShowtimesEmbargosSuspenseQueryHookResult = ReturnType<typeof useGetMovieShowtimesEmbargosSuspenseQuery>;
export type GetMovieShowtimesEmbargosQueryResult = Apollo.QueryResult<Generated.GetMovieShowtimesEmbargosQuery, Generated.GetMovieShowtimesEmbargosQueryVariables>;
export const GetMovieSyncInfoDocument = /*#__PURE__*/ gql`
    query getMovieSyncInfo($id: ID!) {
  movie(id: $id) {
    ...MovieSyncInfo
  }
}
    ${MovieSyncInfoFragmentDoc}`;

/**
 * __useGetMovieSyncInfoQuery__
 *
 * To run a query within a React component, call `useGetMovieSyncInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieSyncInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieSyncInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovieSyncInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieSyncInfoQuery, Generated.GetMovieSyncInfoQueryVariables> & ({ variables: Generated.GetMovieSyncInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieSyncInfoQuery, Generated.GetMovieSyncInfoQueryVariables>(GetMovieSyncInfoDocument, options);
      }
export function useGetMovieSyncInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieSyncInfoQuery, Generated.GetMovieSyncInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieSyncInfoQuery, Generated.GetMovieSyncInfoQueryVariables>(GetMovieSyncInfoDocument, options);
        }
export function useGetMovieSyncInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieSyncInfoQuery, Generated.GetMovieSyncInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieSyncInfoQuery, Generated.GetMovieSyncInfoQueryVariables>(GetMovieSyncInfoDocument, options);
        }
export type GetMovieSyncInfoQueryHookResult = ReturnType<typeof useGetMovieSyncInfoQuery>;
export type GetMovieSyncInfoLazyQueryHookResult = ReturnType<typeof useGetMovieSyncInfoLazyQuery>;
export type GetMovieSyncInfoSuspenseQueryHookResult = ReturnType<typeof useGetMovieSyncInfoSuspenseQuery>;
export type GetMovieSyncInfoQueryResult = Apollo.QueryResult<Generated.GetMovieSyncInfoQuery, Generated.GetMovieSyncInfoQueryVariables>;
export const GetMovieTechnicalInfoDocument = /*#__PURE__*/ gql`
    query getMovieTechnicalInfo($id: ID!) {
  movie(id: $id) {
    ...MovieTechnicalInfo
  }
}
    ${MovieTechnicalInfoFragmentDoc}`;

/**
 * __useGetMovieTechnicalInfoQuery__
 *
 * To run a query within a React component, call `useGetMovieTechnicalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieTechnicalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieTechnicalInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovieTechnicalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieTechnicalInfoQuery, Generated.GetMovieTechnicalInfoQueryVariables> & ({ variables: Generated.GetMovieTechnicalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieTechnicalInfoQuery, Generated.GetMovieTechnicalInfoQueryVariables>(GetMovieTechnicalInfoDocument, options);
      }
export function useGetMovieTechnicalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieTechnicalInfoQuery, Generated.GetMovieTechnicalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieTechnicalInfoQuery, Generated.GetMovieTechnicalInfoQueryVariables>(GetMovieTechnicalInfoDocument, options);
        }
export function useGetMovieTechnicalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieTechnicalInfoQuery, Generated.GetMovieTechnicalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieTechnicalInfoQuery, Generated.GetMovieTechnicalInfoQueryVariables>(GetMovieTechnicalInfoDocument, options);
        }
export type GetMovieTechnicalInfoQueryHookResult = ReturnType<typeof useGetMovieTechnicalInfoQuery>;
export type GetMovieTechnicalInfoLazyQueryHookResult = ReturnType<typeof useGetMovieTechnicalInfoLazyQuery>;
export type GetMovieTechnicalInfoSuspenseQueryHookResult = ReturnType<typeof useGetMovieTechnicalInfoSuspenseQuery>;
export type GetMovieTechnicalInfoQueryResult = Apollo.QueryResult<Generated.GetMovieTechnicalInfoQuery, Generated.GetMovieTechnicalInfoQueryVariables>;
export const GetMovieTagsDocument = /*#__PURE__*/ gql`
    query getMovieTags($movieId: ID!, $brandId: ID!) {
  movie(id: $movieId) {
    id
    tags(limit: 1000, brandId: $brandId) {
      nodes {
        ...EntityTag
      }
    }
  }
}
    ${EntityTagFragmentDoc}`;

/**
 * __useGetMovieTagsQuery__
 *
 * To run a query within a React component, call `useGetMovieTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieTagsQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetMovieTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieTagsQuery, Generated.GetMovieTagsQueryVariables> & ({ variables: Generated.GetMovieTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieTagsQuery, Generated.GetMovieTagsQueryVariables>(GetMovieTagsDocument, options);
      }
export function useGetMovieTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieTagsQuery, Generated.GetMovieTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieTagsQuery, Generated.GetMovieTagsQueryVariables>(GetMovieTagsDocument, options);
        }
export function useGetMovieTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieTagsQuery, Generated.GetMovieTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieTagsQuery, Generated.GetMovieTagsQueryVariables>(GetMovieTagsDocument, options);
        }
export type GetMovieTagsQueryHookResult = ReturnType<typeof useGetMovieTagsQuery>;
export type GetMovieTagsLazyQueryHookResult = ReturnType<typeof useGetMovieTagsLazyQuery>;
export type GetMovieTagsSuspenseQueryHookResult = ReturnType<typeof useGetMovieTagsSuspenseQuery>;
export type GetMovieTagsQueryResult = Apollo.QueryResult<Generated.GetMovieTagsQuery, Generated.GetMovieTagsQueryVariables>;
export const GetMovieVersionsDocument = /*#__PURE__*/ gql`
    query getMovieVersions($movieId: ID!) {
  movie(id: $movieId) {
    id
    versions {
      ...MovieVersion
    }
  }
}
    ${MovieVersionFragmentDoc}`;

/**
 * __useGetMovieVersionsQuery__
 *
 * To run a query within a React component, call `useGetMovieVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieVersionsQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useGetMovieVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieVersionsQuery, Generated.GetMovieVersionsQueryVariables> & ({ variables: Generated.GetMovieVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieVersionsQuery, Generated.GetMovieVersionsQueryVariables>(GetMovieVersionsDocument, options);
      }
export function useGetMovieVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieVersionsQuery, Generated.GetMovieVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieVersionsQuery, Generated.GetMovieVersionsQueryVariables>(GetMovieVersionsDocument, options);
        }
export function useGetMovieVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieVersionsQuery, Generated.GetMovieVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieVersionsQuery, Generated.GetMovieVersionsQueryVariables>(GetMovieVersionsDocument, options);
        }
export type GetMovieVersionsQueryHookResult = ReturnType<typeof useGetMovieVersionsQuery>;
export type GetMovieVersionsLazyQueryHookResult = ReturnType<typeof useGetMovieVersionsLazyQuery>;
export type GetMovieVersionsSuspenseQueryHookResult = ReturnType<typeof useGetMovieVersionsSuspenseQuery>;
export type GetMovieVersionsQueryResult = Apollo.QueryResult<Generated.GetMovieVersionsQuery, Generated.GetMovieVersionsQueryVariables>;
export const GetMovieTriviasDocument = /*#__PURE__*/ gql`
    query getMovieTrivias($id: ID!, $limit: Int, $offset: Int!, $brandId: ID!) {
  movie(id: $id) {
    id
    trivias(limit: $limit, offset: $offset, brandId: $brandId) {
      totalCount
      nodes {
        ...EntityTrivia
      }
    }
  }
}
    ${EntityTriviaFragmentDoc}`;

/**
 * __useGetMovieTriviasQuery__
 *
 * To run a query within a React component, call `useGetMovieTriviasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovieTriviasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovieTriviasQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetMovieTriviasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMovieTriviasQuery, Generated.GetMovieTriviasQueryVariables> & ({ variables: Generated.GetMovieTriviasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMovieTriviasQuery, Generated.GetMovieTriviasQueryVariables>(GetMovieTriviasDocument, options);
      }
export function useGetMovieTriviasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMovieTriviasQuery, Generated.GetMovieTriviasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMovieTriviasQuery, Generated.GetMovieTriviasQueryVariables>(GetMovieTriviasDocument, options);
        }
export function useGetMovieTriviasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMovieTriviasQuery, Generated.GetMovieTriviasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMovieTriviasQuery, Generated.GetMovieTriviasQueryVariables>(GetMovieTriviasDocument, options);
        }
export type GetMovieTriviasQueryHookResult = ReturnType<typeof useGetMovieTriviasQuery>;
export type GetMovieTriviasLazyQueryHookResult = ReturnType<typeof useGetMovieTriviasLazyQuery>;
export type GetMovieTriviasSuspenseQueryHookResult = ReturnType<typeof useGetMovieTriviasSuspenseQuery>;
export type GetMovieTriviasQueryResult = Apollo.QueryResult<Generated.GetMovieTriviasQuery, Generated.GetMovieTriviasQueryVariables>;
export const UpdateMovieBoxofficeDocument = /*#__PURE__*/ gql`
    mutation updateMovieBoxoffice($input: UpdateMovieBoxofficeInput!) {
  updateMovieBoxoffice(input: $input) {
    id
    totalBoxofficeUs
    totalBoxofficeInternational
  }
}
    `;
export type UpdateMovieBoxofficeMutationFn = Apollo.MutationFunction<Generated.UpdateMovieBoxofficeMutation, Generated.UpdateMovieBoxofficeMutationVariables>;

/**
 * __useUpdateMovieBoxofficeMutation__
 *
 * To run a mutation, you first call `useUpdateMovieBoxofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovieBoxofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovieBoxofficeMutation, { data, loading, error }] = useUpdateMovieBoxofficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovieBoxofficeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateMovieBoxofficeMutation, Generated.UpdateMovieBoxofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateMovieBoxofficeMutation, Generated.UpdateMovieBoxofficeMutationVariables>(UpdateMovieBoxofficeDocument, options);
      }
export type UpdateMovieBoxofficeMutationHookResult = ReturnType<typeof useUpdateMovieBoxofficeMutation>;
export type UpdateMovieBoxofficeMutationResult = Apollo.MutationResult<Generated.UpdateMovieBoxofficeMutation>;
export type UpdateMovieBoxofficeMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateMovieBoxofficeMutation, Generated.UpdateMovieBoxofficeMutationVariables>;
export const GetMoviesByRefsDocument = /*#__PURE__*/ gql`
    query getMoviesByRefs($refs: [ID!]!) {
  entitiesByRef(type: MOVIE, refs: $refs) {
    ... on Movie {
      __typename
      id
      ref
      title
    }
  }
}
    `;

/**
 * __useGetMoviesByRefsQuery__
 *
 * To run a query within a React component, call `useGetMoviesByRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoviesByRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoviesByRefsQuery({
 *   variables: {
 *      refs: // value for 'refs'
 *   },
 * });
 */
export function useGetMoviesByRefsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMoviesByRefsQuery, Generated.GetMoviesByRefsQueryVariables> & ({ variables: Generated.GetMoviesByRefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMoviesByRefsQuery, Generated.GetMoviesByRefsQueryVariables>(GetMoviesByRefsDocument, options);
      }
export function useGetMoviesByRefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMoviesByRefsQuery, Generated.GetMoviesByRefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMoviesByRefsQuery, Generated.GetMoviesByRefsQueryVariables>(GetMoviesByRefsDocument, options);
        }
export function useGetMoviesByRefsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMoviesByRefsQuery, Generated.GetMoviesByRefsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMoviesByRefsQuery, Generated.GetMoviesByRefsQueryVariables>(GetMoviesByRefsDocument, options);
        }
export type GetMoviesByRefsQueryHookResult = ReturnType<typeof useGetMoviesByRefsQuery>;
export type GetMoviesByRefsLazyQueryHookResult = ReturnType<typeof useGetMoviesByRefsLazyQuery>;
export type GetMoviesByRefsSuspenseQueryHookResult = ReturnType<typeof useGetMoviesByRefsSuspenseQuery>;
export type GetMoviesByRefsQueryResult = Apollo.QueryResult<Generated.GetMoviesByRefsQuery, Generated.GetMoviesByRefsQueryVariables>;
export const GetSlideshowSlideNewsDocument = /*#__PURE__*/ gql`
    query getSlideshowSlideNews($ref: ID!) {
  entityByRef(ref: $ref, type: NEWS) {
    ... on News {
      id
      ref
      type
      brand {
        ...BrandOption
      }
    }
  }
}
    ${BrandOptionFragmentDoc}`;

/**
 * __useGetSlideshowSlideNewsQuery__
 *
 * To run a query within a React component, call `useGetSlideshowSlideNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideshowSlideNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideshowSlideNewsQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSlideshowSlideNewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSlideshowSlideNewsQuery, Generated.GetSlideshowSlideNewsQueryVariables> & ({ variables: Generated.GetSlideshowSlideNewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSlideshowSlideNewsQuery, Generated.GetSlideshowSlideNewsQueryVariables>(GetSlideshowSlideNewsDocument, options);
      }
export function useGetSlideshowSlideNewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSlideshowSlideNewsQuery, Generated.GetSlideshowSlideNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSlideshowSlideNewsQuery, Generated.GetSlideshowSlideNewsQueryVariables>(GetSlideshowSlideNewsDocument, options);
        }
export function useGetSlideshowSlideNewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSlideshowSlideNewsQuery, Generated.GetSlideshowSlideNewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSlideshowSlideNewsQuery, Generated.GetSlideshowSlideNewsQueryVariables>(GetSlideshowSlideNewsDocument, options);
        }
export type GetSlideshowSlideNewsQueryHookResult = ReturnType<typeof useGetSlideshowSlideNewsQuery>;
export type GetSlideshowSlideNewsLazyQueryHookResult = ReturnType<typeof useGetSlideshowSlideNewsLazyQuery>;
export type GetSlideshowSlideNewsSuspenseQueryHookResult = ReturnType<typeof useGetSlideshowSlideNewsSuspenseQuery>;
export type GetSlideshowSlideNewsQueryResult = Apollo.QueryResult<Generated.GetSlideshowSlideNewsQuery, Generated.GetSlideshowSlideNewsQueryVariables>;
export const UpdateMovieBrandedContentDocument = /*#__PURE__*/ gql`
    mutation updateMovieBrandedContent($input: UpdateMovieBrandedContentInput!) {
  updateMovieBrandedContent(input: $input) {
    ...MovieTab
  }
}
    ${MovieTabFragmentDoc}`;
export type UpdateMovieBrandedContentMutationFn = Apollo.MutationFunction<Generated.UpdateMovieBrandedContentMutation, Generated.UpdateMovieBrandedContentMutationVariables>;

/**
 * __useUpdateMovieBrandedContentMutation__
 *
 * To run a mutation, you first call `useUpdateMovieBrandedContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovieBrandedContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovieBrandedContentMutation, { data, loading, error }] = useUpdateMovieBrandedContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovieBrandedContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateMovieBrandedContentMutation, Generated.UpdateMovieBrandedContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateMovieBrandedContentMutation, Generated.UpdateMovieBrandedContentMutationVariables>(UpdateMovieBrandedContentDocument, options);
      }
export type UpdateMovieBrandedContentMutationHookResult = ReturnType<typeof useUpdateMovieBrandedContentMutation>;
export type UpdateMovieBrandedContentMutationResult = Apollo.MutationResult<Generated.UpdateMovieBrandedContentMutation>;
export type UpdateMovieBrandedContentMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateMovieBrandedContentMutation, Generated.UpdateMovieBrandedContentMutationVariables>;
export const UpdateMovieBrandedDataDocument = /*#__PURE__*/ gql`
    mutation updateMovieBrandedData($input: UpdateMovieBrandDataInput!) {
  updateMovieBrandData(input: $input) {
    id
    title
    keywords
    synopsis
    synopsisShort
    poster {
      id
      url
    }
    ruling {
      hasRating
      atRisk
      hasWarningMessage
      hasMandatoryReview
    }
  }
}
    `;
export type UpdateMovieBrandedDataMutationFn = Apollo.MutationFunction<Generated.UpdateMovieBrandedDataMutation, Generated.UpdateMovieBrandedDataMutationVariables>;

/**
 * __useUpdateMovieBrandedDataMutation__
 *
 * To run a mutation, you first call `useUpdateMovieBrandedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovieBrandedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovieBrandedDataMutation, { data, loading, error }] = useUpdateMovieBrandedDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovieBrandedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateMovieBrandedDataMutation, Generated.UpdateMovieBrandedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateMovieBrandedDataMutation, Generated.UpdateMovieBrandedDataMutationVariables>(UpdateMovieBrandedDataDocument, options);
      }
export type UpdateMovieBrandedDataMutationHookResult = ReturnType<typeof useUpdateMovieBrandedDataMutation>;
export type UpdateMovieBrandedDataMutationResult = Apollo.MutationResult<Generated.UpdateMovieBrandedDataMutation>;
export type UpdateMovieBrandedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateMovieBrandedDataMutation, Generated.UpdateMovieBrandedDataMutationVariables>;
export const UpdateMovieLocalizedDataDocument = /*#__PURE__*/ gql`
    mutation updateMovieLocalizedData($input: UpdateMovieLocaleDataInput!) {
  updateMovieLocaleData(input: $input) {
    title
    synopsis
    synopsisShort
    url
    poster {
      id
      url
    }
    quad: image(type: QUAD) {
      id
      url
    }
  }
}
    `;
export type UpdateMovieLocalizedDataMutationFn = Apollo.MutationFunction<Generated.UpdateMovieLocalizedDataMutation, Generated.UpdateMovieLocalizedDataMutationVariables>;

/**
 * __useUpdateMovieLocalizedDataMutation__
 *
 * To run a mutation, you first call `useUpdateMovieLocalizedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovieLocalizedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovieLocalizedDataMutation, { data, loading, error }] = useUpdateMovieLocalizedDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovieLocalizedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateMovieLocalizedDataMutation, Generated.UpdateMovieLocalizedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateMovieLocalizedDataMutation, Generated.UpdateMovieLocalizedDataMutationVariables>(UpdateMovieLocalizedDataDocument, options);
      }
export type UpdateMovieLocalizedDataMutationHookResult = ReturnType<typeof useUpdateMovieLocalizedDataMutation>;
export type UpdateMovieLocalizedDataMutationResult = Apollo.MutationResult<Generated.UpdateMovieLocalizedDataMutation>;
export type UpdateMovieLocalizedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateMovieLocalizedDataMutation, Generated.UpdateMovieLocalizedDataMutationVariables>;
export const UpdateMoviesShowtimesEmbargoDocument = /*#__PURE__*/ gql`
    mutation updateMoviesShowtimesEmbargo($input: UpdateShowtimesEmbargoInput!) {
  updateShowtimesEmbargo(input: $input) {
    id
    bookableAt
    publicAt
  }
}
    `;
export type UpdateMoviesShowtimesEmbargoMutationFn = Apollo.MutationFunction<Generated.UpdateMoviesShowtimesEmbargoMutation, Generated.UpdateMoviesShowtimesEmbargoMutationVariables>;

/**
 * __useUpdateMoviesShowtimesEmbargoMutation__
 *
 * To run a mutation, you first call `useUpdateMoviesShowtimesEmbargoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoviesShowtimesEmbargoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoviesShowtimesEmbargoMutation, { data, loading, error }] = useUpdateMoviesShowtimesEmbargoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMoviesShowtimesEmbargoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateMoviesShowtimesEmbargoMutation, Generated.UpdateMoviesShowtimesEmbargoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateMoviesShowtimesEmbargoMutation, Generated.UpdateMoviesShowtimesEmbargoMutationVariables>(UpdateMoviesShowtimesEmbargoDocument, options);
      }
export type UpdateMoviesShowtimesEmbargoMutationHookResult = ReturnType<typeof useUpdateMoviesShowtimesEmbargoMutation>;
export type UpdateMoviesShowtimesEmbargoMutationResult = Apollo.MutationResult<Generated.UpdateMoviesShowtimesEmbargoMutation>;
export type UpdateMoviesShowtimesEmbargoMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateMoviesShowtimesEmbargoMutation, Generated.UpdateMoviesShowtimesEmbargoMutationVariables>;
export const UpdateReleaseDocument = /*#__PURE__*/ gql`
    mutation updateRelease($input: UpdateReleaseInput!) {
  updateRelease(input: $input) {
    ...MovieRelease
  }
}
    ${MovieReleaseFragmentDoc}`;
export type UpdateReleaseMutationFn = Apollo.MutationFunction<Generated.UpdateReleaseMutation, Generated.UpdateReleaseMutationVariables>;

/**
 * __useUpdateReleaseMutation__
 *
 * To run a mutation, you first call `useUpdateReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReleaseMutation, { data, loading, error }] = useUpdateReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateReleaseMutation, Generated.UpdateReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateReleaseMutation, Generated.UpdateReleaseMutationVariables>(UpdateReleaseDocument, options);
      }
export type UpdateReleaseMutationHookResult = ReturnType<typeof useUpdateReleaseMutation>;
export type UpdateReleaseMutationResult = Apollo.MutationResult<Generated.UpdateReleaseMutation>;
export type UpdateReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateReleaseMutation, Generated.UpdateReleaseMutationVariables>;
export const UpdateMovieDocument = /*#__PURE__*/ gql`
    mutation updateMovie($input: UpdateMovieInput!) {
  updateMovie(input: $input) {
    id
    ...MovieFullIdentity
    ...MovieMetadata
  }
}
    ${MovieFullIdentityFragmentDoc}
${MovieMetadataFragmentDoc}`;
export type UpdateMovieMutationFn = Apollo.MutationFunction<Generated.UpdateMovieMutation, Generated.UpdateMovieMutationVariables>;

/**
 * __useUpdateMovieMutation__
 *
 * To run a mutation, you first call `useUpdateMovieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovieMutation, { data, loading, error }] = useUpdateMovieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovieMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateMovieMutation, Generated.UpdateMovieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateMovieMutation, Generated.UpdateMovieMutationVariables>(UpdateMovieDocument, options);
      }
export type UpdateMovieMutationHookResult = ReturnType<typeof useUpdateMovieMutation>;
export type UpdateMovieMutationResult = Apollo.MutationResult<Generated.UpdateMovieMutation>;
export type UpdateMovieMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateMovieMutation, Generated.UpdateMovieMutationVariables>;
export const UpdateMovieVersionDocument = /*#__PURE__*/ gql`
    mutation updateMovieVersion($input: UpdateMovieVersionInput!) {
  updateMovieVersion(input: $input) {
    ...MovieVersion
  }
}
    ${MovieVersionFragmentDoc}`;
export type UpdateMovieVersionMutationFn = Apollo.MutationFunction<Generated.UpdateMovieVersionMutation, Generated.UpdateMovieVersionMutationVariables>;

/**
 * __useUpdateMovieVersionMutation__
 *
 * To run a mutation, you first call `useUpdateMovieVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovieVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovieVersionMutation, { data, loading, error }] = useUpdateMovieVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovieVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateMovieVersionMutation, Generated.UpdateMovieVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateMovieVersionMutation, Generated.UpdateMovieVersionMutationVariables>(UpdateMovieVersionDocument, options);
      }
export type UpdateMovieVersionMutationHookResult = ReturnType<typeof useUpdateMovieVersionMutation>;
export type UpdateMovieVersionMutationResult = Apollo.MutationResult<Generated.UpdateMovieVersionMutation>;
export type UpdateMovieVersionMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateMovieVersionMutation, Generated.UpdateMovieVersionMutationVariables>;
export const AllowedNewsScopesDocument = /*#__PURE__*/ gql`
    query AllowedNewsScopes {
  viewer {
    id
    admin
    allowedNewsScopes
  }
}
    `;

/**
 * __useAllowedNewsScopesQuery__
 *
 * To run a query within a React component, call `useAllowedNewsScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedNewsScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedNewsScopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowedNewsScopesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.AllowedNewsScopesQuery, Generated.AllowedNewsScopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.AllowedNewsScopesQuery, Generated.AllowedNewsScopesQueryVariables>(AllowedNewsScopesDocument, options);
      }
export function useAllowedNewsScopesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.AllowedNewsScopesQuery, Generated.AllowedNewsScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.AllowedNewsScopesQuery, Generated.AllowedNewsScopesQueryVariables>(AllowedNewsScopesDocument, options);
        }
export function useAllowedNewsScopesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.AllowedNewsScopesQuery, Generated.AllowedNewsScopesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.AllowedNewsScopesQuery, Generated.AllowedNewsScopesQueryVariables>(AllowedNewsScopesDocument, options);
        }
export type AllowedNewsScopesQueryHookResult = ReturnType<typeof useAllowedNewsScopesQuery>;
export type AllowedNewsScopesLazyQueryHookResult = ReturnType<typeof useAllowedNewsScopesLazyQuery>;
export type AllowedNewsScopesSuspenseQueryHookResult = ReturnType<typeof useAllowedNewsScopesSuspenseQuery>;
export type AllowedNewsScopesQueryResult = Apollo.QueryResult<Generated.AllowedNewsScopesQuery, Generated.AllowedNewsScopesQueryVariables>;
export const CreateNewsPageDocument = /*#__PURE__*/ gql`
    mutation createNewsPage($input: CreateNewsPageInput!) {
  createNewsPage(input: $input) {
    id
    news {
      id
      ...NewsPages
    }
  }
}
    ${NewsPagesFragmentDoc}`;
export type CreateNewsPageMutationFn = Apollo.MutationFunction<Generated.CreateNewsPageMutation, Generated.CreateNewsPageMutationVariables>;

/**
 * __useCreateNewsPageMutation__
 *
 * To run a mutation, you first call `useCreateNewsPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsPageMutation, { data, loading, error }] = useCreateNewsPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewsPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateNewsPageMutation, Generated.CreateNewsPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateNewsPageMutation, Generated.CreateNewsPageMutationVariables>(CreateNewsPageDocument, options);
      }
export type CreateNewsPageMutationHookResult = ReturnType<typeof useCreateNewsPageMutation>;
export type CreateNewsPageMutationResult = Apollo.MutationResult<Generated.CreateNewsPageMutation>;
export type CreateNewsPageMutationOptions = Apollo.BaseMutationOptions<Generated.CreateNewsPageMutation, Generated.CreateNewsPageMutationVariables>;
export const CreateNewsDocument = /*#__PURE__*/ gql`
    mutation createNews($input: CreateNewsInput!) {
  createNews(input: $input) {
    id
    ref
  }
}
    `;
export type CreateNewsMutationFn = Apollo.MutationFunction<Generated.CreateNewsMutation, Generated.CreateNewsMutationVariables>;

/**
 * __useCreateNewsMutation__
 *
 * To run a mutation, you first call `useCreateNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsMutation, { data, loading, error }] = useCreateNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateNewsMutation, Generated.CreateNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateNewsMutation, Generated.CreateNewsMutationVariables>(CreateNewsDocument, options);
      }
export type CreateNewsMutationHookResult = ReturnType<typeof useCreateNewsMutation>;
export type CreateNewsMutationResult = Apollo.MutationResult<Generated.CreateNewsMutation>;
export type CreateNewsMutationOptions = Apollo.BaseMutationOptions<Generated.CreateNewsMutation, Generated.CreateNewsMutationVariables>;
export const CreateSlideshowSlideDocument = /*#__PURE__*/ gql`
    mutation createSlideshowSlide($input: CreateSlideshowSlideInput!) {
  createSlideshowSlide(input: $input) {
    ...SlideshowSlideIdentity
  }
}
    ${SlideshowSlideIdentityFragmentDoc}`;
export type CreateSlideshowSlideMutationFn = Apollo.MutationFunction<Generated.CreateSlideshowSlideMutation, Generated.CreateSlideshowSlideMutationVariables>;

/**
 * __useCreateSlideshowSlideMutation__
 *
 * To run a mutation, you first call `useCreateSlideshowSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlideshowSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlideshowSlideMutation, { data, loading, error }] = useCreateSlideshowSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlideshowSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSlideshowSlideMutation, Generated.CreateSlideshowSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSlideshowSlideMutation, Generated.CreateSlideshowSlideMutationVariables>(CreateSlideshowSlideDocument, options);
      }
export type CreateSlideshowSlideMutationHookResult = ReturnType<typeof useCreateSlideshowSlideMutation>;
export type CreateSlideshowSlideMutationResult = Apollo.MutationResult<Generated.CreateSlideshowSlideMutation>;
export type CreateSlideshowSlideMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSlideshowSlideMutation, Generated.CreateSlideshowSlideMutationVariables>;
export const DeleteNewsPageDocument = /*#__PURE__*/ gql`
    mutation deleteNewsPage($input: DeleteNewsPageInput!) {
  deleteNewsPage(input: $input) {
    id
    news {
      id
      ...NewsPages
    }
  }
}
    ${NewsPagesFragmentDoc}`;
export type DeleteNewsPageMutationFn = Apollo.MutationFunction<Generated.DeleteNewsPageMutation, Generated.DeleteNewsPageMutationVariables>;

/**
 * __useDeleteNewsPageMutation__
 *
 * To run a mutation, you first call `useDeleteNewsPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewsPageMutation, { data, loading, error }] = useDeleteNewsPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNewsPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteNewsPageMutation, Generated.DeleteNewsPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteNewsPageMutation, Generated.DeleteNewsPageMutationVariables>(DeleteNewsPageDocument, options);
      }
export type DeleteNewsPageMutationHookResult = ReturnType<typeof useDeleteNewsPageMutation>;
export type DeleteNewsPageMutationResult = Apollo.MutationResult<Generated.DeleteNewsPageMutation>;
export type DeleteNewsPageMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteNewsPageMutation, Generated.DeleteNewsPageMutationVariables>;
export const DeleteNewsDocument = /*#__PURE__*/ gql`
    mutation deleteNews($input: DeleteNewsInput!) {
  deleteNews(input: $input) {
    id
  }
}
    `;
export type DeleteNewsMutationFn = Apollo.MutationFunction<Generated.DeleteNewsMutation, Generated.DeleteNewsMutationVariables>;

/**
 * __useDeleteNewsMutation__
 *
 * To run a mutation, you first call `useDeleteNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewsMutation, { data, loading, error }] = useDeleteNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteNewsMutation, Generated.DeleteNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteNewsMutation, Generated.DeleteNewsMutationVariables>(DeleteNewsDocument, options);
      }
export type DeleteNewsMutationHookResult = ReturnType<typeof useDeleteNewsMutation>;
export type DeleteNewsMutationResult = Apollo.MutationResult<Generated.DeleteNewsMutation>;
export type DeleteNewsMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteNewsMutation, Generated.DeleteNewsMutationVariables>;
export const GetAiArticleContentDocument = /*#__PURE__*/ gql`
    query getAIArticleContent($aiSkillId: ID!, $articleId: ID, $brandId: ID, $category: String, $universe: String, $title: String, $description: String, $keywords: [String!]) {
  aiArticleContent: getAIArticleContent(
    aiSkillId: $aiSkillId
    articleId: $articleId
    brandId: $brandId
    category: $category
    universe: $universe
    title: $title
    description: $description
    keywords: $keywords
  ) {
    title
    description
    keywords
    aiMetadata {
      promptTokenCount
      totalTokenCount
    }
  }
}
    `;

/**
 * __useGetAiArticleContentQuery__
 *
 * To run a query within a React component, call `useGetAiArticleContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiArticleContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiArticleContentQuery({
 *   variables: {
 *      aiSkillId: // value for 'aiSkillId'
 *      articleId: // value for 'articleId'
 *      brandId: // value for 'brandId'
 *      category: // value for 'category'
 *      universe: // value for 'universe'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      keywords: // value for 'keywords'
 *   },
 * });
 */
export function useGetAiArticleContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetAiArticleContentQuery, Generated.GetAiArticleContentQueryVariables> & ({ variables: Generated.GetAiArticleContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetAiArticleContentQuery, Generated.GetAiArticleContentQueryVariables>(GetAiArticleContentDocument, options);
      }
export function useGetAiArticleContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetAiArticleContentQuery, Generated.GetAiArticleContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetAiArticleContentQuery, Generated.GetAiArticleContentQueryVariables>(GetAiArticleContentDocument, options);
        }
export function useGetAiArticleContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetAiArticleContentQuery, Generated.GetAiArticleContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetAiArticleContentQuery, Generated.GetAiArticleContentQueryVariables>(GetAiArticleContentDocument, options);
        }
export type GetAiArticleContentQueryHookResult = ReturnType<typeof useGetAiArticleContentQuery>;
export type GetAiArticleContentLazyQueryHookResult = ReturnType<typeof useGetAiArticleContentLazyQuery>;
export type GetAiArticleContentSuspenseQueryHookResult = ReturnType<typeof useGetAiArticleContentSuspenseQuery>;
export type GetAiArticleContentQueryResult = Apollo.QueryResult<Generated.GetAiArticleContentQuery, Generated.GetAiArticleContentQueryVariables>;
export const DeleteSlideshowSlideDocument = /*#__PURE__*/ gql`
    mutation deleteSlideshowSlide($input: DeleteSlideshowSlideInput!) {
  deleteSlideshowSlide(input: $input) {
    ...SlideshowSlideIdentity
  }
}
    ${SlideshowSlideIdentityFragmentDoc}`;
export type DeleteSlideshowSlideMutationFn = Apollo.MutationFunction<Generated.DeleteSlideshowSlideMutation, Generated.DeleteSlideshowSlideMutationVariables>;

/**
 * __useDeleteSlideshowSlideMutation__
 *
 * To run a mutation, you first call `useDeleteSlideshowSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSlideshowSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSlideshowSlideMutation, { data, loading, error }] = useDeleteSlideshowSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSlideshowSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteSlideshowSlideMutation, Generated.DeleteSlideshowSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteSlideshowSlideMutation, Generated.DeleteSlideshowSlideMutationVariables>(DeleteSlideshowSlideDocument, options);
      }
export type DeleteSlideshowSlideMutationHookResult = ReturnType<typeof useDeleteSlideshowSlideMutation>;
export type DeleteSlideshowSlideMutationResult = Apollo.MutationResult<Generated.DeleteSlideshowSlideMutation>;
export type DeleteSlideshowSlideMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteSlideshowSlideMutation, Generated.DeleteSlideshowSlideMutationVariables>;
export const GetAiSkillsDocument = /*#__PURE__*/ gql`
    query getAISkills($entityType: AISkillEntityType!, $code: AISkillCode!) {
  aiSkills: getAISkills(entityType: $entityType, code: $code) {
    id
    entityType
    code
    version
    isDefault
    model
    displayLabel
  }
}
    `;

/**
 * __useGetAiSkillsQuery__
 *
 * To run a query within a React component, call `useGetAiSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiSkillsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetAiSkillsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetAiSkillsQuery, Generated.GetAiSkillsQueryVariables> & ({ variables: Generated.GetAiSkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetAiSkillsQuery, Generated.GetAiSkillsQueryVariables>(GetAiSkillsDocument, options);
      }
export function useGetAiSkillsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetAiSkillsQuery, Generated.GetAiSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetAiSkillsQuery, Generated.GetAiSkillsQueryVariables>(GetAiSkillsDocument, options);
        }
export function useGetAiSkillsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetAiSkillsQuery, Generated.GetAiSkillsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetAiSkillsQuery, Generated.GetAiSkillsQueryVariables>(GetAiSkillsDocument, options);
        }
export type GetAiSkillsQueryHookResult = ReturnType<typeof useGetAiSkillsQuery>;
export type GetAiSkillsLazyQueryHookResult = ReturnType<typeof useGetAiSkillsLazyQuery>;
export type GetAiSkillsSuspenseQueryHookResult = ReturnType<typeof useGetAiSkillsSuspenseQuery>;
export type GetAiSkillsQueryResult = Apollo.QueryResult<Generated.GetAiSkillsQuery, Generated.GetAiSkillsQueryVariables>;
export const GetNewsAdditionalInfoDocument = /*#__PURE__*/ gql`
    query getNewsAdditionalInfo($newsId: ID!) {
  news(id: $newsId) {
    ref
    active
    universe
    ...NewsMetadata
    ...NewsAuthors
    ...NewsTagList
  }
}
    ${NewsMetadataFragmentDoc}
${NewsAuthorsFragmentDoc}
${NewsTagListFragmentDoc}`;

/**
 * __useGetNewsAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useGetNewsAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsAdditionalInfoQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *   },
 * });
 */
export function useGetNewsAdditionalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsAdditionalInfoQuery, Generated.GetNewsAdditionalInfoQueryVariables> & ({ variables: Generated.GetNewsAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsAdditionalInfoQuery, Generated.GetNewsAdditionalInfoQueryVariables>(GetNewsAdditionalInfoDocument, options);
      }
export function useGetNewsAdditionalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsAdditionalInfoQuery, Generated.GetNewsAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsAdditionalInfoQuery, Generated.GetNewsAdditionalInfoQueryVariables>(GetNewsAdditionalInfoDocument, options);
        }
export function useGetNewsAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsAdditionalInfoQuery, Generated.GetNewsAdditionalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsAdditionalInfoQuery, Generated.GetNewsAdditionalInfoQueryVariables>(GetNewsAdditionalInfoDocument, options);
        }
export type GetNewsAdditionalInfoQueryHookResult = ReturnType<typeof useGetNewsAdditionalInfoQuery>;
export type GetNewsAdditionalInfoLazyQueryHookResult = ReturnType<typeof useGetNewsAdditionalInfoLazyQuery>;
export type GetNewsAdditionalInfoSuspenseQueryHookResult = ReturnType<typeof useGetNewsAdditionalInfoSuspenseQuery>;
export type GetNewsAdditionalInfoQueryResult = Apollo.QueryResult<Generated.GetNewsAdditionalInfoQuery, Generated.GetNewsAdditionalInfoQueryVariables>;
export const GetNewsChecklistDocument = /*#__PURE__*/ gql`
    query getNewsChecklist($newsId: ID!, $brandId: ID!, $excludedTypes: [NewsLinkableEntityType!], $includedTypes: [NewsLinkableEntityType!]) {
  news(id: $newsId) {
    id
    active
    pages {
      id
      body
    }
    ...NewsIdentity
    ...NewsMainImage
    ...NewsAuthors
    ...NewsPublications
    isUpdatedWhenPublished
    tags(limit: 0, offset: 0, brandId: $brandId) {
      totalCount
    }
    relatedNews: relatedEntities(includedTypes: [NEWS]) {
      ... on News {
        id
        ref
        title
      }
    }
    relatedEntities(excludedTypes: $excludedTypes, includedTypes: $includedTypes) {
      __typename
      ... on Movie {
        id
        ref
        title
      }
      ... on Series {
        id
        ref
        title
      }
      ... on Person {
        id
        ref
        firstName
        lastName
      }
      ... on SeriesSeason {
        id
        ref
        number
        series {
          id
          ref
          title
        }
      }
      ... on Festival {
        id
        ref
      }
      ... on FestivalEdition {
        id
        ref
      }
      ... on SeriesEpisode {
        id
        ref
        episodeNumber: number
        season {
          id
          ref
          number
        }
        series {
          id
          ref
          title
        }
      }
      ... on News {
        id
        ref
      }
    }
    ...NewsTracking
  }
}
    ${NewsIdentityFragmentDoc}
${NewsMainImageFragmentDoc}
${NewsAuthorsFragmentDoc}
${NewsPublicationsFragmentDoc}
${NewsTrackingFragmentDoc}`;

/**
 * __useGetNewsChecklistQuery__
 *
 * To run a query within a React component, call `useGetNewsChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsChecklistQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *      brandId: // value for 'brandId'
 *      excludedTypes: // value for 'excludedTypes'
 *      includedTypes: // value for 'includedTypes'
 *   },
 * });
 */
export function useGetNewsChecklistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsChecklistQuery, Generated.GetNewsChecklistQueryVariables> & ({ variables: Generated.GetNewsChecklistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsChecklistQuery, Generated.GetNewsChecklistQueryVariables>(GetNewsChecklistDocument, options);
      }
export function useGetNewsChecklistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsChecklistQuery, Generated.GetNewsChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsChecklistQuery, Generated.GetNewsChecklistQueryVariables>(GetNewsChecklistDocument, options);
        }
export function useGetNewsChecklistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsChecklistQuery, Generated.GetNewsChecklistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsChecklistQuery, Generated.GetNewsChecklistQueryVariables>(GetNewsChecklistDocument, options);
        }
export type GetNewsChecklistQueryHookResult = ReturnType<typeof useGetNewsChecklistQuery>;
export type GetNewsChecklistLazyQueryHookResult = ReturnType<typeof useGetNewsChecklistLazyQuery>;
export type GetNewsChecklistSuspenseQueryHookResult = ReturnType<typeof useGetNewsChecklistSuspenseQuery>;
export type GetNewsChecklistQueryResult = Apollo.QueryResult<Generated.GetNewsChecklistQuery, Generated.GetNewsChecklistQueryVariables>;
export const GetNewsListDocument = /*#__PURE__*/ gql`
    query getNewsList($limit: Int, $offset: Int!, $orderBy: NewsOrder!, $search: String, $brandId: ID, $authorIds: [ID!], $tagId: ID, $relatedEntityId: ID, $type: NewsType, $publicationStatus: EntityPublicationStatus, $universes: [NewsUniverse], $range: DateRangeInput) {
  newsList(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    search: $search
    brandId: $brandId
    authorIds: $authorIds
    tagId: $tagId
    relatedEntityId: $relatedEntityId
    publicationStatus: $publicationStatus
    type: $type
    universes: $universes
    range: $range
  ) {
    totalCount
    nodes {
      ...NewsRow
    }
  }
}
    ${NewsRowFragmentDoc}`;

/**
 * __useGetNewsListQuery__
 *
 * To run a query within a React component, call `useGetNewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      authorIds: // value for 'authorIds'
 *      tagId: // value for 'tagId'
 *      relatedEntityId: // value for 'relatedEntityId'
 *      type: // value for 'type'
 *      publicationStatus: // value for 'publicationStatus'
 *      universes: // value for 'universes'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetNewsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsListQuery, Generated.GetNewsListQueryVariables> & ({ variables: Generated.GetNewsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsListQuery, Generated.GetNewsListQueryVariables>(GetNewsListDocument, options);
      }
export function useGetNewsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsListQuery, Generated.GetNewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsListQuery, Generated.GetNewsListQueryVariables>(GetNewsListDocument, options);
        }
export function useGetNewsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsListQuery, Generated.GetNewsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsListQuery, Generated.GetNewsListQueryVariables>(GetNewsListDocument, options);
        }
export type GetNewsListQueryHookResult = ReturnType<typeof useGetNewsListQuery>;
export type GetNewsListLazyQueryHookResult = ReturnType<typeof useGetNewsListLazyQuery>;
export type GetNewsListSuspenseQueryHookResult = ReturnType<typeof useGetNewsListSuspenseQuery>;
export type GetNewsListQueryResult = Apollo.QueryResult<Generated.GetNewsListQuery, Generated.GetNewsListQueryVariables>;
export const GetNewsIdentityDocument = /*#__PURE__*/ gql`
    query getNewsIdentity($newsId: ID!) {
  news(id: $newsId) {
    ...NewsIdentity
    ...NewsMetadata
    ...NewsPages
  }
}
    ${NewsIdentityFragmentDoc}
${NewsMetadataFragmentDoc}
${NewsPagesFragmentDoc}`;

/**
 * __useGetNewsIdentityQuery__
 *
 * To run a query within a React component, call `useGetNewsIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsIdentityQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *   },
 * });
 */
export function useGetNewsIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsIdentityQuery, Generated.GetNewsIdentityQueryVariables> & ({ variables: Generated.GetNewsIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsIdentityQuery, Generated.GetNewsIdentityQueryVariables>(GetNewsIdentityDocument, options);
      }
export function useGetNewsIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsIdentityQuery, Generated.GetNewsIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsIdentityQuery, Generated.GetNewsIdentityQueryVariables>(GetNewsIdentityDocument, options);
        }
export function useGetNewsIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsIdentityQuery, Generated.GetNewsIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsIdentityQuery, Generated.GetNewsIdentityQueryVariables>(GetNewsIdentityDocument, options);
        }
export type GetNewsIdentityQueryHookResult = ReturnType<typeof useGetNewsIdentityQuery>;
export type GetNewsIdentityLazyQueryHookResult = ReturnType<typeof useGetNewsIdentityLazyQuery>;
export type GetNewsIdentitySuspenseQueryHookResult = ReturnType<typeof useGetNewsIdentitySuspenseQuery>;
export type GetNewsIdentityQueryResult = Apollo.QueryResult<Generated.GetNewsIdentityQuery, Generated.GetNewsIdentityQueryVariables>;
export const GetNewsNavigationDataDocument = /*#__PURE__*/ gql`
    query getNewsNavigationData($newsId: ID!) {
  news(id: $newsId) {
    id
    brand {
      ...BrandOption
    }
    ...NewsNavigationData
  }
}
    ${BrandOptionFragmentDoc}
${NewsNavigationDataFragmentDoc}`;

/**
 * __useGetNewsNavigationDataQuery__
 *
 * To run a query within a React component, call `useGetNewsNavigationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsNavigationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsNavigationDataQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *   },
 * });
 */
export function useGetNewsNavigationDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsNavigationDataQuery, Generated.GetNewsNavigationDataQueryVariables> & ({ variables: Generated.GetNewsNavigationDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsNavigationDataQuery, Generated.GetNewsNavigationDataQueryVariables>(GetNewsNavigationDataDocument, options);
      }
export function useGetNewsNavigationDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsNavigationDataQuery, Generated.GetNewsNavigationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsNavigationDataQuery, Generated.GetNewsNavigationDataQueryVariables>(GetNewsNavigationDataDocument, options);
        }
export function useGetNewsNavigationDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsNavigationDataQuery, Generated.GetNewsNavigationDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsNavigationDataQuery, Generated.GetNewsNavigationDataQueryVariables>(GetNewsNavigationDataDocument, options);
        }
export type GetNewsNavigationDataQueryHookResult = ReturnType<typeof useGetNewsNavigationDataQuery>;
export type GetNewsNavigationDataLazyQueryHookResult = ReturnType<typeof useGetNewsNavigationDataLazyQuery>;
export type GetNewsNavigationDataSuspenseQueryHookResult = ReturnType<typeof useGetNewsNavigationDataSuspenseQuery>;
export type GetNewsNavigationDataQueryResult = Apollo.QueryResult<Generated.GetNewsNavigationDataQuery, Generated.GetNewsNavigationDataQueryVariables>;
export const GetNewsPageContentDocument = /*#__PURE__*/ gql`
    query getNewsPageContent($newsPageId: ID!) {
  newsPage(id: $newsPageId) {
    id
    body
    brand {
      ...BrandOption
      country {
        ...CountryOption
        currency
      }
    }
  }
}
    ${BrandOptionFragmentDoc}
${CountryOptionFragmentDoc}`;

/**
 * __useGetNewsPageContentQuery__
 *
 * To run a query within a React component, call `useGetNewsPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsPageContentQuery({
 *   variables: {
 *      newsPageId: // value for 'newsPageId'
 *   },
 * });
 */
export function useGetNewsPageContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsPageContentQuery, Generated.GetNewsPageContentQueryVariables> & ({ variables: Generated.GetNewsPageContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsPageContentQuery, Generated.GetNewsPageContentQueryVariables>(GetNewsPageContentDocument, options);
      }
export function useGetNewsPageContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsPageContentQuery, Generated.GetNewsPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsPageContentQuery, Generated.GetNewsPageContentQueryVariables>(GetNewsPageContentDocument, options);
        }
export function useGetNewsPageContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsPageContentQuery, Generated.GetNewsPageContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsPageContentQuery, Generated.GetNewsPageContentQueryVariables>(GetNewsPageContentDocument, options);
        }
export type GetNewsPageContentQueryHookResult = ReturnType<typeof useGetNewsPageContentQuery>;
export type GetNewsPageContentLazyQueryHookResult = ReturnType<typeof useGetNewsPageContentLazyQuery>;
export type GetNewsPageContentSuspenseQueryHookResult = ReturnType<typeof useGetNewsPageContentSuspenseQuery>;
export type GetNewsPageContentQueryResult = Apollo.QueryResult<Generated.GetNewsPageContentQuery, Generated.GetNewsPageContentQueryVariables>;
export const GetNewsRelatedEntitiesListDocument = /*#__PURE__*/ gql`
    query getNewsRelatedEntitiesList($id: ID!, $excludedTypes: [NewsLinkableEntityType!], $includedTypes: [NewsLinkableEntityType!]) {
  news(id: $id) {
    id
    relatedEntities(excludedTypes: $excludedTypes, includedTypes: $includedTypes) {
      ...NewsEntity
    }
  }
}
    ${NewsEntityFragmentDoc}`;

/**
 * __useGetNewsRelatedEntitiesListQuery__
 *
 * To run a query within a React component, call `useGetNewsRelatedEntitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsRelatedEntitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsRelatedEntitiesListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      excludedTypes: // value for 'excludedTypes'
 *      includedTypes: // value for 'includedTypes'
 *   },
 * });
 */
export function useGetNewsRelatedEntitiesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsRelatedEntitiesListQuery, Generated.GetNewsRelatedEntitiesListQueryVariables> & ({ variables: Generated.GetNewsRelatedEntitiesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsRelatedEntitiesListQuery, Generated.GetNewsRelatedEntitiesListQueryVariables>(GetNewsRelatedEntitiesListDocument, options);
      }
export function useGetNewsRelatedEntitiesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsRelatedEntitiesListQuery, Generated.GetNewsRelatedEntitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsRelatedEntitiesListQuery, Generated.GetNewsRelatedEntitiesListQueryVariables>(GetNewsRelatedEntitiesListDocument, options);
        }
export function useGetNewsRelatedEntitiesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsRelatedEntitiesListQuery, Generated.GetNewsRelatedEntitiesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsRelatedEntitiesListQuery, Generated.GetNewsRelatedEntitiesListQueryVariables>(GetNewsRelatedEntitiesListDocument, options);
        }
export type GetNewsRelatedEntitiesListQueryHookResult = ReturnType<typeof useGetNewsRelatedEntitiesListQuery>;
export type GetNewsRelatedEntitiesListLazyQueryHookResult = ReturnType<typeof useGetNewsRelatedEntitiesListLazyQuery>;
export type GetNewsRelatedEntitiesListSuspenseQueryHookResult = ReturnType<typeof useGetNewsRelatedEntitiesListSuspenseQuery>;
export type GetNewsRelatedEntitiesListQueryResult = Apollo.QueryResult<Generated.GetNewsRelatedEntitiesListQuery, Generated.GetNewsRelatedEntitiesListQueryVariables>;
export const GetNewsPublicationListDocument = /*#__PURE__*/ gql`
    query getNewsPublicationList($id: ID!) {
  news(id: $id) {
    id
    brand {
      ...BrandOption
      timezone
    }
    poster {
      id
    }
    pages {
      id
      body
    }
    ...NewsPublications
  }
}
    ${BrandOptionFragmentDoc}
${NewsPublicationsFragmentDoc}`;

/**
 * __useGetNewsPublicationListQuery__
 *
 * To run a query within a React component, call `useGetNewsPublicationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsPublicationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsPublicationListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNewsPublicationListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsPublicationListQuery, Generated.GetNewsPublicationListQueryVariables> & ({ variables: Generated.GetNewsPublicationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsPublicationListQuery, Generated.GetNewsPublicationListQueryVariables>(GetNewsPublicationListDocument, options);
      }
export function useGetNewsPublicationListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsPublicationListQuery, Generated.GetNewsPublicationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsPublicationListQuery, Generated.GetNewsPublicationListQueryVariables>(GetNewsPublicationListDocument, options);
        }
export function useGetNewsPublicationListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsPublicationListQuery, Generated.GetNewsPublicationListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsPublicationListQuery, Generated.GetNewsPublicationListQueryVariables>(GetNewsPublicationListDocument, options);
        }
export type GetNewsPublicationListQueryHookResult = ReturnType<typeof useGetNewsPublicationListQuery>;
export type GetNewsPublicationListLazyQueryHookResult = ReturnType<typeof useGetNewsPublicationListLazyQuery>;
export type GetNewsPublicationListSuspenseQueryHookResult = ReturnType<typeof useGetNewsPublicationListSuspenseQuery>;
export type GetNewsPublicationListQueryResult = Apollo.QueryResult<Generated.GetNewsPublicationListQuery, Generated.GetNewsPublicationListQueryVariables>;
export const GetNewsPosterDocument = /*#__PURE__*/ gql`
    query getNewsPoster($newsId: ID!) {
  news(id: $newsId) {
    ...NewsMainImage
  }
}
    ${NewsMainImageFragmentDoc}`;

/**
 * __useGetNewsPosterQuery__
 *
 * To run a query within a React component, call `useGetNewsPosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsPosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsPosterQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *   },
 * });
 */
export function useGetNewsPosterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsPosterQuery, Generated.GetNewsPosterQueryVariables> & ({ variables: Generated.GetNewsPosterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsPosterQuery, Generated.GetNewsPosterQueryVariables>(GetNewsPosterDocument, options);
      }
export function useGetNewsPosterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsPosterQuery, Generated.GetNewsPosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsPosterQuery, Generated.GetNewsPosterQueryVariables>(GetNewsPosterDocument, options);
        }
export function useGetNewsPosterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsPosterQuery, Generated.GetNewsPosterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsPosterQuery, Generated.GetNewsPosterQueryVariables>(GetNewsPosterDocument, options);
        }
export type GetNewsPosterQueryHookResult = ReturnType<typeof useGetNewsPosterQuery>;
export type GetNewsPosterLazyQueryHookResult = ReturnType<typeof useGetNewsPosterLazyQuery>;
export type GetNewsPosterSuspenseQueryHookResult = ReturnType<typeof useGetNewsPosterSuspenseQuery>;
export type GetNewsPosterQueryResult = Apollo.QueryResult<Generated.GetNewsPosterQuery, Generated.GetNewsPosterQueryVariables>;
export const GetNewsRelatedNewsListDocument = /*#__PURE__*/ gql`
    query getNewsRelatedNewsList($id: ID!) {
  news(id: $id) {
    id
    relatedEntities(includedTypes: [NEWS]) {
      ... on News {
        id
        ref
        title
        active
        publicationStatus
        publicationDate
      }
    }
  }
}
    `;

/**
 * __useGetNewsRelatedNewsListQuery__
 *
 * To run a query within a React component, call `useGetNewsRelatedNewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsRelatedNewsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsRelatedNewsListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNewsRelatedNewsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsRelatedNewsListQuery, Generated.GetNewsRelatedNewsListQueryVariables> & ({ variables: Generated.GetNewsRelatedNewsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsRelatedNewsListQuery, Generated.GetNewsRelatedNewsListQueryVariables>(GetNewsRelatedNewsListDocument, options);
      }
export function useGetNewsRelatedNewsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsRelatedNewsListQuery, Generated.GetNewsRelatedNewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsRelatedNewsListQuery, Generated.GetNewsRelatedNewsListQueryVariables>(GetNewsRelatedNewsListDocument, options);
        }
export function useGetNewsRelatedNewsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsRelatedNewsListQuery, Generated.GetNewsRelatedNewsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsRelatedNewsListQuery, Generated.GetNewsRelatedNewsListQueryVariables>(GetNewsRelatedNewsListDocument, options);
        }
export type GetNewsRelatedNewsListQueryHookResult = ReturnType<typeof useGetNewsRelatedNewsListQuery>;
export type GetNewsRelatedNewsListLazyQueryHookResult = ReturnType<typeof useGetNewsRelatedNewsListLazyQuery>;
export type GetNewsRelatedNewsListSuspenseQueryHookResult = ReturnType<typeof useGetNewsRelatedNewsListSuspenseQuery>;
export type GetNewsRelatedNewsListQueryResult = Apollo.QueryResult<Generated.GetNewsRelatedNewsListQuery, Generated.GetNewsRelatedNewsListQueryVariables>;
export const GetNewsSlidesDocument = /*#__PURE__*/ gql`
    query getNewsSlides($newsId: ID!) {
  news(id: $newsId) {
    ...NewsSlides
  }
}
    ${NewsSlidesFragmentDoc}`;

/**
 * __useGetNewsSlidesQuery__
 *
 * To run a query within a React component, call `useGetNewsSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsSlidesQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *   },
 * });
 */
export function useGetNewsSlidesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsSlidesQuery, Generated.GetNewsSlidesQueryVariables> & ({ variables: Generated.GetNewsSlidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsSlidesQuery, Generated.GetNewsSlidesQueryVariables>(GetNewsSlidesDocument, options);
      }
export function useGetNewsSlidesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsSlidesQuery, Generated.GetNewsSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsSlidesQuery, Generated.GetNewsSlidesQueryVariables>(GetNewsSlidesDocument, options);
        }
export function useGetNewsSlidesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsSlidesQuery, Generated.GetNewsSlidesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsSlidesQuery, Generated.GetNewsSlidesQueryVariables>(GetNewsSlidesDocument, options);
        }
export type GetNewsSlidesQueryHookResult = ReturnType<typeof useGetNewsSlidesQuery>;
export type GetNewsSlidesLazyQueryHookResult = ReturnType<typeof useGetNewsSlidesLazyQuery>;
export type GetNewsSlidesSuspenseQueryHookResult = ReturnType<typeof useGetNewsSlidesSuspenseQuery>;
export type GetNewsSlidesQueryResult = Apollo.QueryResult<Generated.GetNewsSlidesQuery, Generated.GetNewsSlidesQueryVariables>;
export const GetNewsSeoAttributesDocument = /*#__PURE__*/ gql`
    query getNewsSeoAttributes($id: ID!) {
  news(id: $id) {
    id
    active
    ...NewsSeoAttributes
  }
}
    ${NewsSeoAttributesFragmentDoc}`;

/**
 * __useGetNewsSeoAttributesQuery__
 *
 * To run a query within a React component, call `useGetNewsSeoAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsSeoAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsSeoAttributesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNewsSeoAttributesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsSeoAttributesQuery, Generated.GetNewsSeoAttributesQueryVariables> & ({ variables: Generated.GetNewsSeoAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsSeoAttributesQuery, Generated.GetNewsSeoAttributesQueryVariables>(GetNewsSeoAttributesDocument, options);
      }
export function useGetNewsSeoAttributesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsSeoAttributesQuery, Generated.GetNewsSeoAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsSeoAttributesQuery, Generated.GetNewsSeoAttributesQueryVariables>(GetNewsSeoAttributesDocument, options);
        }
export function useGetNewsSeoAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsSeoAttributesQuery, Generated.GetNewsSeoAttributesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsSeoAttributesQuery, Generated.GetNewsSeoAttributesQueryVariables>(GetNewsSeoAttributesDocument, options);
        }
export type GetNewsSeoAttributesQueryHookResult = ReturnType<typeof useGetNewsSeoAttributesQuery>;
export type GetNewsSeoAttributesLazyQueryHookResult = ReturnType<typeof useGetNewsSeoAttributesLazyQuery>;
export type GetNewsSeoAttributesSuspenseQueryHookResult = ReturnType<typeof useGetNewsSeoAttributesSuspenseQuery>;
export type GetNewsSeoAttributesQueryResult = Apollo.QueryResult<Generated.GetNewsSeoAttributesQuery, Generated.GetNewsSeoAttributesQueryVariables>;
export const GetNewsTagsDocument = /*#__PURE__*/ gql`
    query getNewsTags($newsId: ID!, $brandId: ID!) {
  news(id: $newsId) {
    id
    tags(limit: 1000, brandId: $brandId) {
      nodes {
        ...EntityTag
      }
    }
  }
}
    ${EntityTagFragmentDoc}`;

/**
 * __useGetNewsTagsQuery__
 *
 * To run a query within a React component, call `useGetNewsTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsTagsQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetNewsTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsTagsQuery, Generated.GetNewsTagsQueryVariables> & ({ variables: Generated.GetNewsTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsTagsQuery, Generated.GetNewsTagsQueryVariables>(GetNewsTagsDocument, options);
      }
export function useGetNewsTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsTagsQuery, Generated.GetNewsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsTagsQuery, Generated.GetNewsTagsQueryVariables>(GetNewsTagsDocument, options);
        }
export function useGetNewsTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsTagsQuery, Generated.GetNewsTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsTagsQuery, Generated.GetNewsTagsQueryVariables>(GetNewsTagsDocument, options);
        }
export type GetNewsTagsQueryHookResult = ReturnType<typeof useGetNewsTagsQuery>;
export type GetNewsTagsLazyQueryHookResult = ReturnType<typeof useGetNewsTagsLazyQuery>;
export type GetNewsTagsSuspenseQueryHookResult = ReturnType<typeof useGetNewsTagsSuspenseQuery>;
export type GetNewsTagsQueryResult = Apollo.QueryResult<Generated.GetNewsTagsQuery, Generated.GetNewsTagsQueryVariables>;
export const GetNewsDocument = /*#__PURE__*/ gql`
    query getNews($ref: ID!) {
  entityByRef(type: NEWS, ref: $ref) {
    ... on News {
      id
      title
      brand {
        ...BrandOption
      }
      universe
      ...NewsMetadata
    }
  }
  viewer {
    id
    admin
    allowedNewsScopes
  }
}
    ${BrandOptionFragmentDoc}
${NewsMetadataFragmentDoc}`;

/**
 * __useGetNewsQuery__
 *
 * To run a query within a React component, call `useGetNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetNewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetNewsQuery, Generated.GetNewsQueryVariables> & ({ variables: Generated.GetNewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetNewsQuery, Generated.GetNewsQueryVariables>(GetNewsDocument, options);
      }
export function useGetNewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetNewsQuery, Generated.GetNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetNewsQuery, Generated.GetNewsQueryVariables>(GetNewsDocument, options);
        }
export function useGetNewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetNewsQuery, Generated.GetNewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetNewsQuery, Generated.GetNewsQueryVariables>(GetNewsDocument, options);
        }
export type GetNewsQueryHookResult = ReturnType<typeof useGetNewsQuery>;
export type GetNewsLazyQueryHookResult = ReturnType<typeof useGetNewsLazyQuery>;
export type GetNewsSuspenseQueryHookResult = ReturnType<typeof useGetNewsSuspenseQuery>;
export type GetNewsQueryResult = Apollo.QueryResult<Generated.GetNewsQuery, Generated.GetNewsQueryVariables>;
export const GetSlideshowSlideDocument = /*#__PURE__*/ gql`
    query getSlideshowSlide($id: ID!) {
  slideshowSlide(id: $id) {
    ...SlideshowSlideIdentity
  }
}
    ${SlideshowSlideIdentityFragmentDoc}`;

/**
 * __useGetSlideshowSlideQuery__
 *
 * To run a query within a React component, call `useGetSlideshowSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideshowSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideshowSlideQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSlideshowSlideQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSlideshowSlideQuery, Generated.GetSlideshowSlideQueryVariables> & ({ variables: Generated.GetSlideshowSlideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSlideshowSlideQuery, Generated.GetSlideshowSlideQueryVariables>(GetSlideshowSlideDocument, options);
      }
export function useGetSlideshowSlideLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSlideshowSlideQuery, Generated.GetSlideshowSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSlideshowSlideQuery, Generated.GetSlideshowSlideQueryVariables>(GetSlideshowSlideDocument, options);
        }
export function useGetSlideshowSlideSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSlideshowSlideQuery, Generated.GetSlideshowSlideQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSlideshowSlideQuery, Generated.GetSlideshowSlideQueryVariables>(GetSlideshowSlideDocument, options);
        }
export type GetSlideshowSlideQueryHookResult = ReturnType<typeof useGetSlideshowSlideQuery>;
export type GetSlideshowSlideLazyQueryHookResult = ReturnType<typeof useGetSlideshowSlideLazyQuery>;
export type GetSlideshowSlideSuspenseQueryHookResult = ReturnType<typeof useGetSlideshowSlideSuspenseQuery>;
export type GetSlideshowSlideQueryResult = Apollo.QueryResult<Generated.GetSlideshowSlideQuery, Generated.GetSlideshowSlideQueryVariables>;
export const GetSlideshowSlidesDocument = /*#__PURE__*/ gql`
    query getSlideshowSlides($newsId: ID!) {
  news(id: $newsId) {
    id
    universe
    slideshowSlides {
      id
      number
      title
      image {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useGetSlideshowSlidesQuery__
 *
 * To run a query within a React component, call `useGetSlideshowSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideshowSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideshowSlidesQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *   },
 * });
 */
export function useGetSlideshowSlidesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSlideshowSlidesQuery, Generated.GetSlideshowSlidesQueryVariables> & ({ variables: Generated.GetSlideshowSlidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSlideshowSlidesQuery, Generated.GetSlideshowSlidesQueryVariables>(GetSlideshowSlidesDocument, options);
      }
export function useGetSlideshowSlidesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSlideshowSlidesQuery, Generated.GetSlideshowSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSlideshowSlidesQuery, Generated.GetSlideshowSlidesQueryVariables>(GetSlideshowSlidesDocument, options);
        }
export function useGetSlideshowSlidesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSlideshowSlidesQuery, Generated.GetSlideshowSlidesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSlideshowSlidesQuery, Generated.GetSlideshowSlidesQueryVariables>(GetSlideshowSlidesDocument, options);
        }
export type GetSlideshowSlidesQueryHookResult = ReturnType<typeof useGetSlideshowSlidesQuery>;
export type GetSlideshowSlidesLazyQueryHookResult = ReturnType<typeof useGetSlideshowSlidesLazyQuery>;
export type GetSlideshowSlidesSuspenseQueryHookResult = ReturnType<typeof useGetSlideshowSlidesSuspenseQuery>;
export type GetSlideshowSlidesQueryResult = Apollo.QueryResult<Generated.GetSlideshowSlidesQuery, Generated.GetSlideshowSlidesQueryVariables>;
export const LinkAuthorToNewsDocument = /*#__PURE__*/ gql`
    mutation linkAuthorToNews($input: LinkAuthorToNewsInput!) {
  linkAuthorToNews(input: $input) {
    id
  }
}
    `;
export type LinkAuthorToNewsMutationFn = Apollo.MutationFunction<Generated.LinkAuthorToNewsMutation, Generated.LinkAuthorToNewsMutationVariables>;

/**
 * __useLinkAuthorToNewsMutation__
 *
 * To run a mutation, you first call `useLinkAuthorToNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAuthorToNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAuthorToNewsMutation, { data, loading, error }] = useLinkAuthorToNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkAuthorToNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkAuthorToNewsMutation, Generated.LinkAuthorToNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkAuthorToNewsMutation, Generated.LinkAuthorToNewsMutationVariables>(LinkAuthorToNewsDocument, options);
      }
export type LinkAuthorToNewsMutationHookResult = ReturnType<typeof useLinkAuthorToNewsMutation>;
export type LinkAuthorToNewsMutationResult = Apollo.MutationResult<Generated.LinkAuthorToNewsMutation>;
export type LinkAuthorToNewsMutationOptions = Apollo.BaseMutationOptions<Generated.LinkAuthorToNewsMutation, Generated.LinkAuthorToNewsMutationVariables>;
export const LinkEntityToNewsDocument = /*#__PURE__*/ gql`
    mutation linkEntityToNews($input: LinkEntityToNewsInput!) {
  linkEntityToNews(input: $input) {
    __typename
  }
}
    `;
export type LinkEntityToNewsMutationFn = Apollo.MutationFunction<Generated.LinkEntityToNewsMutation, Generated.LinkEntityToNewsMutationVariables>;

/**
 * __useLinkEntityToNewsMutation__
 *
 * To run a mutation, you first call `useLinkEntityToNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEntityToNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEntityToNewsMutation, { data, loading, error }] = useLinkEntityToNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkEntityToNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkEntityToNewsMutation, Generated.LinkEntityToNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkEntityToNewsMutation, Generated.LinkEntityToNewsMutationVariables>(LinkEntityToNewsDocument, options);
      }
export type LinkEntityToNewsMutationHookResult = ReturnType<typeof useLinkEntityToNewsMutation>;
export type LinkEntityToNewsMutationResult = Apollo.MutationResult<Generated.LinkEntityToNewsMutation>;
export type LinkEntityToNewsMutationOptions = Apollo.BaseMutationOptions<Generated.LinkEntityToNewsMutation, Generated.LinkEntityToNewsMutationVariables>;
export const MoveAuthorInNewsDocument = /*#__PURE__*/ gql`
    mutation moveAuthorInNews($input: MoveAuthorInNewsInput!) {
  moveAuthorInNews(input: $input) {
    id
  }
}
    `;
export type MoveAuthorInNewsMutationFn = Apollo.MutationFunction<Generated.MoveAuthorInNewsMutation, Generated.MoveAuthorInNewsMutationVariables>;

/**
 * __useMoveAuthorInNewsMutation__
 *
 * To run a mutation, you first call `useMoveAuthorInNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAuthorInNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAuthorInNewsMutation, { data, loading, error }] = useMoveAuthorInNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveAuthorInNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveAuthorInNewsMutation, Generated.MoveAuthorInNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveAuthorInNewsMutation, Generated.MoveAuthorInNewsMutationVariables>(MoveAuthorInNewsDocument, options);
      }
export type MoveAuthorInNewsMutationHookResult = ReturnType<typeof useMoveAuthorInNewsMutation>;
export type MoveAuthorInNewsMutationResult = Apollo.MutationResult<Generated.MoveAuthorInNewsMutation>;
export type MoveAuthorInNewsMutationOptions = Apollo.BaseMutationOptions<Generated.MoveAuthorInNewsMutation, Generated.MoveAuthorInNewsMutationVariables>;
export const SearchAuthorsDocument = /*#__PURE__*/ gql`
    query searchAuthors($search: String, $brandId: ID, $limit: Int) {
  authors(search: $search, limit: $limit, brandId: $brandId) {
    nodes {
      ...SearchAuthor
    }
  }
}
    ${SearchAuthorFragmentDoc}`;

/**
 * __useSearchAuthorsQuery__
 *
 * To run a query within a React component, call `useSearchAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAuthorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchAuthorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchAuthorsQuery, Generated.SearchAuthorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchAuthorsQuery, Generated.SearchAuthorsQueryVariables>(SearchAuthorsDocument, options);
      }
export function useSearchAuthorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchAuthorsQuery, Generated.SearchAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchAuthorsQuery, Generated.SearchAuthorsQueryVariables>(SearchAuthorsDocument, options);
        }
export function useSearchAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchAuthorsQuery, Generated.SearchAuthorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchAuthorsQuery, Generated.SearchAuthorsQueryVariables>(SearchAuthorsDocument, options);
        }
export type SearchAuthorsQueryHookResult = ReturnType<typeof useSearchAuthorsQuery>;
export type SearchAuthorsLazyQueryHookResult = ReturnType<typeof useSearchAuthorsLazyQuery>;
export type SearchAuthorsSuspenseQueryHookResult = ReturnType<typeof useSearchAuthorsSuspenseQuery>;
export type SearchAuthorsQueryResult = Apollo.QueryResult<Generated.SearchAuthorsQuery, Generated.SearchAuthorsQueryVariables>;
export const ToggleNewsActivationDocument = /*#__PURE__*/ gql`
    mutation toggleNewsActivation($input: ToggleNewsActivationInput!) {
  toggleNewsActivation(input: $input) {
    ...NewsSeoAttributes
    ...NewsMetadata
  }
}
    ${NewsSeoAttributesFragmentDoc}
${NewsMetadataFragmentDoc}`;
export type ToggleNewsActivationMutationFn = Apollo.MutationFunction<Generated.ToggleNewsActivationMutation, Generated.ToggleNewsActivationMutationVariables>;

/**
 * __useToggleNewsActivationMutation__
 *
 * To run a mutation, you first call `useToggleNewsActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleNewsActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleNewsActivationMutation, { data, loading, error }] = useToggleNewsActivationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleNewsActivationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.ToggleNewsActivationMutation, Generated.ToggleNewsActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.ToggleNewsActivationMutation, Generated.ToggleNewsActivationMutationVariables>(ToggleNewsActivationDocument, options);
      }
export type ToggleNewsActivationMutationHookResult = ReturnType<typeof useToggleNewsActivationMutation>;
export type ToggleNewsActivationMutationResult = Apollo.MutationResult<Generated.ToggleNewsActivationMutation>;
export type ToggleNewsActivationMutationOptions = Apollo.BaseMutationOptions<Generated.ToggleNewsActivationMutation, Generated.ToggleNewsActivationMutationVariables>;
export const UnlinkAuthorFromNewsDocument = /*#__PURE__*/ gql`
    mutation unlinkAuthorFromNews($input: UnlinkAuthorFromNewsInput!) {
  unlinkAuthorFromNews(input: $input) {
    id
  }
}
    `;
export type UnlinkAuthorFromNewsMutationFn = Apollo.MutationFunction<Generated.UnlinkAuthorFromNewsMutation, Generated.UnlinkAuthorFromNewsMutationVariables>;

/**
 * __useUnlinkAuthorFromNewsMutation__
 *
 * To run a mutation, you first call `useUnlinkAuthorFromNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAuthorFromNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAuthorFromNewsMutation, { data, loading, error }] = useUnlinkAuthorFromNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkAuthorFromNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkAuthorFromNewsMutation, Generated.UnlinkAuthorFromNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkAuthorFromNewsMutation, Generated.UnlinkAuthorFromNewsMutationVariables>(UnlinkAuthorFromNewsDocument, options);
      }
export type UnlinkAuthorFromNewsMutationHookResult = ReturnType<typeof useUnlinkAuthorFromNewsMutation>;
export type UnlinkAuthorFromNewsMutationResult = Apollo.MutationResult<Generated.UnlinkAuthorFromNewsMutation>;
export type UnlinkAuthorFromNewsMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkAuthorFromNewsMutation, Generated.UnlinkAuthorFromNewsMutationVariables>;
export const UpdateNewsMainImageDocument = /*#__PURE__*/ gql`
    mutation updateNewsMainImage($input: UpdateNewsInput!) {
  updateNews(input: $input) {
    id
    ...NewsMainImage
    ...NewsMetadata
  }
}
    ${NewsMainImageFragmentDoc}
${NewsMetadataFragmentDoc}`;
export type UpdateNewsMainImageMutationFn = Apollo.MutationFunction<Generated.UpdateNewsMainImageMutation, Generated.UpdateNewsMainImageMutationVariables>;

/**
 * __useUpdateNewsMainImageMutation__
 *
 * To run a mutation, you first call `useUpdateNewsMainImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsMainImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsMainImageMutation, { data, loading, error }] = useUpdateNewsMainImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsMainImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateNewsMainImageMutation, Generated.UpdateNewsMainImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateNewsMainImageMutation, Generated.UpdateNewsMainImageMutationVariables>(UpdateNewsMainImageDocument, options);
      }
export type UpdateNewsMainImageMutationHookResult = ReturnType<typeof useUpdateNewsMainImageMutation>;
export type UpdateNewsMainImageMutationResult = Apollo.MutationResult<Generated.UpdateNewsMainImageMutation>;
export type UpdateNewsMainImageMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateNewsMainImageMutation, Generated.UpdateNewsMainImageMutationVariables>;
export const UnlinkEntityFromNewsDocument = /*#__PURE__*/ gql`
    mutation unlinkEntityFromNews($input: UnlinkEntityFromNewsInput!) {
  unlinkEntityFromNews(input: $input) {
    __typename
  }
}
    `;
export type UnlinkEntityFromNewsMutationFn = Apollo.MutationFunction<Generated.UnlinkEntityFromNewsMutation, Generated.UnlinkEntityFromNewsMutationVariables>;

/**
 * __useUnlinkEntityFromNewsMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityFromNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityFromNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityFromNewsMutation, { data, loading, error }] = useUnlinkEntityFromNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkEntityFromNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkEntityFromNewsMutation, Generated.UnlinkEntityFromNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkEntityFromNewsMutation, Generated.UnlinkEntityFromNewsMutationVariables>(UnlinkEntityFromNewsDocument, options);
      }
export type UnlinkEntityFromNewsMutationHookResult = ReturnType<typeof useUnlinkEntityFromNewsMutation>;
export type UnlinkEntityFromNewsMutationResult = Apollo.MutationResult<Generated.UnlinkEntityFromNewsMutation>;
export type UnlinkEntityFromNewsMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkEntityFromNewsMutation, Generated.UnlinkEntityFromNewsMutationVariables>;
export const UpdateNewsPageNumberDocument = /*#__PURE__*/ gql`
    mutation updateNewsPageNumber($input: UpdateNewsPageNumberInput!) {
  updateNewsPageNumber(input: $input) {
    id
    news {
      id
      ...NewsPages
      ...NewsMetadata
    }
  }
}
    ${NewsPagesFragmentDoc}
${NewsMetadataFragmentDoc}`;
export type UpdateNewsPageNumberMutationFn = Apollo.MutationFunction<Generated.UpdateNewsPageNumberMutation, Generated.UpdateNewsPageNumberMutationVariables>;

/**
 * __useUpdateNewsPageNumberMutation__
 *
 * To run a mutation, you first call `useUpdateNewsPageNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsPageNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsPageNumberMutation, { data, loading, error }] = useUpdateNewsPageNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsPageNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateNewsPageNumberMutation, Generated.UpdateNewsPageNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateNewsPageNumberMutation, Generated.UpdateNewsPageNumberMutationVariables>(UpdateNewsPageNumberDocument, options);
      }
export type UpdateNewsPageNumberMutationHookResult = ReturnType<typeof useUpdateNewsPageNumberMutation>;
export type UpdateNewsPageNumberMutationResult = Apollo.MutationResult<Generated.UpdateNewsPageNumberMutation>;
export type UpdateNewsPageNumberMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateNewsPageNumberMutation, Generated.UpdateNewsPageNumberMutationVariables>;
export const UpdateNewsPageDocument = /*#__PURE__*/ gql`
    mutation updateNewsPage($input: UpdateNewsPageInput!) {
  updateNewsPage(input: $input) {
    id
    title
    video {
      id
      title
      generatedTitle
    }
    news {
      id
      ...NewsMetadata
    }
  }
}
    ${NewsMetadataFragmentDoc}`;
export type UpdateNewsPageMutationFn = Apollo.MutationFunction<Generated.UpdateNewsPageMutation, Generated.UpdateNewsPageMutationVariables>;

/**
 * __useUpdateNewsPageMutation__
 *
 * To run a mutation, you first call `useUpdateNewsPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsPageMutation, { data, loading, error }] = useUpdateNewsPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateNewsPageMutation, Generated.UpdateNewsPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateNewsPageMutation, Generated.UpdateNewsPageMutationVariables>(UpdateNewsPageDocument, options);
      }
export type UpdateNewsPageMutationHookResult = ReturnType<typeof useUpdateNewsPageMutation>;
export type UpdateNewsPageMutationResult = Apollo.MutationResult<Generated.UpdateNewsPageMutation>;
export type UpdateNewsPageMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateNewsPageMutation, Generated.UpdateNewsPageMutationVariables>;
export const UpdateNewsPageContentDocument = /*#__PURE__*/ gql`
    mutation updateNewsPageContent($input: UpdateNewsPageInput!) {
  updateNewsPage(input: $input) {
    id
    body
    news {
      id
      isUpdatedWhenPublished
      ...NewsMetadata
    }
  }
}
    ${NewsMetadataFragmentDoc}`;
export type UpdateNewsPageContentMutationFn = Apollo.MutationFunction<Generated.UpdateNewsPageContentMutation, Generated.UpdateNewsPageContentMutationVariables>;

/**
 * __useUpdateNewsPageContentMutation__
 *
 * To run a mutation, you first call `useUpdateNewsPageContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsPageContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsPageContentMutation, { data, loading, error }] = useUpdateNewsPageContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsPageContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateNewsPageContentMutation, Generated.UpdateNewsPageContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateNewsPageContentMutation, Generated.UpdateNewsPageContentMutationVariables>(UpdateNewsPageContentDocument, options);
      }
export type UpdateNewsPageContentMutationHookResult = ReturnType<typeof useUpdateNewsPageContentMutation>;
export type UpdateNewsPageContentMutationResult = Apollo.MutationResult<Generated.UpdateNewsPageContentMutation>;
export type UpdateNewsPageContentMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateNewsPageContentMutation, Generated.UpdateNewsPageContentMutationVariables>;
export const UpdateNewsSeoAttributesDocument = /*#__PURE__*/ gql`
    mutation updateNewsSeoAttributes($input: UpdateNewsSeoAttributesInput!) {
  updateNewsSeoAttributes(input: $input) {
    id
    active
    seoAttributes {
      title
      subtitle
      description
    }
    ...NewsMetadata
  }
}
    ${NewsMetadataFragmentDoc}`;
export type UpdateNewsSeoAttributesMutationFn = Apollo.MutationFunction<Generated.UpdateNewsSeoAttributesMutation, Generated.UpdateNewsSeoAttributesMutationVariables>;

/**
 * __useUpdateNewsSeoAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateNewsSeoAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsSeoAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsSeoAttributesMutation, { data, loading, error }] = useUpdateNewsSeoAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsSeoAttributesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateNewsSeoAttributesMutation, Generated.UpdateNewsSeoAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateNewsSeoAttributesMutation, Generated.UpdateNewsSeoAttributesMutationVariables>(UpdateNewsSeoAttributesDocument, options);
      }
export type UpdateNewsSeoAttributesMutationHookResult = ReturnType<typeof useUpdateNewsSeoAttributesMutation>;
export type UpdateNewsSeoAttributesMutationResult = Apollo.MutationResult<Generated.UpdateNewsSeoAttributesMutation>;
export type UpdateNewsSeoAttributesMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateNewsSeoAttributesMutation, Generated.UpdateNewsSeoAttributesMutationVariables>;
export const UpdateNewsNavigationDataDocument = /*#__PURE__*/ gql`
    mutation updateNewsNavigationData($input: UpdateNewsNavigationDataInput!) {
  updateNewsNavigationData(input: $input) {
    id
    ...NewsNavigationData
    ...NewsMetadata
  }
}
    ${NewsNavigationDataFragmentDoc}
${NewsMetadataFragmentDoc}`;
export type UpdateNewsNavigationDataMutationFn = Apollo.MutationFunction<Generated.UpdateNewsNavigationDataMutation, Generated.UpdateNewsNavigationDataMutationVariables>;

/**
 * __useUpdateNewsNavigationDataMutation__
 *
 * To run a mutation, you first call `useUpdateNewsNavigationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsNavigationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsNavigationDataMutation, { data, loading, error }] = useUpdateNewsNavigationDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsNavigationDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateNewsNavigationDataMutation, Generated.UpdateNewsNavigationDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateNewsNavigationDataMutation, Generated.UpdateNewsNavigationDataMutationVariables>(UpdateNewsNavigationDataDocument, options);
      }
export type UpdateNewsNavigationDataMutationHookResult = ReturnType<typeof useUpdateNewsNavigationDataMutation>;
export type UpdateNewsNavigationDataMutationResult = Apollo.MutationResult<Generated.UpdateNewsNavigationDataMutation>;
export type UpdateNewsNavigationDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateNewsNavigationDataMutation, Generated.UpdateNewsNavigationDataMutationVariables>;
export const MoveNewsSlideDocument = /*#__PURE__*/ gql`
    mutation moveNewsSlide($input: MoveNewsSlideInput!) {
  moveNewsSlide(input: $input) {
    id
    news {
      id
      ...NewsSlides
      ...NewsMetadata
    }
  }
}
    ${NewsSlidesFragmentDoc}
${NewsMetadataFragmentDoc}`;
export type MoveNewsSlideMutationFn = Apollo.MutationFunction<Generated.MoveNewsSlideMutation, Generated.MoveNewsSlideMutationVariables>;

/**
 * __useMoveNewsSlideMutation__
 *
 * To run a mutation, you first call `useMoveNewsSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveNewsSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveNewsSlideMutation, { data, loading, error }] = useMoveNewsSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveNewsSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveNewsSlideMutation, Generated.MoveNewsSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveNewsSlideMutation, Generated.MoveNewsSlideMutationVariables>(MoveNewsSlideDocument, options);
      }
export type MoveNewsSlideMutationHookResult = ReturnType<typeof useMoveNewsSlideMutation>;
export type MoveNewsSlideMutationResult = Apollo.MutationResult<Generated.MoveNewsSlideMutation>;
export type MoveNewsSlideMutationOptions = Apollo.BaseMutationOptions<Generated.MoveNewsSlideMutation, Generated.MoveNewsSlideMutationVariables>;
export const UpdateNewsDocument = /*#__PURE__*/ gql`
    mutation updateNews($input: UpdateNewsInput!) {
  updateNews(input: $input) {
    id
    ...NewsIdentity
    ...NewsMetadata
    isUpdatedWhenPublished
    tracking
  }
}
    ${NewsIdentityFragmentDoc}
${NewsMetadataFragmentDoc}`;
export type UpdateNewsMutationFn = Apollo.MutationFunction<Generated.UpdateNewsMutation, Generated.UpdateNewsMutationVariables>;

/**
 * __useUpdateNewsMutation__
 *
 * To run a mutation, you first call `useUpdateNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsMutation, { data, loading, error }] = useUpdateNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateNewsMutation, Generated.UpdateNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateNewsMutation, Generated.UpdateNewsMutationVariables>(UpdateNewsDocument, options);
      }
export type UpdateNewsMutationHookResult = ReturnType<typeof useUpdateNewsMutation>;
export type UpdateNewsMutationResult = Apollo.MutationResult<Generated.UpdateNewsMutation>;
export type UpdateNewsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateNewsMutation, Generated.UpdateNewsMutationVariables>;
export const UpdateSlideshowSlideDocument = /*#__PURE__*/ gql`
    mutation updateSlideshowSlide($input: UpdateSlideshowSlideInput!) {
  updateSlideshowSlide(input: $input) {
    ...SlideshowSlideIdentity
    news {
      id
      ...NewsMetadata
    }
  }
}
    ${SlideshowSlideIdentityFragmentDoc}
${NewsMetadataFragmentDoc}`;
export type UpdateSlideshowSlideMutationFn = Apollo.MutationFunction<Generated.UpdateSlideshowSlideMutation, Generated.UpdateSlideshowSlideMutationVariables>;

/**
 * __useUpdateSlideshowSlideMutation__
 *
 * To run a mutation, you first call `useUpdateSlideshowSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlideshowSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlideshowSlideMutation, { data, loading, error }] = useUpdateSlideshowSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSlideshowSlideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSlideshowSlideMutation, Generated.UpdateSlideshowSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSlideshowSlideMutation, Generated.UpdateSlideshowSlideMutationVariables>(UpdateSlideshowSlideDocument, options);
      }
export type UpdateSlideshowSlideMutationHookResult = ReturnType<typeof useUpdateSlideshowSlideMutation>;
export type UpdateSlideshowSlideMutationResult = Apollo.MutationResult<Generated.UpdateSlideshowSlideMutation>;
export type UpdateSlideshowSlideMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSlideshowSlideMutation, Generated.UpdateSlideshowSlideMutationVariables>;
export const AddPersonNicknameDocument = /*#__PURE__*/ gql`
    mutation addPersonNickname($input: AddPersonNicknameInput!) {
  addPersonNickname(input: $input) {
    ...PersonNickname
  }
}
    ${PersonNicknameFragmentDoc}`;
export type AddPersonNicknameMutationFn = Apollo.MutationFunction<Generated.AddPersonNicknameMutation, Generated.AddPersonNicknameMutationVariables>;

/**
 * __useAddPersonNicknameMutation__
 *
 * To run a mutation, you first call `useAddPersonNicknameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPersonNicknameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPersonNicknameMutation, { data, loading, error }] = useAddPersonNicknameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPersonNicknameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddPersonNicknameMutation, Generated.AddPersonNicknameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddPersonNicknameMutation, Generated.AddPersonNicknameMutationVariables>(AddPersonNicknameDocument, options);
      }
export type AddPersonNicknameMutationHookResult = ReturnType<typeof useAddPersonNicknameMutation>;
export type AddPersonNicknameMutationResult = Apollo.MutationResult<Generated.AddPersonNicknameMutation>;
export type AddPersonNicknameMutationOptions = Apollo.BaseMutationOptions<Generated.AddPersonNicknameMutation, Generated.AddPersonNicknameMutationVariables>;
export const CreatePersonDocument = /*#__PURE__*/ gql`
    mutation createPerson($input: CreatePersonInput!, $brandId: ID!, $includeBrandData: Boolean = false, $withSeoAttributes: Boolean! = false) {
  createPerson(input: $input) {
    ...PersonWithSeoMetadata
  }
}
    ${PersonWithSeoMetadataFragmentDoc}`;
export type CreatePersonMutationFn = Apollo.MutationFunction<Generated.CreatePersonMutation, Generated.CreatePersonMutationVariables>;

/**
 * __useCreatePersonMutation__
 *
 * To run a mutation, you first call `useCreatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonMutation, { data, loading, error }] = useCreatePersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useCreatePersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreatePersonMutation, Generated.CreatePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreatePersonMutation, Generated.CreatePersonMutationVariables>(CreatePersonDocument, options);
      }
export type CreatePersonMutationHookResult = ReturnType<typeof useCreatePersonMutation>;
export type CreatePersonMutationResult = Apollo.MutationResult<Generated.CreatePersonMutation>;
export type CreatePersonMutationOptions = Apollo.BaseMutationOptions<Generated.CreatePersonMutation, Generated.CreatePersonMutationVariables>;
export const DeletePersonImagesImportDocument = /*#__PURE__*/ gql`
    mutation deletePersonImagesImport($input: DeletePersonImagesImportInput!) {
  deletePersonImagesImport(input: $input)
}
    `;
export type DeletePersonImagesImportMutationFn = Apollo.MutationFunction<Generated.DeletePersonImagesImportMutation, Generated.DeletePersonImagesImportMutationVariables>;

/**
 * __useDeletePersonImagesImportMutation__
 *
 * To run a mutation, you first call `useDeletePersonImagesImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonImagesImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonImagesImportMutation, { data, loading, error }] = useDeletePersonImagesImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePersonImagesImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeletePersonImagesImportMutation, Generated.DeletePersonImagesImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeletePersonImagesImportMutation, Generated.DeletePersonImagesImportMutationVariables>(DeletePersonImagesImportDocument, options);
      }
export type DeletePersonImagesImportMutationHookResult = ReturnType<typeof useDeletePersonImagesImportMutation>;
export type DeletePersonImagesImportMutationResult = Apollo.MutationResult<Generated.DeletePersonImagesImportMutation>;
export type DeletePersonImagesImportMutationOptions = Apollo.BaseMutationOptions<Generated.DeletePersonImagesImportMutation, Generated.DeletePersonImagesImportMutationVariables>;
export const DeletePersonNicknameDocument = /*#__PURE__*/ gql`
    mutation deletePersonNickname($input: DeletePersonNicknameInput!) {
  deletePersonNickname(input: $input) {
    id
  }
}
    `;
export type DeletePersonNicknameMutationFn = Apollo.MutationFunction<Generated.DeletePersonNicknameMutation, Generated.DeletePersonNicknameMutationVariables>;

/**
 * __useDeletePersonNicknameMutation__
 *
 * To run a mutation, you first call `useDeletePersonNicknameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonNicknameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonNicknameMutation, { data, loading, error }] = useDeletePersonNicknameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePersonNicknameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeletePersonNicknameMutation, Generated.DeletePersonNicknameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeletePersonNicknameMutation, Generated.DeletePersonNicknameMutationVariables>(DeletePersonNicknameDocument, options);
      }
export type DeletePersonNicknameMutationHookResult = ReturnType<typeof useDeletePersonNicknameMutation>;
export type DeletePersonNicknameMutationResult = Apollo.MutationResult<Generated.DeletePersonNicknameMutation>;
export type DeletePersonNicknameMutationOptions = Apollo.BaseMutationOptions<Generated.DeletePersonNicknameMutation, Generated.DeletePersonNicknameMutationVariables>;
export const GetPersonActivitiesForEntityTypeDocument = /*#__PURE__*/ gql`
    query getPersonActivitiesForEntityType($entityType: String) {
  personActivities(entityType: $entityType)
}
    `;

/**
 * __useGetPersonActivitiesForEntityTypeQuery__
 *
 * To run a query within a React component, call `useGetPersonActivitiesForEntityTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonActivitiesForEntityTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonActivitiesForEntityTypeQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetPersonActivitiesForEntityTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetPersonActivitiesForEntityTypeQuery, Generated.GetPersonActivitiesForEntityTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonActivitiesForEntityTypeQuery, Generated.GetPersonActivitiesForEntityTypeQueryVariables>(GetPersonActivitiesForEntityTypeDocument, options);
      }
export function useGetPersonActivitiesForEntityTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonActivitiesForEntityTypeQuery, Generated.GetPersonActivitiesForEntityTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonActivitiesForEntityTypeQuery, Generated.GetPersonActivitiesForEntityTypeQueryVariables>(GetPersonActivitiesForEntityTypeDocument, options);
        }
export function useGetPersonActivitiesForEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonActivitiesForEntityTypeQuery, Generated.GetPersonActivitiesForEntityTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonActivitiesForEntityTypeQuery, Generated.GetPersonActivitiesForEntityTypeQueryVariables>(GetPersonActivitiesForEntityTypeDocument, options);
        }
export type GetPersonActivitiesForEntityTypeQueryHookResult = ReturnType<typeof useGetPersonActivitiesForEntityTypeQuery>;
export type GetPersonActivitiesForEntityTypeLazyQueryHookResult = ReturnType<typeof useGetPersonActivitiesForEntityTypeLazyQuery>;
export type GetPersonActivitiesForEntityTypeSuspenseQueryHookResult = ReturnType<typeof useGetPersonActivitiesForEntityTypeSuspenseQuery>;
export type GetPersonActivitiesForEntityTypeQueryResult = Apollo.QueryResult<Generated.GetPersonActivitiesForEntityTypeQuery, Generated.GetPersonActivitiesForEntityTypeQueryVariables>;
export const DeletePersonDocument = /*#__PURE__*/ gql`
    mutation deletePerson($input: DeleteEntityInput!) {
  deleteEntity(input: $input) {
    ... on Person {
      id
      ref
    }
  }
}
    `;
export type DeletePersonMutationFn = Apollo.MutationFunction<Generated.DeletePersonMutation, Generated.DeletePersonMutationVariables>;

/**
 * __useDeletePersonMutation__
 *
 * To run a mutation, you first call `useDeletePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonMutation, { data, loading, error }] = useDeletePersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeletePersonMutation, Generated.DeletePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeletePersonMutation, Generated.DeletePersonMutationVariables>(DeletePersonDocument, options);
      }
export type DeletePersonMutationHookResult = ReturnType<typeof useDeletePersonMutation>;
export type DeletePersonMutationResult = Apollo.MutationResult<Generated.DeletePersonMutation>;
export type DeletePersonMutationOptions = Apollo.BaseMutationOptions<Generated.DeletePersonMutation, Generated.DeletePersonMutationVariables>;
export const GetPersonBrandedDataDocument = /*#__PURE__*/ gql`
    query getPersonBrandedData($personId: ID!, $brandId: ID!) {
  person(id: $personId) {
    id
    brandData(brandId: $brandId) {
      biography
      birthPlace
      deathPlace
      deathCause
      poster {
        ...Image
        brandData(brandId: $brandId) {
          id
          copyrights {
            ...CopyrightIdentity
          }
          copyrightName
        }
      }
    }
  }
}
    ${ImageFragmentDoc}
${CopyrightIdentityFragmentDoc}`;

/**
 * __useGetPersonBrandedDataQuery__
 *
 * To run a query within a React component, call `useGetPersonBrandedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonBrandedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonBrandedDataQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetPersonBrandedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonBrandedDataQuery, Generated.GetPersonBrandedDataQueryVariables> & ({ variables: Generated.GetPersonBrandedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonBrandedDataQuery, Generated.GetPersonBrandedDataQueryVariables>(GetPersonBrandedDataDocument, options);
      }
export function useGetPersonBrandedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonBrandedDataQuery, Generated.GetPersonBrandedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonBrandedDataQuery, Generated.GetPersonBrandedDataQueryVariables>(GetPersonBrandedDataDocument, options);
        }
export function useGetPersonBrandedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonBrandedDataQuery, Generated.GetPersonBrandedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonBrandedDataQuery, Generated.GetPersonBrandedDataQueryVariables>(GetPersonBrandedDataDocument, options);
        }
export type GetPersonBrandedDataQueryHookResult = ReturnType<typeof useGetPersonBrandedDataQuery>;
export type GetPersonBrandedDataLazyQueryHookResult = ReturnType<typeof useGetPersonBrandedDataLazyQuery>;
export type GetPersonBrandedDataSuspenseQueryHookResult = ReturnType<typeof useGetPersonBrandedDataSuspenseQuery>;
export type GetPersonBrandedDataQueryResult = Apollo.QueryResult<Generated.GetPersonBrandedDataQuery, Generated.GetPersonBrandedDataQueryVariables>;
export const GetPersonFilmographyTotalCountDocument = /*#__PURE__*/ gql`
    query getPersonFilmographyTotalCount($id: ID!) {
  person(id: $id) {
    id
    filmography {
      totalCount
    }
  }
}
    `;

/**
 * __useGetPersonFilmographyTotalCountQuery__
 *
 * To run a query within a React component, call `useGetPersonFilmographyTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonFilmographyTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonFilmographyTotalCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonFilmographyTotalCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonFilmographyTotalCountQuery, Generated.GetPersonFilmographyTotalCountQueryVariables> & ({ variables: Generated.GetPersonFilmographyTotalCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonFilmographyTotalCountQuery, Generated.GetPersonFilmographyTotalCountQueryVariables>(GetPersonFilmographyTotalCountDocument, options);
      }
export function useGetPersonFilmographyTotalCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonFilmographyTotalCountQuery, Generated.GetPersonFilmographyTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonFilmographyTotalCountQuery, Generated.GetPersonFilmographyTotalCountQueryVariables>(GetPersonFilmographyTotalCountDocument, options);
        }
export function useGetPersonFilmographyTotalCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonFilmographyTotalCountQuery, Generated.GetPersonFilmographyTotalCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonFilmographyTotalCountQuery, Generated.GetPersonFilmographyTotalCountQueryVariables>(GetPersonFilmographyTotalCountDocument, options);
        }
export type GetPersonFilmographyTotalCountQueryHookResult = ReturnType<typeof useGetPersonFilmographyTotalCountQuery>;
export type GetPersonFilmographyTotalCountLazyQueryHookResult = ReturnType<typeof useGetPersonFilmographyTotalCountLazyQuery>;
export type GetPersonFilmographyTotalCountSuspenseQueryHookResult = ReturnType<typeof useGetPersonFilmographyTotalCountSuspenseQuery>;
export type GetPersonFilmographyTotalCountQueryResult = Apollo.QueryResult<Generated.GetPersonFilmographyTotalCountQuery, Generated.GetPersonFilmographyTotalCountQueryVariables>;
export const GetPersonImageSourcesDocument = /*#__PURE__*/ gql`
    query getPersonImageSources {
  personImageSources
}
    `;

/**
 * __useGetPersonImageSourcesQuery__
 *
 * To run a query within a React component, call `useGetPersonImageSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonImageSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonImageSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonImageSourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetPersonImageSourcesQuery, Generated.GetPersonImageSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonImageSourcesQuery, Generated.GetPersonImageSourcesQueryVariables>(GetPersonImageSourcesDocument, options);
      }
export function useGetPersonImageSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonImageSourcesQuery, Generated.GetPersonImageSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonImageSourcesQuery, Generated.GetPersonImageSourcesQueryVariables>(GetPersonImageSourcesDocument, options);
        }
export function useGetPersonImageSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonImageSourcesQuery, Generated.GetPersonImageSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonImageSourcesQuery, Generated.GetPersonImageSourcesQueryVariables>(GetPersonImageSourcesDocument, options);
        }
export type GetPersonImageSourcesQueryHookResult = ReturnType<typeof useGetPersonImageSourcesQuery>;
export type GetPersonImageSourcesLazyQueryHookResult = ReturnType<typeof useGetPersonImageSourcesLazyQuery>;
export type GetPersonImageSourcesSuspenseQueryHookResult = ReturnType<typeof useGetPersonImageSourcesSuspenseQuery>;
export type GetPersonImageSourcesQueryResult = Apollo.QueryResult<Generated.GetPersonImageSourcesQuery, Generated.GetPersonImageSourcesQueryVariables>;
export const GetPersonFilmographyDocument = /*#__PURE__*/ gql`
    query getPersonFilmography($id: ID!, $limit: Int, $offset: Int!, $entityTypes: [FilmographyEntity], $activities: [PersonActivity!], $orderBy: FilmographyOrder!) {
  person(id: $id) {
    id
    filmography(
      limit: $limit
      offset: $offset
      entityTypes: $entityTypes
      activities: $activities
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        activity
        role
        ...PersonFilmographyEntity
        productionDate
      }
    }
  }
}
    ${PersonFilmographyEntityFragmentDoc}`;

/**
 * __useGetPersonFilmographyQuery__
 *
 * To run a query within a React component, call `useGetPersonFilmographyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonFilmographyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonFilmographyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      entityTypes: // value for 'entityTypes'
 *      activities: // value for 'activities'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPersonFilmographyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonFilmographyQuery, Generated.GetPersonFilmographyQueryVariables> & ({ variables: Generated.GetPersonFilmographyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonFilmographyQuery, Generated.GetPersonFilmographyQueryVariables>(GetPersonFilmographyDocument, options);
      }
export function useGetPersonFilmographyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonFilmographyQuery, Generated.GetPersonFilmographyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonFilmographyQuery, Generated.GetPersonFilmographyQueryVariables>(GetPersonFilmographyDocument, options);
        }
export function useGetPersonFilmographySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonFilmographyQuery, Generated.GetPersonFilmographyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonFilmographyQuery, Generated.GetPersonFilmographyQueryVariables>(GetPersonFilmographyDocument, options);
        }
export type GetPersonFilmographyQueryHookResult = ReturnType<typeof useGetPersonFilmographyQuery>;
export type GetPersonFilmographyLazyQueryHookResult = ReturnType<typeof useGetPersonFilmographyLazyQuery>;
export type GetPersonFilmographySuspenseQueryHookResult = ReturnType<typeof useGetPersonFilmographySuspenseQuery>;
export type GetPersonFilmographyQueryResult = Apollo.QueryResult<Generated.GetPersonFilmographyQuery, Generated.GetPersonFilmographyQueryVariables>;
export const GetPersonImagesImportOutcomesDocument = /*#__PURE__*/ gql`
    query getPersonImagesImportOutcomes($id: ID!, $reportId: ID!) {
  person(id: $id) {
    id
    imageImport(id: $reportId) {
      __typename
      id
      status
      importedCount
      outcomes {
        url
        status
        message
      }
    }
  }
}
    `;

/**
 * __useGetPersonImagesImportOutcomesQuery__
 *
 * To run a query within a React component, call `useGetPersonImagesImportOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonImagesImportOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonImagesImportOutcomesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetPersonImagesImportOutcomesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonImagesImportOutcomesQuery, Generated.GetPersonImagesImportOutcomesQueryVariables> & ({ variables: Generated.GetPersonImagesImportOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonImagesImportOutcomesQuery, Generated.GetPersonImagesImportOutcomesQueryVariables>(GetPersonImagesImportOutcomesDocument, options);
      }
export function useGetPersonImagesImportOutcomesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonImagesImportOutcomesQuery, Generated.GetPersonImagesImportOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonImagesImportOutcomesQuery, Generated.GetPersonImagesImportOutcomesQueryVariables>(GetPersonImagesImportOutcomesDocument, options);
        }
export function useGetPersonImagesImportOutcomesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonImagesImportOutcomesQuery, Generated.GetPersonImagesImportOutcomesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonImagesImportOutcomesQuery, Generated.GetPersonImagesImportOutcomesQueryVariables>(GetPersonImagesImportOutcomesDocument, options);
        }
export type GetPersonImagesImportOutcomesQueryHookResult = ReturnType<typeof useGetPersonImagesImportOutcomesQuery>;
export type GetPersonImagesImportOutcomesLazyQueryHookResult = ReturnType<typeof useGetPersonImagesImportOutcomesLazyQuery>;
export type GetPersonImagesImportOutcomesSuspenseQueryHookResult = ReturnType<typeof useGetPersonImagesImportOutcomesSuspenseQuery>;
export type GetPersonImagesImportOutcomesQueryResult = Apollo.QueryResult<Generated.GetPersonImagesImportOutcomesQuery, Generated.GetPersonImagesImportOutcomesQueryVariables>;
export const GetPersonImagesImportsDocument = /*#__PURE__*/ gql`
    query getPersonImagesImports($id: ID!) {
  person(id: $id) {
    id
    imageImports {
      ...PersonImagesImportReportSummary
    }
  }
}
    ${PersonImagesImportReportSummaryFragmentDoc}`;

/**
 * __useGetPersonImagesImportsQuery__
 *
 * To run a query within a React component, call `useGetPersonImagesImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonImagesImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonImagesImportsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonImagesImportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonImagesImportsQuery, Generated.GetPersonImagesImportsQueryVariables> & ({ variables: Generated.GetPersonImagesImportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonImagesImportsQuery, Generated.GetPersonImagesImportsQueryVariables>(GetPersonImagesImportsDocument, options);
      }
export function useGetPersonImagesImportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonImagesImportsQuery, Generated.GetPersonImagesImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonImagesImportsQuery, Generated.GetPersonImagesImportsQueryVariables>(GetPersonImagesImportsDocument, options);
        }
export function useGetPersonImagesImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonImagesImportsQuery, Generated.GetPersonImagesImportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonImagesImportsQuery, Generated.GetPersonImagesImportsQueryVariables>(GetPersonImagesImportsDocument, options);
        }
export type GetPersonImagesImportsQueryHookResult = ReturnType<typeof useGetPersonImagesImportsQuery>;
export type GetPersonImagesImportsLazyQueryHookResult = ReturnType<typeof useGetPersonImagesImportsLazyQuery>;
export type GetPersonImagesImportsSuspenseQueryHookResult = ReturnType<typeof useGetPersonImagesImportsSuspenseQuery>;
export type GetPersonImagesImportsQueryResult = Apollo.QueryResult<Generated.GetPersonImagesImportsQuery, Generated.GetPersonImagesImportsQueryVariables>;
export const GetPersonImagesImportDocument = /*#__PURE__*/ gql`
    query getPersonImagesImport($id: ID!, $reportId: ID!) {
  person(id: $id) {
    id
    imageImport(id: $reportId) {
      ...PersonImagesImportReport
    }
  }
}
    ${PersonImagesImportReportFragmentDoc}`;

/**
 * __useGetPersonImagesImportQuery__
 *
 * To run a query within a React component, call `useGetPersonImagesImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonImagesImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonImagesImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetPersonImagesImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonImagesImportQuery, Generated.GetPersonImagesImportQueryVariables> & ({ variables: Generated.GetPersonImagesImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonImagesImportQuery, Generated.GetPersonImagesImportQueryVariables>(GetPersonImagesImportDocument, options);
      }
export function useGetPersonImagesImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonImagesImportQuery, Generated.GetPersonImagesImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonImagesImportQuery, Generated.GetPersonImagesImportQueryVariables>(GetPersonImagesImportDocument, options);
        }
export function useGetPersonImagesImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonImagesImportQuery, Generated.GetPersonImagesImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonImagesImportQuery, Generated.GetPersonImagesImportQueryVariables>(GetPersonImagesImportDocument, options);
        }
export type GetPersonImagesImportQueryHookResult = ReturnType<typeof useGetPersonImagesImportQuery>;
export type GetPersonImagesImportLazyQueryHookResult = ReturnType<typeof useGetPersonImagesImportLazyQuery>;
export type GetPersonImagesImportSuspenseQueryHookResult = ReturnType<typeof useGetPersonImagesImportSuspenseQuery>;
export type GetPersonImagesImportQueryResult = Apollo.QueryResult<Generated.GetPersonImagesImportQuery, Generated.GetPersonImagesImportQueryVariables>;
export const GetPersonTagsDocument = /*#__PURE__*/ gql`
    query getPersonTags($personId: ID!, $brandId: ID!) {
  person(id: $personId) {
    id
    tags(limit: 1000, brandId: $brandId) {
      nodes {
        ...EntityTag
      }
    }
  }
}
    ${EntityTagFragmentDoc}`;

/**
 * __useGetPersonTagsQuery__
 *
 * To run a query within a React component, call `useGetPersonTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonTagsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetPersonTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonTagsQuery, Generated.GetPersonTagsQueryVariables> & ({ variables: Generated.GetPersonTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonTagsQuery, Generated.GetPersonTagsQueryVariables>(GetPersonTagsDocument, options);
      }
export function useGetPersonTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonTagsQuery, Generated.GetPersonTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonTagsQuery, Generated.GetPersonTagsQueryVariables>(GetPersonTagsDocument, options);
        }
export function useGetPersonTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonTagsQuery, Generated.GetPersonTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonTagsQuery, Generated.GetPersonTagsQueryVariables>(GetPersonTagsDocument, options);
        }
export type GetPersonTagsQueryHookResult = ReturnType<typeof useGetPersonTagsQuery>;
export type GetPersonTagsLazyQueryHookResult = ReturnType<typeof useGetPersonTagsLazyQuery>;
export type GetPersonTagsSuspenseQueryHookResult = ReturnType<typeof useGetPersonTagsSuspenseQuery>;
export type GetPersonTagsQueryResult = Apollo.QueryResult<Generated.GetPersonTagsQuery, Generated.GetPersonTagsQueryVariables>;
export const GetPersonListDocument = /*#__PURE__*/ gql`
    query getPersonList($limit: Int, $offset: Int!, $orderBy: PersonOrder, $search: String, $activities: [PersonActivity], $searchIn: EntitySearchTypes, $searchSensitivity: EntitySearchOptions, $brandId: ID!, $includeBrandData: Boolean = false) {
  persons(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    search: $search
    activities: $activities
    searchIn: $searchIn
    searchSensitivity: $searchSensitivity
  ) {
    totalCount
    nodes {
      __typename
      id
      ref
      firstName
      lastName
      gender
      birthDate
      deathDate
      countries {
        ...CountryOption
      }
      poster {
        ...Image
      }
      metadata {
        createdAt
        updatedAt
        createdBy {
          ...MetadataUser
        }
        updatedBy {
          ...MetadataUser
        }
      }
      activities
      activeOnBrands {
        id
      }
      seoData(brandId: $brandId) @include(if: $includeBrandData) {
        ...SeoData
      }
      metadata {
        ...Metadata
      }
    }
  }
}
    ${CountryOptionFragmentDoc}
${ImageFragmentDoc}
${MetadataUserFragmentDoc}
${SeoDataFragmentDoc}
${MetadataFragmentDoc}`;

/**
 * __useGetPersonListQuery__
 *
 * To run a query within a React component, call `useGetPersonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      activities: // value for 'activities'
 *      searchIn: // value for 'searchIn'
 *      searchSensitivity: // value for 'searchSensitivity'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetPersonListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonListQuery, Generated.GetPersonListQueryVariables> & ({ variables: Generated.GetPersonListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonListQuery, Generated.GetPersonListQueryVariables>(GetPersonListDocument, options);
      }
export function useGetPersonListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonListQuery, Generated.GetPersonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonListQuery, Generated.GetPersonListQueryVariables>(GetPersonListDocument, options);
        }
export function useGetPersonListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonListQuery, Generated.GetPersonListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonListQuery, Generated.GetPersonListQueryVariables>(GetPersonListDocument, options);
        }
export type GetPersonListQueryHookResult = ReturnType<typeof useGetPersonListQuery>;
export type GetPersonListLazyQueryHookResult = ReturnType<typeof useGetPersonListLazyQuery>;
export type GetPersonListSuspenseQueryHookResult = ReturnType<typeof useGetPersonListSuspenseQuery>;
export type GetPersonListQueryResult = Apollo.QueryResult<Generated.GetPersonListQuery, Generated.GetPersonListQueryVariables>;
export const GetPersonDocument = /*#__PURE__*/ gql`
    query getPerson($ref: ID!) {
  entityByRef(type: PERSON, ref: $ref) {
    __typename
    ... on Person {
      ...PersonFullIdentity
      ...PersonMetadata
      ...PersonNicknames
      activeOnBrands {
        ref
      }
    }
  }
}
    ${PersonFullIdentityFragmentDoc}
${PersonMetadataFragmentDoc}
${PersonNicknamesFragmentDoc}`;

/**
 * __useGetPersonQuery__
 *
 * To run a query within a React component, call `useGetPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetPersonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPersonQuery, Generated.GetPersonQueryVariables> & ({ variables: Generated.GetPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonQuery, Generated.GetPersonQueryVariables>(GetPersonDocument, options);
      }
export function useGetPersonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonQuery, Generated.GetPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonQuery, Generated.GetPersonQueryVariables>(GetPersonDocument, options);
        }
export function useGetPersonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonQuery, Generated.GetPersonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonQuery, Generated.GetPersonQueryVariables>(GetPersonDocument, options);
        }
export type GetPersonQueryHookResult = ReturnType<typeof useGetPersonQuery>;
export type GetPersonLazyQueryHookResult = ReturnType<typeof useGetPersonLazyQuery>;
export type GetPersonSuspenseQueryHookResult = ReturnType<typeof useGetPersonSuspenseQuery>;
export type GetPersonQueryResult = Apollo.QueryResult<Generated.GetPersonQuery, Generated.GetPersonQueryVariables>;
export const ImportPersonImagesDocument = /*#__PURE__*/ gql`
    mutation importPersonImages($input: ImportPersonImagesInput!) {
  importPersonImages(input: $input) {
    url
    status
    message
  }
}
    `;
export type ImportPersonImagesMutationFn = Apollo.MutationFunction<Generated.ImportPersonImagesMutation, Generated.ImportPersonImagesMutationVariables>;

/**
 * __useImportPersonImagesMutation__
 *
 * To run a mutation, you first call `useImportPersonImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPersonImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPersonImagesMutation, { data, loading, error }] = useImportPersonImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportPersonImagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.ImportPersonImagesMutation, Generated.ImportPersonImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.ImportPersonImagesMutation, Generated.ImportPersonImagesMutationVariables>(ImportPersonImagesDocument, options);
      }
export type ImportPersonImagesMutationHookResult = ReturnType<typeof useImportPersonImagesMutation>;
export type ImportPersonImagesMutationResult = Apollo.MutationResult<Generated.ImportPersonImagesMutation>;
export type ImportPersonImagesMutationOptions = Apollo.BaseMutationOptions<Generated.ImportPersonImagesMutation, Generated.ImportPersonImagesMutationVariables>;
export const UpdatePersonBrandedDataDocument = /*#__PURE__*/ gql`
    mutation updatePersonBrandedData($input: UpdatePersonBrandDataInput!, $brandId: ID!) {
  updatePersonBrandData(input: $input) {
    biography
    birthPlace
    deathPlace
    deathCause
    poster {
      ...Image
      brandData(brandId: $brandId) {
        id
        copyrights {
          ...CopyrightIdentity
        }
        copyrightName
      }
    }
  }
}
    ${ImageFragmentDoc}
${CopyrightIdentityFragmentDoc}`;
export type UpdatePersonBrandedDataMutationFn = Apollo.MutationFunction<Generated.UpdatePersonBrandedDataMutation, Generated.UpdatePersonBrandedDataMutationVariables>;

/**
 * __useUpdatePersonBrandedDataMutation__
 *
 * To run a mutation, you first call `useUpdatePersonBrandedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonBrandedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonBrandedDataMutation, { data, loading, error }] = useUpdatePersonBrandedDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useUpdatePersonBrandedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdatePersonBrandedDataMutation, Generated.UpdatePersonBrandedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdatePersonBrandedDataMutation, Generated.UpdatePersonBrandedDataMutationVariables>(UpdatePersonBrandedDataDocument, options);
      }
export type UpdatePersonBrandedDataMutationHookResult = ReturnType<typeof useUpdatePersonBrandedDataMutation>;
export type UpdatePersonBrandedDataMutationResult = Apollo.MutationResult<Generated.UpdatePersonBrandedDataMutation>;
export type UpdatePersonBrandedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdatePersonBrandedDataMutation, Generated.UpdatePersonBrandedDataMutationVariables>;
export const LaunchPersonImagesImportDocument = /*#__PURE__*/ gql`
    mutation launchPersonImagesImport($input: LaunchPersonImagesImportInput!) {
  launchPersonImagesImport(input: $input) {
    ...PersonImagesImportReportSummary
  }
}
    ${PersonImagesImportReportSummaryFragmentDoc}`;
export type LaunchPersonImagesImportMutationFn = Apollo.MutationFunction<Generated.LaunchPersonImagesImportMutation, Generated.LaunchPersonImagesImportMutationVariables>;

/**
 * __useLaunchPersonImagesImportMutation__
 *
 * To run a mutation, you first call `useLaunchPersonImagesImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchPersonImagesImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchPersonImagesImportMutation, { data, loading, error }] = useLaunchPersonImagesImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchPersonImagesImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LaunchPersonImagesImportMutation, Generated.LaunchPersonImagesImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LaunchPersonImagesImportMutation, Generated.LaunchPersonImagesImportMutationVariables>(LaunchPersonImagesImportDocument, options);
      }
export type LaunchPersonImagesImportMutationHookResult = ReturnType<typeof useLaunchPersonImagesImportMutation>;
export type LaunchPersonImagesImportMutationResult = Apollo.MutationResult<Generated.LaunchPersonImagesImportMutation>;
export type LaunchPersonImagesImportMutationOptions = Apollo.BaseMutationOptions<Generated.LaunchPersonImagesImportMutation, Generated.LaunchPersonImagesImportMutationVariables>;
export const AddReleaseToEntityDocument = /*#__PURE__*/ gql`
    mutation addReleaseToEntity($input: AddReleaseToEntityInput!) {
  addReleaseToEntity(input: $input) {
    id
    ref
  }
}
    `;
export type AddReleaseToEntityMutationFn = Apollo.MutationFunction<Generated.AddReleaseToEntityMutation, Generated.AddReleaseToEntityMutationVariables>;

/**
 * __useAddReleaseToEntityMutation__
 *
 * To run a mutation, you first call `useAddReleaseToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReleaseToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReleaseToEntityMutation, { data, loading, error }] = useAddReleaseToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddReleaseToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddReleaseToEntityMutation, Generated.AddReleaseToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddReleaseToEntityMutation, Generated.AddReleaseToEntityMutationVariables>(AddReleaseToEntityDocument, options);
      }
export type AddReleaseToEntityMutationHookResult = ReturnType<typeof useAddReleaseToEntityMutation>;
export type AddReleaseToEntityMutationResult = Apollo.MutationResult<Generated.AddReleaseToEntityMutation>;
export type AddReleaseToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.AddReleaseToEntityMutation, Generated.AddReleaseToEntityMutationVariables>;
export const UpdatePersonDocument = /*#__PURE__*/ gql`
    mutation updatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    ...PersonFullIdentity
    ...PersonMetadata
  }
}
    ${PersonFullIdentityFragmentDoc}
${PersonMetadataFragmentDoc}`;
export type UpdatePersonMutationFn = Apollo.MutationFunction<Generated.UpdatePersonMutation, Generated.UpdatePersonMutationVariables>;

/**
 * __useUpdatePersonMutation__
 *
 * To run a mutation, you first call `useUpdatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonMutation, { data, loading, error }] = useUpdatePersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdatePersonMutation, Generated.UpdatePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdatePersonMutation, Generated.UpdatePersonMutationVariables>(UpdatePersonDocument, options);
      }
export type UpdatePersonMutationHookResult = ReturnType<typeof useUpdatePersonMutation>;
export type UpdatePersonMutationResult = Apollo.MutationResult<Generated.UpdatePersonMutation>;
export type UpdatePersonMutationOptions = Apollo.BaseMutationOptions<Generated.UpdatePersonMutation, Generated.UpdatePersonMutationVariables>;
export const CreateProductDocument = /*#__PURE__*/ gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    product {
      id
    }
    releaseCreated
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<Generated.CreateProductMutation, Generated.CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateProductMutation, Generated.CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateProductMutation, Generated.CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<Generated.CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<Generated.CreateProductMutation, Generated.CreateProductMutationVariables>;
export const GetProductListDocument = /*#__PURE__*/ gql`
    query getProductList($countryId: ID!, $companyId: ID, $productType: String, $entityType: ProductEntityType, $entitySearch: String, $origin: ProductListOrigin, $limit: Int, $offset: Int) {
  productList(
    countryId: $countryId
    companyId: $companyId
    productType: $productType
    entityType: $entityType
    entitySearch: $entitySearch
    origin: $origin
    limit: $limit
    offset: $offset
  ) {
    totalCount
    nodes {
      productId
      metadata {
        ...Metadata
      }
      productType
      productName
      url
      price
      currency
      provider {
        id
        name
      }
      relatedEntityId
    }
  }
}
    ${MetadataFragmentDoc}`;

/**
 * __useGetProductListQuery__
 *
 * To run a query within a React component, call `useGetProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductListQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      companyId: // value for 'companyId'
 *      productType: // value for 'productType'
 *      entityType: // value for 'entityType'
 *      entitySearch: // value for 'entitySearch'
 *      origin: // value for 'origin'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetProductListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetProductListQuery, Generated.GetProductListQueryVariables> & ({ variables: Generated.GetProductListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetProductListQuery, Generated.GetProductListQueryVariables>(GetProductListDocument, options);
      }
export function useGetProductListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetProductListQuery, Generated.GetProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetProductListQuery, Generated.GetProductListQueryVariables>(GetProductListDocument, options);
        }
export function useGetProductListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetProductListQuery, Generated.GetProductListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetProductListQuery, Generated.GetProductListQueryVariables>(GetProductListDocument, options);
        }
export type GetProductListQueryHookResult = ReturnType<typeof useGetProductListQuery>;
export type GetProductListLazyQueryHookResult = ReturnType<typeof useGetProductListLazyQuery>;
export type GetProductListSuspenseQueryHookResult = ReturnType<typeof useGetProductListSuspenseQuery>;
export type GetProductListQueryResult = Apollo.QueryResult<Generated.GetProductListQuery, Generated.GetProductListQueryVariables>;
export const GetProductDocument = /*#__PURE__*/ gql`
    query getProduct($productId: ID!) {
  product(productId: $productId) {
    productId
    countryId
    companyId
    productType
    name
    url
    price
    currency
    country {
      ...CountryOption
    }
    linkedEntities {
      ... on Movie {
        id
        __typename
        title
      }
      ... on Series {
        id
        __typename
        title
      }
      ... on SeriesSeason {
        id
        __typename
        ref
        number
        series {
          id
          title
        }
      }
      ... on SeriesEpisode {
        id
        __typename
        ref
        number
        series {
          id
          title
        }
        season {
          id
          number
        }
      }
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetProductQuery, Generated.GetProductQueryVariables> & ({ variables: Generated.GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetProductQuery, Generated.GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetProductQuery, Generated.GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetProductQuery, Generated.GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetProductQuery, Generated.GetProductQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetProductQuery, Generated.GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<Generated.GetProductQuery, Generated.GetProductQueryVariables>;
export const HasReleaseForEntityDocument = /*#__PURE__*/ gql`
    query hasReleaseForEntity($entityId: ID!, $countryId: ID!, $limitedCompanyId: ID, $type: ReleaseType!) {
  hasReleaseForEntity(
    entityId: $entityId
    countryId: $countryId
    limitedCompanyId: $limitedCompanyId
    type: $type
  )
}
    `;

/**
 * __useHasReleaseForEntityQuery__
 *
 * To run a query within a React component, call `useHasReleaseForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasReleaseForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasReleaseForEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      countryId: // value for 'countryId'
 *      limitedCompanyId: // value for 'limitedCompanyId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useHasReleaseForEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.HasReleaseForEntityQuery, Generated.HasReleaseForEntityQueryVariables> & ({ variables: Generated.HasReleaseForEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.HasReleaseForEntityQuery, Generated.HasReleaseForEntityQueryVariables>(HasReleaseForEntityDocument, options);
      }
export function useHasReleaseForEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.HasReleaseForEntityQuery, Generated.HasReleaseForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.HasReleaseForEntityQuery, Generated.HasReleaseForEntityQueryVariables>(HasReleaseForEntityDocument, options);
        }
export function useHasReleaseForEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.HasReleaseForEntityQuery, Generated.HasReleaseForEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.HasReleaseForEntityQuery, Generated.HasReleaseForEntityQueryVariables>(HasReleaseForEntityDocument, options);
        }
export type HasReleaseForEntityQueryHookResult = ReturnType<typeof useHasReleaseForEntityQuery>;
export type HasReleaseForEntityLazyQueryHookResult = ReturnType<typeof useHasReleaseForEntityLazyQuery>;
export type HasReleaseForEntitySuspenseQueryHookResult = ReturnType<typeof useHasReleaseForEntitySuspenseQuery>;
export type HasReleaseForEntityQueryResult = Apollo.QueryResult<Generated.HasReleaseForEntityQuery, Generated.HasReleaseForEntityQueryVariables>;
export const UpdateProductDetailsDocument = /*#__PURE__*/ gql`
    mutation updateProductDetails($input: UpdateProductDetailsInput!) {
  updateProductDetails(input: $input) {
    id
  }
}
    `;
export type UpdateProductDetailsMutationFn = Apollo.MutationFunction<Generated.UpdateProductDetailsMutation, Generated.UpdateProductDetailsMutationVariables>;

/**
 * __useUpdateProductDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateProductDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductDetailsMutation, { data, loading, error }] = useUpdateProductDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateProductDetailsMutation, Generated.UpdateProductDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateProductDetailsMutation, Generated.UpdateProductDetailsMutationVariables>(UpdateProductDetailsDocument, options);
      }
export type UpdateProductDetailsMutationHookResult = ReturnType<typeof useUpdateProductDetailsMutation>;
export type UpdateProductDetailsMutationResult = Apollo.MutationResult<Generated.UpdateProductDetailsMutation>;
export type UpdateProductDetailsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateProductDetailsMutation, Generated.UpdateProductDetailsMutationVariables>;
export const UpdateProductProviderDocument = /*#__PURE__*/ gql`
    mutation updateProductProvider($input: UpdateProductProviderInput!) {
  updateProductProvider(input: $input) {
    id
  }
}
    `;
export type UpdateProductProviderMutationFn = Apollo.MutationFunction<Generated.UpdateProductProviderMutation, Generated.UpdateProductProviderMutationVariables>;

/**
 * __useUpdateProductProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProductProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductProviderMutation, { data, loading, error }] = useUpdateProductProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateProductProviderMutation, Generated.UpdateProductProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateProductProviderMutation, Generated.UpdateProductProviderMutationVariables>(UpdateProductProviderDocument, options);
      }
export type UpdateProductProviderMutationHookResult = ReturnType<typeof useUpdateProductProviderMutation>;
export type UpdateProductProviderMutationResult = Apollo.MutationResult<Generated.UpdateProductProviderMutation>;
export type UpdateProductProviderMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateProductProviderMutation, Generated.UpdateProductProviderMutationVariables>;
export const CreateRedirectionRuleDocument = /*#__PURE__*/ gql`
    mutation CreateRedirectionRule($input: CreateRedirectionRuleInput!) {
  createRedirectionRule(input: $input) {
    ...RedirectionRuleRow
  }
}
    ${RedirectionRuleRowFragmentDoc}`;
export type CreateRedirectionRuleMutationFn = Apollo.MutationFunction<Generated.CreateRedirectionRuleMutation, Generated.CreateRedirectionRuleMutationVariables>;

/**
 * __useCreateRedirectionRuleMutation__
 *
 * To run a mutation, you first call `useCreateRedirectionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRedirectionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRedirectionRuleMutation, { data, loading, error }] = useCreateRedirectionRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRedirectionRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateRedirectionRuleMutation, Generated.CreateRedirectionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateRedirectionRuleMutation, Generated.CreateRedirectionRuleMutationVariables>(CreateRedirectionRuleDocument, options);
      }
export type CreateRedirectionRuleMutationHookResult = ReturnType<typeof useCreateRedirectionRuleMutation>;
export type CreateRedirectionRuleMutationResult = Apollo.MutationResult<Generated.CreateRedirectionRuleMutation>;
export type CreateRedirectionRuleMutationOptions = Apollo.BaseMutationOptions<Generated.CreateRedirectionRuleMutation, Generated.CreateRedirectionRuleMutationVariables>;
export const RedirectionRuleChainRewritesDocument = /*#__PURE__*/ gql`
    query RedirectionRuleChainRewrites($id: ID, $brandId: ID!, $kind: RedirectionRuleKind!, $mode: WritableRedirectionMode!, $active: Boolean, $sourcePattern: String, $targetPattern: String, $startAt: DateTimeISO, $endAt: DateTimeISO) {
  redirectionRuleChainRewrites(
    id: $id
    brandId: $brandId
    kind: $kind
    mode: $mode
    active: $active
    sourcePattern: $sourcePattern
    targetPattern: $targetPattern
    startAt: $startAt
    endAt: $endAt
  ) {
    target
    warnings
    reviewToken
    rewrites {
      ...RedirectionRuleChainRewrite
    }
  }
}
    ${RedirectionRuleChainRewriteFragmentDoc}`;

/**
 * __useRedirectionRuleChainRewritesQuery__
 *
 * To run a query within a React component, call `useRedirectionRuleChainRewritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectionRuleChainRewritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectionRuleChainRewritesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      kind: // value for 'kind'
 *      mode: // value for 'mode'
 *      active: // value for 'active'
 *      sourcePattern: // value for 'sourcePattern'
 *      targetPattern: // value for 'targetPattern'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useRedirectionRuleChainRewritesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.RedirectionRuleChainRewritesQuery, Generated.RedirectionRuleChainRewritesQueryVariables> & ({ variables: Generated.RedirectionRuleChainRewritesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.RedirectionRuleChainRewritesQuery, Generated.RedirectionRuleChainRewritesQueryVariables>(RedirectionRuleChainRewritesDocument, options);
      }
export function useRedirectionRuleChainRewritesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.RedirectionRuleChainRewritesQuery, Generated.RedirectionRuleChainRewritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.RedirectionRuleChainRewritesQuery, Generated.RedirectionRuleChainRewritesQueryVariables>(RedirectionRuleChainRewritesDocument, options);
        }
export function useRedirectionRuleChainRewritesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.RedirectionRuleChainRewritesQuery, Generated.RedirectionRuleChainRewritesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.RedirectionRuleChainRewritesQuery, Generated.RedirectionRuleChainRewritesQueryVariables>(RedirectionRuleChainRewritesDocument, options);
        }
export type RedirectionRuleChainRewritesQueryHookResult = ReturnType<typeof useRedirectionRuleChainRewritesQuery>;
export type RedirectionRuleChainRewritesLazyQueryHookResult = ReturnType<typeof useRedirectionRuleChainRewritesLazyQuery>;
export type RedirectionRuleChainRewritesSuspenseQueryHookResult = ReturnType<typeof useRedirectionRuleChainRewritesSuspenseQuery>;
export type RedirectionRuleChainRewritesQueryResult = Apollo.QueryResult<Generated.RedirectionRuleChainRewritesQuery, Generated.RedirectionRuleChainRewritesQueryVariables>;
export const RedirectionRulesExportDocument = /*#__PURE__*/ gql`
    query RedirectionRulesExport($offset: Int, $limit: Int, $q: String, $brandIds: [ID!], $kinds: [RedirectionRuleKind!], $modes: [RedirectionMode!], $status: RedirectionRuleStatus, $sourceUrl: String, $destinationUrl: String, $startAt: DateTimeISO, $endAt: DateTimeISO) {
  redirectionRules(
    offset: $offset
    limit: $limit
    q: $q
    brandIds: $brandIds
    kinds: $kinds
    modes: $modes
    status: $status
    sourceUrl: $sourceUrl
    destinationUrl: $destinationUrl
    startAt: $startAt
    endAt: $endAt
  ) {
    totalCount
    nodes {
      ...RedirectionRuleExportRow
    }
  }
}
    ${RedirectionRuleExportRowFragmentDoc}`;

/**
 * __useRedirectionRulesExportQuery__
 *
 * To run a query within a React component, call `useRedirectionRulesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectionRulesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectionRulesExportQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      brandIds: // value for 'brandIds'
 *      kinds: // value for 'kinds'
 *      modes: // value for 'modes'
 *      status: // value for 'status'
 *      sourceUrl: // value for 'sourceUrl'
 *      destinationUrl: // value for 'destinationUrl'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useRedirectionRulesExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.RedirectionRulesExportQuery, Generated.RedirectionRulesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.RedirectionRulesExportQuery, Generated.RedirectionRulesExportQueryVariables>(RedirectionRulesExportDocument, options);
      }
export function useRedirectionRulesExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.RedirectionRulesExportQuery, Generated.RedirectionRulesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.RedirectionRulesExportQuery, Generated.RedirectionRulesExportQueryVariables>(RedirectionRulesExportDocument, options);
        }
export function useRedirectionRulesExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.RedirectionRulesExportQuery, Generated.RedirectionRulesExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.RedirectionRulesExportQuery, Generated.RedirectionRulesExportQueryVariables>(RedirectionRulesExportDocument, options);
        }
export type RedirectionRulesExportQueryHookResult = ReturnType<typeof useRedirectionRulesExportQuery>;
export type RedirectionRulesExportLazyQueryHookResult = ReturnType<typeof useRedirectionRulesExportLazyQuery>;
export type RedirectionRulesExportSuspenseQueryHookResult = ReturnType<typeof useRedirectionRulesExportSuspenseQuery>;
export type RedirectionRulesExportQueryResult = Apollo.QueryResult<Generated.RedirectionRulesExportQuery, Generated.RedirectionRulesExportQueryVariables>;
export const DeleteRedirectionRulesDocument = /*#__PURE__*/ gql`
    mutation DeleteRedirectionRules($input: DeleteRedirectionRulesInput!) {
  deleteRedirectionRules(input: $input)
}
    `;
export type DeleteRedirectionRulesMutationFn = Apollo.MutationFunction<Generated.DeleteRedirectionRulesMutation, Generated.DeleteRedirectionRulesMutationVariables>;

/**
 * __useDeleteRedirectionRulesMutation__
 *
 * To run a mutation, you first call `useDeleteRedirectionRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRedirectionRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRedirectionRulesMutation, { data, loading, error }] = useDeleteRedirectionRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRedirectionRulesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteRedirectionRulesMutation, Generated.DeleteRedirectionRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteRedirectionRulesMutation, Generated.DeleteRedirectionRulesMutationVariables>(DeleteRedirectionRulesDocument, options);
      }
export type DeleteRedirectionRulesMutationHookResult = ReturnType<typeof useDeleteRedirectionRulesMutation>;
export type DeleteRedirectionRulesMutationResult = Apollo.MutationResult<Generated.DeleteRedirectionRulesMutation>;
export type DeleteRedirectionRulesMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteRedirectionRulesMutation, Generated.DeleteRedirectionRulesMutationVariables>;
export const RedirectionRulesListDocument = /*#__PURE__*/ gql`
    query RedirectionRulesList($offset: Int, $limit: Int, $q: String, $brandIds: [ID!], $modes: [RedirectionMode!], $status: RedirectionRuleStatus, $sourceUrl: String, $destinationUrl: String, $startAt: DateTimeISO, $endAt: DateTimeISO, $orderBy: RedirectionRulesOrder) {
  redirectionRules(
    offset: $offset
    limit: $limit
    q: $q
    brandIds: $brandIds
    modes: $modes
    status: $status
    sourceUrl: $sourceUrl
    destinationUrl: $destinationUrl
    startAt: $startAt
    endAt: $endAt
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...RedirectionRuleRow
    }
  }
}
    ${RedirectionRuleRowFragmentDoc}`;

/**
 * __useRedirectionRulesListQuery__
 *
 * To run a query within a React component, call `useRedirectionRulesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectionRulesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectionRulesListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      brandIds: // value for 'brandIds'
 *      modes: // value for 'modes'
 *      status: // value for 'status'
 *      sourceUrl: // value for 'sourceUrl'
 *      destinationUrl: // value for 'destinationUrl'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRedirectionRulesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.RedirectionRulesListQuery, Generated.RedirectionRulesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.RedirectionRulesListQuery, Generated.RedirectionRulesListQueryVariables>(RedirectionRulesListDocument, options);
      }
export function useRedirectionRulesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.RedirectionRulesListQuery, Generated.RedirectionRulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.RedirectionRulesListQuery, Generated.RedirectionRulesListQueryVariables>(RedirectionRulesListDocument, options);
        }
export function useRedirectionRulesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.RedirectionRulesListQuery, Generated.RedirectionRulesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.RedirectionRulesListQuery, Generated.RedirectionRulesListQueryVariables>(RedirectionRulesListDocument, options);
        }
export type RedirectionRulesListQueryHookResult = ReturnType<typeof useRedirectionRulesListQuery>;
export type RedirectionRulesListLazyQueryHookResult = ReturnType<typeof useRedirectionRulesListLazyQuery>;
export type RedirectionRulesListSuspenseQueryHookResult = ReturnType<typeof useRedirectionRulesListSuspenseQuery>;
export type RedirectionRulesListQueryResult = Apollo.QueryResult<Generated.RedirectionRulesListQuery, Generated.RedirectionRulesListQueryVariables>;
export const UpsertRedirectionRulesDocument = /*#__PURE__*/ gql`
    mutation UpsertRedirectionRules($input: UpsertRedirectionRulesInput!) {
  upsertRedirectionRules(input: $input) {
    totalRows
    createdCount
    updatedCount
    unchangedCount
    rewrittenCount
    chainReviewToken
    chainRewrites {
      ...RedirectionRuleChainRewrite
    }
    errors {
      index
      field
      message
    }
  }
}
    ${RedirectionRuleChainRewriteFragmentDoc}`;
export type UpsertRedirectionRulesMutationFn = Apollo.MutationFunction<Generated.UpsertRedirectionRulesMutation, Generated.UpsertRedirectionRulesMutationVariables>;

/**
 * __useUpsertRedirectionRulesMutation__
 *
 * To run a mutation, you first call `useUpsertRedirectionRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRedirectionRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRedirectionRulesMutation, { data, loading, error }] = useUpsertRedirectionRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertRedirectionRulesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertRedirectionRulesMutation, Generated.UpsertRedirectionRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertRedirectionRulesMutation, Generated.UpsertRedirectionRulesMutationVariables>(UpsertRedirectionRulesDocument, options);
      }
export type UpsertRedirectionRulesMutationHookResult = ReturnType<typeof useUpsertRedirectionRulesMutation>;
export type UpsertRedirectionRulesMutationResult = Apollo.MutationResult<Generated.UpsertRedirectionRulesMutation>;
export type UpsertRedirectionRulesMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertRedirectionRulesMutation, Generated.UpsertRedirectionRulesMutationVariables>;
export const UpdateRedirectionRuleDocument = /*#__PURE__*/ gql`
    mutation UpdateRedirectionRule($input: UpdateRedirectionRuleInput!) {
  updateRedirectionRule(input: $input) {
    ...RedirectionRuleRow
  }
}
    ${RedirectionRuleRowFragmentDoc}`;
export type UpdateRedirectionRuleMutationFn = Apollo.MutationFunction<Generated.UpdateRedirectionRuleMutation, Generated.UpdateRedirectionRuleMutationVariables>;

/**
 * __useUpdateRedirectionRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRedirectionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRedirectionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRedirectionRuleMutation, { data, loading, error }] = useUpdateRedirectionRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRedirectionRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateRedirectionRuleMutation, Generated.UpdateRedirectionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateRedirectionRuleMutation, Generated.UpdateRedirectionRuleMutationVariables>(UpdateRedirectionRuleDocument, options);
      }
export type UpdateRedirectionRuleMutationHookResult = ReturnType<typeof useUpdateRedirectionRuleMutation>;
export type UpdateRedirectionRuleMutationResult = Apollo.MutationResult<Generated.UpdateRedirectionRuleMutation>;
export type UpdateRedirectionRuleMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateRedirectionRuleMutation, Generated.UpdateRedirectionRuleMutationVariables>;
export const CreateScreenDocument = /*#__PURE__*/ gql`
    mutation createScreen($theaterId: ID!, $number: Int!, $name: String!, $size: ScreenSizeInput) {
  createScreen(
    input: {theaterId: $theaterId, number: $number, size: $size, name: $name}
  ) {
    id
  }
}
    `;
export type CreateScreenMutationFn = Apollo.MutationFunction<Generated.CreateScreenMutation, Generated.CreateScreenMutationVariables>;

/**
 * __useCreateScreenMutation__
 *
 * To run a mutation, you first call `useCreateScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreenMutation, { data, loading, error }] = useCreateScreenMutation({
 *   variables: {
 *      theaterId: // value for 'theaterId'
 *      number: // value for 'number'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useCreateScreenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateScreenMutation, Generated.CreateScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateScreenMutation, Generated.CreateScreenMutationVariables>(CreateScreenDocument, options);
      }
export type CreateScreenMutationHookResult = ReturnType<typeof useCreateScreenMutation>;
export type CreateScreenMutationResult = Apollo.MutationResult<Generated.CreateScreenMutation>;
export type CreateScreenMutationOptions = Apollo.BaseMutationOptions<Generated.CreateScreenMutation, Generated.CreateScreenMutationVariables>;
export const AddImageToScreenDocument = /*#__PURE__*/ gql`
    mutation addImageToScreen($entityId: ID!, $imageId: ID!) {
  addImageToScreen(input: {entityId: $entityId, imageId: $imageId}) {
    ...ImageReference
  }
}
    ${ImageReferenceFragmentDoc}`;
export type AddImageToScreenMutationFn = Apollo.MutationFunction<Generated.AddImageToScreenMutation, Generated.AddImageToScreenMutationVariables>;

/**
 * __useAddImageToScreenMutation__
 *
 * To run a mutation, you first call `useAddImageToScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddImageToScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addImageToScreenMutation, { data, loading, error }] = useAddImageToScreenMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useAddImageToScreenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddImageToScreenMutation, Generated.AddImageToScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddImageToScreenMutation, Generated.AddImageToScreenMutationVariables>(AddImageToScreenDocument, options);
      }
export type AddImageToScreenMutationHookResult = ReturnType<typeof useAddImageToScreenMutation>;
export type AddImageToScreenMutationResult = Apollo.MutationResult<Generated.AddImageToScreenMutation>;
export type AddImageToScreenMutationOptions = Apollo.BaseMutationOptions<Generated.AddImageToScreenMutation, Generated.AddImageToScreenMutationVariables>;
export const DeleteImageFromScreenDocument = /*#__PURE__*/ gql`
    mutation deleteImageFromScreen($entityId: ID!, $imageId: ID!) {
  deleteImageFromScreen(input: {entityId: $entityId, imageId: $imageId}) {
    image {
      id
      url
    }
    rank
  }
}
    `;
export type DeleteImageFromScreenMutationFn = Apollo.MutationFunction<Generated.DeleteImageFromScreenMutation, Generated.DeleteImageFromScreenMutationVariables>;

/**
 * __useDeleteImageFromScreenMutation__
 *
 * To run a mutation, you first call `useDeleteImageFromScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageFromScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageFromScreenMutation, { data, loading, error }] = useDeleteImageFromScreenMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useDeleteImageFromScreenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteImageFromScreenMutation, Generated.DeleteImageFromScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteImageFromScreenMutation, Generated.DeleteImageFromScreenMutationVariables>(DeleteImageFromScreenDocument, options);
      }
export type DeleteImageFromScreenMutationHookResult = ReturnType<typeof useDeleteImageFromScreenMutation>;
export type DeleteImageFromScreenMutationResult = Apollo.MutationResult<Generated.DeleteImageFromScreenMutation>;
export type DeleteImageFromScreenMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteImageFromScreenMutation, Generated.DeleteImageFromScreenMutationVariables>;
export const GetScreenDocument = /*#__PURE__*/ gql`
    query getScreen($id: ID!) {
  screen(id: $id) {
    id
    ...EntityAlts
    ...ScreenFlags
    ...ScreenIdentity
    ...ScreenMetadata
    ...ScreenSeats
    ...ScreenNav
  }
}
    ${EntityAltsFragmentDoc}
${ScreenFlagsFragmentDoc}
${ScreenIdentityFragmentDoc}
${ScreenMetadataFragmentDoc}
${ScreenSeatsFragmentDoc}
${ScreenNavFragmentDoc}`;

/**
 * __useGetScreenQuery__
 *
 * To run a query within a React component, call `useGetScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScreenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScreenQuery, Generated.GetScreenQueryVariables> & ({ variables: Generated.GetScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScreenQuery, Generated.GetScreenQueryVariables>(GetScreenDocument, options);
      }
export function useGetScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScreenQuery, Generated.GetScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScreenQuery, Generated.GetScreenQueryVariables>(GetScreenDocument, options);
        }
export function useGetScreenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScreenQuery, Generated.GetScreenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScreenQuery, Generated.GetScreenQueryVariables>(GetScreenDocument, options);
        }
export type GetScreenQueryHookResult = ReturnType<typeof useGetScreenQuery>;
export type GetScreenLazyQueryHookResult = ReturnType<typeof useGetScreenLazyQuery>;
export type GetScreenSuspenseQueryHookResult = ReturnType<typeof useGetScreenSuspenseQuery>;
export type GetScreenQueryResult = Apollo.QueryResult<Generated.GetScreenQuery, Generated.GetScreenQueryVariables>;
export const GetScreenImagesDocument = /*#__PURE__*/ gql`
    query getScreenImages($id: ID!, $limit: Int, $offset: Int!) {
  screen(id: $id) {
    id
    images(limit: $limit, offset: $offset) {
      totalCount
      nodes {
        ...ImageReference
      }
    }
  }
}
    ${ImageReferenceFragmentDoc}`;

/**
 * __useGetScreenImagesQuery__
 *
 * To run a query within a React component, call `useGetScreenImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenImagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetScreenImagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScreenImagesQuery, Generated.GetScreenImagesQueryVariables> & ({ variables: Generated.GetScreenImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScreenImagesQuery, Generated.GetScreenImagesQueryVariables>(GetScreenImagesDocument, options);
      }
export function useGetScreenImagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScreenImagesQuery, Generated.GetScreenImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScreenImagesQuery, Generated.GetScreenImagesQueryVariables>(GetScreenImagesDocument, options);
        }
export function useGetScreenImagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScreenImagesQuery, Generated.GetScreenImagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScreenImagesQuery, Generated.GetScreenImagesQueryVariables>(GetScreenImagesDocument, options);
        }
export type GetScreenImagesQueryHookResult = ReturnType<typeof useGetScreenImagesQuery>;
export type GetScreenImagesLazyQueryHookResult = ReturnType<typeof useGetScreenImagesLazyQuery>;
export type GetScreenImagesSuspenseQueryHookResult = ReturnType<typeof useGetScreenImagesSuspenseQuery>;
export type GetScreenImagesQueryResult = Apollo.QueryResult<Generated.GetScreenImagesQuery, Generated.GetScreenImagesQueryVariables>;
export const GetTheaterIdDocument = /*#__PURE__*/ gql`
    query getTheaterId($code: ID!) {
  theaterByCode(code: $code) {
    id
  }
}
    `;

/**
 * __useGetTheaterIdQuery__
 *
 * To run a query within a React component, call `useGetTheaterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterIdQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetTheaterIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterIdQuery, Generated.GetTheaterIdQueryVariables> & ({ variables: Generated.GetTheaterIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterIdQuery, Generated.GetTheaterIdQueryVariables>(GetTheaterIdDocument, options);
      }
export function useGetTheaterIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterIdQuery, Generated.GetTheaterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterIdQuery, Generated.GetTheaterIdQueryVariables>(GetTheaterIdDocument, options);
        }
export function useGetTheaterIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterIdQuery, Generated.GetTheaterIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterIdQuery, Generated.GetTheaterIdQueryVariables>(GetTheaterIdDocument, options);
        }
export type GetTheaterIdQueryHookResult = ReturnType<typeof useGetTheaterIdQuery>;
export type GetTheaterIdLazyQueryHookResult = ReturnType<typeof useGetTheaterIdLazyQuery>;
export type GetTheaterIdSuspenseQueryHookResult = ReturnType<typeof useGetTheaterIdSuspenseQuery>;
export type GetTheaterIdQueryResult = Apollo.QueryResult<Generated.GetTheaterIdQuery, Generated.GetTheaterIdQueryVariables>;
export const UpdateScreenFlagsDocument = /*#__PURE__*/ gql`
    mutation updateScreenFlags($id: ID!, $flags: ScreenFlagsInput!) {
  updateScreen(input: {id: $id, flags: $flags}) {
    id
    ...ScreenFlags
    ...ScreenMetadata
  }
}
    ${ScreenFlagsFragmentDoc}
${ScreenMetadataFragmentDoc}`;
export type UpdateScreenFlagsMutationFn = Apollo.MutationFunction<Generated.UpdateScreenFlagsMutation, Generated.UpdateScreenFlagsMutationVariables>;

/**
 * __useUpdateScreenFlagsMutation__
 *
 * To run a mutation, you first call `useUpdateScreenFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreenFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreenFlagsMutation, { data, loading, error }] = useUpdateScreenFlagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      flags: // value for 'flags'
 *   },
 * });
 */
export function useUpdateScreenFlagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateScreenFlagsMutation, Generated.UpdateScreenFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateScreenFlagsMutation, Generated.UpdateScreenFlagsMutationVariables>(UpdateScreenFlagsDocument, options);
      }
export type UpdateScreenFlagsMutationHookResult = ReturnType<typeof useUpdateScreenFlagsMutation>;
export type UpdateScreenFlagsMutationResult = Apollo.MutationResult<Generated.UpdateScreenFlagsMutation>;
export type UpdateScreenFlagsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateScreenFlagsMutation, Generated.UpdateScreenFlagsMutationVariables>;
export const UpdateScreenSeatsDocument = /*#__PURE__*/ gql`
    mutation updateScreenSeats($id: ID!, $seats: Int) {
  updateScreen(input: {id: $id, seats: $seats}) {
    id
    ...ScreenSeats
    ...ScreenMetadata
  }
}
    ${ScreenSeatsFragmentDoc}
${ScreenMetadataFragmentDoc}`;
export type UpdateScreenSeatsMutationFn = Apollo.MutationFunction<Generated.UpdateScreenSeatsMutation, Generated.UpdateScreenSeatsMutationVariables>;

/**
 * __useUpdateScreenSeatsMutation__
 *
 * To run a mutation, you first call `useUpdateScreenSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreenSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreenSeatsMutation, { data, loading, error }] = useUpdateScreenSeatsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      seats: // value for 'seats'
 *   },
 * });
 */
export function useUpdateScreenSeatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateScreenSeatsMutation, Generated.UpdateScreenSeatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateScreenSeatsMutation, Generated.UpdateScreenSeatsMutationVariables>(UpdateScreenSeatsDocument, options);
      }
export type UpdateScreenSeatsMutationHookResult = ReturnType<typeof useUpdateScreenSeatsMutation>;
export type UpdateScreenSeatsMutationResult = Apollo.MutationResult<Generated.UpdateScreenSeatsMutation>;
export type UpdateScreenSeatsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateScreenSeatsMutation, Generated.UpdateScreenSeatsMutationVariables>;
export const UpdateScreenIdentityDocument = /*#__PURE__*/ gql`
    mutation updateScreenIdentity($id: ID!, $number: Int!, $name: String, $size: ScreenSizeInput) {
  updateScreen(input: {id: $id, number: $number, name: $name, size: $size}) {
    id
    ...ScreenIdentity
    ...ScreenMetadata
  }
}
    ${ScreenIdentityFragmentDoc}
${ScreenMetadataFragmentDoc}`;
export type UpdateScreenIdentityMutationFn = Apollo.MutationFunction<Generated.UpdateScreenIdentityMutation, Generated.UpdateScreenIdentityMutationVariables>;

/**
 * __useUpdateScreenIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateScreenIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreenIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreenIdentityMutation, { data, loading, error }] = useUpdateScreenIdentityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      number: // value for 'number'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUpdateScreenIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateScreenIdentityMutation, Generated.UpdateScreenIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateScreenIdentityMutation, Generated.UpdateScreenIdentityMutationVariables>(UpdateScreenIdentityDocument, options);
      }
export type UpdateScreenIdentityMutationHookResult = ReturnType<typeof useUpdateScreenIdentityMutation>;
export type UpdateScreenIdentityMutationResult = Apollo.MutationResult<Generated.UpdateScreenIdentityMutation>;
export type UpdateScreenIdentityMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateScreenIdentityMutation, Generated.UpdateScreenIdentityMutationVariables>;
export const CreateUserDocument = /*#__PURE__*/ gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    ref
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<Generated.CreateUserMutation, Generated.CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateUserMutation, Generated.CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateUserMutation, Generated.CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<Generated.CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<Generated.CreateUserMutation, Generated.CreateUserMutationVariables>;
export const DeletePresetDocument = /*#__PURE__*/ gql`
    mutation deletePreset($presetId: ID!) {
  deletePreset(input: {presetId: $presetId}) {
    id
  }
}
    `;
export type DeletePresetMutationFn = Apollo.MutationFunction<Generated.DeletePresetMutation, Generated.DeletePresetMutationVariables>;

/**
 * __useDeletePresetMutation__
 *
 * To run a mutation, you first call `useDeletePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePresetMutation, { data, loading, error }] = useDeletePresetMutation({
 *   variables: {
 *      presetId: // value for 'presetId'
 *   },
 * });
 */
export function useDeletePresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeletePresetMutation, Generated.DeletePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeletePresetMutation, Generated.DeletePresetMutationVariables>(DeletePresetDocument, options);
      }
export type DeletePresetMutationHookResult = ReturnType<typeof useDeletePresetMutation>;
export type DeletePresetMutationResult = Apollo.MutationResult<Generated.DeletePresetMutation>;
export type DeletePresetMutationOptions = Apollo.BaseMutationOptions<Generated.DeletePresetMutation, Generated.DeletePresetMutationVariables>;
export const CreatePresetDocument = /*#__PURE__*/ gql`
    mutation createPreset($input: CreatePresetInput!) {
  createPreset(input: $input) {
    id
  }
}
    `;
export type CreatePresetMutationFn = Apollo.MutationFunction<Generated.CreatePresetMutation, Generated.CreatePresetMutationVariables>;

/**
 * __useCreatePresetMutation__
 *
 * To run a mutation, you first call `useCreatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPresetMutation, { data, loading, error }] = useCreatePresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreatePresetMutation, Generated.CreatePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreatePresetMutation, Generated.CreatePresetMutationVariables>(CreatePresetDocument, options);
      }
export type CreatePresetMutationHookResult = ReturnType<typeof useCreatePresetMutation>;
export type CreatePresetMutationResult = Apollo.MutationResult<Generated.CreatePresetMutation>;
export type CreatePresetMutationOptions = Apollo.BaseMutationOptions<Generated.CreatePresetMutation, Generated.CreatePresetMutationVariables>;
export const CreateTeamDocument = /*#__PURE__*/ gql`
    mutation createTeam($name: String!, $countryIds: [ID!]!, $brandIds: [ID!]!, $localeIds: [ID!]!) {
  createTeam(
    input: {name: $name, countryIds: $countryIds, brandIds: $brandIds, localeIds: $localeIds}
  ) {
    id
    ref
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<Generated.CreateTeamMutation, Generated.CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      name: // value for 'name'
 *      countryIds: // value for 'countryIds'
 *      brandIds: // value for 'brandIds'
 *      localeIds: // value for 'localeIds'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateTeamMutation, Generated.CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateTeamMutation, Generated.CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<Generated.CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<Generated.CreateTeamMutation, Generated.CreateTeamMutationVariables>;
export const GetPresetListDocument = /*#__PURE__*/ gql`
    query getPresetList($limit: Int, $offset: Int!, $search: String, $universes: [Universe!]) {
  presets(limit: $limit, offset: $offset, search: $search, universes: $universes) {
    totalCount
    nodes {
      ...PresetRow
    }
  }
}
    ${PresetRowFragmentDoc}`;

/**
 * __useGetPresetListQuery__
 *
 * To run a query within a React component, call `useGetPresetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresetListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      universes: // value for 'universes'
 *   },
 * });
 */
export function useGetPresetListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPresetListQuery, Generated.GetPresetListQueryVariables> & ({ variables: Generated.GetPresetListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPresetListQuery, Generated.GetPresetListQueryVariables>(GetPresetListDocument, options);
      }
export function useGetPresetListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPresetListQuery, Generated.GetPresetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPresetListQuery, Generated.GetPresetListQueryVariables>(GetPresetListDocument, options);
        }
export function useGetPresetListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPresetListQuery, Generated.GetPresetListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPresetListQuery, Generated.GetPresetListQueryVariables>(GetPresetListDocument, options);
        }
export type GetPresetListQueryHookResult = ReturnType<typeof useGetPresetListQuery>;
export type GetPresetListLazyQueryHookResult = ReturnType<typeof useGetPresetListLazyQuery>;
export type GetPresetListSuspenseQueryHookResult = ReturnType<typeof useGetPresetListSuspenseQuery>;
export type GetPresetListQueryResult = Apollo.QueryResult<Generated.GetPresetListQuery, Generated.GetPresetListQueryVariables>;
export const DeleteTeamDocument = /*#__PURE__*/ gql`
    mutation deleteTeam($teamId: ID!) {
  deleteTeam(input: {teamId: $teamId}) {
    id
    name
  }
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<Generated.DeleteTeamMutation, Generated.DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteTeamMutation, Generated.DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteTeamMutation, Generated.DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<Generated.DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteTeamMutation, Generated.DeleteTeamMutationVariables>;
export const GenerateUserTokenDocument = /*#__PURE__*/ gql`
    mutation GenerateUserToken($input: GenerateUserTokenInput!) {
  generateUserToken(input: $input)
}
    `;
export type GenerateUserTokenMutationFn = Apollo.MutationFunction<Generated.GenerateUserTokenMutation, Generated.GenerateUserTokenMutationVariables>;

/**
 * __useGenerateUserTokenMutation__
 *
 * To run a mutation, you first call `useGenerateUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUserTokenMutation, { data, loading, error }] = useGenerateUserTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUserTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.GenerateUserTokenMutation, Generated.GenerateUserTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.GenerateUserTokenMutation, Generated.GenerateUserTokenMutationVariables>(GenerateUserTokenDocument, options);
      }
export type GenerateUserTokenMutationHookResult = ReturnType<typeof useGenerateUserTokenMutation>;
export type GenerateUserTokenMutationResult = Apollo.MutationResult<Generated.GenerateUserTokenMutation>;
export type GenerateUserTokenMutationOptions = Apollo.BaseMutationOptions<Generated.GenerateUserTokenMutation, Generated.GenerateUserTokenMutationVariables>;
export const GetBrandOrCountryLocaleDocument = /*#__PURE__*/ gql`
    query getBrandOrCountryLocale($brandId: ID!, $countryId: ID!, $withBrandData: Boolean = false) {
  brand(id: $brandId) @include(if: $withBrandData) {
    id
    locale {
      ...LocaleOption
    }
  }
  country(id: $countryId) {
    id
    locale {
      ...LocaleOption
    }
  }
}
    ${LocaleOptionFragmentDoc}`;

/**
 * __useGetBrandOrCountryLocaleQuery__
 *
 * To run a query within a React component, call `useGetBrandOrCountryLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrCountryLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrCountryLocaleQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      countryId: // value for 'countryId'
 *      withBrandData: // value for 'withBrandData'
 *   },
 * });
 */
export function useGetBrandOrCountryLocaleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetBrandOrCountryLocaleQuery, Generated.GetBrandOrCountryLocaleQueryVariables> & ({ variables: Generated.GetBrandOrCountryLocaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetBrandOrCountryLocaleQuery, Generated.GetBrandOrCountryLocaleQueryVariables>(GetBrandOrCountryLocaleDocument, options);
      }
export function useGetBrandOrCountryLocaleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetBrandOrCountryLocaleQuery, Generated.GetBrandOrCountryLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetBrandOrCountryLocaleQuery, Generated.GetBrandOrCountryLocaleQueryVariables>(GetBrandOrCountryLocaleDocument, options);
        }
export function useGetBrandOrCountryLocaleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetBrandOrCountryLocaleQuery, Generated.GetBrandOrCountryLocaleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetBrandOrCountryLocaleQuery, Generated.GetBrandOrCountryLocaleQueryVariables>(GetBrandOrCountryLocaleDocument, options);
        }
export type GetBrandOrCountryLocaleQueryHookResult = ReturnType<typeof useGetBrandOrCountryLocaleQuery>;
export type GetBrandOrCountryLocaleLazyQueryHookResult = ReturnType<typeof useGetBrandOrCountryLocaleLazyQuery>;
export type GetBrandOrCountryLocaleSuspenseQueryHookResult = ReturnType<typeof useGetBrandOrCountryLocaleSuspenseQuery>;
export type GetBrandOrCountryLocaleQueryResult = Apollo.QueryResult<Generated.GetBrandOrCountryLocaleQuery, Generated.GetBrandOrCountryLocaleQueryVariables>;
export const GetPresetDocument = /*#__PURE__*/ gql`
    query getPreset($id: ID!) {
  preset(id: $id) {
    id
    ...PresetIdentity
    ...PresetPermissions
    ...PresetUsers
    ...PresetMetadata
  }
}
    ${PresetIdentityFragmentDoc}
${PresetPermissionsFragmentDoc}
${PresetUsersFragmentDoc}
${PresetMetadataFragmentDoc}`;

/**
 * __useGetPresetQuery__
 *
 * To run a query within a React component, call `useGetPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPresetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPresetQuery, Generated.GetPresetQueryVariables> & ({ variables: Generated.GetPresetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPresetQuery, Generated.GetPresetQueryVariables>(GetPresetDocument, options);
      }
export function useGetPresetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPresetQuery, Generated.GetPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPresetQuery, Generated.GetPresetQueryVariables>(GetPresetDocument, options);
        }
export function useGetPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPresetQuery, Generated.GetPresetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPresetQuery, Generated.GetPresetQueryVariables>(GetPresetDocument, options);
        }
export type GetPresetQueryHookResult = ReturnType<typeof useGetPresetQuery>;
export type GetPresetLazyQueryHookResult = ReturnType<typeof useGetPresetLazyQuery>;
export type GetPresetSuspenseQueryHookResult = ReturnType<typeof useGetPresetSuspenseQuery>;
export type GetPresetQueryResult = Apollo.QueryResult<Generated.GetPresetQuery, Generated.GetPresetQueryVariables>;
export const GetTeamListDocument = /*#__PURE__*/ gql`
    query getTeamList($limit: Int, $offset: Int!, $search: String, $brandIds: [ID!], $localeIds: [ID!], $countryIds: [ID!]) {
  teams(
    limit: $limit
    offset: $offset
    brandIds: $brandIds
    localeIds: $localeIds
    countryIds: $countryIds
    search: $search
  ) {
    totalCount
    nodes {
      ...TeamRow
    }
  }
}
    ${TeamRowFragmentDoc}`;

/**
 * __useGetTeamListQuery__
 *
 * To run a query within a React component, call `useGetTeamListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      brandIds: // value for 'brandIds'
 *      localeIds: // value for 'localeIds'
 *      countryIds: // value for 'countryIds'
 *   },
 * });
 */
export function useGetTeamListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTeamListQuery, Generated.GetTeamListQueryVariables> & ({ variables: Generated.GetTeamListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTeamListQuery, Generated.GetTeamListQueryVariables>(GetTeamListDocument, options);
      }
export function useGetTeamListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTeamListQuery, Generated.GetTeamListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTeamListQuery, Generated.GetTeamListQueryVariables>(GetTeamListDocument, options);
        }
export function useGetTeamListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTeamListQuery, Generated.GetTeamListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTeamListQuery, Generated.GetTeamListQueryVariables>(GetTeamListDocument, options);
        }
export type GetTeamListQueryHookResult = ReturnType<typeof useGetTeamListQuery>;
export type GetTeamListLazyQueryHookResult = ReturnType<typeof useGetTeamListLazyQuery>;
export type GetTeamListSuspenseQueryHookResult = ReturnType<typeof useGetTeamListSuspenseQuery>;
export type GetTeamListQueryResult = Apollo.QueryResult<Generated.GetTeamListQuery, Generated.GetTeamListQueryVariables>;
export const GetTeamDocument = /*#__PURE__*/ gql`
    query getTeam($ref: ID!) {
  teamByRef(ref: $ref) {
    ...TeamIdentity
    ...TeamMetadata
  }
}
    ${TeamIdentityFragmentDoc}
${TeamMetadataFragmentDoc}`;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetTeamQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTeamQuery, Generated.GetTeamQueryVariables> & ({ variables: Generated.GetTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTeamQuery, Generated.GetTeamQueryVariables>(GetTeamDocument, options);
      }
export function useGetTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTeamQuery, Generated.GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTeamQuery, Generated.GetTeamQueryVariables>(GetTeamDocument, options);
        }
export function useGetTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTeamQuery, Generated.GetTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTeamQuery, Generated.GetTeamQueryVariables>(GetTeamDocument, options);
        }
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamSuspenseQueryHookResult = ReturnType<typeof useGetTeamSuspenseQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<Generated.GetTeamQuery, Generated.GetTeamQueryVariables>;
export const GetUserListDocument = /*#__PURE__*/ gql`
    query getUserList($limit: Int, $offset: Int!, $teamIds: [ID!]!, $search: String) {
  users(limit: $limit, offset: $offset, teamIds: $teamIds, search: $search) {
    totalCount
    nodes {
      id
      ref
      name
      email
      active
      application
      admin
      metadata {
        createdAt
      }
      allowedBrands {
        ref
      }
    }
  }
}
    `;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      teamIds: // value for 'teamIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetUserListQuery, Generated.GetUserListQueryVariables> & ({ variables: Generated.GetUserListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetUserListQuery, Generated.GetUserListQueryVariables>(GetUserListDocument, options);
      }
export function useGetUserListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetUserListQuery, Generated.GetUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetUserListQuery, Generated.GetUserListQueryVariables>(GetUserListDocument, options);
        }
export function useGetUserListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetUserListQuery, Generated.GetUserListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetUserListQuery, Generated.GetUserListQueryVariables>(GetUserListDocument, options);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListSuspenseQueryHookResult = ReturnType<typeof useGetUserListSuspenseQuery>;
export type GetUserListQueryResult = Apollo.QueryResult<Generated.GetUserListQuery, Generated.GetUserListQueryVariables>;
export const GetUserDocument = /*#__PURE__*/ gql`
    query getUser($ref: ID!) {
  entityByRef(type: USER, ref: $ref) {
    ... on User {
      ...UserIdentity
      ...UserPermissions
      ...UserPreferences
      ...UserRoles
      ...UserMetadata
    }
  }
}
    ${UserIdentityFragmentDoc}
${UserPermissionsFragmentDoc}
${UserPreferencesFragmentDoc}
${UserRolesFragmentDoc}
${UserMetadataFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetUserQuery, Generated.GetUserQueryVariables> & ({ variables: Generated.GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetUserQuery, Generated.GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetUserQuery, Generated.GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetUserQuery, Generated.GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetUserQuery, Generated.GetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetUserQuery, Generated.GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<Generated.GetUserQuery, Generated.GetUserQueryVariables>;
export const GetUserPreferencesDocument = /*#__PURE__*/ gql`
    query getUserPreferences($id: ID!) {
  user(id: $id) {
    id
    ...UserPreferences
  }
}
    ${UserPreferencesFragmentDoc}`;

/**
 * __useGetUserPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserPreferencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetUserPreferencesQuery, Generated.GetUserPreferencesQueryVariables> & ({ variables: Generated.GetUserPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetUserPreferencesQuery, Generated.GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
      }
export function useGetUserPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetUserPreferencesQuery, Generated.GetUserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetUserPreferencesQuery, Generated.GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
export function useGetUserPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetUserPreferencesQuery, Generated.GetUserPreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetUserPreferencesQuery, Generated.GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
export type GetUserPreferencesQueryHookResult = ReturnType<typeof useGetUserPreferencesQuery>;
export type GetUserPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserPreferencesLazyQuery>;
export type GetUserPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetUserPreferencesSuspenseQuery>;
export type GetUserPreferencesQueryResult = Apollo.QueryResult<Generated.GetUserPreferencesQuery, Generated.GetUserPreferencesQueryVariables>;
export const UpdatePresetPermissionsDocument = /*#__PURE__*/ gql`
    mutation updatePresetPermissions($input: UpdatePresetInput!) {
  updatePreset(input: $input) {
    id
    ...PresetPermissions
    ...PresetMetadata
  }
}
    ${PresetPermissionsFragmentDoc}
${PresetMetadataFragmentDoc}`;
export type UpdatePresetPermissionsMutationFn = Apollo.MutationFunction<Generated.UpdatePresetPermissionsMutation, Generated.UpdatePresetPermissionsMutationVariables>;

/**
 * __useUpdatePresetPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdatePresetPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresetPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresetPermissionsMutation, { data, loading, error }] = useUpdatePresetPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePresetPermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdatePresetPermissionsMutation, Generated.UpdatePresetPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdatePresetPermissionsMutation, Generated.UpdatePresetPermissionsMutationVariables>(UpdatePresetPermissionsDocument, options);
      }
export type UpdatePresetPermissionsMutationHookResult = ReturnType<typeof useUpdatePresetPermissionsMutation>;
export type UpdatePresetPermissionsMutationResult = Apollo.MutationResult<Generated.UpdatePresetPermissionsMutation>;
export type UpdatePresetPermissionsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdatePresetPermissionsMutation, Generated.UpdatePresetPermissionsMutationVariables>;
export const UpdatePresetDocument = /*#__PURE__*/ gql`
    mutation updatePreset($input: UpdatePresetInput!) {
  updatePreset(input: $input) {
    id
    ...PresetIdentity
    ...PresetMetadata
  }
}
    ${PresetIdentityFragmentDoc}
${PresetMetadataFragmentDoc}`;
export type UpdatePresetMutationFn = Apollo.MutationFunction<Generated.UpdatePresetMutation, Generated.UpdatePresetMutationVariables>;

/**
 * __useUpdatePresetMutation__
 *
 * To run a mutation, you first call `useUpdatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresetMutation, { data, loading, error }] = useUpdatePresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdatePresetMutation, Generated.UpdatePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdatePresetMutation, Generated.UpdatePresetMutationVariables>(UpdatePresetDocument, options);
      }
export type UpdatePresetMutationHookResult = ReturnType<typeof useUpdatePresetMutation>;
export type UpdatePresetMutationResult = Apollo.MutationResult<Generated.UpdatePresetMutation>;
export type UpdatePresetMutationOptions = Apollo.BaseMutationOptions<Generated.UpdatePresetMutation, Generated.UpdatePresetMutationVariables>;
export const UpdateTeamDocument = /*#__PURE__*/ gql`
    mutation updateTeam($id: ID!, $name: String!, $countryIds: [ID!], $brandIds: [ID!], $localeIds: [ID!]) {
  updateTeam(
    input: {id: $id, name: $name, countryIds: $countryIds, brandIds: $brandIds, localeIds: $localeIds}
  ) {
    ...TeamIdentity
    ...TeamMetadata
  }
}
    ${TeamIdentityFragmentDoc}
${TeamMetadataFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<Generated.UpdateTeamMutation, Generated.UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      countryIds: // value for 'countryIds'
 *      brandIds: // value for 'brandIds'
 *      localeIds: // value for 'localeIds'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTeamMutation, Generated.UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTeamMutation, Generated.UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<Generated.UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTeamMutation, Generated.UpdateTeamMutationVariables>;
export const UpdateUserPermissionsDocument = /*#__PURE__*/ gql`
    mutation updateUserPermissions($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    ...UserPermissions
    ...UserMetadata
  }
}
    ${UserPermissionsFragmentDoc}
${UserMetadataFragmentDoc}`;
export type UpdateUserPermissionsMutationFn = Apollo.MutationFunction<Generated.UpdateUserPermissionsMutation, Generated.UpdateUserPermissionsMutationVariables>;

/**
 * __useUpdateUserPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateUserPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPermissionsMutation, { data, loading, error }] = useUpdateUserPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateUserPermissionsMutation, Generated.UpdateUserPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateUserPermissionsMutation, Generated.UpdateUserPermissionsMutationVariables>(UpdateUserPermissionsDocument, options);
      }
export type UpdateUserPermissionsMutationHookResult = ReturnType<typeof useUpdateUserPermissionsMutation>;
export type UpdateUserPermissionsMutationResult = Apollo.MutationResult<Generated.UpdateUserPermissionsMutation>;
export type UpdateUserPermissionsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateUserPermissionsMutation, Generated.UpdateUserPermissionsMutationVariables>;
export const UpdateUserPreferencesDocument = /*#__PURE__*/ gql`
    mutation updateUserPreferences($input: UpdateUserPreferencesInput!) {
  updateUserPreferences(input: $input) {
    id
    ...UserPreferences
    ...UserMetadata
  }
}
    ${UserPreferencesFragmentDoc}
${UserMetadataFragmentDoc}`;
export type UpdateUserPreferencesMutationFn = Apollo.MutationFunction<Generated.UpdateUserPreferencesMutation, Generated.UpdateUserPreferencesMutationVariables>;

/**
 * __useUpdateUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferencesMutation, { data, loading, error }] = useUpdateUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateUserPreferencesMutation, Generated.UpdateUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateUserPreferencesMutation, Generated.UpdateUserPreferencesMutationVariables>(UpdateUserPreferencesDocument, options);
      }
export type UpdateUserPreferencesMutationHookResult = ReturnType<typeof useUpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationResult = Apollo.MutationResult<Generated.UpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateUserPreferencesMutation, Generated.UpdateUserPreferencesMutationVariables>;
export const UpdateUserDocument = /*#__PURE__*/ gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    ...UserIdentity
    ...UserMetadata
  }
}
    ${UserIdentityFragmentDoc}
${UserMetadataFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<Generated.UpdateUserMutation, Generated.UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateUserMutation, Generated.UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateUserMutation, Generated.UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Generated.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateUserMutation, Generated.UpdateUserMutationVariables>;
export const UpdateUserRolesDocument = /*#__PURE__*/ gql`
    mutation updateUserRoles($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    ...UserRoles
    ...UserMetadata
  }
}
    ${UserRolesFragmentDoc}
${UserMetadataFragmentDoc}`;
export type UpdateUserRolesMutationFn = Apollo.MutationFunction<Generated.UpdateUserRolesMutation, Generated.UpdateUserRolesMutationVariables>;

/**
 * __useUpdateUserRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesMutation, { data, loading, error }] = useUpdateUserRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateUserRolesMutation, Generated.UpdateUserRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateUserRolesMutation, Generated.UpdateUserRolesMutationVariables>(UpdateUserRolesDocument, options);
      }
export type UpdateUserRolesMutationHookResult = ReturnType<typeof useUpdateUserRolesMutation>;
export type UpdateUserRolesMutationResult = Apollo.MutationResult<Generated.UpdateUserRolesMutation>;
export type UpdateUserRolesMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateUserRolesMutation, Generated.UpdateUserRolesMutationVariables>;
export const BatchCreateSeriesSeasonsDocument = /*#__PURE__*/ gql`
    mutation batchCreateSeriesSeasons($input: BatchCreateSeriesSeasonsInput!) {
  batchCreateSeriesSeasons(input: $input) {
    id
  }
}
    `;
export type BatchCreateSeriesSeasonsMutationFn = Apollo.MutationFunction<Generated.BatchCreateSeriesSeasonsMutation, Generated.BatchCreateSeriesSeasonsMutationVariables>;

/**
 * __useBatchCreateSeriesSeasonsMutation__
 *
 * To run a mutation, you first call `useBatchCreateSeriesSeasonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateSeriesSeasonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateSeriesSeasonsMutation, { data, loading, error }] = useBatchCreateSeriesSeasonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateSeriesSeasonsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.BatchCreateSeriesSeasonsMutation, Generated.BatchCreateSeriesSeasonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.BatchCreateSeriesSeasonsMutation, Generated.BatchCreateSeriesSeasonsMutationVariables>(BatchCreateSeriesSeasonsDocument, options);
      }
export type BatchCreateSeriesSeasonsMutationHookResult = ReturnType<typeof useBatchCreateSeriesSeasonsMutation>;
export type BatchCreateSeriesSeasonsMutationResult = Apollo.MutationResult<Generated.BatchCreateSeriesSeasonsMutation>;
export type BatchCreateSeriesSeasonsMutationOptions = Apollo.BaseMutationOptions<Generated.BatchCreateSeriesSeasonsMutation, Generated.BatchCreateSeriesSeasonsMutationVariables>;
export const ApplyCreditToEntityDocument = /*#__PURE__*/ gql`
    mutation applyCreditToEntity($input: ApplyCreditToEntityInput!) {
  applyCreditToEntity(input: $input) {
    id
  }
}
    `;
export type ApplyCreditToEntityMutationFn = Apollo.MutationFunction<Generated.ApplyCreditToEntityMutation, Generated.ApplyCreditToEntityMutationVariables>;

/**
 * __useApplyCreditToEntityMutation__
 *
 * To run a mutation, you first call `useApplyCreditToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCreditToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCreditToEntityMutation, { data, loading, error }] = useApplyCreditToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyCreditToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.ApplyCreditToEntityMutation, Generated.ApplyCreditToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.ApplyCreditToEntityMutation, Generated.ApplyCreditToEntityMutationVariables>(ApplyCreditToEntityDocument, options);
      }
export type ApplyCreditToEntityMutationHookResult = ReturnType<typeof useApplyCreditToEntityMutation>;
export type ApplyCreditToEntityMutationResult = Apollo.MutationResult<Generated.ApplyCreditToEntityMutation>;
export type ApplyCreditToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.ApplyCreditToEntityMutation, Generated.ApplyCreditToEntityMutationVariables>;
export const ApplyCastingToEntityDocument = /*#__PURE__*/ gql`
    mutation applyCastingToEntity($input: ApplyCastingToEntityInput!) {
  applyCastingToEntity(input: $input) {
    id
  }
}
    `;
export type ApplyCastingToEntityMutationFn = Apollo.MutationFunction<Generated.ApplyCastingToEntityMutation, Generated.ApplyCastingToEntityMutationVariables>;

/**
 * __useApplyCastingToEntityMutation__
 *
 * To run a mutation, you first call `useApplyCastingToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCastingToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCastingToEntityMutation, { data, loading, error }] = useApplyCastingToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyCastingToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.ApplyCastingToEntityMutation, Generated.ApplyCastingToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.ApplyCastingToEntityMutation, Generated.ApplyCastingToEntityMutationVariables>(ApplyCastingToEntityDocument, options);
      }
export type ApplyCastingToEntityMutationHookResult = ReturnType<typeof useApplyCastingToEntityMutation>;
export type ApplyCastingToEntityMutationResult = Apollo.MutationResult<Generated.ApplyCastingToEntityMutation>;
export type ApplyCastingToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.ApplyCastingToEntityMutation, Generated.ApplyCastingToEntityMutationVariables>;
export const BatchCreateSeriesEpisodesDocument = /*#__PURE__*/ gql`
    mutation batchCreateSeriesEpisodes($input: BatchCreateSeriesEpisodesInput!) {
  batchCreateSeriesEpisodes(input: $input) {
    id
  }
}
    `;
export type BatchCreateSeriesEpisodesMutationFn = Apollo.MutationFunction<Generated.BatchCreateSeriesEpisodesMutation, Generated.BatchCreateSeriesEpisodesMutationVariables>;

/**
 * __useBatchCreateSeriesEpisodesMutation__
 *
 * To run a mutation, you first call `useBatchCreateSeriesEpisodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateSeriesEpisodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateSeriesEpisodesMutation, { data, loading, error }] = useBatchCreateSeriesEpisodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateSeriesEpisodesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.BatchCreateSeriesEpisodesMutation, Generated.BatchCreateSeriesEpisodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.BatchCreateSeriesEpisodesMutation, Generated.BatchCreateSeriesEpisodesMutationVariables>(BatchCreateSeriesEpisodesDocument, options);
      }
export type BatchCreateSeriesEpisodesMutationHookResult = ReturnType<typeof useBatchCreateSeriesEpisodesMutation>;
export type BatchCreateSeriesEpisodesMutationResult = Apollo.MutationResult<Generated.BatchCreateSeriesEpisodesMutation>;
export type BatchCreateSeriesEpisodesMutationOptions = Apollo.BaseMutationOptions<Generated.BatchCreateSeriesEpisodesMutation, Generated.BatchCreateSeriesEpisodesMutationVariables>;
export const TeamOptionsDocument = /*#__PURE__*/ gql`
    query TeamOptions {
  teams(limit: 300) {
    nodes {
      ...TeamOption
    }
  }
}
    ${TeamOptionFragmentDoc}`;

/**
 * __useTeamOptionsQuery__
 *
 * To run a query within a React component, call `useTeamOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.TeamOptionsQuery, Generated.TeamOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.TeamOptionsQuery, Generated.TeamOptionsQueryVariables>(TeamOptionsDocument, options);
      }
export function useTeamOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.TeamOptionsQuery, Generated.TeamOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.TeamOptionsQuery, Generated.TeamOptionsQueryVariables>(TeamOptionsDocument, options);
        }
export function useTeamOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.TeamOptionsQuery, Generated.TeamOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.TeamOptionsQuery, Generated.TeamOptionsQueryVariables>(TeamOptionsDocument, options);
        }
export type TeamOptionsQueryHookResult = ReturnType<typeof useTeamOptionsQuery>;
export type TeamOptionsLazyQueryHookResult = ReturnType<typeof useTeamOptionsLazyQuery>;
export type TeamOptionsSuspenseQueryHookResult = ReturnType<typeof useTeamOptionsSuspenseQuery>;
export type TeamOptionsQueryResult = Apollo.QueryResult<Generated.TeamOptionsQuery, Generated.TeamOptionsQueryVariables>;
export const PresetOptionsDocument = /*#__PURE__*/ gql`
    query PresetOptions {
  presets(limit: 300) {
    nodes {
      ...PresetOption
    }
  }
}
    ${PresetOptionFragmentDoc}`;

/**
 * __usePresetOptionsQuery__
 *
 * To run a query within a React component, call `usePresetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresetOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePresetOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.PresetOptionsQuery, Generated.PresetOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.PresetOptionsQuery, Generated.PresetOptionsQueryVariables>(PresetOptionsDocument, options);
      }
export function usePresetOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.PresetOptionsQuery, Generated.PresetOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.PresetOptionsQuery, Generated.PresetOptionsQueryVariables>(PresetOptionsDocument, options);
        }
export function usePresetOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.PresetOptionsQuery, Generated.PresetOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.PresetOptionsQuery, Generated.PresetOptionsQueryVariables>(PresetOptionsDocument, options);
        }
export type PresetOptionsQueryHookResult = ReturnType<typeof usePresetOptionsQuery>;
export type PresetOptionsLazyQueryHookResult = ReturnType<typeof usePresetOptionsLazyQuery>;
export type PresetOptionsSuspenseQueryHookResult = ReturnType<typeof usePresetOptionsSuspenseQuery>;
export type PresetOptionsQueryResult = Apollo.QueryResult<Generated.PresetOptionsQuery, Generated.PresetOptionsQueryVariables>;
export const CreateSeasonReleaseDocument = /*#__PURE__*/ gql`
    mutation createSeasonRelease($input: AddReleaseToEntityInput!) {
  addReleaseToEntity(input: $input) {
    id
  }
}
    `;
export type CreateSeasonReleaseMutationFn = Apollo.MutationFunction<Generated.CreateSeasonReleaseMutation, Generated.CreateSeasonReleaseMutationVariables>;

/**
 * __useCreateSeasonReleaseMutation__
 *
 * To run a mutation, you first call `useCreateSeasonReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeasonReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeasonReleaseMutation, { data, loading, error }] = useCreateSeasonReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeasonReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSeasonReleaseMutation, Generated.CreateSeasonReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSeasonReleaseMutation, Generated.CreateSeasonReleaseMutationVariables>(CreateSeasonReleaseDocument, options);
      }
export type CreateSeasonReleaseMutationHookResult = ReturnType<typeof useCreateSeasonReleaseMutation>;
export type CreateSeasonReleaseMutationResult = Apollo.MutationResult<Generated.CreateSeasonReleaseMutation>;
export type CreateSeasonReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSeasonReleaseMutation, Generated.CreateSeasonReleaseMutationVariables>;
export const CreateEpisodeReleaseDocument = /*#__PURE__*/ gql`
    mutation createEpisodeRelease($input: AddReleaseToEntityInput!) {
  addReleaseToEntity(input: $input) {
    id
  }
}
    `;
export type CreateEpisodeReleaseMutationFn = Apollo.MutationFunction<Generated.CreateEpisodeReleaseMutation, Generated.CreateEpisodeReleaseMutationVariables>;

/**
 * __useCreateEpisodeReleaseMutation__
 *
 * To run a mutation, you first call `useCreateEpisodeReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpisodeReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpisodeReleaseMutation, { data, loading, error }] = useCreateEpisodeReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEpisodeReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateEpisodeReleaseMutation, Generated.CreateEpisodeReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateEpisodeReleaseMutation, Generated.CreateEpisodeReleaseMutationVariables>(CreateEpisodeReleaseDocument, options);
      }
export type CreateEpisodeReleaseMutationHookResult = ReturnType<typeof useCreateEpisodeReleaseMutation>;
export type CreateEpisodeReleaseMutationResult = Apollo.MutationResult<Generated.CreateEpisodeReleaseMutation>;
export type CreateEpisodeReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.CreateEpisodeReleaseMutation, Generated.CreateEpisodeReleaseMutationVariables>;
export const CreateSeriesEpisodeDocument = /*#__PURE__*/ gql`
    mutation createSeriesEpisode($input: CreateSeriesEpisodeInput!) {
  createSeriesEpisode(input: $input) {
    id
    ref
    series {
      id
      ref
    }
    season {
      id
      ref
    }
  }
}
    `;
export type CreateSeriesEpisodeMutationFn = Apollo.MutationFunction<Generated.CreateSeriesEpisodeMutation, Generated.CreateSeriesEpisodeMutationVariables>;

/**
 * __useCreateSeriesEpisodeMutation__
 *
 * To run a mutation, you first call `useCreateSeriesEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeriesEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeriesEpisodeMutation, { data, loading, error }] = useCreateSeriesEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeriesEpisodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSeriesEpisodeMutation, Generated.CreateSeriesEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSeriesEpisodeMutation, Generated.CreateSeriesEpisodeMutationVariables>(CreateSeriesEpisodeDocument, options);
      }
export type CreateSeriesEpisodeMutationHookResult = ReturnType<typeof useCreateSeriesEpisodeMutation>;
export type CreateSeriesEpisodeMutationResult = Apollo.MutationResult<Generated.CreateSeriesEpisodeMutation>;
export type CreateSeriesEpisodeMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSeriesEpisodeMutation, Generated.CreateSeriesEpisodeMutationVariables>;
export const CreateSeriesReleaseDocument = /*#__PURE__*/ gql`
    mutation createSeriesRelease($input: AddReleaseToEntityInput!) {
  addReleaseToEntity(input: $input) {
    id
    entity {
      ... on Series {
        id
      }
    }
  }
}
    `;
export type CreateSeriesReleaseMutationFn = Apollo.MutationFunction<Generated.CreateSeriesReleaseMutation, Generated.CreateSeriesReleaseMutationVariables>;

/**
 * __useCreateSeriesReleaseMutation__
 *
 * To run a mutation, you first call `useCreateSeriesReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeriesReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeriesReleaseMutation, { data, loading, error }] = useCreateSeriesReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeriesReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSeriesReleaseMutation, Generated.CreateSeriesReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSeriesReleaseMutation, Generated.CreateSeriesReleaseMutationVariables>(CreateSeriesReleaseDocument, options);
      }
export type CreateSeriesReleaseMutationHookResult = ReturnType<typeof useCreateSeriesReleaseMutation>;
export type CreateSeriesReleaseMutationResult = Apollo.MutationResult<Generated.CreateSeriesReleaseMutation>;
export type CreateSeriesReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSeriesReleaseMutation, Generated.CreateSeriesReleaseMutationVariables>;
export const CreateSeriesSeasonDocument = /*#__PURE__*/ gql`
    mutation createSeriesSeason($input: CreateSeriesSeasonInput!) {
  createSeriesSeason(input: $input) {
    id
    ref
    series {
      id
      ref
    }
  }
}
    `;
export type CreateSeriesSeasonMutationFn = Apollo.MutationFunction<Generated.CreateSeriesSeasonMutation, Generated.CreateSeriesSeasonMutationVariables>;

/**
 * __useCreateSeriesSeasonMutation__
 *
 * To run a mutation, you first call `useCreateSeriesSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeriesSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeriesSeasonMutation, { data, loading, error }] = useCreateSeriesSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeriesSeasonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSeriesSeasonMutation, Generated.CreateSeriesSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSeriesSeasonMutation, Generated.CreateSeriesSeasonMutationVariables>(CreateSeriesSeasonDocument, options);
      }
export type CreateSeriesSeasonMutationHookResult = ReturnType<typeof useCreateSeriesSeasonMutation>;
export type CreateSeriesSeasonMutationResult = Apollo.MutationResult<Generated.CreateSeriesSeasonMutation>;
export type CreateSeriesSeasonMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSeriesSeasonMutation, Generated.CreateSeriesSeasonMutationVariables>;
export const CreateSeriesDocument = /*#__PURE__*/ gql`
    mutation createSeries($input: CreateSeriesInput!) {
  createSeries(input: $input) {
    id
    ref
  }
}
    `;
export type CreateSeriesMutationFn = Apollo.MutationFunction<Generated.CreateSeriesMutation, Generated.CreateSeriesMutationVariables>;

/**
 * __useCreateSeriesMutation__
 *
 * To run a mutation, you first call `useCreateSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeriesMutation, { data, loading, error }] = useCreateSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSeriesMutation, Generated.CreateSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSeriesMutation, Generated.CreateSeriesMutationVariables>(CreateSeriesDocument, options);
      }
export type CreateSeriesMutationHookResult = ReturnType<typeof useCreateSeriesMutation>;
export type CreateSeriesMutationResult = Apollo.MutationResult<Generated.CreateSeriesMutation>;
export type CreateSeriesMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSeriesMutation, Generated.CreateSeriesMutationVariables>;
export const DeleteEpisodeDocument = /*#__PURE__*/ gql`
    mutation deleteEpisode($input: DeleteEntityInput!) {
  deleteEntity(input: $input) {
    ... on SeriesEpisode {
      id
      ref
    }
  }
}
    `;
export type DeleteEpisodeMutationFn = Apollo.MutationFunction<Generated.DeleteEpisodeMutation, Generated.DeleteEpisodeMutationVariables>;

/**
 * __useDeleteEpisodeMutation__
 *
 * To run a mutation, you first call `useDeleteEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpisodeMutation, { data, loading, error }] = useDeleteEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEpisodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEpisodeMutation, Generated.DeleteEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEpisodeMutation, Generated.DeleteEpisodeMutationVariables>(DeleteEpisodeDocument, options);
      }
export type DeleteEpisodeMutationHookResult = ReturnType<typeof useDeleteEpisodeMutation>;
export type DeleteEpisodeMutationResult = Apollo.MutationResult<Generated.DeleteEpisodeMutation>;
export type DeleteEpisodeMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEpisodeMutation, Generated.DeleteEpisodeMutationVariables>;
export const GetEpisodeBrandedDataDocument = /*#__PURE__*/ gql`
    query getEpisodeBrandedData($id: ID!, $brandId: ID!) {
  seriesEpisode(id: $id) {
    id
    brandData(brandId: $brandId) {
      synopsis
      title
      ruling {
        hasRating
        atRisk
        hasWarningMessage
        hasMandatoryReview
      }
    }
  }
}
    `;

/**
 * __useGetEpisodeBrandedDataQuery__
 *
 * To run a query within a React component, call `useGetEpisodeBrandedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeBrandedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeBrandedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetEpisodeBrandedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeBrandedDataQuery, Generated.GetEpisodeBrandedDataQueryVariables> & ({ variables: Generated.GetEpisodeBrandedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeBrandedDataQuery, Generated.GetEpisodeBrandedDataQueryVariables>(GetEpisodeBrandedDataDocument, options);
      }
export function useGetEpisodeBrandedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeBrandedDataQuery, Generated.GetEpisodeBrandedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeBrandedDataQuery, Generated.GetEpisodeBrandedDataQueryVariables>(GetEpisodeBrandedDataDocument, options);
        }
export function useGetEpisodeBrandedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeBrandedDataQuery, Generated.GetEpisodeBrandedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeBrandedDataQuery, Generated.GetEpisodeBrandedDataQueryVariables>(GetEpisodeBrandedDataDocument, options);
        }
export type GetEpisodeBrandedDataQueryHookResult = ReturnType<typeof useGetEpisodeBrandedDataQuery>;
export type GetEpisodeBrandedDataLazyQueryHookResult = ReturnType<typeof useGetEpisodeBrandedDataLazyQuery>;
export type GetEpisodeBrandedDataSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeBrandedDataSuspenseQuery>;
export type GetEpisodeBrandedDataQueryResult = Apollo.QueryResult<Generated.GetEpisodeBrandedDataQuery, Generated.GetEpisodeBrandedDataQueryVariables>;
export const DeleteSeriesSeasonDocument = /*#__PURE__*/ gql`
    mutation deleteSeriesSeason($input: DeleteEntityInput!) {
  deleteEntity(input: $input) {
    ... on SeriesSeason {
      id
      ref
    }
  }
}
    `;
export type DeleteSeriesSeasonMutationFn = Apollo.MutationFunction<Generated.DeleteSeriesSeasonMutation, Generated.DeleteSeriesSeasonMutationVariables>;

/**
 * __useDeleteSeriesSeasonMutation__
 *
 * To run a mutation, you first call `useDeleteSeriesSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeriesSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSeriesSeasonMutation, { data, loading, error }] = useDeleteSeriesSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSeriesSeasonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteSeriesSeasonMutation, Generated.DeleteSeriesSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteSeriesSeasonMutation, Generated.DeleteSeriesSeasonMutationVariables>(DeleteSeriesSeasonDocument, options);
      }
export type DeleteSeriesSeasonMutationHookResult = ReturnType<typeof useDeleteSeriesSeasonMutation>;
export type DeleteSeriesSeasonMutationResult = Apollo.MutationResult<Generated.DeleteSeriesSeasonMutation>;
export type DeleteSeriesSeasonMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteSeriesSeasonMutation, Generated.DeleteSeriesSeasonMutationVariables>;
export const DeleteSeriesDocument = /*#__PURE__*/ gql`
    mutation deleteSeries($input: DeleteEntityInput!) {
  deleteEntity(input: $input) {
    ... on Series {
      id
      ref
    }
  }
}
    `;
export type DeleteSeriesMutationFn = Apollo.MutationFunction<Generated.DeleteSeriesMutation, Generated.DeleteSeriesMutationVariables>;

/**
 * __useDeleteSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSeriesMutation, { data, loading, error }] = useDeleteSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteSeriesMutation, Generated.DeleteSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteSeriesMutation, Generated.DeleteSeriesMutationVariables>(DeleteSeriesDocument, options);
      }
export type DeleteSeriesMutationHookResult = ReturnType<typeof useDeleteSeriesMutation>;
export type DeleteSeriesMutationResult = Apollo.MutationResult<Generated.DeleteSeriesMutation>;
export type DeleteSeriesMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteSeriesMutation, Generated.DeleteSeriesMutationVariables>;
export const GetEpisodeCompanyDocument = /*#__PURE__*/ gql`
    query getEpisodeCompany($id: ID!, $limit: Int!, $offset: Int!, $activities: [CompanyActivity!]) {
  seriesEpisode(id: $id) {
    id
    companies(limit: $limit, offset: $offset, activities: $activities) {
      totalCount
      nodes {
        ...EntitiesCompany
      }
    }
  }
}
    ${EntitiesCompanyFragmentDoc}`;

/**
 * __useGetEpisodeCompanyQuery__
 *
 * To run a query within a React component, call `useGetEpisodeCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *   },
 * });
 */
export function useGetEpisodeCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeCompanyQuery, Generated.GetEpisodeCompanyQueryVariables> & ({ variables: Generated.GetEpisodeCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeCompanyQuery, Generated.GetEpisodeCompanyQueryVariables>(GetEpisodeCompanyDocument, options);
      }
export function useGetEpisodeCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeCompanyQuery, Generated.GetEpisodeCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeCompanyQuery, Generated.GetEpisodeCompanyQueryVariables>(GetEpisodeCompanyDocument, options);
        }
export function useGetEpisodeCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeCompanyQuery, Generated.GetEpisodeCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeCompanyQuery, Generated.GetEpisodeCompanyQueryVariables>(GetEpisodeCompanyDocument, options);
        }
export type GetEpisodeCompanyQueryHookResult = ReturnType<typeof useGetEpisodeCompanyQuery>;
export type GetEpisodeCompanyLazyQueryHookResult = ReturnType<typeof useGetEpisodeCompanyLazyQuery>;
export type GetEpisodeCompanySuspenseQueryHookResult = ReturnType<typeof useGetEpisodeCompanySuspenseQuery>;
export type GetEpisodeCompanyQueryResult = Apollo.QueryResult<Generated.GetEpisodeCompanyQuery, Generated.GetEpisodeCompanyQueryVariables>;
export const GetEpisodeCastingDocument = /*#__PURE__*/ gql`
    query getEpisodeCasting($id: ID!, $limit: Int, $offset: Int!, $locale: ID, $showLocaleData: Boolean!, $brandId: ID!, $includeBrandData: Boolean = false, $withSeoAttributes: Boolean! = false) {
  seriesEpisode(id: $id) {
    id
    parent: season {
      id
    }
    credits(limit: $limit, offset: $offset, activities: [ACTOR_ACTOR]) {
      totalCount
      nodes {
        ...Credit
      }
    }
  }
}
    ${CreditFragmentDoc}`;

/**
 * __useGetEpisodeCastingQuery__
 *
 * To run a query within a React component, call `useGetEpisodeCastingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeCastingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeCastingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      locale: // value for 'locale'
 *      showLocaleData: // value for 'showLocaleData'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useGetEpisodeCastingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeCastingQuery, Generated.GetEpisodeCastingQueryVariables> & ({ variables: Generated.GetEpisodeCastingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeCastingQuery, Generated.GetEpisodeCastingQueryVariables>(GetEpisodeCastingDocument, options);
      }
export function useGetEpisodeCastingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeCastingQuery, Generated.GetEpisodeCastingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeCastingQuery, Generated.GetEpisodeCastingQueryVariables>(GetEpisodeCastingDocument, options);
        }
export function useGetEpisodeCastingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeCastingQuery, Generated.GetEpisodeCastingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeCastingQuery, Generated.GetEpisodeCastingQueryVariables>(GetEpisodeCastingDocument, options);
        }
export type GetEpisodeCastingQueryHookResult = ReturnType<typeof useGetEpisodeCastingQuery>;
export type GetEpisodeCastingLazyQueryHookResult = ReturnType<typeof useGetEpisodeCastingLazyQuery>;
export type GetEpisodeCastingSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeCastingSuspenseQuery>;
export type GetEpisodeCastingQueryResult = Apollo.QueryResult<Generated.GetEpisodeCastingQuery, Generated.GetEpisodeCastingQueryVariables>;
export const GetEpisodeCreditDocument = /*#__PURE__*/ gql`
    query getEpisodeCredit($id: ID!, $limit: Int!, $offset: Int!, $activities: [PersonActivity!], $brandId: ID!, $includeBrandData: Boolean = false) {
  seriesEpisode(id: $id) {
    id
    parent: season {
      id
    }
    credits(
      limit: $limit
      offset: $offset
      activities: $activities
      excludeActivities: [ACTOR_ACTOR]
    ) {
      totalCount
      nodes {
        ...CreditLimited
      }
    }
  }
}
    ${CreditLimitedFragmentDoc}`;

/**
 * __useGetEpisodeCreditQuery__
 *
 * To run a query within a React component, call `useGetEpisodeCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeCreditQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetEpisodeCreditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeCreditQuery, Generated.GetEpisodeCreditQueryVariables> & ({ variables: Generated.GetEpisodeCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeCreditQuery, Generated.GetEpisodeCreditQueryVariables>(GetEpisodeCreditDocument, options);
      }
export function useGetEpisodeCreditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeCreditQuery, Generated.GetEpisodeCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeCreditQuery, Generated.GetEpisodeCreditQueryVariables>(GetEpisodeCreditDocument, options);
        }
export function useGetEpisodeCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeCreditQuery, Generated.GetEpisodeCreditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeCreditQuery, Generated.GetEpisodeCreditQueryVariables>(GetEpisodeCreditDocument, options);
        }
export type GetEpisodeCreditQueryHookResult = ReturnType<typeof useGetEpisodeCreditQuery>;
export type GetEpisodeCreditLazyQueryHookResult = ReturnType<typeof useGetEpisodeCreditLazyQuery>;
export type GetEpisodeCreditSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeCreditSuspenseQuery>;
export type GetEpisodeCreditQueryResult = Apollo.QueryResult<Generated.GetEpisodeCreditQuery, Generated.GetEpisodeCreditQueryVariables>;
export const GetEpisodeExternalIdsDocument = /*#__PURE__*/ gql`
    query getEpisodeExternalIds($id: ID!) {
  seriesEpisode(id: $id) {
    ... on SeriesEpisode {
      id
      ...EntityAlts
    }
  }
}
    ${EntityAltsFragmentDoc}`;

/**
 * __useGetEpisodeExternalIdsQuery__
 *
 * To run a query within a React component, call `useGetEpisodeExternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeExternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeExternalIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEpisodeExternalIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeExternalIdsQuery, Generated.GetEpisodeExternalIdsQueryVariables> & ({ variables: Generated.GetEpisodeExternalIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeExternalIdsQuery, Generated.GetEpisodeExternalIdsQueryVariables>(GetEpisodeExternalIdsDocument, options);
      }
export function useGetEpisodeExternalIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeExternalIdsQuery, Generated.GetEpisodeExternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeExternalIdsQuery, Generated.GetEpisodeExternalIdsQueryVariables>(GetEpisodeExternalIdsDocument, options);
        }
export function useGetEpisodeExternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeExternalIdsQuery, Generated.GetEpisodeExternalIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeExternalIdsQuery, Generated.GetEpisodeExternalIdsQueryVariables>(GetEpisodeExternalIdsDocument, options);
        }
export type GetEpisodeExternalIdsQueryHookResult = ReturnType<typeof useGetEpisodeExternalIdsQuery>;
export type GetEpisodeExternalIdsLazyQueryHookResult = ReturnType<typeof useGetEpisodeExternalIdsLazyQuery>;
export type GetEpisodeExternalIdsSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeExternalIdsSuspenseQuery>;
export type GetEpisodeExternalIdsQueryResult = Apollo.QueryResult<Generated.GetEpisodeExternalIdsQuery, Generated.GetEpisodeExternalIdsQueryVariables>;
export const GetEpisodeIdDocument = /*#__PURE__*/ gql`
    query getEpisodeId($ref: ID!) {
  entityByRef(type: SERIES_EPISODE, ref: $ref) {
    ... on SeriesEpisode {
      id
    }
  }
}
    `;

/**
 * __useGetEpisodeIdQuery__
 *
 * To run a query within a React component, call `useGetEpisodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeIdQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetEpisodeIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeIdQuery, Generated.GetEpisodeIdQueryVariables> & ({ variables: Generated.GetEpisodeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeIdQuery, Generated.GetEpisodeIdQueryVariables>(GetEpisodeIdDocument, options);
      }
export function useGetEpisodeIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeIdQuery, Generated.GetEpisodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeIdQuery, Generated.GetEpisodeIdQueryVariables>(GetEpisodeIdDocument, options);
        }
export function useGetEpisodeIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeIdQuery, Generated.GetEpisodeIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeIdQuery, Generated.GetEpisodeIdQueryVariables>(GetEpisodeIdDocument, options);
        }
export type GetEpisodeIdQueryHookResult = ReturnType<typeof useGetEpisodeIdQuery>;
export type GetEpisodeIdLazyQueryHookResult = ReturnType<typeof useGetEpisodeIdLazyQuery>;
export type GetEpisodeIdSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeIdSuspenseQuery>;
export type GetEpisodeIdQueryResult = Apollo.QueryResult<Generated.GetEpisodeIdQuery, Generated.GetEpisodeIdQueryVariables>;
export const GetEpisodeIdentityDocument = /*#__PURE__*/ gql`
    query getEpisodeIdentity($id: ID!, $brandId: ID!, $includeBrandData: Boolean = false) {
  seriesEpisode(id: $id) {
    ...SeriesEpisodeWithSeo
  }
}
    ${SeriesEpisodeWithSeoFragmentDoc}`;

/**
 * __useGetEpisodeIdentityQuery__
 *
 * To run a query within a React component, call `useGetEpisodeIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetEpisodeIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeIdentityQuery, Generated.GetEpisodeIdentityQueryVariables> & ({ variables: Generated.GetEpisodeIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeIdentityQuery, Generated.GetEpisodeIdentityQueryVariables>(GetEpisodeIdentityDocument, options);
      }
export function useGetEpisodeIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeIdentityQuery, Generated.GetEpisodeIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeIdentityQuery, Generated.GetEpisodeIdentityQueryVariables>(GetEpisodeIdentityDocument, options);
        }
export function useGetEpisodeIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeIdentityQuery, Generated.GetEpisodeIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeIdentityQuery, Generated.GetEpisodeIdentityQueryVariables>(GetEpisodeIdentityDocument, options);
        }
export type GetEpisodeIdentityQueryHookResult = ReturnType<typeof useGetEpisodeIdentityQuery>;
export type GetEpisodeIdentityLazyQueryHookResult = ReturnType<typeof useGetEpisodeIdentityLazyQuery>;
export type GetEpisodeIdentitySuspenseQueryHookResult = ReturnType<typeof useGetEpisodeIdentitySuspenseQuery>;
export type GetEpisodeIdentityQueryResult = Apollo.QueryResult<Generated.GetEpisodeIdentityQuery, Generated.GetEpisodeIdentityQueryVariables>;
export const GetEpisodePersonCreditsImportDocument = /*#__PURE__*/ gql`
    query getEpisodePersonCreditsImport($id: ID!, $reportId: ID) {
  seriesEpisode(id: $id) {
    id
    personCreditsImport(id: $reportId) {
      ...PersonCreditsImportReport
    }
    personCreditsImports {
      ...PersonCreditsImportReportSummary
    }
  }
}
    ${PersonCreditsImportReportFragmentDoc}
${PersonCreditsImportReportSummaryFragmentDoc}`;

/**
 * __useGetEpisodePersonCreditsImportQuery__
 *
 * To run a query within a React component, call `useGetEpisodePersonCreditsImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodePersonCreditsImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodePersonCreditsImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetEpisodePersonCreditsImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodePersonCreditsImportQuery, Generated.GetEpisodePersonCreditsImportQueryVariables> & ({ variables: Generated.GetEpisodePersonCreditsImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodePersonCreditsImportQuery, Generated.GetEpisodePersonCreditsImportQueryVariables>(GetEpisodePersonCreditsImportDocument, options);
      }
export function useGetEpisodePersonCreditsImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodePersonCreditsImportQuery, Generated.GetEpisodePersonCreditsImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodePersonCreditsImportQuery, Generated.GetEpisodePersonCreditsImportQueryVariables>(GetEpisodePersonCreditsImportDocument, options);
        }
export function useGetEpisodePersonCreditsImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodePersonCreditsImportQuery, Generated.GetEpisodePersonCreditsImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodePersonCreditsImportQuery, Generated.GetEpisodePersonCreditsImportQueryVariables>(GetEpisodePersonCreditsImportDocument, options);
        }
export type GetEpisodePersonCreditsImportQueryHookResult = ReturnType<typeof useGetEpisodePersonCreditsImportQuery>;
export type GetEpisodePersonCreditsImportLazyQueryHookResult = ReturnType<typeof useGetEpisodePersonCreditsImportLazyQuery>;
export type GetEpisodePersonCreditsImportSuspenseQueryHookResult = ReturnType<typeof useGetEpisodePersonCreditsImportSuspenseQuery>;
export type GetEpisodePersonCreditsImportQueryResult = Apollo.QueryResult<Generated.GetEpisodePersonCreditsImportQuery, Generated.GetEpisodePersonCreditsImportQueryVariables>;
export const GetEpisodeMetadataDocument = /*#__PURE__*/ gql`
    query getEpisodeMetadata($ref: ID!) {
  entityByRef(type: SERIES_EPISODE, ref: $ref) {
    ... on SeriesEpisode {
      __typename
      id
      ref
      number
      ...EpisodeIdentity
      ...EpisodeMetadata
      ...EpisodeMetadataNav
    }
  }
}
    ${EpisodeIdentityFragmentDoc}
${EpisodeMetadataFragmentDoc}
${EpisodeMetadataNavFragmentDoc}`;

/**
 * __useGetEpisodeMetadataQuery__
 *
 * To run a query within a React component, call `useGetEpisodeMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetEpisodeMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeMetadataQuery, Generated.GetEpisodeMetadataQueryVariables> & ({ variables: Generated.GetEpisodeMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeMetadataQuery, Generated.GetEpisodeMetadataQueryVariables>(GetEpisodeMetadataDocument, options);
      }
export function useGetEpisodeMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeMetadataQuery, Generated.GetEpisodeMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeMetadataQuery, Generated.GetEpisodeMetadataQueryVariables>(GetEpisodeMetadataDocument, options);
        }
export function useGetEpisodeMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeMetadataQuery, Generated.GetEpisodeMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeMetadataQuery, Generated.GetEpisodeMetadataQueryVariables>(GetEpisodeMetadataDocument, options);
        }
export type GetEpisodeMetadataQueryHookResult = ReturnType<typeof useGetEpisodeMetadataQuery>;
export type GetEpisodeMetadataLazyQueryHookResult = ReturnType<typeof useGetEpisodeMetadataLazyQuery>;
export type GetEpisodeMetadataSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeMetadataSuspenseQuery>;
export type GetEpisodeMetadataQueryResult = Apollo.QueryResult<Generated.GetEpisodeMetadataQuery, Generated.GetEpisodeMetadataQueryVariables>;
export const GetEpisodeReleaseDocument = /*#__PURE__*/ gql`
    query getEpisodeRelease($ref: ID!) {
  releaseByRef(entityType: SERIES_EPISODE, ref: $ref) {
    ...EpisodeRelease
    ...EpisodeReleaseMetadata
    ...EpisodeReleaseNav
  }
}
    ${EpisodeReleaseFragmentDoc}
${EpisodeReleaseMetadataFragmentDoc}
${EpisodeReleaseNavFragmentDoc}`;

/**
 * __useGetEpisodeReleaseQuery__
 *
 * To run a query within a React component, call `useGetEpisodeReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeReleaseQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetEpisodeReleaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEpisodeReleaseQuery, Generated.GetEpisodeReleaseQueryVariables> & ({ variables: Generated.GetEpisodeReleaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEpisodeReleaseQuery, Generated.GetEpisodeReleaseQueryVariables>(GetEpisodeReleaseDocument, options);
      }
export function useGetEpisodeReleaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEpisodeReleaseQuery, Generated.GetEpisodeReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEpisodeReleaseQuery, Generated.GetEpisodeReleaseQueryVariables>(GetEpisodeReleaseDocument, options);
        }
export function useGetEpisodeReleaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEpisodeReleaseQuery, Generated.GetEpisodeReleaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEpisodeReleaseQuery, Generated.GetEpisodeReleaseQueryVariables>(GetEpisodeReleaseDocument, options);
        }
export type GetEpisodeReleaseQueryHookResult = ReturnType<typeof useGetEpisodeReleaseQuery>;
export type GetEpisodeReleaseLazyQueryHookResult = ReturnType<typeof useGetEpisodeReleaseLazyQuery>;
export type GetEpisodeReleaseSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeReleaseSuspenseQuery>;
export type GetEpisodeReleaseQueryResult = Apollo.QueryResult<Generated.GetEpisodeReleaseQuery, Generated.GetEpisodeReleaseQueryVariables>;
export const GetSeasonBrandedDataDocument = /*#__PURE__*/ gql`
    query getSeasonBrandedData($id: ID!, $brandId: ID!) {
  seriesSeason(id: $id) {
    id
    brandData(brandId: $brandId) {
      id
      synopsis
      poster {
        ...Image
      }
      ruling {
        hasRating
        atRisk
        hasWarningMessage
        hasMandatoryReview
      }
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetSeasonBrandedDataQuery__
 *
 * To run a query within a React component, call `useGetSeasonBrandedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonBrandedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonBrandedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetSeasonBrandedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonBrandedDataQuery, Generated.GetSeasonBrandedDataQueryVariables> & ({ variables: Generated.GetSeasonBrandedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonBrandedDataQuery, Generated.GetSeasonBrandedDataQueryVariables>(GetSeasonBrandedDataDocument, options);
      }
export function useGetSeasonBrandedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonBrandedDataQuery, Generated.GetSeasonBrandedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonBrandedDataQuery, Generated.GetSeasonBrandedDataQueryVariables>(GetSeasonBrandedDataDocument, options);
        }
export function useGetSeasonBrandedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonBrandedDataQuery, Generated.GetSeasonBrandedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonBrandedDataQuery, Generated.GetSeasonBrandedDataQueryVariables>(GetSeasonBrandedDataDocument, options);
        }
export type GetSeasonBrandedDataQueryHookResult = ReturnType<typeof useGetSeasonBrandedDataQuery>;
export type GetSeasonBrandedDataLazyQueryHookResult = ReturnType<typeof useGetSeasonBrandedDataLazyQuery>;
export type GetSeasonBrandedDataSuspenseQueryHookResult = ReturnType<typeof useGetSeasonBrandedDataSuspenseQuery>;
export type GetSeasonBrandedDataQueryResult = Apollo.QueryResult<Generated.GetSeasonBrandedDataQuery, Generated.GetSeasonBrandedDataQueryVariables>;
export const GetSeasonCompanyDocument = /*#__PURE__*/ gql`
    query getSeasonCompany($id: ID!, $limit: Int!, $offset: Int!, $activities: [CompanyActivity!]) {
  seriesSeason(id: $id) {
    id
    companies(limit: $limit, offset: $offset, activities: $activities) {
      totalCount
      nodes {
        ...EntitiesCompany
      }
    }
    series {
      id
    }
  }
}
    ${EntitiesCompanyFragmentDoc}`;

/**
 * __useGetSeasonCompanyQuery__
 *
 * To run a query within a React component, call `useGetSeasonCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *   },
 * });
 */
export function useGetSeasonCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonCompanyQuery, Generated.GetSeasonCompanyQueryVariables> & ({ variables: Generated.GetSeasonCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonCompanyQuery, Generated.GetSeasonCompanyQueryVariables>(GetSeasonCompanyDocument, options);
      }
export function useGetSeasonCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonCompanyQuery, Generated.GetSeasonCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonCompanyQuery, Generated.GetSeasonCompanyQueryVariables>(GetSeasonCompanyDocument, options);
        }
export function useGetSeasonCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonCompanyQuery, Generated.GetSeasonCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonCompanyQuery, Generated.GetSeasonCompanyQueryVariables>(GetSeasonCompanyDocument, options);
        }
export type GetSeasonCompanyQueryHookResult = ReturnType<typeof useGetSeasonCompanyQuery>;
export type GetSeasonCompanyLazyQueryHookResult = ReturnType<typeof useGetSeasonCompanyLazyQuery>;
export type GetSeasonCompanySuspenseQueryHookResult = ReturnType<typeof useGetSeasonCompanySuspenseQuery>;
export type GetSeasonCompanyQueryResult = Apollo.QueryResult<Generated.GetSeasonCompanyQuery, Generated.GetSeasonCompanyQueryVariables>;
export const GetSeasonCreditDocument = /*#__PURE__*/ gql`
    query getSeasonCredit($id: ID!, $limit: Int!, $offset: Int!, $activities: [PersonActivity!], $brandId: ID!, $includeBrandData: Boolean = false) {
  seriesSeason(id: $id) {
    id
    parent: series {
      id
    }
    credits(
      limit: $limit
      offset: $offset
      activities: $activities
      excludeActivities: [ACTOR_ACTOR]
    ) {
      totalCount
      nodes {
        ...CreditLimited
      }
    }
  }
}
    ${CreditLimitedFragmentDoc}`;

/**
 * __useGetSeasonCreditQuery__
 *
 * To run a query within a React component, call `useGetSeasonCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonCreditQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetSeasonCreditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonCreditQuery, Generated.GetSeasonCreditQueryVariables> & ({ variables: Generated.GetSeasonCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonCreditQuery, Generated.GetSeasonCreditQueryVariables>(GetSeasonCreditDocument, options);
      }
export function useGetSeasonCreditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonCreditQuery, Generated.GetSeasonCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonCreditQuery, Generated.GetSeasonCreditQueryVariables>(GetSeasonCreditDocument, options);
        }
export function useGetSeasonCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonCreditQuery, Generated.GetSeasonCreditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonCreditQuery, Generated.GetSeasonCreditQueryVariables>(GetSeasonCreditDocument, options);
        }
export type GetSeasonCreditQueryHookResult = ReturnType<typeof useGetSeasonCreditQuery>;
export type GetSeasonCreditLazyQueryHookResult = ReturnType<typeof useGetSeasonCreditLazyQuery>;
export type GetSeasonCreditSuspenseQueryHookResult = ReturnType<typeof useGetSeasonCreditSuspenseQuery>;
export type GetSeasonCreditQueryResult = Apollo.QueryResult<Generated.GetSeasonCreditQuery, Generated.GetSeasonCreditQueryVariables>;
export const GetSeasonEpisodesDocument = /*#__PURE__*/ gql`
    query getSeasonEpisodes($id: ID!, $limit: Int!, $offset: Int!, $brandId: ID!, $episodeNumbers: [NonNegativeInt!], $includeBrandData: Boolean = false) {
  seriesSeason(id: $id) {
    id
    series {
      id
    }
    episodes(limit: $limit, offset: $offset, episodeNumbers: $episodeNumbers) {
      totalCount
      nodes {
        ...EpisodeBrandIdentity
      }
    }
  }
}
    ${EpisodeBrandIdentityFragmentDoc}`;

/**
 * __useGetSeasonEpisodesQuery__
 *
 * To run a query within a React component, call `useGetSeasonEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      episodeNumbers: // value for 'episodeNumbers'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetSeasonEpisodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonEpisodesQuery, Generated.GetSeasonEpisodesQueryVariables> & ({ variables: Generated.GetSeasonEpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonEpisodesQuery, Generated.GetSeasonEpisodesQueryVariables>(GetSeasonEpisodesDocument, options);
      }
export function useGetSeasonEpisodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonEpisodesQuery, Generated.GetSeasonEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonEpisodesQuery, Generated.GetSeasonEpisodesQueryVariables>(GetSeasonEpisodesDocument, options);
        }
export function useGetSeasonEpisodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonEpisodesQuery, Generated.GetSeasonEpisodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonEpisodesQuery, Generated.GetSeasonEpisodesQueryVariables>(GetSeasonEpisodesDocument, options);
        }
export type GetSeasonEpisodesQueryHookResult = ReturnType<typeof useGetSeasonEpisodesQuery>;
export type GetSeasonEpisodesLazyQueryHookResult = ReturnType<typeof useGetSeasonEpisodesLazyQuery>;
export type GetSeasonEpisodesSuspenseQueryHookResult = ReturnType<typeof useGetSeasonEpisodesSuspenseQuery>;
export type GetSeasonEpisodesQueryResult = Apollo.QueryResult<Generated.GetSeasonEpisodesQuery, Generated.GetSeasonEpisodesQueryVariables>;
export const GetSeasonCastingDocument = /*#__PURE__*/ gql`
    query getSeasonCasting($id: ID!, $limit: Int, $offset: Int!, $locale: ID, $showLocaleData: Boolean!, $brandId: ID!, $includeBrandData: Boolean = false, $withSeoAttributes: Boolean! = false) {
  seriesSeason(id: $id) {
    id
    parent: series {
      id
    }
    credits(limit: $limit, offset: $offset, activities: [ACTOR_ACTOR]) {
      totalCount
      nodes {
        ...Credit
      }
    }
  }
}
    ${CreditFragmentDoc}`;

/**
 * __useGetSeasonCastingQuery__
 *
 * To run a query within a React component, call `useGetSeasonCastingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonCastingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonCastingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      locale: // value for 'locale'
 *      showLocaleData: // value for 'showLocaleData'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useGetSeasonCastingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonCastingQuery, Generated.GetSeasonCastingQueryVariables> & ({ variables: Generated.GetSeasonCastingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonCastingQuery, Generated.GetSeasonCastingQueryVariables>(GetSeasonCastingDocument, options);
      }
export function useGetSeasonCastingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonCastingQuery, Generated.GetSeasonCastingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonCastingQuery, Generated.GetSeasonCastingQueryVariables>(GetSeasonCastingDocument, options);
        }
export function useGetSeasonCastingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonCastingQuery, Generated.GetSeasonCastingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonCastingQuery, Generated.GetSeasonCastingQueryVariables>(GetSeasonCastingDocument, options);
        }
export type GetSeasonCastingQueryHookResult = ReturnType<typeof useGetSeasonCastingQuery>;
export type GetSeasonCastingLazyQueryHookResult = ReturnType<typeof useGetSeasonCastingLazyQuery>;
export type GetSeasonCastingSuspenseQueryHookResult = ReturnType<typeof useGetSeasonCastingSuspenseQuery>;
export type GetSeasonCastingQueryResult = Apollo.QueryResult<Generated.GetSeasonCastingQuery, Generated.GetSeasonCastingQueryVariables>;
export const GetSeasonExternalIdsDocument = /*#__PURE__*/ gql`
    query getSeasonExternalIds($id: ID!) {
  seriesSeason(id: $id) {
    ... on SeriesSeason {
      id
      ...EntityAlts
    }
  }
}
    ${EntityAltsFragmentDoc}`;

/**
 * __useGetSeasonExternalIdsQuery__
 *
 * To run a query within a React component, call `useGetSeasonExternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonExternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonExternalIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSeasonExternalIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonExternalIdsQuery, Generated.GetSeasonExternalIdsQueryVariables> & ({ variables: Generated.GetSeasonExternalIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonExternalIdsQuery, Generated.GetSeasonExternalIdsQueryVariables>(GetSeasonExternalIdsDocument, options);
      }
export function useGetSeasonExternalIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonExternalIdsQuery, Generated.GetSeasonExternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonExternalIdsQuery, Generated.GetSeasonExternalIdsQueryVariables>(GetSeasonExternalIdsDocument, options);
        }
export function useGetSeasonExternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonExternalIdsQuery, Generated.GetSeasonExternalIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonExternalIdsQuery, Generated.GetSeasonExternalIdsQueryVariables>(GetSeasonExternalIdsDocument, options);
        }
export type GetSeasonExternalIdsQueryHookResult = ReturnType<typeof useGetSeasonExternalIdsQuery>;
export type GetSeasonExternalIdsLazyQueryHookResult = ReturnType<typeof useGetSeasonExternalIdsLazyQuery>;
export type GetSeasonExternalIdsSuspenseQueryHookResult = ReturnType<typeof useGetSeasonExternalIdsSuspenseQuery>;
export type GetSeasonExternalIdsQueryResult = Apollo.QueryResult<Generated.GetSeasonExternalIdsQuery, Generated.GetSeasonExternalIdsQueryVariables>;
export const GetSeasonIdDocument = /*#__PURE__*/ gql`
    query getSeasonId($ref: ID!) {
  entityByRef(type: SERIES_SEASON, ref: $ref) {
    ... on SeriesSeason {
      id
    }
  }
}
    `;

/**
 * __useGetSeasonIdQuery__
 *
 * To run a query within a React component, call `useGetSeasonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonIdQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSeasonIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonIdQuery, Generated.GetSeasonIdQueryVariables> & ({ variables: Generated.GetSeasonIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonIdQuery, Generated.GetSeasonIdQueryVariables>(GetSeasonIdDocument, options);
      }
export function useGetSeasonIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonIdQuery, Generated.GetSeasonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonIdQuery, Generated.GetSeasonIdQueryVariables>(GetSeasonIdDocument, options);
        }
export function useGetSeasonIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonIdQuery, Generated.GetSeasonIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonIdQuery, Generated.GetSeasonIdQueryVariables>(GetSeasonIdDocument, options);
        }
export type GetSeasonIdQueryHookResult = ReturnType<typeof useGetSeasonIdQuery>;
export type GetSeasonIdLazyQueryHookResult = ReturnType<typeof useGetSeasonIdLazyQuery>;
export type GetSeasonIdSuspenseQueryHookResult = ReturnType<typeof useGetSeasonIdSuspenseQuery>;
export type GetSeasonIdQueryResult = Apollo.QueryResult<Generated.GetSeasonIdQuery, Generated.GetSeasonIdQueryVariables>;
export const GetSeasonIdentityDocument = /*#__PURE__*/ gql`
    query getSeasonIdentity($id: ID!, $brandId: ID!, $includeBrandData: Boolean = false) {
  seriesSeason(id: $id) {
    __typename
    ...SeriesSeasonWithSeo
  }
}
    ${SeriesSeasonWithSeoFragmentDoc}`;

/**
 * __useGetSeasonIdentityQuery__
 *
 * To run a query within a React component, call `useGetSeasonIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetSeasonIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonIdentityQuery, Generated.GetSeasonIdentityQueryVariables> & ({ variables: Generated.GetSeasonIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonIdentityQuery, Generated.GetSeasonIdentityQueryVariables>(GetSeasonIdentityDocument, options);
      }
export function useGetSeasonIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonIdentityQuery, Generated.GetSeasonIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonIdentityQuery, Generated.GetSeasonIdentityQueryVariables>(GetSeasonIdentityDocument, options);
        }
export function useGetSeasonIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonIdentityQuery, Generated.GetSeasonIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonIdentityQuery, Generated.GetSeasonIdentityQueryVariables>(GetSeasonIdentityDocument, options);
        }
export type GetSeasonIdentityQueryHookResult = ReturnType<typeof useGetSeasonIdentityQuery>;
export type GetSeasonIdentityLazyQueryHookResult = ReturnType<typeof useGetSeasonIdentityLazyQuery>;
export type GetSeasonIdentitySuspenseQueryHookResult = ReturnType<typeof useGetSeasonIdentitySuspenseQuery>;
export type GetSeasonIdentityQueryResult = Apollo.QueryResult<Generated.GetSeasonIdentityQuery, Generated.GetSeasonIdentityQueryVariables>;
export const GetSeasonPersonCreditsImportDocument = /*#__PURE__*/ gql`
    query getSeasonPersonCreditsImport($id: ID!, $reportId: ID) {
  seriesSeason(id: $id) {
    id
    personCreditsImport(id: $reportId) {
      ...PersonCreditsImportReport
    }
    personCreditsImports {
      ...PersonCreditsImportReportSummary
    }
  }
}
    ${PersonCreditsImportReportFragmentDoc}
${PersonCreditsImportReportSummaryFragmentDoc}`;

/**
 * __useGetSeasonPersonCreditsImportQuery__
 *
 * To run a query within a React component, call `useGetSeasonPersonCreditsImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonPersonCreditsImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonPersonCreditsImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetSeasonPersonCreditsImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonPersonCreditsImportQuery, Generated.GetSeasonPersonCreditsImportQueryVariables> & ({ variables: Generated.GetSeasonPersonCreditsImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonPersonCreditsImportQuery, Generated.GetSeasonPersonCreditsImportQueryVariables>(GetSeasonPersonCreditsImportDocument, options);
      }
export function useGetSeasonPersonCreditsImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonPersonCreditsImportQuery, Generated.GetSeasonPersonCreditsImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonPersonCreditsImportQuery, Generated.GetSeasonPersonCreditsImportQueryVariables>(GetSeasonPersonCreditsImportDocument, options);
        }
export function useGetSeasonPersonCreditsImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonPersonCreditsImportQuery, Generated.GetSeasonPersonCreditsImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonPersonCreditsImportQuery, Generated.GetSeasonPersonCreditsImportQueryVariables>(GetSeasonPersonCreditsImportDocument, options);
        }
export type GetSeasonPersonCreditsImportQueryHookResult = ReturnType<typeof useGetSeasonPersonCreditsImportQuery>;
export type GetSeasonPersonCreditsImportLazyQueryHookResult = ReturnType<typeof useGetSeasonPersonCreditsImportLazyQuery>;
export type GetSeasonPersonCreditsImportSuspenseQueryHookResult = ReturnType<typeof useGetSeasonPersonCreditsImportSuspenseQuery>;
export type GetSeasonPersonCreditsImportQueryResult = Apollo.QueryResult<Generated.GetSeasonPersonCreditsImportQuery, Generated.GetSeasonPersonCreditsImportQueryVariables>;
export const GetSeriesBrandedDataDocument = /*#__PURE__*/ gql`
    query getSeriesBrandedData($id: ID!, $brandId: ID!) {
  series(id: $id) {
    id
    brandData(brandId: $brandId) {
      id
      title
      keywords
      synopsis
      synopsisShort
      poster {
        ...Image
      }
      ruling {
        hasRating
        atRisk
        hasWarningMessage
        hasMandatoryReview
      }
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetSeriesBrandedDataQuery__
 *
 * To run a query within a React component, call `useGetSeriesBrandedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesBrandedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesBrandedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetSeriesBrandedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesBrandedDataQuery, Generated.GetSeriesBrandedDataQueryVariables> & ({ variables: Generated.GetSeriesBrandedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesBrandedDataQuery, Generated.GetSeriesBrandedDataQueryVariables>(GetSeriesBrandedDataDocument, options);
      }
export function useGetSeriesBrandedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesBrandedDataQuery, Generated.GetSeriesBrandedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesBrandedDataQuery, Generated.GetSeriesBrandedDataQueryVariables>(GetSeriesBrandedDataDocument, options);
        }
export function useGetSeriesBrandedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesBrandedDataQuery, Generated.GetSeriesBrandedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesBrandedDataQuery, Generated.GetSeriesBrandedDataQueryVariables>(GetSeriesBrandedDataDocument, options);
        }
export type GetSeriesBrandedDataQueryHookResult = ReturnType<typeof useGetSeriesBrandedDataQuery>;
export type GetSeriesBrandedDataLazyQueryHookResult = ReturnType<typeof useGetSeriesBrandedDataLazyQuery>;
export type GetSeriesBrandedDataSuspenseQueryHookResult = ReturnType<typeof useGetSeriesBrandedDataSuspenseQuery>;
export type GetSeriesBrandedDataQueryResult = Apollo.QueryResult<Generated.GetSeriesBrandedDataQuery, Generated.GetSeriesBrandedDataQueryVariables>;
export const GetSeasonMetadataDocument = /*#__PURE__*/ gql`
    query getSeasonMetadata($ref: ID!) {
  entityByRef(type: SERIES_SEASON, ref: $ref) {
    ... on SeriesSeason {
      id
      ref
      number
      __typename
      ...SeasonMetadata
      ...SeasonMetadataNav
    }
  }
}
    ${SeasonMetadataFragmentDoc}
${SeasonMetadataNavFragmentDoc}`;

/**
 * __useGetSeasonMetadataQuery__
 *
 * To run a query within a React component, call `useGetSeasonMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSeasonMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonMetadataQuery, Generated.GetSeasonMetadataQueryVariables> & ({ variables: Generated.GetSeasonMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonMetadataQuery, Generated.GetSeasonMetadataQueryVariables>(GetSeasonMetadataDocument, options);
      }
export function useGetSeasonMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonMetadataQuery, Generated.GetSeasonMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonMetadataQuery, Generated.GetSeasonMetadataQueryVariables>(GetSeasonMetadataDocument, options);
        }
export function useGetSeasonMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonMetadataQuery, Generated.GetSeasonMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonMetadataQuery, Generated.GetSeasonMetadataQueryVariables>(GetSeasonMetadataDocument, options);
        }
export type GetSeasonMetadataQueryHookResult = ReturnType<typeof useGetSeasonMetadataQuery>;
export type GetSeasonMetadataLazyQueryHookResult = ReturnType<typeof useGetSeasonMetadataLazyQuery>;
export type GetSeasonMetadataSuspenseQueryHookResult = ReturnType<typeof useGetSeasonMetadataSuspenseQuery>;
export type GetSeasonMetadataQueryResult = Apollo.QueryResult<Generated.GetSeasonMetadataQuery, Generated.GetSeasonMetadataQueryVariables>;
export const GetSeasonReleaseDocument = /*#__PURE__*/ gql`
    query getSeasonRelease($ref: ID!) {
  releaseByRef(entityType: SERIES_SEASON, ref: $ref) {
    ...SeasonRelease
    ...SeasonReleaseMetadata
    ...SeasonReleaseNav
  }
}
    ${SeasonReleaseFragmentDoc}
${SeasonReleaseMetadataFragmentDoc}
${SeasonReleaseNavFragmentDoc}`;

/**
 * __useGetSeasonReleaseQuery__
 *
 * To run a query within a React component, call `useGetSeasonReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonReleaseQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSeasonReleaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeasonReleaseQuery, Generated.GetSeasonReleaseQueryVariables> & ({ variables: Generated.GetSeasonReleaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeasonReleaseQuery, Generated.GetSeasonReleaseQueryVariables>(GetSeasonReleaseDocument, options);
      }
export function useGetSeasonReleaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeasonReleaseQuery, Generated.GetSeasonReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeasonReleaseQuery, Generated.GetSeasonReleaseQueryVariables>(GetSeasonReleaseDocument, options);
        }
export function useGetSeasonReleaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeasonReleaseQuery, Generated.GetSeasonReleaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeasonReleaseQuery, Generated.GetSeasonReleaseQueryVariables>(GetSeasonReleaseDocument, options);
        }
export type GetSeasonReleaseQueryHookResult = ReturnType<typeof useGetSeasonReleaseQuery>;
export type GetSeasonReleaseLazyQueryHookResult = ReturnType<typeof useGetSeasonReleaseLazyQuery>;
export type GetSeasonReleaseSuspenseQueryHookResult = ReturnType<typeof useGetSeasonReleaseSuspenseQuery>;
export type GetSeasonReleaseQueryResult = Apollo.QueryResult<Generated.GetSeasonReleaseQuery, Generated.GetSeasonReleaseQueryVariables>;
export const GetSeriesByRefsDocument = /*#__PURE__*/ gql`
    query getSeriesByRefs($refs: [ID!]!) {
  entitiesByRef(type: SERIES, refs: $refs) {
    ... on Series {
      __typename
      id
      ref
      title
    }
  }
}
    `;

/**
 * __useGetSeriesByRefsQuery__
 *
 * To run a query within a React component, call `useGetSeriesByRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesByRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesByRefsQuery({
 *   variables: {
 *      refs: // value for 'refs'
 *   },
 * });
 */
export function useGetSeriesByRefsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesByRefsQuery, Generated.GetSeriesByRefsQueryVariables> & ({ variables: Generated.GetSeriesByRefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesByRefsQuery, Generated.GetSeriesByRefsQueryVariables>(GetSeriesByRefsDocument, options);
      }
export function useGetSeriesByRefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesByRefsQuery, Generated.GetSeriesByRefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesByRefsQuery, Generated.GetSeriesByRefsQueryVariables>(GetSeriesByRefsDocument, options);
        }
export function useGetSeriesByRefsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesByRefsQuery, Generated.GetSeriesByRefsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesByRefsQuery, Generated.GetSeriesByRefsQueryVariables>(GetSeriesByRefsDocument, options);
        }
export type GetSeriesByRefsQueryHookResult = ReturnType<typeof useGetSeriesByRefsQuery>;
export type GetSeriesByRefsLazyQueryHookResult = ReturnType<typeof useGetSeriesByRefsLazyQuery>;
export type GetSeriesByRefsSuspenseQueryHookResult = ReturnType<typeof useGetSeriesByRefsSuspenseQuery>;
export type GetSeriesByRefsQueryResult = Apollo.QueryResult<Generated.GetSeriesByRefsQuery, Generated.GetSeriesByRefsQueryVariables>;
export const GetSeriesCompanyDocument = /*#__PURE__*/ gql`
    query getSeriesCompany($id: ID!, $limit: Int!, $offset: Int!, $activities: [CompanyActivity!]) {
  series(id: $id) {
    id
    companies(limit: $limit, offset: $offset, activities: $activities) {
      totalCount
      nodes {
        ...EntitiesCompany
      }
    }
  }
}
    ${EntitiesCompanyFragmentDoc}`;

/**
 * __useGetSeriesCompanyQuery__
 *
 * To run a query within a React component, call `useGetSeriesCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *   },
 * });
 */
export function useGetSeriesCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesCompanyQuery, Generated.GetSeriesCompanyQueryVariables> & ({ variables: Generated.GetSeriesCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesCompanyQuery, Generated.GetSeriesCompanyQueryVariables>(GetSeriesCompanyDocument, options);
      }
export function useGetSeriesCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesCompanyQuery, Generated.GetSeriesCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesCompanyQuery, Generated.GetSeriesCompanyQueryVariables>(GetSeriesCompanyDocument, options);
        }
export function useGetSeriesCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesCompanyQuery, Generated.GetSeriesCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesCompanyQuery, Generated.GetSeriesCompanyQueryVariables>(GetSeriesCompanyDocument, options);
        }
export type GetSeriesCompanyQueryHookResult = ReturnType<typeof useGetSeriesCompanyQuery>;
export type GetSeriesCompanyLazyQueryHookResult = ReturnType<typeof useGetSeriesCompanyLazyQuery>;
export type GetSeriesCompanySuspenseQueryHookResult = ReturnType<typeof useGetSeriesCompanySuspenseQuery>;
export type GetSeriesCompanyQueryResult = Apollo.QueryResult<Generated.GetSeriesCompanyQuery, Generated.GetSeriesCompanyQueryVariables>;
export const GetSeriesEntityLinksDocument = /*#__PURE__*/ gql`
    query getSeriesEntityLinks($id: ID!) {
  series(id: $id) {
    id
    ...SeriesEntityLinkList
  }
}
    ${SeriesEntityLinkListFragmentDoc}`;

/**
 * __useGetSeriesEntityLinksQuery__
 *
 * To run a query within a React component, call `useGetSeriesEntityLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesEntityLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesEntityLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSeriesEntityLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesEntityLinksQuery, Generated.GetSeriesEntityLinksQueryVariables> & ({ variables: Generated.GetSeriesEntityLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesEntityLinksQuery, Generated.GetSeriesEntityLinksQueryVariables>(GetSeriesEntityLinksDocument, options);
      }
export function useGetSeriesEntityLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesEntityLinksQuery, Generated.GetSeriesEntityLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesEntityLinksQuery, Generated.GetSeriesEntityLinksQueryVariables>(GetSeriesEntityLinksDocument, options);
        }
export function useGetSeriesEntityLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesEntityLinksQuery, Generated.GetSeriesEntityLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesEntityLinksQuery, Generated.GetSeriesEntityLinksQueryVariables>(GetSeriesEntityLinksDocument, options);
        }
export type GetSeriesEntityLinksQueryHookResult = ReturnType<typeof useGetSeriesEntityLinksQuery>;
export type GetSeriesEntityLinksLazyQueryHookResult = ReturnType<typeof useGetSeriesEntityLinksLazyQuery>;
export type GetSeriesEntityLinksSuspenseQueryHookResult = ReturnType<typeof useGetSeriesEntityLinksSuspenseQuery>;
export type GetSeriesEntityLinksQueryResult = Apollo.QueryResult<Generated.GetSeriesEntityLinksQuery, Generated.GetSeriesEntityLinksQueryVariables>;
export const GetSeriesCreditDocument = /*#__PURE__*/ gql`
    query getSeriesCredit($id: ID!, $limit: Int!, $offset: Int!, $activities: [PersonActivity!], $brandId: ID!, $includeBrandData: Boolean = false) {
  series(id: $id) {
    id
    credits(
      limit: $limit
      offset: $offset
      activities: $activities
      excludeActivities: [ACTOR_ACTOR]
    ) {
      totalCount
      nodes {
        ...CreditLimited
      }
    }
  }
}
    ${CreditLimitedFragmentDoc}`;

/**
 * __useGetSeriesCreditQuery__
 *
 * To run a query within a React component, call `useGetSeriesCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesCreditQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activities: // value for 'activities'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetSeriesCreditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesCreditQuery, Generated.GetSeriesCreditQueryVariables> & ({ variables: Generated.GetSeriesCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesCreditQuery, Generated.GetSeriesCreditQueryVariables>(GetSeriesCreditDocument, options);
      }
export function useGetSeriesCreditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesCreditQuery, Generated.GetSeriesCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesCreditQuery, Generated.GetSeriesCreditQueryVariables>(GetSeriesCreditDocument, options);
        }
export function useGetSeriesCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesCreditQuery, Generated.GetSeriesCreditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesCreditQuery, Generated.GetSeriesCreditQueryVariables>(GetSeriesCreditDocument, options);
        }
export type GetSeriesCreditQueryHookResult = ReturnType<typeof useGetSeriesCreditQuery>;
export type GetSeriesCreditLazyQueryHookResult = ReturnType<typeof useGetSeriesCreditLazyQuery>;
export type GetSeriesCreditSuspenseQueryHookResult = ReturnType<typeof useGetSeriesCreditSuspenseQuery>;
export type GetSeriesCreditQueryResult = Apollo.QueryResult<Generated.GetSeriesCreditQuery, Generated.GetSeriesCreditQueryVariables>;
export const GetSeriesEpisodesDocument = /*#__PURE__*/ gql`
    query getSeriesEpisodes($id: ID!, $limit: Int, $offset: Int, $filter: SeriesEpisodeFilter, $brandId: ID!, $includeBrandData: Boolean = false) {
  series(id: $id) {
    id
    episodes(filter: $filter, limit: $limit, offset: $offset) {
      totalCount
      nodes {
        ...EpisodeBrandIdentity
      }
    }
  }
}
    ${EpisodeBrandIdentityFragmentDoc}`;

/**
 * __useGetSeriesEpisodesQuery__
 *
 * To run a query within a React component, call `useGetSeriesEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetSeriesEpisodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesEpisodesQuery, Generated.GetSeriesEpisodesQueryVariables> & ({ variables: Generated.GetSeriesEpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesEpisodesQuery, Generated.GetSeriesEpisodesQueryVariables>(GetSeriesEpisodesDocument, options);
      }
export function useGetSeriesEpisodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesEpisodesQuery, Generated.GetSeriesEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesEpisodesQuery, Generated.GetSeriesEpisodesQueryVariables>(GetSeriesEpisodesDocument, options);
        }
export function useGetSeriesEpisodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesEpisodesQuery, Generated.GetSeriesEpisodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesEpisodesQuery, Generated.GetSeriesEpisodesQueryVariables>(GetSeriesEpisodesDocument, options);
        }
export type GetSeriesEpisodesQueryHookResult = ReturnType<typeof useGetSeriesEpisodesQuery>;
export type GetSeriesEpisodesLazyQueryHookResult = ReturnType<typeof useGetSeriesEpisodesLazyQuery>;
export type GetSeriesEpisodesSuspenseQueryHookResult = ReturnType<typeof useGetSeriesEpisodesSuspenseQuery>;
export type GetSeriesEpisodesQueryResult = Apollo.QueryResult<Generated.GetSeriesEpisodesQuery, Generated.GetSeriesEpisodesQueryVariables>;
export const GetSeriesIdDocument = /*#__PURE__*/ gql`
    query getSeriesId($ref: ID!) {
  entityByRef(type: SERIES, ref: $ref) {
    ... on Series {
      id
    }
  }
}
    `;

/**
 * __useGetSeriesIdQuery__
 *
 * To run a query within a React component, call `useGetSeriesIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesIdQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSeriesIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesIdQuery, Generated.GetSeriesIdQueryVariables> & ({ variables: Generated.GetSeriesIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesIdQuery, Generated.GetSeriesIdQueryVariables>(GetSeriesIdDocument, options);
      }
export function useGetSeriesIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesIdQuery, Generated.GetSeriesIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesIdQuery, Generated.GetSeriesIdQueryVariables>(GetSeriesIdDocument, options);
        }
export function useGetSeriesIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesIdQuery, Generated.GetSeriesIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesIdQuery, Generated.GetSeriesIdQueryVariables>(GetSeriesIdDocument, options);
        }
export type GetSeriesIdQueryHookResult = ReturnType<typeof useGetSeriesIdQuery>;
export type GetSeriesIdLazyQueryHookResult = ReturnType<typeof useGetSeriesIdLazyQuery>;
export type GetSeriesIdSuspenseQueryHookResult = ReturnType<typeof useGetSeriesIdSuspenseQuery>;
export type GetSeriesIdQueryResult = Apollo.QueryResult<Generated.GetSeriesIdQuery, Generated.GetSeriesIdQueryVariables>;
export const GetSeriesExternalIdsDocument = /*#__PURE__*/ gql`
    query getSeriesExternalIds($id: ID!) {
  series(id: $id) {
    ... on Series {
      id
      ...EntityAlts
    }
  }
}
    ${EntityAltsFragmentDoc}`;

/**
 * __useGetSeriesExternalIdsQuery__
 *
 * To run a query within a React component, call `useGetSeriesExternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesExternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesExternalIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSeriesExternalIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesExternalIdsQuery, Generated.GetSeriesExternalIdsQueryVariables> & ({ variables: Generated.GetSeriesExternalIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesExternalIdsQuery, Generated.GetSeriesExternalIdsQueryVariables>(GetSeriesExternalIdsDocument, options);
      }
export function useGetSeriesExternalIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesExternalIdsQuery, Generated.GetSeriesExternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesExternalIdsQuery, Generated.GetSeriesExternalIdsQueryVariables>(GetSeriesExternalIdsDocument, options);
        }
export function useGetSeriesExternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesExternalIdsQuery, Generated.GetSeriesExternalIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesExternalIdsQuery, Generated.GetSeriesExternalIdsQueryVariables>(GetSeriesExternalIdsDocument, options);
        }
export type GetSeriesExternalIdsQueryHookResult = ReturnType<typeof useGetSeriesExternalIdsQuery>;
export type GetSeriesExternalIdsLazyQueryHookResult = ReturnType<typeof useGetSeriesExternalIdsLazyQuery>;
export type GetSeriesExternalIdsSuspenseQueryHookResult = ReturnType<typeof useGetSeriesExternalIdsSuspenseQuery>;
export type GetSeriesExternalIdsQueryResult = Apollo.QueryResult<Generated.GetSeriesExternalIdsQuery, Generated.GetSeriesExternalIdsQueryVariables>;
export const GetSeriesIdentityDocument = /*#__PURE__*/ gql`
    query getSeriesIdentity($id: ID!) {
  series(id: $id) {
    ... on Series {
      id
      ...SeriesIdentity
      ...SeriesAdditionalInfo
    }
  }
}
    ${SeriesIdentityFragmentDoc}
${SeriesAdditionalInfoFragmentDoc}`;

/**
 * __useGetSeriesIdentityQuery__
 *
 * To run a query within a React component, call `useGetSeriesIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSeriesIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesIdentityQuery, Generated.GetSeriesIdentityQueryVariables> & ({ variables: Generated.GetSeriesIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesIdentityQuery, Generated.GetSeriesIdentityQueryVariables>(GetSeriesIdentityDocument, options);
      }
export function useGetSeriesIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesIdentityQuery, Generated.GetSeriesIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesIdentityQuery, Generated.GetSeriesIdentityQueryVariables>(GetSeriesIdentityDocument, options);
        }
export function useGetSeriesIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesIdentityQuery, Generated.GetSeriesIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesIdentityQuery, Generated.GetSeriesIdentityQueryVariables>(GetSeriesIdentityDocument, options);
        }
export type GetSeriesIdentityQueryHookResult = ReturnType<typeof useGetSeriesIdentityQuery>;
export type GetSeriesIdentityLazyQueryHookResult = ReturnType<typeof useGetSeriesIdentityLazyQuery>;
export type GetSeriesIdentitySuspenseQueryHookResult = ReturnType<typeof useGetSeriesIdentitySuspenseQuery>;
export type GetSeriesIdentityQueryResult = Apollo.QueryResult<Generated.GetSeriesIdentityQuery, Generated.GetSeriesIdentityQueryVariables>;
export const GetSeriesListDocument = /*#__PURE__*/ gql`
    query getSeriesList($limit: Int, $offset: Int!, $search: String, $genres: [Genre!], $orderBy: SeriesOrder, $personId: ID, $brandIds: [ID!], $localeIds: [ID!], $includeBrandsData: Boolean = false, $includeLocalesData: Boolean = false, $brandId: ID!, $includeSeoData: Boolean = false, $searchIn: EntitySearchTypes, $searchSensitivity: EntitySearchOptions) {
  seriesList(
    limit: $limit
    offset: $offset
    search: $search
    genres: $genres
    orderBy: $orderBy
    personId: $personId
    searchIn: $searchIn
    searchSensitivity: $searchSensitivity
  ) {
    totalCount
    nodes {
      __typename
      id
      ref
      title
      activeOnBrands {
        id
        ref
        name
      }
      poster {
        ...Image
      }
      brandsData(brandIds: $brandIds) @include(if: $includeBrandsData) {
        brand {
          ref
        }
        title
      }
      localesData(locales: $localeIds) @include(if: $includeLocalesData) {
        title
      }
      credits(limit: 3, activities: [STORYLINE_CREATOR]) {
        nodes {
          person {
            ref
            firstName
            lastName
          }
        }
      }
      originalPremiere
      status
      metadata {
        ...Metadata
      }
      seoData(brandId: $brandId) @include(if: $includeSeoData) {
        ...SeoData
      }
    }
  }
}
    ${ImageFragmentDoc}
${MetadataFragmentDoc}
${SeoDataFragmentDoc}`;

/**
 * __useGetSeriesListQuery__
 *
 * To run a query within a React component, call `useGetSeriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      genres: // value for 'genres'
 *      orderBy: // value for 'orderBy'
 *      personId: // value for 'personId'
 *      brandIds: // value for 'brandIds'
 *      localeIds: // value for 'localeIds'
 *      includeBrandsData: // value for 'includeBrandsData'
 *      includeLocalesData: // value for 'includeLocalesData'
 *      brandId: // value for 'brandId'
 *      includeSeoData: // value for 'includeSeoData'
 *      searchIn: // value for 'searchIn'
 *      searchSensitivity: // value for 'searchSensitivity'
 *   },
 * });
 */
export function useGetSeriesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesListQuery, Generated.GetSeriesListQueryVariables> & ({ variables: Generated.GetSeriesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesListQuery, Generated.GetSeriesListQueryVariables>(GetSeriesListDocument, options);
      }
export function useGetSeriesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesListQuery, Generated.GetSeriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesListQuery, Generated.GetSeriesListQueryVariables>(GetSeriesListDocument, options);
        }
export function useGetSeriesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesListQuery, Generated.GetSeriesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesListQuery, Generated.GetSeriesListQueryVariables>(GetSeriesListDocument, options);
        }
export type GetSeriesListQueryHookResult = ReturnType<typeof useGetSeriesListQuery>;
export type GetSeriesListLazyQueryHookResult = ReturnType<typeof useGetSeriesListLazyQuery>;
export type GetSeriesListSuspenseQueryHookResult = ReturnType<typeof useGetSeriesListSuspenseQuery>;
export type GetSeriesListQueryResult = Apollo.QueryResult<Generated.GetSeriesListQuery, Generated.GetSeriesListQueryVariables>;
export const GetSeriesPersonCreditsImportDocument = /*#__PURE__*/ gql`
    query getSeriesPersonCreditsImport($id: ID!, $reportId: ID) {
  series(id: $id) {
    id
    personCreditsImport(id: $reportId) {
      ...PersonCreditsImportReport
    }
    personCreditsImports {
      ...PersonCreditsImportReportSummary
    }
  }
}
    ${PersonCreditsImportReportFragmentDoc}
${PersonCreditsImportReportSummaryFragmentDoc}`;

/**
 * __useGetSeriesPersonCreditsImportQuery__
 *
 * To run a query within a React component, call `useGetSeriesPersonCreditsImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesPersonCreditsImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesPersonCreditsImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetSeriesPersonCreditsImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesPersonCreditsImportQuery, Generated.GetSeriesPersonCreditsImportQueryVariables> & ({ variables: Generated.GetSeriesPersonCreditsImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesPersonCreditsImportQuery, Generated.GetSeriesPersonCreditsImportQueryVariables>(GetSeriesPersonCreditsImportDocument, options);
      }
export function useGetSeriesPersonCreditsImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesPersonCreditsImportQuery, Generated.GetSeriesPersonCreditsImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesPersonCreditsImportQuery, Generated.GetSeriesPersonCreditsImportQueryVariables>(GetSeriesPersonCreditsImportDocument, options);
        }
export function useGetSeriesPersonCreditsImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesPersonCreditsImportQuery, Generated.GetSeriesPersonCreditsImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesPersonCreditsImportQuery, Generated.GetSeriesPersonCreditsImportQueryVariables>(GetSeriesPersonCreditsImportDocument, options);
        }
export type GetSeriesPersonCreditsImportQueryHookResult = ReturnType<typeof useGetSeriesPersonCreditsImportQuery>;
export type GetSeriesPersonCreditsImportLazyQueryHookResult = ReturnType<typeof useGetSeriesPersonCreditsImportLazyQuery>;
export type GetSeriesPersonCreditsImportSuspenseQueryHookResult = ReturnType<typeof useGetSeriesPersonCreditsImportSuspenseQuery>;
export type GetSeriesPersonCreditsImportQueryResult = Apollo.QueryResult<Generated.GetSeriesPersonCreditsImportQuery, Generated.GetSeriesPersonCreditsImportQueryVariables>;
export const GetSeriesMetadataDocument = /*#__PURE__*/ gql`
    query getSeriesMetadata($ref: ID!, $brandIds: [ID!], $localeIds: [ID!], $includeBrandData: Boolean = false, $includeLocalesData: Boolean = false) {
  entityByRef(type: SERIES, ref: $ref) {
    __typename
    ... on Series {
      ...SeriesMetadataEntity
    }
  }
}
    ${SeriesMetadataEntityFragmentDoc}`;

/**
 * __useGetSeriesMetadataQuery__
 *
 * To run a query within a React component, call `useGetSeriesMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesMetadataQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      brandIds: // value for 'brandIds'
 *      localeIds: // value for 'localeIds'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocalesData: // value for 'includeLocalesData'
 *   },
 * });
 */
export function useGetSeriesMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesMetadataQuery, Generated.GetSeriesMetadataQueryVariables> & ({ variables: Generated.GetSeriesMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesMetadataQuery, Generated.GetSeriesMetadataQueryVariables>(GetSeriesMetadataDocument, options);
      }
export function useGetSeriesMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesMetadataQuery, Generated.GetSeriesMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesMetadataQuery, Generated.GetSeriesMetadataQueryVariables>(GetSeriesMetadataDocument, options);
        }
export function useGetSeriesMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesMetadataQuery, Generated.GetSeriesMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesMetadataQuery, Generated.GetSeriesMetadataQueryVariables>(GetSeriesMetadataDocument, options);
        }
export type GetSeriesMetadataQueryHookResult = ReturnType<typeof useGetSeriesMetadataQuery>;
export type GetSeriesMetadataLazyQueryHookResult = ReturnType<typeof useGetSeriesMetadataLazyQuery>;
export type GetSeriesMetadataSuspenseQueryHookResult = ReturnType<typeof useGetSeriesMetadataSuspenseQuery>;
export type GetSeriesMetadataQueryResult = Apollo.QueryResult<Generated.GetSeriesMetadataQuery, Generated.GetSeriesMetadataQueryVariables>;
export const GetSeriesSeasonsEpisodesQuickAccessDocument = /*#__PURE__*/ gql`
    query getSeriesSeasonsEpisodesQuickAccess($id: ID!, $seasonsLimit: Int, $subEpisodesLimit: Int) {
  series(id: $id) {
    ...SeriesQuickAccessIdentity
    seasons(limit: $seasonsLimit, offset: 0) {
      totalCount
      nodes {
        ...SeriesSeasonEpisodesQuickAccessRow
      }
    }
    specialEpisodes: episodes(limit: $subEpisodesLimit, offset: 0, filter: ORPHANS) {
      totalCount
      nodes {
        ...EpisodeQuickAccessIdentity
      }
    }
  }
}
    ${SeriesQuickAccessIdentityFragmentDoc}
${SeriesSeasonEpisodesQuickAccessRowFragmentDoc}
${EpisodeQuickAccessIdentityFragmentDoc}`;

/**
 * __useGetSeriesSeasonsEpisodesQuickAccessQuery__
 *
 * To run a query within a React component, call `useGetSeriesSeasonsEpisodesQuickAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesSeasonsEpisodesQuickAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesSeasonsEpisodesQuickAccessQuery({
 *   variables: {
 *      id: // value for 'id'
 *      seasonsLimit: // value for 'seasonsLimit'
 *      subEpisodesLimit: // value for 'subEpisodesLimit'
 *   },
 * });
 */
export function useGetSeriesSeasonsEpisodesQuickAccessQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesSeasonsEpisodesQuickAccessQuery, Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables> & ({ variables: Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesSeasonsEpisodesQuickAccessQuery, Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables>(GetSeriesSeasonsEpisodesQuickAccessDocument, options);
      }
export function useGetSeriesSeasonsEpisodesQuickAccessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesSeasonsEpisodesQuickAccessQuery, Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesSeasonsEpisodesQuickAccessQuery, Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables>(GetSeriesSeasonsEpisodesQuickAccessDocument, options);
        }
export function useGetSeriesSeasonsEpisodesQuickAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesSeasonsEpisodesQuickAccessQuery, Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesSeasonsEpisodesQuickAccessQuery, Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables>(GetSeriesSeasonsEpisodesQuickAccessDocument, options);
        }
export type GetSeriesSeasonsEpisodesQuickAccessQueryHookResult = ReturnType<typeof useGetSeriesSeasonsEpisodesQuickAccessQuery>;
export type GetSeriesSeasonsEpisodesQuickAccessLazyQueryHookResult = ReturnType<typeof useGetSeriesSeasonsEpisodesQuickAccessLazyQuery>;
export type GetSeriesSeasonsEpisodesQuickAccessSuspenseQueryHookResult = ReturnType<typeof useGetSeriesSeasonsEpisodesQuickAccessSuspenseQuery>;
export type GetSeriesSeasonsEpisodesQuickAccessQueryResult = Apollo.QueryResult<Generated.GetSeriesSeasonsEpisodesQuickAccessQuery, Generated.GetSeriesSeasonsEpisodesQuickAccessQueryVariables>;
export const GetSeriesSeasonsDocument = /*#__PURE__*/ gql`
    query getSeriesSeasons($id: ID!, $limit: Int!, $offset: Int!, $brandId: ID!, $seasonNumbers: [NonNegativeInt!], $includeBrandData: Boolean = false) {
  series(id: $id) {
    id
    seasons(limit: $limit, offset: $offset, seasonNumbers: $seasonNumbers) {
      totalCount
      nodes {
        ...SeriesSeasonRow
      }
    }
    episodes(limit: 0) {
      totalCount
    }
  }
}
    ${SeriesSeasonRowFragmentDoc}`;

/**
 * __useGetSeriesSeasonsQuery__
 *
 * To run a query within a React component, call `useGetSeriesSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesSeasonsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      seasonNumbers: // value for 'seasonNumbers'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetSeriesSeasonsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesSeasonsQuery, Generated.GetSeriesSeasonsQueryVariables> & ({ variables: Generated.GetSeriesSeasonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesSeasonsQuery, Generated.GetSeriesSeasonsQueryVariables>(GetSeriesSeasonsDocument, options);
      }
export function useGetSeriesSeasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesSeasonsQuery, Generated.GetSeriesSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesSeasonsQuery, Generated.GetSeriesSeasonsQueryVariables>(GetSeriesSeasonsDocument, options);
        }
export function useGetSeriesSeasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesSeasonsQuery, Generated.GetSeriesSeasonsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesSeasonsQuery, Generated.GetSeriesSeasonsQueryVariables>(GetSeriesSeasonsDocument, options);
        }
export type GetSeriesSeasonsQueryHookResult = ReturnType<typeof useGetSeriesSeasonsQuery>;
export type GetSeriesSeasonsLazyQueryHookResult = ReturnType<typeof useGetSeriesSeasonsLazyQuery>;
export type GetSeriesSeasonsSuspenseQueryHookResult = ReturnType<typeof useGetSeriesSeasonsSuspenseQuery>;
export type GetSeriesSeasonsQueryResult = Apollo.QueryResult<Generated.GetSeriesSeasonsQuery, Generated.GetSeriesSeasonsQueryVariables>;
export const GetSeriesReleaseDocument = /*#__PURE__*/ gql`
    query getSeriesRelease($ref: ID!) {
  releaseByRef(entityType: SERIES, ref: $ref) {
    ...SeriesRelease
    ...SeriesReleaseMetadata
    ...SeriesReleaseNav
  }
}
    ${SeriesReleaseFragmentDoc}
${SeriesReleaseMetadataFragmentDoc}
${SeriesReleaseNavFragmentDoc}`;

/**
 * __useGetSeriesReleaseQuery__
 *
 * To run a query within a React component, call `useGetSeriesReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesReleaseQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSeriesReleaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesReleaseQuery, Generated.GetSeriesReleaseQueryVariables> & ({ variables: Generated.GetSeriesReleaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesReleaseQuery, Generated.GetSeriesReleaseQueryVariables>(GetSeriesReleaseDocument, options);
      }
export function useGetSeriesReleaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesReleaseQuery, Generated.GetSeriesReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesReleaseQuery, Generated.GetSeriesReleaseQueryVariables>(GetSeriesReleaseDocument, options);
        }
export function useGetSeriesReleaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesReleaseQuery, Generated.GetSeriesReleaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesReleaseQuery, Generated.GetSeriesReleaseQueryVariables>(GetSeriesReleaseDocument, options);
        }
export type GetSeriesReleaseQueryHookResult = ReturnType<typeof useGetSeriesReleaseQuery>;
export type GetSeriesReleaseLazyQueryHookResult = ReturnType<typeof useGetSeriesReleaseLazyQuery>;
export type GetSeriesReleaseSuspenseQueryHookResult = ReturnType<typeof useGetSeriesReleaseSuspenseQuery>;
export type GetSeriesReleaseQueryResult = Apollo.QueryResult<Generated.GetSeriesReleaseQuery, Generated.GetSeriesReleaseQueryVariables>;
export const GetSeriesSeasonsEpisodesDocument = /*#__PURE__*/ gql`
    query getSeriesSeasonsEpisodes($id: ID!, $limit: Int, $offset: Int, $brandId: ID!, $includeBrandData: Boolean = false) {
  series(id: $id) {
    id
    ...SeasonFromSeries
    ...EpisodeFromSeries
  }
}
    ${SeasonFromSeriesFragmentDoc}
${EpisodeFromSeriesFragmentDoc}`;

/**
 * __useGetSeriesSeasonsEpisodesQuery__
 *
 * To run a query within a React component, call `useGetSeriesSeasonsEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesSeasonsEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesSeasonsEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useGetSeriesSeasonsEpisodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesSeasonsEpisodesQuery, Generated.GetSeriesSeasonsEpisodesQueryVariables> & ({ variables: Generated.GetSeriesSeasonsEpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesSeasonsEpisodesQuery, Generated.GetSeriesSeasonsEpisodesQueryVariables>(GetSeriesSeasonsEpisodesDocument, options);
      }
export function useGetSeriesSeasonsEpisodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesSeasonsEpisodesQuery, Generated.GetSeriesSeasonsEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesSeasonsEpisodesQuery, Generated.GetSeriesSeasonsEpisodesQueryVariables>(GetSeriesSeasonsEpisodesDocument, options);
        }
export function useGetSeriesSeasonsEpisodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesSeasonsEpisodesQuery, Generated.GetSeriesSeasonsEpisodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesSeasonsEpisodesQuery, Generated.GetSeriesSeasonsEpisodesQueryVariables>(GetSeriesSeasonsEpisodesDocument, options);
        }
export type GetSeriesSeasonsEpisodesQueryHookResult = ReturnType<typeof useGetSeriesSeasonsEpisodesQuery>;
export type GetSeriesSeasonsEpisodesLazyQueryHookResult = ReturnType<typeof useGetSeriesSeasonsEpisodesLazyQuery>;
export type GetSeriesSeasonsEpisodesSuspenseQueryHookResult = ReturnType<typeof useGetSeriesSeasonsEpisodesSuspenseQuery>;
export type GetSeriesSeasonsEpisodesQueryResult = Apollo.QueryResult<Generated.GetSeriesSeasonsEpisodesQuery, Generated.GetSeriesSeasonsEpisodesQueryVariables>;
export const GetSeriesTagsDocument = /*#__PURE__*/ gql`
    query getSeriesTags($seriesId: ID!, $brandId: ID!) {
  series(id: $seriesId) {
    id
    tags(limit: 1000, brandId: $brandId) {
      nodes {
        ...EntityTag
      }
    }
  }
}
    ${EntityTagFragmentDoc}`;

/**
 * __useGetSeriesTagsQuery__
 *
 * To run a query within a React component, call `useGetSeriesTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesTagsQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetSeriesTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesTagsQuery, Generated.GetSeriesTagsQueryVariables> & ({ variables: Generated.GetSeriesTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesTagsQuery, Generated.GetSeriesTagsQueryVariables>(GetSeriesTagsDocument, options);
      }
export function useGetSeriesTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesTagsQuery, Generated.GetSeriesTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesTagsQuery, Generated.GetSeriesTagsQueryVariables>(GetSeriesTagsDocument, options);
        }
export function useGetSeriesTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesTagsQuery, Generated.GetSeriesTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesTagsQuery, Generated.GetSeriesTagsQueryVariables>(GetSeriesTagsDocument, options);
        }
export type GetSeriesTagsQueryHookResult = ReturnType<typeof useGetSeriesTagsQuery>;
export type GetSeriesTagsLazyQueryHookResult = ReturnType<typeof useGetSeriesTagsLazyQuery>;
export type GetSeriesTagsSuspenseQueryHookResult = ReturnType<typeof useGetSeriesTagsSuspenseQuery>;
export type GetSeriesTagsQueryResult = Apollo.QueryResult<Generated.GetSeriesTagsQuery, Generated.GetSeriesTagsQueryVariables>;
export const GetSeriesTitleByRefDocument = /*#__PURE__*/ gql`
    query getSeriesTitleByRef($ref: ID!) {
  entityByRef(type: SERIES, ref: $ref) {
    __typename
    ... on Series {
      id
      title
    }
  }
}
    `;

/**
 * __useGetSeriesTitleByRefQuery__
 *
 * To run a query within a React component, call `useGetSeriesTitleByRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesTitleByRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesTitleByRefQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSeriesTitleByRefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesTitleByRefQuery, Generated.GetSeriesTitleByRefQueryVariables> & ({ variables: Generated.GetSeriesTitleByRefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesTitleByRefQuery, Generated.GetSeriesTitleByRefQueryVariables>(GetSeriesTitleByRefDocument, options);
      }
export function useGetSeriesTitleByRefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesTitleByRefQuery, Generated.GetSeriesTitleByRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesTitleByRefQuery, Generated.GetSeriesTitleByRefQueryVariables>(GetSeriesTitleByRefDocument, options);
        }
export function useGetSeriesTitleByRefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesTitleByRefQuery, Generated.GetSeriesTitleByRefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesTitleByRefQuery, Generated.GetSeriesTitleByRefQueryVariables>(GetSeriesTitleByRefDocument, options);
        }
export type GetSeriesTitleByRefQueryHookResult = ReturnType<typeof useGetSeriesTitleByRefQuery>;
export type GetSeriesTitleByRefLazyQueryHookResult = ReturnType<typeof useGetSeriesTitleByRefLazyQuery>;
export type GetSeriesTitleByRefSuspenseQueryHookResult = ReturnType<typeof useGetSeriesTitleByRefSuspenseQuery>;
export type GetSeriesTitleByRefQueryResult = Apollo.QueryResult<Generated.GetSeriesTitleByRefQuery, Generated.GetSeriesTitleByRefQueryVariables>;
export const SearchSeriesSeasonDocument = /*#__PURE__*/ gql`
    query SearchSeriesSeason($search: String, $limit: Int, $offset: Int!, $brandId: ID!, $includeBrandData: Boolean!, $entityType: [SearchableEntityType!], $options: SearchOptionsInput) {
  searchEntities(
    search: $search
    brandId: $brandId
    limit: $limit
    offset: $offset
    entityType: $entityType
    options: $options
  ) {
    totalCount
    nodes {
      __typename
      ... on Series {
        ...SeriesSearchEntity
      }
      ... on SeriesSeason {
        ...SeriesSeasonSearchEntity
        ...SearchSeriesSeason
      }
      ... on SeriesEpisode {
        ...SeriesEpisodeSearchEntity
      }
    }
  }
}
    ${SeriesSearchEntityFragmentDoc}
${SeriesSeasonSearchEntityFragmentDoc}
${SearchSeriesSeasonFragmentDoc}
${SeriesEpisodeSearchEntityFragmentDoc}`;

/**
 * __useSearchSeriesSeasonQuery__
 *
 * To run a query within a React component, call `useSearchSeriesSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSeriesSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSeriesSeasonQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      entityType: // value for 'entityType'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchSeriesSeasonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchSeriesSeasonQuery, Generated.SearchSeriesSeasonQueryVariables> & ({ variables: Generated.SearchSeriesSeasonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchSeriesSeasonQuery, Generated.SearchSeriesSeasonQueryVariables>(SearchSeriesSeasonDocument, options);
      }
export function useSearchSeriesSeasonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchSeriesSeasonQuery, Generated.SearchSeriesSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchSeriesSeasonQuery, Generated.SearchSeriesSeasonQueryVariables>(SearchSeriesSeasonDocument, options);
        }
export function useSearchSeriesSeasonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchSeriesSeasonQuery, Generated.SearchSeriesSeasonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchSeriesSeasonQuery, Generated.SearchSeriesSeasonQueryVariables>(SearchSeriesSeasonDocument, options);
        }
export type SearchSeriesSeasonQueryHookResult = ReturnType<typeof useSearchSeriesSeasonQuery>;
export type SearchSeriesSeasonLazyQueryHookResult = ReturnType<typeof useSearchSeriesSeasonLazyQuery>;
export type SearchSeriesSeasonSuspenseQueryHookResult = ReturnType<typeof useSearchSeriesSeasonSuspenseQuery>;
export type SearchSeriesSeasonQueryResult = Apollo.QueryResult<Generated.SearchSeriesSeasonQuery, Generated.SearchSeriesSeasonQueryVariables>;
export const GetSeriesTriviasDocument = /*#__PURE__*/ gql`
    query getSeriesTrivias($id: ID!, $limit: Int, $offset: Int!, $brandId: ID!) {
  series(id: $id) {
    id
    trivias(limit: $limit, offset: $offset, brandId: $brandId) {
      totalCount
      nodes {
        ...EntityTrivia
      }
    }
  }
}
    ${EntityTriviaFragmentDoc}`;

/**
 * __useGetSeriesTriviasQuery__
 *
 * To run a query within a React component, call `useGetSeriesTriviasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesTriviasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesTriviasQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetSeriesTriviasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSeriesTriviasQuery, Generated.GetSeriesTriviasQueryVariables> & ({ variables: Generated.GetSeriesTriviasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSeriesTriviasQuery, Generated.GetSeriesTriviasQueryVariables>(GetSeriesTriviasDocument, options);
      }
export function useGetSeriesTriviasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSeriesTriviasQuery, Generated.GetSeriesTriviasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSeriesTriviasQuery, Generated.GetSeriesTriviasQueryVariables>(GetSeriesTriviasDocument, options);
        }
export function useGetSeriesTriviasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSeriesTriviasQuery, Generated.GetSeriesTriviasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSeriesTriviasQuery, Generated.GetSeriesTriviasQueryVariables>(GetSeriesTriviasDocument, options);
        }
export type GetSeriesTriviasQueryHookResult = ReturnType<typeof useGetSeriesTriviasQuery>;
export type GetSeriesTriviasLazyQueryHookResult = ReturnType<typeof useGetSeriesTriviasLazyQuery>;
export type GetSeriesTriviasSuspenseQueryHookResult = ReturnType<typeof useGetSeriesTriviasSuspenseQuery>;
export type GetSeriesTriviasQueryResult = Apollo.QueryResult<Generated.GetSeriesTriviasQuery, Generated.GetSeriesTriviasQueryVariables>;
export const UpdateEpisodeReleaseDocument = /*#__PURE__*/ gql`
    mutation updateEpisodeRelease($input: UpdateReleaseInput!) {
  updateRelease(input: $input) {
    ...EpisodeRelease
  }
}
    ${EpisodeReleaseFragmentDoc}`;
export type UpdateEpisodeReleaseMutationFn = Apollo.MutationFunction<Generated.UpdateEpisodeReleaseMutation, Generated.UpdateEpisodeReleaseMutationVariables>;

/**
 * __useUpdateEpisodeReleaseMutation__
 *
 * To run a mutation, you first call `useUpdateEpisodeReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpisodeReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpisodeReleaseMutation, { data, loading, error }] = useUpdateEpisodeReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEpisodeReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEpisodeReleaseMutation, Generated.UpdateEpisodeReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEpisodeReleaseMutation, Generated.UpdateEpisodeReleaseMutationVariables>(UpdateEpisodeReleaseDocument, options);
      }
export type UpdateEpisodeReleaseMutationHookResult = ReturnType<typeof useUpdateEpisodeReleaseMutation>;
export type UpdateEpisodeReleaseMutationResult = Apollo.MutationResult<Generated.UpdateEpisodeReleaseMutation>;
export type UpdateEpisodeReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEpisodeReleaseMutation, Generated.UpdateEpisodeReleaseMutationVariables>;
export const UpdateSeriesSeasonBrandDataDocument = /*#__PURE__*/ gql`
    mutation updateSeriesSeasonBrandData($input: UpdateSeriesSeasonBrandDataInput!) {
  updateSeriesSeasonBrandData(input: $input) {
    id
    synopsis
    poster {
      id
      url
    }
    ruling {
      hasRating
      atRisk
      hasWarningMessage
      hasMandatoryReview
    }
  }
}
    `;
export type UpdateSeriesSeasonBrandDataMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesSeasonBrandDataMutation, Generated.UpdateSeriesSeasonBrandDataMutationVariables>;

/**
 * __useUpdateSeriesSeasonBrandDataMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesSeasonBrandDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesSeasonBrandDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesSeasonBrandDataMutation, { data, loading, error }] = useUpdateSeriesSeasonBrandDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesSeasonBrandDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesSeasonBrandDataMutation, Generated.UpdateSeriesSeasonBrandDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesSeasonBrandDataMutation, Generated.UpdateSeriesSeasonBrandDataMutationVariables>(UpdateSeriesSeasonBrandDataDocument, options);
      }
export type UpdateSeriesSeasonBrandDataMutationHookResult = ReturnType<typeof useUpdateSeriesSeasonBrandDataMutation>;
export type UpdateSeriesSeasonBrandDataMutationResult = Apollo.MutationResult<Generated.UpdateSeriesSeasonBrandDataMutation>;
export type UpdateSeriesSeasonBrandDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesSeasonBrandDataMutation, Generated.UpdateSeriesSeasonBrandDataMutationVariables>;
export const UpdateSeriesEpisodeBrandDataDocument = /*#__PURE__*/ gql`
    mutation updateSeriesEpisodeBrandData($input: UpdateSeriesEpisodeBrandDataInput!) {
  updateSeriesEpisodeBrandData(input: $input) {
    synopsis
    title
    ruling {
      hasRating
      atRisk
      hasWarningMessage
      hasMandatoryReview
    }
  }
}
    `;
export type UpdateSeriesEpisodeBrandDataMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesEpisodeBrandDataMutation, Generated.UpdateSeriesEpisodeBrandDataMutationVariables>;

/**
 * __useUpdateSeriesEpisodeBrandDataMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesEpisodeBrandDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesEpisodeBrandDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesEpisodeBrandDataMutation, { data, loading, error }] = useUpdateSeriesEpisodeBrandDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesEpisodeBrandDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesEpisodeBrandDataMutation, Generated.UpdateSeriesEpisodeBrandDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesEpisodeBrandDataMutation, Generated.UpdateSeriesEpisodeBrandDataMutationVariables>(UpdateSeriesEpisodeBrandDataDocument, options);
      }
export type UpdateSeriesEpisodeBrandDataMutationHookResult = ReturnType<typeof useUpdateSeriesEpisodeBrandDataMutation>;
export type UpdateSeriesEpisodeBrandDataMutationResult = Apollo.MutationResult<Generated.UpdateSeriesEpisodeBrandDataMutation>;
export type UpdateSeriesEpisodeBrandDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesEpisodeBrandDataMutation, Generated.UpdateSeriesEpisodeBrandDataMutationVariables>;
export const UpdateSeasonReleaseDocument = /*#__PURE__*/ gql`
    mutation updateSeasonRelease($input: UpdateReleaseInput!) {
  updateRelease(input: $input) {
    ...SeasonRelease
  }
}
    ${SeasonReleaseFragmentDoc}`;
export type UpdateSeasonReleaseMutationFn = Apollo.MutationFunction<Generated.UpdateSeasonReleaseMutation, Generated.UpdateSeasonReleaseMutationVariables>;

/**
 * __useUpdateSeasonReleaseMutation__
 *
 * To run a mutation, you first call `useUpdateSeasonReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeasonReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeasonReleaseMutation, { data, loading, error }] = useUpdateSeasonReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeasonReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeasonReleaseMutation, Generated.UpdateSeasonReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeasonReleaseMutation, Generated.UpdateSeasonReleaseMutationVariables>(UpdateSeasonReleaseDocument, options);
      }
export type UpdateSeasonReleaseMutationHookResult = ReturnType<typeof useUpdateSeasonReleaseMutation>;
export type UpdateSeasonReleaseMutationResult = Apollo.MutationResult<Generated.UpdateSeasonReleaseMutation>;
export type UpdateSeasonReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeasonReleaseMutation, Generated.UpdateSeasonReleaseMutationVariables>;
export const UpdateSeriesSeasonDocument = /*#__PURE__*/ gql`
    mutation updateSeriesSeason($input: UpdateSeriesSeasonInput!) {
  updateSeriesSeason(input: $input) {
    id
    ...SeasonMetadata
    ...SeasonIdentity
  }
}
    ${SeasonMetadataFragmentDoc}
${SeasonIdentityFragmentDoc}`;
export type UpdateSeriesSeasonMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesSeasonMutation, Generated.UpdateSeriesSeasonMutationVariables>;

/**
 * __useUpdateSeriesSeasonMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesSeasonMutation, { data, loading, error }] = useUpdateSeriesSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesSeasonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesSeasonMutation, Generated.UpdateSeriesSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesSeasonMutation, Generated.UpdateSeriesSeasonMutationVariables>(UpdateSeriesSeasonDocument, options);
      }
export type UpdateSeriesSeasonMutationHookResult = ReturnType<typeof useUpdateSeriesSeasonMutation>;
export type UpdateSeriesSeasonMutationResult = Apollo.MutationResult<Generated.UpdateSeriesSeasonMutation>;
export type UpdateSeriesSeasonMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesSeasonMutation, Generated.UpdateSeriesSeasonMutationVariables>;
export const UpdateSeriesAdditionalInfoDocument = /*#__PURE__*/ gql`
    mutation updateSeriesAdditionalInfo($input: UpdateSeriesInput!) {
  updateSeries(input: $input) {
    id
    ...SeriesMetadata
    ...SeriesAdditionalInfo
  }
}
    ${SeriesMetadataFragmentDoc}
${SeriesAdditionalInfoFragmentDoc}`;
export type UpdateSeriesAdditionalInfoMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesAdditionalInfoMutation, Generated.UpdateSeriesAdditionalInfoMutationVariables>;

/**
 * __useUpdateSeriesAdditionalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesAdditionalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesAdditionalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesAdditionalInfoMutation, { data, loading, error }] = useUpdateSeriesAdditionalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesAdditionalInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesAdditionalInfoMutation, Generated.UpdateSeriesAdditionalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesAdditionalInfoMutation, Generated.UpdateSeriesAdditionalInfoMutationVariables>(UpdateSeriesAdditionalInfoDocument, options);
      }
export type UpdateSeriesAdditionalInfoMutationHookResult = ReturnType<typeof useUpdateSeriesAdditionalInfoMutation>;
export type UpdateSeriesAdditionalInfoMutationResult = Apollo.MutationResult<Generated.UpdateSeriesAdditionalInfoMutation>;
export type UpdateSeriesAdditionalInfoMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesAdditionalInfoMutation, Generated.UpdateSeriesAdditionalInfoMutationVariables>;
export const UpdateSeriesReleaseDocument = /*#__PURE__*/ gql`
    mutation updateSeriesRelease($input: UpdateReleaseInput!) {
  updateRelease(input: $input) {
    ...SeriesRelease
  }
}
    ${SeriesReleaseFragmentDoc}`;
export type UpdateSeriesReleaseMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesReleaseMutation, Generated.UpdateSeriesReleaseMutationVariables>;

/**
 * __useUpdateSeriesReleaseMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesReleaseMutation, { data, loading, error }] = useUpdateSeriesReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesReleaseMutation, Generated.UpdateSeriesReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesReleaseMutation, Generated.UpdateSeriesReleaseMutationVariables>(UpdateSeriesReleaseDocument, options);
      }
export type UpdateSeriesReleaseMutationHookResult = ReturnType<typeof useUpdateSeriesReleaseMutation>;
export type UpdateSeriesReleaseMutationResult = Apollo.MutationResult<Generated.UpdateSeriesReleaseMutation>;
export type UpdateSeriesReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesReleaseMutation, Generated.UpdateSeriesReleaseMutationVariables>;
export const UpdateSeriesBrandedDataDocument = /*#__PURE__*/ gql`
    mutation updateSeriesBrandedData($input: UpdateSeriesBrandDataInput!) {
  updateSeriesBrandData(input: $input) {
    id
    title
    keywords
    synopsis
    synopsisShort
    poster {
      id
      url
    }
    ruling {
      hasRating
      atRisk
      hasWarningMessage
      hasMandatoryReview
    }
  }
}
    `;
export type UpdateSeriesBrandedDataMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesBrandedDataMutation, Generated.UpdateSeriesBrandedDataMutationVariables>;

/**
 * __useUpdateSeriesBrandedDataMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesBrandedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesBrandedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesBrandedDataMutation, { data, loading, error }] = useUpdateSeriesBrandedDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesBrandedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesBrandedDataMutation, Generated.UpdateSeriesBrandedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesBrandedDataMutation, Generated.UpdateSeriesBrandedDataMutationVariables>(UpdateSeriesBrandedDataDocument, options);
      }
export type UpdateSeriesBrandedDataMutationHookResult = ReturnType<typeof useUpdateSeriesBrandedDataMutation>;
export type UpdateSeriesBrandedDataMutationResult = Apollo.MutationResult<Generated.UpdateSeriesBrandedDataMutation>;
export type UpdateSeriesBrandedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesBrandedDataMutation, Generated.UpdateSeriesBrandedDataMutationVariables>;
export const UpdateSeriesEpisodeDocument = /*#__PURE__*/ gql`
    mutation updateSeriesEpisode($input: UpdateSeriesEpisodeInput!) {
  updateSeriesEpisode(input: $input) {
    id
    ...EpisodeMetadata
    ...EpisodeIdentity
  }
}
    ${EpisodeMetadataFragmentDoc}
${EpisodeIdentityFragmentDoc}`;
export type UpdateSeriesEpisodeMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesEpisodeMutation, Generated.UpdateSeriesEpisodeMutationVariables>;

/**
 * __useUpdateSeriesEpisodeMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesEpisodeMutation, { data, loading, error }] = useUpdateSeriesEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesEpisodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesEpisodeMutation, Generated.UpdateSeriesEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesEpisodeMutation, Generated.UpdateSeriesEpisodeMutationVariables>(UpdateSeriesEpisodeDocument, options);
      }
export type UpdateSeriesEpisodeMutationHookResult = ReturnType<typeof useUpdateSeriesEpisodeMutation>;
export type UpdateSeriesEpisodeMutationResult = Apollo.MutationResult<Generated.UpdateSeriesEpisodeMutation>;
export type UpdateSeriesEpisodeMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesEpisodeMutation, Generated.UpdateSeriesEpisodeMutationVariables>;
export const UpdateSeriesDocument = /*#__PURE__*/ gql`
    mutation updateSeries($input: UpdateSeriesInput!) {
  updateSeries(input: $input) {
    id
    ...SeriesMetadata
    ...SeriesIdentity
  }
}
    ${SeriesMetadataFragmentDoc}
${SeriesIdentityFragmentDoc}`;
export type UpdateSeriesMutationFn = Apollo.MutationFunction<Generated.UpdateSeriesMutation, Generated.UpdateSeriesMutationVariables>;

/**
 * __useUpdateSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesMutation, { data, loading, error }] = useUpdateSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSeriesMutation, Generated.UpdateSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSeriesMutation, Generated.UpdateSeriesMutationVariables>(UpdateSeriesDocument, options);
      }
export type UpdateSeriesMutationHookResult = ReturnType<typeof useUpdateSeriesMutation>;
export type UpdateSeriesMutationResult = Apollo.MutationResult<Generated.UpdateSeriesMutation>;
export type UpdateSeriesMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSeriesMutation, Generated.UpdateSeriesMutationVariables>;
export const BrandOptionsDocument = /*#__PURE__*/ gql`
    query BrandOptions {
  brands {
    ...BrandOption
  }
}
    ${BrandOptionFragmentDoc}`;

/**
 * __useBrandOptionsQuery__
 *
 * To run a query within a React component, call `useBrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.BrandOptionsQuery, Generated.BrandOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.BrandOptionsQuery, Generated.BrandOptionsQueryVariables>(BrandOptionsDocument, options);
      }
export function useBrandOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.BrandOptionsQuery, Generated.BrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.BrandOptionsQuery, Generated.BrandOptionsQueryVariables>(BrandOptionsDocument, options);
        }
export function useBrandOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.BrandOptionsQuery, Generated.BrandOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.BrandOptionsQuery, Generated.BrandOptionsQueryVariables>(BrandOptionsDocument, options);
        }
export type BrandOptionsQueryHookResult = ReturnType<typeof useBrandOptionsQuery>;
export type BrandOptionsLazyQueryHookResult = ReturnType<typeof useBrandOptionsLazyQuery>;
export type BrandOptionsSuspenseQueryHookResult = ReturnType<typeof useBrandOptionsSuspenseQuery>;
export type BrandOptionsQueryResult = Apollo.QueryResult<Generated.BrandOptionsQuery, Generated.BrandOptionsQueryVariables>;
export const AddCompanyToEntityDocument = /*#__PURE__*/ gql`
    mutation addCompanyToEntity($input: AddCompanyToEntityInput!) {
  addCompanyToEntity(input: $input) {
    id
  }
}
    `;
export type AddCompanyToEntityMutationFn = Apollo.MutationFunction<Generated.AddCompanyToEntityMutation, Generated.AddCompanyToEntityMutationVariables>;

/**
 * __useAddCompanyToEntityMutation__
 *
 * To run a mutation, you first call `useAddCompanyToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyToEntityMutation, { data, loading, error }] = useAddCompanyToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddCompanyToEntityMutation, Generated.AddCompanyToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddCompanyToEntityMutation, Generated.AddCompanyToEntityMutationVariables>(AddCompanyToEntityDocument, options);
      }
export type AddCompanyToEntityMutationHookResult = ReturnType<typeof useAddCompanyToEntityMutation>;
export type AddCompanyToEntityMutationResult = Apollo.MutationResult<Generated.AddCompanyToEntityMutation>;
export type AddCompanyToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.AddCompanyToEntityMutation, Generated.AddCompanyToEntityMutationVariables>;
export const AddActorToEntityDocument = /*#__PURE__*/ gql`
    mutation addActorToEntity($input: AddActorToEntityInput!) {
  addActorToEntity(input: $input) {
    id
  }
}
    `;
export type AddActorToEntityMutationFn = Apollo.MutationFunction<Generated.AddActorToEntityMutation, Generated.AddActorToEntityMutationVariables>;

/**
 * __useAddActorToEntityMutation__
 *
 * To run a mutation, you first call `useAddActorToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActorToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActorToEntityMutation, { data, loading, error }] = useAddActorToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActorToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddActorToEntityMutation, Generated.AddActorToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddActorToEntityMutation, Generated.AddActorToEntityMutationVariables>(AddActorToEntityDocument, options);
      }
export type AddActorToEntityMutationHookResult = ReturnType<typeof useAddActorToEntityMutation>;
export type AddActorToEntityMutationResult = Apollo.MutationResult<Generated.AddActorToEntityMutation>;
export type AddActorToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.AddActorToEntityMutation, Generated.AddActorToEntityMutationVariables>;
export const AddCreditsToEntityDocument = /*#__PURE__*/ gql`
    mutation addCreditsToEntity($input: AddCreditsToEntityInput!) {
  addCreditsToEntity(input: $input) {
    id
  }
}
    `;
export type AddCreditsToEntityMutationFn = Apollo.MutationFunction<Generated.AddCreditsToEntityMutation, Generated.AddCreditsToEntityMutationVariables>;

/**
 * __useAddCreditsToEntityMutation__
 *
 * To run a mutation, you first call `useAddCreditsToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditsToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditsToEntityMutation, { data, loading, error }] = useAddCreditsToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCreditsToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddCreditsToEntityMutation, Generated.AddCreditsToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddCreditsToEntityMutation, Generated.AddCreditsToEntityMutationVariables>(AddCreditsToEntityDocument, options);
      }
export type AddCreditsToEntityMutationHookResult = ReturnType<typeof useAddCreditsToEntityMutation>;
export type AddCreditsToEntityMutationResult = Apollo.MutationResult<Generated.AddCreditsToEntityMutation>;
export type AddCreditsToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.AddCreditsToEntityMutation, Generated.AddCreditsToEntityMutationVariables>;
export const AddEntityToTagDocument = /*#__PURE__*/ gql`
    mutation addEntityToTag($input: AddEntityToTagInput!) {
  addEntityToTag(input: $input) {
    id
    ...EntityTag
  }
}
    ${EntityTagFragmentDoc}`;
export type AddEntityToTagMutationFn = Apollo.MutationFunction<Generated.AddEntityToTagMutation, Generated.AddEntityToTagMutationVariables>;

/**
 * __useAddEntityToTagMutation__
 *
 * To run a mutation, you first call `useAddEntityToTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEntityToTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEntityToTagMutation, { data, loading, error }] = useAddEntityToTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEntityToTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddEntityToTagMutation, Generated.AddEntityToTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddEntityToTagMutation, Generated.AddEntityToTagMutationVariables>(AddEntityToTagDocument, options);
      }
export type AddEntityToTagMutationHookResult = ReturnType<typeof useAddEntityToTagMutation>;
export type AddEntityToTagMutationResult = Apollo.MutationResult<Generated.AddEntityToTagMutation>;
export type AddEntityToTagMutationOptions = Apollo.BaseMutationOptions<Generated.AddEntityToTagMutation, Generated.AddEntityToTagMutationVariables>;
export const AddTriviaToEntityDocument = /*#__PURE__*/ gql`
    mutation addTriviaToEntity($input: AddTriviaToEntityInput!) {
  addTriviaToEntity(input: $input) {
    id
    ...EntityTrivia
  }
}
    ${EntityTriviaFragmentDoc}`;
export type AddTriviaToEntityMutationFn = Apollo.MutationFunction<Generated.AddTriviaToEntityMutation, Generated.AddTriviaToEntityMutationVariables>;

/**
 * __useAddTriviaToEntityMutation__
 *
 * To run a mutation, you first call `useAddTriviaToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTriviaToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTriviaToEntityMutation, { data, loading, error }] = useAddTriviaToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTriviaToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddTriviaToEntityMutation, Generated.AddTriviaToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddTriviaToEntityMutation, Generated.AddTriviaToEntityMutationVariables>(AddTriviaToEntityDocument, options);
      }
export type AddTriviaToEntityMutationHookResult = ReturnType<typeof useAddTriviaToEntityMutation>;
export type AddTriviaToEntityMutationResult = Apollo.MutationResult<Generated.AddTriviaToEntityMutation>;
export type AddTriviaToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.AddTriviaToEntityMutation, Generated.AddTriviaToEntityMutationVariables>;
export const AddCreditToEntityDocument = /*#__PURE__*/ gql`
    mutation addCreditToEntity($input: AddCreditToEntityInput!) {
  addCreditToEntity(input: $input) {
    id
  }
}
    `;
export type AddCreditToEntityMutationFn = Apollo.MutationFunction<Generated.AddCreditToEntityMutation, Generated.AddCreditToEntityMutationVariables>;

/**
 * __useAddCreditToEntityMutation__
 *
 * To run a mutation, you first call `useAddCreditToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditToEntityMutation, { data, loading, error }] = useAddCreditToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCreditToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddCreditToEntityMutation, Generated.AddCreditToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddCreditToEntityMutation, Generated.AddCreditToEntityMutationVariables>(AddCreditToEntityDocument, options);
      }
export type AddCreditToEntityMutationHookResult = ReturnType<typeof useAddCreditToEntityMutation>;
export type AddCreditToEntityMutationResult = Apollo.MutationResult<Generated.AddCreditToEntityMutation>;
export type AddCreditToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.AddCreditToEntityMutation, Generated.AddCreditToEntityMutationVariables>;
export const AddLocalizedActorToEntityDocument = /*#__PURE__*/ gql`
    mutation addLocalizedActorToEntity($input: AddLocalizedActorToEntityInput!) {
  addLocalizedActorToEntity(input: $input) {
    id
  }
}
    `;
export type AddLocalizedActorToEntityMutationFn = Apollo.MutationFunction<Generated.AddLocalizedActorToEntityMutation, Generated.AddLocalizedActorToEntityMutationVariables>;

/**
 * __useAddLocalizedActorToEntityMutation__
 *
 * To run a mutation, you first call `useAddLocalizedActorToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocalizedActorToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocalizedActorToEntityMutation, { data, loading, error }] = useAddLocalizedActorToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLocalizedActorToEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddLocalizedActorToEntityMutation, Generated.AddLocalizedActorToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddLocalizedActorToEntityMutation, Generated.AddLocalizedActorToEntityMutationVariables>(AddLocalizedActorToEntityDocument, options);
      }
export type AddLocalizedActorToEntityMutationHookResult = ReturnType<typeof useAddLocalizedActorToEntityMutation>;
export type AddLocalizedActorToEntityMutationResult = Apollo.MutationResult<Generated.AddLocalizedActorToEntityMutation>;
export type AddLocalizedActorToEntityMutationOptions = Apollo.BaseMutationOptions<Generated.AddLocalizedActorToEntityMutation, Generated.AddLocalizedActorToEntityMutationVariables>;
export const AllowedBrandOptionsDocument = /*#__PURE__*/ gql`
    query AllowedBrandOptions($id: ID!) {
  user(id: $id) {
    id
    allowedBrands {
      ...BrandOption
    }
  }
}
    ${BrandOptionFragmentDoc}`;

/**
 * __useAllowedBrandOptionsQuery__
 *
 * To run a query within a React component, call `useAllowedBrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedBrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedBrandOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllowedBrandOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.AllowedBrandOptionsQuery, Generated.AllowedBrandOptionsQueryVariables> & ({ variables: Generated.AllowedBrandOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.AllowedBrandOptionsQuery, Generated.AllowedBrandOptionsQueryVariables>(AllowedBrandOptionsDocument, options);
      }
export function useAllowedBrandOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.AllowedBrandOptionsQuery, Generated.AllowedBrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.AllowedBrandOptionsQuery, Generated.AllowedBrandOptionsQueryVariables>(AllowedBrandOptionsDocument, options);
        }
export function useAllowedBrandOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.AllowedBrandOptionsQuery, Generated.AllowedBrandOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.AllowedBrandOptionsQuery, Generated.AllowedBrandOptionsQueryVariables>(AllowedBrandOptionsDocument, options);
        }
export type AllowedBrandOptionsQueryHookResult = ReturnType<typeof useAllowedBrandOptionsQuery>;
export type AllowedBrandOptionsLazyQueryHookResult = ReturnType<typeof useAllowedBrandOptionsLazyQuery>;
export type AllowedBrandOptionsSuspenseQueryHookResult = ReturnType<typeof useAllowedBrandOptionsSuspenseQuery>;
export type AllowedBrandOptionsQueryResult = Apollo.QueryResult<Generated.AllowedBrandOptionsQuery, Generated.AllowedBrandOptionsQueryVariables>;
export const AllowedViewerBrandOptionsDocument = /*#__PURE__*/ gql`
    query AllowedViewerBrandOptions {
  brands {
    ...BrandOption
  }
  viewer {
    id
    allowedBrands {
      ...BrandOption
    }
  }
}
    ${BrandOptionFragmentDoc}`;

/**
 * __useAllowedViewerBrandOptionsQuery__
 *
 * To run a query within a React component, call `useAllowedViewerBrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedViewerBrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedViewerBrandOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowedViewerBrandOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.AllowedViewerBrandOptionsQuery, Generated.AllowedViewerBrandOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.AllowedViewerBrandOptionsQuery, Generated.AllowedViewerBrandOptionsQueryVariables>(AllowedViewerBrandOptionsDocument, options);
      }
export function useAllowedViewerBrandOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.AllowedViewerBrandOptionsQuery, Generated.AllowedViewerBrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.AllowedViewerBrandOptionsQuery, Generated.AllowedViewerBrandOptionsQueryVariables>(AllowedViewerBrandOptionsDocument, options);
        }
export function useAllowedViewerBrandOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.AllowedViewerBrandOptionsQuery, Generated.AllowedViewerBrandOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.AllowedViewerBrandOptionsQuery, Generated.AllowedViewerBrandOptionsQueryVariables>(AllowedViewerBrandOptionsDocument, options);
        }
export type AllowedViewerBrandOptionsQueryHookResult = ReturnType<typeof useAllowedViewerBrandOptionsQuery>;
export type AllowedViewerBrandOptionsLazyQueryHookResult = ReturnType<typeof useAllowedViewerBrandOptionsLazyQuery>;
export type AllowedViewerBrandOptionsSuspenseQueryHookResult = ReturnType<typeof useAllowedViewerBrandOptionsSuspenseQuery>;
export type AllowedViewerBrandOptionsQueryResult = Apollo.QueryResult<Generated.AllowedViewerBrandOptionsQuery, Generated.AllowedViewerBrandOptionsQueryVariables>;
export const AllowedCountryOptionsDocument = /*#__PURE__*/ gql`
    query AllowedCountryOptions($id: ID!) {
  user(id: $id) {
    allowedCountries {
      ...CountryOption
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useAllowedCountryOptionsQuery__
 *
 * To run a query within a React component, call `useAllowedCountryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedCountryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedCountryOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllowedCountryOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.AllowedCountryOptionsQuery, Generated.AllowedCountryOptionsQueryVariables> & ({ variables: Generated.AllowedCountryOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.AllowedCountryOptionsQuery, Generated.AllowedCountryOptionsQueryVariables>(AllowedCountryOptionsDocument, options);
      }
export function useAllowedCountryOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.AllowedCountryOptionsQuery, Generated.AllowedCountryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.AllowedCountryOptionsQuery, Generated.AllowedCountryOptionsQueryVariables>(AllowedCountryOptionsDocument, options);
        }
export function useAllowedCountryOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.AllowedCountryOptionsQuery, Generated.AllowedCountryOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.AllowedCountryOptionsQuery, Generated.AllowedCountryOptionsQueryVariables>(AllowedCountryOptionsDocument, options);
        }
export type AllowedCountryOptionsQueryHookResult = ReturnType<typeof useAllowedCountryOptionsQuery>;
export type AllowedCountryOptionsLazyQueryHookResult = ReturnType<typeof useAllowedCountryOptionsLazyQuery>;
export type AllowedCountryOptionsSuspenseQueryHookResult = ReturnType<typeof useAllowedCountryOptionsSuspenseQuery>;
export type AllowedCountryOptionsQueryResult = Apollo.QueryResult<Generated.AllowedCountryOptionsQuery, Generated.AllowedCountryOptionsQueryVariables>;
export const AllowedViewerCountryOptionsDocument = /*#__PURE__*/ gql`
    query AllowedViewerCountryOptions {
  viewer {
    id
    allowedCountries {
      ...CountryOption
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useAllowedViewerCountryOptionsQuery__
 *
 * To run a query within a React component, call `useAllowedViewerCountryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedViewerCountryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedViewerCountryOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowedViewerCountryOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.AllowedViewerCountryOptionsQuery, Generated.AllowedViewerCountryOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.AllowedViewerCountryOptionsQuery, Generated.AllowedViewerCountryOptionsQueryVariables>(AllowedViewerCountryOptionsDocument, options);
      }
export function useAllowedViewerCountryOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.AllowedViewerCountryOptionsQuery, Generated.AllowedViewerCountryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.AllowedViewerCountryOptionsQuery, Generated.AllowedViewerCountryOptionsQueryVariables>(AllowedViewerCountryOptionsDocument, options);
        }
export function useAllowedViewerCountryOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.AllowedViewerCountryOptionsQuery, Generated.AllowedViewerCountryOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.AllowedViewerCountryOptionsQuery, Generated.AllowedViewerCountryOptionsQueryVariables>(AllowedViewerCountryOptionsDocument, options);
        }
export type AllowedViewerCountryOptionsQueryHookResult = ReturnType<typeof useAllowedViewerCountryOptionsQuery>;
export type AllowedViewerCountryOptionsLazyQueryHookResult = ReturnType<typeof useAllowedViewerCountryOptionsLazyQuery>;
export type AllowedViewerCountryOptionsSuspenseQueryHookResult = ReturnType<typeof useAllowedViewerCountryOptionsSuspenseQuery>;
export type AllowedViewerCountryOptionsQueryResult = Apollo.QueryResult<Generated.AllowedViewerCountryOptionsQuery, Generated.AllowedViewerCountryOptionsQueryVariables>;
export const AllowedLocaleOptionsDocument = /*#__PURE__*/ gql`
    query AllowedLocaleOptions($id: ID!) {
  user(id: $id) {
    allowedLocales {
      ...LocaleOption
    }
  }
}
    ${LocaleOptionFragmentDoc}`;

/**
 * __useAllowedLocaleOptionsQuery__
 *
 * To run a query within a React component, call `useAllowedLocaleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedLocaleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedLocaleOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllowedLocaleOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.AllowedLocaleOptionsQuery, Generated.AllowedLocaleOptionsQueryVariables> & ({ variables: Generated.AllowedLocaleOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.AllowedLocaleOptionsQuery, Generated.AllowedLocaleOptionsQueryVariables>(AllowedLocaleOptionsDocument, options);
      }
export function useAllowedLocaleOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.AllowedLocaleOptionsQuery, Generated.AllowedLocaleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.AllowedLocaleOptionsQuery, Generated.AllowedLocaleOptionsQueryVariables>(AllowedLocaleOptionsDocument, options);
        }
export function useAllowedLocaleOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.AllowedLocaleOptionsQuery, Generated.AllowedLocaleOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.AllowedLocaleOptionsQuery, Generated.AllowedLocaleOptionsQueryVariables>(AllowedLocaleOptionsDocument, options);
        }
export type AllowedLocaleOptionsQueryHookResult = ReturnType<typeof useAllowedLocaleOptionsQuery>;
export type AllowedLocaleOptionsLazyQueryHookResult = ReturnType<typeof useAllowedLocaleOptionsLazyQuery>;
export type AllowedLocaleOptionsSuspenseQueryHookResult = ReturnType<typeof useAllowedLocaleOptionsSuspenseQuery>;
export type AllowedLocaleOptionsQueryResult = Apollo.QueryResult<Generated.AllowedLocaleOptionsQuery, Generated.AllowedLocaleOptionsQueryVariables>;
export const AllowedViewerLocaleOptionsDocument = /*#__PURE__*/ gql`
    query AllowedViewerLocaleOptions {
  viewer {
    id
    allowedLocales {
      ...LocaleOption
    }
  }
}
    ${LocaleOptionFragmentDoc}`;

/**
 * __useAllowedViewerLocaleOptionsQuery__
 *
 * To run a query within a React component, call `useAllowedViewerLocaleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedViewerLocaleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedViewerLocaleOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowedViewerLocaleOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.AllowedViewerLocaleOptionsQuery, Generated.AllowedViewerLocaleOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.AllowedViewerLocaleOptionsQuery, Generated.AllowedViewerLocaleOptionsQueryVariables>(AllowedViewerLocaleOptionsDocument, options);
      }
export function useAllowedViewerLocaleOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.AllowedViewerLocaleOptionsQuery, Generated.AllowedViewerLocaleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.AllowedViewerLocaleOptionsQuery, Generated.AllowedViewerLocaleOptionsQueryVariables>(AllowedViewerLocaleOptionsDocument, options);
        }
export function useAllowedViewerLocaleOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.AllowedViewerLocaleOptionsQuery, Generated.AllowedViewerLocaleOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.AllowedViewerLocaleOptionsQuery, Generated.AllowedViewerLocaleOptionsQueryVariables>(AllowedViewerLocaleOptionsDocument, options);
        }
export type AllowedViewerLocaleOptionsQueryHookResult = ReturnType<typeof useAllowedViewerLocaleOptionsQuery>;
export type AllowedViewerLocaleOptionsLazyQueryHookResult = ReturnType<typeof useAllowedViewerLocaleOptionsLazyQuery>;
export type AllowedViewerLocaleOptionsSuspenseQueryHookResult = ReturnType<typeof useAllowedViewerLocaleOptionsSuspenseQuery>;
export type AllowedViewerLocaleOptionsQueryResult = Apollo.QueryResult<Generated.AllowedViewerLocaleOptionsQuery, Generated.AllowedViewerLocaleOptionsQueryVariables>;
export const CancelImportDocument = /*#__PURE__*/ gql`
    mutation cancelImport($reportId: ID!) {
  cancelImport(reportId: $reportId)
}
    `;
export type CancelImportMutationFn = Apollo.MutationFunction<Generated.CancelImportMutation, Generated.CancelImportMutationVariables>;

/**
 * __useCancelImportMutation__
 *
 * To run a mutation, you first call `useCancelImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelImportMutation, { data, loading, error }] = useCancelImportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useCancelImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CancelImportMutation, Generated.CancelImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CancelImportMutation, Generated.CancelImportMutationVariables>(CancelImportDocument, options);
      }
export type CancelImportMutationHookResult = ReturnType<typeof useCancelImportMutation>;
export type CancelImportMutationResult = Apollo.MutationResult<Generated.CancelImportMutation>;
export type CancelImportMutationOptions = Apollo.BaseMutationOptions<Generated.CancelImportMutation, Generated.CancelImportMutationVariables>;
export const CountriesWithBrandsOptionsDocument = /*#__PURE__*/ gql`
    query CountriesWithBrandsOptions {
  countries(limit: 500, linkedToBrand: true) {
    nodes {
      ...CountryOption
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useCountriesWithBrandsOptionsQuery__
 *
 * To run a query within a React component, call `useCountriesWithBrandsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesWithBrandsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesWithBrandsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesWithBrandsOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.CountriesWithBrandsOptionsQuery, Generated.CountriesWithBrandsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.CountriesWithBrandsOptionsQuery, Generated.CountriesWithBrandsOptionsQueryVariables>(CountriesWithBrandsOptionsDocument, options);
      }
export function useCountriesWithBrandsOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.CountriesWithBrandsOptionsQuery, Generated.CountriesWithBrandsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.CountriesWithBrandsOptionsQuery, Generated.CountriesWithBrandsOptionsQueryVariables>(CountriesWithBrandsOptionsDocument, options);
        }
export function useCountriesWithBrandsOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.CountriesWithBrandsOptionsQuery, Generated.CountriesWithBrandsOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.CountriesWithBrandsOptionsQuery, Generated.CountriesWithBrandsOptionsQueryVariables>(CountriesWithBrandsOptionsDocument, options);
        }
export type CountriesWithBrandsOptionsQueryHookResult = ReturnType<typeof useCountriesWithBrandsOptionsQuery>;
export type CountriesWithBrandsOptionsLazyQueryHookResult = ReturnType<typeof useCountriesWithBrandsOptionsLazyQuery>;
export type CountriesWithBrandsOptionsSuspenseQueryHookResult = ReturnType<typeof useCountriesWithBrandsOptionsSuspenseQuery>;
export type CountriesWithBrandsOptionsQueryResult = Apollo.QueryResult<Generated.CountriesWithBrandsOptionsQuery, Generated.CountriesWithBrandsOptionsQueryVariables>;
export const CountryOptionsDocument = /*#__PURE__*/ gql`
    query CountryOptions($linkedToBrand: Boolean = false) {
  countries(limit: 500, linkedToBrand: $linkedToBrand) {
    nodes {
      ...CountryOption
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useCountryOptionsQuery__
 *
 * To run a query within a React component, call `useCountryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryOptionsQuery({
 *   variables: {
 *      linkedToBrand: // value for 'linkedToBrand'
 *   },
 * });
 */
export function useCountryOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.CountryOptionsQuery, Generated.CountryOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.CountryOptionsQuery, Generated.CountryOptionsQueryVariables>(CountryOptionsDocument, options);
      }
export function useCountryOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.CountryOptionsQuery, Generated.CountryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.CountryOptionsQuery, Generated.CountryOptionsQueryVariables>(CountryOptionsDocument, options);
        }
export function useCountryOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.CountryOptionsQuery, Generated.CountryOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.CountryOptionsQuery, Generated.CountryOptionsQueryVariables>(CountryOptionsDocument, options);
        }
export type CountryOptionsQueryHookResult = ReturnType<typeof useCountryOptionsQuery>;
export type CountryOptionsLazyQueryHookResult = ReturnType<typeof useCountryOptionsLazyQuery>;
export type CountryOptionsSuspenseQueryHookResult = ReturnType<typeof useCountryOptionsSuspenseQuery>;
export type CountryOptionsQueryResult = Apollo.QueryResult<Generated.CountryOptionsQuery, Generated.CountryOptionsQueryVariables>;
export const CreateCopyrightDocument = /*#__PURE__*/ gql`
    mutation createCopyright($input: CreateCopyrightInput!) {
  createCopyright(input: $input) {
    ...CopyrightIdentity
  }
}
    ${CopyrightIdentityFragmentDoc}`;
export type CreateCopyrightMutationFn = Apollo.MutationFunction<Generated.CreateCopyrightMutation, Generated.CreateCopyrightMutationVariables>;

/**
 * __useCreateCopyrightMutation__
 *
 * To run a mutation, you first call `useCreateCopyrightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCopyrightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCopyrightMutation, { data, loading, error }] = useCreateCopyrightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCopyrightMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateCopyrightMutation, Generated.CreateCopyrightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateCopyrightMutation, Generated.CreateCopyrightMutationVariables>(CreateCopyrightDocument, options);
      }
export type CreateCopyrightMutationHookResult = ReturnType<typeof useCreateCopyrightMutation>;
export type CreateCopyrightMutationResult = Apollo.MutationResult<Generated.CreateCopyrightMutation>;
export type CreateCopyrightMutationOptions = Apollo.BaseMutationOptions<Generated.CreateCopyrightMutation, Generated.CreateCopyrightMutationVariables>;
export const CreateEntityPublicationDocument = /*#__PURE__*/ gql`
    mutation createEntityPublication($input: CreateEntityPublicationInput!) {
  createEntityPublication(input: $input) {
    ... on News {
      id
      ...NewsMetadata
      ...PublishableEntityFragment
    }
    ... on EditorialReview {
      id
      ...PublishableEntityFragment
    }
  }
}
    ${NewsMetadataFragmentDoc}
${PublishableEntityFragmentFragmentDoc}`;
export type CreateEntityPublicationMutationFn = Apollo.MutationFunction<Generated.CreateEntityPublicationMutation, Generated.CreateEntityPublicationMutationVariables>;

/**
 * __useCreateEntityPublicationMutation__
 *
 * To run a mutation, you first call `useCreateEntityPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityPublicationMutation, { data, loading, error }] = useCreateEntityPublicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityPublicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateEntityPublicationMutation, Generated.CreateEntityPublicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateEntityPublicationMutation, Generated.CreateEntityPublicationMutationVariables>(CreateEntityPublicationDocument, options);
      }
export type CreateEntityPublicationMutationHookResult = ReturnType<typeof useCreateEntityPublicationMutation>;
export type CreateEntityPublicationMutationResult = Apollo.MutationResult<Generated.CreateEntityPublicationMutation>;
export type CreateEntityPublicationMutationOptions = Apollo.BaseMutationOptions<Generated.CreateEntityPublicationMutation, Generated.CreateEntityPublicationMutationVariables>;
export const CreateImageDocument = /*#__PURE__*/ gql`
    mutation CreateImage($input: CreateImageInput!) {
  createImage(input: $input) {
    __typename
    ... on DuplicatedImage {
      image {
        ...CreatedImage
      }
    }
    ... on Image {
      ...CreatedImage
    }
  }
}
    ${CreatedImageFragmentDoc}`;
export type CreateImageMutationFn = Apollo.MutationFunction<Generated.CreateImageMutation, Generated.CreateImageMutationVariables>;

/**
 * __useCreateImageMutation__
 *
 * To run a mutation, you first call `useCreateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageMutation, { data, loading, error }] = useCreateImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateImageMutation, Generated.CreateImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateImageMutation, Generated.CreateImageMutationVariables>(CreateImageDocument, options);
      }
export type CreateImageMutationHookResult = ReturnType<typeof useCreateImageMutation>;
export type CreateImageMutationResult = Apollo.MutationResult<Generated.CreateImageMutation>;
export type CreateImageMutationOptions = Apollo.BaseMutationOptions<Generated.CreateImageMutation, Generated.CreateImageMutationVariables>;
export const CreateLocalCertificateDocument = /*#__PURE__*/ gql`
    mutation createLocalCertificate($input: CreateLocalCertificateInput!) {
  createLocalCertificate(input: $input) {
    localization {
      id
      name
      type
      country {
        ...CountryOption
      }
    }
    certificate {
      id
      label
    }
    advisory
  }
}
    ${CountryOptionFragmentDoc}`;
export type CreateLocalCertificateMutationFn = Apollo.MutationFunction<Generated.CreateLocalCertificateMutation, Generated.CreateLocalCertificateMutationVariables>;

/**
 * __useCreateLocalCertificateMutation__
 *
 * To run a mutation, you first call `useCreateLocalCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocalCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocalCertificateMutation, { data, loading, error }] = useCreateLocalCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocalCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateLocalCertificateMutation, Generated.CreateLocalCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateLocalCertificateMutation, Generated.CreateLocalCertificateMutationVariables>(CreateLocalCertificateDocument, options);
      }
export type CreateLocalCertificateMutationHookResult = ReturnType<typeof useCreateLocalCertificateMutation>;
export type CreateLocalCertificateMutationResult = Apollo.MutationResult<Generated.CreateLocalCertificateMutation>;
export type CreateLocalCertificateMutationOptions = Apollo.BaseMutationOptions<Generated.CreateLocalCertificateMutation, Generated.CreateLocalCertificateMutationVariables>;
export const DeleteEntityCompanyDocument = /*#__PURE__*/ gql`
    mutation deleteEntityCompany($input: DeleteEntityCompanyInput!) {
  deleteEntityCompany(input: $input) {
    id
  }
}
    `;
export type DeleteEntityCompanyMutationFn = Apollo.MutationFunction<Generated.DeleteEntityCompanyMutation, Generated.DeleteEntityCompanyMutationVariables>;

/**
 * __useDeleteEntityCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteEntityCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityCompanyMutation, { data, loading, error }] = useDeleteEntityCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEntityCompanyMutation, Generated.DeleteEntityCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEntityCompanyMutation, Generated.DeleteEntityCompanyMutationVariables>(DeleteEntityCompanyDocument, options);
      }
export type DeleteEntityCompanyMutationHookResult = ReturnType<typeof useDeleteEntityCompanyMutation>;
export type DeleteEntityCompanyMutationResult = Apollo.MutationResult<Generated.DeleteEntityCompanyMutation>;
export type DeleteEntityCompanyMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEntityCompanyMutation, Generated.DeleteEntityCompanyMutationVariables>;
export const DeleteBrandEntityClubDocument = /*#__PURE__*/ gql`
    mutation deleteBrandEntityClub($input: DeleteBrandEntityClubInput!) {
  deleteBrandEntityClub(input: $input) {
    __typename
    id
  }
}
    `;
export type DeleteBrandEntityClubMutationFn = Apollo.MutationFunction<Generated.DeleteBrandEntityClubMutation, Generated.DeleteBrandEntityClubMutationVariables>;

/**
 * __useDeleteBrandEntityClubMutation__
 *
 * To run a mutation, you first call `useDeleteBrandEntityClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandEntityClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandEntityClubMutation, { data, loading, error }] = useDeleteBrandEntityClubMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBrandEntityClubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteBrandEntityClubMutation, Generated.DeleteBrandEntityClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteBrandEntityClubMutation, Generated.DeleteBrandEntityClubMutationVariables>(DeleteBrandEntityClubDocument, options);
      }
export type DeleteBrandEntityClubMutationHookResult = ReturnType<typeof useDeleteBrandEntityClubMutation>;
export type DeleteBrandEntityClubMutationResult = Apollo.MutationResult<Generated.DeleteBrandEntityClubMutation>;
export type DeleteBrandEntityClubMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteBrandEntityClubMutation, Generated.DeleteBrandEntityClubMutationVariables>;
export const DeleteEntityCreditDocument = /*#__PURE__*/ gql`
    mutation deleteEntityCredit($input: DeleteCreditInput!) {
  deleteCredit(input: $input) {
    id
  }
}
    `;
export type DeleteEntityCreditMutationFn = Apollo.MutationFunction<Generated.DeleteEntityCreditMutation, Generated.DeleteEntityCreditMutationVariables>;

/**
 * __useDeleteEntityCreditMutation__
 *
 * To run a mutation, you first call `useDeleteEntityCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityCreditMutation, { data, loading, error }] = useDeleteEntityCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEntityCreditMutation, Generated.DeleteEntityCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEntityCreditMutation, Generated.DeleteEntityCreditMutationVariables>(DeleteEntityCreditDocument, options);
      }
export type DeleteEntityCreditMutationHookResult = ReturnType<typeof useDeleteEntityCreditMutation>;
export type DeleteEntityCreditMutationResult = Apollo.MutationResult<Generated.DeleteEntityCreditMutation>;
export type DeleteEntityCreditMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEntityCreditMutation, Generated.DeleteEntityCreditMutationVariables>;
export const DeleteEntityLocalCreditDocument = /*#__PURE__*/ gql`
    mutation deleteEntityLocalCredit($input: DeleteLocalCreditInput!) {
  deleteLocalCredit(input: $input) {
    id
  }
}
    `;
export type DeleteEntityLocalCreditMutationFn = Apollo.MutationFunction<Generated.DeleteEntityLocalCreditMutation, Generated.DeleteEntityLocalCreditMutationVariables>;

/**
 * __useDeleteEntityLocalCreditMutation__
 *
 * To run a mutation, you first call `useDeleteEntityLocalCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityLocalCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityLocalCreditMutation, { data, loading, error }] = useDeleteEntityLocalCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityLocalCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEntityLocalCreditMutation, Generated.DeleteEntityLocalCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEntityLocalCreditMutation, Generated.DeleteEntityLocalCreditMutationVariables>(DeleteEntityLocalCreditDocument, options);
      }
export type DeleteEntityLocalCreditMutationHookResult = ReturnType<typeof useDeleteEntityLocalCreditMutation>;
export type DeleteEntityLocalCreditMutationResult = Apollo.MutationResult<Generated.DeleteEntityLocalCreditMutation>;
export type DeleteEntityLocalCreditMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEntityLocalCreditMutation, Generated.DeleteEntityLocalCreditMutationVariables>;
export const DeleteEntityPublicationDocument = /*#__PURE__*/ gql`
    mutation deleteEntityPublication($input: DeleteEntityPublicationInput!) {
  deleteEntityPublication(input: $input) {
    ... on News {
      id
      ...NewsMetadata
      ...PublishableEntityFragment
    }
    ... on EditorialReview {
      id
      ...PublishableEntityFragment
    }
  }
}
    ${NewsMetadataFragmentDoc}
${PublishableEntityFragmentFragmentDoc}`;
export type DeleteEntityPublicationMutationFn = Apollo.MutationFunction<Generated.DeleteEntityPublicationMutation, Generated.DeleteEntityPublicationMutationVariables>;

/**
 * __useDeleteEntityPublicationMutation__
 *
 * To run a mutation, you first call `useDeleteEntityPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityPublicationMutation, { data, loading, error }] = useDeleteEntityPublicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityPublicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEntityPublicationMutation, Generated.DeleteEntityPublicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEntityPublicationMutation, Generated.DeleteEntityPublicationMutationVariables>(DeleteEntityPublicationDocument, options);
      }
export type DeleteEntityPublicationMutationHookResult = ReturnType<typeof useDeleteEntityPublicationMutation>;
export type DeleteEntityPublicationMutationResult = Apollo.MutationResult<Generated.DeleteEntityPublicationMutation>;
export type DeleteEntityPublicationMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEntityPublicationMutation, Generated.DeleteEntityPublicationMutationVariables>;
export const DeleteEntityFromTagDocument = /*#__PURE__*/ gql`
    mutation deleteEntityFromTag($input: DeleteEntityFromTagInput!) {
  deleteEntityFromTag(input: $input) {
    ...EntityTag
  }
}
    ${EntityTagFragmentDoc}`;
export type DeleteEntityFromTagMutationFn = Apollo.MutationFunction<Generated.DeleteEntityFromTagMutation, Generated.DeleteEntityFromTagMutationVariables>;

/**
 * __useDeleteEntityFromTagMutation__
 *
 * To run a mutation, you first call `useDeleteEntityFromTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityFromTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityFromTagMutation, { data, loading, error }] = useDeleteEntityFromTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityFromTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEntityFromTagMutation, Generated.DeleteEntityFromTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEntityFromTagMutation, Generated.DeleteEntityFromTagMutationVariables>(DeleteEntityFromTagDocument, options);
      }
export type DeleteEntityFromTagMutationHookResult = ReturnType<typeof useDeleteEntityFromTagMutation>;
export type DeleteEntityFromTagMutationResult = Apollo.MutationResult<Generated.DeleteEntityFromTagMutation>;
export type DeleteEntityFromTagMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEntityFromTagMutation, Generated.DeleteEntityFromTagMutationVariables>;
export const DeleteTriviaFromEntityDocument = /*#__PURE__*/ gql`
    mutation deleteTriviaFromEntity($input: DeleteTriviaFromEntityInput!) {
  deleteTriviaFromEntity(input: $input) {
    ...EntityTrivia
  }
}
    ${EntityTriviaFragmentDoc}`;
export type DeleteTriviaFromEntityMutationFn = Apollo.MutationFunction<Generated.DeleteTriviaFromEntityMutation, Generated.DeleteTriviaFromEntityMutationVariables>;

/**
 * __useDeleteTriviaFromEntityMutation__
 *
 * To run a mutation, you first call `useDeleteTriviaFromEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTriviaFromEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTriviaFromEntityMutation, { data, loading, error }] = useDeleteTriviaFromEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTriviaFromEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteTriviaFromEntityMutation, Generated.DeleteTriviaFromEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteTriviaFromEntityMutation, Generated.DeleteTriviaFromEntityMutationVariables>(DeleteTriviaFromEntityDocument, options);
      }
export type DeleteTriviaFromEntityMutationHookResult = ReturnType<typeof useDeleteTriviaFromEntityMutation>;
export type DeleteTriviaFromEntityMutationResult = Apollo.MutationResult<Generated.DeleteTriviaFromEntityMutation>;
export type DeleteTriviaFromEntityMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteTriviaFromEntityMutation, Generated.DeleteTriviaFromEntityMutationVariables>;
export const DeleteEntityReleaseDocument = /*#__PURE__*/ gql`
    mutation deleteEntityRelease($input: DeleteReleaseFromEntityInput!) {
  deleteReleaseFromEntity(input: $input) {
    id
  }
}
    `;
export type DeleteEntityReleaseMutationFn = Apollo.MutationFunction<Generated.DeleteEntityReleaseMutation, Generated.DeleteEntityReleaseMutationVariables>;

/**
 * __useDeleteEntityReleaseMutation__
 *
 * To run a mutation, you first call `useDeleteEntityReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityReleaseMutation, { data, loading, error }] = useDeleteEntityReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEntityReleaseMutation, Generated.DeleteEntityReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEntityReleaseMutation, Generated.DeleteEntityReleaseMutationVariables>(DeleteEntityReleaseDocument, options);
      }
export type DeleteEntityReleaseMutationHookResult = ReturnType<typeof useDeleteEntityReleaseMutation>;
export type DeleteEntityReleaseMutationResult = Apollo.MutationResult<Generated.DeleteEntityReleaseMutation>;
export type DeleteEntityReleaseMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEntityReleaseMutation, Generated.DeleteEntityReleaseMutationVariables>;
export const DeleteLocalizedCertificateDocument = /*#__PURE__*/ gql`
    mutation deleteLocalizedCertificate($input: DeleteLocalCertificateInput!) {
  deleteLocalCertificate(input: $input) {
    ...LocalCertificateIdentity
  }
}
    ${LocalCertificateIdentityFragmentDoc}`;
export type DeleteLocalizedCertificateMutationFn = Apollo.MutationFunction<Generated.DeleteLocalizedCertificateMutation, Generated.DeleteLocalizedCertificateMutationVariables>;

/**
 * __useDeleteLocalizedCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteLocalizedCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocalizedCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocalizedCertificateMutation, { data, loading, error }] = useDeleteLocalizedCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocalizedCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteLocalizedCertificateMutation, Generated.DeleteLocalizedCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteLocalizedCertificateMutation, Generated.DeleteLocalizedCertificateMutationVariables>(DeleteLocalizedCertificateDocument, options);
      }
export type DeleteLocalizedCertificateMutationHookResult = ReturnType<typeof useDeleteLocalizedCertificateMutation>;
export type DeleteLocalizedCertificateMutationResult = Apollo.MutationResult<Generated.DeleteLocalizedCertificateMutation>;
export type DeleteLocalizedCertificateMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteLocalizedCertificateMutation, Generated.DeleteLocalizedCertificateMutationVariables>;
export const DeletePersonCreditsImportReportDocument = /*#__PURE__*/ gql`
    mutation deletePersonCreditsImportReport($input: DeletePersonCreditsImportReportInput!) {
  deletePersonCreditsImportReport(input: $input)
}
    `;
export type DeletePersonCreditsImportReportMutationFn = Apollo.MutationFunction<Generated.DeletePersonCreditsImportReportMutation, Generated.DeletePersonCreditsImportReportMutationVariables>;

/**
 * __useDeletePersonCreditsImportReportMutation__
 *
 * To run a mutation, you first call `useDeletePersonCreditsImportReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonCreditsImportReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonCreditsImportReportMutation, { data, loading, error }] = useDeletePersonCreditsImportReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePersonCreditsImportReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeletePersonCreditsImportReportMutation, Generated.DeletePersonCreditsImportReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeletePersonCreditsImportReportMutation, Generated.DeletePersonCreditsImportReportMutationVariables>(DeletePersonCreditsImportReportDocument, options);
      }
export type DeletePersonCreditsImportReportMutationHookResult = ReturnType<typeof useDeletePersonCreditsImportReportMutation>;
export type DeletePersonCreditsImportReportMutationResult = Apollo.MutationResult<Generated.DeletePersonCreditsImportReportMutation>;
export type DeletePersonCreditsImportReportMutationOptions = Apollo.BaseMutationOptions<Generated.DeletePersonCreditsImportReportMutation, Generated.DeletePersonCreditsImportReportMutationVariables>;
export const GetCertificatesDocument = /*#__PURE__*/ gql`
    query getCertificates($scope: CertificateScope, $countryId: ID, $limitedLocalizationId: ID, $limit: Int = 10) {
  certificates(
    scope: $scope
    countryId: $countryId
    limit: $limit
    limitedLocalizationId: $limitedLocalizationId
  ) {
    nodes {
      id
      code
      label
      country {
        ...CountryOption
      }
      limitedLocalization {
        id
        name
        type
      }
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useGetCertificatesQuery__
 *
 * To run a query within a React component, call `useGetCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificatesQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      countryId: // value for 'countryId'
 *      limitedLocalizationId: // value for 'limitedLocalizationId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCertificatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetCertificatesQuery, Generated.GetCertificatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCertificatesQuery, Generated.GetCertificatesQueryVariables>(GetCertificatesDocument, options);
      }
export function useGetCertificatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCertificatesQuery, Generated.GetCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCertificatesQuery, Generated.GetCertificatesQueryVariables>(GetCertificatesDocument, options);
        }
export function useGetCertificatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCertificatesQuery, Generated.GetCertificatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCertificatesQuery, Generated.GetCertificatesQueryVariables>(GetCertificatesDocument, options);
        }
export type GetCertificatesQueryHookResult = ReturnType<typeof useGetCertificatesQuery>;
export type GetCertificatesLazyQueryHookResult = ReturnType<typeof useGetCertificatesLazyQuery>;
export type GetCertificatesSuspenseQueryHookResult = ReturnType<typeof useGetCertificatesSuspenseQuery>;
export type GetCertificatesQueryResult = Apollo.QueryResult<Generated.GetCertificatesQuery, Generated.GetCertificatesQueryVariables>;
export const CreateEntityConnectionDocument = /*#__PURE__*/ gql`
    mutation CreateEntityConnection($input: LinkEntityToEntityInput!) {
  linkEntityToEntity(input: $input) {
    ...ConnectionIdentity
  }
}
    ${ConnectionIdentityFragmentDoc}`;
export type CreateEntityConnectionMutationFn = Apollo.MutationFunction<Generated.CreateEntityConnectionMutation, Generated.CreateEntityConnectionMutationVariables>;

/**
 * __useCreateEntityConnectionMutation__
 *
 * To run a mutation, you first call `useCreateEntityConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityConnectionMutation, { data, loading, error }] = useCreateEntityConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateEntityConnectionMutation, Generated.CreateEntityConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateEntityConnectionMutation, Generated.CreateEntityConnectionMutationVariables>(CreateEntityConnectionDocument, options);
      }
export type CreateEntityConnectionMutationHookResult = ReturnType<typeof useCreateEntityConnectionMutation>;
export type CreateEntityConnectionMutationResult = Apollo.MutationResult<Generated.CreateEntityConnectionMutation>;
export type CreateEntityConnectionMutationOptions = Apollo.BaseMutationOptions<Generated.CreateEntityConnectionMutation, Generated.CreateEntityConnectionMutationVariables>;
export const DeleteEntityConnectionDocument = /*#__PURE__*/ gql`
    mutation DeleteEntityConnection($input: DeleteEntityLinkInput!) {
  deleteEntityLink(input: $input) {
    ...ConnectionIdentity
  }
}
    ${ConnectionIdentityFragmentDoc}`;
export type DeleteEntityConnectionMutationFn = Apollo.MutationFunction<Generated.DeleteEntityConnectionMutation, Generated.DeleteEntityConnectionMutationVariables>;

/**
 * __useDeleteEntityConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteEntityConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityConnectionMutation, { data, loading, error }] = useDeleteEntityConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntityConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEntityConnectionMutation, Generated.DeleteEntityConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEntityConnectionMutation, Generated.DeleteEntityConnectionMutationVariables>(DeleteEntityConnectionDocument, options);
      }
export type DeleteEntityConnectionMutationHookResult = ReturnType<typeof useDeleteEntityConnectionMutation>;
export type DeleteEntityConnectionMutationResult = Apollo.MutationResult<Generated.DeleteEntityConnectionMutation>;
export type DeleteEntityConnectionMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEntityConnectionMutation, Generated.DeleteEntityConnectionMutationVariables>;
export const UpdateEntityConnectionDocument = /*#__PURE__*/ gql`
    mutation UpdateEntityConnection($input: UpdateEntityLinkInput!) {
  updateEntityLink(input: $input) {
    ...ConnectionIdentity
  }
}
    ${ConnectionIdentityFragmentDoc}`;
export type UpdateEntityConnectionMutationFn = Apollo.MutationFunction<Generated.UpdateEntityConnectionMutation, Generated.UpdateEntityConnectionMutationVariables>;

/**
 * __useUpdateEntityConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateEntityConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityConnectionMutation, { data, loading, error }] = useUpdateEntityConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntityConnectionMutation, Generated.UpdateEntityConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntityConnectionMutation, Generated.UpdateEntityConnectionMutationVariables>(UpdateEntityConnectionDocument, options);
      }
export type UpdateEntityConnectionMutationHookResult = ReturnType<typeof useUpdateEntityConnectionMutation>;
export type UpdateEntityConnectionMutationResult = Apollo.MutationResult<Generated.UpdateEntityConnectionMutation>;
export type UpdateEntityConnectionMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntityConnectionMutation, Generated.UpdateEntityConnectionMutationVariables>;
export const MoveEntityConnectionDocument = /*#__PURE__*/ gql`
    mutation MoveEntityConnection($input: MoveEntityLinkInput!) {
  moveEntityLink(input: $input) {
    ...ConnectionIdentity
  }
}
    ${ConnectionIdentityFragmentDoc}`;
export type MoveEntityConnectionMutationFn = Apollo.MutationFunction<Generated.MoveEntityConnectionMutation, Generated.MoveEntityConnectionMutationVariables>;

/**
 * __useMoveEntityConnectionMutation__
 *
 * To run a mutation, you first call `useMoveEntityConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveEntityConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveEntityConnectionMutation, { data, loading, error }] = useMoveEntityConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveEntityConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveEntityConnectionMutation, Generated.MoveEntityConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveEntityConnectionMutation, Generated.MoveEntityConnectionMutationVariables>(MoveEntityConnectionDocument, options);
      }
export type MoveEntityConnectionMutationHookResult = ReturnType<typeof useMoveEntityConnectionMutation>;
export type MoveEntityConnectionMutationResult = Apollo.MutationResult<Generated.MoveEntityConnectionMutation>;
export type MoveEntityConnectionMutationOptions = Apollo.BaseMutationOptions<Generated.MoveEntityConnectionMutation, Generated.MoveEntityConnectionMutationVariables>;
export const GetEntityConnectionListDocument = /*#__PURE__*/ gql`
    query GetEntityConnectionList($entityId: ID!, $linkType: EntityLinkType, $offset: Int!, $limit: Int!, $orderBy: EntityLinkOrder) {
  linkedEntities(
    entityId: $entityId
    linkType: $linkType
    offset: $offset
    limit: $limit
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...ConnectionIdentity
    }
  }
}
    ${ConnectionIdentityFragmentDoc}`;

/**
 * __useGetEntityConnectionListQuery__
 *
 * To run a query within a React component, call `useGetEntityConnectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityConnectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityConnectionListQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      linkType: // value for 'linkType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetEntityConnectionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityConnectionListQuery, Generated.GetEntityConnectionListQueryVariables> & ({ variables: Generated.GetEntityConnectionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityConnectionListQuery, Generated.GetEntityConnectionListQueryVariables>(GetEntityConnectionListDocument, options);
      }
export function useGetEntityConnectionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityConnectionListQuery, Generated.GetEntityConnectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityConnectionListQuery, Generated.GetEntityConnectionListQueryVariables>(GetEntityConnectionListDocument, options);
        }
export function useGetEntityConnectionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityConnectionListQuery, Generated.GetEntityConnectionListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityConnectionListQuery, Generated.GetEntityConnectionListQueryVariables>(GetEntityConnectionListDocument, options);
        }
export type GetEntityConnectionListQueryHookResult = ReturnType<typeof useGetEntityConnectionListQuery>;
export type GetEntityConnectionListLazyQueryHookResult = ReturnType<typeof useGetEntityConnectionListLazyQuery>;
export type GetEntityConnectionListSuspenseQueryHookResult = ReturnType<typeof useGetEntityConnectionListSuspenseQuery>;
export type GetEntityConnectionListQueryResult = Apollo.QueryResult<Generated.GetEntityConnectionListQuery, Generated.GetEntityConnectionListQueryVariables>;
export const SearchCopyrightsDocument = /*#__PURE__*/ gql`
    query searchCopyrights($search: String, $limit: Int) {
  copyrights(search: $search, limit: $limit) {
    ...CopyrightIdentity
  }
}
    ${CopyrightIdentityFragmentDoc}`;

/**
 * __useSearchCopyrightsQuery__
 *
 * To run a query within a React component, call `useSearchCopyrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCopyrightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCopyrightsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCopyrightsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchCopyrightsQuery, Generated.SearchCopyrightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchCopyrightsQuery, Generated.SearchCopyrightsQueryVariables>(SearchCopyrightsDocument, options);
      }
export function useSearchCopyrightsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchCopyrightsQuery, Generated.SearchCopyrightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchCopyrightsQuery, Generated.SearchCopyrightsQueryVariables>(SearchCopyrightsDocument, options);
        }
export function useSearchCopyrightsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchCopyrightsQuery, Generated.SearchCopyrightsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchCopyrightsQuery, Generated.SearchCopyrightsQueryVariables>(SearchCopyrightsDocument, options);
        }
export type SearchCopyrightsQueryHookResult = ReturnType<typeof useSearchCopyrightsQuery>;
export type SearchCopyrightsLazyQueryHookResult = ReturnType<typeof useSearchCopyrightsLazyQuery>;
export type SearchCopyrightsSuspenseQueryHookResult = ReturnType<typeof useSearchCopyrightsSuspenseQuery>;
export type SearchCopyrightsQueryResult = Apollo.QueryResult<Generated.SearchCopyrightsQuery, Generated.SearchCopyrightsQueryVariables>;
export const GetEntityBrandDataDocument = /*#__PURE__*/ gql`
    query getEntityBrandData($id: ID!) {
  entity(id: $id) {
    __typename
    ... on Brandable {
      ...EntityBrandData
    }
  }
}
    ${EntityBrandDataFragmentDoc}`;

/**
 * __useGetEntityBrandDataQuery__
 *
 * To run a query within a React component, call `useGetEntityBrandDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityBrandDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityBrandDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEntityBrandDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityBrandDataQuery, Generated.GetEntityBrandDataQueryVariables> & ({ variables: Generated.GetEntityBrandDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityBrandDataQuery, Generated.GetEntityBrandDataQueryVariables>(GetEntityBrandDataDocument, options);
      }
export function useGetEntityBrandDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityBrandDataQuery, Generated.GetEntityBrandDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityBrandDataQuery, Generated.GetEntityBrandDataQueryVariables>(GetEntityBrandDataDocument, options);
        }
export function useGetEntityBrandDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityBrandDataQuery, Generated.GetEntityBrandDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityBrandDataQuery, Generated.GetEntityBrandDataQueryVariables>(GetEntityBrandDataDocument, options);
        }
export type GetEntityBrandDataQueryHookResult = ReturnType<typeof useGetEntityBrandDataQuery>;
export type GetEntityBrandDataLazyQueryHookResult = ReturnType<typeof useGetEntityBrandDataLazyQuery>;
export type GetEntityBrandDataSuspenseQueryHookResult = ReturnType<typeof useGetEntityBrandDataSuspenseQuery>;
export type GetEntityBrandDataQueryResult = Apollo.QueryResult<Generated.GetEntityBrandDataQuery, Generated.GetEntityBrandDataQueryVariables>;
export const GetCreditDocument = /*#__PURE__*/ gql`
    query getCredit($id: ID!) {
  credit(id: $id) {
    ...MainCredit
    ...LocalCasting
  }
}
    ${MainCreditFragmentDoc}
${LocalCastingFragmentDoc}`;

/**
 * __useGetCreditQuery__
 *
 * To run a query within a React component, call `useGetCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCreditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCreditQuery, Generated.GetCreditQueryVariables> & ({ variables: Generated.GetCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCreditQuery, Generated.GetCreditQueryVariables>(GetCreditDocument, options);
      }
export function useGetCreditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCreditQuery, Generated.GetCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCreditQuery, Generated.GetCreditQueryVariables>(GetCreditDocument, options);
        }
export function useGetCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCreditQuery, Generated.GetCreditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCreditQuery, Generated.GetCreditQueryVariables>(GetCreditDocument, options);
        }
export type GetCreditQueryHookResult = ReturnType<typeof useGetCreditQuery>;
export type GetCreditLazyQueryHookResult = ReturnType<typeof useGetCreditLazyQuery>;
export type GetCreditSuspenseQueryHookResult = ReturnType<typeof useGetCreditSuspenseQuery>;
export type GetCreditQueryResult = Apollo.QueryResult<Generated.GetCreditQuery, Generated.GetCreditQueryVariables>;
export const GetEntityClosestReleaseDocument = /*#__PURE__*/ gql`
    query getEntityClosestRelease($entityId: ID!, $countryId: ID, $brandId: ID, $referenceDateTime: DateTime) {
  entity(id: $entityId) {
    __typename
    ... on Movie {
      id
      closestRelease(
        brandId: $brandId
        countryId: $countryId
        referenceDateTime: $referenceDateTime
      ) {
        releasedAt
      }
    }
  }
}
    `;

/**
 * __useGetEntityClosestReleaseQuery__
 *
 * To run a query within a React component, call `useGetEntityClosestReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityClosestReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityClosestReleaseQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      countryId: // value for 'countryId'
 *      brandId: // value for 'brandId'
 *      referenceDateTime: // value for 'referenceDateTime'
 *   },
 * });
 */
export function useGetEntityClosestReleaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityClosestReleaseQuery, Generated.GetEntityClosestReleaseQueryVariables> & ({ variables: Generated.GetEntityClosestReleaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityClosestReleaseQuery, Generated.GetEntityClosestReleaseQueryVariables>(GetEntityClosestReleaseDocument, options);
      }
export function useGetEntityClosestReleaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityClosestReleaseQuery, Generated.GetEntityClosestReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityClosestReleaseQuery, Generated.GetEntityClosestReleaseQueryVariables>(GetEntityClosestReleaseDocument, options);
        }
export function useGetEntityClosestReleaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityClosestReleaseQuery, Generated.GetEntityClosestReleaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityClosestReleaseQuery, Generated.GetEntityClosestReleaseQueryVariables>(GetEntityClosestReleaseDocument, options);
        }
export type GetEntityClosestReleaseQueryHookResult = ReturnType<typeof useGetEntityClosestReleaseQuery>;
export type GetEntityClosestReleaseLazyQueryHookResult = ReturnType<typeof useGetEntityClosestReleaseLazyQuery>;
export type GetEntityClosestReleaseSuspenseQueryHookResult = ReturnType<typeof useGetEntityClosestReleaseSuspenseQuery>;
export type GetEntityClosestReleaseQueryResult = Apollo.QueryResult<Generated.GetEntityClosestReleaseQuery, Generated.GetEntityClosestReleaseQueryVariables>;
export const GetEntityImageListDocument = /*#__PURE__*/ gql`
    query getEntityImageList($entityId: ID!, $imageId: String, $brandId: ID!, $localeId: ID!, $withMainPoster: Boolean = false, $withMainBrandedPoster: Boolean = false, $withMainLocalizedPoster: Boolean = false, $limit: Int, $offset: Int!, $type: ImageType, $orderBy: [EntityHasImageOrder], $mainPoster: Boolean, $mainBrandPosters: [ID], $mainLocalizedPosters: [ID]) {
  imagesByEntity(
    entityId: $entityId
    imageId: $imageId
    type: $type
    orderBy: $orderBy
    limit: $limit
    offset: $offset
    mainPoster: $mainPoster
    mainBrandPosters: $mainBrandPosters
    mainLocalizedPosters: $mainLocalizedPosters
  ) {
    totalCount
    maxRank
    nodes {
      ...EntityImageItem
    }
  }
}
    ${EntityImageItemFragmentDoc}`;

/**
 * __useGetEntityImageListQuery__
 *
 * To run a query within a React component, call `useGetEntityImageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityImageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityImageListQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imageId: // value for 'imageId'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      withMainPoster: // value for 'withMainPoster'
 *      withMainBrandedPoster: // value for 'withMainBrandedPoster'
 *      withMainLocalizedPoster: // value for 'withMainLocalizedPoster'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      type: // value for 'type'
 *      orderBy: // value for 'orderBy'
 *      mainPoster: // value for 'mainPoster'
 *      mainBrandPosters: // value for 'mainBrandPosters'
 *      mainLocalizedPosters: // value for 'mainLocalizedPosters'
 *   },
 * });
 */
export function useGetEntityImageListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityImageListQuery, Generated.GetEntityImageListQueryVariables> & ({ variables: Generated.GetEntityImageListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityImageListQuery, Generated.GetEntityImageListQueryVariables>(GetEntityImageListDocument, options);
      }
export function useGetEntityImageListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityImageListQuery, Generated.GetEntityImageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityImageListQuery, Generated.GetEntityImageListQueryVariables>(GetEntityImageListDocument, options);
        }
export function useGetEntityImageListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityImageListQuery, Generated.GetEntityImageListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityImageListQuery, Generated.GetEntityImageListQueryVariables>(GetEntityImageListDocument, options);
        }
export type GetEntityImageListQueryHookResult = ReturnType<typeof useGetEntityImageListQuery>;
export type GetEntityImageListLazyQueryHookResult = ReturnType<typeof useGetEntityImageListLazyQuery>;
export type GetEntityImageListSuspenseQueryHookResult = ReturnType<typeof useGetEntityImageListSuspenseQuery>;
export type GetEntityImageListQueryResult = Apollo.QueryResult<Generated.GetEntityImageListQuery, Generated.GetEntityImageListQueryVariables>;
export const GetEntityReleasesDocument = /*#__PURE__*/ gql`
    query getEntityReleases($entityId: ID!, $limit: Int, $offset: Int!, $type: ReleaseType, $countryId: ID) {
  releases(
    entityId: $entityId
    limit: $limit
    offset: $offset
    type: $type
    countryId: $countryId
  ) {
    totalCount
    nodes {
      ...EntityReleaseListItem
    }
  }
}
    ${EntityReleaseListItemFragmentDoc}`;

/**
 * __useGetEntityReleasesQuery__
 *
 * To run a query within a React component, call `useGetEntityReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityReleasesQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      type: // value for 'type'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetEntityReleasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityReleasesQuery, Generated.GetEntityReleasesQueryVariables> & ({ variables: Generated.GetEntityReleasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityReleasesQuery, Generated.GetEntityReleasesQueryVariables>(GetEntityReleasesDocument, options);
      }
export function useGetEntityReleasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityReleasesQuery, Generated.GetEntityReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityReleasesQuery, Generated.GetEntityReleasesQueryVariables>(GetEntityReleasesDocument, options);
        }
export function useGetEntityReleasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityReleasesQuery, Generated.GetEntityReleasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityReleasesQuery, Generated.GetEntityReleasesQueryVariables>(GetEntityReleasesDocument, options);
        }
export type GetEntityReleasesQueryHookResult = ReturnType<typeof useGetEntityReleasesQuery>;
export type GetEntityReleasesLazyQueryHookResult = ReturnType<typeof useGetEntityReleasesLazyQuery>;
export type GetEntityReleasesSuspenseQueryHookResult = ReturnType<typeof useGetEntityReleasesSuspenseQuery>;
export type GetEntityReleasesQueryResult = Apollo.QueryResult<Generated.GetEntityReleasesQuery, Generated.GetEntityReleasesQueryVariables>;
export const GetEntityReleaseVisaNumberDocument = /*#__PURE__*/ gql`
    query getEntityReleaseVisaNumber($ref: ID!, $countryId: ID!, $releaseType: ReleaseType!) {
  entityByRef(type: MOVIE, ref: $ref) {
    __typename
    ... on Movie {
      id
      closestRelease(
        releaseType: $releaseType
        filterOnVisaNumber: true
        filterOnlyPastReleases: true
        countryId: $countryId
      ) {
        id
        visaNumber
      }
    }
  }
}
    `;

/**
 * __useGetEntityReleaseVisaNumberQuery__
 *
 * To run a query within a React component, call `useGetEntityReleaseVisaNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityReleaseVisaNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityReleaseVisaNumberQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      countryId: // value for 'countryId'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useGetEntityReleaseVisaNumberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityReleaseVisaNumberQuery, Generated.GetEntityReleaseVisaNumberQueryVariables> & ({ variables: Generated.GetEntityReleaseVisaNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityReleaseVisaNumberQuery, Generated.GetEntityReleaseVisaNumberQueryVariables>(GetEntityReleaseVisaNumberDocument, options);
      }
export function useGetEntityReleaseVisaNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityReleaseVisaNumberQuery, Generated.GetEntityReleaseVisaNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityReleaseVisaNumberQuery, Generated.GetEntityReleaseVisaNumberQueryVariables>(GetEntityReleaseVisaNumberDocument, options);
        }
export function useGetEntityReleaseVisaNumberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityReleaseVisaNumberQuery, Generated.GetEntityReleaseVisaNumberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityReleaseVisaNumberQuery, Generated.GetEntityReleaseVisaNumberQueryVariables>(GetEntityReleaseVisaNumberDocument, options);
        }
export type GetEntityReleaseVisaNumberQueryHookResult = ReturnType<typeof useGetEntityReleaseVisaNumberQuery>;
export type GetEntityReleaseVisaNumberLazyQueryHookResult = ReturnType<typeof useGetEntityReleaseVisaNumberLazyQuery>;
export type GetEntityReleaseVisaNumberSuspenseQueryHookResult = ReturnType<typeof useGetEntityReleaseVisaNumberSuspenseQuery>;
export type GetEntityReleaseVisaNumberQueryResult = Apollo.QueryResult<Generated.GetEntityReleaseVisaNumberQuery, Generated.GetEntityReleaseVisaNumberQueryVariables>;
export const GetEntitySeoDataDocument = /*#__PURE__*/ gql`
    query getEntitySeoData($id: ID!, $brandId: ID!) {
  entity(id: $id) {
    ... on Company {
      ...CompanyMetadata
      ...CompanySeodata
    }
    ... on Movie {
      ...MovieMetadata
      ...MovieSeodata
    }
    ... on Person {
      ...PersonMetadata
      ...PersonSeodata
    }
    ... on SeriesSeason {
      ...SeasonMetadata
      ...SeasonSeodata
    }
    ... on Series {
      ...SeriesMetadata
      ...SeriesSeodata
    }
    ... on SeriesEpisode {
      ...EpisodeMetadata
      ...EpisodeSeodata
    }
    ... on Theater {
      ...TheaterMetadata
      ...TheaterSeodata
    }
  }
}
    ${CompanyMetadataFragmentDoc}
${CompanySeodataFragmentDoc}
${MovieMetadataFragmentDoc}
${MovieSeodataFragmentDoc}
${PersonMetadataFragmentDoc}
${PersonSeodataFragmentDoc}
${SeasonMetadataFragmentDoc}
${SeasonSeodataFragmentDoc}
${SeriesMetadataFragmentDoc}
${SeriesSeodataFragmentDoc}
${EpisodeMetadataFragmentDoc}
${EpisodeSeodataFragmentDoc}
${TheaterMetadataFragmentDoc}
${TheaterSeodataFragmentDoc}`;

/**
 * __useGetEntitySeoDataQuery__
 *
 * To run a query within a React component, call `useGetEntitySeoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitySeoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitySeoDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetEntitySeoDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntitySeoDataQuery, Generated.GetEntitySeoDataQueryVariables> & ({ variables: Generated.GetEntitySeoDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntitySeoDataQuery, Generated.GetEntitySeoDataQueryVariables>(GetEntitySeoDataDocument, options);
      }
export function useGetEntitySeoDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntitySeoDataQuery, Generated.GetEntitySeoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntitySeoDataQuery, Generated.GetEntitySeoDataQueryVariables>(GetEntitySeoDataDocument, options);
        }
export function useGetEntitySeoDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntitySeoDataQuery, Generated.GetEntitySeoDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntitySeoDataQuery, Generated.GetEntitySeoDataQueryVariables>(GetEntitySeoDataDocument, options);
        }
export type GetEntitySeoDataQueryHookResult = ReturnType<typeof useGetEntitySeoDataQuery>;
export type GetEntitySeoDataLazyQueryHookResult = ReturnType<typeof useGetEntitySeoDataLazyQuery>;
export type GetEntitySeoDataSuspenseQueryHookResult = ReturnType<typeof useGetEntitySeoDataSuspenseQuery>;
export type GetEntitySeoDataQueryResult = Apollo.QueryResult<Generated.GetEntitySeoDataQuery, Generated.GetEntitySeoDataQueryVariables>;
export const GetVideosByEntityDocument = /*#__PURE__*/ gql`
    query getVideosByEntity($type: VideoType, $entityId: ID!, $brandId: ID) {
  videosLegacyByEntity(type: $type, entityId: $entityId, brandId: $brandId) {
    totalCount
    nodes {
      ...EntityVideo
    }
  }
}
    ${EntityVideoFragmentDoc}`;

/**
 * __useGetVideosByEntityQuery__
 *
 * To run a query within a React component, call `useGetVideosByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosByEntityQuery({
 *   variables: {
 *      type: // value for 'type'
 *      entityId: // value for 'entityId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetVideosByEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideosByEntityQuery, Generated.GetVideosByEntityQueryVariables> & ({ variables: Generated.GetVideosByEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideosByEntityQuery, Generated.GetVideosByEntityQueryVariables>(GetVideosByEntityDocument, options);
      }
export function useGetVideosByEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideosByEntityQuery, Generated.GetVideosByEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideosByEntityQuery, Generated.GetVideosByEntityQueryVariables>(GetVideosByEntityDocument, options);
        }
export function useGetVideosByEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideosByEntityQuery, Generated.GetVideosByEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideosByEntityQuery, Generated.GetVideosByEntityQueryVariables>(GetVideosByEntityDocument, options);
        }
export type GetVideosByEntityQueryHookResult = ReturnType<typeof useGetVideosByEntityQuery>;
export type GetVideosByEntityLazyQueryHookResult = ReturnType<typeof useGetVideosByEntityLazyQuery>;
export type GetVideosByEntitySuspenseQueryHookResult = ReturnType<typeof useGetVideosByEntitySuspenseQuery>;
export type GetVideosByEntityQueryResult = Apollo.QueryResult<Generated.GetVideosByEntityQuery, Generated.GetVideosByEntityQueryVariables>;
export const GetVideosB2CByEntityDocument = /*#__PURE__*/ gql`
    query getVideosB2CByEntity($entityId: ID!, $type: VideoType, $brandId: ID, $offset: Int, $limit: Int, $orderBy: VideoOrder) {
  videosLegacyByEntity(
    entityId: $entityId
    type: $type
    brandId: $brandId
    offset: $offset
    limit: $limit
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      video {
        ...VideoIdentity
        ...VideoRank
      }
    }
  }
}
    ${VideoIdentityFragmentDoc}
${VideoRankFragmentDoc}`;

/**
 * __useGetVideosB2CByEntityQuery__
 *
 * To run a query within a React component, call `useGetVideosB2CByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosB2CByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosB2CByEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *      brandId: // value for 'brandId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetVideosB2CByEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideosB2CByEntityQuery, Generated.GetVideosB2CByEntityQueryVariables> & ({ variables: Generated.GetVideosB2CByEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideosB2CByEntityQuery, Generated.GetVideosB2CByEntityQueryVariables>(GetVideosB2CByEntityDocument, options);
      }
export function useGetVideosB2CByEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideosB2CByEntityQuery, Generated.GetVideosB2CByEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideosB2CByEntityQuery, Generated.GetVideosB2CByEntityQueryVariables>(GetVideosB2CByEntityDocument, options);
        }
export function useGetVideosB2CByEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideosB2CByEntityQuery, Generated.GetVideosB2CByEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideosB2CByEntityQuery, Generated.GetVideosB2CByEntityQueryVariables>(GetVideosB2CByEntityDocument, options);
        }
export type GetVideosB2CByEntityQueryHookResult = ReturnType<typeof useGetVideosB2CByEntityQuery>;
export type GetVideosB2CByEntityLazyQueryHookResult = ReturnType<typeof useGetVideosB2CByEntityLazyQuery>;
export type GetVideosB2CByEntitySuspenseQueryHookResult = ReturnType<typeof useGetVideosB2CByEntitySuspenseQuery>;
export type GetVideosB2CByEntityQueryResult = Apollo.QueryResult<Generated.GetVideosB2CByEntityQuery, Generated.GetVideosB2CByEntityQueryVariables>;
export const GetVideosB2BByEntityDocument = /*#__PURE__*/ gql`
    query getVideosB2BByEntity($entityId: ID!, $type: VideoType, $offset: Int, $limit: Int, $orderBy: VideoOrder) {
  videosB2BByEntity(
    entityId: $entityId
    type: $type
    offset: $offset
    limit: $limit
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      video {
        ...VideoIdentity
        ...VideoRank
      }
    }
  }
}
    ${VideoIdentityFragmentDoc}
${VideoRankFragmentDoc}`;

/**
 * __useGetVideosB2BByEntityQuery__
 *
 * To run a query within a React component, call `useGetVideosB2BByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosB2BByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosB2BByEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetVideosB2BByEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideosB2BByEntityQuery, Generated.GetVideosB2BByEntityQueryVariables> & ({ variables: Generated.GetVideosB2BByEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideosB2BByEntityQuery, Generated.GetVideosB2BByEntityQueryVariables>(GetVideosB2BByEntityDocument, options);
      }
export function useGetVideosB2BByEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideosB2BByEntityQuery, Generated.GetVideosB2BByEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideosB2BByEntityQuery, Generated.GetVideosB2BByEntityQueryVariables>(GetVideosB2BByEntityDocument, options);
        }
export function useGetVideosB2BByEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideosB2BByEntityQuery, Generated.GetVideosB2BByEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideosB2BByEntityQuery, Generated.GetVideosB2BByEntityQueryVariables>(GetVideosB2BByEntityDocument, options);
        }
export type GetVideosB2BByEntityQueryHookResult = ReturnType<typeof useGetVideosB2BByEntityQuery>;
export type GetVideosB2BByEntityLazyQueryHookResult = ReturnType<typeof useGetVideosB2BByEntityLazyQuery>;
export type GetVideosB2BByEntitySuspenseQueryHookResult = ReturnType<typeof useGetVideosB2BByEntitySuspenseQuery>;
export type GetVideosB2BByEntityQueryResult = Apollo.QueryResult<Generated.GetVideosB2BByEntityQuery, Generated.GetVideosB2BByEntityQueryVariables>;
export const GetLocalCreditDocument = /*#__PURE__*/ gql`
    query getLocalCredit($id: ID!) {
  localCredit(id: $id) {
    ...LocalCastingDetail
  }
}
    ${LocalCastingDetailFragmentDoc}`;

/**
 * __useGetLocalCreditQuery__
 *
 * To run a query within a React component, call `useGetLocalCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalCreditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocalCreditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetLocalCreditQuery, Generated.GetLocalCreditQueryVariables> & ({ variables: Generated.GetLocalCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetLocalCreditQuery, Generated.GetLocalCreditQueryVariables>(GetLocalCreditDocument, options);
      }
export function useGetLocalCreditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetLocalCreditQuery, Generated.GetLocalCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetLocalCreditQuery, Generated.GetLocalCreditQueryVariables>(GetLocalCreditDocument, options);
        }
export function useGetLocalCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetLocalCreditQuery, Generated.GetLocalCreditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetLocalCreditQuery, Generated.GetLocalCreditQueryVariables>(GetLocalCreditDocument, options);
        }
export type GetLocalCreditQueryHookResult = ReturnType<typeof useGetLocalCreditQuery>;
export type GetLocalCreditLazyQueryHookResult = ReturnType<typeof useGetLocalCreditLazyQuery>;
export type GetLocalCreditSuspenseQueryHookResult = ReturnType<typeof useGetLocalCreditSuspenseQuery>;
export type GetLocalCreditQueryResult = Apollo.QueryResult<Generated.GetLocalCreditQuery, Generated.GetLocalCreditQueryVariables>;
export const GetLocalesDocument = /*#__PURE__*/ gql`
    query getLocales {
  locales {
    ...LocaleOption
  }
}
    ${LocaleOptionFragmentDoc}`;

/**
 * __useGetLocalesQuery__
 *
 * To run a query within a React component, call `useGetLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocalesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetLocalesQuery, Generated.GetLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetLocalesQuery, Generated.GetLocalesQueryVariables>(GetLocalesDocument, options);
      }
export function useGetLocalesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetLocalesQuery, Generated.GetLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetLocalesQuery, Generated.GetLocalesQueryVariables>(GetLocalesDocument, options);
        }
export function useGetLocalesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetLocalesQuery, Generated.GetLocalesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetLocalesQuery, Generated.GetLocalesQueryVariables>(GetLocalesDocument, options);
        }
export type GetLocalesQueryHookResult = ReturnType<typeof useGetLocalesQuery>;
export type GetLocalesLazyQueryHookResult = ReturnType<typeof useGetLocalesLazyQuery>;
export type GetLocalesSuspenseQueryHookResult = ReturnType<typeof useGetLocalesSuspenseQuery>;
export type GetLocalesQueryResult = Apollo.QueryResult<Generated.GetLocalesQuery, Generated.GetLocalesQueryVariables>;
export const GetLocalizedCertificatesDocument = /*#__PURE__*/ gql`
    query getLocalizedCertificates($id: ID!) {
  release(id: $id) {
    localCertificates {
      ...LocalCertificateIdentity
    }
  }
}
    ${LocalCertificateIdentityFragmentDoc}`;

/**
 * __useGetLocalizedCertificatesQuery__
 *
 * To run a query within a React component, call `useGetLocalizedCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizedCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizedCertificatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocalizedCertificatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetLocalizedCertificatesQuery, Generated.GetLocalizedCertificatesQueryVariables> & ({ variables: Generated.GetLocalizedCertificatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetLocalizedCertificatesQuery, Generated.GetLocalizedCertificatesQueryVariables>(GetLocalizedCertificatesDocument, options);
      }
export function useGetLocalizedCertificatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetLocalizedCertificatesQuery, Generated.GetLocalizedCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetLocalizedCertificatesQuery, Generated.GetLocalizedCertificatesQueryVariables>(GetLocalizedCertificatesDocument, options);
        }
export function useGetLocalizedCertificatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetLocalizedCertificatesQuery, Generated.GetLocalizedCertificatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetLocalizedCertificatesQuery, Generated.GetLocalizedCertificatesQueryVariables>(GetLocalizedCertificatesDocument, options);
        }
export type GetLocalizedCertificatesQueryHookResult = ReturnType<typeof useGetLocalizedCertificatesQuery>;
export type GetLocalizedCertificatesLazyQueryHookResult = ReturnType<typeof useGetLocalizedCertificatesLazyQuery>;
export type GetLocalizedCertificatesSuspenseQueryHookResult = ReturnType<typeof useGetLocalizedCertificatesSuspenseQuery>;
export type GetLocalizedCertificatesQueryResult = Apollo.QueryResult<Generated.GetLocalizedCertificatesQuery, Generated.GetLocalizedCertificatesQueryVariables>;
export const GetUserOptionsDocument = /*#__PURE__*/ gql`
    query getUserOptions($limit: Int, $search: String) {
  users(limit: $limit, offset: 0, teamIds: [], search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserOptionsQuery__
 *
 * To run a query within a React component, call `useGetUserOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOptionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetUserOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetUserOptionsQuery, Generated.GetUserOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetUserOptionsQuery, Generated.GetUserOptionsQueryVariables>(GetUserOptionsDocument, options);
      }
export function useGetUserOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetUserOptionsQuery, Generated.GetUserOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetUserOptionsQuery, Generated.GetUserOptionsQueryVariables>(GetUserOptionsDocument, options);
        }
export function useGetUserOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetUserOptionsQuery, Generated.GetUserOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetUserOptionsQuery, Generated.GetUserOptionsQueryVariables>(GetUserOptionsDocument, options);
        }
export type GetUserOptionsQueryHookResult = ReturnType<typeof useGetUserOptionsQuery>;
export type GetUserOptionsLazyQueryHookResult = ReturnType<typeof useGetUserOptionsLazyQuery>;
export type GetUserOptionsSuspenseQueryHookResult = ReturnType<typeof useGetUserOptionsSuspenseQuery>;
export type GetUserOptionsQueryResult = Apollo.QueryResult<Generated.GetUserOptionsQuery, Generated.GetUserOptionsQueryVariables>;
export const GetRelatedProductsDocument = /*#__PURE__*/ gql`
    query getRelatedProducts($entityId: ID!, $countryId: ID!) {
  companyProducts(entityId: $entityId, countryId: $countryId) {
    company {
      ...CompanyOption
    }
    product {
      id
      name
      type
    }
    url
  }
}
    ${CompanyOptionFragmentDoc}`;

/**
 * __useGetRelatedProductsQuery__
 *
 * To run a query within a React component, call `useGetRelatedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedProductsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetRelatedProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetRelatedProductsQuery, Generated.GetRelatedProductsQueryVariables> & ({ variables: Generated.GetRelatedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetRelatedProductsQuery, Generated.GetRelatedProductsQueryVariables>(GetRelatedProductsDocument, options);
      }
export function useGetRelatedProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetRelatedProductsQuery, Generated.GetRelatedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetRelatedProductsQuery, Generated.GetRelatedProductsQueryVariables>(GetRelatedProductsDocument, options);
        }
export function useGetRelatedProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetRelatedProductsQuery, Generated.GetRelatedProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetRelatedProductsQuery, Generated.GetRelatedProductsQueryVariables>(GetRelatedProductsDocument, options);
        }
export type GetRelatedProductsQueryHookResult = ReturnType<typeof useGetRelatedProductsQuery>;
export type GetRelatedProductsLazyQueryHookResult = ReturnType<typeof useGetRelatedProductsLazyQuery>;
export type GetRelatedProductsSuspenseQueryHookResult = ReturnType<typeof useGetRelatedProductsSuspenseQuery>;
export type GetRelatedProductsQueryResult = Apollo.QueryResult<Generated.GetRelatedProductsQuery, Generated.GetRelatedProductsQueryVariables>;
export const GetPersonCreditsImportSourcesDocument = /*#__PURE__*/ gql`
    query getPersonCreditsImportSources {
  personCreditsImportSources
}
    `;

/**
 * __useGetPersonCreditsImportSourcesQuery__
 *
 * To run a query within a React component, call `useGetPersonCreditsImportSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonCreditsImportSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonCreditsImportSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonCreditsImportSourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetPersonCreditsImportSourcesQuery, Generated.GetPersonCreditsImportSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPersonCreditsImportSourcesQuery, Generated.GetPersonCreditsImportSourcesQueryVariables>(GetPersonCreditsImportSourcesDocument, options);
      }
export function useGetPersonCreditsImportSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPersonCreditsImportSourcesQuery, Generated.GetPersonCreditsImportSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPersonCreditsImportSourcesQuery, Generated.GetPersonCreditsImportSourcesQueryVariables>(GetPersonCreditsImportSourcesDocument, options);
        }
export function useGetPersonCreditsImportSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPersonCreditsImportSourcesQuery, Generated.GetPersonCreditsImportSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPersonCreditsImportSourcesQuery, Generated.GetPersonCreditsImportSourcesQueryVariables>(GetPersonCreditsImportSourcesDocument, options);
        }
export type GetPersonCreditsImportSourcesQueryHookResult = ReturnType<typeof useGetPersonCreditsImportSourcesQuery>;
export type GetPersonCreditsImportSourcesLazyQueryHookResult = ReturnType<typeof useGetPersonCreditsImportSourcesLazyQuery>;
export type GetPersonCreditsImportSourcesSuspenseQueryHookResult = ReturnType<typeof useGetPersonCreditsImportSourcesSuspenseQuery>;
export type GetPersonCreditsImportSourcesQueryResult = Apollo.QueryResult<Generated.GetPersonCreditsImportSourcesQuery, Generated.GetPersonCreditsImportSourcesQueryVariables>;
export const GetClubsOptionsDocument = /*#__PURE__*/ gql`
    query getClubsOptions($brandIds: [ID!], $ids: [ID!]) {
  clubs(brandIds: $brandIds, ids: $ids) {
    ...IClub
  }
}
    ${IClubFragmentDoc}`;

/**
 * __useGetClubsOptionsQuery__
 *
 * To run a query within a React component, call `useGetClubsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsOptionsQuery({
 *   variables: {
 *      brandIds: // value for 'brandIds'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetClubsOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetClubsOptionsQuery, Generated.GetClubsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetClubsOptionsQuery, Generated.GetClubsOptionsQueryVariables>(GetClubsOptionsDocument, options);
      }
export function useGetClubsOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetClubsOptionsQuery, Generated.GetClubsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetClubsOptionsQuery, Generated.GetClubsOptionsQueryVariables>(GetClubsOptionsDocument, options);
        }
export function useGetClubsOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetClubsOptionsQuery, Generated.GetClubsOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetClubsOptionsQuery, Generated.GetClubsOptionsQueryVariables>(GetClubsOptionsDocument, options);
        }
export type GetClubsOptionsQueryHookResult = ReturnType<typeof useGetClubsOptionsQuery>;
export type GetClubsOptionsLazyQueryHookResult = ReturnType<typeof useGetClubsOptionsLazyQuery>;
export type GetClubsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetClubsOptionsSuspenseQuery>;
export type GetClubsOptionsQueryResult = Apollo.QueryResult<Generated.GetClubsOptionsQuery, Generated.GetClubsOptionsQueryVariables>;
export const LaunchPersonCreditsImportDocument = /*#__PURE__*/ gql`
    mutation launchPersonCreditsImport($input: LaunchPersonCreditsImportInput!) {
  launchPersonCreditsImport(input: $input) {
    ...PersonCreditsImportReport
  }
}
    ${PersonCreditsImportReportFragmentDoc}`;
export type LaunchPersonCreditsImportMutationFn = Apollo.MutationFunction<Generated.LaunchPersonCreditsImportMutation, Generated.LaunchPersonCreditsImportMutationVariables>;

/**
 * __useLaunchPersonCreditsImportMutation__
 *
 * To run a mutation, you first call `useLaunchPersonCreditsImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchPersonCreditsImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchPersonCreditsImportMutation, { data, loading, error }] = useLaunchPersonCreditsImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchPersonCreditsImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LaunchPersonCreditsImportMutation, Generated.LaunchPersonCreditsImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LaunchPersonCreditsImportMutation, Generated.LaunchPersonCreditsImportMutationVariables>(LaunchPersonCreditsImportDocument, options);
      }
export type LaunchPersonCreditsImportMutationHookResult = ReturnType<typeof useLaunchPersonCreditsImportMutation>;
export type LaunchPersonCreditsImportMutationResult = Apollo.MutationResult<Generated.LaunchPersonCreditsImportMutation>;
export type LaunchPersonCreditsImportMutationOptions = Apollo.BaseMutationOptions<Generated.LaunchPersonCreditsImportMutation, Generated.LaunchPersonCreditsImportMutationVariables>;
export const LocaleOptionsDocument = /*#__PURE__*/ gql`
    query LocaleOptions {
  locales {
    ...LocaleOption
  }
}
    ${LocaleOptionFragmentDoc}`;

/**
 * __useLocaleOptionsQuery__
 *
 * To run a query within a React component, call `useLocaleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocaleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocaleOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocaleOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.LocaleOptionsQuery, Generated.LocaleOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.LocaleOptionsQuery, Generated.LocaleOptionsQueryVariables>(LocaleOptionsDocument, options);
      }
export function useLocaleOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.LocaleOptionsQuery, Generated.LocaleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.LocaleOptionsQuery, Generated.LocaleOptionsQueryVariables>(LocaleOptionsDocument, options);
        }
export function useLocaleOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.LocaleOptionsQuery, Generated.LocaleOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.LocaleOptionsQuery, Generated.LocaleOptionsQueryVariables>(LocaleOptionsDocument, options);
        }
export type LocaleOptionsQueryHookResult = ReturnType<typeof useLocaleOptionsQuery>;
export type LocaleOptionsLazyQueryHookResult = ReturnType<typeof useLocaleOptionsLazyQuery>;
export type LocaleOptionsSuspenseQueryHookResult = ReturnType<typeof useLocaleOptionsSuspenseQuery>;
export type LocaleOptionsQueryResult = Apollo.QueryResult<Generated.LocaleOptionsQuery, Generated.LocaleOptionsQueryVariables>;
export const LinkEntitiesDocument = /*#__PURE__*/ gql`
    mutation linkEntities($input: LinkEntitiesInput!) {
  linkEntities(input: $input) {
    __typename
  }
}
    `;
export type LinkEntitiesMutationFn = Apollo.MutationFunction<Generated.LinkEntitiesMutation, Generated.LinkEntitiesMutationVariables>;

/**
 * __useLinkEntitiesMutation__
 *
 * To run a mutation, you first call `useLinkEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEntitiesMutation, { data, loading, error }] = useLinkEntitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkEntitiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkEntitiesMutation, Generated.LinkEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkEntitiesMutation, Generated.LinkEntitiesMutationVariables>(LinkEntitiesDocument, options);
      }
export type LinkEntitiesMutationHookResult = ReturnType<typeof useLinkEntitiesMutation>;
export type LinkEntitiesMutationResult = Apollo.MutationResult<Generated.LinkEntitiesMutation>;
export type LinkEntitiesMutationOptions = Apollo.BaseMutationOptions<Generated.LinkEntitiesMutation, Generated.LinkEntitiesMutationVariables>;
export const LookupCountryDocument = /*#__PURE__*/ gql`
    query lookupCountry($alpha2: String!) {
  countryByAlpha2(alpha2: $alpha2) {
    id
    name
  }
}
    `;

/**
 * __useLookupCountryQuery__
 *
 * To run a query within a React component, call `useLookupCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupCountryQuery({
 *   variables: {
 *      alpha2: // value for 'alpha2'
 *   },
 * });
 */
export function useLookupCountryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.LookupCountryQuery, Generated.LookupCountryQueryVariables> & ({ variables: Generated.LookupCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.LookupCountryQuery, Generated.LookupCountryQueryVariables>(LookupCountryDocument, options);
      }
export function useLookupCountryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.LookupCountryQuery, Generated.LookupCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.LookupCountryQuery, Generated.LookupCountryQueryVariables>(LookupCountryDocument, options);
        }
export function useLookupCountrySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.LookupCountryQuery, Generated.LookupCountryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.LookupCountryQuery, Generated.LookupCountryQueryVariables>(LookupCountryDocument, options);
        }
export type LookupCountryQueryHookResult = ReturnType<typeof useLookupCountryQuery>;
export type LookupCountryLazyQueryHookResult = ReturnType<typeof useLookupCountryLazyQuery>;
export type LookupCountrySuspenseQueryHookResult = ReturnType<typeof useLookupCountrySuspenseQuery>;
export type LookupCountryQueryResult = Apollo.QueryResult<Generated.LookupCountryQuery, Generated.LookupCountryQueryVariables>;
export const MoveCompanyDocument = /*#__PURE__*/ gql`
    mutation moveCompany($input: MoveCompanyInput!) {
  moveCompany(input: $input) {
    __typename
    id
    rank
  }
}
    `;
export type MoveCompanyMutationFn = Apollo.MutationFunction<Generated.MoveCompanyMutation, Generated.MoveCompanyMutationVariables>;

/**
 * __useMoveCompanyMutation__
 *
 * To run a mutation, you first call `useMoveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCompanyMutation, { data, loading, error }] = useMoveCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveCompanyMutation, Generated.MoveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveCompanyMutation, Generated.MoveCompanyMutationVariables>(MoveCompanyDocument, options);
      }
export type MoveCompanyMutationHookResult = ReturnType<typeof useMoveCompanyMutation>;
export type MoveCompanyMutationResult = Apollo.MutationResult<Generated.MoveCompanyMutation>;
export type MoveCompanyMutationOptions = Apollo.BaseMutationOptions<Generated.MoveCompanyMutation, Generated.MoveCompanyMutationVariables>;
export const MetabaseWidgetDocument = /*#__PURE__*/ gql`
    query MetabaseWidget($dashboard: Int!, $params: JSONObject) {
  metabase(dashboard: $dashboard, params: $params)
}
    `;

/**
 * __useMetabaseWidgetQuery__
 *
 * To run a query within a React component, call `useMetabaseWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetabaseWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetabaseWidgetQuery({
 *   variables: {
 *      dashboard: // value for 'dashboard'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useMetabaseWidgetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.MetabaseWidgetQuery, Generated.MetabaseWidgetQueryVariables> & ({ variables: Generated.MetabaseWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.MetabaseWidgetQuery, Generated.MetabaseWidgetQueryVariables>(MetabaseWidgetDocument, options);
      }
export function useMetabaseWidgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.MetabaseWidgetQuery, Generated.MetabaseWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.MetabaseWidgetQuery, Generated.MetabaseWidgetQueryVariables>(MetabaseWidgetDocument, options);
        }
export function useMetabaseWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.MetabaseWidgetQuery, Generated.MetabaseWidgetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.MetabaseWidgetQuery, Generated.MetabaseWidgetQueryVariables>(MetabaseWidgetDocument, options);
        }
export type MetabaseWidgetQueryHookResult = ReturnType<typeof useMetabaseWidgetQuery>;
export type MetabaseWidgetLazyQueryHookResult = ReturnType<typeof useMetabaseWidgetLazyQuery>;
export type MetabaseWidgetSuspenseQueryHookResult = ReturnType<typeof useMetabaseWidgetSuspenseQuery>;
export type MetabaseWidgetQueryResult = Apollo.QueryResult<Generated.MetabaseWidgetQuery, Generated.MetabaseWidgetQueryVariables>;
export const MoveCreditDocument = /*#__PURE__*/ gql`
    mutation moveCredit($input: MoveCreditInput!) {
  moveCredit(input: $input) {
    id
  }
}
    `;
export type MoveCreditMutationFn = Apollo.MutationFunction<Generated.MoveCreditMutation, Generated.MoveCreditMutationVariables>;

/**
 * __useMoveCreditMutation__
 *
 * To run a mutation, you first call `useMoveCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCreditMutation, { data, loading, error }] = useMoveCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveCreditMutation, Generated.MoveCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveCreditMutation, Generated.MoveCreditMutationVariables>(MoveCreditDocument, options);
      }
export type MoveCreditMutationHookResult = ReturnType<typeof useMoveCreditMutation>;
export type MoveCreditMutationResult = Apollo.MutationResult<Generated.MoveCreditMutation>;
export type MoveCreditMutationOptions = Apollo.BaseMutationOptions<Generated.MoveCreditMutation, Generated.MoveCreditMutationVariables>;
export const OnPersonCreditsImportReportDocument = /*#__PURE__*/ gql`
    subscription onPersonCreditsImportReport($entityId: ID!) {
  personCreditsImportReport(entityId: $entityId) {
    ...PersonCreditsImportReport
  }
}
    ${PersonCreditsImportReportFragmentDoc}`;

/**
 * __useOnPersonCreditsImportReportSubscription__
 *
 * To run a query within a React component, call `useOnPersonCreditsImportReportSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPersonCreditsImportReportSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPersonCreditsImportReportSubscription({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useOnPersonCreditsImportReportSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<Generated.OnPersonCreditsImportReportSubscription, Generated.OnPersonCreditsImportReportSubscriptionVariables> & ({ variables: Generated.OnPersonCreditsImportReportSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<Generated.OnPersonCreditsImportReportSubscription, Generated.OnPersonCreditsImportReportSubscriptionVariables>(OnPersonCreditsImportReportDocument, options);
      }
export type OnPersonCreditsImportReportSubscriptionHookResult = ReturnType<typeof useOnPersonCreditsImportReportSubscription>;
export type OnPersonCreditsImportReportSubscriptionResult = Apollo.SubscriptionResult<Generated.OnPersonCreditsImportReportSubscription>;
export const ProductTypeOptionsDocument = /*#__PURE__*/ gql`
    query ProductTypeOptions($companyId: ID) {
  productTypeOptions(companyId: $companyId) {
    value
    label
  }
}
    `;

/**
 * __useProductTypeOptionsQuery__
 *
 * To run a query within a React component, call `useProductTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTypeOptionsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useProductTypeOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.ProductTypeOptionsQuery, Generated.ProductTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ProductTypeOptionsQuery, Generated.ProductTypeOptionsQueryVariables>(ProductTypeOptionsDocument, options);
      }
export function useProductTypeOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ProductTypeOptionsQuery, Generated.ProductTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ProductTypeOptionsQuery, Generated.ProductTypeOptionsQueryVariables>(ProductTypeOptionsDocument, options);
        }
export function useProductTypeOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ProductTypeOptionsQuery, Generated.ProductTypeOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ProductTypeOptionsQuery, Generated.ProductTypeOptionsQueryVariables>(ProductTypeOptionsDocument, options);
        }
export type ProductTypeOptionsQueryHookResult = ReturnType<typeof useProductTypeOptionsQuery>;
export type ProductTypeOptionsLazyQueryHookResult = ReturnType<typeof useProductTypeOptionsLazyQuery>;
export type ProductTypeOptionsSuspenseQueryHookResult = ReturnType<typeof useProductTypeOptionsSuspenseQuery>;
export type ProductTypeOptionsQueryResult = Apollo.QueryResult<Generated.ProductTypeOptionsQuery, Generated.ProductTypeOptionsQueryVariables>;
export const SearchCompaniesDocument = /*#__PURE__*/ gql`
    query searchCompanies($name: String, $limit: Int, $activities: [CompanyActivity!], $countryIds: [ID!]) {
  companies(
    search: $name
    activities: $activities
    limit: $limit
    countryIds: $countryIds
  ) {
    nodes {
      ...SearchCompany
    }
  }
}
    ${SearchCompanyFragmentDoc}`;

/**
 * __useSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *      activities: // value for 'activities'
 *      countryIds: // value for 'countryIds'
 *   },
 * });
 */
export function useSearchCompaniesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchCompaniesQuery, Generated.SearchCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchCompaniesQuery, Generated.SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
      }
export function useSearchCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchCompaniesQuery, Generated.SearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchCompaniesQuery, Generated.SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export function useSearchCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchCompaniesQuery, Generated.SearchCompaniesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchCompaniesQuery, Generated.SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export type SearchCompaniesQueryHookResult = ReturnType<typeof useSearchCompaniesQuery>;
export type SearchCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCompaniesLazyQuery>;
export type SearchCompaniesSuspenseQueryHookResult = ReturnType<typeof useSearchCompaniesSuspenseQuery>;
export type SearchCompaniesQueryResult = Apollo.QueryResult<Generated.SearchCompaniesQuery, Generated.SearchCompaniesQueryVariables>;
export const SearchEntitiesDocument = /*#__PURE__*/ gql`
    query searchEntities($search: String, $limit: Int, $offset: Int!, $brandId: ID!, $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $entityType: [SearchableEntityType!], $options: SearchOptionsInput, $includeClosestRelease: Boolean = false) {
  searchEntities(
    search: $search
    brandId: $brandId
    limit: $limit
    offset: $offset
    entityType: $entityType
    options: $options
  ) {
    totalCount
    nodes {
      __typename
      ... on Movie {
        ...MovieSearchEntity
        closestRelease(brandId: $brandId, countryId: $localeId) @include(if: $includeClosestRelease) {
          releasedAt
        }
      }
      ... on Series {
        ...SeriesSearchEntity
        closestRelease(brandId: $brandId, countryId: $localeId) @include(if: $includeClosestRelease) {
          releasedAt
        }
      }
      ... on SeriesSeason {
        ...SeriesSeasonSearchEntity
        ...SearchSeriesSeason
      }
      ... on SeriesEpisode {
        ...SeriesEpisodeSearchEntity
      }
      ... on Person {
        ...PersonSearchEntity
      }
      ... on Company {
        ...CompanySearchEntity
      }
      ... on CompanyStaff {
        id
      }
      ... on Festival {
        ...FestivalSearchEntity
      }
      ... on News {
        ...NewsSearchEntity
      }
      ... on Slide {
        ...SlideSearchEntity
      }
      ... on Theater {
        ...TheaterSearchEntity
      }
      ... on Video {
        ...VideoLegacySearchEntity
      }
    }
  }
}
    ${MovieSearchEntityFragmentDoc}
${SeriesSearchEntityFragmentDoc}
${SeriesSeasonSearchEntityFragmentDoc}
${SearchSeriesSeasonFragmentDoc}
${SeriesEpisodeSearchEntityFragmentDoc}
${PersonSearchEntityFragmentDoc}
${CompanySearchEntityFragmentDoc}
${FestivalSearchEntityFragmentDoc}
${NewsSearchEntityFragmentDoc}
${SlideSearchEntityFragmentDoc}
${TheaterSearchEntityFragmentDoc}
${VideoLegacySearchEntityFragmentDoc}`;

/**
 * __useSearchEntitiesQuery__
 *
 * To run a query within a React component, call `useSearchEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEntitiesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      entityType: // value for 'entityType'
 *      options: // value for 'options'
 *      includeClosestRelease: // value for 'includeClosestRelease'
 *   },
 * });
 */
export function useSearchEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchEntitiesQuery, Generated.SearchEntitiesQueryVariables> & ({ variables: Generated.SearchEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchEntitiesQuery, Generated.SearchEntitiesQueryVariables>(SearchEntitiesDocument, options);
      }
export function useSearchEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchEntitiesQuery, Generated.SearchEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchEntitiesQuery, Generated.SearchEntitiesQueryVariables>(SearchEntitiesDocument, options);
        }
export function useSearchEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchEntitiesQuery, Generated.SearchEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchEntitiesQuery, Generated.SearchEntitiesQueryVariables>(SearchEntitiesDocument, options);
        }
export type SearchEntitiesQueryHookResult = ReturnType<typeof useSearchEntitiesQuery>;
export type SearchEntitiesLazyQueryHookResult = ReturnType<typeof useSearchEntitiesLazyQuery>;
export type SearchEntitiesSuspenseQueryHookResult = ReturnType<typeof useSearchEntitiesSuspenseQuery>;
export type SearchEntitiesQueryResult = Apollo.QueryResult<Generated.SearchEntitiesQuery, Generated.SearchEntitiesQueryVariables>;
export const SearchExternalIdProvidersDocument = /*#__PURE__*/ gql`
    query searchExternalIdProviders($type: ExternalIdProviderType!) {
  externalIdProviders(type: $type)
}
    `;

/**
 * __useSearchExternalIdProvidersQuery__
 *
 * To run a query within a React component, call `useSearchExternalIdProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExternalIdProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExternalIdProvidersQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSearchExternalIdProvidersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchExternalIdProvidersQuery, Generated.SearchExternalIdProvidersQueryVariables> & ({ variables: Generated.SearchExternalIdProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchExternalIdProvidersQuery, Generated.SearchExternalIdProvidersQueryVariables>(SearchExternalIdProvidersDocument, options);
      }
export function useSearchExternalIdProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchExternalIdProvidersQuery, Generated.SearchExternalIdProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchExternalIdProvidersQuery, Generated.SearchExternalIdProvidersQueryVariables>(SearchExternalIdProvidersDocument, options);
        }
export function useSearchExternalIdProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchExternalIdProvidersQuery, Generated.SearchExternalIdProvidersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchExternalIdProvidersQuery, Generated.SearchExternalIdProvidersQueryVariables>(SearchExternalIdProvidersDocument, options);
        }
export type SearchExternalIdProvidersQueryHookResult = ReturnType<typeof useSearchExternalIdProvidersQuery>;
export type SearchExternalIdProvidersLazyQueryHookResult = ReturnType<typeof useSearchExternalIdProvidersLazyQuery>;
export type SearchExternalIdProvidersSuspenseQueryHookResult = ReturnType<typeof useSearchExternalIdProvidersSuspenseQuery>;
export type SearchExternalIdProvidersQueryResult = Apollo.QueryResult<Generated.SearchExternalIdProvidersQuery, Generated.SearchExternalIdProvidersQueryVariables>;
export const SearchFestivalEditionsDocument = /*#__PURE__*/ gql`
    query searchFestivalEditions($festivalId: ID, $limit: Int, $offset: Int!, $search: String, $orderBy: FestivalEditionOrder) {
  festivalEditions(
    festivalId: $festivalId
    search: $search
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...SearchFestivalEdition
    }
  }
}
    ${SearchFestivalEditionFragmentDoc}`;

/**
 * __useSearchFestivalEditionsQuery__
 *
 * To run a query within a React component, call `useSearchFestivalEditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFestivalEditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFestivalEditionsQuery({
 *   variables: {
 *      festivalId: // value for 'festivalId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSearchFestivalEditionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchFestivalEditionsQuery, Generated.SearchFestivalEditionsQueryVariables> & ({ variables: Generated.SearchFestivalEditionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchFestivalEditionsQuery, Generated.SearchFestivalEditionsQueryVariables>(SearchFestivalEditionsDocument, options);
      }
export function useSearchFestivalEditionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchFestivalEditionsQuery, Generated.SearchFestivalEditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchFestivalEditionsQuery, Generated.SearchFestivalEditionsQueryVariables>(SearchFestivalEditionsDocument, options);
        }
export function useSearchFestivalEditionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchFestivalEditionsQuery, Generated.SearchFestivalEditionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchFestivalEditionsQuery, Generated.SearchFestivalEditionsQueryVariables>(SearchFestivalEditionsDocument, options);
        }
export type SearchFestivalEditionsQueryHookResult = ReturnType<typeof useSearchFestivalEditionsQuery>;
export type SearchFestivalEditionsLazyQueryHookResult = ReturnType<typeof useSearchFestivalEditionsLazyQuery>;
export type SearchFestivalEditionsSuspenseQueryHookResult = ReturnType<typeof useSearchFestivalEditionsSuspenseQuery>;
export type SearchFestivalEditionsQueryResult = Apollo.QueryResult<Generated.SearchFestivalEditionsQuery, Generated.SearchFestivalEditionsQueryVariables>;
export const SearchFestivalsDocument = /*#__PURE__*/ gql`
    query searchFestivals($search: String, $limit: Int, $orderBy: FestivalOrder!) {
  festivals(search: $search, limit: $limit, orderBy: $orderBy) {
    nodes {
      ...SearchFestival
    }
  }
}
    ${SearchFestivalFragmentDoc}`;

/**
 * __useSearchFestivalsQuery__
 *
 * To run a query within a React component, call `useSearchFestivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFestivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFestivalsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSearchFestivalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchFestivalsQuery, Generated.SearchFestivalsQueryVariables> & ({ variables: Generated.SearchFestivalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchFestivalsQuery, Generated.SearchFestivalsQueryVariables>(SearchFestivalsDocument, options);
      }
export function useSearchFestivalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchFestivalsQuery, Generated.SearchFestivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchFestivalsQuery, Generated.SearchFestivalsQueryVariables>(SearchFestivalsDocument, options);
        }
export function useSearchFestivalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchFestivalsQuery, Generated.SearchFestivalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchFestivalsQuery, Generated.SearchFestivalsQueryVariables>(SearchFestivalsDocument, options);
        }
export type SearchFestivalsQueryHookResult = ReturnType<typeof useSearchFestivalsQuery>;
export type SearchFestivalsLazyQueryHookResult = ReturnType<typeof useSearchFestivalsLazyQuery>;
export type SearchFestivalsSuspenseQueryHookResult = ReturnType<typeof useSearchFestivalsSuspenseQuery>;
export type SearchFestivalsQueryResult = Apollo.QueryResult<Generated.SearchFestivalsQuery, Generated.SearchFestivalsQueryVariables>;
export const SearchLocalizationsDocument = /*#__PURE__*/ gql`
    query searchLocalizations($name: String, $countryId: ID, $localizationKind: [LocalizationKind!], $limit: Int = 100) {
  localizations(
    search: $name
    countryId: $countryId
    localizationKind: $localizationKind
    limit: $limit
  ) {
    nodes {
      id
      name
      type
      code
      parent {
        id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useSearchLocalizationsQuery__
 *
 * To run a query within a React component, call `useSearchLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocalizationsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      countryId: // value for 'countryId'
 *      localizationKind: // value for 'localizationKind'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchLocalizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchLocalizationsQuery, Generated.SearchLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchLocalizationsQuery, Generated.SearchLocalizationsQueryVariables>(SearchLocalizationsDocument, options);
      }
export function useSearchLocalizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchLocalizationsQuery, Generated.SearchLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchLocalizationsQuery, Generated.SearchLocalizationsQueryVariables>(SearchLocalizationsDocument, options);
        }
export function useSearchLocalizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchLocalizationsQuery, Generated.SearchLocalizationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchLocalizationsQuery, Generated.SearchLocalizationsQueryVariables>(SearchLocalizationsDocument, options);
        }
export type SearchLocalizationsQueryHookResult = ReturnType<typeof useSearchLocalizationsQuery>;
export type SearchLocalizationsLazyQueryHookResult = ReturnType<typeof useSearchLocalizationsLazyQuery>;
export type SearchLocalizationsSuspenseQueryHookResult = ReturnType<typeof useSearchLocalizationsSuspenseQuery>;
export type SearchLocalizationsQueryResult = Apollo.QueryResult<Generated.SearchLocalizationsQuery, Generated.SearchLocalizationsQueryVariables>;
export const SearchMoviesDocument = /*#__PURE__*/ gql`
    query searchMovies($search: String, $limit: Int, $orderBy: MovieOrder!, $algorithm: MovieSearchAlgorithm, $withSeoAttributes: Boolean! = false, $brandId: ID! = "") {
  movies(search: $search, limit: $limit, orderBy: $orderBy, algorithm: $algorithm) {
    nodes {
      ...SearchMovie
    }
  }
}
    ${SearchMovieFragmentDoc}`;

/**
 * __useSearchMoviesQuery__
 *
 * To run a query within a React component, call `useSearchMoviesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMoviesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMoviesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      algorithm: // value for 'algorithm'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useSearchMoviesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchMoviesQuery, Generated.SearchMoviesQueryVariables> & ({ variables: Generated.SearchMoviesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchMoviesQuery, Generated.SearchMoviesQueryVariables>(SearchMoviesDocument, options);
      }
export function useSearchMoviesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchMoviesQuery, Generated.SearchMoviesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchMoviesQuery, Generated.SearchMoviesQueryVariables>(SearchMoviesDocument, options);
        }
export function useSearchMoviesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchMoviesQuery, Generated.SearchMoviesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchMoviesQuery, Generated.SearchMoviesQueryVariables>(SearchMoviesDocument, options);
        }
export type SearchMoviesQueryHookResult = ReturnType<typeof useSearchMoviesQuery>;
export type SearchMoviesLazyQueryHookResult = ReturnType<typeof useSearchMoviesLazyQuery>;
export type SearchMoviesSuspenseQueryHookResult = ReturnType<typeof useSearchMoviesSuspenseQuery>;
export type SearchMoviesQueryResult = Apollo.QueryResult<Generated.SearchMoviesQuery, Generated.SearchMoviesQueryVariables>;
export const SearchNewsDocument = /*#__PURE__*/ gql`
    query searchNews($search: String, $limit: Int, $brandId: ID, $universes: [NewsUniverse]) {
  newsList(
    search: $search
    limit: $limit
    brandId: $brandId
    universes: $universes
  ) {
    nodes {
      ...SearchNews
    }
  }
}
    ${SearchNewsFragmentDoc}`;

/**
 * __useSearchNewsQuery__
 *
 * To run a query within a React component, call `useSearchNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNewsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      brandId: // value for 'brandId'
 *      universes: // value for 'universes'
 *   },
 * });
 */
export function useSearchNewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchNewsQuery, Generated.SearchNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchNewsQuery, Generated.SearchNewsQueryVariables>(SearchNewsDocument, options);
      }
export function useSearchNewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchNewsQuery, Generated.SearchNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchNewsQuery, Generated.SearchNewsQueryVariables>(SearchNewsDocument, options);
        }
export function useSearchNewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchNewsQuery, Generated.SearchNewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchNewsQuery, Generated.SearchNewsQueryVariables>(SearchNewsDocument, options);
        }
export type SearchNewsQueryHookResult = ReturnType<typeof useSearchNewsQuery>;
export type SearchNewsLazyQueryHookResult = ReturnType<typeof useSearchNewsLazyQuery>;
export type SearchNewsSuspenseQueryHookResult = ReturnType<typeof useSearchNewsSuspenseQuery>;
export type SearchNewsQueryResult = Apollo.QueryResult<Generated.SearchNewsQuery, Generated.SearchNewsQueryVariables>;
export const SearchPersonsDocument = /*#__PURE__*/ gql`
    query searchPersons($search: String, $limit: Int, $orderBy: PersonOrder!, $relatedEntities: [ID!], $withSeoAttributes: Boolean! = false, $brandId: ID! = "") {
  persons(
    search: $search
    limit: $limit
    orderBy: $orderBy
    relatedEntities: $relatedEntities
  ) {
    nodes {
      id
      ...SearchPerson
    }
  }
}
    ${SearchPersonFragmentDoc}`;

/**
 * __useSearchPersonsQuery__
 *
 * To run a query within a React component, call `useSearchPersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPersonsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      relatedEntities: // value for 'relatedEntities'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useSearchPersonsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchPersonsQuery, Generated.SearchPersonsQueryVariables> & ({ variables: Generated.SearchPersonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchPersonsQuery, Generated.SearchPersonsQueryVariables>(SearchPersonsDocument, options);
      }
export function useSearchPersonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchPersonsQuery, Generated.SearchPersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchPersonsQuery, Generated.SearchPersonsQueryVariables>(SearchPersonsDocument, options);
        }
export function useSearchPersonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchPersonsQuery, Generated.SearchPersonsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchPersonsQuery, Generated.SearchPersonsQueryVariables>(SearchPersonsDocument, options);
        }
export type SearchPersonsQueryHookResult = ReturnType<typeof useSearchPersonsQuery>;
export type SearchPersonsLazyQueryHookResult = ReturnType<typeof useSearchPersonsLazyQuery>;
export type SearchPersonsSuspenseQueryHookResult = ReturnType<typeof useSearchPersonsSuspenseQuery>;
export type SearchPersonsQueryResult = Apollo.QueryResult<Generated.SearchPersonsQuery, Generated.SearchPersonsQueryVariables>;
export const SearchSeriesEpisodesDocument = /*#__PURE__*/ gql`
    query searchSeriesEpisodes($id: ID!, $limit: Int, $offset: Int!, $search: String, $brandId: ID = "", $includeBrandData: Boolean = false) {
  series(id: $id) {
    id
    episodes(limit: $limit, offset: $offset, search: $search) {
      totalCount
      nodes {
        ...SearchSeriesEpisode
      }
    }
  }
}
    ${SearchSeriesEpisodeFragmentDoc}`;

/**
 * __useSearchSeriesEpisodesQuery__
 *
 * To run a query within a React component, call `useSearchSeriesEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSeriesEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSeriesEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useSearchSeriesEpisodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchSeriesEpisodesQuery, Generated.SearchSeriesEpisodesQueryVariables> & ({ variables: Generated.SearchSeriesEpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchSeriesEpisodesQuery, Generated.SearchSeriesEpisodesQueryVariables>(SearchSeriesEpisodesDocument, options);
      }
export function useSearchSeriesEpisodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchSeriesEpisodesQuery, Generated.SearchSeriesEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchSeriesEpisodesQuery, Generated.SearchSeriesEpisodesQueryVariables>(SearchSeriesEpisodesDocument, options);
        }
export function useSearchSeriesEpisodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchSeriesEpisodesQuery, Generated.SearchSeriesEpisodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchSeriesEpisodesQuery, Generated.SearchSeriesEpisodesQueryVariables>(SearchSeriesEpisodesDocument, options);
        }
export type SearchSeriesEpisodesQueryHookResult = ReturnType<typeof useSearchSeriesEpisodesQuery>;
export type SearchSeriesEpisodesLazyQueryHookResult = ReturnType<typeof useSearchSeriesEpisodesLazyQuery>;
export type SearchSeriesEpisodesSuspenseQueryHookResult = ReturnType<typeof useSearchSeriesEpisodesSuspenseQuery>;
export type SearchSeriesEpisodesQueryResult = Apollo.QueryResult<Generated.SearchSeriesEpisodesQuery, Generated.SearchSeriesEpisodesQueryVariables>;
export const SearchSeriesSeasonEpisodesDocument = /*#__PURE__*/ gql`
    query searchSeriesSeasonEpisodes($id: ID!, $limit: Int, $offset: Int!, $search: String, $brandId: ID! = "", $includeBrandData: Boolean! = false) {
  seriesSeason(id: $id) {
    id
    episodes(limit: $limit, offset: $offset, search: $search) {
      totalCount
      nodes {
        ...SearchSeriesEpisode
      }
    }
  }
}
    ${SearchSeriesEpisodeFragmentDoc}`;

/**
 * __useSearchSeriesSeasonEpisodesQuery__
 *
 * To run a query within a React component, call `useSearchSeriesSeasonEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSeriesSeasonEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSeriesSeasonEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *   },
 * });
 */
export function useSearchSeriesSeasonEpisodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchSeriesSeasonEpisodesQuery, Generated.SearchSeriesSeasonEpisodesQueryVariables> & ({ variables: Generated.SearchSeriesSeasonEpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchSeriesSeasonEpisodesQuery, Generated.SearchSeriesSeasonEpisodesQueryVariables>(SearchSeriesSeasonEpisodesDocument, options);
      }
export function useSearchSeriesSeasonEpisodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchSeriesSeasonEpisodesQuery, Generated.SearchSeriesSeasonEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchSeriesSeasonEpisodesQuery, Generated.SearchSeriesSeasonEpisodesQueryVariables>(SearchSeriesSeasonEpisodesDocument, options);
        }
export function useSearchSeriesSeasonEpisodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchSeriesSeasonEpisodesQuery, Generated.SearchSeriesSeasonEpisodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchSeriesSeasonEpisodesQuery, Generated.SearchSeriesSeasonEpisodesQueryVariables>(SearchSeriesSeasonEpisodesDocument, options);
        }
export type SearchSeriesSeasonEpisodesQueryHookResult = ReturnType<typeof useSearchSeriesSeasonEpisodesQuery>;
export type SearchSeriesSeasonEpisodesLazyQueryHookResult = ReturnType<typeof useSearchSeriesSeasonEpisodesLazyQuery>;
export type SearchSeriesSeasonEpisodesSuspenseQueryHookResult = ReturnType<typeof useSearchSeriesSeasonEpisodesSuspenseQuery>;
export type SearchSeriesSeasonEpisodesQueryResult = Apollo.QueryResult<Generated.SearchSeriesSeasonEpisodesQuery, Generated.SearchSeriesSeasonEpisodesQueryVariables>;
export const SearchSeriesSeasonsDocument = /*#__PURE__*/ gql`
    query searchSeriesSeasons($id: ID!, $limit: Int, $offset: Int!, $search: String) {
  series(id: $id) {
    id
    seasons(limit: $limit, offset: $offset, search: $search) {
      totalCount
      nodes {
        ...SearchSeriesSeason
      }
    }
  }
}
    ${SearchSeriesSeasonFragmentDoc}`;

/**
 * __useSearchSeriesSeasonsQuery__
 *
 * To run a query within a React component, call `useSearchSeriesSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSeriesSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSeriesSeasonsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchSeriesSeasonsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchSeriesSeasonsQuery, Generated.SearchSeriesSeasonsQueryVariables> & ({ variables: Generated.SearchSeriesSeasonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchSeriesSeasonsQuery, Generated.SearchSeriesSeasonsQueryVariables>(SearchSeriesSeasonsDocument, options);
      }
export function useSearchSeriesSeasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchSeriesSeasonsQuery, Generated.SearchSeriesSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchSeriesSeasonsQuery, Generated.SearchSeriesSeasonsQueryVariables>(SearchSeriesSeasonsDocument, options);
        }
export function useSearchSeriesSeasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchSeriesSeasonsQuery, Generated.SearchSeriesSeasonsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchSeriesSeasonsQuery, Generated.SearchSeriesSeasonsQueryVariables>(SearchSeriesSeasonsDocument, options);
        }
export type SearchSeriesSeasonsQueryHookResult = ReturnType<typeof useSearchSeriesSeasonsQuery>;
export type SearchSeriesSeasonsLazyQueryHookResult = ReturnType<typeof useSearchSeriesSeasonsLazyQuery>;
export type SearchSeriesSeasonsSuspenseQueryHookResult = ReturnType<typeof useSearchSeriesSeasonsSuspenseQuery>;
export type SearchSeriesSeasonsQueryResult = Apollo.QueryResult<Generated.SearchSeriesSeasonsQuery, Generated.SearchSeriesSeasonsQueryVariables>;
export const SearchSeriesDocument = /*#__PURE__*/ gql`
    query searchSeries($search: String, $limit: Int, $brandId: ID!, $orderBy: SeriesOrder!, $includeBrandData: Boolean!, $withSeoAttributes: Boolean! = false) {
  seriesList(search: $search, limit: $limit, orderBy: $orderBy) {
    nodes {
      ...SearchSeries
    }
  }
}
    ${SearchSeriesFragmentDoc}`;

/**
 * __useSearchSeriesQuery__
 *
 * To run a query within a React component, call `useSearchSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSeriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      brandId: // value for 'brandId'
 *      orderBy: // value for 'orderBy'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useSearchSeriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchSeriesQuery, Generated.SearchSeriesQueryVariables> & ({ variables: Generated.SearchSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchSeriesQuery, Generated.SearchSeriesQueryVariables>(SearchSeriesDocument, options);
      }
export function useSearchSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchSeriesQuery, Generated.SearchSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchSeriesQuery, Generated.SearchSeriesQueryVariables>(SearchSeriesDocument, options);
        }
export function useSearchSeriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchSeriesQuery, Generated.SearchSeriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchSeriesQuery, Generated.SearchSeriesQueryVariables>(SearchSeriesDocument, options);
        }
export type SearchSeriesQueryHookResult = ReturnType<typeof useSearchSeriesQuery>;
export type SearchSeriesLazyQueryHookResult = ReturnType<typeof useSearchSeriesLazyQuery>;
export type SearchSeriesSuspenseQueryHookResult = ReturnType<typeof useSearchSeriesSuspenseQuery>;
export type SearchSeriesQueryResult = Apollo.QueryResult<Generated.SearchSeriesQuery, Generated.SearchSeriesQueryVariables>;
export const SearchTagsDocument = /*#__PURE__*/ gql`
    query searchTags($search: String!, $brandId: ID, $scoped: Boolean) {
  tags(limit: 30, search: $search, brandId: $brandId, scoped: $scoped) {
    nodes {
      id
      ref
      name
    }
  }
}
    `;

/**
 * __useSearchTagsQuery__
 *
 * To run a query within a React component, call `useSearchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      scoped: // value for 'scoped'
 *   },
 * });
 */
export function useSearchTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchTagsQuery, Generated.SearchTagsQueryVariables> & ({ variables: Generated.SearchTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchTagsQuery, Generated.SearchTagsQueryVariables>(SearchTagsDocument, options);
      }
export function useSearchTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchTagsQuery, Generated.SearchTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchTagsQuery, Generated.SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
export function useSearchTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchTagsQuery, Generated.SearchTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchTagsQuery, Generated.SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
export type SearchTagsQueryHookResult = ReturnType<typeof useSearchTagsQuery>;
export type SearchTagsLazyQueryHookResult = ReturnType<typeof useSearchTagsLazyQuery>;
export type SearchTagsSuspenseQueryHookResult = ReturnType<typeof useSearchTagsSuspenseQuery>;
export type SearchTagsQueryResult = Apollo.QueryResult<Generated.SearchTagsQuery, Generated.SearchTagsQueryVariables>;
export const SearchSlidesDocument = /*#__PURE__*/ gql`
    query searchSlides($limit: Int, $offset: Int, $brandId: ID, $search: String) {
  slides(limit: $limit, offset: $offset, brandId: $brandId, search: $search) {
    nodes {
      id
      title
    }
  }
}
    `;

/**
 * __useSearchSlidesQuery__
 *
 * To run a query within a React component, call `useSearchSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSlidesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchSlidesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchSlidesQuery, Generated.SearchSlidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchSlidesQuery, Generated.SearchSlidesQueryVariables>(SearchSlidesDocument, options);
      }
export function useSearchSlidesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchSlidesQuery, Generated.SearchSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchSlidesQuery, Generated.SearchSlidesQueryVariables>(SearchSlidesDocument, options);
        }
export function useSearchSlidesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchSlidesQuery, Generated.SearchSlidesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchSlidesQuery, Generated.SearchSlidesQueryVariables>(SearchSlidesDocument, options);
        }
export type SearchSlidesQueryHookResult = ReturnType<typeof useSearchSlidesQuery>;
export type SearchSlidesLazyQueryHookResult = ReturnType<typeof useSearchSlidesLazyQuery>;
export type SearchSlidesSuspenseQueryHookResult = ReturnType<typeof useSearchSlidesSuspenseQuery>;
export type SearchSlidesQueryResult = Apollo.QueryResult<Generated.SearchSlidesQuery, Generated.SearchSlidesQueryVariables>;
export const SearchTheatersDocument = /*#__PURE__*/ gql`
    query searchTheaters($search: String, $limit: Int, $countryIds: [ID!]) {
  theaters(
    search: $search
    limit: $limit
    countryIds: $countryIds
    orderBy: {field: SCORE, direction: DESC}
  ) {
    nodes {
      ...SearchTheater
    }
  }
}
    ${SearchTheaterFragmentDoc}`;

/**
 * __useSearchTheatersQuery__
 *
 * To run a query within a React component, call `useSearchTheatersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTheatersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTheatersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      countryIds: // value for 'countryIds'
 *   },
 * });
 */
export function useSearchTheatersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchTheatersQuery, Generated.SearchTheatersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchTheatersQuery, Generated.SearchTheatersQueryVariables>(SearchTheatersDocument, options);
      }
export function useSearchTheatersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchTheatersQuery, Generated.SearchTheatersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchTheatersQuery, Generated.SearchTheatersQueryVariables>(SearchTheatersDocument, options);
        }
export function useSearchTheatersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchTheatersQuery, Generated.SearchTheatersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchTheatersQuery, Generated.SearchTheatersQueryVariables>(SearchTheatersDocument, options);
        }
export type SearchTheatersQueryHookResult = ReturnType<typeof useSearchTheatersQuery>;
export type SearchTheatersLazyQueryHookResult = ReturnType<typeof useSearchTheatersLazyQuery>;
export type SearchTheatersSuspenseQueryHookResult = ReturnType<typeof useSearchTheatersSuspenseQuery>;
export type SearchTheatersQueryResult = Apollo.QueryResult<Generated.SearchTheatersQuery, Generated.SearchTheatersQueryVariables>;
export const SearchTriviasDocument = /*#__PURE__*/ gql`
    query searchTrivias($search: String, $brandId: ID) {
  trivias(limit: 30, search: $search, brandId: $brandId) {
    nodes {
      id
      ref
      title
    }
  }
}
    `;

/**
 * __useSearchTriviasQuery__
 *
 * To run a query within a React component, call `useSearchTriviasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTriviasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTriviasQuery({
 *   variables: {
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useSearchTriviasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SearchTriviasQuery, Generated.SearchTriviasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchTriviasQuery, Generated.SearchTriviasQueryVariables>(SearchTriviasDocument, options);
      }
export function useSearchTriviasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchTriviasQuery, Generated.SearchTriviasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchTriviasQuery, Generated.SearchTriviasQueryVariables>(SearchTriviasDocument, options);
        }
export function useSearchTriviasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchTriviasQuery, Generated.SearchTriviasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchTriviasQuery, Generated.SearchTriviasQueryVariables>(SearchTriviasDocument, options);
        }
export type SearchTriviasQueryHookResult = ReturnType<typeof useSearchTriviasQuery>;
export type SearchTriviasLazyQueryHookResult = ReturnType<typeof useSearchTriviasLazyQuery>;
export type SearchTriviasSuspenseQueryHookResult = ReturnType<typeof useSearchTriviasSuspenseQuery>;
export type SearchTriviasQueryResult = Apollo.QueryResult<Generated.SearchTriviasQuery, Generated.SearchTriviasQueryVariables>;
export const TimezonesDocument = /*#__PURE__*/ gql`
    query Timezones {
  timezones
}
    `;

/**
 * __useTimezonesQuery__
 *
 * To run a query within a React component, call `useTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimezonesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.TimezonesQuery, Generated.TimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.TimezonesQuery, Generated.TimezonesQueryVariables>(TimezonesDocument, options);
      }
export function useTimezonesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.TimezonesQuery, Generated.TimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.TimezonesQuery, Generated.TimezonesQueryVariables>(TimezonesDocument, options);
        }
export function useTimezonesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.TimezonesQuery, Generated.TimezonesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.TimezonesQuery, Generated.TimezonesQueryVariables>(TimezonesDocument, options);
        }
export type TimezonesQueryHookResult = ReturnType<typeof useTimezonesQuery>;
export type TimezonesLazyQueryHookResult = ReturnType<typeof useTimezonesLazyQuery>;
export type TimezonesSuspenseQueryHookResult = ReturnType<typeof useTimezonesSuspenseQuery>;
export type TimezonesQueryResult = Apollo.QueryResult<Generated.TimezonesQuery, Generated.TimezonesQueryVariables>;
export const SearchVideosDocument = /*#__PURE__*/ gql`
    query searchVideos($limit: Int, $search: String!, $brandId: ID, $universes: [VideoUniverse]) {
  videos: videoLegacyList(
    limit: $limit
    search: $search
    brandId: $brandId
    universes: $universes
  ) {
    nodes {
      ...SearchVideo
    }
  }
}
    ${SearchVideoFragmentDoc}`;

/**
 * __useSearchVideosQuery__
 *
 * To run a query within a React component, call `useSearchVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVideosQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      universes: // value for 'universes'
 *   },
 * });
 */
export function useSearchVideosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchVideosQuery, Generated.SearchVideosQueryVariables> & ({ variables: Generated.SearchVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchVideosQuery, Generated.SearchVideosQueryVariables>(SearchVideosDocument, options);
      }
export function useSearchVideosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchVideosQuery, Generated.SearchVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchVideosQuery, Generated.SearchVideosQueryVariables>(SearchVideosDocument, options);
        }
export function useSearchVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchVideosQuery, Generated.SearchVideosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchVideosQuery, Generated.SearchVideosQueryVariables>(SearchVideosDocument, options);
        }
export type SearchVideosQueryHookResult = ReturnType<typeof useSearchVideosQuery>;
export type SearchVideosLazyQueryHookResult = ReturnType<typeof useSearchVideosLazyQuery>;
export type SearchVideosSuspenseQueryHookResult = ReturnType<typeof useSearchVideosSuspenseQuery>;
export type SearchVideosQueryResult = Apollo.QueryResult<Generated.SearchVideosQuery, Generated.SearchVideosQueryVariables>;
export const SecureUserOptionsDocument = /*#__PURE__*/ gql`
    query SecureUserOptions($search: String, $limit: Int) {
  users(search: $search, limit: $limit) {
    nodes {
      ...SecureUserOption
    }
  }
}
    ${SecureUserOptionFragmentDoc}`;

/**
 * __useSecureUserOptionsQuery__
 *
 * To run a query within a React component, call `useSecureUserOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureUserOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureUserOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSecureUserOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.SecureUserOptionsQuery, Generated.SecureUserOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SecureUserOptionsQuery, Generated.SecureUserOptionsQueryVariables>(SecureUserOptionsDocument, options);
      }
export function useSecureUserOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SecureUserOptionsQuery, Generated.SecureUserOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SecureUserOptionsQuery, Generated.SecureUserOptionsQueryVariables>(SecureUserOptionsDocument, options);
        }
export function useSecureUserOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SecureUserOptionsQuery, Generated.SecureUserOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SecureUserOptionsQuery, Generated.SecureUserOptionsQueryVariables>(SecureUserOptionsDocument, options);
        }
export type SecureUserOptionsQueryHookResult = ReturnType<typeof useSecureUserOptionsQuery>;
export type SecureUserOptionsLazyQueryHookResult = ReturnType<typeof useSecureUserOptionsLazyQuery>;
export type SecureUserOptionsSuspenseQueryHookResult = ReturnType<typeof useSecureUserOptionsSuspenseQuery>;
export type SecureUserOptionsQueryResult = Apollo.QueryResult<Generated.SecureUserOptionsQuery, Generated.SecureUserOptionsQueryVariables>;
export const UnlinkEntitiesDocument = /*#__PURE__*/ gql`
    mutation unlinkEntities($input: UnlinkEntitiesInput!) {
  unlinkEntities(input: $input) {
    __typename
  }
}
    `;
export type UnlinkEntitiesMutationFn = Apollo.MutationFunction<Generated.UnlinkEntitiesMutation, Generated.UnlinkEntitiesMutationVariables>;

/**
 * __useUnlinkEntitiesMutation__
 *
 * To run a mutation, you first call `useUnlinkEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntitiesMutation, { data, loading, error }] = useUnlinkEntitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkEntitiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkEntitiesMutation, Generated.UnlinkEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkEntitiesMutation, Generated.UnlinkEntitiesMutationVariables>(UnlinkEntitiesDocument, options);
      }
export type UnlinkEntitiesMutationHookResult = ReturnType<typeof useUnlinkEntitiesMutation>;
export type UnlinkEntitiesMutationResult = Apollo.MutationResult<Generated.UnlinkEntitiesMutation>;
export type UnlinkEntitiesMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkEntitiesMutation, Generated.UnlinkEntitiesMutationVariables>;
export const ToggleEntityBrandActivationDocument = /*#__PURE__*/ gql`
    mutation toggleEntityBrandActivation($brandId: ID!, $entityId: ID!, $reason: String) {
  toggleEntityBrandActivation(
    input: {brandId: $brandId, entityId: $entityId, reason: $reason}
  ) {
    ... on Company {
      ...CompanyMetadata
      ...CompanySeodata
    }
    ... on Movie {
      ...MovieMetadata
      ...MovieSeodata
    }
    ... on Theater {
      ...TheaterMetadata
      ...TheaterSeodata
    }
  }
}
    ${CompanyMetadataFragmentDoc}
${CompanySeodataFragmentDoc}
${MovieMetadataFragmentDoc}
${MovieSeodataFragmentDoc}
${TheaterMetadataFragmentDoc}
${TheaterSeodataFragmentDoc}`;
export type ToggleEntityBrandActivationMutationFn = Apollo.MutationFunction<Generated.ToggleEntityBrandActivationMutation, Generated.ToggleEntityBrandActivationMutationVariables>;

/**
 * __useToggleEntityBrandActivationMutation__
 *
 * To run a mutation, you first call `useToggleEntityBrandActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleEntityBrandActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleEntityBrandActivationMutation, { data, loading, error }] = useToggleEntityBrandActivationMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      entityId: // value for 'entityId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useToggleEntityBrandActivationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.ToggleEntityBrandActivationMutation, Generated.ToggleEntityBrandActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.ToggleEntityBrandActivationMutation, Generated.ToggleEntityBrandActivationMutationVariables>(ToggleEntityBrandActivationDocument, options);
      }
export type ToggleEntityBrandActivationMutationHookResult = ReturnType<typeof useToggleEntityBrandActivationMutation>;
export type ToggleEntityBrandActivationMutationResult = Apollo.MutationResult<Generated.ToggleEntityBrandActivationMutation>;
export type ToggleEntityBrandActivationMutationOptions = Apollo.BaseMutationOptions<Generated.ToggleEntityBrandActivationMutation, Generated.ToggleEntityBrandActivationMutationVariables>;
export const UpdateBrandEntityClubDocument = /*#__PURE__*/ gql`
    mutation updateBrandEntityClub($input: UpdateBrandEntityClubInput!) {
  updateBrandEntityClub(input: $input) {
    __typename
  }
}
    `;
export type UpdateBrandEntityClubMutationFn = Apollo.MutationFunction<Generated.UpdateBrandEntityClubMutation, Generated.UpdateBrandEntityClubMutationVariables>;

/**
 * __useUpdateBrandEntityClubMutation__
 *
 * To run a mutation, you first call `useUpdateBrandEntityClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandEntityClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandEntityClubMutation, { data, loading, error }] = useUpdateBrandEntityClubMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandEntityClubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateBrandEntityClubMutation, Generated.UpdateBrandEntityClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateBrandEntityClubMutation, Generated.UpdateBrandEntityClubMutationVariables>(UpdateBrandEntityClubDocument, options);
      }
export type UpdateBrandEntityClubMutationHookResult = ReturnType<typeof useUpdateBrandEntityClubMutation>;
export type UpdateBrandEntityClubMutationResult = Apollo.MutationResult<Generated.UpdateBrandEntityClubMutation>;
export type UpdateBrandEntityClubMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateBrandEntityClubMutation, Generated.UpdateBrandEntityClubMutationVariables>;
export const UpdateEntityAltsDocument = /*#__PURE__*/ gql`
    mutation updateEntityAlts($input: UpdateEntityAltsInput!) {
  updateEntityAlts(input: $input) {
    id
    ...EntityAlts
  }
}
    ${EntityAltsFragmentDoc}`;
export type UpdateEntityAltsMutationFn = Apollo.MutationFunction<Generated.UpdateEntityAltsMutation, Generated.UpdateEntityAltsMutationVariables>;

/**
 * __useUpdateEntityAltsMutation__
 *
 * To run a mutation, you first call `useUpdateEntityAltsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityAltsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityAltsMutation, { data, loading, error }] = useUpdateEntityAltsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityAltsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntityAltsMutation, Generated.UpdateEntityAltsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntityAltsMutation, Generated.UpdateEntityAltsMutationVariables>(UpdateEntityAltsDocument, options);
      }
export type UpdateEntityAltsMutationHookResult = ReturnType<typeof useUpdateEntityAltsMutation>;
export type UpdateEntityAltsMutationResult = Apollo.MutationResult<Generated.UpdateEntityAltsMutation>;
export type UpdateEntityAltsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntityAltsMutation, Generated.UpdateEntityAltsMutationVariables>;
export const UpdateEntityGeneratedVideoTitlesDocument = /*#__PURE__*/ gql`
    mutation updateEntityGeneratedVideoTitles($input: UpdateEntityGeneratedVideoTitlesInput!) {
  updateEntityGeneratedVideoTitles(input: $input) {
    __typename
    count
  }
}
    `;
export type UpdateEntityGeneratedVideoTitlesMutationFn = Apollo.MutationFunction<Generated.UpdateEntityGeneratedVideoTitlesMutation, Generated.UpdateEntityGeneratedVideoTitlesMutationVariables>;

/**
 * __useUpdateEntityGeneratedVideoTitlesMutation__
 *
 * To run a mutation, you first call `useUpdateEntityGeneratedVideoTitlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityGeneratedVideoTitlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityGeneratedVideoTitlesMutation, { data, loading, error }] = useUpdateEntityGeneratedVideoTitlesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityGeneratedVideoTitlesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntityGeneratedVideoTitlesMutation, Generated.UpdateEntityGeneratedVideoTitlesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntityGeneratedVideoTitlesMutation, Generated.UpdateEntityGeneratedVideoTitlesMutationVariables>(UpdateEntityGeneratedVideoTitlesDocument, options);
      }
export type UpdateEntityGeneratedVideoTitlesMutationHookResult = ReturnType<typeof useUpdateEntityGeneratedVideoTitlesMutation>;
export type UpdateEntityGeneratedVideoTitlesMutationResult = Apollo.MutationResult<Generated.UpdateEntityGeneratedVideoTitlesMutation>;
export type UpdateEntityGeneratedVideoTitlesMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntityGeneratedVideoTitlesMutation, Generated.UpdateEntityGeneratedVideoTitlesMutationVariables>;
export const UpdateCreditDocument = /*#__PURE__*/ gql`
    mutation updateCredit($input: UpdateCreditInput!) {
  updateCredit(input: $input) {
    id
    role
    person {
      id
    }
    voice {
      id
    }
  }
}
    `;
export type UpdateCreditMutationFn = Apollo.MutationFunction<Generated.UpdateCreditMutation, Generated.UpdateCreditMutationVariables>;

/**
 * __useUpdateCreditMutation__
 *
 * To run a mutation, you first call `useUpdateCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditMutation, { data, loading, error }] = useUpdateCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCreditMutation, Generated.UpdateCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCreditMutation, Generated.UpdateCreditMutationVariables>(UpdateCreditDocument, options);
      }
export type UpdateCreditMutationHookResult = ReturnType<typeof useUpdateCreditMutation>;
export type UpdateCreditMutationResult = Apollo.MutationResult<Generated.UpdateCreditMutation>;
export type UpdateCreditMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCreditMutation, Generated.UpdateCreditMutationVariables>;
export const UpdateEntityMainPosterDocument = /*#__PURE__*/ gql`
    mutation updateEntityMainPoster($input: UpdateEntityMainPosterInput!) {
  updateEntityMainPoster(input: $input) {
    __typename
    id
  }
}
    `;
export type UpdateEntityMainPosterMutationFn = Apollo.MutationFunction<Generated.UpdateEntityMainPosterMutation, Generated.UpdateEntityMainPosterMutationVariables>;

/**
 * __useUpdateEntityMainPosterMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMainPosterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMainPosterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMainPosterMutation, { data, loading, error }] = useUpdateEntityMainPosterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityMainPosterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntityMainPosterMutation, Generated.UpdateEntityMainPosterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntityMainPosterMutation, Generated.UpdateEntityMainPosterMutationVariables>(UpdateEntityMainPosterDocument, options);
      }
export type UpdateEntityMainPosterMutationHookResult = ReturnType<typeof useUpdateEntityMainPosterMutation>;
export type UpdateEntityMainPosterMutationResult = Apollo.MutationResult<Generated.UpdateEntityMainPosterMutation>;
export type UpdateEntityMainPosterMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntityMainPosterMutation, Generated.UpdateEntityMainPosterMutationVariables>;
export const UpdateEntityMainBrandedPosterDocument = /*#__PURE__*/ gql`
    mutation updateEntityMainBrandedPoster($input: UpdateEntityMainBrandPosterInput!) {
  updateEntityMainBrandPoster(input: $input) {
    __typename
    id
  }
}
    `;
export type UpdateEntityMainBrandedPosterMutationFn = Apollo.MutationFunction<Generated.UpdateEntityMainBrandedPosterMutation, Generated.UpdateEntityMainBrandedPosterMutationVariables>;

/**
 * __useUpdateEntityMainBrandedPosterMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMainBrandedPosterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMainBrandedPosterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMainBrandedPosterMutation, { data, loading, error }] = useUpdateEntityMainBrandedPosterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityMainBrandedPosterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntityMainBrandedPosterMutation, Generated.UpdateEntityMainBrandedPosterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntityMainBrandedPosterMutation, Generated.UpdateEntityMainBrandedPosterMutationVariables>(UpdateEntityMainBrandedPosterDocument, options);
      }
export type UpdateEntityMainBrandedPosterMutationHookResult = ReturnType<typeof useUpdateEntityMainBrandedPosterMutation>;
export type UpdateEntityMainBrandedPosterMutationResult = Apollo.MutationResult<Generated.UpdateEntityMainBrandedPosterMutation>;
export type UpdateEntityMainBrandedPosterMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntityMainBrandedPosterMutation, Generated.UpdateEntityMainBrandedPosterMutationVariables>;
export const UpdateEntityMainLocalizedPosterDocument = /*#__PURE__*/ gql`
    mutation updateEntityMainLocalizedPoster($input: UpdateEntityMainLocalizedPosterInput!) {
  updateEntityMainLocalizedPoster(input: $input) {
    __typename
    id
  }
}
    `;
export type UpdateEntityMainLocalizedPosterMutationFn = Apollo.MutationFunction<Generated.UpdateEntityMainLocalizedPosterMutation, Generated.UpdateEntityMainLocalizedPosterMutationVariables>;

/**
 * __useUpdateEntityMainLocalizedPosterMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMainLocalizedPosterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMainLocalizedPosterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMainLocalizedPosterMutation, { data, loading, error }] = useUpdateEntityMainLocalizedPosterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityMainLocalizedPosterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntityMainLocalizedPosterMutation, Generated.UpdateEntityMainLocalizedPosterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntityMainLocalizedPosterMutation, Generated.UpdateEntityMainLocalizedPosterMutationVariables>(UpdateEntityMainLocalizedPosterDocument, options);
      }
export type UpdateEntityMainLocalizedPosterMutationHookResult = ReturnType<typeof useUpdateEntityMainLocalizedPosterMutation>;
export type UpdateEntityMainLocalizedPosterMutationResult = Apollo.MutationResult<Generated.UpdateEntityMainLocalizedPosterMutation>;
export type UpdateEntityMainLocalizedPosterMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntityMainLocalizedPosterMutation, Generated.UpdateEntityMainLocalizedPosterMutationVariables>;
export const UpdateEntitySeoDataDocument = /*#__PURE__*/ gql`
    mutation updateEntitySeoData($entityId: ID!, $brandId: ID!, $active: Boolean!, $browsable: Boolean!, $title: String, $alternateTitle: String, $description: String) {
  updateEntitySeoData(
    input: {entityId: $entityId, brandId: $brandId, active: $active, browsable: $browsable, title: $title, alternateTitle: $alternateTitle, description: $description}
  ) {
    ... on Company {
      ...CompanyMetadata
      ...CompanySeodata
    }
    ... on Movie {
      ...MovieMetadata
      ...MovieSeodata
    }
    ... on Person {
      ...PersonMetadata
      ...PersonSeodata
    }
    ... on Theater {
      ...TheaterMetadata
      ...TheaterSeodata
    }
  }
}
    ${CompanyMetadataFragmentDoc}
${CompanySeodataFragmentDoc}
${MovieMetadataFragmentDoc}
${MovieSeodataFragmentDoc}
${PersonMetadataFragmentDoc}
${PersonSeodataFragmentDoc}
${TheaterMetadataFragmentDoc}
${TheaterSeodataFragmentDoc}`;
export type UpdateEntitySeoDataMutationFn = Apollo.MutationFunction<Generated.UpdateEntitySeoDataMutation, Generated.UpdateEntitySeoDataMutationVariables>;

/**
 * __useUpdateEntitySeoDataMutation__
 *
 * To run a mutation, you first call `useUpdateEntitySeoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntitySeoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntitySeoDataMutation, { data, loading, error }] = useUpdateEntitySeoDataMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      brandId: // value for 'brandId'
 *      active: // value for 'active'
 *      browsable: // value for 'browsable'
 *      title: // value for 'title'
 *      alternateTitle: // value for 'alternateTitle'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateEntitySeoDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntitySeoDataMutation, Generated.UpdateEntitySeoDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntitySeoDataMutation, Generated.UpdateEntitySeoDataMutationVariables>(UpdateEntitySeoDataDocument, options);
      }
export type UpdateEntitySeoDataMutationHookResult = ReturnType<typeof useUpdateEntitySeoDataMutation>;
export type UpdateEntitySeoDataMutationResult = Apollo.MutationResult<Generated.UpdateEntitySeoDataMutation>;
export type UpdateEntitySeoDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntitySeoDataMutation, Generated.UpdateEntitySeoDataMutationVariables>;
export const UpdateEntityPublicationDocument = /*#__PURE__*/ gql`
    mutation updateEntityPublication($input: UpdateEntityPublicationInput!) {
  updateEntityPublication(input: $input) {
    ... on News {
      id
      ...NewsMetadata
      ...PublishableEntityFragment
    }
    ... on EditorialReview {
      id
      ...PublishableEntityFragment
    }
  }
}
    ${NewsMetadataFragmentDoc}
${PublishableEntityFragmentFragmentDoc}`;
export type UpdateEntityPublicationMutationFn = Apollo.MutationFunction<Generated.UpdateEntityPublicationMutation, Generated.UpdateEntityPublicationMutationVariables>;

/**
 * __useUpdateEntityPublicationMutation__
 *
 * To run a mutation, you first call `useUpdateEntityPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityPublicationMutation, { data, loading, error }] = useUpdateEntityPublicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityPublicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEntityPublicationMutation, Generated.UpdateEntityPublicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEntityPublicationMutation, Generated.UpdateEntityPublicationMutationVariables>(UpdateEntityPublicationDocument, options);
      }
export type UpdateEntityPublicationMutationHookResult = ReturnType<typeof useUpdateEntityPublicationMutation>;
export type UpdateEntityPublicationMutationResult = Apollo.MutationResult<Generated.UpdateEntityPublicationMutation>;
export type UpdateEntityPublicationMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEntityPublicationMutation, Generated.UpdateEntityPublicationMutationVariables>;
export const UpdateLocalCertificateDocument = /*#__PURE__*/ gql`
    mutation updateLocalCertificate($input: UpdateLocalCertificateInput!) {
  updateLocalCertificate(input: $input) {
    ...LocalCertificateIdentity
  }
}
    ${LocalCertificateIdentityFragmentDoc}`;
export type UpdateLocalCertificateMutationFn = Apollo.MutationFunction<Generated.UpdateLocalCertificateMutation, Generated.UpdateLocalCertificateMutationVariables>;

/**
 * __useUpdateLocalCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateLocalCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalCertificateMutation, { data, loading, error }] = useUpdateLocalCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateLocalCertificateMutation, Generated.UpdateLocalCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateLocalCertificateMutation, Generated.UpdateLocalCertificateMutationVariables>(UpdateLocalCertificateDocument, options);
      }
export type UpdateLocalCertificateMutationHookResult = ReturnType<typeof useUpdateLocalCertificateMutation>;
export type UpdateLocalCertificateMutationResult = Apollo.MutationResult<Generated.UpdateLocalCertificateMutation>;
export type UpdateLocalCertificateMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateLocalCertificateMutation, Generated.UpdateLocalCertificateMutationVariables>;
export const UpdateLocalCreditDocument = /*#__PURE__*/ gql`
    mutation updateLocalCredit($input: UpdateLocalCreditInput!) {
  updateLocalCredit(input: $input) {
    id
    role
    voice {
      id
    }
    locale {
      id
    }
  }
}
    `;
export type UpdateLocalCreditMutationFn = Apollo.MutationFunction<Generated.UpdateLocalCreditMutation, Generated.UpdateLocalCreditMutationVariables>;

/**
 * __useUpdateLocalCreditMutation__
 *
 * To run a mutation, you first call `useUpdateLocalCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalCreditMutation, { data, loading, error }] = useUpdateLocalCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateLocalCreditMutation, Generated.UpdateLocalCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateLocalCreditMutation, Generated.UpdateLocalCreditMutationVariables>(UpdateLocalCreditDocument, options);
      }
export type UpdateLocalCreditMutationHookResult = ReturnType<typeof useUpdateLocalCreditMutation>;
export type UpdateLocalCreditMutationResult = Apollo.MutationResult<Generated.UpdateLocalCreditMutation>;
export type UpdateLocalCreditMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateLocalCreditMutation, Generated.UpdateLocalCreditMutationVariables>;
export const UpdateTriviaRankDocument = /*#__PURE__*/ gql`
    mutation updateTriviaRank($input: UpdateTriviaRankInput!) {
  updateTriviaRank(input: $input) {
    id
  }
}
    `;
export type UpdateTriviaRankMutationFn = Apollo.MutationFunction<Generated.UpdateTriviaRankMutation, Generated.UpdateTriviaRankMutationVariables>;

/**
 * __useUpdateTriviaRankMutation__
 *
 * To run a mutation, you first call `useUpdateTriviaRankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriviaRankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriviaRankMutation, { data, loading, error }] = useUpdateTriviaRankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriviaRankMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTriviaRankMutation, Generated.UpdateTriviaRankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTriviaRankMutation, Generated.UpdateTriviaRankMutationVariables>(UpdateTriviaRankDocument, options);
      }
export type UpdateTriviaRankMutationHookResult = ReturnType<typeof useUpdateTriviaRankMutation>;
export type UpdateTriviaRankMutationResult = Apollo.MutationResult<Generated.UpdateTriviaRankMutation>;
export type UpdateTriviaRankMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTriviaRankMutation, Generated.UpdateTriviaRankMutationVariables>;
export const ViewerDocument = /*#__PURE__*/ gql`
    query Viewer {
  viewer {
    ...ViewerData
  }
}
    ${ViewerDataFragmentDoc}`;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.ViewerQuery, Generated.ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ViewerQuery, Generated.ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ViewerQuery, Generated.ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ViewerQuery, Generated.ViewerQueryVariables>(ViewerDocument, options);
        }
export function useViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ViewerQuery, Generated.ViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ViewerQuery, Generated.ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<typeof useViewerSuspenseQuery>;
export type ViewerQueryResult = Apollo.QueryResult<Generated.ViewerQuery, Generated.ViewerQueryVariables>;
export const DeleteSpecialOperationDocument = /*#__PURE__*/ gql`
    mutation deleteSpecialOperation($specialOperationId: ID!) {
  deleteSpecialOperation(input: {specialOperationId: $specialOperationId}) {
    id
  }
}
    `;
export type DeleteSpecialOperationMutationFn = Apollo.MutationFunction<Generated.DeleteSpecialOperationMutation, Generated.DeleteSpecialOperationMutationVariables>;

/**
 * __useDeleteSpecialOperationMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialOperationMutation, { data, loading, error }] = useDeleteSpecialOperationMutation({
 *   variables: {
 *      specialOperationId: // value for 'specialOperationId'
 *   },
 * });
 */
export function useDeleteSpecialOperationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteSpecialOperationMutation, Generated.DeleteSpecialOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteSpecialOperationMutation, Generated.DeleteSpecialOperationMutationVariables>(DeleteSpecialOperationDocument, options);
      }
export type DeleteSpecialOperationMutationHookResult = ReturnType<typeof useDeleteSpecialOperationMutation>;
export type DeleteSpecialOperationMutationResult = Apollo.MutationResult<Generated.DeleteSpecialOperationMutation>;
export type DeleteSpecialOperationMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteSpecialOperationMutation, Generated.DeleteSpecialOperationMutationVariables>;
export const CreateSpecialOperationDocument = /*#__PURE__*/ gql`
    mutation createSpecialOperation($input: CreateSpecialOperationInput!) {
  createSpecialOperation(input: $input) {
    id
    ref
  }
}
    `;
export type CreateSpecialOperationMutationFn = Apollo.MutationFunction<Generated.CreateSpecialOperationMutation, Generated.CreateSpecialOperationMutationVariables>;

/**
 * __useCreateSpecialOperationMutation__
 *
 * To run a mutation, you first call `useCreateSpecialOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialOperationMutation, { data, loading, error }] = useCreateSpecialOperationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpecialOperationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateSpecialOperationMutation, Generated.CreateSpecialOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateSpecialOperationMutation, Generated.CreateSpecialOperationMutationVariables>(CreateSpecialOperationDocument, options);
      }
export type CreateSpecialOperationMutationHookResult = ReturnType<typeof useCreateSpecialOperationMutation>;
export type CreateSpecialOperationMutationResult = Apollo.MutationResult<Generated.CreateSpecialOperationMutation>;
export type CreateSpecialOperationMutationOptions = Apollo.BaseMutationOptions<Generated.CreateSpecialOperationMutation, Generated.CreateSpecialOperationMutationVariables>;
export const AddTargetToSpecialOperationDocument = /*#__PURE__*/ gql`
    mutation addTargetToSpecialOperation($input: AddTargetToSpecialOperationInput!) {
  addTargetToSpecialOperation(input: $input) {
    id
  }
}
    `;
export type AddTargetToSpecialOperationMutationFn = Apollo.MutationFunction<Generated.AddTargetToSpecialOperationMutation, Generated.AddTargetToSpecialOperationMutationVariables>;

/**
 * __useAddTargetToSpecialOperationMutation__
 *
 * To run a mutation, you first call `useAddTargetToSpecialOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTargetToSpecialOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTargetToSpecialOperationMutation, { data, loading, error }] = useAddTargetToSpecialOperationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTargetToSpecialOperationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddTargetToSpecialOperationMutation, Generated.AddTargetToSpecialOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddTargetToSpecialOperationMutation, Generated.AddTargetToSpecialOperationMutationVariables>(AddTargetToSpecialOperationDocument, options);
      }
export type AddTargetToSpecialOperationMutationHookResult = ReturnType<typeof useAddTargetToSpecialOperationMutation>;
export type AddTargetToSpecialOperationMutationResult = Apollo.MutationResult<Generated.AddTargetToSpecialOperationMutation>;
export type AddTargetToSpecialOperationMutationOptions = Apollo.BaseMutationOptions<Generated.AddTargetToSpecialOperationMutation, Generated.AddTargetToSpecialOperationMutationVariables>;
export const GetEmergenceTargetsDocument = /*#__PURE__*/ gql`
    query getEmergenceTargets($id: ID!, $target: [Tag3D!]) {
  specialOperation(id: $id) {
    id
    targets(target: $target) {
      ...EmergenceTarget
    }
  }
}
    ${EmergenceTargetFragmentDoc}`;

/**
 * __useGetEmergenceTargetsQuery__
 *
 * To run a query within a React component, call `useGetEmergenceTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmergenceTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmergenceTargetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useGetEmergenceTargetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEmergenceTargetsQuery, Generated.GetEmergenceTargetsQueryVariables> & ({ variables: Generated.GetEmergenceTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEmergenceTargetsQuery, Generated.GetEmergenceTargetsQueryVariables>(GetEmergenceTargetsDocument, options);
      }
export function useGetEmergenceTargetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEmergenceTargetsQuery, Generated.GetEmergenceTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEmergenceTargetsQuery, Generated.GetEmergenceTargetsQueryVariables>(GetEmergenceTargetsDocument, options);
        }
export function useGetEmergenceTargetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEmergenceTargetsQuery, Generated.GetEmergenceTargetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEmergenceTargetsQuery, Generated.GetEmergenceTargetsQueryVariables>(GetEmergenceTargetsDocument, options);
        }
export type GetEmergenceTargetsQueryHookResult = ReturnType<typeof useGetEmergenceTargetsQuery>;
export type GetEmergenceTargetsLazyQueryHookResult = ReturnType<typeof useGetEmergenceTargetsLazyQuery>;
export type GetEmergenceTargetsSuspenseQueryHookResult = ReturnType<typeof useGetEmergenceTargetsSuspenseQuery>;
export type GetEmergenceTargetsQueryResult = Apollo.QueryResult<Generated.GetEmergenceTargetsQuery, Generated.GetEmergenceTargetsQueryVariables>;
export const GetSpecialOperationAdditionalInfosDocument = /*#__PURE__*/ gql`
    query getSpecialOperationAdditionalInfos($ref: ID!) {
  specialOperationByRef(ref: $ref) {
    ...SpecialOperationAdditionalInfos
  }
}
    ${SpecialOperationAdditionalInfosFragmentDoc}`;

/**
 * __useGetSpecialOperationAdditionalInfosQuery__
 *
 * To run a query within a React component, call `useGetSpecialOperationAdditionalInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialOperationAdditionalInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialOperationAdditionalInfosQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSpecialOperationAdditionalInfosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSpecialOperationAdditionalInfosQuery, Generated.GetSpecialOperationAdditionalInfosQueryVariables> & ({ variables: Generated.GetSpecialOperationAdditionalInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSpecialOperationAdditionalInfosQuery, Generated.GetSpecialOperationAdditionalInfosQueryVariables>(GetSpecialOperationAdditionalInfosDocument, options);
      }
export function useGetSpecialOperationAdditionalInfosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSpecialOperationAdditionalInfosQuery, Generated.GetSpecialOperationAdditionalInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSpecialOperationAdditionalInfosQuery, Generated.GetSpecialOperationAdditionalInfosQueryVariables>(GetSpecialOperationAdditionalInfosDocument, options);
        }
export function useGetSpecialOperationAdditionalInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSpecialOperationAdditionalInfosQuery, Generated.GetSpecialOperationAdditionalInfosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSpecialOperationAdditionalInfosQuery, Generated.GetSpecialOperationAdditionalInfosQueryVariables>(GetSpecialOperationAdditionalInfosDocument, options);
        }
export type GetSpecialOperationAdditionalInfosQueryHookResult = ReturnType<typeof useGetSpecialOperationAdditionalInfosQuery>;
export type GetSpecialOperationAdditionalInfosLazyQueryHookResult = ReturnType<typeof useGetSpecialOperationAdditionalInfosLazyQuery>;
export type GetSpecialOperationAdditionalInfosSuspenseQueryHookResult = ReturnType<typeof useGetSpecialOperationAdditionalInfosSuspenseQuery>;
export type GetSpecialOperationAdditionalInfosQueryResult = Apollo.QueryResult<Generated.GetSpecialOperationAdditionalInfosQuery, Generated.GetSpecialOperationAdditionalInfosQueryVariables>;
export const GetSpecialOperationCustoDocument = /*#__PURE__*/ gql`
    query getSpecialOperationCusto($ref: ID!) {
  specialOperationByRef(ref: $ref) {
    ...SpecialOperationCusto
  }
}
    ${SpecialOperationCustoFragmentDoc}`;

/**
 * __useGetSpecialOperationCustoQuery__
 *
 * To run a query within a React component, call `useGetSpecialOperationCustoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialOperationCustoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialOperationCustoQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSpecialOperationCustoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSpecialOperationCustoQuery, Generated.GetSpecialOperationCustoQueryVariables> & ({ variables: Generated.GetSpecialOperationCustoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSpecialOperationCustoQuery, Generated.GetSpecialOperationCustoQueryVariables>(GetSpecialOperationCustoDocument, options);
      }
export function useGetSpecialOperationCustoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSpecialOperationCustoQuery, Generated.GetSpecialOperationCustoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSpecialOperationCustoQuery, Generated.GetSpecialOperationCustoQueryVariables>(GetSpecialOperationCustoDocument, options);
        }
export function useGetSpecialOperationCustoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSpecialOperationCustoQuery, Generated.GetSpecialOperationCustoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSpecialOperationCustoQuery, Generated.GetSpecialOperationCustoQueryVariables>(GetSpecialOperationCustoDocument, options);
        }
export type GetSpecialOperationCustoQueryHookResult = ReturnType<typeof useGetSpecialOperationCustoQuery>;
export type GetSpecialOperationCustoLazyQueryHookResult = ReturnType<typeof useGetSpecialOperationCustoLazyQuery>;
export type GetSpecialOperationCustoSuspenseQueryHookResult = ReturnType<typeof useGetSpecialOperationCustoSuspenseQuery>;
export type GetSpecialOperationCustoQueryResult = Apollo.QueryResult<Generated.GetSpecialOperationCustoQuery, Generated.GetSpecialOperationCustoQueryVariables>;
export const GetSpecialOperationEntitiesDocument = /*#__PURE__*/ gql`
    query getSpecialOperationEntities($id: ID!, $target: [Tag3D!], $brandId: ID = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false) {
  specialOperation(id: $id) {
    id
    targets(target: $target) {
      ...SpecialOperationHasTarget
    }
  }
}
    ${SpecialOperationHasTargetFragmentDoc}`;

/**
 * __useGetSpecialOperationEntitiesQuery__
 *
 * To run a query within a React component, call `useGetSpecialOperationEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialOperationEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialOperationEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      target: // value for 'target'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *   },
 * });
 */
export function useGetSpecialOperationEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSpecialOperationEntitiesQuery, Generated.GetSpecialOperationEntitiesQueryVariables> & ({ variables: Generated.GetSpecialOperationEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSpecialOperationEntitiesQuery, Generated.GetSpecialOperationEntitiesQueryVariables>(GetSpecialOperationEntitiesDocument, options);
      }
export function useGetSpecialOperationEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSpecialOperationEntitiesQuery, Generated.GetSpecialOperationEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSpecialOperationEntitiesQuery, Generated.GetSpecialOperationEntitiesQueryVariables>(GetSpecialOperationEntitiesDocument, options);
        }
export function useGetSpecialOperationEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSpecialOperationEntitiesQuery, Generated.GetSpecialOperationEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSpecialOperationEntitiesQuery, Generated.GetSpecialOperationEntitiesQueryVariables>(GetSpecialOperationEntitiesDocument, options);
        }
export type GetSpecialOperationEntitiesQueryHookResult = ReturnType<typeof useGetSpecialOperationEntitiesQuery>;
export type GetSpecialOperationEntitiesLazyQueryHookResult = ReturnType<typeof useGetSpecialOperationEntitiesLazyQuery>;
export type GetSpecialOperationEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetSpecialOperationEntitiesSuspenseQuery>;
export type GetSpecialOperationEntitiesQueryResult = Apollo.QueryResult<Generated.GetSpecialOperationEntitiesQuery, Generated.GetSpecialOperationEntitiesQueryVariables>;
export const GetSpecialOperationSlotsDocument = /*#__PURE__*/ gql`
    query getSpecialOperationSlots($ref: ID!) {
  specialOperationByRef(ref: $ref) {
    ...SpecialOperationSlots
  }
}
    ${SpecialOperationSlotsFragmentDoc}`;

/**
 * __useGetSpecialOperationSlotsQuery__
 *
 * To run a query within a React component, call `useGetSpecialOperationSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialOperationSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialOperationSlotsQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSpecialOperationSlotsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSpecialOperationSlotsQuery, Generated.GetSpecialOperationSlotsQueryVariables> & ({ variables: Generated.GetSpecialOperationSlotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSpecialOperationSlotsQuery, Generated.GetSpecialOperationSlotsQueryVariables>(GetSpecialOperationSlotsDocument, options);
      }
export function useGetSpecialOperationSlotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSpecialOperationSlotsQuery, Generated.GetSpecialOperationSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSpecialOperationSlotsQuery, Generated.GetSpecialOperationSlotsQueryVariables>(GetSpecialOperationSlotsDocument, options);
        }
export function useGetSpecialOperationSlotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSpecialOperationSlotsQuery, Generated.GetSpecialOperationSlotsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSpecialOperationSlotsQuery, Generated.GetSpecialOperationSlotsQueryVariables>(GetSpecialOperationSlotsDocument, options);
        }
export type GetSpecialOperationSlotsQueryHookResult = ReturnType<typeof useGetSpecialOperationSlotsQuery>;
export type GetSpecialOperationSlotsLazyQueryHookResult = ReturnType<typeof useGetSpecialOperationSlotsLazyQuery>;
export type GetSpecialOperationSlotsSuspenseQueryHookResult = ReturnType<typeof useGetSpecialOperationSlotsSuspenseQuery>;
export type GetSpecialOperationSlotsQueryResult = Apollo.QueryResult<Generated.GetSpecialOperationSlotsQuery, Generated.GetSpecialOperationSlotsQueryVariables>;
export const GetSpecialOperationsDocument = /*#__PURE__*/ gql`
    query getSpecialOperations($limit: Int, $offset: Int!, $brands: [ID!], $codes: [SpecialOperationCode!]) {
  specialOperations(
    limit: $limit
    offset: $offset
    brandIds: $brands
    codes: $codes
  ) {
    totalCount
    nodes {
      ...SpecialOperationItem
    }
  }
}
    ${SpecialOperationItemFragmentDoc}`;

/**
 * __useGetSpecialOperationsQuery__
 *
 * To run a query within a React component, call `useGetSpecialOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialOperationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brands: // value for 'brands'
 *      codes: // value for 'codes'
 *   },
 * });
 */
export function useGetSpecialOperationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSpecialOperationsQuery, Generated.GetSpecialOperationsQueryVariables> & ({ variables: Generated.GetSpecialOperationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSpecialOperationsQuery, Generated.GetSpecialOperationsQueryVariables>(GetSpecialOperationsDocument, options);
      }
export function useGetSpecialOperationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSpecialOperationsQuery, Generated.GetSpecialOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSpecialOperationsQuery, Generated.GetSpecialOperationsQueryVariables>(GetSpecialOperationsDocument, options);
        }
export function useGetSpecialOperationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSpecialOperationsQuery, Generated.GetSpecialOperationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSpecialOperationsQuery, Generated.GetSpecialOperationsQueryVariables>(GetSpecialOperationsDocument, options);
        }
export type GetSpecialOperationsQueryHookResult = ReturnType<typeof useGetSpecialOperationsQuery>;
export type GetSpecialOperationsLazyQueryHookResult = ReturnType<typeof useGetSpecialOperationsLazyQuery>;
export type GetSpecialOperationsSuspenseQueryHookResult = ReturnType<typeof useGetSpecialOperationsSuspenseQuery>;
export type GetSpecialOperationsQueryResult = Apollo.QueryResult<Generated.GetSpecialOperationsQuery, Generated.GetSpecialOperationsQueryVariables>;
export const GetSpecialOperationDocument = /*#__PURE__*/ gql`
    query getSpecialOperation($ref: ID!, $brandId: ID!, $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false) {
  specialOperationByRef(ref: $ref) {
    ...SpecialOperation
    ...SpecialOperationMetadata
  }
}
    ${SpecialOperationFragmentDoc}
${SpecialOperationMetadataFragmentDoc}`;

/**
 * __useGetSpecialOperationQuery__
 *
 * To run a query within a React component, call `useGetSpecialOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialOperationQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *   },
 * });
 */
export function useGetSpecialOperationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSpecialOperationQuery, Generated.GetSpecialOperationQueryVariables> & ({ variables: Generated.GetSpecialOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSpecialOperationQuery, Generated.GetSpecialOperationQueryVariables>(GetSpecialOperationDocument, options);
      }
export function useGetSpecialOperationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSpecialOperationQuery, Generated.GetSpecialOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSpecialOperationQuery, Generated.GetSpecialOperationQueryVariables>(GetSpecialOperationDocument, options);
        }
export function useGetSpecialOperationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSpecialOperationQuery, Generated.GetSpecialOperationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSpecialOperationQuery, Generated.GetSpecialOperationQueryVariables>(GetSpecialOperationDocument, options);
        }
export type GetSpecialOperationQueryHookResult = ReturnType<typeof useGetSpecialOperationQuery>;
export type GetSpecialOperationLazyQueryHookResult = ReturnType<typeof useGetSpecialOperationLazyQuery>;
export type GetSpecialOperationSuspenseQueryHookResult = ReturnType<typeof useGetSpecialOperationSuspenseQuery>;
export type GetSpecialOperationQueryResult = Apollo.QueryResult<Generated.GetSpecialOperationQuery, Generated.GetSpecialOperationQueryVariables>;
export const RemoveTargetFromSpecialOperationDocument = /*#__PURE__*/ gql`
    mutation removeTargetFromSpecialOperation($input: RemoveTargetFromSpecialOperationInput!) {
  removeTargetFromSpecialOperation(input: $input) {
    id
  }
}
    `;
export type RemoveTargetFromSpecialOperationMutationFn = Apollo.MutationFunction<Generated.RemoveTargetFromSpecialOperationMutation, Generated.RemoveTargetFromSpecialOperationMutationVariables>;

/**
 * __useRemoveTargetFromSpecialOperationMutation__
 *
 * To run a mutation, you first call `useRemoveTargetFromSpecialOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTargetFromSpecialOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTargetFromSpecialOperationMutation, { data, loading, error }] = useRemoveTargetFromSpecialOperationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTargetFromSpecialOperationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.RemoveTargetFromSpecialOperationMutation, Generated.RemoveTargetFromSpecialOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.RemoveTargetFromSpecialOperationMutation, Generated.RemoveTargetFromSpecialOperationMutationVariables>(RemoveTargetFromSpecialOperationDocument, options);
      }
export type RemoveTargetFromSpecialOperationMutationHookResult = ReturnType<typeof useRemoveTargetFromSpecialOperationMutation>;
export type RemoveTargetFromSpecialOperationMutationResult = Apollo.MutationResult<Generated.RemoveTargetFromSpecialOperationMutation>;
export type RemoveTargetFromSpecialOperationMutationOptions = Apollo.BaseMutationOptions<Generated.RemoveTargetFromSpecialOperationMutation, Generated.RemoveTargetFromSpecialOperationMutationVariables>;
export const UpdateSpecialOperationDocument = /*#__PURE__*/ gql`
    mutation updateSpecialOperation($input: UpdateSpecialOperationInput!, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false) {
  updateSpecialOperation(input: $input) {
    ...SpecialOperation
    ...SpecialOperationMetadata
  }
}
    ${SpecialOperationFragmentDoc}
${SpecialOperationMetadataFragmentDoc}`;
export type UpdateSpecialOperationMutationFn = Apollo.MutationFunction<Generated.UpdateSpecialOperationMutation, Generated.UpdateSpecialOperationMutationVariables>;

/**
 * __useUpdateSpecialOperationMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialOperationMutation, { data, loading, error }] = useUpdateSpecialOperationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *   },
 * });
 */
export function useUpdateSpecialOperationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSpecialOperationMutation, Generated.UpdateSpecialOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSpecialOperationMutation, Generated.UpdateSpecialOperationMutationVariables>(UpdateSpecialOperationDocument, options);
      }
export type UpdateSpecialOperationMutationHookResult = ReturnType<typeof useUpdateSpecialOperationMutation>;
export type UpdateSpecialOperationMutationResult = Apollo.MutationResult<Generated.UpdateSpecialOperationMutation>;
export type UpdateSpecialOperationMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSpecialOperationMutation, Generated.UpdateSpecialOperationMutationVariables>;
export const UpdateSpecialOperationTargetDocument = /*#__PURE__*/ gql`
    mutation updateSpecialOperationTarget($input: UpdateSpecialOperationTargetInput!) {
  updateSpecialOperationTarget(input: $input) {
    id
    rank
    startsAt
    endsAt
    data
  }
}
    `;
export type UpdateSpecialOperationTargetMutationFn = Apollo.MutationFunction<Generated.UpdateSpecialOperationTargetMutation, Generated.UpdateSpecialOperationTargetMutationVariables>;

/**
 * __useUpdateSpecialOperationTargetMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialOperationTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialOperationTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialOperationTargetMutation, { data, loading, error }] = useUpdateSpecialOperationTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialOperationTargetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSpecialOperationTargetMutation, Generated.UpdateSpecialOperationTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSpecialOperationTargetMutation, Generated.UpdateSpecialOperationTargetMutationVariables>(UpdateSpecialOperationTargetDocument, options);
      }
export type UpdateSpecialOperationTargetMutationHookResult = ReturnType<typeof useUpdateSpecialOperationTargetMutation>;
export type UpdateSpecialOperationTargetMutationResult = Apollo.MutationResult<Generated.UpdateSpecialOperationTargetMutation>;
export type UpdateSpecialOperationTargetMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSpecialOperationTargetMutation, Generated.UpdateSpecialOperationTargetMutationVariables>;
export const UpsertCanalHomeDocument = /*#__PURE__*/ gql`
    mutation upsertCanalHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: CanalHomeDataInput!, $name: String) {
  upsertCanalHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...CanalHomeSpecialOperation
  }
}
    ${CanalHomeSpecialOperationFragmentDoc}`;
export type UpsertCanalHomeMutationFn = Apollo.MutationFunction<Generated.UpsertCanalHomeMutation, Generated.UpsertCanalHomeMutationVariables>;

/**
 * __useUpsertCanalHomeMutation__
 *
 * To run a mutation, you first call `useUpsertCanalHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCanalHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCanalHomeMutation, { data, loading, error }] = useUpsertCanalHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertCanalHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertCanalHomeMutation, Generated.UpsertCanalHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertCanalHomeMutation, Generated.UpsertCanalHomeMutationVariables>(UpsertCanalHomeDocument, options);
      }
export type UpsertCanalHomeMutationHookResult = ReturnType<typeof useUpsertCanalHomeMutation>;
export type UpsertCanalHomeMutationResult = Apollo.MutationResult<Generated.UpsertCanalHomeMutation>;
export type UpsertCanalHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertCanalHomeMutation, Generated.UpsertCanalHomeMutationVariables>;
export const UpsertBannerHpDocument = /*#__PURE__*/ gql`
    mutation upsertBannerHP($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: BannerHPDataInput!, $name: String) {
  upsertBannerHP(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    id
    name
    ref
    rawId
    code
    startsAt
    endsAt
    brand {
      ...BrandOption
      country {
        id
      }
    }
    entity {
      __typename
      ... on Movie {
        ...MovieSearchEntity
      }
      ... on Series {
        ...SeriesSearchEntity
      }
      ... on SeriesSeason {
        ...SeriesSeasonSearchEntity
      }
      ... on Company {
        ...CompanySearchEntity
      }
      ... on News {
        ...NewsSearchEntity
      }
      ... on Slide {
        ...SlideSearchEntity
      }
    }
    data {
      __typename
      ... on BannerHPData {
        ...BannerHpData
      }
    }
    metadata {
      ...Metadata
    }
  }
}
    ${BrandOptionFragmentDoc}
${MovieSearchEntityFragmentDoc}
${SeriesSearchEntityFragmentDoc}
${SeriesSeasonSearchEntityFragmentDoc}
${CompanySearchEntityFragmentDoc}
${NewsSearchEntityFragmentDoc}
${SlideSearchEntityFragmentDoc}
${BannerHpDataFragmentDoc}
${MetadataFragmentDoc}`;
export type UpsertBannerHpMutationFn = Apollo.MutationFunction<Generated.UpsertBannerHpMutation, Generated.UpsertBannerHpMutationVariables>;

/**
 * __useUpsertBannerHpMutation__
 *
 * To run a mutation, you first call `useUpsertBannerHpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBannerHpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBannerHpMutation, { data, loading, error }] = useUpsertBannerHpMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertBannerHpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertBannerHpMutation, Generated.UpsertBannerHpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertBannerHpMutation, Generated.UpsertBannerHpMutationVariables>(UpsertBannerHpDocument, options);
      }
export type UpsertBannerHpMutationHookResult = ReturnType<typeof useUpsertBannerHpMutation>;
export type UpsertBannerHpMutationResult = Apollo.MutationResult<Generated.UpsertBannerHpMutation>;
export type UpsertBannerHpMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertBannerHpMutation, Generated.UpsertBannerHpMutationVariables>;
export const UpsertClub300Document = /*#__PURE__*/ gql`
    mutation upsertClub300($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: Club300DataInput!, $name: String) {
  upsertClub300(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    id
    name
    ref
    rawId
    code
    startsAt
    endsAt
    brand {
      ...BrandOption
      country {
        id
      }
    }
    entity {
      __typename
      ... on Movie {
        ...MovieSearchEntity
      }
      ... on Series {
        ...SeriesSearchEntity
      }
      ... on SeriesSeason {
        ...SeriesSeasonSearchEntity
      }
      ... on Company {
        ...CompanySearchEntity
      }
      ... on News {
        ...NewsSearchEntity
      }
      ... on Slide {
        ...SlideSearchEntity
      }
    }
    data {
      __typename
      ... on Club300Data {
        ...Club300Data
      }
    }
    metadata {
      ...Metadata
    }
  }
}
    ${BrandOptionFragmentDoc}
${MovieSearchEntityFragmentDoc}
${SeriesSearchEntityFragmentDoc}
${SeriesSeasonSearchEntityFragmentDoc}
${CompanySearchEntityFragmentDoc}
${NewsSearchEntityFragmentDoc}
${SlideSearchEntityFragmentDoc}
${Club300DataFragmentDoc}
${MetadataFragmentDoc}`;
export type UpsertClub300MutationFn = Apollo.MutationFunction<Generated.UpsertClub300Mutation, Generated.UpsertClub300MutationVariables>;

/**
 * __useUpsertClub300Mutation__
 *
 * To run a mutation, you first call `useUpsertClub300Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClub300Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClub300Mutation, { data, loading, error }] = useUpsertClub300Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertClub300Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertClub300Mutation, Generated.UpsertClub300MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertClub300Mutation, Generated.UpsertClub300MutationVariables>(UpsertClub300Document, options);
      }
export type UpsertClub300MutationHookResult = ReturnType<typeof useUpsertClub300Mutation>;
export type UpsertClub300MutationResult = Apollo.MutationResult<Generated.UpsertClub300Mutation>;
export type UpsertClub300MutationOptions = Apollo.BaseMutationOptions<Generated.UpsertClub300Mutation, Generated.UpsertClub300MutationVariables>;
export const UpsertClassiqueHomeDocument = /*#__PURE__*/ gql`
    mutation upsertClassiqueHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: ClassiqueHomeDataInput!, $name: String) {
  upsertClassiqueHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...ClassiqueHomeSpecialOperation
  }
}
    ${ClassiqueHomeSpecialOperationFragmentDoc}`;
export type UpsertClassiqueHomeMutationFn = Apollo.MutationFunction<Generated.UpsertClassiqueHomeMutation, Generated.UpsertClassiqueHomeMutationVariables>;

/**
 * __useUpsertClassiqueHomeMutation__
 *
 * To run a mutation, you first call `useUpsertClassiqueHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClassiqueHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClassiqueHomeMutation, { data, loading, error }] = useUpsertClassiqueHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertClassiqueHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertClassiqueHomeMutation, Generated.UpsertClassiqueHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertClassiqueHomeMutation, Generated.UpsertClassiqueHomeMutationVariables>(UpsertClassiqueHomeDocument, options);
      }
export type UpsertClassiqueHomeMutationHookResult = ReturnType<typeof useUpsertClassiqueHomeMutation>;
export type UpsertClassiqueHomeMutationResult = Apollo.MutationResult<Generated.UpsertClassiqueHomeMutation>;
export type UpsertClassiqueHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertClassiqueHomeMutation, Generated.UpsertClassiqueHomeMutationVariables>;
export const UpsertDolbyHomeDocument = /*#__PURE__*/ gql`
    mutation upsertDolbyHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: DolbyHomeDataInput!, $name: String) {
  upsertDolbyHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...DolbyHomeSpecialOperation
  }
}
    ${DolbyHomeSpecialOperationFragmentDoc}`;
export type UpsertDolbyHomeMutationFn = Apollo.MutationFunction<Generated.UpsertDolbyHomeMutation, Generated.UpsertDolbyHomeMutationVariables>;

/**
 * __useUpsertDolbyHomeMutation__
 *
 * To run a mutation, you first call `useUpsertDolbyHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDolbyHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDolbyHomeMutation, { data, loading, error }] = useUpsertDolbyHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertDolbyHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertDolbyHomeMutation, Generated.UpsertDolbyHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertDolbyHomeMutation, Generated.UpsertDolbyHomeMutationVariables>(UpsertDolbyHomeDocument, options);
      }
export type UpsertDolbyHomeMutationHookResult = ReturnType<typeof useUpsertDolbyHomeMutation>;
export type UpsertDolbyHomeMutationResult = Apollo.MutationResult<Generated.UpsertDolbyHomeMutation>;
export type UpsertDolbyHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertDolbyHomeMutation, Generated.UpsertDolbyHomeMutationVariables>;
export const UpsertEmergenceMovieDocument = /*#__PURE__*/ gql`
    mutation upsertEmergenceMovie($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: EmergenceMovieDataInput!, $name: String) {
  upsertEmergenceMovie(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...EmergenceMovieSpecialOperation
  }
}
    ${EmergenceMovieSpecialOperationFragmentDoc}`;
export type UpsertEmergenceMovieMutationFn = Apollo.MutationFunction<Generated.UpsertEmergenceMovieMutation, Generated.UpsertEmergenceMovieMutationVariables>;

/**
 * __useUpsertEmergenceMovieMutation__
 *
 * To run a mutation, you first call `useUpsertEmergenceMovieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmergenceMovieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEmergenceMovieMutation, { data, loading, error }] = useUpsertEmergenceMovieMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertEmergenceMovieMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertEmergenceMovieMutation, Generated.UpsertEmergenceMovieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertEmergenceMovieMutation, Generated.UpsertEmergenceMovieMutationVariables>(UpsertEmergenceMovieDocument, options);
      }
export type UpsertEmergenceMovieMutationHookResult = ReturnType<typeof useUpsertEmergenceMovieMutation>;
export type UpsertEmergenceMovieMutationResult = Apollo.MutationResult<Generated.UpsertEmergenceMovieMutation>;
export type UpsertEmergenceMovieMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertEmergenceMovieMutation, Generated.UpsertEmergenceMovieMutationVariables>;
export const UpsertDisneyHomeDocument = /*#__PURE__*/ gql`
    mutation upsertDisneyHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: DisneyHomeDataInput!, $name: String) {
  upsertDisneyHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...DisneyHomeSpecialOperation
  }
}
    ${DisneyHomeSpecialOperationFragmentDoc}`;
export type UpsertDisneyHomeMutationFn = Apollo.MutationFunction<Generated.UpsertDisneyHomeMutation, Generated.UpsertDisneyHomeMutationVariables>;

/**
 * __useUpsertDisneyHomeMutation__
 *
 * To run a mutation, you first call `useUpsertDisneyHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDisneyHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDisneyHomeMutation, { data, loading, error }] = useUpsertDisneyHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertDisneyHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertDisneyHomeMutation, Generated.UpsertDisneyHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertDisneyHomeMutation, Generated.UpsertDisneyHomeMutationVariables>(UpsertDisneyHomeDocument, options);
      }
export type UpsertDisneyHomeMutationHookResult = ReturnType<typeof useUpsertDisneyHomeMutation>;
export type UpsertDisneyHomeMutationResult = Apollo.MutationResult<Generated.UpsertDisneyHomeMutation>;
export type UpsertDisneyHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertDisneyHomeMutation, Generated.UpsertDisneyHomeMutationVariables>;
export const UpsertEmergenceSeriesDocument = /*#__PURE__*/ gql`
    mutation upsertEmergenceSeries($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: EmergenceSeriesDataInput!, $name: String) {
  upsertEmergenceSeries(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...EmergenceSeriesSpecialOperation
  }
}
    ${EmergenceSeriesSpecialOperationFragmentDoc}`;
export type UpsertEmergenceSeriesMutationFn = Apollo.MutationFunction<Generated.UpsertEmergenceSeriesMutation, Generated.UpsertEmergenceSeriesMutationVariables>;

/**
 * __useUpsertEmergenceSeriesMutation__
 *
 * To run a mutation, you first call `useUpsertEmergenceSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmergenceSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEmergenceSeriesMutation, { data, loading, error }] = useUpsertEmergenceSeriesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertEmergenceSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertEmergenceSeriesMutation, Generated.UpsertEmergenceSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertEmergenceSeriesMutation, Generated.UpsertEmergenceSeriesMutationVariables>(UpsertEmergenceSeriesDocument, options);
      }
export type UpsertEmergenceSeriesMutationHookResult = ReturnType<typeof useUpsertEmergenceSeriesMutation>;
export type UpsertEmergenceSeriesMutationResult = Apollo.MutationResult<Generated.UpsertEmergenceSeriesMutation>;
export type UpsertEmergenceSeriesMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertEmergenceSeriesMutation, Generated.UpsertEmergenceSeriesMutationVariables>;
export const UpsertFestivalSectionDocument = /*#__PURE__*/ gql`
    mutation upsertFestivalSection($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: FestivalSectionDataInput!, $name: String) {
  upsertFestivalSection(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...FestivalSectionSpecialOperation
  }
}
    ${FestivalSectionSpecialOperationFragmentDoc}`;
export type UpsertFestivalSectionMutationFn = Apollo.MutationFunction<Generated.UpsertFestivalSectionMutation, Generated.UpsertFestivalSectionMutationVariables>;

/**
 * __useUpsertFestivalSectionMutation__
 *
 * To run a mutation, you first call `useUpsertFestivalSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFestivalSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFestivalSectionMutation, { data, loading, error }] = useUpsertFestivalSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertFestivalSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertFestivalSectionMutation, Generated.UpsertFestivalSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertFestivalSectionMutation, Generated.UpsertFestivalSectionMutationVariables>(UpsertFestivalSectionDocument, options);
      }
export type UpsertFestivalSectionMutationHookResult = ReturnType<typeof useUpsertFestivalSectionMutation>;
export type UpsertFestivalSectionMutationResult = Apollo.MutationResult<Generated.UpsertFestivalSectionMutation>;
export type UpsertFestivalSectionMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertFestivalSectionMutation, Generated.UpsertFestivalSectionMutationVariables>;
export const UpsertEmergenceTheaterDocument = /*#__PURE__*/ gql`
    mutation upsertEmergenceTheater($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: EmergenceTheaterDataInput!, $name: String) {
  upsertEmergenceTheater(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...EmergenceTheaterSpecialOperation
  }
}
    ${EmergenceTheaterSpecialOperationFragmentDoc}`;
export type UpsertEmergenceTheaterMutationFn = Apollo.MutationFunction<Generated.UpsertEmergenceTheaterMutation, Generated.UpsertEmergenceTheaterMutationVariables>;

/**
 * __useUpsertEmergenceTheaterMutation__
 *
 * To run a mutation, you first call `useUpsertEmergenceTheaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmergenceTheaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEmergenceTheaterMutation, { data, loading, error }] = useUpsertEmergenceTheaterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertEmergenceTheaterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertEmergenceTheaterMutation, Generated.UpsertEmergenceTheaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertEmergenceTheaterMutation, Generated.UpsertEmergenceTheaterMutationVariables>(UpsertEmergenceTheaterDocument, options);
      }
export type UpsertEmergenceTheaterMutationHookResult = ReturnType<typeof useUpsertEmergenceTheaterMutation>;
export type UpsertEmergenceTheaterMutationResult = Apollo.MutationResult<Generated.UpsertEmergenceTheaterMutation>;
export type UpsertEmergenceTheaterMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertEmergenceTheaterMutation, Generated.UpsertEmergenceTheaterMutationVariables>;
export const UpsertImaxHomeDocument = /*#__PURE__*/ gql`
    mutation upsertIMAXHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: IMAXHomeDataInput!, $name: String) {
  upsertIMAXHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...IMAXHomeSpecialOperation
  }
}
    ${ImaxHomeSpecialOperationFragmentDoc}`;
export type UpsertImaxHomeMutationFn = Apollo.MutationFunction<Generated.UpsertImaxHomeMutation, Generated.UpsertImaxHomeMutationVariables>;

/**
 * __useUpsertImaxHomeMutation__
 *
 * To run a mutation, you first call `useUpsertImaxHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertImaxHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertImaxHomeMutation, { data, loading, error }] = useUpsertImaxHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertImaxHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertImaxHomeMutation, Generated.UpsertImaxHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertImaxHomeMutation, Generated.UpsertImaxHomeMutationVariables>(UpsertImaxHomeDocument, options);
      }
export type UpsertImaxHomeMutationHookResult = ReturnType<typeof useUpsertImaxHomeMutation>;
export type UpsertImaxHomeMutationResult = Apollo.MutationResult<Generated.UpsertImaxHomeMutation>;
export type UpsertImaxHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertImaxHomeMutation, Generated.UpsertImaxHomeMutationVariables>;
export const UpsertEmergenceSvodDocument = /*#__PURE__*/ gql`
    mutation upsertEmergenceSVOD($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: EmergenceSVODDataInput!, $name: String) {
  upsertEmergenceSVOD(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...EmergenceSVODSpecialOperation
  }
}
    ${EmergenceSvodSpecialOperationFragmentDoc}`;
export type UpsertEmergenceSvodMutationFn = Apollo.MutationFunction<Generated.UpsertEmergenceSvodMutation, Generated.UpsertEmergenceSvodMutationVariables>;

/**
 * __useUpsertEmergenceSvodMutation__
 *
 * To run a mutation, you first call `useUpsertEmergenceSvodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmergenceSvodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEmergenceSvodMutation, { data, loading, error }] = useUpsertEmergenceSvodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertEmergenceSvodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertEmergenceSvodMutation, Generated.UpsertEmergenceSvodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertEmergenceSvodMutation, Generated.UpsertEmergenceSvodMutationVariables>(UpsertEmergenceSvodDocument, options);
      }
export type UpsertEmergenceSvodMutationHookResult = ReturnType<typeof useUpsertEmergenceSvodMutation>;
export type UpsertEmergenceSvodMutationResult = Apollo.MutationResult<Generated.UpsertEmergenceSvodMutation>;
export type UpsertEmergenceSvodMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertEmergenceSvodMutation, Generated.UpsertEmergenceSvodMutationVariables>;
export const UpsertM6HomeDocument = /*#__PURE__*/ gql`
    mutation upsertM6Home($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: M6HomeDataInput!, $name: String) {
  upsertM6Home(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...M6HomeSpecialOperation
  }
}
    ${M6HomeSpecialOperationFragmentDoc}`;
export type UpsertM6HomeMutationFn = Apollo.MutationFunction<Generated.UpsertM6HomeMutation, Generated.UpsertM6HomeMutationVariables>;

/**
 * __useUpsertM6HomeMutation__
 *
 * To run a mutation, you first call `useUpsertM6HomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertM6HomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertM6HomeMutation, { data, loading, error }] = useUpsertM6HomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertM6HomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertM6HomeMutation, Generated.UpsertM6HomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertM6HomeMutation, Generated.UpsertM6HomeMutationVariables>(UpsertM6HomeDocument, options);
      }
export type UpsertM6HomeMutationHookResult = ReturnType<typeof useUpsertM6HomeMutation>;
export type UpsertM6HomeMutationResult = Apollo.MutationResult<Generated.UpsertM6HomeMutation>;
export type UpsertM6HomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertM6HomeMutation, Generated.UpsertM6HomeMutationVariables>;
export const UpsertIndelebileHomeDocument = /*#__PURE__*/ gql`
    mutation upsertIndelebileHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: IndelebileHomeDataInput!, $name: String) {
  upsertIndelebileHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...IndelebileHomeSpecialOperation
  }
}
    ${IndelebileHomeSpecialOperationFragmentDoc}`;
export type UpsertIndelebileHomeMutationFn = Apollo.MutationFunction<Generated.UpsertIndelebileHomeMutation, Generated.UpsertIndelebileHomeMutationVariables>;

/**
 * __useUpsertIndelebileHomeMutation__
 *
 * To run a mutation, you first call `useUpsertIndelebileHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIndelebileHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertIndelebileHomeMutation, { data, loading, error }] = useUpsertIndelebileHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertIndelebileHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertIndelebileHomeMutation, Generated.UpsertIndelebileHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertIndelebileHomeMutation, Generated.UpsertIndelebileHomeMutationVariables>(UpsertIndelebileHomeDocument, options);
      }
export type UpsertIndelebileHomeMutationHookResult = ReturnType<typeof useUpsertIndelebileHomeMutation>;
export type UpsertIndelebileHomeMutationResult = Apollo.MutationResult<Generated.UpsertIndelebileHomeMutation>;
export type UpsertIndelebileHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertIndelebileHomeMutation, Generated.UpsertIndelebileHomeMutationVariables>;
export const UpsertFilmesOnlineDocument = /*#__PURE__*/ gql`
    mutation upsertFilmesOnline($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: FilmesOnlineDataInput!, $name: String) {
  upsertFilmesOnline(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...FilmesOnlineSpecialOperation
  }
}
    ${FilmesOnlineSpecialOperationFragmentDoc}`;
export type UpsertFilmesOnlineMutationFn = Apollo.MutationFunction<Generated.UpsertFilmesOnlineMutation, Generated.UpsertFilmesOnlineMutationVariables>;

/**
 * __useUpsertFilmesOnlineMutation__
 *
 * To run a mutation, you first call `useUpsertFilmesOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFilmesOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFilmesOnlineMutation, { data, loading, error }] = useUpsertFilmesOnlineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertFilmesOnlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertFilmesOnlineMutation, Generated.UpsertFilmesOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertFilmesOnlineMutation, Generated.UpsertFilmesOnlineMutationVariables>(UpsertFilmesOnlineDocument, options);
      }
export type UpsertFilmesOnlineMutationHookResult = ReturnType<typeof useUpsertFilmesOnlineMutation>;
export type UpsertFilmesOnlineMutationResult = Apollo.MutationResult<Generated.UpsertFilmesOnlineMutation>;
export type UpsertFilmesOnlineMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertFilmesOnlineMutation, Generated.UpsertFilmesOnlineMutationVariables>;
export const UpsertRollerHomeDocument = /*#__PURE__*/ gql`
    mutation upsertRollerHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: RollerHomeDataInput!, $name: String) {
  upsertRollerHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...RollerHomeSpecialOperation
  }
}
    ${RollerHomeSpecialOperationFragmentDoc}`;
export type UpsertRollerHomeMutationFn = Apollo.MutationFunction<Generated.UpsertRollerHomeMutation, Generated.UpsertRollerHomeMutationVariables>;

/**
 * __useUpsertRollerHomeMutation__
 *
 * To run a mutation, you first call `useUpsertRollerHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRollerHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRollerHomeMutation, { data, loading, error }] = useUpsertRollerHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertRollerHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertRollerHomeMutation, Generated.UpsertRollerHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertRollerHomeMutation, Generated.UpsertRollerHomeMutationVariables>(UpsertRollerHomeDocument, options);
      }
export type UpsertRollerHomeMutationHookResult = ReturnType<typeof useUpsertRollerHomeMutation>;
export type UpsertRollerHomeMutationResult = Apollo.MutationResult<Generated.UpsertRollerHomeMutation>;
export type UpsertRollerHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertRollerHomeMutation, Generated.UpsertRollerHomeMutationVariables>;
export const UpsertMaxHomeDocument = /*#__PURE__*/ gql`
    mutation upsertMaxHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: MaxHomeDataInput!, $name: String) {
  upsertMaxHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...MaxHomeSpecialOperation
  }
}
    ${MaxHomeSpecialOperationFragmentDoc}`;
export type UpsertMaxHomeMutationFn = Apollo.MutationFunction<Generated.UpsertMaxHomeMutation, Generated.UpsertMaxHomeMutationVariables>;

/**
 * __useUpsertMaxHomeMutation__
 *
 * To run a mutation, you first call `useUpsertMaxHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMaxHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMaxHomeMutation, { data, loading, error }] = useUpsertMaxHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertMaxHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertMaxHomeMutation, Generated.UpsertMaxHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertMaxHomeMutation, Generated.UpsertMaxHomeMutationVariables>(UpsertMaxHomeDocument, options);
      }
export type UpsertMaxHomeMutationHookResult = ReturnType<typeof useUpsertMaxHomeMutation>;
export type UpsertMaxHomeMutationResult = Apollo.MutationResult<Generated.UpsertMaxHomeMutation>;
export type UpsertMaxHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertMaxHomeMutation, Generated.UpsertMaxHomeMutationVariables>;
export const UpsertMobileDdayDocument = /*#__PURE__*/ gql`
    mutation upsertMobileDday($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: MobileDdayDataInput!, $name: String) {
  upsertMobileDday(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...MobileDdaySpecialOperation
  }
}
    ${MobileDdaySpecialOperationFragmentDoc}`;
export type UpsertMobileDdayMutationFn = Apollo.MutationFunction<Generated.UpsertMobileDdayMutation, Generated.UpsertMobileDdayMutationVariables>;

/**
 * __useUpsertMobileDdayMutation__
 *
 * To run a mutation, you first call `useUpsertMobileDdayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMobileDdayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMobileDdayMutation, { data, loading, error }] = useUpsertMobileDdayMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertMobileDdayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertMobileDdayMutation, Generated.UpsertMobileDdayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertMobileDdayMutation, Generated.UpsertMobileDdayMutationVariables>(UpsertMobileDdayDocument, options);
      }
export type UpsertMobileDdayMutationHookResult = ReturnType<typeof useUpsertMobileDdayMutation>;
export type UpsertMobileDdayMutationResult = Apollo.MutationResult<Generated.UpsertMobileDdayMutation>;
export type UpsertMobileDdayMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertMobileDdayMutation, Generated.UpsertMobileDdayMutationVariables>;
export const UpsertSponsoredAutocompleteDocument = /*#__PURE__*/ gql`
    mutation upsertSponsoredAutocomplete($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: SponsoredAutocompleteDataInput!, $name: String) {
  upsertSponsoredAutocomplete(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...SponsoredAutocompleteSpecialOperation
  }
}
    ${SponsoredAutocompleteSpecialOperationFragmentDoc}`;
export type UpsertSponsoredAutocompleteMutationFn = Apollo.MutationFunction<Generated.UpsertSponsoredAutocompleteMutation, Generated.UpsertSponsoredAutocompleteMutationVariables>;

/**
 * __useUpsertSponsoredAutocompleteMutation__
 *
 * To run a mutation, you first call `useUpsertSponsoredAutocompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSponsoredAutocompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSponsoredAutocompleteMutation, { data, loading, error }] = useUpsertSponsoredAutocompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertSponsoredAutocompleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertSponsoredAutocompleteMutation, Generated.UpsertSponsoredAutocompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertSponsoredAutocompleteMutation, Generated.UpsertSponsoredAutocompleteMutationVariables>(UpsertSponsoredAutocompleteDocument, options);
      }
export type UpsertSponsoredAutocompleteMutationHookResult = ReturnType<typeof useUpsertSponsoredAutocompleteMutation>;
export type UpsertSponsoredAutocompleteMutationResult = Apollo.MutationResult<Generated.UpsertSponsoredAutocompleteMutation>;
export type UpsertSponsoredAutocompleteMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertSponsoredAutocompleteMutation, Generated.UpsertSponsoredAutocompleteMutationVariables>;
export const UpsertTf1HomeDocument = /*#__PURE__*/ gql`
    mutation upsertTF1Home($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: TF1HomeDataInput!, $name: String) {
  upsertTF1Home(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...TF1HomeSpecialOperation
  }
}
    ${Tf1HomeSpecialOperationFragmentDoc}`;
export type UpsertTf1HomeMutationFn = Apollo.MutationFunction<Generated.UpsertTf1HomeMutation, Generated.UpsertTf1HomeMutationVariables>;

/**
 * __useUpsertTf1HomeMutation__
 *
 * To run a mutation, you first call `useUpsertTf1HomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTf1HomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTf1HomeMutation, { data, loading, error }] = useUpsertTf1HomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertTf1HomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertTf1HomeMutation, Generated.UpsertTf1HomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertTf1HomeMutation, Generated.UpsertTf1HomeMutationVariables>(UpsertTf1HomeDocument, options);
      }
export type UpsertTf1HomeMutationHookResult = ReturnType<typeof useUpsertTf1HomeMutation>;
export type UpsertTf1HomeMutationResult = Apollo.MutationResult<Generated.UpsertTf1HomeMutation>;
export type UpsertTf1HomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertTf1HomeMutation, Generated.UpsertTf1HomeMutationVariables>;
export const UpsertTicketAnchorDocument = /*#__PURE__*/ gql`
    mutation upsertTicketAnchor($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: TicketAnchorDataInput!, $name: String) {
  upsertTicketAnchor(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...TicketAnchorSpecialOperation
  }
}
    ${TicketAnchorSpecialOperationFragmentDoc}`;
export type UpsertTicketAnchorMutationFn = Apollo.MutationFunction<Generated.UpsertTicketAnchorMutation, Generated.UpsertTicketAnchorMutationVariables>;

/**
 * __useUpsertTicketAnchorMutation__
 *
 * To run a mutation, you first call `useUpsertTicketAnchorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTicketAnchorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTicketAnchorMutation, { data, loading, error }] = useUpsertTicketAnchorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertTicketAnchorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertTicketAnchorMutation, Generated.UpsertTicketAnchorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertTicketAnchorMutation, Generated.UpsertTicketAnchorMutationVariables>(UpsertTicketAnchorDocument, options);
      }
export type UpsertTicketAnchorMutationHookResult = ReturnType<typeof useUpsertTicketAnchorMutation>;
export type UpsertTicketAnchorMutationResult = Apollo.MutationResult<Generated.UpsertTicketAnchorMutation>;
export type UpsertTicketAnchorMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertTicketAnchorMutation, Generated.UpsertTicketAnchorMutationVariables>;
export const UpsertNovelasHomeDocument = /*#__PURE__*/ gql`
    mutation upsertNovelasHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: NovelasHomeDataInput!, $name: String) {
  upsertNovelasHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...NovelasHomeSpecialOperation
  }
}
    ${NovelasHomeSpecialOperationFragmentDoc}`;
export type UpsertNovelasHomeMutationFn = Apollo.MutationFunction<Generated.UpsertNovelasHomeMutation, Generated.UpsertNovelasHomeMutationVariables>;

/**
 * __useUpsertNovelasHomeMutation__
 *
 * To run a mutation, you first call `useUpsertNovelasHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNovelasHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNovelasHomeMutation, { data, loading, error }] = useUpsertNovelasHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertNovelasHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertNovelasHomeMutation, Generated.UpsertNovelasHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertNovelasHomeMutation, Generated.UpsertNovelasHomeMutationVariables>(UpsertNovelasHomeDocument, options);
      }
export type UpsertNovelasHomeMutationHookResult = ReturnType<typeof useUpsertNovelasHomeMutation>;
export type UpsertNovelasHomeMutationResult = Apollo.MutationResult<Generated.UpsertNovelasHomeMutation>;
export type UpsertNovelasHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertNovelasHomeMutation, Generated.UpsertNovelasHomeMutationVariables>;
export const CreateTagDocument = /*#__PURE__*/ gql`
    mutation createTag($input: CreateTagInput!) {
  createTag(input: $input) {
    id
    ...TagIdentity
  }
}
    ${TagIdentityFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<Generated.CreateTagMutation, Generated.CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateTagMutation, Generated.CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateTagMutation, Generated.CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<Generated.CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<Generated.CreateTagMutation, Generated.CreateTagMutationVariables>;
export const GetTagEntitiesDocument = /*#__PURE__*/ gql`
    query getTagEntities($id: ID!, $limit: Int!, $offset: Int!, $entityType: String) {
  tag(id: $id) {
    id
    entities(limit: $limit, offset: $offset, entityType: $entityType) {
      totalCount
      nodes {
        ...EntityTag
      }
    }
  }
}
    ${EntityTagFragmentDoc}`;

/**
 * __useGetTagEntitiesQuery__
 *
 * To run a query within a React component, call `useGetTagEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetTagEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTagEntitiesQuery, Generated.GetTagEntitiesQueryVariables> & ({ variables: Generated.GetTagEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTagEntitiesQuery, Generated.GetTagEntitiesQueryVariables>(GetTagEntitiesDocument, options);
      }
export function useGetTagEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTagEntitiesQuery, Generated.GetTagEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTagEntitiesQuery, Generated.GetTagEntitiesQueryVariables>(GetTagEntitiesDocument, options);
        }
export function useGetTagEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTagEntitiesQuery, Generated.GetTagEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTagEntitiesQuery, Generated.GetTagEntitiesQueryVariables>(GetTagEntitiesDocument, options);
        }
export type GetTagEntitiesQueryHookResult = ReturnType<typeof useGetTagEntitiesQuery>;
export type GetTagEntitiesLazyQueryHookResult = ReturnType<typeof useGetTagEntitiesLazyQuery>;
export type GetTagEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetTagEntitiesSuspenseQuery>;
export type GetTagEntitiesQueryResult = Apollo.QueryResult<Generated.GetTagEntitiesQuery, Generated.GetTagEntitiesQueryVariables>;
export const UpsertVodHomeDocument = /*#__PURE__*/ gql`
    mutation upsertVODHome($id: ID, $brandId: ID! = "", $localeId: ID = "", $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false, $startsAt: DateTimeWithoutTz!, $endsAt: DateTimeWithoutTz, $entityId: ID, $data: VODHomeDataInput!, $name: String) {
  upsertVODHome(
    id: $id
    brandId: $brandId
    startsAt: $startsAt
    endsAt: $endsAt
    entityId: $entityId
    data: $data
    name: $name
  ) {
    ...VODHomeSpecialOperation
  }
}
    ${VodHomeSpecialOperationFragmentDoc}`;
export type UpsertVodHomeMutationFn = Apollo.MutationFunction<Generated.UpsertVodHomeMutation, Generated.UpsertVodHomeMutationVariables>;

/**
 * __useUpsertVodHomeMutation__
 *
 * To run a mutation, you first call `useUpsertVodHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVodHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVodHomeMutation, { data, loading, error }] = useUpsertVodHomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      entityId: // value for 'entityId'
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertVodHomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpsertVodHomeMutation, Generated.UpsertVodHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpsertVodHomeMutation, Generated.UpsertVodHomeMutationVariables>(UpsertVodHomeDocument, options);
      }
export type UpsertVodHomeMutationHookResult = ReturnType<typeof useUpsertVodHomeMutation>;
export type UpsertVodHomeMutationResult = Apollo.MutationResult<Generated.UpsertVodHomeMutation>;
export type UpsertVodHomeMutationOptions = Apollo.BaseMutationOptions<Generated.UpsertVodHomeMutation, Generated.UpsertVodHomeMutationVariables>;
export const GetTagDocument = /*#__PURE__*/ gql`
    query getTag($ref: ID!) {
  tagByRef(ref: $ref) {
    ...TagIdentity
    ...TagSeo
    ...TagMetadata
  }
}
    ${TagIdentityFragmentDoc}
${TagSeoFragmentDoc}
${TagMetadataFragmentDoc}`;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTagQuery, Generated.GetTagQueryVariables> & ({ variables: Generated.GetTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTagQuery, Generated.GetTagQueryVariables>(GetTagDocument, options);
      }
export function useGetTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTagQuery, Generated.GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTagQuery, Generated.GetTagQueryVariables>(GetTagDocument, options);
        }
export function useGetTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTagQuery, Generated.GetTagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTagQuery, Generated.GetTagQueryVariables>(GetTagDocument, options);
        }
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagSuspenseQueryHookResult = ReturnType<typeof useGetTagSuspenseQuery>;
export type GetTagQueryResult = Apollo.QueryResult<Generated.GetTagQuery, Generated.GetTagQueryVariables>;
export const ToggleTagActivationDocument = /*#__PURE__*/ gql`
    mutation toggleTagActivation($input: ToggleTagActivationInput!) {
  toggleTagActivation(input: $input) {
    id
  }
}
    `;
export type ToggleTagActivationMutationFn = Apollo.MutationFunction<Generated.ToggleTagActivationMutation, Generated.ToggleTagActivationMutationVariables>;

/**
 * __useToggleTagActivationMutation__
 *
 * To run a mutation, you first call `useToggleTagActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTagActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTagActivationMutation, { data, loading, error }] = useToggleTagActivationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleTagActivationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.ToggleTagActivationMutation, Generated.ToggleTagActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.ToggleTagActivationMutation, Generated.ToggleTagActivationMutationVariables>(ToggleTagActivationDocument, options);
      }
export type ToggleTagActivationMutationHookResult = ReturnType<typeof useToggleTagActivationMutation>;
export type ToggleTagActivationMutationResult = Apollo.MutationResult<Generated.ToggleTagActivationMutation>;
export type ToggleTagActivationMutationOptions = Apollo.BaseMutationOptions<Generated.ToggleTagActivationMutation, Generated.ToggleTagActivationMutationVariables>;
export const GetTagsDocument = /*#__PURE__*/ gql`
    query getTags($limit: Int, $offset: Int!, $search: String, $brandId: ID, $orderBy: TagOrder) {
  tags(
    limit: $limit
    offset: $offset
    search: $search
    brandId: $brandId
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTagsQuery, Generated.GetTagsQueryVariables> & ({ variables: Generated.GetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTagsQuery, Generated.GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTagsQuery, Generated.GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTagsQuery, Generated.GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTagsQuery, Generated.GetTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTagsQuery, Generated.GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<Generated.GetTagsQuery, Generated.GetTagsQueryVariables>;
export const GetTagListDocument = /*#__PURE__*/ gql`
    query getTagList($limit: Int, $offset: Int!, $search: String, $brandId: ID, $orderBy: TagOrder) {
  tags(
    limit: $limit
    offset: $offset
    search: $search
    brandId: $brandId
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...TagIdentity
    }
  }
}
    ${TagIdentityFragmentDoc}`;

/**
 * __useGetTagListQuery__
 *
 * To run a query within a React component, call `useGetTagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetTagListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTagListQuery, Generated.GetTagListQueryVariables> & ({ variables: Generated.GetTagListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTagListQuery, Generated.GetTagListQueryVariables>(GetTagListDocument, options);
      }
export function useGetTagListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTagListQuery, Generated.GetTagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTagListQuery, Generated.GetTagListQueryVariables>(GetTagListDocument, options);
        }
export function useGetTagListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTagListQuery, Generated.GetTagListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTagListQuery, Generated.GetTagListQueryVariables>(GetTagListDocument, options);
        }
export type GetTagListQueryHookResult = ReturnType<typeof useGetTagListQuery>;
export type GetTagListLazyQueryHookResult = ReturnType<typeof useGetTagListLazyQuery>;
export type GetTagListSuspenseQueryHookResult = ReturnType<typeof useGetTagListSuspenseQuery>;
export type GetTagListQueryResult = Apollo.QueryResult<Generated.GetTagListQuery, Generated.GetTagListQueryVariables>;
export const UpdateTagRankDocument = /*#__PURE__*/ gql`
    mutation updateTagRank($input: UpdateTagRankInput!) {
  updateTagRank(input: $input) {
    id
  }
}
    `;
export type UpdateTagRankMutationFn = Apollo.MutationFunction<Generated.UpdateTagRankMutation, Generated.UpdateTagRankMutationVariables>;

/**
 * __useUpdateTagRankMutation__
 *
 * To run a mutation, you first call `useUpdateTagRankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagRankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagRankMutation, { data, loading, error }] = useUpdateTagRankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagRankMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTagRankMutation, Generated.UpdateTagRankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTagRankMutation, Generated.UpdateTagRankMutationVariables>(UpdateTagRankDocument, options);
      }
export type UpdateTagRankMutationHookResult = ReturnType<typeof useUpdateTagRankMutation>;
export type UpdateTagRankMutationResult = Apollo.MutationResult<Generated.UpdateTagRankMutation>;
export type UpdateTagRankMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTagRankMutation, Generated.UpdateTagRankMutationVariables>;
export const AddFareDocument = /*#__PURE__*/ gql`
    mutation addFare($input: AddFareInput!) {
  addFare(input: $input) {
    id
    theater {
      __typename
      id
      ref
      code
      country {
        ...CountryOption
      }
      ...TheaterFareList
      ...TheaterMetadata
    }
  }
}
    ${CountryOptionFragmentDoc}
${TheaterFareListFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type AddFareMutationFn = Apollo.MutationFunction<Generated.AddFareMutation, Generated.AddFareMutationVariables>;

/**
 * __useAddFareMutation__
 *
 * To run a mutation, you first call `useAddFareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFareMutation, { data, loading, error }] = useAddFareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddFareMutation, Generated.AddFareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddFareMutation, Generated.AddFareMutationVariables>(AddFareDocument, options);
      }
export type AddFareMutationHookResult = ReturnType<typeof useAddFareMutation>;
export type AddFareMutationResult = Apollo.MutationResult<Generated.AddFareMutation>;
export type AddFareMutationOptions = Apollo.BaseMutationOptions<Generated.AddFareMutation, Generated.AddFareMutationVariables>;
export const UpdateTagDocument = /*#__PURE__*/ gql`
    mutation updateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    ...TagIdentity
    ...TagSeo
  }
}
    ${TagIdentityFragmentDoc}
${TagSeoFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<Generated.UpdateTagMutation, Generated.UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTagMutation, Generated.UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTagMutation, Generated.UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<Generated.UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTagMutation, Generated.UpdateTagMutationVariables>;
export const AddImageToTheaterDocument = /*#__PURE__*/ gql`
    mutation addImageToTheater($entityId: ID!, $imageId: ID!) {
  addImageToTheater(input: {entityId: $entityId, imageId: $imageId}) {
    ...ImageReference
  }
}
    ${ImageReferenceFragmentDoc}`;
export type AddImageToTheaterMutationFn = Apollo.MutationFunction<Generated.AddImageToTheaterMutation, Generated.AddImageToTheaterMutationVariables>;

/**
 * __useAddImageToTheaterMutation__
 *
 * To run a mutation, you first call `useAddImageToTheaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddImageToTheaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addImageToTheaterMutation, { data, loading, error }] = useAddImageToTheaterMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useAddImageToTheaterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddImageToTheaterMutation, Generated.AddImageToTheaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddImageToTheaterMutation, Generated.AddImageToTheaterMutationVariables>(AddImageToTheaterDocument, options);
      }
export type AddImageToTheaterMutationHookResult = ReturnType<typeof useAddImageToTheaterMutation>;
export type AddImageToTheaterMutationResult = Apollo.MutationResult<Generated.AddImageToTheaterMutation>;
export type AddImageToTheaterMutationOptions = Apollo.BaseMutationOptions<Generated.AddImageToTheaterMutation, Generated.AddImageToTheaterMutationVariables>;
export const CreateScreensDocument = /*#__PURE__*/ gql`
    mutation createScreens($input: CreateScreensInput!) {
  createScreens(input: $input) {
    id
  }
}
    `;
export type CreateScreensMutationFn = Apollo.MutationFunction<Generated.CreateScreensMutation, Generated.CreateScreensMutationVariables>;

/**
 * __useCreateScreensMutation__
 *
 * To run a mutation, you first call `useCreateScreensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreensMutation, { data, loading, error }] = useCreateScreensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScreensMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateScreensMutation, Generated.CreateScreensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateScreensMutation, Generated.CreateScreensMutationVariables>(CreateScreensDocument, options);
      }
export type CreateScreensMutationHookResult = ReturnType<typeof useCreateScreensMutation>;
export type CreateScreensMutationResult = Apollo.MutationResult<Generated.CreateScreensMutation>;
export type CreateScreensMutationOptions = Apollo.BaseMutationOptions<Generated.CreateScreensMutation, Generated.CreateScreensMutationVariables>;
export const DataApiProxyDocument = /*#__PURE__*/ gql`
    query dataApiProxy($query: String!, $variables: JSONObject) {
  dataApi(query: $query, variables: $variables)
}
    `;

/**
 * __useDataApiProxyQuery__
 *
 * To run a query within a React component, call `useDataApiProxyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataApiProxyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataApiProxyQuery({
 *   variables: {
 *      query: // value for 'query'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useDataApiProxyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.DataApiProxyQuery, Generated.DataApiProxyQueryVariables> & ({ variables: Generated.DataApiProxyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.DataApiProxyQuery, Generated.DataApiProxyQueryVariables>(DataApiProxyDocument, options);
      }
export function useDataApiProxyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.DataApiProxyQuery, Generated.DataApiProxyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.DataApiProxyQuery, Generated.DataApiProxyQueryVariables>(DataApiProxyDocument, options);
        }
export function useDataApiProxySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.DataApiProxyQuery, Generated.DataApiProxyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.DataApiProxyQuery, Generated.DataApiProxyQueryVariables>(DataApiProxyDocument, options);
        }
export type DataApiProxyQueryHookResult = ReturnType<typeof useDataApiProxyQuery>;
export type DataApiProxyLazyQueryHookResult = ReturnType<typeof useDataApiProxyLazyQuery>;
export type DataApiProxySuspenseQueryHookResult = ReturnType<typeof useDataApiProxySuspenseQuery>;
export type DataApiProxyQueryResult = Apollo.QueryResult<Generated.DataApiProxyQuery, Generated.DataApiProxyQueryVariables>;
export const CreateTheaterDocument = /*#__PURE__*/ gql`
    mutation createTheater($input: CreateTheaterInput!) {
  createTheater(input: $input) {
    id
    code
  }
}
    `;
export type CreateTheaterMutationFn = Apollo.MutationFunction<Generated.CreateTheaterMutation, Generated.CreateTheaterMutationVariables>;

/**
 * __useCreateTheaterMutation__
 *
 * To run a mutation, you first call `useCreateTheaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTheaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTheaterMutation, { data, loading, error }] = useCreateTheaterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTheaterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateTheaterMutation, Generated.CreateTheaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateTheaterMutation, Generated.CreateTheaterMutationVariables>(CreateTheaterDocument, options);
      }
export type CreateTheaterMutationHookResult = ReturnType<typeof useCreateTheaterMutation>;
export type CreateTheaterMutationResult = Apollo.MutationResult<Generated.CreateTheaterMutation>;
export type CreateTheaterMutationOptions = Apollo.BaseMutationOptions<Generated.CreateTheaterMutation, Generated.CreateTheaterMutationVariables>;
export const DeleteImageFromTheaterDocument = /*#__PURE__*/ gql`
    mutation deleteImageFromTheater($entityId: ID!, $imageId: ID!) {
  deleteImageFromTheater(input: {entityId: $entityId, imageId: $imageId}) {
    image {
      id
      url
    }
    rank
  }
}
    `;
export type DeleteImageFromTheaterMutationFn = Apollo.MutationFunction<Generated.DeleteImageFromTheaterMutation, Generated.DeleteImageFromTheaterMutationVariables>;

/**
 * __useDeleteImageFromTheaterMutation__
 *
 * To run a mutation, you first call `useDeleteImageFromTheaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageFromTheaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageFromTheaterMutation, { data, loading, error }] = useDeleteImageFromTheaterMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useDeleteImageFromTheaterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteImageFromTheaterMutation, Generated.DeleteImageFromTheaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteImageFromTheaterMutation, Generated.DeleteImageFromTheaterMutationVariables>(DeleteImageFromTheaterDocument, options);
      }
export type DeleteImageFromTheaterMutationHookResult = ReturnType<typeof useDeleteImageFromTheaterMutation>;
export type DeleteImageFromTheaterMutationResult = Apollo.MutationResult<Generated.DeleteImageFromTheaterMutation>;
export type DeleteImageFromTheaterMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteImageFromTheaterMutation, Generated.DeleteImageFromTheaterMutationVariables>;
export const DeleteScreenDocument = /*#__PURE__*/ gql`
    mutation deleteScreen($screenId: ID!) {
  deleteScreen(input: {screenId: $screenId}) {
    id
  }
}
    `;
export type DeleteScreenMutationFn = Apollo.MutationFunction<Generated.DeleteScreenMutation, Generated.DeleteScreenMutationVariables>;

/**
 * __useDeleteScreenMutation__
 *
 * To run a mutation, you first call `useDeleteScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScreenMutation, { data, loading, error }] = useDeleteScreenMutation({
 *   variables: {
 *      screenId: // value for 'screenId'
 *   },
 * });
 */
export function useDeleteScreenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteScreenMutation, Generated.DeleteScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteScreenMutation, Generated.DeleteScreenMutationVariables>(DeleteScreenDocument, options);
      }
export type DeleteScreenMutationHookResult = ReturnType<typeof useDeleteScreenMutation>;
export type DeleteScreenMutationResult = Apollo.MutationResult<Generated.DeleteScreenMutation>;
export type DeleteScreenMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteScreenMutation, Generated.DeleteScreenMutationVariables>;
export const DeleteFareDocument = /*#__PURE__*/ gql`
    mutation deleteFare($input: DeleteFareInput!) {
  deleteFare(input: $input) {
    id
    theater {
      __typename
      id
      ref
      code
      name
      country {
        ...CountryOption
      }
      ...TheaterFareList
      ...TheaterMetadata
    }
  }
}
    ${CountryOptionFragmentDoc}
${TheaterFareListFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type DeleteFareMutationFn = Apollo.MutationFunction<Generated.DeleteFareMutation, Generated.DeleteFareMutationVariables>;

/**
 * __useDeleteFareMutation__
 *
 * To run a mutation, you first call `useDeleteFareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFareMutation, { data, loading, error }] = useDeleteFareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteFareMutation, Generated.DeleteFareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteFareMutation, Generated.DeleteFareMutationVariables>(DeleteFareDocument, options);
      }
export type DeleteFareMutationHookResult = ReturnType<typeof useDeleteFareMutation>;
export type DeleteFareMutationResult = Apollo.MutationResult<Generated.DeleteFareMutation>;
export type DeleteFareMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteFareMutation, Generated.DeleteFareMutationVariables>;
export const GetMarketsDocument = /*#__PURE__*/ gql`
    query getMarkets($countryId: ID) {
  markets(countryId: $countryId)
}
    `;

/**
 * __useGetMarketsQuery__
 *
 * To run a query within a React component, call `useGetMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketsQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetMarketsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetMarketsQuery, Generated.GetMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMarketsQuery, Generated.GetMarketsQueryVariables>(GetMarketsDocument, options);
      }
export function useGetMarketsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMarketsQuery, Generated.GetMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMarketsQuery, Generated.GetMarketsQueryVariables>(GetMarketsDocument, options);
        }
export function useGetMarketsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMarketsQuery, Generated.GetMarketsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMarketsQuery, Generated.GetMarketsQueryVariables>(GetMarketsDocument, options);
        }
export type GetMarketsQueryHookResult = ReturnType<typeof useGetMarketsQuery>;
export type GetMarketsLazyQueryHookResult = ReturnType<typeof useGetMarketsLazyQuery>;
export type GetMarketsSuspenseQueryHookResult = ReturnType<typeof useGetMarketsSuspenseQuery>;
export type GetMarketsQueryResult = Apollo.QueryResult<Generated.GetMarketsQuery, Generated.GetMarketsQueryVariables>;
export const GetScreenListDocument = /*#__PURE__*/ gql`
    query getScreenList($limit: Int, $offset: Int!, $theater: ID!) {
  theater(id: $theater) {
    id
    code
    screens(limit: $limit, offset: $offset) {
      totalCount
      nodes {
        ...ScreenRow
      }
    }
  }
}
    ${ScreenRowFragmentDoc}`;

/**
 * __useGetScreenListQuery__
 *
 * To run a query within a React component, call `useGetScreenListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      theater: // value for 'theater'
 *   },
 * });
 */
export function useGetScreenListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScreenListQuery, Generated.GetScreenListQueryVariables> & ({ variables: Generated.GetScreenListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScreenListQuery, Generated.GetScreenListQueryVariables>(GetScreenListDocument, options);
      }
export function useGetScreenListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScreenListQuery, Generated.GetScreenListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScreenListQuery, Generated.GetScreenListQueryVariables>(GetScreenListDocument, options);
        }
export function useGetScreenListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScreenListQuery, Generated.GetScreenListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScreenListQuery, Generated.GetScreenListQueryVariables>(GetScreenListDocument, options);
        }
export type GetScreenListQueryHookResult = ReturnType<typeof useGetScreenListQuery>;
export type GetScreenListLazyQueryHookResult = ReturnType<typeof useGetScreenListLazyQuery>;
export type GetScreenListSuspenseQueryHookResult = ReturnType<typeof useGetScreenListSuspenseQuery>;
export type GetScreenListQueryResult = Apollo.QueryResult<Generated.GetScreenListQuery, Generated.GetScreenListQueryVariables>;
export const GetTheaterAdditionalInfoDocument = /*#__PURE__*/ gql`
    query getTheaterAdditionalInfo($id: ID!) {
  theater(id: $id) {
    ...TheaterAdditionalInfo
  }
}
    ${TheaterAdditionalInfoFragmentDoc}`;

/**
 * __useGetTheaterAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useGetTheaterAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterAdditionalInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTheaterAdditionalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterAdditionalInfoQuery, Generated.GetTheaterAdditionalInfoQueryVariables> & ({ variables: Generated.GetTheaterAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterAdditionalInfoQuery, Generated.GetTheaterAdditionalInfoQueryVariables>(GetTheaterAdditionalInfoDocument, options);
      }
export function useGetTheaterAdditionalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterAdditionalInfoQuery, Generated.GetTheaterAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterAdditionalInfoQuery, Generated.GetTheaterAdditionalInfoQueryVariables>(GetTheaterAdditionalInfoDocument, options);
        }
export function useGetTheaterAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterAdditionalInfoQuery, Generated.GetTheaterAdditionalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterAdditionalInfoQuery, Generated.GetTheaterAdditionalInfoQueryVariables>(GetTheaterAdditionalInfoDocument, options);
        }
export type GetTheaterAdditionalInfoQueryHookResult = ReturnType<typeof useGetTheaterAdditionalInfoQuery>;
export type GetTheaterAdditionalInfoLazyQueryHookResult = ReturnType<typeof useGetTheaterAdditionalInfoLazyQuery>;
export type GetTheaterAdditionalInfoSuspenseQueryHookResult = ReturnType<typeof useGetTheaterAdditionalInfoSuspenseQuery>;
export type GetTheaterAdditionalInfoQueryResult = Apollo.QueryResult<Generated.GetTheaterAdditionalInfoQuery, Generated.GetTheaterAdditionalInfoQueryVariables>;
export const GetTheaterAddressDocument = /*#__PURE__*/ gql`
    query getTheaterAddress($id: ID!) {
  theater(id: $id) {
    ...TheaterAddress
  }
}
    ${TheaterAddressFragmentDoc}`;

/**
 * __useGetTheaterAddressQuery__
 *
 * To run a query within a React component, call `useGetTheaterAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTheaterAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterAddressQuery, Generated.GetTheaterAddressQueryVariables> & ({ variables: Generated.GetTheaterAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterAddressQuery, Generated.GetTheaterAddressQueryVariables>(GetTheaterAddressDocument, options);
      }
export function useGetTheaterAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterAddressQuery, Generated.GetTheaterAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterAddressQuery, Generated.GetTheaterAddressQueryVariables>(GetTheaterAddressDocument, options);
        }
export function useGetTheaterAddressSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterAddressQuery, Generated.GetTheaterAddressQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterAddressQuery, Generated.GetTheaterAddressQueryVariables>(GetTheaterAddressDocument, options);
        }
export type GetTheaterAddressQueryHookResult = ReturnType<typeof useGetTheaterAddressQuery>;
export type GetTheaterAddressLazyQueryHookResult = ReturnType<typeof useGetTheaterAddressLazyQuery>;
export type GetTheaterAddressSuspenseQueryHookResult = ReturnType<typeof useGetTheaterAddressSuspenseQuery>;
export type GetTheaterAddressQueryResult = Apollo.QueryResult<Generated.GetTheaterAddressQuery, Generated.GetTheaterAddressQueryVariables>;
export const GetTheaterAttributesDocument = /*#__PURE__*/ gql`
    query getTheaterAttributes($id: ID!) {
  theater(id: $id) {
    id
    ...TheaterAffiliation
    ...TheaterFlags
    ...TheaterTicketing
  }
}
    ${TheaterAffiliationFragmentDoc}
${TheaterFlagsFragmentDoc}
${TheaterTicketingFragmentDoc}`;

/**
 * __useGetTheaterAttributesQuery__
 *
 * To run a query within a React component, call `useGetTheaterAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterAttributesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTheaterAttributesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterAttributesQuery, Generated.GetTheaterAttributesQueryVariables> & ({ variables: Generated.GetTheaterAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterAttributesQuery, Generated.GetTheaterAttributesQueryVariables>(GetTheaterAttributesDocument, options);
      }
export function useGetTheaterAttributesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterAttributesQuery, Generated.GetTheaterAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterAttributesQuery, Generated.GetTheaterAttributesQueryVariables>(GetTheaterAttributesDocument, options);
        }
export function useGetTheaterAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterAttributesQuery, Generated.GetTheaterAttributesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterAttributesQuery, Generated.GetTheaterAttributesQueryVariables>(GetTheaterAttributesDocument, options);
        }
export type GetTheaterAttributesQueryHookResult = ReturnType<typeof useGetTheaterAttributesQuery>;
export type GetTheaterAttributesLazyQueryHookResult = ReturnType<typeof useGetTheaterAttributesLazyQuery>;
export type GetTheaterAttributesSuspenseQueryHookResult = ReturnType<typeof useGetTheaterAttributesSuspenseQuery>;
export type GetTheaterAttributesQueryResult = Apollo.QueryResult<Generated.GetTheaterAttributesQuery, Generated.GetTheaterAttributesQueryVariables>;
export const GetTheaterChainDocument = /*#__PURE__*/ gql`
    query getTheaterChain($ref: ID!) {
  entityByRef(type: COMPANY, ref: $ref) {
    ... on Company {
      ...CompanyOption
      ...TheaterChain
      country {
        ...TheaterCountry
      }
    }
  }
}
    ${CompanyOptionFragmentDoc}
${TheaterChainFragmentDoc}
${TheaterCountryFragmentDoc}`;

/**
 * __useGetTheaterChainQuery__
 *
 * To run a query within a React component, call `useGetTheaterChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterChainQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetTheaterChainQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterChainQuery, Generated.GetTheaterChainQueryVariables> & ({ variables: Generated.GetTheaterChainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterChainQuery, Generated.GetTheaterChainQueryVariables>(GetTheaterChainDocument, options);
      }
export function useGetTheaterChainLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterChainQuery, Generated.GetTheaterChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterChainQuery, Generated.GetTheaterChainQueryVariables>(GetTheaterChainDocument, options);
        }
export function useGetTheaterChainSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterChainQuery, Generated.GetTheaterChainQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterChainQuery, Generated.GetTheaterChainQueryVariables>(GetTheaterChainDocument, options);
        }
export type GetTheaterChainQueryHookResult = ReturnType<typeof useGetTheaterChainQuery>;
export type GetTheaterChainLazyQueryHookResult = ReturnType<typeof useGetTheaterChainLazyQuery>;
export type GetTheaterChainSuspenseQueryHookResult = ReturnType<typeof useGetTheaterChainSuspenseQuery>;
export type GetTheaterChainQueryResult = Apollo.QueryResult<Generated.GetTheaterChainQuery, Generated.GetTheaterChainQueryVariables>;
export const GetTheaterFareListDocument = /*#__PURE__*/ gql`
    query getTheaterFareList($id: ID!) {
  theater(id: $id) {
    id
    ...TheaterFareList
  }
}
    ${TheaterFareListFragmentDoc}`;

/**
 * __useGetTheaterFareListQuery__
 *
 * To run a query within a React component, call `useGetTheaterFareListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterFareListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterFareListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTheaterFareListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterFareListQuery, Generated.GetTheaterFareListQueryVariables> & ({ variables: Generated.GetTheaterFareListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterFareListQuery, Generated.GetTheaterFareListQueryVariables>(GetTheaterFareListDocument, options);
      }
export function useGetTheaterFareListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterFareListQuery, Generated.GetTheaterFareListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterFareListQuery, Generated.GetTheaterFareListQueryVariables>(GetTheaterFareListDocument, options);
        }
export function useGetTheaterFareListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterFareListQuery, Generated.GetTheaterFareListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterFareListQuery, Generated.GetTheaterFareListQueryVariables>(GetTheaterFareListDocument, options);
        }
export type GetTheaterFareListQueryHookResult = ReturnType<typeof useGetTheaterFareListQuery>;
export type GetTheaterFareListLazyQueryHookResult = ReturnType<typeof useGetTheaterFareListLazyQuery>;
export type GetTheaterFareListSuspenseQueryHookResult = ReturnType<typeof useGetTheaterFareListSuspenseQuery>;
export type GetTheaterFareListQueryResult = Apollo.QueryResult<Generated.GetTheaterFareListQuery, Generated.GetTheaterFareListQueryVariables>;
export const GetTheaterDataDocument = /*#__PURE__*/ gql`
    query getTheaterData($id: ID!) {
  theater(id: $id) {
    id
    ...EntityAlts
  }
}
    ${EntityAltsFragmentDoc}`;

/**
 * __useGetTheaterDataQuery__
 *
 * To run a query within a React component, call `useGetTheaterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTheaterDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterDataQuery, Generated.GetTheaterDataQueryVariables> & ({ variables: Generated.GetTheaterDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterDataQuery, Generated.GetTheaterDataQueryVariables>(GetTheaterDataDocument, options);
      }
export function useGetTheaterDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterDataQuery, Generated.GetTheaterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterDataQuery, Generated.GetTheaterDataQueryVariables>(GetTheaterDataDocument, options);
        }
export function useGetTheaterDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterDataQuery, Generated.GetTheaterDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterDataQuery, Generated.GetTheaterDataQueryVariables>(GetTheaterDataDocument, options);
        }
export type GetTheaterDataQueryHookResult = ReturnType<typeof useGetTheaterDataQuery>;
export type GetTheaterDataLazyQueryHookResult = ReturnType<typeof useGetTheaterDataLazyQuery>;
export type GetTheaterDataSuspenseQueryHookResult = ReturnType<typeof useGetTheaterDataSuspenseQuery>;
export type GetTheaterDataQueryResult = Apollo.QueryResult<Generated.GetTheaterDataQuery, Generated.GetTheaterDataQueryVariables>;
export const GetTheaterIdentityDocument = /*#__PURE__*/ gql`
    query getTheaterIdentity($id: ID!) {
  theater(id: $id) {
    ...TheaterIdentity
  }
}
    ${TheaterIdentityFragmentDoc}`;

/**
 * __useGetTheaterIdentityQuery__
 *
 * To run a query within a React component, call `useGetTheaterIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterIdentityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTheaterIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterIdentityQuery, Generated.GetTheaterIdentityQueryVariables> & ({ variables: Generated.GetTheaterIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterIdentityQuery, Generated.GetTheaterIdentityQueryVariables>(GetTheaterIdentityDocument, options);
      }
export function useGetTheaterIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterIdentityQuery, Generated.GetTheaterIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterIdentityQuery, Generated.GetTheaterIdentityQueryVariables>(GetTheaterIdentityDocument, options);
        }
export function useGetTheaterIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterIdentityQuery, Generated.GetTheaterIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterIdentityQuery, Generated.GetTheaterIdentityQueryVariables>(GetTheaterIdentityDocument, options);
        }
export type GetTheaterIdentityQueryHookResult = ReturnType<typeof useGetTheaterIdentityQuery>;
export type GetTheaterIdentityLazyQueryHookResult = ReturnType<typeof useGetTheaterIdentityLazyQuery>;
export type GetTheaterIdentitySuspenseQueryHookResult = ReturnType<typeof useGetTheaterIdentitySuspenseQuery>;
export type GetTheaterIdentityQueryResult = Apollo.QueryResult<Generated.GetTheaterIdentityQuery, Generated.GetTheaterIdentityQueryVariables>;
export const GetTheaterImagesDocument = /*#__PURE__*/ gql`
    query getTheaterImages($id: ID!, $limit: Int, $offset: Int!) {
  theater(id: $id) {
    id
    images(limit: $limit, offset: $offset) {
      totalCount
      nodes {
        ...ImageReference
      }
    }
  }
}
    ${ImageReferenceFragmentDoc}`;

/**
 * __useGetTheaterImagesQuery__
 *
 * To run a query within a React component, call `useGetTheaterImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterImagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetTheaterImagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterImagesQuery, Generated.GetTheaterImagesQueryVariables> & ({ variables: Generated.GetTheaterImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterImagesQuery, Generated.GetTheaterImagesQueryVariables>(GetTheaterImagesDocument, options);
      }
export function useGetTheaterImagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterImagesQuery, Generated.GetTheaterImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterImagesQuery, Generated.GetTheaterImagesQueryVariables>(GetTheaterImagesDocument, options);
        }
export function useGetTheaterImagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterImagesQuery, Generated.GetTheaterImagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterImagesQuery, Generated.GetTheaterImagesQueryVariables>(GetTheaterImagesDocument, options);
        }
export type GetTheaterImagesQueryHookResult = ReturnType<typeof useGetTheaterImagesQuery>;
export type GetTheaterImagesLazyQueryHookResult = ReturnType<typeof useGetTheaterImagesLazyQuery>;
export type GetTheaterImagesSuspenseQueryHookResult = ReturnType<typeof useGetTheaterImagesSuspenseQuery>;
export type GetTheaterImagesQueryResult = Apollo.QueryResult<Generated.GetTheaterImagesQuery, Generated.GetTheaterImagesQueryVariables>;
export const GetTheaterLinksDocument = /*#__PURE__*/ gql`
    query getTheaterLinks($id: ID!) {
  theater(id: $id) {
    ...TheaterLinks
  }
}
    ${TheaterLinksFragmentDoc}`;

/**
 * __useGetTheaterLinksQuery__
 *
 * To run a query within a React component, call `useGetTheaterLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTheaterLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterLinksQuery, Generated.GetTheaterLinksQueryVariables> & ({ variables: Generated.GetTheaterLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterLinksQuery, Generated.GetTheaterLinksQueryVariables>(GetTheaterLinksDocument, options);
      }
export function useGetTheaterLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterLinksQuery, Generated.GetTheaterLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterLinksQuery, Generated.GetTheaterLinksQueryVariables>(GetTheaterLinksDocument, options);
        }
export function useGetTheaterLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterLinksQuery, Generated.GetTheaterLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterLinksQuery, Generated.GetTheaterLinksQueryVariables>(GetTheaterLinksDocument, options);
        }
export type GetTheaterLinksQueryHookResult = ReturnType<typeof useGetTheaterLinksQuery>;
export type GetTheaterLinksLazyQueryHookResult = ReturnType<typeof useGetTheaterLinksLazyQuery>;
export type GetTheaterLinksSuspenseQueryHookResult = ReturnType<typeof useGetTheaterLinksSuspenseQuery>;
export type GetTheaterLinksQueryResult = Apollo.QueryResult<Generated.GetTheaterLinksQuery, Generated.GetTheaterLinksQueryVariables>;
export const GetTheaterListDocument = /*#__PURE__*/ gql`
    query getTheaterList($limit: Int, $offset: Int!, $search: String!, $companyIds: [ID!]!, $countryIds: [ID!]!, $localizationIds: [ID!]!, $theaterOpeningStatuses: [TheaterOpeningStatus!]!, $showtimeSources: [TheaterShowtimeSource!], $orderBy: TheaterOrder!) {
  theaters(
    limit: $limit
    offset: $offset
    companyIds: $companyIds
    countryIds: $countryIds
    localizationIds: $localizationIds
    theaterOpeningStatuses: $theaterOpeningStatuses
    showtimeSources: $showtimeSources
    search: $search
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      __typename
      id
      ref
      name
      code
      showtimeSource
      parent {
        ...CompanyOption
      }
      location {
        zip
        city
      }
      country {
        ...CountryOption
      }
      localization {
        name
      }
      openingStatus
      metadata {
        createdAt
      }
      ...Closure
      showtimesGatheringMethod
      showtimesGatheringMethodCode
    }
  }
}
    ${CompanyOptionFragmentDoc}
${CountryOptionFragmentDoc}
${ClosureFragmentDoc}`;

/**
 * __useGetTheaterListQuery__
 *
 * To run a query within a React component, call `useGetTheaterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      companyIds: // value for 'companyIds'
 *      countryIds: // value for 'countryIds'
 *      localizationIds: // value for 'localizationIds'
 *      theaterOpeningStatuses: // value for 'theaterOpeningStatuses'
 *      showtimeSources: // value for 'showtimeSources'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetTheaterListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterListQuery, Generated.GetTheaterListQueryVariables> & ({ variables: Generated.GetTheaterListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterListQuery, Generated.GetTheaterListQueryVariables>(GetTheaterListDocument, options);
      }
export function useGetTheaterListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterListQuery, Generated.GetTheaterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterListQuery, Generated.GetTheaterListQueryVariables>(GetTheaterListDocument, options);
        }
export function useGetTheaterListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterListQuery, Generated.GetTheaterListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterListQuery, Generated.GetTheaterListQueryVariables>(GetTheaterListDocument, options);
        }
export type GetTheaterListQueryHookResult = ReturnType<typeof useGetTheaterListQuery>;
export type GetTheaterListLazyQueryHookResult = ReturnType<typeof useGetTheaterListLazyQuery>;
export type GetTheaterListSuspenseQueryHookResult = ReturnType<typeof useGetTheaterListSuspenseQuery>;
export type GetTheaterListQueryResult = Apollo.QueryResult<Generated.GetTheaterListQuery, Generated.GetTheaterListQueryVariables>;
export const GetTheaterLocalizedDataDocument = /*#__PURE__*/ gql`
    query getTheaterLocalizedData($id: ID!, $locale: ID!) {
  theater(id: $id) {
    id
    localeData(locale: $locale) {
      title
      description
      locale
      address
      city
      state
    }
  }
}
    `;

/**
 * __useGetTheaterLocalizedDataQuery__
 *
 * To run a query within a React component, call `useGetTheaterLocalizedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterLocalizedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterLocalizedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetTheaterLocalizedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterLocalizedDataQuery, Generated.GetTheaterLocalizedDataQueryVariables> & ({ variables: Generated.GetTheaterLocalizedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterLocalizedDataQuery, Generated.GetTheaterLocalizedDataQueryVariables>(GetTheaterLocalizedDataDocument, options);
      }
export function useGetTheaterLocalizedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterLocalizedDataQuery, Generated.GetTheaterLocalizedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterLocalizedDataQuery, Generated.GetTheaterLocalizedDataQueryVariables>(GetTheaterLocalizedDataDocument, options);
        }
export function useGetTheaterLocalizedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterLocalizedDataQuery, Generated.GetTheaterLocalizedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterLocalizedDataQuery, Generated.GetTheaterLocalizedDataQueryVariables>(GetTheaterLocalizedDataDocument, options);
        }
export type GetTheaterLocalizedDataQueryHookResult = ReturnType<typeof useGetTheaterLocalizedDataQuery>;
export type GetTheaterLocalizedDataLazyQueryHookResult = ReturnType<typeof useGetTheaterLocalizedDataLazyQuery>;
export type GetTheaterLocalizedDataSuspenseQueryHookResult = ReturnType<typeof useGetTheaterLocalizedDataSuspenseQuery>;
export type GetTheaterLocalizedDataQueryResult = Apollo.QueryResult<Generated.GetTheaterLocalizedDataQuery, Generated.GetTheaterLocalizedDataQueryVariables>;
export const GetTheaterMetadataDocument = /*#__PURE__*/ gql`
    query getTheaterMetadata($code: ID!) {
  theaterByCode(code: $code) {
    id
    name
    activeOnBrands {
      ref
    }
    ...TheaterMetadata
  }
}
    ${TheaterMetadataFragmentDoc}`;

/**
 * __useGetTheaterMetadataQuery__
 *
 * To run a query within a React component, call `useGetTheaterMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheaterMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheaterMetadataQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetTheaterMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTheaterMetadataQuery, Generated.GetTheaterMetadataQueryVariables> & ({ variables: Generated.GetTheaterMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTheaterMetadataQuery, Generated.GetTheaterMetadataQueryVariables>(GetTheaterMetadataDocument, options);
      }
export function useGetTheaterMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTheaterMetadataQuery, Generated.GetTheaterMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTheaterMetadataQuery, Generated.GetTheaterMetadataQueryVariables>(GetTheaterMetadataDocument, options);
        }
export function useGetTheaterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTheaterMetadataQuery, Generated.GetTheaterMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTheaterMetadataQuery, Generated.GetTheaterMetadataQueryVariables>(GetTheaterMetadataDocument, options);
        }
export type GetTheaterMetadataQueryHookResult = ReturnType<typeof useGetTheaterMetadataQuery>;
export type GetTheaterMetadataLazyQueryHookResult = ReturnType<typeof useGetTheaterMetadataLazyQuery>;
export type GetTheaterMetadataSuspenseQueryHookResult = ReturnType<typeof useGetTheaterMetadataSuspenseQuery>;
export type GetTheaterMetadataQueryResult = Apollo.QueryResult<Generated.GetTheaterMetadataQuery, Generated.GetTheaterMetadataQueryVariables>;
export const MoveFareDocument = /*#__PURE__*/ gql`
    mutation moveFare($input: MoveFareInput!) {
  moveFare(input: $input) {
    ...TheaterFare
  }
}
    ${TheaterFareFragmentDoc}`;
export type MoveFareMutationFn = Apollo.MutationFunction<Generated.MoveFareMutation, Generated.MoveFareMutationVariables>;

/**
 * __useMoveFareMutation__
 *
 * To run a mutation, you first call `useMoveFareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFareMutation, { data, loading, error }] = useMoveFareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveFareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveFareMutation, Generated.MoveFareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveFareMutation, Generated.MoveFareMutationVariables>(MoveFareDocument, options);
      }
export type MoveFareMutationHookResult = ReturnType<typeof useMoveFareMutation>;
export type MoveFareMutationResult = Apollo.MutationResult<Generated.MoveFareMutation>;
export type MoveFareMutationOptions = Apollo.BaseMutationOptions<Generated.MoveFareMutation, Generated.MoveFareMutationVariables>;
export const UpdateTheaterAddressDocument = /*#__PURE__*/ gql`
    mutation updateTheaterAddress($entityId: ID!, $coordinates: CoordinatesInput!, $location: LocationInput!) {
  updateEntityLocalization(
    input: {entityId: $entityId, coordinates: $coordinates, location: $location}
  ) {
    ... on Theater {
      id
      timezone
      ...TheaterAddress
      ...TheaterMetadata
    }
  }
}
    ${TheaterAddressFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type UpdateTheaterAddressMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterAddressMutation, Generated.UpdateTheaterAddressMutationVariables>;

/**
 * __useUpdateTheaterAddressMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterAddressMutation, { data, loading, error }] = useUpdateTheaterAddressMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      coordinates: // value for 'coordinates'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUpdateTheaterAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterAddressMutation, Generated.UpdateTheaterAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterAddressMutation, Generated.UpdateTheaterAddressMutationVariables>(UpdateTheaterAddressDocument, options);
      }
export type UpdateTheaterAddressMutationHookResult = ReturnType<typeof useUpdateTheaterAddressMutation>;
export type UpdateTheaterAddressMutationResult = Apollo.MutationResult<Generated.UpdateTheaterAddressMutation>;
export type UpdateTheaterAddressMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterAddressMutation, Generated.UpdateTheaterAddressMutationVariables>;
export const UpdateFareDocument = /*#__PURE__*/ gql`
    mutation updateFare($input: UpdateFareInput!) {
  updateFare(input: $input) {
    ...TheaterFare
  }
}
    ${TheaterFareFragmentDoc}`;
export type UpdateFareMutationFn = Apollo.MutationFunction<Generated.UpdateFareMutation, Generated.UpdateFareMutationVariables>;

/**
 * __useUpdateFareMutation__
 *
 * To run a mutation, you first call `useUpdateFareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFareMutation, { data, loading, error }] = useUpdateFareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateFareMutation, Generated.UpdateFareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateFareMutation, Generated.UpdateFareMutationVariables>(UpdateFareDocument, options);
      }
export type UpdateFareMutationHookResult = ReturnType<typeof useUpdateFareMutation>;
export type UpdateFareMutationResult = Apollo.MutationResult<Generated.UpdateFareMutation>;
export type UpdateFareMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateFareMutation, Generated.UpdateFareMutationVariables>;
export const UpdateTheaterFlagsDocument = /*#__PURE__*/ gql`
    mutation updateTheaterFlags($id: ID!, $flags: TheaterFlagsInput) {
  updateTheater(input: {id: $id, flags: $flags}) {
    id
    ...TheaterMetadata
    ...TheaterFlags
  }
}
    ${TheaterMetadataFragmentDoc}
${TheaterFlagsFragmentDoc}`;
export type UpdateTheaterFlagsMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterFlagsMutation, Generated.UpdateTheaterFlagsMutationVariables>;

/**
 * __useUpdateTheaterFlagsMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterFlagsMutation, { data, loading, error }] = useUpdateTheaterFlagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      flags: // value for 'flags'
 *   },
 * });
 */
export function useUpdateTheaterFlagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterFlagsMutation, Generated.UpdateTheaterFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterFlagsMutation, Generated.UpdateTheaterFlagsMutationVariables>(UpdateTheaterFlagsDocument, options);
      }
export type UpdateTheaterFlagsMutationHookResult = ReturnType<typeof useUpdateTheaterFlagsMutation>;
export type UpdateTheaterFlagsMutationResult = Apollo.MutationResult<Generated.UpdateTheaterFlagsMutation>;
export type UpdateTheaterFlagsMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterFlagsMutation, Generated.UpdateTheaterFlagsMutationVariables>;
export const UpdateTheaterInfoDocument = /*#__PURE__*/ gql`
    mutation updateTheaterInfo($input: UpdateTheaterInput!) {
  updateTheater(input: $input) {
    id
    ...TheaterFullIdentity
    ...TheaterMetadata
  }
}
    ${TheaterFullIdentityFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type UpdateTheaterInfoMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterInfoMutation, Generated.UpdateTheaterInfoMutationVariables>;

/**
 * __useUpdateTheaterInfoMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterInfoMutation, { data, loading, error }] = useUpdateTheaterInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTheaterInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterInfoMutation, Generated.UpdateTheaterInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterInfoMutation, Generated.UpdateTheaterInfoMutationVariables>(UpdateTheaterInfoDocument, options);
      }
export type UpdateTheaterInfoMutationHookResult = ReturnType<typeof useUpdateTheaterInfoMutation>;
export type UpdateTheaterInfoMutationResult = Apollo.MutationResult<Generated.UpdateTheaterInfoMutation>;
export type UpdateTheaterInfoMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterInfoMutation, Generated.UpdateTheaterInfoMutationVariables>;
export const UpdateTheaterIdentityDocument = /*#__PURE__*/ gql`
    mutation updateTheaterIdentity($input: UpdateTheaterInput!) {
  updateTheater(input: $input) {
    id
    ...TheaterFullIdentity
    ...TheaterMetadata
  }
}
    ${TheaterFullIdentityFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type UpdateTheaterIdentityMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterIdentityMutation, Generated.UpdateTheaterIdentityMutationVariables>;

/**
 * __useUpdateTheaterIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterIdentityMutation, { data, loading, error }] = useUpdateTheaterIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTheaterIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterIdentityMutation, Generated.UpdateTheaterIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterIdentityMutation, Generated.UpdateTheaterIdentityMutationVariables>(UpdateTheaterIdentityDocument, options);
      }
export type UpdateTheaterIdentityMutationHookResult = ReturnType<typeof useUpdateTheaterIdentityMutation>;
export type UpdateTheaterIdentityMutationResult = Apollo.MutationResult<Generated.UpdateTheaterIdentityMutation>;
export type UpdateTheaterIdentityMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterIdentityMutation, Generated.UpdateTheaterIdentityMutationVariables>;
export const UpdateTheaterAffiliationDocument = /*#__PURE__*/ gql`
    mutation updateTheaterAffiliation($id: ID!, $market: String, $affiliatedTo: [ID!], $tradeGroup: [ID!], $pointOfSale: [ID!], $scheduledTypology: [TheaterTypology!]) {
  updateTheater(
    input: {id: $id, market: $market, affiliatedTo: $affiliatedTo, tradeGroup: $tradeGroup, pointOfSale: $pointOfSale, scheduledTypology: $scheduledTypology}
  ) {
    id
    ...TheaterAffiliation
    ...TheaterMetadata
  }
}
    ${TheaterAffiliationFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type UpdateTheaterAffiliationMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterAffiliationMutation, Generated.UpdateTheaterAffiliationMutationVariables>;

/**
 * __useUpdateTheaterAffiliationMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterAffiliationMutation, { data, loading, error }] = useUpdateTheaterAffiliationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      market: // value for 'market'
 *      affiliatedTo: // value for 'affiliatedTo'
 *      tradeGroup: // value for 'tradeGroup'
 *      pointOfSale: // value for 'pointOfSale'
 *      scheduledTypology: // value for 'scheduledTypology'
 *   },
 * });
 */
export function useUpdateTheaterAffiliationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterAffiliationMutation, Generated.UpdateTheaterAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterAffiliationMutation, Generated.UpdateTheaterAffiliationMutationVariables>(UpdateTheaterAffiliationDocument, options);
      }
export type UpdateTheaterAffiliationMutationHookResult = ReturnType<typeof useUpdateTheaterAffiliationMutation>;
export type UpdateTheaterAffiliationMutationResult = Apollo.MutationResult<Generated.UpdateTheaterAffiliationMutation>;
export type UpdateTheaterAffiliationMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterAffiliationMutation, Generated.UpdateTheaterAffiliationMutationVariables>;
export const UpdateTheaterLinksDocument = /*#__PURE__*/ gql`
    mutation updateTheaterLinks($id: ID!, $links: SocialLinksInput!) {
  updateTheater(input: {id: $id, links: $links}) {
    id
    ...TheaterLinks
    ...TheaterMetadata
  }
}
    ${TheaterLinksFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type UpdateTheaterLinksMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterLinksMutation, Generated.UpdateTheaterLinksMutationVariables>;

/**
 * __useUpdateTheaterLinksMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterLinksMutation, { data, loading, error }] = useUpdateTheaterLinksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useUpdateTheaterLinksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterLinksMutation, Generated.UpdateTheaterLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterLinksMutation, Generated.UpdateTheaterLinksMutationVariables>(UpdateTheaterLinksDocument, options);
      }
export type UpdateTheaterLinksMutationHookResult = ReturnType<typeof useUpdateTheaterLinksMutation>;
export type UpdateTheaterLinksMutationResult = Apollo.MutationResult<Generated.UpdateTheaterLinksMutation>;
export type UpdateTheaterLinksMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterLinksMutation, Generated.UpdateTheaterLinksMutationVariables>;
export const UpdateTheaterLocalizedDataDocument = /*#__PURE__*/ gql`
    mutation updateTheaterLocalizedData($theaterId: ID!, $locale: ID!, $title: String, $description: String, $address: String, $city: String, $state: String) {
  updateTheaterLocaleData(
    input: {theaterId: $theaterId, locale: $locale, title: $title, description: $description, address: $address, city: $city, state: $state}
  ) {
    id
    localeData(locale: $locale) {
      locale
      title
      description
      address
      city
      state
    }
    ...TheaterMetadata
  }
}
    ${TheaterMetadataFragmentDoc}`;
export type UpdateTheaterLocalizedDataMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterLocalizedDataMutation, Generated.UpdateTheaterLocalizedDataMutationVariables>;

/**
 * __useUpdateTheaterLocalizedDataMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterLocalizedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterLocalizedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterLocalizedDataMutation, { data, loading, error }] = useUpdateTheaterLocalizedDataMutation({
 *   variables: {
 *      theaterId: // value for 'theaterId'
 *      locale: // value for 'locale'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateTheaterLocalizedDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterLocalizedDataMutation, Generated.UpdateTheaterLocalizedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterLocalizedDataMutation, Generated.UpdateTheaterLocalizedDataMutationVariables>(UpdateTheaterLocalizedDataDocument, options);
      }
export type UpdateTheaterLocalizedDataMutationHookResult = ReturnType<typeof useUpdateTheaterLocalizedDataMutation>;
export type UpdateTheaterLocalizedDataMutationResult = Apollo.MutationResult<Generated.UpdateTheaterLocalizedDataMutation>;
export type UpdateTheaterLocalizedDataMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterLocalizedDataMutation, Generated.UpdateTheaterLocalizedDataMutationVariables>;
export const DeleteTriviaDocument = /*#__PURE__*/ gql`
    mutation deleteTrivia($input: DeleteTriviaInput!) {
  deleteTrivia(input: $input) {
    id
  }
}
    `;
export type DeleteTriviaMutationFn = Apollo.MutationFunction<Generated.DeleteTriviaMutation, Generated.DeleteTriviaMutationVariables>;

/**
 * __useDeleteTriviaMutation__
 *
 * To run a mutation, you first call `useDeleteTriviaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTriviaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTriviaMutation, { data, loading, error }] = useDeleteTriviaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTriviaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteTriviaMutation, Generated.DeleteTriviaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteTriviaMutation, Generated.DeleteTriviaMutationVariables>(DeleteTriviaDocument, options);
      }
export type DeleteTriviaMutationHookResult = ReturnType<typeof useDeleteTriviaMutation>;
export type DeleteTriviaMutationResult = Apollo.MutationResult<Generated.DeleteTriviaMutation>;
export type DeleteTriviaMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteTriviaMutation, Generated.DeleteTriviaMutationVariables>;
export const UpdateTheaterTicketingDocument = /*#__PURE__*/ gql`
    mutation updateTheaterTicketing($input: UpdateTheaterTicketingInput!) {
  updateTheaterTicketing(input: $input) {
    id
    ...TheaterTicketing
    ...TheaterMetadata
  }
}
    ${TheaterTicketingFragmentDoc}
${TheaterMetadataFragmentDoc}`;
export type UpdateTheaterTicketingMutationFn = Apollo.MutationFunction<Generated.UpdateTheaterTicketingMutation, Generated.UpdateTheaterTicketingMutationVariables>;

/**
 * __useUpdateTheaterTicketingMutation__
 *
 * To run a mutation, you first call `useUpdateTheaterTicketingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTheaterTicketingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTheaterTicketingMutation, { data, loading, error }] = useUpdateTheaterTicketingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTheaterTicketingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTheaterTicketingMutation, Generated.UpdateTheaterTicketingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTheaterTicketingMutation, Generated.UpdateTheaterTicketingMutationVariables>(UpdateTheaterTicketingDocument, options);
      }
export type UpdateTheaterTicketingMutationHookResult = ReturnType<typeof useUpdateTheaterTicketingMutation>;
export type UpdateTheaterTicketingMutationResult = Apollo.MutationResult<Generated.UpdateTheaterTicketingMutation>;
export type UpdateTheaterTicketingMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTheaterTicketingMutation, Generated.UpdateTheaterTicketingMutationVariables>;
export const GetTriviaListDocument = /*#__PURE__*/ gql`
    query getTriviaList($limit: Int, $offset: Int!, $brandId: ID, $search: String) {
  trivias(limit: $limit, offset: $offset, brandId: $brandId, search: $search) {
    totalCount
    nodes {
      __typename
      id
      ref
      active
      title
      type
      metadata {
        ...Metadata
      }
      relatedEntities {
        __typename
        ... on Movie {
          id
          ref
          title
        }
        ... on Series {
          id
          ref
          title
        }
        ... on SeriesSeason {
          id
          ref
          number
          series {
            id
            ref
            title
          }
        }
        ... on SeriesEpisode {
          ref
          id
          __typename
          number
          series {
            ref
            id
            title
          }
          season {
            ref
          }
        }
        ... on Person {
          ref
          id
          lastName
          firstName
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}`;

/**
 * __useGetTriviaListQuery__
 *
 * To run a query within a React component, call `useGetTriviaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriviaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriviaListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brandId: // value for 'brandId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTriviaListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTriviaListQuery, Generated.GetTriviaListQueryVariables> & ({ variables: Generated.GetTriviaListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTriviaListQuery, Generated.GetTriviaListQueryVariables>(GetTriviaListDocument, options);
      }
export function useGetTriviaListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTriviaListQuery, Generated.GetTriviaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTriviaListQuery, Generated.GetTriviaListQueryVariables>(GetTriviaListDocument, options);
        }
export function useGetTriviaListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTriviaListQuery, Generated.GetTriviaListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTriviaListQuery, Generated.GetTriviaListQueryVariables>(GetTriviaListDocument, options);
        }
export type GetTriviaListQueryHookResult = ReturnType<typeof useGetTriviaListQuery>;
export type GetTriviaListLazyQueryHookResult = ReturnType<typeof useGetTriviaListLazyQuery>;
export type GetTriviaListSuspenseQueryHookResult = ReturnType<typeof useGetTriviaListSuspenseQuery>;
export type GetTriviaListQueryResult = Apollo.QueryResult<Generated.GetTriviaListQuery, Generated.GetTriviaListQueryVariables>;
export const GetTriviaDocument = /*#__PURE__*/ gql`
    query getTrivia($ref: ID!) {
  triviaByRef(ref: $ref) {
    ... on Trivia {
      ...TriviaIdentity
      metadata {
        ...Metadata
      }
    }
  }
}
    ${TriviaIdentityFragmentDoc}
${MetadataFragmentDoc}`;

/**
 * __useGetTriviaQuery__
 *
 * To run a query within a React component, call `useGetTriviaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriviaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriviaQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetTriviaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTriviaQuery, Generated.GetTriviaQueryVariables> & ({ variables: Generated.GetTriviaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTriviaQuery, Generated.GetTriviaQueryVariables>(GetTriviaDocument, options);
      }
export function useGetTriviaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTriviaQuery, Generated.GetTriviaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTriviaQuery, Generated.GetTriviaQueryVariables>(GetTriviaDocument, options);
        }
export function useGetTriviaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTriviaQuery, Generated.GetTriviaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTriviaQuery, Generated.GetTriviaQueryVariables>(GetTriviaDocument, options);
        }
export type GetTriviaQueryHookResult = ReturnType<typeof useGetTriviaQuery>;
export type GetTriviaLazyQueryHookResult = ReturnType<typeof useGetTriviaLazyQuery>;
export type GetTriviaSuspenseQueryHookResult = ReturnType<typeof useGetTriviaSuspenseQuery>;
export type GetTriviaQueryResult = Apollo.QueryResult<Generated.GetTriviaQuery, Generated.GetTriviaQueryVariables>;
export const CreateTriviaDocument = /*#__PURE__*/ gql`
    mutation createTrivia($input: CreateTriviaInput!) {
  createTrivia(input: $input) {
    id
    ref
  }
}
    `;
export type CreateTriviaMutationFn = Apollo.MutationFunction<Generated.CreateTriviaMutation, Generated.CreateTriviaMutationVariables>;

/**
 * __useCreateTriviaMutation__
 *
 * To run a mutation, you first call `useCreateTriviaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTriviaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTriviaMutation, { data, loading, error }] = useCreateTriviaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTriviaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateTriviaMutation, Generated.CreateTriviaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateTriviaMutation, Generated.CreateTriviaMutationVariables>(CreateTriviaDocument, options);
      }
export type CreateTriviaMutationHookResult = ReturnType<typeof useCreateTriviaMutation>;
export type CreateTriviaMutationResult = Apollo.MutationResult<Generated.CreateTriviaMutation>;
export type CreateTriviaMutationOptions = Apollo.BaseMutationOptions<Generated.CreateTriviaMutation, Generated.CreateTriviaMutationVariables>;
export const UpdateTriviaDocument = /*#__PURE__*/ gql`
    mutation updateTrivia($input: UpdateTriviaInput!) {
  updateTrivia(input: $input) {
    ...TriviaIdentity
  }
}
    ${TriviaIdentityFragmentDoc}`;
export type UpdateTriviaMutationFn = Apollo.MutationFunction<Generated.UpdateTriviaMutation, Generated.UpdateTriviaMutationVariables>;

/**
 * __useUpdateTriviaMutation__
 *
 * To run a mutation, you first call `useUpdateTriviaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriviaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriviaMutation, { data, loading, error }] = useUpdateTriviaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriviaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTriviaMutation, Generated.UpdateTriviaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTriviaMutation, Generated.UpdateTriviaMutationVariables>(UpdateTriviaDocument, options);
      }
export type UpdateTriviaMutationHookResult = ReturnType<typeof useUpdateTriviaMutation>;
export type UpdateTriviaMutationResult = Apollo.MutationResult<Generated.UpdateTriviaMutation>;
export type UpdateTriviaMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTriviaMutation, Generated.UpdateTriviaMutationVariables>;
export const GetTriviaRelatedEntitiesListDocument = /*#__PURE__*/ gql`
    query getTriviaRelatedEntitiesList($id: ID!, $excludedTypes: [TriviaLinkableEntityType!], $includedTypes: [TriviaLinkableEntityType!]) {
  trivia(id: $id) {
    id
    relatedEntities(excludedTypes: $excludedTypes, includedTypes: $includedTypes) {
      ...TriviaEntity
    }
  }
}
    ${TriviaEntityFragmentDoc}`;

/**
 * __useGetTriviaRelatedEntitiesListQuery__
 *
 * To run a query within a React component, call `useGetTriviaRelatedEntitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriviaRelatedEntitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriviaRelatedEntitiesListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      excludedTypes: // value for 'excludedTypes'
 *      includedTypes: // value for 'includedTypes'
 *   },
 * });
 */
export function useGetTriviaRelatedEntitiesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTriviaRelatedEntitiesListQuery, Generated.GetTriviaRelatedEntitiesListQueryVariables> & ({ variables: Generated.GetTriviaRelatedEntitiesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTriviaRelatedEntitiesListQuery, Generated.GetTriviaRelatedEntitiesListQueryVariables>(GetTriviaRelatedEntitiesListDocument, options);
      }
export function useGetTriviaRelatedEntitiesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTriviaRelatedEntitiesListQuery, Generated.GetTriviaRelatedEntitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTriviaRelatedEntitiesListQuery, Generated.GetTriviaRelatedEntitiesListQueryVariables>(GetTriviaRelatedEntitiesListDocument, options);
        }
export function useGetTriviaRelatedEntitiesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTriviaRelatedEntitiesListQuery, Generated.GetTriviaRelatedEntitiesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTriviaRelatedEntitiesListQuery, Generated.GetTriviaRelatedEntitiesListQueryVariables>(GetTriviaRelatedEntitiesListDocument, options);
        }
export type GetTriviaRelatedEntitiesListQueryHookResult = ReturnType<typeof useGetTriviaRelatedEntitiesListQuery>;
export type GetTriviaRelatedEntitiesListLazyQueryHookResult = ReturnType<typeof useGetTriviaRelatedEntitiesListLazyQuery>;
export type GetTriviaRelatedEntitiesListSuspenseQueryHookResult = ReturnType<typeof useGetTriviaRelatedEntitiesListSuspenseQuery>;
export type GetTriviaRelatedEntitiesListQueryResult = Apollo.QueryResult<Generated.GetTriviaRelatedEntitiesListQuery, Generated.GetTriviaRelatedEntitiesListQueryVariables>;
export const CreateFileUploadTokenDocument = /*#__PURE__*/ gql`
    mutation createFileUploadToken($fileStorageType: FileUploadStorageType!, $mimeType: FileUploadMimeType!, $originalFileName: String!, $iso8601Duration: String = "PT1H") {
  createFileUploadToken(
    input: {fileStorageType: $fileStorageType, mimeType: $mimeType, iso8601Duration: $iso8601Duration, originalFileName: $originalFileName}
  ) {
    uploadUrl
    uploadToken
    additionalStorageParams
    relativePath
  }
}
    `;
export type CreateFileUploadTokenMutationFn = Apollo.MutationFunction<Generated.CreateFileUploadTokenMutation, Generated.CreateFileUploadTokenMutationVariables>;

/**
 * __useCreateFileUploadTokenMutation__
 *
 * To run a mutation, you first call `useCreateFileUploadTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileUploadTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileUploadTokenMutation, { data, loading, error }] = useCreateFileUploadTokenMutation({
 *   variables: {
 *      fileStorageType: // value for 'fileStorageType'
 *      mimeType: // value for 'mimeType'
 *      originalFileName: // value for 'originalFileName'
 *      iso8601Duration: // value for 'iso8601Duration'
 *   },
 * });
 */
export function useCreateFileUploadTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateFileUploadTokenMutation, Generated.CreateFileUploadTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateFileUploadTokenMutation, Generated.CreateFileUploadTokenMutationVariables>(CreateFileUploadTokenDocument, options);
      }
export type CreateFileUploadTokenMutationHookResult = ReturnType<typeof useCreateFileUploadTokenMutation>;
export type CreateFileUploadTokenMutationResult = Apollo.MutationResult<Generated.CreateFileUploadTokenMutation>;
export type CreateFileUploadTokenMutationOptions = Apollo.BaseMutationOptions<Generated.CreateFileUploadTokenMutation, Generated.CreateFileUploadTokenMutationVariables>;
export const CreateVideoDocument = /*#__PURE__*/ gql`
    mutation createVideo($input: CreateVideoInput!) {
  createVideo(input: $input) {
    id
    ref
    title
  }
}
    `;
export type CreateVideoMutationFn = Apollo.MutationFunction<Generated.CreateVideoMutation, Generated.CreateVideoMutationVariables>;

/**
 * __useCreateVideoMutation__
 *
 * To run a mutation, you first call `useCreateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoMutation, { data, loading, error }] = useCreateVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateVideoMutation, Generated.CreateVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateVideoMutation, Generated.CreateVideoMutationVariables>(CreateVideoDocument, options);
      }
export type CreateVideoMutationHookResult = ReturnType<typeof useCreateVideoMutation>;
export type CreateVideoMutationResult = Apollo.MutationResult<Generated.CreateVideoMutation>;
export type CreateVideoMutationOptions = Apollo.BaseMutationOptions<Generated.CreateVideoMutation, Generated.CreateVideoMutationVariables>;
export const DeleteVideoFileDocument = /*#__PURE__*/ gql`
    mutation deleteVideoFile($videoRef: ID!, $fileId: ID!) {
  deleteVideoFile(input: {videoRef: $videoRef, fileId: $fileId}) {
    __typename
  }
}
    `;
export type DeleteVideoFileMutationFn = Apollo.MutationFunction<Generated.DeleteVideoFileMutation, Generated.DeleteVideoFileMutationVariables>;

/**
 * __useDeleteVideoFileMutation__
 *
 * To run a mutation, you first call `useDeleteVideoFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoFileMutation, { data, loading, error }] = useDeleteVideoFileMutation({
 *   variables: {
 *      videoRef: // value for 'videoRef'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteVideoFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteVideoFileMutation, Generated.DeleteVideoFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteVideoFileMutation, Generated.DeleteVideoFileMutationVariables>(DeleteVideoFileDocument, options);
      }
export type DeleteVideoFileMutationHookResult = ReturnType<typeof useDeleteVideoFileMutation>;
export type DeleteVideoFileMutationResult = Apollo.MutationResult<Generated.DeleteVideoFileMutation>;
export type DeleteVideoFileMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteVideoFileMutation, Generated.DeleteVideoFileMutationVariables>;
export const GetVideoCopyrightDocument = /*#__PURE__*/ gql`
    query getVideoCopyright($ref: ID!, $type: EntityType!) {
  entityByRef(ref: $ref, type: $type) {
    ...VideoCopyright
  }
}
    ${VideoCopyrightFragmentDoc}`;

/**
 * __useGetVideoCopyrightQuery__
 *
 * To run a query within a React component, call `useGetVideoCopyrightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoCopyrightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoCopyrightQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetVideoCopyrightQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoCopyrightQuery, Generated.GetVideoCopyrightQueryVariables> & ({ variables: Generated.GetVideoCopyrightQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoCopyrightQuery, Generated.GetVideoCopyrightQueryVariables>(GetVideoCopyrightDocument, options);
      }
export function useGetVideoCopyrightLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoCopyrightQuery, Generated.GetVideoCopyrightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoCopyrightQuery, Generated.GetVideoCopyrightQueryVariables>(GetVideoCopyrightDocument, options);
        }
export function useGetVideoCopyrightSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoCopyrightQuery, Generated.GetVideoCopyrightQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoCopyrightQuery, Generated.GetVideoCopyrightQueryVariables>(GetVideoCopyrightDocument, options);
        }
export type GetVideoCopyrightQueryHookResult = ReturnType<typeof useGetVideoCopyrightQuery>;
export type GetVideoCopyrightLazyQueryHookResult = ReturnType<typeof useGetVideoCopyrightLazyQuery>;
export type GetVideoCopyrightSuspenseQueryHookResult = ReturnType<typeof useGetVideoCopyrightSuspenseQuery>;
export type GetVideoCopyrightQueryResult = Apollo.QueryResult<Generated.GetVideoCopyrightQuery, Generated.GetVideoCopyrightQueryVariables>;
export const DeleteVideoDocument = /*#__PURE__*/ gql`
    mutation deleteVideo($input: DeleteVideoInput!) {
  deleteVideo(input: $input) {
    __typename
    id
    ref
  }
}
    `;
export type DeleteVideoMutationFn = Apollo.MutationFunction<Generated.DeleteVideoMutation, Generated.DeleteVideoMutationVariables>;

/**
 * __useDeleteVideoMutation__
 *
 * To run a mutation, you first call `useDeleteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoMutation, { data, loading, error }] = useDeleteVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteVideoMutation, Generated.DeleteVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteVideoMutation, Generated.DeleteVideoMutationVariables>(DeleteVideoDocument, options);
      }
export type DeleteVideoMutationHookResult = ReturnType<typeof useDeleteVideoMutation>;
export type DeleteVideoMutationResult = Apollo.MutationResult<Generated.DeleteVideoMutation>;
export type DeleteVideoMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteVideoMutation, Generated.DeleteVideoMutationVariables>;
export const GetVideoFilesDocument = /*#__PURE__*/ gql`
    query getVideoFiles($ref: ID!, $type: EntityType!) {
  entityByRef(ref: $ref, type: $type) {
    __typename
    ...VideoFiles
    ...VideoAlt
  }
}
    ${VideoFilesFragmentDoc}
${VideoAltFragmentDoc}`;

/**
 * __useGetVideoFilesQuery__
 *
 * To run a query within a React component, call `useGetVideoFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoFilesQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetVideoFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoFilesQuery, Generated.GetVideoFilesQueryVariables> & ({ variables: Generated.GetVideoFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoFilesQuery, Generated.GetVideoFilesQueryVariables>(GetVideoFilesDocument, options);
      }
export function useGetVideoFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoFilesQuery, Generated.GetVideoFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoFilesQuery, Generated.GetVideoFilesQueryVariables>(GetVideoFilesDocument, options);
        }
export function useGetVideoFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoFilesQuery, Generated.GetVideoFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoFilesQuery, Generated.GetVideoFilesQueryVariables>(GetVideoFilesDocument, options);
        }
export type GetVideoFilesQueryHookResult = ReturnType<typeof useGetVideoFilesQuery>;
export type GetVideoFilesLazyQueryHookResult = ReturnType<typeof useGetVideoFilesLazyQuery>;
export type GetVideoFilesSuspenseQueryHookResult = ReturnType<typeof useGetVideoFilesSuspenseQuery>;
export type GetVideoFilesQueryResult = Apollo.QueryResult<Generated.GetVideoFilesQuery, Generated.GetVideoFilesQueryVariables>;
export const GetVideoEmbedCodeDocument = /*#__PURE__*/ gql`
    query getVideoEmbedCode($id: ID!) {
  entity(id: $id) {
    ...VideoEmbedCode
  }
}
    ${VideoEmbedCodeFragmentDoc}`;

/**
 * __useGetVideoEmbedCodeQuery__
 *
 * To run a query within a React component, call `useGetVideoEmbedCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoEmbedCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoEmbedCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVideoEmbedCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoEmbedCodeQuery, Generated.GetVideoEmbedCodeQueryVariables> & ({ variables: Generated.GetVideoEmbedCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoEmbedCodeQuery, Generated.GetVideoEmbedCodeQueryVariables>(GetVideoEmbedCodeDocument, options);
      }
export function useGetVideoEmbedCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoEmbedCodeQuery, Generated.GetVideoEmbedCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoEmbedCodeQuery, Generated.GetVideoEmbedCodeQueryVariables>(GetVideoEmbedCodeDocument, options);
        }
export function useGetVideoEmbedCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoEmbedCodeQuery, Generated.GetVideoEmbedCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoEmbedCodeQuery, Generated.GetVideoEmbedCodeQueryVariables>(GetVideoEmbedCodeDocument, options);
        }
export type GetVideoEmbedCodeQueryHookResult = ReturnType<typeof useGetVideoEmbedCodeQuery>;
export type GetVideoEmbedCodeLazyQueryHookResult = ReturnType<typeof useGetVideoEmbedCodeLazyQuery>;
export type GetVideoEmbedCodeSuspenseQueryHookResult = ReturnType<typeof useGetVideoEmbedCodeSuspenseQuery>;
export type GetVideoEmbedCodeQueryResult = Apollo.QueryResult<Generated.GetVideoEmbedCodeQuery, Generated.GetVideoEmbedCodeQueryVariables>;
export const GetVideoLanguageAndSubtitleDocument = /*#__PURE__*/ gql`
    query getVideoLanguageAndSubtitle($id: ID!) {
  entity(id: $id) {
    ...VideoLanguageAndSubtitleB2B
    ...VideoLanguageAndSubtitleLegacy
  }
}
    ${VideoLanguageAndSubtitleB2BFragmentDoc}
${VideoLanguageAndSubtitleLegacyFragmentDoc}`;

/**
 * __useGetVideoLanguageAndSubtitleQuery__
 *
 * To run a query within a React component, call `useGetVideoLanguageAndSubtitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLanguageAndSubtitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLanguageAndSubtitleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVideoLanguageAndSubtitleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoLanguageAndSubtitleQuery, Generated.GetVideoLanguageAndSubtitleQueryVariables> & ({ variables: Generated.GetVideoLanguageAndSubtitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoLanguageAndSubtitleQuery, Generated.GetVideoLanguageAndSubtitleQueryVariables>(GetVideoLanguageAndSubtitleDocument, options);
      }
export function useGetVideoLanguageAndSubtitleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoLanguageAndSubtitleQuery, Generated.GetVideoLanguageAndSubtitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoLanguageAndSubtitleQuery, Generated.GetVideoLanguageAndSubtitleQueryVariables>(GetVideoLanguageAndSubtitleDocument, options);
        }
export function useGetVideoLanguageAndSubtitleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoLanguageAndSubtitleQuery, Generated.GetVideoLanguageAndSubtitleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoLanguageAndSubtitleQuery, Generated.GetVideoLanguageAndSubtitleQueryVariables>(GetVideoLanguageAndSubtitleDocument, options);
        }
export type GetVideoLanguageAndSubtitleQueryHookResult = ReturnType<typeof useGetVideoLanguageAndSubtitleQuery>;
export type GetVideoLanguageAndSubtitleLazyQueryHookResult = ReturnType<typeof useGetVideoLanguageAndSubtitleLazyQuery>;
export type GetVideoLanguageAndSubtitleSuspenseQueryHookResult = ReturnType<typeof useGetVideoLanguageAndSubtitleSuspenseQuery>;
export type GetVideoLanguageAndSubtitleQueryResult = Apollo.QueryResult<Generated.GetVideoLanguageAndSubtitleQuery, Generated.GetVideoLanguageAndSubtitleQueryVariables>;
export const GetVideoListDocument = /*#__PURE__*/ gql`
    query getVideoList($limit: Int, $offset: Int!, $orderBy: VideoOrder!, $search: String, $brandId: ID, $type: VideoType, $universes: [VideoUniverse]) {
  videoLegacyList(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    search: $search
    brandId: $brandId
    type: $type
    universes: $universes
  ) {
    totalCount
    nodes {
      __typename
      id
      active
      ref
      title
      generatedTitle
      type
      universe
      language
      subtitle
      duration {
        hours
        minutes
        seconds
      }
      metadata {
        ...Metadata
      }
      snapshot {
        path
        url
      }
      previewVideoFile {
        cdnUrl
      }
    }
  }
}
    ${MetadataFragmentDoc}`;

/**
 * __useGetVideoListQuery__
 *
 * To run a query within a React component, call `useGetVideoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      brandId: // value for 'brandId'
 *      type: // value for 'type'
 *      universes: // value for 'universes'
 *   },
 * });
 */
export function useGetVideoListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoListQuery, Generated.GetVideoListQueryVariables> & ({ variables: Generated.GetVideoListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoListQuery, Generated.GetVideoListQueryVariables>(GetVideoListDocument, options);
      }
export function useGetVideoListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoListQuery, Generated.GetVideoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoListQuery, Generated.GetVideoListQueryVariables>(GetVideoListDocument, options);
        }
export function useGetVideoListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoListQuery, Generated.GetVideoListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoListQuery, Generated.GetVideoListQueryVariables>(GetVideoListDocument, options);
        }
export type GetVideoListQueryHookResult = ReturnType<typeof useGetVideoListQuery>;
export type GetVideoListLazyQueryHookResult = ReturnType<typeof useGetVideoListLazyQuery>;
export type GetVideoListSuspenseQueryHookResult = ReturnType<typeof useGetVideoListSuspenseQuery>;
export type GetVideoListQueryResult = Apollo.QueryResult<Generated.GetVideoListQuery, Generated.GetVideoListQueryVariables>;
export const GetVideoRestrictionsDocument = /*#__PURE__*/ gql`
    query getVideoRestrictions($id: ID!) {
  entity(id: $id) {
    ...VideoRestrictions
  }
}
    ${VideoRestrictionsFragmentDoc}`;

/**
 * __useGetVideoRestrictionsQuery__
 *
 * To run a query within a React component, call `useGetVideoRestrictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoRestrictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoRestrictionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVideoRestrictionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoRestrictionsQuery, Generated.GetVideoRestrictionsQueryVariables> & ({ variables: Generated.GetVideoRestrictionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoRestrictionsQuery, Generated.GetVideoRestrictionsQueryVariables>(GetVideoRestrictionsDocument, options);
      }
export function useGetVideoRestrictionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoRestrictionsQuery, Generated.GetVideoRestrictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoRestrictionsQuery, Generated.GetVideoRestrictionsQueryVariables>(GetVideoRestrictionsDocument, options);
        }
export function useGetVideoRestrictionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoRestrictionsQuery, Generated.GetVideoRestrictionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoRestrictionsQuery, Generated.GetVideoRestrictionsQueryVariables>(GetVideoRestrictionsDocument, options);
        }
export type GetVideoRestrictionsQueryHookResult = ReturnType<typeof useGetVideoRestrictionsQuery>;
export type GetVideoRestrictionsLazyQueryHookResult = ReturnType<typeof useGetVideoRestrictionsLazyQuery>;
export type GetVideoRestrictionsSuspenseQueryHookResult = ReturnType<typeof useGetVideoRestrictionsSuspenseQuery>;
export type GetVideoRestrictionsQueryResult = Apollo.QueryResult<Generated.GetVideoRestrictionsQuery, Generated.GetVideoRestrictionsQueryVariables>;
export const GetVideoRelatedEntitiesDocument = /*#__PURE__*/ gql`
    query getVideoRelatedEntities($id: ID!) {
  entity(id: $id) {
    ...VideoRelatedEntities
  }
}
    ${VideoRelatedEntitiesFragmentDoc}`;

/**
 * __useGetVideoRelatedEntitiesQuery__
 *
 * To run a query within a React component, call `useGetVideoRelatedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoRelatedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoRelatedEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVideoRelatedEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoRelatedEntitiesQuery, Generated.GetVideoRelatedEntitiesQueryVariables> & ({ variables: Generated.GetVideoRelatedEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoRelatedEntitiesQuery, Generated.GetVideoRelatedEntitiesQueryVariables>(GetVideoRelatedEntitiesDocument, options);
      }
export function useGetVideoRelatedEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoRelatedEntitiesQuery, Generated.GetVideoRelatedEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoRelatedEntitiesQuery, Generated.GetVideoRelatedEntitiesQueryVariables>(GetVideoRelatedEntitiesDocument, options);
        }
export function useGetVideoRelatedEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoRelatedEntitiesQuery, Generated.GetVideoRelatedEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoRelatedEntitiesQuery, Generated.GetVideoRelatedEntitiesQueryVariables>(GetVideoRelatedEntitiesDocument, options);
        }
export type GetVideoRelatedEntitiesQueryHookResult = ReturnType<typeof useGetVideoRelatedEntitiesQuery>;
export type GetVideoRelatedEntitiesLazyQueryHookResult = ReturnType<typeof useGetVideoRelatedEntitiesLazyQuery>;
export type GetVideoRelatedEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetVideoRelatedEntitiesSuspenseQuery>;
export type GetVideoRelatedEntitiesQueryResult = Apollo.QueryResult<Generated.GetVideoRelatedEntitiesQuery, Generated.GetVideoRelatedEntitiesQueryVariables>;
export const GetVideoSuggestedTitleDocument = /*#__PURE__*/ gql`
    query getVideoSuggestedTitle($ref: ID!, $type: EntityType!) {
  entityByRef(ref: $ref, type: $type) {
    __typename
    ...VideoSuggestedTitle
  }
}
    ${VideoSuggestedTitleFragmentDoc}`;

/**
 * __useGetVideoSuggestedTitleQuery__
 *
 * To run a query within a React component, call `useGetVideoSuggestedTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoSuggestedTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoSuggestedTitleQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetVideoSuggestedTitleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoSuggestedTitleQuery, Generated.GetVideoSuggestedTitleQueryVariables> & ({ variables: Generated.GetVideoSuggestedTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoSuggestedTitleQuery, Generated.GetVideoSuggestedTitleQueryVariables>(GetVideoSuggestedTitleDocument, options);
      }
export function useGetVideoSuggestedTitleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoSuggestedTitleQuery, Generated.GetVideoSuggestedTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoSuggestedTitleQuery, Generated.GetVideoSuggestedTitleQueryVariables>(GetVideoSuggestedTitleDocument, options);
        }
export function useGetVideoSuggestedTitleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoSuggestedTitleQuery, Generated.GetVideoSuggestedTitleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoSuggestedTitleQuery, Generated.GetVideoSuggestedTitleQueryVariables>(GetVideoSuggestedTitleDocument, options);
        }
export type GetVideoSuggestedTitleQueryHookResult = ReturnType<typeof useGetVideoSuggestedTitleQuery>;
export type GetVideoSuggestedTitleLazyQueryHookResult = ReturnType<typeof useGetVideoSuggestedTitleLazyQuery>;
export type GetVideoSuggestedTitleSuspenseQueryHookResult = ReturnType<typeof useGetVideoSuggestedTitleSuspenseQuery>;
export type GetVideoSuggestedTitleQueryResult = Apollo.QueryResult<Generated.GetVideoSuggestedTitleQuery, Generated.GetVideoSuggestedTitleQueryVariables>;
export const LinkEntityToVideoDocument = /*#__PURE__*/ gql`
    mutation linkEntityToVideo($input: LinkEntityToVideoInput!) {
  linkEntityToVideo(input: $input) {
    __typename
  }
}
    `;
export type LinkEntityToVideoMutationFn = Apollo.MutationFunction<Generated.LinkEntityToVideoMutation, Generated.LinkEntityToVideoMutationVariables>;

/**
 * __useLinkEntityToVideoMutation__
 *
 * To run a mutation, you first call `useLinkEntityToVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEntityToVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEntityToVideoMutation, { data, loading, error }] = useLinkEntityToVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkEntityToVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkEntityToVideoMutation, Generated.LinkEntityToVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkEntityToVideoMutation, Generated.LinkEntityToVideoMutationVariables>(LinkEntityToVideoDocument, options);
      }
export type LinkEntityToVideoMutationHookResult = ReturnType<typeof useLinkEntityToVideoMutation>;
export type LinkEntityToVideoMutationResult = Apollo.MutationResult<Generated.LinkEntityToVideoMutation>;
export type LinkEntityToVideoMutationOptions = Apollo.BaseMutationOptions<Generated.LinkEntityToVideoMutation, Generated.LinkEntityToVideoMutationVariables>;
export const GetVideoDocument = /*#__PURE__*/ gql`
    query getVideo($ref: ID!, $type: EntityType!) {
  entityByRef(ref: $ref, type: $type) {
    __typename
    ...VideoEntity
  }
}
    ${VideoEntityFragmentDoc}`;

/**
 * __useGetVideoQuery__
 *
 * To run a query within a React component, call `useGetVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetVideoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetVideoQuery, Generated.GetVideoQueryVariables> & ({ variables: Generated.GetVideoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetVideoQuery, Generated.GetVideoQueryVariables>(GetVideoDocument, options);
      }
export function useGetVideoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetVideoQuery, Generated.GetVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetVideoQuery, Generated.GetVideoQueryVariables>(GetVideoDocument, options);
        }
export function useGetVideoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetVideoQuery, Generated.GetVideoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetVideoQuery, Generated.GetVideoQueryVariables>(GetVideoDocument, options);
        }
export type GetVideoQueryHookResult = ReturnType<typeof useGetVideoQuery>;
export type GetVideoLazyQueryHookResult = ReturnType<typeof useGetVideoLazyQuery>;
export type GetVideoSuspenseQueryHookResult = ReturnType<typeof useGetVideoSuspenseQuery>;
export type GetVideoQueryResult = Apollo.QueryResult<Generated.GetVideoQuery, Generated.GetVideoQueryVariables>;
export const MoveEntityVideoDocument = /*#__PURE__*/ gql`
    mutation moveEntityVideo($input: MoveEntityVideoInput!) {
  moveEntityVideo(input: $input) {
    __typename
    ... on Movie {
      id
    }
    ... on Series {
      id
    }
    ... on SeriesSeason {
      id
    }
    ... on SeriesEpisode {
      id
    }
    ... on Person {
      id
    }
  }
}
    `;
export type MoveEntityVideoMutationFn = Apollo.MutationFunction<Generated.MoveEntityVideoMutation, Generated.MoveEntityVideoMutationVariables>;

/**
 * __useMoveEntityVideoMutation__
 *
 * To run a mutation, you first call `useMoveEntityVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveEntityVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveEntityVideoMutation, { data, loading, error }] = useMoveEntityVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveEntityVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveEntityVideoMutation, Generated.MoveEntityVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveEntityVideoMutation, Generated.MoveEntityVideoMutationVariables>(MoveEntityVideoDocument, options);
      }
export type MoveEntityVideoMutationHookResult = ReturnType<typeof useMoveEntityVideoMutation>;
export type MoveEntityVideoMutationResult = Apollo.MutationResult<Generated.MoveEntityVideoMutation>;
export type MoveEntityVideoMutationOptions = Apollo.BaseMutationOptions<Generated.MoveEntityVideoMutation, Generated.MoveEntityVideoMutationVariables>;
export const UnlinkEntityFromVideoDocument = /*#__PURE__*/ gql`
    mutation unlinkEntityFromVideo($input: UnlinkEntityFromVideoInput!) {
  unlinkEntityFromVideo(input: $input) {
    __typename
  }
}
    `;
export type UnlinkEntityFromVideoMutationFn = Apollo.MutationFunction<Generated.UnlinkEntityFromVideoMutation, Generated.UnlinkEntityFromVideoMutationVariables>;

/**
 * __useUnlinkEntityFromVideoMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityFromVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityFromVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityFromVideoMutation, { data, loading, error }] = useUnlinkEntityFromVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkEntityFromVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkEntityFromVideoMutation, Generated.UnlinkEntityFromVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkEntityFromVideoMutation, Generated.UnlinkEntityFromVideoMutationVariables>(UnlinkEntityFromVideoDocument, options);
      }
export type UnlinkEntityFromVideoMutationHookResult = ReturnType<typeof useUnlinkEntityFromVideoMutation>;
export type UnlinkEntityFromVideoMutationResult = Apollo.MutationResult<Generated.UnlinkEntityFromVideoMutation>;
export type UnlinkEntityFromVideoMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkEntityFromVideoMutation, Generated.UnlinkEntityFromVideoMutationVariables>;
export const SetYoutubeVideoIdDocument = /*#__PURE__*/ gql`
    mutation SetYoutubeVideoId($videoRef: ID!, $youtubeVideo: String!) {
  setYoutubeVideoId(input: {videoRef: $videoRef, youtubeVideo: $youtubeVideo}) {
    __typename
    id
    ref
    youtubeUrl
    ...VideoAlt
  }
}
    ${VideoAltFragmentDoc}`;
export type SetYoutubeVideoIdMutationFn = Apollo.MutationFunction<Generated.SetYoutubeVideoIdMutation, Generated.SetYoutubeVideoIdMutationVariables>;

/**
 * __useSetYoutubeVideoIdMutation__
 *
 * To run a mutation, you first call `useSetYoutubeVideoIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetYoutubeVideoIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setYoutubeVideoIdMutation, { data, loading, error }] = useSetYoutubeVideoIdMutation({
 *   variables: {
 *      videoRef: // value for 'videoRef'
 *      youtubeVideo: // value for 'youtubeVideo'
 *   },
 * });
 */
export function useSetYoutubeVideoIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.SetYoutubeVideoIdMutation, Generated.SetYoutubeVideoIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.SetYoutubeVideoIdMutation, Generated.SetYoutubeVideoIdMutationVariables>(SetYoutubeVideoIdDocument, options);
      }
export type SetYoutubeVideoIdMutationHookResult = ReturnType<typeof useSetYoutubeVideoIdMutation>;
export type SetYoutubeVideoIdMutationResult = Apollo.MutationResult<Generated.SetYoutubeVideoIdMutation>;
export type SetYoutubeVideoIdMutationOptions = Apollo.BaseMutationOptions<Generated.SetYoutubeVideoIdMutation, Generated.SetYoutubeVideoIdMutationVariables>;
export const RetryVideoPlatformEncodingDocument = /*#__PURE__*/ gql`
    mutation retryVideoPlatformEncoding($videoRef: ID!, $platform: VideoPlatformEnum!, $youtubeChannelId: String) {
  retryVideoPlatformEncoding(
    input: {videoRef: $videoRef, platform: $platform, youtubeChannelId: $youtubeChannelId}
  ) {
    __typename
    id
    ...VideoAlt
  }
}
    ${VideoAltFragmentDoc}`;
export type RetryVideoPlatformEncodingMutationFn = Apollo.MutationFunction<Generated.RetryVideoPlatformEncodingMutation, Generated.RetryVideoPlatformEncodingMutationVariables>;

/**
 * __useRetryVideoPlatformEncodingMutation__
 *
 * To run a mutation, you first call `useRetryVideoPlatformEncodingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryVideoPlatformEncodingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryVideoPlatformEncodingMutation, { data, loading, error }] = useRetryVideoPlatformEncodingMutation({
 *   variables: {
 *      videoRef: // value for 'videoRef'
 *      platform: // value for 'platform'
 *      youtubeChannelId: // value for 'youtubeChannelId'
 *   },
 * });
 */
export function useRetryVideoPlatformEncodingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.RetryVideoPlatformEncodingMutation, Generated.RetryVideoPlatformEncodingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.RetryVideoPlatformEncodingMutation, Generated.RetryVideoPlatformEncodingMutationVariables>(RetryVideoPlatformEncodingDocument, options);
      }
export type RetryVideoPlatformEncodingMutationHookResult = ReturnType<typeof useRetryVideoPlatformEncodingMutation>;
export type RetryVideoPlatformEncodingMutationResult = Apollo.MutationResult<Generated.RetryVideoPlatformEncodingMutation>;
export type RetryVideoPlatformEncodingMutationOptions = Apollo.BaseMutationOptions<Generated.RetryVideoPlatformEncodingMutation, Generated.RetryVideoPlatformEncodingMutationVariables>;
export const VideoEncodingProgressDocument = /*#__PURE__*/ gql`
    subscription videoEncodingProgress($videoId: ID!) {
  videoEncodingProgress(videoId: $videoId) {
    videoId
    videoEncoders {
      ...VideoEncoderIdentity
    }
  }
}
    ${VideoEncoderIdentityFragmentDoc}`;

/**
 * __useVideoEncodingProgressSubscription__
 *
 * To run a query within a React component, call `useVideoEncodingProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVideoEncodingProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoEncodingProgressSubscription({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useVideoEncodingProgressSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<Generated.VideoEncodingProgressSubscription, Generated.VideoEncodingProgressSubscriptionVariables> & ({ variables: Generated.VideoEncodingProgressSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<Generated.VideoEncodingProgressSubscription, Generated.VideoEncodingProgressSubscriptionVariables>(VideoEncodingProgressDocument, options);
      }
export type VideoEncodingProgressSubscriptionHookResult = ReturnType<typeof useVideoEncodingProgressSubscription>;
export type VideoEncodingProgressSubscriptionResult = Apollo.SubscriptionResult<Generated.VideoEncodingProgressSubscription>;
export const UpdateVideoDocument = /*#__PURE__*/ gql`
    mutation updateVideo($input: UpdateVideoInput!) {
  updateVideo(input: $input) {
    ...VideoIdentity
    ...VideoMetadata
    ...VideoRestrictions
  }
}
    ${VideoIdentityFragmentDoc}
${VideoMetadataFragmentDoc}
${VideoRestrictionsFragmentDoc}`;
export type UpdateVideoMutationFn = Apollo.MutationFunction<Generated.UpdateVideoMutation, Generated.UpdateVideoMutationVariables>;

/**
 * __useUpdateVideoMutation__
 *
 * To run a mutation, you first call `useUpdateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoMutation, { data, loading, error }] = useUpdateVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateVideoMutation, Generated.UpdateVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateVideoMutation, Generated.UpdateVideoMutationVariables>(UpdateVideoDocument, options);
      }
export type UpdateVideoMutationHookResult = ReturnType<typeof useUpdateVideoMutation>;
export type UpdateVideoMutationResult = Apollo.MutationResult<Generated.UpdateVideoMutation>;
export type UpdateVideoMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateVideoMutation, Generated.UpdateVideoMutationVariables>;
export const UploadVideoDocument = /*#__PURE__*/ gql`
    mutation uploadVideo($uploadToken: String!, $videoRef: ID!, $platforms: [VideoPlatformEnum!], $youtubeChannelId: String) {
  uploadVideo(
    input: {uploadToken: $uploadToken, videoRef: $videoRef, platforms: $platforms, youtubeChannelId: $youtubeChannelId}
  ) {
    __typename
    ... on VideoB2B {
      id
      ref
    }
    ... on VideoLegacy {
      id
      ref
    }
  }
}
    `;
export type UploadVideoMutationFn = Apollo.MutationFunction<Generated.UploadVideoMutation, Generated.UploadVideoMutationVariables>;

/**
 * __useUploadVideoMutation__
 *
 * To run a mutation, you first call `useUploadVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVideoMutation, { data, loading, error }] = useUploadVideoMutation({
 *   variables: {
 *      uploadToken: // value for 'uploadToken'
 *      videoRef: // value for 'videoRef'
 *      platforms: // value for 'platforms'
 *      youtubeChannelId: // value for 'youtubeChannelId'
 *   },
 * });
 */
export function useUploadVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UploadVideoMutation, Generated.UploadVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UploadVideoMutation, Generated.UploadVideoMutationVariables>(UploadVideoDocument, options);
      }
export type UploadVideoMutationHookResult = ReturnType<typeof useUploadVideoMutation>;
export type UploadVideoMutationResult = Apollo.MutationResult<Generated.UploadVideoMutation>;
export type UploadVideoMutationOptions = Apollo.BaseMutationOptions<Generated.UploadVideoMutation, Generated.UploadVideoMutationVariables>;
export const CreateWidgetDocument = /*#__PURE__*/ gql`
    mutation CreateWidget($input: CreateWidgetInput!) {
  createWidget(input: $input) {
    ...WidgetIdentity
  }
}
    ${WidgetIdentityFragmentDoc}`;
export type CreateWidgetMutationFn = Apollo.MutationFunction<Generated.CreateWidgetMutation, Generated.CreateWidgetMutationVariables>;

/**
 * __useCreateWidgetMutation__
 *
 * To run a mutation, you first call `useCreateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWidgetMutation, { data, loading, error }] = useCreateWidgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWidgetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateWidgetMutation, Generated.CreateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateWidgetMutation, Generated.CreateWidgetMutationVariables>(CreateWidgetDocument, options);
      }
export type CreateWidgetMutationHookResult = ReturnType<typeof useCreateWidgetMutation>;
export type CreateWidgetMutationResult = Apollo.MutationResult<Generated.CreateWidgetMutation>;
export type CreateWidgetMutationOptions = Apollo.BaseMutationOptions<Generated.CreateWidgetMutation, Generated.CreateWidgetMutationVariables>;
export const DeleteWidgetDocument = /*#__PURE__*/ gql`
    mutation DeleteWidget($input: DeleteWidgetInput!) {
  deleteWidget(input: $input) {
    id
  }
}
    `;
export type DeleteWidgetMutationFn = Apollo.MutationFunction<Generated.DeleteWidgetMutation, Generated.DeleteWidgetMutationVariables>;

/**
 * __useDeleteWidgetMutation__
 *
 * To run a mutation, you first call `useDeleteWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWidgetMutation, { data, loading, error }] = useDeleteWidgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWidgetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteWidgetMutation, Generated.DeleteWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteWidgetMutation, Generated.DeleteWidgetMutationVariables>(DeleteWidgetDocument, options);
      }
export type DeleteWidgetMutationHookResult = ReturnType<typeof useDeleteWidgetMutation>;
export type DeleteWidgetMutationResult = Apollo.MutationResult<Generated.DeleteWidgetMutation>;
export type DeleteWidgetMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteWidgetMutation, Generated.DeleteWidgetMutationVariables>;
export const GetWidgetDocument = /*#__PURE__*/ gql`
    query getWidget($ref: ID!) {
  entityByRef(type: WIDGET, ref: $ref) {
    __typename
    ... on Widget {
      ...WidgetIdentity
    }
  }
}
    ${WidgetIdentityFragmentDoc}`;

/**
 * __useGetWidgetQuery__
 *
 * To run a query within a React component, call `useGetWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetWidgetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetWidgetQuery, Generated.GetWidgetQueryVariables> & ({ variables: Generated.GetWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetWidgetQuery, Generated.GetWidgetQueryVariables>(GetWidgetDocument, options);
      }
export function useGetWidgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetWidgetQuery, Generated.GetWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetWidgetQuery, Generated.GetWidgetQueryVariables>(GetWidgetDocument, options);
        }
export function useGetWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetWidgetQuery, Generated.GetWidgetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetWidgetQuery, Generated.GetWidgetQueryVariables>(GetWidgetDocument, options);
        }
export type GetWidgetQueryHookResult = ReturnType<typeof useGetWidgetQuery>;
export type GetWidgetLazyQueryHookResult = ReturnType<typeof useGetWidgetLazyQuery>;
export type GetWidgetSuspenseQueryHookResult = ReturnType<typeof useGetWidgetSuspenseQuery>;
export type GetWidgetQueryResult = Apollo.QueryResult<Generated.GetWidgetQuery, Generated.GetWidgetQueryVariables>;
export const UpdateWidgetDocument = /*#__PURE__*/ gql`
    mutation UpdateWidget($input: UpdateWidgetInput!) {
  updateWidget(input: $input) {
    ...WidgetIdentity
  }
}
    ${WidgetIdentityFragmentDoc}`;
export type UpdateWidgetMutationFn = Apollo.MutationFunction<Generated.UpdateWidgetMutation, Generated.UpdateWidgetMutationVariables>;

/**
 * __useUpdateWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetMutation, { data, loading, error }] = useUpdateWidgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWidgetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateWidgetMutation, Generated.UpdateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateWidgetMutation, Generated.UpdateWidgetMutationVariables>(UpdateWidgetDocument, options);
      }
export type UpdateWidgetMutationHookResult = ReturnType<typeof useUpdateWidgetMutation>;
export type UpdateWidgetMutationResult = Apollo.MutationResult<Generated.UpdateWidgetMutation>;
export type UpdateWidgetMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateWidgetMutation, Generated.UpdateWidgetMutationVariables>;
export const SearchWidgetsDocument = /*#__PURE__*/ gql`
    query SearchWidgets($search: String, $limit: Int, $offset: Int!) {
  widgets(search: $search, limit: $limit, offset: $offset) {
    totalCount
    nodes {
      __typename
      ...WidgetIdentity
      metadata {
        ...Metadata
      }
    }
  }
}
    ${WidgetIdentityFragmentDoc}
${MetadataFragmentDoc}`;

/**
 * __useSearchWidgetsQuery__
 *
 * To run a query within a React component, call `useSearchWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWidgetsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchWidgetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchWidgetsQuery, Generated.SearchWidgetsQueryVariables> & ({ variables: Generated.SearchWidgetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchWidgetsQuery, Generated.SearchWidgetsQueryVariables>(SearchWidgetsDocument, options);
      }
export function useSearchWidgetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchWidgetsQuery, Generated.SearchWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchWidgetsQuery, Generated.SearchWidgetsQueryVariables>(SearchWidgetsDocument, options);
        }
export function useSearchWidgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchWidgetsQuery, Generated.SearchWidgetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchWidgetsQuery, Generated.SearchWidgetsQueryVariables>(SearchWidgetsDocument, options);
        }
export type SearchWidgetsQueryHookResult = ReturnType<typeof useSearchWidgetsQuery>;
export type SearchWidgetsLazyQueryHookResult = ReturnType<typeof useSearchWidgetsLazyQuery>;
export type SearchWidgetsSuspenseQueryHookResult = ReturnType<typeof useSearchWidgetsSuspenseQuery>;
export type SearchWidgetsQueryResult = Apollo.QueryResult<Generated.SearchWidgetsQuery, Generated.SearchWidgetsQueryVariables>;
export const UpdateApplicationDocument = /*#__PURE__*/ gql`
    mutation updateApplication($id: ID!, $active: Boolean!) {
  updateApplication(input: {id: $id, active: $active}) {
    ...ApplicationIdentity
  }
}
    ${ApplicationIdentityFragmentDoc}`;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<Generated.UpdateApplicationMutation, Generated.UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateApplicationMutation, Generated.UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateApplicationMutation, Generated.UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = Apollo.MutationResult<Generated.UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateApplicationMutation, Generated.UpdateApplicationMutationVariables>;
export const GetApplicationListDocument = /*#__PURE__*/ gql`
    query getApplicationList($limit: Int, $offset: Int!, $search: String!) {
  applications(limit: $limit, offset: $offset, search: $search) {
    totalCount
    nodes {
      id
      ...ApplicationRow
    }
  }
}
    ${ApplicationRowFragmentDoc}`;

/**
 * __useGetApplicationListQuery__
 *
 * To run a query within a React component, call `useGetApplicationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetApplicationListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetApplicationListQuery, Generated.GetApplicationListQueryVariables> & ({ variables: Generated.GetApplicationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetApplicationListQuery, Generated.GetApplicationListQueryVariables>(GetApplicationListDocument, options);
      }
export function useGetApplicationListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetApplicationListQuery, Generated.GetApplicationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetApplicationListQuery, Generated.GetApplicationListQueryVariables>(GetApplicationListDocument, options);
        }
export function useGetApplicationListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetApplicationListQuery, Generated.GetApplicationListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetApplicationListQuery, Generated.GetApplicationListQueryVariables>(GetApplicationListDocument, options);
        }
export type GetApplicationListQueryHookResult = ReturnType<typeof useGetApplicationListQuery>;
export type GetApplicationListLazyQueryHookResult = ReturnType<typeof useGetApplicationListLazyQuery>;
export type GetApplicationListSuspenseQueryHookResult = ReturnType<typeof useGetApplicationListSuspenseQuery>;
export type GetApplicationListQueryResult = Apollo.QueryResult<Generated.GetApplicationListQuery, Generated.GetApplicationListQueryVariables>;
export const GetTokenApplicationsDocument = /*#__PURE__*/ gql`
    query getTokenApplications {
  applications(limit: 100) {
    totalCount
    nodes {
      ...ApplicationIdentity
    }
  }
}
    ${ApplicationIdentityFragmentDoc}`;

/**
 * __useGetTokenApplicationsQuery__
 *
 * To run a query within a React component, call `useGetTokenApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTokenApplicationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetTokenApplicationsQuery, Generated.GetTokenApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTokenApplicationsQuery, Generated.GetTokenApplicationsQueryVariables>(GetTokenApplicationsDocument, options);
      }
export function useGetTokenApplicationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTokenApplicationsQuery, Generated.GetTokenApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTokenApplicationsQuery, Generated.GetTokenApplicationsQueryVariables>(GetTokenApplicationsDocument, options);
        }
export function useGetTokenApplicationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTokenApplicationsQuery, Generated.GetTokenApplicationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTokenApplicationsQuery, Generated.GetTokenApplicationsQueryVariables>(GetTokenApplicationsDocument, options);
        }
export type GetTokenApplicationsQueryHookResult = ReturnType<typeof useGetTokenApplicationsQuery>;
export type GetTokenApplicationsLazyQueryHookResult = ReturnType<typeof useGetTokenApplicationsLazyQuery>;
export type GetTokenApplicationsSuspenseQueryHookResult = ReturnType<typeof useGetTokenApplicationsSuspenseQuery>;
export type GetTokenApplicationsQueryResult = Apollo.QueryResult<Generated.GetTokenApplicationsQuery, Generated.GetTokenApplicationsQueryVariables>;
export const DeleteTokenDocument = /*#__PURE__*/ gql`
    mutation deleteToken($tokenId: ID!) {
  deleteToken(input: {tokenId: $tokenId}) {
    id
  }
}
    `;
export type DeleteTokenMutationFn = Apollo.MutationFunction<Generated.DeleteTokenMutation, Generated.DeleteTokenMutationVariables>;

/**
 * __useDeleteTokenMutation__
 *
 * To run a mutation, you first call `useDeleteTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTokenMutation, { data, loading, error }] = useDeleteTokenMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useDeleteTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteTokenMutation, Generated.DeleteTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteTokenMutation, Generated.DeleteTokenMutationVariables>(DeleteTokenDocument, options);
      }
export type DeleteTokenMutationHookResult = ReturnType<typeof useDeleteTokenMutation>;
export type DeleteTokenMutationResult = Apollo.MutationResult<Generated.DeleteTokenMutation>;
export type DeleteTokenMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteTokenMutation, Generated.DeleteTokenMutationVariables>;
export const AddTokenDocument = /*#__PURE__*/ gql`
    mutation addToken($applicationId: ID!, $email: EmailAddress, $expiresAt: DateTime!, $scopeId: ID, $comment: String) {
  addToken(
    input: {applicationId: $applicationId, email: $email, expiresAt: $expiresAt, scopeId: $scopeId, comment: $comment}
  ) {
    ref
    id
  }
}
    `;
export type AddTokenMutationFn = Apollo.MutationFunction<Generated.AddTokenMutation, Generated.AddTokenMutationVariables>;

/**
 * __useAddTokenMutation__
 *
 * To run a mutation, you first call `useAddTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTokenMutation, { data, loading, error }] = useAddTokenMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      email: // value for 'email'
 *      expiresAt: // value for 'expiresAt'
 *      scopeId: // value for 'scopeId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddTokenMutation, Generated.AddTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddTokenMutation, Generated.AddTokenMutationVariables>(AddTokenDocument, options);
      }
export type AddTokenMutationHookResult = ReturnType<typeof useAddTokenMutation>;
export type AddTokenMutationResult = Apollo.MutationResult<Generated.AddTokenMutation>;
export type AddTokenMutationOptions = Apollo.BaseMutationOptions<Generated.AddTokenMutation, Generated.AddTokenMutationVariables>;
export const CreateApplicationDocument = /*#__PURE__*/ gql`
    mutation createApplication($name: String!, $active: Boolean!) {
  createApplication(input: {name: $name, active: $active}) {
    id
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<Generated.CreateApplicationMutation, Generated.CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateApplicationMutation, Generated.CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateApplicationMutation, Generated.CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<Generated.CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<Generated.CreateApplicationMutation, Generated.CreateApplicationMutationVariables>;
export const GetTokenListDocument = /*#__PURE__*/ gql`
    query getTokenList($limit: Int, $offset: Int!, $search: String!, $applicationIds: [ID!]!, $orderBy: TokenOrder!) {
  tokens(
    limit: $limit
    offset: $offset
    search: $search
    applicationIds: $applicationIds
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      id
      ref
      uuid
      metadata {
        createdAt
      }
      expiresAt
      active
      lastCheckedAt
      application {
        id
        name
        ref
      }
      user {
        nickname
      }
      scope {
        customer {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetTokenListQuery__
 *
 * To run a query within a React component, call `useGetTokenListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      applicationIds: // value for 'applicationIds'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetTokenListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTokenListQuery, Generated.GetTokenListQueryVariables> & ({ variables: Generated.GetTokenListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTokenListQuery, Generated.GetTokenListQueryVariables>(GetTokenListDocument, options);
      }
export function useGetTokenListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTokenListQuery, Generated.GetTokenListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTokenListQuery, Generated.GetTokenListQueryVariables>(GetTokenListDocument, options);
        }
export function useGetTokenListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTokenListQuery, Generated.GetTokenListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTokenListQuery, Generated.GetTokenListQueryVariables>(GetTokenListDocument, options);
        }
export type GetTokenListQueryHookResult = ReturnType<typeof useGetTokenListQuery>;
export type GetTokenListLazyQueryHookResult = ReturnType<typeof useGetTokenListLazyQuery>;
export type GetTokenListSuspenseQueryHookResult = ReturnType<typeof useGetTokenListSuspenseQuery>;
export type GetTokenListQueryResult = Apollo.QueryResult<Generated.GetTokenListQuery, Generated.GetTokenListQueryVariables>;
export const GetTokenScopesDocument = /*#__PURE__*/ gql`
    query getTokenScopes {
  scopes(limit: 10000) {
    nodes {
      id
      name
      customer {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetTokenScopesQuery__
 *
 * To run a query within a React component, call `useGetTokenScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenScopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTokenScopesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetTokenScopesQuery, Generated.GetTokenScopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTokenScopesQuery, Generated.GetTokenScopesQueryVariables>(GetTokenScopesDocument, options);
      }
export function useGetTokenScopesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTokenScopesQuery, Generated.GetTokenScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTokenScopesQuery, Generated.GetTokenScopesQueryVariables>(GetTokenScopesDocument, options);
        }
export function useGetTokenScopesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTokenScopesQuery, Generated.GetTokenScopesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTokenScopesQuery, Generated.GetTokenScopesQueryVariables>(GetTokenScopesDocument, options);
        }
export type GetTokenScopesQueryHookResult = ReturnType<typeof useGetTokenScopesQuery>;
export type GetTokenScopesLazyQueryHookResult = ReturnType<typeof useGetTokenScopesLazyQuery>;
export type GetTokenScopesSuspenseQueryHookResult = ReturnType<typeof useGetTokenScopesSuspenseQuery>;
export type GetTokenScopesQueryResult = Apollo.QueryResult<Generated.GetTokenScopesQuery, Generated.GetTokenScopesQueryVariables>;
export const UpdateTokenDocument = /*#__PURE__*/ gql`
    mutation updateToken($id: ID!, $active: Boolean!, $comment: String) {
  updateToken(input: {id: $id, active: $active, comment: $comment}) {
    ...TokenIdentity
  }
}
    ${TokenIdentityFragmentDoc}`;
export type UpdateTokenMutationFn = Apollo.MutationFunction<Generated.UpdateTokenMutation, Generated.UpdateTokenMutationVariables>;

/**
 * __useUpdateTokenMutation__
 *
 * To run a mutation, you first call `useUpdateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTokenMutation, { data, loading, error }] = useUpdateTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateTokenMutation, Generated.UpdateTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateTokenMutation, Generated.UpdateTokenMutationVariables>(UpdateTokenDocument, options);
      }
export type UpdateTokenMutationHookResult = ReturnType<typeof useUpdateTokenMutation>;
export type UpdateTokenMutationResult = Apollo.MutationResult<Generated.UpdateTokenMutation>;
export type UpdateTokenMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateTokenMutation, Generated.UpdateTokenMutationVariables>;
export const GetTokenDocument = /*#__PURE__*/ gql`
    query getToken($ref: ID!) {
  tokenByRef(ref: $ref) {
    ...TokenIdentity
  }
}
    ${TokenIdentityFragmentDoc}`;

/**
 * __useGetTokenQuery__
 *
 * To run a query within a React component, call `useGetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetTokenQuery, Generated.GetTokenQueryVariables> & ({ variables: Generated.GetTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetTokenQuery, Generated.GetTokenQueryVariables>(GetTokenDocument, options);
      }
export function useGetTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetTokenQuery, Generated.GetTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetTokenQuery, Generated.GetTokenQueryVariables>(GetTokenDocument, options);
        }
export function useGetTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetTokenQuery, Generated.GetTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetTokenQuery, Generated.GetTokenQueryVariables>(GetTokenDocument, options);
        }
export type GetTokenQueryHookResult = ReturnType<typeof useGetTokenQuery>;
export type GetTokenLazyQueryHookResult = ReturnType<typeof useGetTokenLazyQuery>;
export type GetTokenSuspenseQueryHookResult = ReturnType<typeof useGetTokenSuspenseQuery>;
export type GetTokenQueryResult = Apollo.QueryResult<Generated.GetTokenQuery, Generated.GetTokenQueryVariables>;
export const DeleteIgnoredProductDocument = /*#__PURE__*/ gql`
    mutation deleteIgnoredProduct($input: DeleteIgnoredProductInput!) {
  deleteIgnoredProduct(input: $input) {
    id
  }
}
    `;
export type DeleteIgnoredProductMutationFn = Apollo.MutationFunction<Generated.DeleteIgnoredProductMutation, Generated.DeleteIgnoredProductMutationVariables>;

/**
 * __useDeleteIgnoredProductMutation__
 *
 * To run a mutation, you first call `useDeleteIgnoredProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIgnoredProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIgnoredProductMutation, { data, loading, error }] = useDeleteIgnoredProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIgnoredProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteIgnoredProductMutation, Generated.DeleteIgnoredProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteIgnoredProductMutation, Generated.DeleteIgnoredProductMutationVariables>(DeleteIgnoredProductDocument, options);
      }
export type DeleteIgnoredProductMutationHookResult = ReturnType<typeof useDeleteIgnoredProductMutation>;
export type DeleteIgnoredProductMutationResult = Apollo.MutationResult<Generated.DeleteIgnoredProductMutation>;
export type DeleteIgnoredProductMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteIgnoredProductMutation, Generated.DeleteIgnoredProductMutationVariables>;
export const GetMatchedProductEntitiesDocument = /*#__PURE__*/ gql`
    query getMatchedProductEntities($productId: ID!) {
  matchedProductEntities(productId: $productId) {
    id
    linkedEntities {
      ... on Movie {
        ref
        id
        __typename
        title
      }
      ... on SeriesSeason {
        ref
        id
        __typename
        number
        series {
          ref
          id
          title
        }
      }
      ... on SeriesEpisode {
        ref
        id
        __typename
        number
        series {
          ref
          id
          title
        }
        season {
          ref
        }
      }
      ... on Series {
        ref
        id
        __typename
        title
      }
    }
  }
}
    `;

/**
 * __useGetMatchedProductEntitiesQuery__
 *
 * To run a query within a React component, call `useGetMatchedProductEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchedProductEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchedProductEntitiesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetMatchedProductEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMatchedProductEntitiesQuery, Generated.GetMatchedProductEntitiesQueryVariables> & ({ variables: Generated.GetMatchedProductEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMatchedProductEntitiesQuery, Generated.GetMatchedProductEntitiesQueryVariables>(GetMatchedProductEntitiesDocument, options);
      }
export function useGetMatchedProductEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMatchedProductEntitiesQuery, Generated.GetMatchedProductEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMatchedProductEntitiesQuery, Generated.GetMatchedProductEntitiesQueryVariables>(GetMatchedProductEntitiesDocument, options);
        }
export function useGetMatchedProductEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMatchedProductEntitiesQuery, Generated.GetMatchedProductEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMatchedProductEntitiesQuery, Generated.GetMatchedProductEntitiesQueryVariables>(GetMatchedProductEntitiesDocument, options);
        }
export type GetMatchedProductEntitiesQueryHookResult = ReturnType<typeof useGetMatchedProductEntitiesQuery>;
export type GetMatchedProductEntitiesLazyQueryHookResult = ReturnType<typeof useGetMatchedProductEntitiesLazyQuery>;
export type GetMatchedProductEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetMatchedProductEntitiesSuspenseQuery>;
export type GetMatchedProductEntitiesQueryResult = Apollo.QueryResult<Generated.GetMatchedProductEntitiesQuery, Generated.GetMatchedProductEntitiesQueryVariables>;
export const GetIgnoredProductsDocument = /*#__PURE__*/ gql`
    query getIgnoredProducts($limit: Int, $offset: Int!, $source: String!, $search: String) {
  ignoredProducts(
    limit: $limit
    offset: $offset
    source: $source
    search: $search
  ) {
    totalCount
    nodes {
      ...IgnoredProduct
    }
  }
}
    ${IgnoredProductFragmentDoc}`;

/**
 * __useGetIgnoredProductsQuery__
 *
 * To run a query within a React component, call `useGetIgnoredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIgnoredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIgnoredProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      source: // value for 'source'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetIgnoredProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetIgnoredProductsQuery, Generated.GetIgnoredProductsQueryVariables> & ({ variables: Generated.GetIgnoredProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetIgnoredProductsQuery, Generated.GetIgnoredProductsQueryVariables>(GetIgnoredProductsDocument, options);
      }
export function useGetIgnoredProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetIgnoredProductsQuery, Generated.GetIgnoredProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetIgnoredProductsQuery, Generated.GetIgnoredProductsQueryVariables>(GetIgnoredProductsDocument, options);
        }
export function useGetIgnoredProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetIgnoredProductsQuery, Generated.GetIgnoredProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetIgnoredProductsQuery, Generated.GetIgnoredProductsQueryVariables>(GetIgnoredProductsDocument, options);
        }
export type GetIgnoredProductsQueryHookResult = ReturnType<typeof useGetIgnoredProductsQuery>;
export type GetIgnoredProductsLazyQueryHookResult = ReturnType<typeof useGetIgnoredProductsLazyQuery>;
export type GetIgnoredProductsSuspenseQueryHookResult = ReturnType<typeof useGetIgnoredProductsSuspenseQuery>;
export type GetIgnoredProductsQueryResult = Apollo.QueryResult<Generated.GetIgnoredProductsQuery, Generated.GetIgnoredProductsQueryVariables>;
export const GetMatchedProductsDocument = /*#__PURE__*/ gql`
    query getMatchedProducts($limit: Int, $offset: Int!, $sourceName: String!, $countryId: ID!, $search: String) {
  matchedProducts(
    limit: $limit
    offset: $offset
    sourceName: $sourceName
    countryId: $countryId
    search: $search
  ) {
    totalCount
    nodes {
      ...MatchedProduct
    }
  }
}
    ${MatchedProductFragmentDoc}`;

/**
 * __useGetMatchedProductsQuery__
 *
 * To run a query within a React component, call `useGetMatchedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchedProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sourceName: // value for 'sourceName'
 *      countryId: // value for 'countryId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMatchedProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetMatchedProductsQuery, Generated.GetMatchedProductsQueryVariables> & ({ variables: Generated.GetMatchedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetMatchedProductsQuery, Generated.GetMatchedProductsQueryVariables>(GetMatchedProductsDocument, options);
      }
export function useGetMatchedProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetMatchedProductsQuery, Generated.GetMatchedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetMatchedProductsQuery, Generated.GetMatchedProductsQueryVariables>(GetMatchedProductsDocument, options);
        }
export function useGetMatchedProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetMatchedProductsQuery, Generated.GetMatchedProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetMatchedProductsQuery, Generated.GetMatchedProductsQueryVariables>(GetMatchedProductsDocument, options);
        }
export type GetMatchedProductsQueryHookResult = ReturnType<typeof useGetMatchedProductsQuery>;
export type GetMatchedProductsLazyQueryHookResult = ReturnType<typeof useGetMatchedProductsLazyQuery>;
export type GetMatchedProductsSuspenseQueryHookResult = ReturnType<typeof useGetMatchedProductsSuspenseQuery>;
export type GetMatchedProductsQueryResult = Apollo.QueryResult<Generated.GetMatchedProductsQuery, Generated.GetMatchedProductsQueryVariables>;
export const GetProductSourcesDocument = /*#__PURE__*/ gql`
    query getProductSources($countryId: ID!) {
  productSources(countryId: $countryId) {
    ...ProductSourceStats
  }
}
    ${ProductSourceStatsFragmentDoc}`;

/**
 * __useGetProductSourcesQuery__
 *
 * To run a query within a React component, call `useGetProductSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSourcesQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetProductSourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetProductSourcesQuery, Generated.GetProductSourcesQueryVariables> & ({ variables: Generated.GetProductSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetProductSourcesQuery, Generated.GetProductSourcesQueryVariables>(GetProductSourcesDocument, options);
      }
export function useGetProductSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetProductSourcesQuery, Generated.GetProductSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetProductSourcesQuery, Generated.GetProductSourcesQueryVariables>(GetProductSourcesDocument, options);
        }
export function useGetProductSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetProductSourcesQuery, Generated.GetProductSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetProductSourcesQuery, Generated.GetProductSourcesQueryVariables>(GetProductSourcesDocument, options);
        }
export type GetProductSourcesQueryHookResult = ReturnType<typeof useGetProductSourcesQuery>;
export type GetProductSourcesLazyQueryHookResult = ReturnType<typeof useGetProductSourcesLazyQuery>;
export type GetProductSourcesSuspenseQueryHookResult = ReturnType<typeof useGetProductSourcesSuspenseQuery>;
export type GetProductSourcesQueryResult = Apollo.QueryResult<Generated.GetProductSourcesQuery, Generated.GetProductSourcesQueryVariables>;
export const GetProductSourceChannelsDocument = /*#__PURE__*/ gql`
    query getProductSourceChannels($countryId: ID!, $sourceId: ID!) {
  productSourceChannels(countryId: $countryId, sourceId: $sourceId) {
    ...ProductSourceChannelOption
  }
}
    ${ProductSourceChannelOptionFragmentDoc}`;

/**
 * __useGetProductSourceChannelsQuery__
 *
 * To run a query within a React component, call `useGetProductSourceChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSourceChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSourceChannelsQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetProductSourceChannelsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetProductSourceChannelsQuery, Generated.GetProductSourceChannelsQueryVariables> & ({ variables: Generated.GetProductSourceChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetProductSourceChannelsQuery, Generated.GetProductSourceChannelsQueryVariables>(GetProductSourceChannelsDocument, options);
      }
export function useGetProductSourceChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetProductSourceChannelsQuery, Generated.GetProductSourceChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetProductSourceChannelsQuery, Generated.GetProductSourceChannelsQueryVariables>(GetProductSourceChannelsDocument, options);
        }
export function useGetProductSourceChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetProductSourceChannelsQuery, Generated.GetProductSourceChannelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetProductSourceChannelsQuery, Generated.GetProductSourceChannelsQueryVariables>(GetProductSourceChannelsDocument, options);
        }
export type GetProductSourceChannelsQueryHookResult = ReturnType<typeof useGetProductSourceChannelsQuery>;
export type GetProductSourceChannelsLazyQueryHookResult = ReturnType<typeof useGetProductSourceChannelsLazyQuery>;
export type GetProductSourceChannelsSuspenseQueryHookResult = ReturnType<typeof useGetProductSourceChannelsSuspenseQuery>;
export type GetProductSourceChannelsQueryResult = Apollo.QueryResult<Generated.GetProductSourceChannelsQuery, Generated.GetProductSourceChannelsQueryVariables>;
export const IgnoreProductDocument = /*#__PURE__*/ gql`
    mutation ignoreProduct($input: IgnoreProductInput!) {
  ignoreProduct(input: $input) {
    id
  }
}
    `;
export type IgnoreProductMutationFn = Apollo.MutationFunction<Generated.IgnoreProductMutation, Generated.IgnoreProductMutationVariables>;

/**
 * __useIgnoreProductMutation__
 *
 * To run a mutation, you first call `useIgnoreProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreProductMutation, { data, loading, error }] = useIgnoreProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIgnoreProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.IgnoreProductMutation, Generated.IgnoreProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.IgnoreProductMutation, Generated.IgnoreProductMutationVariables>(IgnoreProductDocument, options);
      }
export type IgnoreProductMutationHookResult = ReturnType<typeof useIgnoreProductMutation>;
export type IgnoreProductMutationResult = Apollo.MutationResult<Generated.IgnoreProductMutation>;
export type IgnoreProductMutationOptions = Apollo.BaseMutationOptions<Generated.IgnoreProductMutation, Generated.IgnoreProductMutationVariables>;
export const GetUnknownProductsDocument = /*#__PURE__*/ gql`
    query getUnknownProducts($limit: Int, $offset: Int!, $source: String!, $countryId: ID!, $search: String, $entityType: String, $sourceChannelNames: [String!]) {
  unknownProducts(
    limit: $limit
    offset: $offset
    source: $source
    countryId: $countryId
    search: $search
    entityType: $entityType
    sourceChannelNames: $sourceChannelNames
  ) {
    totalCount
    nodes {
      ...UnknownProduct
    }
  }
}
    ${UnknownProductFragmentDoc}`;

/**
 * __useGetUnknownProductsQuery__
 *
 * To run a query within a React component, call `useGetUnknownProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnknownProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnknownProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      source: // value for 'source'
 *      countryId: // value for 'countryId'
 *      search: // value for 'search'
 *      entityType: // value for 'entityType'
 *      sourceChannelNames: // value for 'sourceChannelNames'
 *   },
 * });
 */
export function useGetUnknownProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetUnknownProductsQuery, Generated.GetUnknownProductsQueryVariables> & ({ variables: Generated.GetUnknownProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetUnknownProductsQuery, Generated.GetUnknownProductsQueryVariables>(GetUnknownProductsDocument, options);
      }
export function useGetUnknownProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetUnknownProductsQuery, Generated.GetUnknownProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetUnknownProductsQuery, Generated.GetUnknownProductsQueryVariables>(GetUnknownProductsDocument, options);
        }
export function useGetUnknownProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetUnknownProductsQuery, Generated.GetUnknownProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetUnknownProductsQuery, Generated.GetUnknownProductsQueryVariables>(GetUnknownProductsDocument, options);
        }
export type GetUnknownProductsQueryHookResult = ReturnType<typeof useGetUnknownProductsQuery>;
export type GetUnknownProductsLazyQueryHookResult = ReturnType<typeof useGetUnknownProductsLazyQuery>;
export type GetUnknownProductsSuspenseQueryHookResult = ReturnType<typeof useGetUnknownProductsSuspenseQuery>;
export type GetUnknownProductsQueryResult = Apollo.QueryResult<Generated.GetUnknownProductsQuery, Generated.GetUnknownProductsQueryVariables>;
export const LinkProductsDocument = /*#__PURE__*/ gql`
    mutation linkProducts($input: LinkProductsInput!) {
  linkProducts(input: $input) {
    unknownProducts {
      id
    }
  }
}
    `;
export type LinkProductsMutationFn = Apollo.MutationFunction<Generated.LinkProductsMutation, Generated.LinkProductsMutationVariables>;

/**
 * __useLinkProductsMutation__
 *
 * To run a mutation, you first call `useLinkProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkProductsMutation, { data, loading, error }] = useLinkProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkProductsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkProductsMutation, Generated.LinkProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkProductsMutation, Generated.LinkProductsMutationVariables>(LinkProductsDocument, options);
      }
export type LinkProductsMutationHookResult = ReturnType<typeof useLinkProductsMutation>;
export type LinkProductsMutationResult = Apollo.MutationResult<Generated.LinkProductsMutation>;
export type LinkProductsMutationOptions = Apollo.BaseMutationOptions<Generated.LinkProductsMutation, Generated.LinkProductsMutationVariables>;
export const MatchingMovieListDocument = /*#__PURE__*/ gql`
    query MatchingMovieList($limit: Int, $offset: Int!, $search: String) {
  movies(
    limit: $limit
    offset: $offset
    search: $search
    orderBy: {field: SCORE, direction: DESC}
  ) {
    totalCount
    nodes {
      ...MatchingMovie
    }
  }
}
    ${MatchingMovieFragmentDoc}`;

/**
 * __useMatchingMovieListQuery__
 *
 * To run a query within a React component, call `useMatchingMovieListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchingMovieListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchingMovieListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMatchingMovieListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.MatchingMovieListQuery, Generated.MatchingMovieListQueryVariables> & ({ variables: Generated.MatchingMovieListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.MatchingMovieListQuery, Generated.MatchingMovieListQueryVariables>(MatchingMovieListDocument, options);
      }
export function useMatchingMovieListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.MatchingMovieListQuery, Generated.MatchingMovieListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.MatchingMovieListQuery, Generated.MatchingMovieListQueryVariables>(MatchingMovieListDocument, options);
        }
export function useMatchingMovieListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.MatchingMovieListQuery, Generated.MatchingMovieListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.MatchingMovieListQuery, Generated.MatchingMovieListQueryVariables>(MatchingMovieListDocument, options);
        }
export type MatchingMovieListQueryHookResult = ReturnType<typeof useMatchingMovieListQuery>;
export type MatchingMovieListLazyQueryHookResult = ReturnType<typeof useMatchingMovieListLazyQuery>;
export type MatchingMovieListSuspenseQueryHookResult = ReturnType<typeof useMatchingMovieListSuspenseQuery>;
export type MatchingMovieListQueryResult = Apollo.QueryResult<Generated.MatchingMovieListQuery, Generated.MatchingMovieListQueryVariables>;
export const MatchingSeriesListDocument = /*#__PURE__*/ gql`
    query MatchingSeriesList($limit: Int, $offset: Int!, $search: String) {
  seriesList(
    limit: $limit
    offset: $offset
    search: $search
    orderBy: {field: SCORE, direction: DESC}
  ) {
    totalCount
    nodes {
      ...MatchingSeries
    }
  }
}
    ${MatchingSeriesFragmentDoc}`;

/**
 * __useMatchingSeriesListQuery__
 *
 * To run a query within a React component, call `useMatchingSeriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchingSeriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchingSeriesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMatchingSeriesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.MatchingSeriesListQuery, Generated.MatchingSeriesListQueryVariables> & ({ variables: Generated.MatchingSeriesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.MatchingSeriesListQuery, Generated.MatchingSeriesListQueryVariables>(MatchingSeriesListDocument, options);
      }
export function useMatchingSeriesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.MatchingSeriesListQuery, Generated.MatchingSeriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.MatchingSeriesListQuery, Generated.MatchingSeriesListQueryVariables>(MatchingSeriesListDocument, options);
        }
export function useMatchingSeriesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.MatchingSeriesListQuery, Generated.MatchingSeriesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.MatchingSeriesListQuery, Generated.MatchingSeriesListQueryVariables>(MatchingSeriesListDocument, options);
        }
export type MatchingSeriesListQueryHookResult = ReturnType<typeof useMatchingSeriesListQuery>;
export type MatchingSeriesListLazyQueryHookResult = ReturnType<typeof useMatchingSeriesListLazyQuery>;
export type MatchingSeriesListSuspenseQueryHookResult = ReturnType<typeof useMatchingSeriesListSuspenseQuery>;
export type MatchingSeriesListQueryResult = Apollo.QueryResult<Generated.MatchingSeriesListQuery, Generated.MatchingSeriesListQueryVariables>;
export const SearchSeasonEpisodesDocument = /*#__PURE__*/ gql`
    query searchSeasonEpisodes($id: ID!, $search: String) {
  seriesSeason(id: $id) {
    episodes(limit: 26, search: $search) {
      totalCount
      nodes {
        id
        number
      }
    }
  }
}
    `;

/**
 * __useSearchSeasonEpisodesQuery__
 *
 * To run a query within a React component, call `useSearchSeasonEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSeasonEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSeasonEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchSeasonEpisodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.SearchSeasonEpisodesQuery, Generated.SearchSeasonEpisodesQueryVariables> & ({ variables: Generated.SearchSeasonEpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.SearchSeasonEpisodesQuery, Generated.SearchSeasonEpisodesQueryVariables>(SearchSeasonEpisodesDocument, options);
      }
export function useSearchSeasonEpisodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.SearchSeasonEpisodesQuery, Generated.SearchSeasonEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.SearchSeasonEpisodesQuery, Generated.SearchSeasonEpisodesQueryVariables>(SearchSeasonEpisodesDocument, options);
        }
export function useSearchSeasonEpisodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.SearchSeasonEpisodesQuery, Generated.SearchSeasonEpisodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.SearchSeasonEpisodesQuery, Generated.SearchSeasonEpisodesQueryVariables>(SearchSeasonEpisodesDocument, options);
        }
export type SearchSeasonEpisodesQueryHookResult = ReturnType<typeof useSearchSeasonEpisodesQuery>;
export type SearchSeasonEpisodesLazyQueryHookResult = ReturnType<typeof useSearchSeasonEpisodesLazyQuery>;
export type SearchSeasonEpisodesSuspenseQueryHookResult = ReturnType<typeof useSearchSeasonEpisodesSuspenseQuery>;
export type SearchSeasonEpisodesQueryResult = Apollo.QueryResult<Generated.SearchSeasonEpisodesQuery, Generated.SearchSeasonEpisodesQueryVariables>;
export const MatchingToolSeriesSeasonsDocument = /*#__PURE__*/ gql`
    query matchingToolSeriesSeasons($id: ID!, $search: String) {
  series(id: $id) {
    seasons(limit: 60, search: $search) {
      totalCount
      nodes {
        id
        number
      }
    }
  }
}
    `;

/**
 * __useMatchingToolSeriesSeasonsQuery__
 *
 * To run a query within a React component, call `useMatchingToolSeriesSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchingToolSeriesSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchingToolSeriesSeasonsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMatchingToolSeriesSeasonsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.MatchingToolSeriesSeasonsQuery, Generated.MatchingToolSeriesSeasonsQueryVariables> & ({ variables: Generated.MatchingToolSeriesSeasonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.MatchingToolSeriesSeasonsQuery, Generated.MatchingToolSeriesSeasonsQueryVariables>(MatchingToolSeriesSeasonsDocument, options);
      }
export function useMatchingToolSeriesSeasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.MatchingToolSeriesSeasonsQuery, Generated.MatchingToolSeriesSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.MatchingToolSeriesSeasonsQuery, Generated.MatchingToolSeriesSeasonsQueryVariables>(MatchingToolSeriesSeasonsDocument, options);
        }
export function useMatchingToolSeriesSeasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.MatchingToolSeriesSeasonsQuery, Generated.MatchingToolSeriesSeasonsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.MatchingToolSeriesSeasonsQuery, Generated.MatchingToolSeriesSeasonsQueryVariables>(MatchingToolSeriesSeasonsDocument, options);
        }
export type MatchingToolSeriesSeasonsQueryHookResult = ReturnType<typeof useMatchingToolSeriesSeasonsQuery>;
export type MatchingToolSeriesSeasonsLazyQueryHookResult = ReturnType<typeof useMatchingToolSeriesSeasonsLazyQuery>;
export type MatchingToolSeriesSeasonsSuspenseQueryHookResult = ReturnType<typeof useMatchingToolSeriesSeasonsSuspenseQuery>;
export type MatchingToolSeriesSeasonsQueryResult = Apollo.QueryResult<Generated.MatchingToolSeriesSeasonsQuery, Generated.MatchingToolSeriesSeasonsQueryVariables>;
export const UnlinkEntityFromProductDocument = /*#__PURE__*/ gql`
    mutation unlinkEntityFromProduct($input: UnlinkEntityFromProductInput!) {
  unlinkEntityFromProduct(input: $input) {
    id
  }
}
    `;
export type UnlinkEntityFromProductMutationFn = Apollo.MutationFunction<Generated.UnlinkEntityFromProductMutation, Generated.UnlinkEntityFromProductMutationVariables>;

/**
 * __useUnlinkEntityFromProductMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityFromProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityFromProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityFromProductMutation, { data, loading, error }] = useUnlinkEntityFromProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkEntityFromProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkEntityFromProductMutation, Generated.UnlinkEntityFromProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkEntityFromProductMutation, Generated.UnlinkEntityFromProductMutationVariables>(UnlinkEntityFromProductDocument, options);
      }
export type UnlinkEntityFromProductMutationHookResult = ReturnType<typeof useUnlinkEntityFromProductMutation>;
export type UnlinkEntityFromProductMutationResult = Apollo.MutationResult<Generated.UnlinkEntityFromProductMutation>;
export type UnlinkEntityFromProductMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkEntityFromProductMutation, Generated.UnlinkEntityFromProductMutationVariables>;
export const DeleteMatchedShowtimeEntityDocument = /*#__PURE__*/ gql`
    mutation DeleteMatchedShowtimeEntity($input: DeleteMatchedShowtimeEntityInput!) {
  deleteMatchedShowtimeEntity(input: $input)
}
    `;
export type DeleteMatchedShowtimeEntityMutationFn = Apollo.MutationFunction<Generated.DeleteMatchedShowtimeEntityMutation, Generated.DeleteMatchedShowtimeEntityMutationVariables>;

/**
 * __useDeleteMatchedShowtimeEntityMutation__
 *
 * To run a mutation, you first call `useDeleteMatchedShowtimeEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchedShowtimeEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchedShowtimeEntityMutation, { data, loading, error }] = useDeleteMatchedShowtimeEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMatchedShowtimeEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteMatchedShowtimeEntityMutation, Generated.DeleteMatchedShowtimeEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteMatchedShowtimeEntityMutation, Generated.DeleteMatchedShowtimeEntityMutationVariables>(DeleteMatchedShowtimeEntityDocument, options);
      }
export type DeleteMatchedShowtimeEntityMutationHookResult = ReturnType<typeof useDeleteMatchedShowtimeEntityMutation>;
export type DeleteMatchedShowtimeEntityMutationResult = Apollo.MutationResult<Generated.DeleteMatchedShowtimeEntityMutation>;
export type DeleteMatchedShowtimeEntityMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteMatchedShowtimeEntityMutation, Generated.DeleteMatchedShowtimeEntityMutationVariables>;
export const DeleteIgnoredShowtimeSourceDocument = /*#__PURE__*/ gql`
    mutation DeleteIgnoredShowtimeSource($input: DeleteIgnoredShowtimeSourceInput!) {
  deleteIgnoredShowtimeSource(input: $input) {
    __typename
  }
}
    `;
export type DeleteIgnoredShowtimeSourceMutationFn = Apollo.MutationFunction<Generated.DeleteIgnoredShowtimeSourceMutation, Generated.DeleteIgnoredShowtimeSourceMutationVariables>;

/**
 * __useDeleteIgnoredShowtimeSourceMutation__
 *
 * To run a mutation, you first call `useDeleteIgnoredShowtimeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIgnoredShowtimeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIgnoredShowtimeSourceMutation, { data, loading, error }] = useDeleteIgnoredShowtimeSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIgnoredShowtimeSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteIgnoredShowtimeSourceMutation, Generated.DeleteIgnoredShowtimeSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteIgnoredShowtimeSourceMutation, Generated.DeleteIgnoredShowtimeSourceMutationVariables>(DeleteIgnoredShowtimeSourceDocument, options);
      }
export type DeleteIgnoredShowtimeSourceMutationHookResult = ReturnType<typeof useDeleteIgnoredShowtimeSourceMutation>;
export type DeleteIgnoredShowtimeSourceMutationResult = Apollo.MutationResult<Generated.DeleteIgnoredShowtimeSourceMutation>;
export type DeleteIgnoredShowtimeSourceMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteIgnoredShowtimeSourceMutation, Generated.DeleteIgnoredShowtimeSourceMutationVariables>;
export const DeleteMatchedShowtimeTheaterDocument = /*#__PURE__*/ gql`
    mutation DeleteMatchedShowtimeTheater($input: DeleteMatchedShowtimeTheaterInput!) {
  deleteMatchedShowtimeTheater(input: $input)
}
    `;
export type DeleteMatchedShowtimeTheaterMutationFn = Apollo.MutationFunction<Generated.DeleteMatchedShowtimeTheaterMutation, Generated.DeleteMatchedShowtimeTheaterMutationVariables>;

/**
 * __useDeleteMatchedShowtimeTheaterMutation__
 *
 * To run a mutation, you first call `useDeleteMatchedShowtimeTheaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchedShowtimeTheaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchedShowtimeTheaterMutation, { data, loading, error }] = useDeleteMatchedShowtimeTheaterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMatchedShowtimeTheaterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteMatchedShowtimeTheaterMutation, Generated.DeleteMatchedShowtimeTheaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteMatchedShowtimeTheaterMutation, Generated.DeleteMatchedShowtimeTheaterMutationVariables>(DeleteMatchedShowtimeTheaterDocument, options);
      }
export type DeleteMatchedShowtimeTheaterMutationHookResult = ReturnType<typeof useDeleteMatchedShowtimeTheaterMutation>;
export type DeleteMatchedShowtimeTheaterMutationResult = Apollo.MutationResult<Generated.DeleteMatchedShowtimeTheaterMutation>;
export type DeleteMatchedShowtimeTheaterMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteMatchedShowtimeTheaterMutation, Generated.DeleteMatchedShowtimeTheaterMutationVariables>;
export const IgnoreIncompleteShowtimeSourceDocument = /*#__PURE__*/ gql`
    mutation IgnoreIncompleteShowtimeSource($input: IgnoreIncompleteShowtimeSourceInput!) {
  ignoreIncompleteShowtimeSource(input: $input)
}
    `;
export type IgnoreIncompleteShowtimeSourceMutationFn = Apollo.MutationFunction<Generated.IgnoreIncompleteShowtimeSourceMutation, Generated.IgnoreIncompleteShowtimeSourceMutationVariables>;

/**
 * __useIgnoreIncompleteShowtimeSourceMutation__
 *
 * To run a mutation, you first call `useIgnoreIncompleteShowtimeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreIncompleteShowtimeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreIncompleteShowtimeSourceMutation, { data, loading, error }] = useIgnoreIncompleteShowtimeSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIgnoreIncompleteShowtimeSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.IgnoreIncompleteShowtimeSourceMutation, Generated.IgnoreIncompleteShowtimeSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.IgnoreIncompleteShowtimeSourceMutation, Generated.IgnoreIncompleteShowtimeSourceMutationVariables>(IgnoreIncompleteShowtimeSourceDocument, options);
      }
export type IgnoreIncompleteShowtimeSourceMutationHookResult = ReturnType<typeof useIgnoreIncompleteShowtimeSourceMutation>;
export type IgnoreIncompleteShowtimeSourceMutationResult = Apollo.MutationResult<Generated.IgnoreIncompleteShowtimeSourceMutation>;
export type IgnoreIncompleteShowtimeSourceMutationOptions = Apollo.BaseMutationOptions<Generated.IgnoreIncompleteShowtimeSourceMutation, Generated.IgnoreIncompleteShowtimeSourceMutationVariables>;
export const IgnoredShowtimeSourcesDocument = /*#__PURE__*/ gql`
    query IgnoredShowtimeSources($limit: Int!, $offset: Int!, $sourceType: ShowtimeSourceType, $sourceName: String, $sourceId: String, $title: String) {
  ignoredShowtimeSources(
    limit: $limit
    offset: $offset
    sourceType: $sourceType
    sourceName: $sourceName
    sourceId: $sourceId
    title: $title
  ) {
    totalCount
    nodes {
      ...IgnoredShowtimeSourceRow
    }
  }
}
    ${IgnoredShowtimeSourceRowFragmentDoc}`;

/**
 * __useIgnoredShowtimeSourcesQuery__
 *
 * To run a query within a React component, call `useIgnoredShowtimeSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIgnoredShowtimeSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIgnoredShowtimeSourcesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sourceType: // value for 'sourceType'
 *      sourceName: // value for 'sourceName'
 *      sourceId: // value for 'sourceId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useIgnoredShowtimeSourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.IgnoredShowtimeSourcesQuery, Generated.IgnoredShowtimeSourcesQueryVariables> & ({ variables: Generated.IgnoredShowtimeSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.IgnoredShowtimeSourcesQuery, Generated.IgnoredShowtimeSourcesQueryVariables>(IgnoredShowtimeSourcesDocument, options);
      }
export function useIgnoredShowtimeSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.IgnoredShowtimeSourcesQuery, Generated.IgnoredShowtimeSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.IgnoredShowtimeSourcesQuery, Generated.IgnoredShowtimeSourcesQueryVariables>(IgnoredShowtimeSourcesDocument, options);
        }
export function useIgnoredShowtimeSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.IgnoredShowtimeSourcesQuery, Generated.IgnoredShowtimeSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.IgnoredShowtimeSourcesQuery, Generated.IgnoredShowtimeSourcesQueryVariables>(IgnoredShowtimeSourcesDocument, options);
        }
export type IgnoredShowtimeSourcesQueryHookResult = ReturnType<typeof useIgnoredShowtimeSourcesQuery>;
export type IgnoredShowtimeSourcesLazyQueryHookResult = ReturnType<typeof useIgnoredShowtimeSourcesLazyQuery>;
export type IgnoredShowtimeSourcesSuspenseQueryHookResult = ReturnType<typeof useIgnoredShowtimeSourcesSuspenseQuery>;
export type IgnoredShowtimeSourcesQueryResult = Apollo.QueryResult<Generated.IgnoredShowtimeSourcesQuery, Generated.IgnoredShowtimeSourcesQueryVariables>;
export const IncompleteShowtimeSourcesDocument = /*#__PURE__*/ gql`
    query IncompleteShowtimeSources($limit: Int!, $offset: Int!, $sourceType: ShowtimeSourceType!, $sourceName: String, $sourceId: String, $title: String, $status: IncompleteMavenStatus, $showId: String) {
  incompleteShowtimeSources(
    limit: $limit
    offset: $offset
    sourceType: $sourceType
    sourceName: $sourceName
    sourceId: $sourceId
    title: $title
    status: $status
    showId: $showId
  ) {
    totalCount
    nodes {
      ...IncompleteShowtimeSourceRow
    }
  }
}
    ${IncompleteShowtimeSourceRowFragmentDoc}`;

/**
 * __useIncompleteShowtimeSourcesQuery__
 *
 * To run a query within a React component, call `useIncompleteShowtimeSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncompleteShowtimeSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncompleteShowtimeSourcesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sourceType: // value for 'sourceType'
 *      sourceName: // value for 'sourceName'
 *      sourceId: // value for 'sourceId'
 *      title: // value for 'title'
 *      status: // value for 'status'
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useIncompleteShowtimeSourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.IncompleteShowtimeSourcesQuery, Generated.IncompleteShowtimeSourcesQueryVariables> & ({ variables: Generated.IncompleteShowtimeSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.IncompleteShowtimeSourcesQuery, Generated.IncompleteShowtimeSourcesQueryVariables>(IncompleteShowtimeSourcesDocument, options);
      }
export function useIncompleteShowtimeSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.IncompleteShowtimeSourcesQuery, Generated.IncompleteShowtimeSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.IncompleteShowtimeSourcesQuery, Generated.IncompleteShowtimeSourcesQueryVariables>(IncompleteShowtimeSourcesDocument, options);
        }
export function useIncompleteShowtimeSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.IncompleteShowtimeSourcesQuery, Generated.IncompleteShowtimeSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.IncompleteShowtimeSourcesQuery, Generated.IncompleteShowtimeSourcesQueryVariables>(IncompleteShowtimeSourcesDocument, options);
        }
export type IncompleteShowtimeSourcesQueryHookResult = ReturnType<typeof useIncompleteShowtimeSourcesQuery>;
export type IncompleteShowtimeSourcesLazyQueryHookResult = ReturnType<typeof useIncompleteShowtimeSourcesLazyQuery>;
export type IncompleteShowtimeSourcesSuspenseQueryHookResult = ReturnType<typeof useIncompleteShowtimeSourcesSuspenseQuery>;
export type IncompleteShowtimeSourcesQueryResult = Apollo.QueryResult<Generated.IncompleteShowtimeSourcesQuery, Generated.IncompleteShowtimeSourcesQueryVariables>;
export const MarkIncompleteEntityInProgressByMavensDocument = /*#__PURE__*/ gql`
    mutation MarkIncompleteEntityInProgressByMavens($input: MarkIncompleteEntityInProgressByMavensInput!) {
  markIncompleteEntityInProgressByMavens(input: $input)
}
    `;
export type MarkIncompleteEntityInProgressByMavensMutationFn = Apollo.MutationFunction<Generated.MarkIncompleteEntityInProgressByMavensMutation, Generated.MarkIncompleteEntityInProgressByMavensMutationVariables>;

/**
 * __useMarkIncompleteEntityInProgressByMavensMutation__
 *
 * To run a mutation, you first call `useMarkIncompleteEntityInProgressByMavensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkIncompleteEntityInProgressByMavensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markIncompleteEntityInProgressByMavensMutation, { data, loading, error }] = useMarkIncompleteEntityInProgressByMavensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkIncompleteEntityInProgressByMavensMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MarkIncompleteEntityInProgressByMavensMutation, Generated.MarkIncompleteEntityInProgressByMavensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MarkIncompleteEntityInProgressByMavensMutation, Generated.MarkIncompleteEntityInProgressByMavensMutationVariables>(MarkIncompleteEntityInProgressByMavensDocument, options);
      }
export type MarkIncompleteEntityInProgressByMavensMutationHookResult = ReturnType<typeof useMarkIncompleteEntityInProgressByMavensMutation>;
export type MarkIncompleteEntityInProgressByMavensMutationResult = Apollo.MutationResult<Generated.MarkIncompleteEntityInProgressByMavensMutation>;
export type MarkIncompleteEntityInProgressByMavensMutationOptions = Apollo.BaseMutationOptions<Generated.MarkIncompleteEntityInProgressByMavensMutation, Generated.MarkIncompleteEntityInProgressByMavensMutationVariables>;
export const MatchShowtimeEntityDocument = /*#__PURE__*/ gql`
    mutation MatchShowtimeEntity($input: MatchShowtimeEntityInput!) {
  matchShowtimeEntity(input: $input)
}
    `;
export type MatchShowtimeEntityMutationFn = Apollo.MutationFunction<Generated.MatchShowtimeEntityMutation, Generated.MatchShowtimeEntityMutationVariables>;

/**
 * __useMatchShowtimeEntityMutation__
 *
 * To run a mutation, you first call `useMatchShowtimeEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchShowtimeEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchShowtimeEntityMutation, { data, loading, error }] = useMatchShowtimeEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchShowtimeEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MatchShowtimeEntityMutation, Generated.MatchShowtimeEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MatchShowtimeEntityMutation, Generated.MatchShowtimeEntityMutationVariables>(MatchShowtimeEntityDocument, options);
      }
export type MatchShowtimeEntityMutationHookResult = ReturnType<typeof useMatchShowtimeEntityMutation>;
export type MatchShowtimeEntityMutationResult = Apollo.MutationResult<Generated.MatchShowtimeEntityMutation>;
export type MatchShowtimeEntityMutationOptions = Apollo.BaseMutationOptions<Generated.MatchShowtimeEntityMutation, Generated.MatchShowtimeEntityMutationVariables>;
export const MatchedShowtimeSourcesDocument = /*#__PURE__*/ gql`
    query MatchedShowtimeSources($limit: Int!, $offset: Int!, $sourceName: String, $sourceId: String, $entityId: ID, $theaterId: ID, $fetchEntities: Boolean!, $fetchTheaters: Boolean!) {
  matchedShowtimeEntities(
    limit: $limit
    offset: $offset
    sourceName: $sourceName
    sourceId: $sourceId
    entityId: $entityId
  ) @include(if: $fetchEntities) {
    totalCount
    nodes {
      ...MatchedShowtimeEntityRow
    }
  }
  matchedShowtimeTheaters(
    limit: $limit
    offset: $offset
    sourceName: $sourceName
    sourceId: $sourceId
    theaterId: $theaterId
  ) @include(if: $fetchTheaters) {
    totalCount
    nodes {
      ...MatchedShowtimeTheaterRow
    }
  }
}
    ${MatchedShowtimeEntityRowFragmentDoc}
${MatchedShowtimeTheaterRowFragmentDoc}`;

/**
 * __useMatchedShowtimeSourcesQuery__
 *
 * To run a query within a React component, call `useMatchedShowtimeSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchedShowtimeSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchedShowtimeSourcesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sourceName: // value for 'sourceName'
 *      sourceId: // value for 'sourceId'
 *      entityId: // value for 'entityId'
 *      theaterId: // value for 'theaterId'
 *      fetchEntities: // value for 'fetchEntities'
 *      fetchTheaters: // value for 'fetchTheaters'
 *   },
 * });
 */
export function useMatchedShowtimeSourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.MatchedShowtimeSourcesQuery, Generated.MatchedShowtimeSourcesQueryVariables> & ({ variables: Generated.MatchedShowtimeSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.MatchedShowtimeSourcesQuery, Generated.MatchedShowtimeSourcesQueryVariables>(MatchedShowtimeSourcesDocument, options);
      }
export function useMatchedShowtimeSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.MatchedShowtimeSourcesQuery, Generated.MatchedShowtimeSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.MatchedShowtimeSourcesQuery, Generated.MatchedShowtimeSourcesQueryVariables>(MatchedShowtimeSourcesDocument, options);
        }
export function useMatchedShowtimeSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.MatchedShowtimeSourcesQuery, Generated.MatchedShowtimeSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.MatchedShowtimeSourcesQuery, Generated.MatchedShowtimeSourcesQueryVariables>(MatchedShowtimeSourcesDocument, options);
        }
export type MatchedShowtimeSourcesQueryHookResult = ReturnType<typeof useMatchedShowtimeSourcesQuery>;
export type MatchedShowtimeSourcesLazyQueryHookResult = ReturnType<typeof useMatchedShowtimeSourcesLazyQuery>;
export type MatchedShowtimeSourcesSuspenseQueryHookResult = ReturnType<typeof useMatchedShowtimeSourcesSuspenseQuery>;
export type MatchedShowtimeSourcesQueryResult = Apollo.QueryResult<Generated.MatchedShowtimeSourcesQuery, Generated.MatchedShowtimeSourcesQueryVariables>;
export const MatchShowtimeTheaterDocument = /*#__PURE__*/ gql`
    mutation MatchShowtimeTheater($input: MatchShowtimeTheaterInput!) {
  matchShowtimeTheater(input: $input)
}
    `;
export type MatchShowtimeTheaterMutationFn = Apollo.MutationFunction<Generated.MatchShowtimeTheaterMutation, Generated.MatchShowtimeTheaterMutationVariables>;

/**
 * __useMatchShowtimeTheaterMutation__
 *
 * To run a mutation, you first call `useMatchShowtimeTheaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchShowtimeTheaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchShowtimeTheaterMutation, { data, loading, error }] = useMatchShowtimeTheaterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchShowtimeTheaterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MatchShowtimeTheaterMutation, Generated.MatchShowtimeTheaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MatchShowtimeTheaterMutation, Generated.MatchShowtimeTheaterMutationVariables>(MatchShowtimeTheaterDocument, options);
      }
export type MatchShowtimeTheaterMutationHookResult = ReturnType<typeof useMatchShowtimeTheaterMutation>;
export type MatchShowtimeTheaterMutationResult = Apollo.MutationResult<Generated.MatchShowtimeTheaterMutation>;
export type MatchShowtimeTheaterMutationOptions = Apollo.BaseMutationOptions<Generated.MatchShowtimeTheaterMutation, Generated.MatchShowtimeTheaterMutationVariables>;
export const ShowtimeEntitiesSearchDocument = /*#__PURE__*/ gql`
    query ShowtimeEntitiesSearch($limit: Int!, $offset: Int!, $search: String, $locale: String) {
  entities: movies(
    limit: $limit
    offset: $offset
    search: $search
    orderBy: {field: SCORE, direction: DESC}
  ) {
    totalCount
    nodes {
      __typename
      ...ShowtimeEntityInfos
      ...ShowtimeEntityRow
      ...MovieLocaleData
    }
  }
}
    ${ShowtimeEntityInfosFragmentDoc}
${ShowtimeEntityRowFragmentDoc}
${MovieLocaleDataFragmentDoc}`;

/**
 * __useShowtimeEntitiesSearchQuery__
 *
 * To run a query within a React component, call `useShowtimeEntitiesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowtimeEntitiesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowtimeEntitiesSearchQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useShowtimeEntitiesSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ShowtimeEntitiesSearchQuery, Generated.ShowtimeEntitiesSearchQueryVariables> & ({ variables: Generated.ShowtimeEntitiesSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ShowtimeEntitiesSearchQuery, Generated.ShowtimeEntitiesSearchQueryVariables>(ShowtimeEntitiesSearchDocument, options);
      }
export function useShowtimeEntitiesSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ShowtimeEntitiesSearchQuery, Generated.ShowtimeEntitiesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ShowtimeEntitiesSearchQuery, Generated.ShowtimeEntitiesSearchQueryVariables>(ShowtimeEntitiesSearchDocument, options);
        }
export function useShowtimeEntitiesSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ShowtimeEntitiesSearchQuery, Generated.ShowtimeEntitiesSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ShowtimeEntitiesSearchQuery, Generated.ShowtimeEntitiesSearchQueryVariables>(ShowtimeEntitiesSearchDocument, options);
        }
export type ShowtimeEntitiesSearchQueryHookResult = ReturnType<typeof useShowtimeEntitiesSearchQuery>;
export type ShowtimeEntitiesSearchLazyQueryHookResult = ReturnType<typeof useShowtimeEntitiesSearchLazyQuery>;
export type ShowtimeEntitiesSearchSuspenseQueryHookResult = ReturnType<typeof useShowtimeEntitiesSearchSuspenseQuery>;
export type ShowtimeEntitiesSearchQueryResult = Apollo.QueryResult<Generated.ShowtimeEntitiesSearchQuery, Generated.ShowtimeEntitiesSearchQueryVariables>;
export const ShowtimeEntitySuggestionsDocument = /*#__PURE__*/ gql`
    query ShowtimeEntitySuggestions($entityMatcher: String!, $entityId: String!, $locale: String) {
  showtimeEntitySuggestions(entityMatcher: $entityMatcher, entityId: $entityId) {
    entity {
      __typename
      ...ShowtimeEntityInfos
      ...ShowtimeEntityRow
      ...ShowtimeEntityLocaleData
    }
    score
  }
}
    ${ShowtimeEntityInfosFragmentDoc}
${ShowtimeEntityRowFragmentDoc}
${ShowtimeEntityLocaleDataFragmentDoc}`;

/**
 * __useShowtimeEntitySuggestionsQuery__
 *
 * To run a query within a React component, call `useShowtimeEntitySuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowtimeEntitySuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowtimeEntitySuggestionsQuery({
 *   variables: {
 *      entityMatcher: // value for 'entityMatcher'
 *      entityId: // value for 'entityId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useShowtimeEntitySuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ShowtimeEntitySuggestionsQuery, Generated.ShowtimeEntitySuggestionsQueryVariables> & ({ variables: Generated.ShowtimeEntitySuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ShowtimeEntitySuggestionsQuery, Generated.ShowtimeEntitySuggestionsQueryVariables>(ShowtimeEntitySuggestionsDocument, options);
      }
export function useShowtimeEntitySuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ShowtimeEntitySuggestionsQuery, Generated.ShowtimeEntitySuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ShowtimeEntitySuggestionsQuery, Generated.ShowtimeEntitySuggestionsQueryVariables>(ShowtimeEntitySuggestionsDocument, options);
        }
export function useShowtimeEntitySuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ShowtimeEntitySuggestionsQuery, Generated.ShowtimeEntitySuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ShowtimeEntitySuggestionsQuery, Generated.ShowtimeEntitySuggestionsQueryVariables>(ShowtimeEntitySuggestionsDocument, options);
        }
export type ShowtimeEntitySuggestionsQueryHookResult = ReturnType<typeof useShowtimeEntitySuggestionsQuery>;
export type ShowtimeEntitySuggestionsLazyQueryHookResult = ReturnType<typeof useShowtimeEntitySuggestionsLazyQuery>;
export type ShowtimeEntitySuggestionsSuspenseQueryHookResult = ReturnType<typeof useShowtimeEntitySuggestionsSuspenseQuery>;
export type ShowtimeEntitySuggestionsQueryResult = Apollo.QueryResult<Generated.ShowtimeEntitySuggestionsQuery, Generated.ShowtimeEntitySuggestionsQueryVariables>;
export const ShowtimeTheatersSearchDocument = /*#__PURE__*/ gql`
    query ShowtimeTheatersSearch($limit: Int!, $offset: Int!, $search: String, $countryIds: [ID!], $companyIds: [ID!]) {
  theaters(
    limit: $limit
    offset: $offset
    search: $search
    countryIds: $countryIds
    companyIds: $companyIds
    orderBy: {field: SCORE, direction: DESC}
  ) {
    totalCount
    nodes {
      ...ShowtimeTheatersSearchRow
    }
  }
}
    ${ShowtimeTheatersSearchRowFragmentDoc}`;

/**
 * __useShowtimeTheatersSearchQuery__
 *
 * To run a query within a React component, call `useShowtimeTheatersSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowtimeTheatersSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowtimeTheatersSearchQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      countryIds: // value for 'countryIds'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useShowtimeTheatersSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.ShowtimeTheatersSearchQuery, Generated.ShowtimeTheatersSearchQueryVariables> & ({ variables: Generated.ShowtimeTheatersSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.ShowtimeTheatersSearchQuery, Generated.ShowtimeTheatersSearchQueryVariables>(ShowtimeTheatersSearchDocument, options);
      }
export function useShowtimeTheatersSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.ShowtimeTheatersSearchQuery, Generated.ShowtimeTheatersSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.ShowtimeTheatersSearchQuery, Generated.ShowtimeTheatersSearchQueryVariables>(ShowtimeTheatersSearchDocument, options);
        }
export function useShowtimeTheatersSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.ShowtimeTheatersSearchQuery, Generated.ShowtimeTheatersSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.ShowtimeTheatersSearchQuery, Generated.ShowtimeTheatersSearchQueryVariables>(ShowtimeTheatersSearchDocument, options);
        }
export type ShowtimeTheatersSearchQueryHookResult = ReturnType<typeof useShowtimeTheatersSearchQuery>;
export type ShowtimeTheatersSearchLazyQueryHookResult = ReturnType<typeof useShowtimeTheatersSearchLazyQuery>;
export type ShowtimeTheatersSearchSuspenseQueryHookResult = ReturnType<typeof useShowtimeTheatersSearchSuspenseQuery>;
export type ShowtimeTheatersSearchQueryResult = Apollo.QueryResult<Generated.ShowtimeTheatersSearchQuery, Generated.ShowtimeTheatersSearchQueryVariables>;
export const UnmatchedTheatersDocument = /*#__PURE__*/ gql`
    query UnmatchedTheaters($limit: Int!, $offset: Int!, $sourceName: String, $name: String) {
  unmatchedTheaters(
    limit: $limit
    offset: $offset
    sourceName: $sourceName
    name: $name
  ) {
    totalCount
    nodes {
      ...UnmatchedTheaterRow
    }
  }
}
    ${UnmatchedTheaterRowFragmentDoc}`;

/**
 * __useUnmatchedTheatersQuery__
 *
 * To run a query within a React component, call `useUnmatchedTheatersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnmatchedTheatersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnmatchedTheatersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sourceName: // value for 'sourceName'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUnmatchedTheatersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.UnmatchedTheatersQuery, Generated.UnmatchedTheatersQueryVariables> & ({ variables: Generated.UnmatchedTheatersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.UnmatchedTheatersQuery, Generated.UnmatchedTheatersQueryVariables>(UnmatchedTheatersDocument, options);
      }
export function useUnmatchedTheatersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.UnmatchedTheatersQuery, Generated.UnmatchedTheatersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.UnmatchedTheatersQuery, Generated.UnmatchedTheatersQueryVariables>(UnmatchedTheatersDocument, options);
        }
export function useUnmatchedTheatersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.UnmatchedTheatersQuery, Generated.UnmatchedTheatersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.UnmatchedTheatersQuery, Generated.UnmatchedTheatersQueryVariables>(UnmatchedTheatersDocument, options);
        }
export type UnmatchedTheatersQueryHookResult = ReturnType<typeof useUnmatchedTheatersQuery>;
export type UnmatchedTheatersLazyQueryHookResult = ReturnType<typeof useUnmatchedTheatersLazyQuery>;
export type UnmatchedTheatersSuspenseQueryHookResult = ReturnType<typeof useUnmatchedTheatersSuspenseQuery>;
export type UnmatchedTheatersQueryResult = Apollo.QueryResult<Generated.UnmatchedTheatersQuery, Generated.UnmatchedTheatersQueryVariables>;
export const UnmatchedMoviesDocument = /*#__PURE__*/ gql`
    query UnmatchedMovies($limit: Int!, $offset: Int!, $sourceName: String, $title: String) {
  unmatchedMovies(
    limit: $limit
    offset: $offset
    sourceName: $sourceName
    title: $title
  ) {
    totalCount
    nodes {
      ...UnmatchedMovieRow
    }
  }
}
    ${UnmatchedMovieRowFragmentDoc}`;

/**
 * __useUnmatchedMoviesQuery__
 *
 * To run a query within a React component, call `useUnmatchedMoviesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnmatchedMoviesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnmatchedMoviesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sourceName: // value for 'sourceName'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUnmatchedMoviesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.UnmatchedMoviesQuery, Generated.UnmatchedMoviesQueryVariables> & ({ variables: Generated.UnmatchedMoviesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.UnmatchedMoviesQuery, Generated.UnmatchedMoviesQueryVariables>(UnmatchedMoviesDocument, options);
      }
export function useUnmatchedMoviesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.UnmatchedMoviesQuery, Generated.UnmatchedMoviesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.UnmatchedMoviesQuery, Generated.UnmatchedMoviesQueryVariables>(UnmatchedMoviesDocument, options);
        }
export function useUnmatchedMoviesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.UnmatchedMoviesQuery, Generated.UnmatchedMoviesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.UnmatchedMoviesQuery, Generated.UnmatchedMoviesQueryVariables>(UnmatchedMoviesDocument, options);
        }
export type UnmatchedMoviesQueryHookResult = ReturnType<typeof useUnmatchedMoviesQuery>;
export type UnmatchedMoviesLazyQueryHookResult = ReturnType<typeof useUnmatchedMoviesLazyQuery>;
export type UnmatchedMoviesSuspenseQueryHookResult = ReturnType<typeof useUnmatchedMoviesSuspenseQuery>;
export type UnmatchedMoviesQueryResult = Apollo.QueryResult<Generated.UnmatchedMoviesQuery, Generated.UnmatchedMoviesQueryVariables>;
export const DeleteCustomerDocument = /*#__PURE__*/ gql`
    mutation deleteCustomer($customerId: ID!) {
  deleteCustomer(input: {customerId: $customerId}) {
    id
  }
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<Generated.DeleteCustomerMutation, Generated.DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteCustomerMutation, Generated.DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteCustomerMutation, Generated.DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<Generated.DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteCustomerMutation, Generated.DeleteCustomerMutationVariables>;
export const GetCustomerListDocument = /*#__PURE__*/ gql`
    query getCustomerList($limit: Int, $offset: Int!, $search: String!) {
  customers(limit: $limit, offset: $offset, search: $search) {
    totalCount
    nodes {
      id
      ref
      name
      metadata {
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetCustomerListQuery__
 *
 * To run a query within a React component, call `useGetCustomerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCustomerListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCustomerListQuery, Generated.GetCustomerListQueryVariables> & ({ variables: Generated.GetCustomerListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCustomerListQuery, Generated.GetCustomerListQueryVariables>(GetCustomerListDocument, options);
      }
export function useGetCustomerListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCustomerListQuery, Generated.GetCustomerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCustomerListQuery, Generated.GetCustomerListQueryVariables>(GetCustomerListDocument, options);
        }
export function useGetCustomerListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCustomerListQuery, Generated.GetCustomerListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCustomerListQuery, Generated.GetCustomerListQueryVariables>(GetCustomerListDocument, options);
        }
export type GetCustomerListQueryHookResult = ReturnType<typeof useGetCustomerListQuery>;
export type GetCustomerListLazyQueryHookResult = ReturnType<typeof useGetCustomerListLazyQuery>;
export type GetCustomerListSuspenseQueryHookResult = ReturnType<typeof useGetCustomerListSuspenseQuery>;
export type GetCustomerListQueryResult = Apollo.QueryResult<Generated.GetCustomerListQuery, Generated.GetCustomerListQueryVariables>;
export const CreateCustomerDocument = /*#__PURE__*/ gql`
    mutation createCustomer($active: Boolean!, $name: String!, $graphBackendEndpoint: URL) {
  createCustomer(
    input: {active: $active, name: $name, graphBackendEndpoint: $graphBackendEndpoint}
  ) {
    id
    ref
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<Generated.CreateCustomerMutation, Generated.CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      active: // value for 'active'
 *      name: // value for 'name'
 *      graphBackendEndpoint: // value for 'graphBackendEndpoint'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateCustomerMutation, Generated.CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateCustomerMutation, Generated.CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<Generated.CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<Generated.CreateCustomerMutation, Generated.CreateCustomerMutationVariables>;
export const GetCustomerDocument = /*#__PURE__*/ gql`
    query getCustomer($ref: ID!) {
  customerByRef(ref: $ref) {
    ...CustomerIdentity
    ...CustomerMetadata
  }
}
    ${CustomerIdentityFragmentDoc}
${CustomerMetadataFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetCustomerQuery, Generated.GetCustomerQueryVariables> & ({ variables: Generated.GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetCustomerQuery, Generated.GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetCustomerQuery, Generated.GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetCustomerQuery, Generated.GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetCustomerQuery, Generated.GetCustomerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetCustomerQuery, Generated.GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<Generated.GetCustomerQuery, Generated.GetCustomerQueryVariables>;
export const UpdateCustomerIdentityDocument = /*#__PURE__*/ gql`
    mutation updateCustomerIdentity($id: ID!, $active: Boolean, $name: String, $graphBackendEndpoint: URL, $comment: String) {
  updateCustomer(
    input: {id: $id, active: $active, name: $name, graphBackendEndpoint: $graphBackendEndpoint, comment: $comment}
  ) {
    ...CustomerIdentity
    ...CustomerMetadata
  }
}
    ${CustomerIdentityFragmentDoc}
${CustomerMetadataFragmentDoc}`;
export type UpdateCustomerIdentityMutationFn = Apollo.MutationFunction<Generated.UpdateCustomerIdentityMutation, Generated.UpdateCustomerIdentityMutationVariables>;

/**
 * __useUpdateCustomerIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerIdentityMutation, { data, loading, error }] = useUpdateCustomerIdentityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *      name: // value for 'name'
 *      graphBackendEndpoint: // value for 'graphBackendEndpoint'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCustomerIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateCustomerIdentityMutation, Generated.UpdateCustomerIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateCustomerIdentityMutation, Generated.UpdateCustomerIdentityMutationVariables>(UpdateCustomerIdentityDocument, options);
      }
export type UpdateCustomerIdentityMutationHookResult = ReturnType<typeof useUpdateCustomerIdentityMutation>;
export type UpdateCustomerIdentityMutationResult = Apollo.MutationResult<Generated.UpdateCustomerIdentityMutation>;
export type UpdateCustomerIdentityMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateCustomerIdentityMutation, Generated.UpdateCustomerIdentityMutationVariables>;
export const DeleteQueryDocument = /*#__PURE__*/ gql`
    mutation deleteQuery($customerQueryId: ID!) {
  deleteCustomerQuery(input: {customerQueryId: $customerQueryId}) {
    id
  }
}
    `;
export type DeleteQueryMutationFn = Apollo.MutationFunction<Generated.DeleteQueryMutation, Generated.DeleteQueryMutationVariables>;

/**
 * __useDeleteQueryMutation__
 *
 * To run a mutation, you first call `useDeleteQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQueryMutation, { data, loading, error }] = useDeleteQueryMutation({
 *   variables: {
 *      customerQueryId: // value for 'customerQueryId'
 *   },
 * });
 */
export function useDeleteQueryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteQueryMutation, Generated.DeleteQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteQueryMutation, Generated.DeleteQueryMutationVariables>(DeleteQueryDocument, options);
      }
export type DeleteQueryMutationHookResult = ReturnType<typeof useDeleteQueryMutation>;
export type DeleteQueryMutationResult = Apollo.MutationResult<Generated.DeleteQueryMutation>;
export type DeleteQueryMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteQueryMutation, Generated.DeleteQueryMutationVariables>;
export const CreateQueryDocument = /*#__PURE__*/ gql`
    mutation createQuery($name: String!, $template: String!) {
  createCustomerQuery(input: {name: $name, template: $template}) {
    id
    ref
  }
}
    `;
export type CreateQueryMutationFn = Apollo.MutationFunction<Generated.CreateQueryMutation, Generated.CreateQueryMutationVariables>;

/**
 * __useCreateQueryMutation__
 *
 * To run a mutation, you first call `useCreateQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueryMutation, { data, loading, error }] = useCreateQueryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useCreateQueryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateQueryMutation, Generated.CreateQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateQueryMutation, Generated.CreateQueryMutationVariables>(CreateQueryDocument, options);
      }
export type CreateQueryMutationHookResult = ReturnType<typeof useCreateQueryMutation>;
export type CreateQueryMutationResult = Apollo.MutationResult<Generated.CreateQueryMutation>;
export type CreateQueryMutationOptions = Apollo.BaseMutationOptions<Generated.CreateQueryMutation, Generated.CreateQueryMutationVariables>;
export const GetQueryListDocument = /*#__PURE__*/ gql`
    query getQueryList($limit: Int, $offset: Int!, $search: String!) {
  customerQueries(limit: $limit, offset: $offset, search: $search) {
    totalCount
    nodes {
      id
      name
      ref
      metadata {
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetQueryListQuery__
 *
 * To run a query within a React component, call `useGetQueryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetQueryListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetQueryListQuery, Generated.GetQueryListQueryVariables> & ({ variables: Generated.GetQueryListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetQueryListQuery, Generated.GetQueryListQueryVariables>(GetQueryListDocument, options);
      }
export function useGetQueryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetQueryListQuery, Generated.GetQueryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetQueryListQuery, Generated.GetQueryListQueryVariables>(GetQueryListDocument, options);
        }
export function useGetQueryListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetQueryListQuery, Generated.GetQueryListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetQueryListQuery, Generated.GetQueryListQueryVariables>(GetQueryListDocument, options);
        }
export type GetQueryListQueryHookResult = ReturnType<typeof useGetQueryListQuery>;
export type GetQueryListLazyQueryHookResult = ReturnType<typeof useGetQueryListLazyQuery>;
export type GetQueryListSuspenseQueryHookResult = ReturnType<typeof useGetQueryListSuspenseQuery>;
export type GetQueryListQueryResult = Apollo.QueryResult<Generated.GetQueryListQuery, Generated.GetQueryListQueryVariables>;
export const GetQueryDocument = /*#__PURE__*/ gql`
    query getQuery($ref: ID!) {
  customerQueryByRef(ref: $ref) {
    ...CustomerQuery
    ...CustomerQueryMetadata
  }
}
    ${CustomerQueryFragmentDoc}
${CustomerQueryMetadataFragmentDoc}`;

/**
 * __useGetQueryQuery__
 *
 * To run a query within a React component, call `useGetQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetQueryQuery, Generated.GetQueryQueryVariables> & ({ variables: Generated.GetQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetQueryQuery, Generated.GetQueryQueryVariables>(GetQueryDocument, options);
      }
export function useGetQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetQueryQuery, Generated.GetQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetQueryQuery, Generated.GetQueryQueryVariables>(GetQueryDocument, options);
        }
export function useGetQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetQueryQuery, Generated.GetQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetQueryQuery, Generated.GetQueryQueryVariables>(GetQueryDocument, options);
        }
export type GetQueryQueryHookResult = ReturnType<typeof useGetQueryQuery>;
export type GetQueryLazyQueryHookResult = ReturnType<typeof useGetQueryLazyQuery>;
export type GetQuerySuspenseQueryHookResult = ReturnType<typeof useGetQuerySuspenseQuery>;
export type GetQueryQueryResult = Apollo.QueryResult<Generated.GetQueryQuery, Generated.GetQueryQueryVariables>;
export const UpdateQueryDocument = /*#__PURE__*/ gql`
    mutation updateQuery($id: ID!, $name: String!, $template: String!) {
  updateCustomerQuery(input: {id: $id, name: $name, template: $template}) {
    ...CustomerQuery
    ...CustomerQueryMetadata
  }
}
    ${CustomerQueryFragmentDoc}
${CustomerQueryMetadataFragmentDoc}`;
export type UpdateQueryMutationFn = Apollo.MutationFunction<Generated.UpdateQueryMutation, Generated.UpdateQueryMutationVariables>;

/**
 * __useUpdateQueryMutation__
 *
 * To run a mutation, you first call `useUpdateQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueryMutation, { data, loading, error }] = useUpdateQueryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useUpdateQueryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateQueryMutation, Generated.UpdateQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateQueryMutation, Generated.UpdateQueryMutationVariables>(UpdateQueryDocument, options);
      }
export type UpdateQueryMutationHookResult = ReturnType<typeof useUpdateQueryMutation>;
export type UpdateQueryMutationResult = Apollo.MutationResult<Generated.UpdateQueryMutation>;
export type UpdateQueryMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateQueryMutation, Generated.UpdateQueryMutationVariables>;
export const CreateScopeDocument = /*#__PURE__*/ gql`
    mutation createScope($name: String!, $customerId: ID!) {
  createScope(input: {name: $name, customerId: $customerId}) {
    id
    ref
  }
}
    `;
export type CreateScopeMutationFn = Apollo.MutationFunction<Generated.CreateScopeMutation, Generated.CreateScopeMutationVariables>;

/**
 * __useCreateScopeMutation__
 *
 * To run a mutation, you first call `useCreateScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScopeMutation, { data, loading, error }] = useCreateScopeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCreateScopeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateScopeMutation, Generated.CreateScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateScopeMutation, Generated.CreateScopeMutationVariables>(CreateScopeDocument, options);
      }
export type CreateScopeMutationHookResult = ReturnType<typeof useCreateScopeMutation>;
export type CreateScopeMutationResult = Apollo.MutationResult<Generated.CreateScopeMutation>;
export type CreateScopeMutationOptions = Apollo.BaseMutationOptions<Generated.CreateScopeMutation, Generated.CreateScopeMutationVariables>;
export const GetScopeCustomerQueriesDocument = /*#__PURE__*/ gql`
    query getScopeCustomerQueries($excludeScope: ID!) {
  customerQueries(limit: 10000, excludeScope: $excludeScope) {
    totalCount
    nodes {
      ...CustomerQuery
    }
  }
}
    ${CustomerQueryFragmentDoc}`;

/**
 * __useGetScopeCustomerQueriesQuery__
 *
 * To run a query within a React component, call `useGetScopeCustomerQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopeCustomerQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopeCustomerQueriesQuery({
 *   variables: {
 *      excludeScope: // value for 'excludeScope'
 *   },
 * });
 */
export function useGetScopeCustomerQueriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScopeCustomerQueriesQuery, Generated.GetScopeCustomerQueriesQueryVariables> & ({ variables: Generated.GetScopeCustomerQueriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScopeCustomerQueriesQuery, Generated.GetScopeCustomerQueriesQueryVariables>(GetScopeCustomerQueriesDocument, options);
      }
export function useGetScopeCustomerQueriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScopeCustomerQueriesQuery, Generated.GetScopeCustomerQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScopeCustomerQueriesQuery, Generated.GetScopeCustomerQueriesQueryVariables>(GetScopeCustomerQueriesDocument, options);
        }
export function useGetScopeCustomerQueriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScopeCustomerQueriesQuery, Generated.GetScopeCustomerQueriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScopeCustomerQueriesQuery, Generated.GetScopeCustomerQueriesQueryVariables>(GetScopeCustomerQueriesDocument, options);
        }
export type GetScopeCustomerQueriesQueryHookResult = ReturnType<typeof useGetScopeCustomerQueriesQuery>;
export type GetScopeCustomerQueriesLazyQueryHookResult = ReturnType<typeof useGetScopeCustomerQueriesLazyQuery>;
export type GetScopeCustomerQueriesSuspenseQueryHookResult = ReturnType<typeof useGetScopeCustomerQueriesSuspenseQuery>;
export type GetScopeCustomerQueriesQueryResult = Apollo.QueryResult<Generated.GetScopeCustomerQueriesQuery, Generated.GetScopeCustomerQueriesQueryVariables>;
export const GetScopeCustomersDocument = /*#__PURE__*/ gql`
    query getScopeCustomers {
  customers(limit: 120, offset: 0) {
    totalCount
    nodes {
      id
      name
      active
      metadata {
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetScopeCustomersQuery__
 *
 * To run a query within a React component, call `useGetScopeCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopeCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopeCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScopeCustomersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetScopeCustomersQuery, Generated.GetScopeCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScopeCustomersQuery, Generated.GetScopeCustomersQueryVariables>(GetScopeCustomersDocument, options);
      }
export function useGetScopeCustomersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScopeCustomersQuery, Generated.GetScopeCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScopeCustomersQuery, Generated.GetScopeCustomersQueryVariables>(GetScopeCustomersDocument, options);
        }
export function useGetScopeCustomersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScopeCustomersQuery, Generated.GetScopeCustomersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScopeCustomersQuery, Generated.GetScopeCustomersQueryVariables>(GetScopeCustomersDocument, options);
        }
export type GetScopeCustomersQueryHookResult = ReturnType<typeof useGetScopeCustomersQuery>;
export type GetScopeCustomersLazyQueryHookResult = ReturnType<typeof useGetScopeCustomersLazyQuery>;
export type GetScopeCustomersSuspenseQueryHookResult = ReturnType<typeof useGetScopeCustomersSuspenseQuery>;
export type GetScopeCustomersQueryResult = Apollo.QueryResult<Generated.GetScopeCustomersQuery, Generated.GetScopeCustomersQueryVariables>;
export const GetScopeListDocument = /*#__PURE__*/ gql`
    query getScopeList($limit: Int, $offset: Int!, $search: String!) {
  scopes(limit: $limit, offset: $offset, search: $search) {
    totalCount
    nodes {
      id
      ref
      name
      customer {
        ref
        name
      }
    }
  }
}
    `;

/**
 * __useGetScopeListQuery__
 *
 * To run a query within a React component, call `useGetScopeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopeListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetScopeListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScopeListQuery, Generated.GetScopeListQueryVariables> & ({ variables: Generated.GetScopeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScopeListQuery, Generated.GetScopeListQueryVariables>(GetScopeListDocument, options);
      }
export function useGetScopeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScopeListQuery, Generated.GetScopeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScopeListQuery, Generated.GetScopeListQueryVariables>(GetScopeListDocument, options);
        }
export function useGetScopeListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScopeListQuery, Generated.GetScopeListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScopeListQuery, Generated.GetScopeListQueryVariables>(GetScopeListDocument, options);
        }
export type GetScopeListQueryHookResult = ReturnType<typeof useGetScopeListQuery>;
export type GetScopeListLazyQueryHookResult = ReturnType<typeof useGetScopeListLazyQuery>;
export type GetScopeListSuspenseQueryHookResult = ReturnType<typeof useGetScopeListSuspenseQuery>;
export type GetScopeListQueryResult = Apollo.QueryResult<Generated.GetScopeListQuery, Generated.GetScopeListQueryVariables>;
export const GetScopeQueriesDocument = /*#__PURE__*/ gql`
    query getScopeQueries($ref: ID!, $limit: Int, $offset: Int!) {
  scopeByRef(ref: $ref) {
    ... on Scope {
      id
      ref
      scopeCustomerQueries(limit: $limit, offset: $offset) {
        totalCount
        nodes {
          ...ScopeCustomerQueryIdentity
        }
      }
    }
  }
}
    ${ScopeCustomerQueryIdentityFragmentDoc}`;

/**
 * __useGetScopeQueriesQuery__
 *
 * To run a query within a React component, call `useGetScopeQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopeQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopeQueriesQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetScopeQueriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScopeQueriesQuery, Generated.GetScopeQueriesQueryVariables> & ({ variables: Generated.GetScopeQueriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScopeQueriesQuery, Generated.GetScopeQueriesQueryVariables>(GetScopeQueriesDocument, options);
      }
export function useGetScopeQueriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScopeQueriesQuery, Generated.GetScopeQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScopeQueriesQuery, Generated.GetScopeQueriesQueryVariables>(GetScopeQueriesDocument, options);
        }
export function useGetScopeQueriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScopeQueriesQuery, Generated.GetScopeQueriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScopeQueriesQuery, Generated.GetScopeQueriesQueryVariables>(GetScopeQueriesDocument, options);
        }
export type GetScopeQueriesQueryHookResult = ReturnType<typeof useGetScopeQueriesQuery>;
export type GetScopeQueriesLazyQueryHookResult = ReturnType<typeof useGetScopeQueriesLazyQuery>;
export type GetScopeQueriesSuspenseQueryHookResult = ReturnType<typeof useGetScopeQueriesSuspenseQuery>;
export type GetScopeQueriesQueryResult = Apollo.QueryResult<Generated.GetScopeQueriesQuery, Generated.GetScopeQueriesQueryVariables>;
export const DeleteScopeDocument = /*#__PURE__*/ gql`
    mutation deleteScope($scopeId: ID!) {
  deleteScope(input: {scopeId: $scopeId}) {
    id
  }
}
    `;
export type DeleteScopeMutationFn = Apollo.MutationFunction<Generated.DeleteScopeMutation, Generated.DeleteScopeMutationVariables>;

/**
 * __useDeleteScopeMutation__
 *
 * To run a mutation, you first call `useDeleteScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScopeMutation, { data, loading, error }] = useDeleteScopeMutation({
 *   variables: {
 *      scopeId: // value for 'scopeId'
 *   },
 * });
 */
export function useDeleteScopeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteScopeMutation, Generated.DeleteScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteScopeMutation, Generated.DeleteScopeMutationVariables>(DeleteScopeDocument, options);
      }
export type DeleteScopeMutationHookResult = ReturnType<typeof useDeleteScopeMutation>;
export type DeleteScopeMutationResult = Apollo.MutationResult<Generated.DeleteScopeMutation>;
export type DeleteScopeMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteScopeMutation, Generated.DeleteScopeMutationVariables>;
export const GetScopeQueryDocument = /*#__PURE__*/ gql`
    query getScopeQuery($ref: ID!, $query: ID!) {
  scopeByRef(ref: $ref) {
    id
    scopeCustomerQuery(scopeCustomerQueryId: $query) {
      id
      alias
      config {
        variables
        userVariables
      }
      customerQuery {
        id
      }
    }
  }
}
    `;

/**
 * __useGetScopeQueryQuery__
 *
 * To run a query within a React component, call `useGetScopeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopeQueryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetScopeQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScopeQueryQuery, Generated.GetScopeQueryQueryVariables> & ({ variables: Generated.GetScopeQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScopeQueryQuery, Generated.GetScopeQueryQueryVariables>(GetScopeQueryDocument, options);
      }
export function useGetScopeQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScopeQueryQuery, Generated.GetScopeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScopeQueryQuery, Generated.GetScopeQueryQueryVariables>(GetScopeQueryDocument, options);
        }
export function useGetScopeQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScopeQueryQuery, Generated.GetScopeQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScopeQueryQuery, Generated.GetScopeQueryQueryVariables>(GetScopeQueryDocument, options);
        }
export type GetScopeQueryQueryHookResult = ReturnType<typeof useGetScopeQueryQuery>;
export type GetScopeQueryLazyQueryHookResult = ReturnType<typeof useGetScopeQueryLazyQuery>;
export type GetScopeQuerySuspenseQueryHookResult = ReturnType<typeof useGetScopeQuerySuspenseQuery>;
export type GetScopeQueryQueryResult = Apollo.QueryResult<Generated.GetScopeQueryQuery, Generated.GetScopeQueryQueryVariables>;
export const LinkCustomerQueryToScopeDocument = /*#__PURE__*/ gql`
    mutation linkCustomerQueryToScope($scopeId: ID!, $customerQueryId: ID!, $alias: String!, $config: QueryConfigInput!) {
  linkCustomerQueryToScope(
    input: {scopeId: $scopeId, customerQueryId: $customerQueryId, alias: $alias, config: $config}
  ) {
    id
  }
}
    `;
export type LinkCustomerQueryToScopeMutationFn = Apollo.MutationFunction<Generated.LinkCustomerQueryToScopeMutation, Generated.LinkCustomerQueryToScopeMutationVariables>;

/**
 * __useLinkCustomerQueryToScopeMutation__
 *
 * To run a mutation, you first call `useLinkCustomerQueryToScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCustomerQueryToScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCustomerQueryToScopeMutation, { data, loading, error }] = useLinkCustomerQueryToScopeMutation({
 *   variables: {
 *      scopeId: // value for 'scopeId'
 *      customerQueryId: // value for 'customerQueryId'
 *      alias: // value for 'alias'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useLinkCustomerQueryToScopeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkCustomerQueryToScopeMutation, Generated.LinkCustomerQueryToScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkCustomerQueryToScopeMutation, Generated.LinkCustomerQueryToScopeMutationVariables>(LinkCustomerQueryToScopeDocument, options);
      }
export type LinkCustomerQueryToScopeMutationHookResult = ReturnType<typeof useLinkCustomerQueryToScopeMutation>;
export type LinkCustomerQueryToScopeMutationResult = Apollo.MutationResult<Generated.LinkCustomerQueryToScopeMutation>;
export type LinkCustomerQueryToScopeMutationOptions = Apollo.BaseMutationOptions<Generated.LinkCustomerQueryToScopeMutation, Generated.LinkCustomerQueryToScopeMutationVariables>;
export const GetScopeDocument = /*#__PURE__*/ gql`
    query getScope($ref: ID!) {
  scopeByRef(ref: $ref) {
    ...ScopeIdentity
    ...ScopeMetadata
  }
}
    ${ScopeIdentityFragmentDoc}
${ScopeMetadataFragmentDoc}`;

/**
 * __useGetScopeQuery__
 *
 * To run a query within a React component, call `useGetScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopeQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetScopeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetScopeQuery, Generated.GetScopeQueryVariables> & ({ variables: Generated.GetScopeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetScopeQuery, Generated.GetScopeQueryVariables>(GetScopeDocument, options);
      }
export function useGetScopeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetScopeQuery, Generated.GetScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetScopeQuery, Generated.GetScopeQueryVariables>(GetScopeDocument, options);
        }
export function useGetScopeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetScopeQuery, Generated.GetScopeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetScopeQuery, Generated.GetScopeQueryVariables>(GetScopeDocument, options);
        }
export type GetScopeQueryHookResult = ReturnType<typeof useGetScopeQuery>;
export type GetScopeLazyQueryHookResult = ReturnType<typeof useGetScopeLazyQuery>;
export type GetScopeSuspenseQueryHookResult = ReturnType<typeof useGetScopeSuspenseQuery>;
export type GetScopeQueryResult = Apollo.QueryResult<Generated.GetScopeQuery, Generated.GetScopeQueryVariables>;
export const UnlinkCustomerQueryFromScopeDocument = /*#__PURE__*/ gql`
    mutation unlinkCustomerQueryFromScope($scopeId: ID!, $customerQueryId: ID!) {
  unlinkCustomerQueryFromScope(
    input: {scopeId: $scopeId, customerQueryId: $customerQueryId}
  ) {
    id
  }
}
    `;
export type UnlinkCustomerQueryFromScopeMutationFn = Apollo.MutationFunction<Generated.UnlinkCustomerQueryFromScopeMutation, Generated.UnlinkCustomerQueryFromScopeMutationVariables>;

/**
 * __useUnlinkCustomerQueryFromScopeMutation__
 *
 * To run a mutation, you first call `useUnlinkCustomerQueryFromScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCustomerQueryFromScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCustomerQueryFromScopeMutation, { data, loading, error }] = useUnlinkCustomerQueryFromScopeMutation({
 *   variables: {
 *      scopeId: // value for 'scopeId'
 *      customerQueryId: // value for 'customerQueryId'
 *   },
 * });
 */
export function useUnlinkCustomerQueryFromScopeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkCustomerQueryFromScopeMutation, Generated.UnlinkCustomerQueryFromScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkCustomerQueryFromScopeMutation, Generated.UnlinkCustomerQueryFromScopeMutationVariables>(UnlinkCustomerQueryFromScopeDocument, options);
      }
export type UnlinkCustomerQueryFromScopeMutationHookResult = ReturnType<typeof useUnlinkCustomerQueryFromScopeMutation>;
export type UnlinkCustomerQueryFromScopeMutationResult = Apollo.MutationResult<Generated.UnlinkCustomerQueryFromScopeMutation>;
export type UnlinkCustomerQueryFromScopeMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkCustomerQueryFromScopeMutation, Generated.UnlinkCustomerQueryFromScopeMutationVariables>;
export const UpdateScopeDocument = /*#__PURE__*/ gql`
    mutation updateScope($id: ID!, $name: String!, $customerId: ID!) {
  updateScope(input: {id: $id, name: $name, customerId: $customerId}) {
    ...ScopeIdentity
    ...ScopeMetadata
  }
}
    ${ScopeIdentityFragmentDoc}
${ScopeMetadataFragmentDoc}`;
export type UpdateScopeMutationFn = Apollo.MutationFunction<Generated.UpdateScopeMutation, Generated.UpdateScopeMutationVariables>;

/**
 * __useUpdateScopeMutation__
 *
 * To run a mutation, you first call `useUpdateScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScopeMutation, { data, loading, error }] = useUpdateScopeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useUpdateScopeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateScopeMutation, Generated.UpdateScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateScopeMutation, Generated.UpdateScopeMutationVariables>(UpdateScopeDocument, options);
      }
export type UpdateScopeMutationHookResult = ReturnType<typeof useUpdateScopeMutation>;
export type UpdateScopeMutationResult = Apollo.MutationResult<Generated.UpdateScopeMutation>;
export type UpdateScopeMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateScopeMutation, Generated.UpdateScopeMutationVariables>;
export const CreateEditorialReviewDocument = /*#__PURE__*/ gql`
    mutation createEditorialReview($input: CreateEditorialReviewInput!) {
  createEditorialReview(input: $input) {
    id
  }
}
    `;
export type CreateEditorialReviewMutationFn = Apollo.MutationFunction<Generated.CreateEditorialReviewMutation, Generated.CreateEditorialReviewMutationVariables>;

/**
 * __useCreateEditorialReviewMutation__
 *
 * To run a mutation, you first call `useCreateEditorialReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEditorialReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEditorialReviewMutation, { data, loading, error }] = useCreateEditorialReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEditorialReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateEditorialReviewMutation, Generated.CreateEditorialReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateEditorialReviewMutation, Generated.CreateEditorialReviewMutationVariables>(CreateEditorialReviewDocument, options);
      }
export type CreateEditorialReviewMutationHookResult = ReturnType<typeof useCreateEditorialReviewMutation>;
export type CreateEditorialReviewMutationResult = Apollo.MutationResult<Generated.CreateEditorialReviewMutation>;
export type CreateEditorialReviewMutationOptions = Apollo.BaseMutationOptions<Generated.CreateEditorialReviewMutation, Generated.CreateEditorialReviewMutationVariables>;
export const GetEditorialReviewEntityDocument = /*#__PURE__*/ gql`
    query getEditorialReviewEntity($id: ID!) {
  entity(id: $id) {
    ...EditorialReviewEntity
  }
}
    ${EditorialReviewEntityFragmentDoc}`;

/**
 * __useGetEditorialReviewEntityQuery__
 *
 * To run a query within a React component, call `useGetEditorialReviewEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorialReviewEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorialReviewEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEditorialReviewEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEditorialReviewEntityQuery, Generated.GetEditorialReviewEntityQueryVariables> & ({ variables: Generated.GetEditorialReviewEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEditorialReviewEntityQuery, Generated.GetEditorialReviewEntityQueryVariables>(GetEditorialReviewEntityDocument, options);
      }
export function useGetEditorialReviewEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEditorialReviewEntityQuery, Generated.GetEditorialReviewEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEditorialReviewEntityQuery, Generated.GetEditorialReviewEntityQueryVariables>(GetEditorialReviewEntityDocument, options);
        }
export function useGetEditorialReviewEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEditorialReviewEntityQuery, Generated.GetEditorialReviewEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEditorialReviewEntityQuery, Generated.GetEditorialReviewEntityQueryVariables>(GetEditorialReviewEntityDocument, options);
        }
export type GetEditorialReviewEntityQueryHookResult = ReturnType<typeof useGetEditorialReviewEntityQuery>;
export type GetEditorialReviewEntityLazyQueryHookResult = ReturnType<typeof useGetEditorialReviewEntityLazyQuery>;
export type GetEditorialReviewEntitySuspenseQueryHookResult = ReturnType<typeof useGetEditorialReviewEntitySuspenseQuery>;
export type GetEditorialReviewEntityQueryResult = Apollo.QueryResult<Generated.GetEditorialReviewEntityQuery, Generated.GetEditorialReviewEntityQueryVariables>;
export const DeleteEditorialReviewDocument = /*#__PURE__*/ gql`
    mutation deleteEditorialReview($editorialReviewId: ID!) {
  deleteEditorialReview(input: {editorialReviewId: $editorialReviewId}) {
    id
  }
}
    `;
export type DeleteEditorialReviewMutationFn = Apollo.MutationFunction<Generated.DeleteEditorialReviewMutation, Generated.DeleteEditorialReviewMutationVariables>;

/**
 * __useDeleteEditorialReviewMutation__
 *
 * To run a mutation, you first call `useDeleteEditorialReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEditorialReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEditorialReviewMutation, { data, loading, error }] = useDeleteEditorialReviewMutation({
 *   variables: {
 *      editorialReviewId: // value for 'editorialReviewId'
 *   },
 * });
 */
export function useDeleteEditorialReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteEditorialReviewMutation, Generated.DeleteEditorialReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteEditorialReviewMutation, Generated.DeleteEditorialReviewMutationVariables>(DeleteEditorialReviewDocument, options);
      }
export type DeleteEditorialReviewMutationHookResult = ReturnType<typeof useDeleteEditorialReviewMutation>;
export type DeleteEditorialReviewMutationResult = Apollo.MutationResult<Generated.DeleteEditorialReviewMutation>;
export type DeleteEditorialReviewMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteEditorialReviewMutation, Generated.DeleteEditorialReviewMutationVariables>;
export const GetEditorialReviewEntityCountDocument = /*#__PURE__*/ gql`
    query getEditorialReviewEntityCount($brandId: ID!, $entityId: ID!) {
  editorialReviews(limit: 0, brandId: $brandId, entityIds: [$entityId]) {
    totalCount
  }
}
    `;

/**
 * __useGetEditorialReviewEntityCountQuery__
 *
 * To run a query within a React component, call `useGetEditorialReviewEntityCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorialReviewEntityCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorialReviewEntityCountQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEditorialReviewEntityCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEditorialReviewEntityCountQuery, Generated.GetEditorialReviewEntityCountQueryVariables> & ({ variables: Generated.GetEditorialReviewEntityCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEditorialReviewEntityCountQuery, Generated.GetEditorialReviewEntityCountQueryVariables>(GetEditorialReviewEntityCountDocument, options);
      }
export function useGetEditorialReviewEntityCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEditorialReviewEntityCountQuery, Generated.GetEditorialReviewEntityCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEditorialReviewEntityCountQuery, Generated.GetEditorialReviewEntityCountQueryVariables>(GetEditorialReviewEntityCountDocument, options);
        }
export function useGetEditorialReviewEntityCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEditorialReviewEntityCountQuery, Generated.GetEditorialReviewEntityCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEditorialReviewEntityCountQuery, Generated.GetEditorialReviewEntityCountQueryVariables>(GetEditorialReviewEntityCountDocument, options);
        }
export type GetEditorialReviewEntityCountQueryHookResult = ReturnType<typeof useGetEditorialReviewEntityCountQuery>;
export type GetEditorialReviewEntityCountLazyQueryHookResult = ReturnType<typeof useGetEditorialReviewEntityCountLazyQuery>;
export type GetEditorialReviewEntityCountSuspenseQueryHookResult = ReturnType<typeof useGetEditorialReviewEntityCountSuspenseQuery>;
export type GetEditorialReviewEntityCountQueryResult = Apollo.QueryResult<Generated.GetEditorialReviewEntityCountQuery, Generated.GetEditorialReviewEntityCountQueryVariables>;
export const LinkAuthorToEditorialReviewDocument = /*#__PURE__*/ gql`
    mutation linkAuthorToEditorialReview($input: LinkAuthorToEditorialReviewInput!) {
  linkAuthorToEditorialReview(input: $input) {
    id
  }
}
    `;
export type LinkAuthorToEditorialReviewMutationFn = Apollo.MutationFunction<Generated.LinkAuthorToEditorialReviewMutation, Generated.LinkAuthorToEditorialReviewMutationVariables>;

/**
 * __useLinkAuthorToEditorialReviewMutation__
 *
 * To run a mutation, you first call `useLinkAuthorToEditorialReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAuthorToEditorialReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAuthorToEditorialReviewMutation, { data, loading, error }] = useLinkAuthorToEditorialReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkAuthorToEditorialReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.LinkAuthorToEditorialReviewMutation, Generated.LinkAuthorToEditorialReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.LinkAuthorToEditorialReviewMutation, Generated.LinkAuthorToEditorialReviewMutationVariables>(LinkAuthorToEditorialReviewDocument, options);
      }
export type LinkAuthorToEditorialReviewMutationHookResult = ReturnType<typeof useLinkAuthorToEditorialReviewMutation>;
export type LinkAuthorToEditorialReviewMutationResult = Apollo.MutationResult<Generated.LinkAuthorToEditorialReviewMutation>;
export type LinkAuthorToEditorialReviewMutationOptions = Apollo.BaseMutationOptions<Generated.LinkAuthorToEditorialReviewMutation, Generated.LinkAuthorToEditorialReviewMutationVariables>;
export const GetEditorialReviewListDocument = /*#__PURE__*/ gql`
    query getEditorialReviewList($limit: Int, $brandId: ID, $offset: Int, $entityIds: [ID!], $search: String) {
  editorialReviews(
    limit: $limit
    brandId: $brandId
    offset: $offset
    entityIds: $entityIds
    search: $search
  ) {
    totalCount
    nodes {
      __typename
      id
      ref
      title
      active
      rating
      metadata {
        createdBy {
          ...MetadataUser
        }
        updatedAt
        createdAt
      }
      authors {
        author {
          __typename
          ref
          name
        }
      }
      entity {
        ...EditorialReviewEntity
      }
    }
  }
}
    ${MetadataUserFragmentDoc}
${EditorialReviewEntityFragmentDoc}`;

/**
 * __useGetEditorialReviewListQuery__
 *
 * To run a query within a React component, call `useGetEditorialReviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorialReviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorialReviewListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      brandId: // value for 'brandId'
 *      offset: // value for 'offset'
 *      entityIds: // value for 'entityIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEditorialReviewListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetEditorialReviewListQuery, Generated.GetEditorialReviewListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEditorialReviewListQuery, Generated.GetEditorialReviewListQueryVariables>(GetEditorialReviewListDocument, options);
      }
export function useGetEditorialReviewListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEditorialReviewListQuery, Generated.GetEditorialReviewListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEditorialReviewListQuery, Generated.GetEditorialReviewListQueryVariables>(GetEditorialReviewListDocument, options);
        }
export function useGetEditorialReviewListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEditorialReviewListQuery, Generated.GetEditorialReviewListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEditorialReviewListQuery, Generated.GetEditorialReviewListQueryVariables>(GetEditorialReviewListDocument, options);
        }
export type GetEditorialReviewListQueryHookResult = ReturnType<typeof useGetEditorialReviewListQuery>;
export type GetEditorialReviewListLazyQueryHookResult = ReturnType<typeof useGetEditorialReviewListLazyQuery>;
export type GetEditorialReviewListSuspenseQueryHookResult = ReturnType<typeof useGetEditorialReviewListSuspenseQuery>;
export type GetEditorialReviewListQueryResult = Apollo.QueryResult<Generated.GetEditorialReviewListQuery, Generated.GetEditorialReviewListQueryVariables>;
export const GetEditorialReviewDocument = /*#__PURE__*/ gql`
    query getEditorialReview($id: ID!) {
  editorialReview(id: $id) {
    ...EditorialReview
    ...EditorialReviewAuthors
    ...EditorialReviewBody
    ...EditorialReviewIdentity
    ...EditorialReviewMetadata
    ...EditorialReviewPicture
    ...EditorialReviewPublications
  }
}
    ${EditorialReviewFragmentDoc}
${EditorialReviewAuthorsFragmentDoc}
${EditorialReviewBodyFragmentDoc}
${EditorialReviewIdentityFragmentDoc}
${EditorialReviewMetadataFragmentDoc}
${EditorialReviewPictureFragmentDoc}
${EditorialReviewPublicationsFragmentDoc}`;

/**
 * __useGetEditorialReviewQuery__
 *
 * To run a query within a React component, call `useGetEditorialReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorialReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorialReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEditorialReviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEditorialReviewQuery, Generated.GetEditorialReviewQueryVariables> & ({ variables: Generated.GetEditorialReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEditorialReviewQuery, Generated.GetEditorialReviewQueryVariables>(GetEditorialReviewDocument, options);
      }
export function useGetEditorialReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEditorialReviewQuery, Generated.GetEditorialReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEditorialReviewQuery, Generated.GetEditorialReviewQueryVariables>(GetEditorialReviewDocument, options);
        }
export function useGetEditorialReviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEditorialReviewQuery, Generated.GetEditorialReviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEditorialReviewQuery, Generated.GetEditorialReviewQueryVariables>(GetEditorialReviewDocument, options);
        }
export type GetEditorialReviewQueryHookResult = ReturnType<typeof useGetEditorialReviewQuery>;
export type GetEditorialReviewLazyQueryHookResult = ReturnType<typeof useGetEditorialReviewLazyQuery>;
export type GetEditorialReviewSuspenseQueryHookResult = ReturnType<typeof useGetEditorialReviewSuspenseQuery>;
export type GetEditorialReviewQueryResult = Apollo.QueryResult<Generated.GetEditorialReviewQuery, Generated.GetEditorialReviewQueryVariables>;
export const MoveAuthorInEditorialReviewsDocument = /*#__PURE__*/ gql`
    mutation moveAuthorInEditorialReviews($input: MoveAuthorInEditorialReviewsInput!) {
  moveAuthorInEditorialReviews(input: $input) {
    id
  }
}
    `;
export type MoveAuthorInEditorialReviewsMutationFn = Apollo.MutationFunction<Generated.MoveAuthorInEditorialReviewsMutation, Generated.MoveAuthorInEditorialReviewsMutationVariables>;

/**
 * __useMoveAuthorInEditorialReviewsMutation__
 *
 * To run a mutation, you first call `useMoveAuthorInEditorialReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAuthorInEditorialReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAuthorInEditorialReviewsMutation, { data, loading, error }] = useMoveAuthorInEditorialReviewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveAuthorInEditorialReviewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.MoveAuthorInEditorialReviewsMutation, Generated.MoveAuthorInEditorialReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.MoveAuthorInEditorialReviewsMutation, Generated.MoveAuthorInEditorialReviewsMutationVariables>(MoveAuthorInEditorialReviewsDocument, options);
      }
export type MoveAuthorInEditorialReviewsMutationHookResult = ReturnType<typeof useMoveAuthorInEditorialReviewsMutation>;
export type MoveAuthorInEditorialReviewsMutationResult = Apollo.MutationResult<Generated.MoveAuthorInEditorialReviewsMutation>;
export type MoveAuthorInEditorialReviewsMutationOptions = Apollo.BaseMutationOptions<Generated.MoveAuthorInEditorialReviewsMutation, Generated.MoveAuthorInEditorialReviewsMutationVariables>;
export const UpdateEditorialReviewDocument = /*#__PURE__*/ gql`
    mutation updateEditorialReview($input: UpdateEditorialReviewInput!) {
  updateEditorialReview(input: $input) {
    id
    active
    body
    bodyShort
    rating
    title
    picture {
      id
      url
    }
  }
}
    `;
export type UpdateEditorialReviewMutationFn = Apollo.MutationFunction<Generated.UpdateEditorialReviewMutation, Generated.UpdateEditorialReviewMutationVariables>;

/**
 * __useUpdateEditorialReviewMutation__
 *
 * To run a mutation, you first call `useUpdateEditorialReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEditorialReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEditorialReviewMutation, { data, loading, error }] = useUpdateEditorialReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEditorialReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateEditorialReviewMutation, Generated.UpdateEditorialReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateEditorialReviewMutation, Generated.UpdateEditorialReviewMutationVariables>(UpdateEditorialReviewDocument, options);
      }
export type UpdateEditorialReviewMutationHookResult = ReturnType<typeof useUpdateEditorialReviewMutation>;
export type UpdateEditorialReviewMutationResult = Apollo.MutationResult<Generated.UpdateEditorialReviewMutation>;
export type UpdateEditorialReviewMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateEditorialReviewMutation, Generated.UpdateEditorialReviewMutationVariables>;
export const UnlinkAuthorFromEditorialReviewDocument = /*#__PURE__*/ gql`
    mutation unlinkAuthorFromEditorialReview($input: UnlinkAuthorFromEditorialReviewInput!) {
  unlinkAuthorFromEditorialReview(input: $input) {
    id
  }
}
    `;
export type UnlinkAuthorFromEditorialReviewMutationFn = Apollo.MutationFunction<Generated.UnlinkAuthorFromEditorialReviewMutation, Generated.UnlinkAuthorFromEditorialReviewMutationVariables>;

/**
 * __useUnlinkAuthorFromEditorialReviewMutation__
 *
 * To run a mutation, you first call `useUnlinkAuthorFromEditorialReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAuthorFromEditorialReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAuthorFromEditorialReviewMutation, { data, loading, error }] = useUnlinkAuthorFromEditorialReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkAuthorFromEditorialReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UnlinkAuthorFromEditorialReviewMutation, Generated.UnlinkAuthorFromEditorialReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UnlinkAuthorFromEditorialReviewMutation, Generated.UnlinkAuthorFromEditorialReviewMutationVariables>(UnlinkAuthorFromEditorialReviewDocument, options);
      }
export type UnlinkAuthorFromEditorialReviewMutationHookResult = ReturnType<typeof useUnlinkAuthorFromEditorialReviewMutation>;
export type UnlinkAuthorFromEditorialReviewMutationResult = Apollo.MutationResult<Generated.UnlinkAuthorFromEditorialReviewMutation>;
export type UnlinkAuthorFromEditorialReviewMutationOptions = Apollo.BaseMutationOptions<Generated.UnlinkAuthorFromEditorialReviewMutation, Generated.UnlinkAuthorFromEditorialReviewMutationVariables>;
export const CreatePressReviewDocument = /*#__PURE__*/ gql`
    mutation createPressReview($input: CreatePressReviewInput!) {
  createPressReview(input: $input) {
    id
    entity {
      ...PressReviewEntity
    }
  }
}
    ${PressReviewEntityFragmentDoc}`;
export type CreatePressReviewMutationFn = Apollo.MutationFunction<Generated.CreatePressReviewMutation, Generated.CreatePressReviewMutationVariables>;

/**
 * __useCreatePressReviewMutation__
 *
 * To run a mutation, you first call `useCreatePressReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePressReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPressReviewMutation, { data, loading, error }] = useCreatePressReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePressReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreatePressReviewMutation, Generated.CreatePressReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreatePressReviewMutation, Generated.CreatePressReviewMutationVariables>(CreatePressReviewDocument, options);
      }
export type CreatePressReviewMutationHookResult = ReturnType<typeof useCreatePressReviewMutation>;
export type CreatePressReviewMutationResult = Apollo.MutationResult<Generated.CreatePressReviewMutation>;
export type CreatePressReviewMutationOptions = Apollo.BaseMutationOptions<Generated.CreatePressReviewMutation, Generated.CreatePressReviewMutationVariables>;
export const DeletePressReviewDocument = /*#__PURE__*/ gql`
    mutation deletePressReview($pressReviewId: ID!) {
  deletePressReview(input: {pressReviewId: $pressReviewId}) {
    id
  }
}
    `;
export type DeletePressReviewMutationFn = Apollo.MutationFunction<Generated.DeletePressReviewMutation, Generated.DeletePressReviewMutationVariables>;

/**
 * __useDeletePressReviewMutation__
 *
 * To run a mutation, you first call `useDeletePressReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePressReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePressReviewMutation, { data, loading, error }] = useDeletePressReviewMutation({
 *   variables: {
 *      pressReviewId: // value for 'pressReviewId'
 *   },
 * });
 */
export function useDeletePressReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeletePressReviewMutation, Generated.DeletePressReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeletePressReviewMutation, Generated.DeletePressReviewMutationVariables>(DeletePressReviewDocument, options);
      }
export type DeletePressReviewMutationHookResult = ReturnType<typeof useDeletePressReviewMutation>;
export type DeletePressReviewMutationResult = Apollo.MutationResult<Generated.DeletePressReviewMutation>;
export type DeletePressReviewMutationOptions = Apollo.BaseMutationOptions<Generated.DeletePressReviewMutation, Generated.DeletePressReviewMutationVariables>;
export const PressReviewEntityDocument = /*#__PURE__*/ gql`
    query PressReviewEntity($id: ID!) {
  entity(id: $id) {
    ...PressReviewEntity
  }
}
    ${PressReviewEntityFragmentDoc}`;

/**
 * __usePressReviewEntityQuery__
 *
 * To run a query within a React component, call `usePressReviewEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressReviewEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressReviewEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePressReviewEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.PressReviewEntityQuery, Generated.PressReviewEntityQueryVariables> & ({ variables: Generated.PressReviewEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.PressReviewEntityQuery, Generated.PressReviewEntityQueryVariables>(PressReviewEntityDocument, options);
      }
export function usePressReviewEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.PressReviewEntityQuery, Generated.PressReviewEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.PressReviewEntityQuery, Generated.PressReviewEntityQueryVariables>(PressReviewEntityDocument, options);
        }
export function usePressReviewEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.PressReviewEntityQuery, Generated.PressReviewEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.PressReviewEntityQuery, Generated.PressReviewEntityQueryVariables>(PressReviewEntityDocument, options);
        }
export type PressReviewEntityQueryHookResult = ReturnType<typeof usePressReviewEntityQuery>;
export type PressReviewEntityLazyQueryHookResult = ReturnType<typeof usePressReviewEntityLazyQuery>;
export type PressReviewEntitySuspenseQueryHookResult = ReturnType<typeof usePressReviewEntitySuspenseQuery>;
export type PressReviewEntityQueryResult = Apollo.QueryResult<Generated.PressReviewEntityQuery, Generated.PressReviewEntityQueryVariables>;
export const GetPressReviewEntityCountDocument = /*#__PURE__*/ gql`
    query getPressReviewEntityCount($brandId: ID!, $companyId: ID!, $entityId: ID!) {
  pressReviews(
    limit: 0
    brandId: $brandId
    companyIds: [$companyId]
    entityIds: [$entityId]
  ) {
    totalCount
  }
}
    `;

/**
 * __useGetPressReviewEntityCountQuery__
 *
 * To run a query within a React component, call `useGetPressReviewEntityCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressReviewEntityCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressReviewEntityCountQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      companyId: // value for 'companyId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetPressReviewEntityCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPressReviewEntityCountQuery, Generated.GetPressReviewEntityCountQueryVariables> & ({ variables: Generated.GetPressReviewEntityCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPressReviewEntityCountQuery, Generated.GetPressReviewEntityCountQueryVariables>(GetPressReviewEntityCountDocument, options);
      }
export function useGetPressReviewEntityCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPressReviewEntityCountQuery, Generated.GetPressReviewEntityCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPressReviewEntityCountQuery, Generated.GetPressReviewEntityCountQueryVariables>(GetPressReviewEntityCountDocument, options);
        }
export function useGetPressReviewEntityCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPressReviewEntityCountQuery, Generated.GetPressReviewEntityCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPressReviewEntityCountQuery, Generated.GetPressReviewEntityCountQueryVariables>(GetPressReviewEntityCountDocument, options);
        }
export type GetPressReviewEntityCountQueryHookResult = ReturnType<typeof useGetPressReviewEntityCountQuery>;
export type GetPressReviewEntityCountLazyQueryHookResult = ReturnType<typeof useGetPressReviewEntityCountLazyQuery>;
export type GetPressReviewEntityCountSuspenseQueryHookResult = ReturnType<typeof useGetPressReviewEntityCountSuspenseQuery>;
export type GetPressReviewEntityCountQueryResult = Apollo.QueryResult<Generated.GetPressReviewEntityCountQuery, Generated.GetPressReviewEntityCountQueryVariables>;
export const GetPressReviewListDocument = /*#__PURE__*/ gql`
    query getPressReviewList($limit: Int, $brandId: ID, $companyIds: [ID!], $offset: Int, $entityIds: [ID!], $search: String) {
  pressReviews(
    limit: $limit
    brandId: $brandId
    companyIds: $companyIds
    offset: $offset
    entityIds: $entityIds
    search: $search
  ) {
    totalCount
    nodes {
      ...PressReviewRow
    }
  }
}
    ${PressReviewRowFragmentDoc}`;

/**
 * __useGetPressReviewListQuery__
 *
 * To run a query within a React component, call `useGetPressReviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressReviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressReviewListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      brandId: // value for 'brandId'
 *      companyIds: // value for 'companyIds'
 *      offset: // value for 'offset'
 *      entityIds: // value for 'entityIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPressReviewListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetPressReviewListQuery, Generated.GetPressReviewListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPressReviewListQuery, Generated.GetPressReviewListQueryVariables>(GetPressReviewListDocument, options);
      }
export function useGetPressReviewListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPressReviewListQuery, Generated.GetPressReviewListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPressReviewListQuery, Generated.GetPressReviewListQueryVariables>(GetPressReviewListDocument, options);
        }
export function useGetPressReviewListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPressReviewListQuery, Generated.GetPressReviewListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPressReviewListQuery, Generated.GetPressReviewListQueryVariables>(GetPressReviewListDocument, options);
        }
export type GetPressReviewListQueryHookResult = ReturnType<typeof useGetPressReviewListQuery>;
export type GetPressReviewListLazyQueryHookResult = ReturnType<typeof useGetPressReviewListLazyQuery>;
export type GetPressReviewListSuspenseQueryHookResult = ReturnType<typeof useGetPressReviewListSuspenseQuery>;
export type GetPressReviewListQueryResult = Apollo.QueryResult<Generated.GetPressReviewListQuery, Generated.GetPressReviewListQueryVariables>;
export const UpdatePressReviewDocument = /*#__PURE__*/ gql`
    mutation updatePressReview($input: UpdatePressReviewInput!) {
  updatePressReview(input: $input) {
    ...PressReviewIdentity
  }
}
    ${PressReviewIdentityFragmentDoc}`;
export type UpdatePressReviewMutationFn = Apollo.MutationFunction<Generated.UpdatePressReviewMutation, Generated.UpdatePressReviewMutationVariables>;

/**
 * __useUpdatePressReviewMutation__
 *
 * To run a mutation, you first call `useUpdatePressReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePressReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePressReviewMutation, { data, loading, error }] = useUpdatePressReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePressReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdatePressReviewMutation, Generated.UpdatePressReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdatePressReviewMutation, Generated.UpdatePressReviewMutationVariables>(UpdatePressReviewDocument, options);
      }
export type UpdatePressReviewMutationHookResult = ReturnType<typeof useUpdatePressReviewMutation>;
export type UpdatePressReviewMutationResult = Apollo.MutationResult<Generated.UpdatePressReviewMutation>;
export type UpdatePressReviewMutationOptions = Apollo.BaseMutationOptions<Generated.UpdatePressReviewMutation, Generated.UpdatePressReviewMutationVariables>;
export const GetPressReviewDocument = /*#__PURE__*/ gql`
    query getPressReview($id: ID!) {
  pressReview(id: $id) {
    ...PressReviewIdentity
    ...PressReviewMetadata
  }
}
    ${PressReviewIdentityFragmentDoc}
${PressReviewMetadataFragmentDoc}`;

/**
 * __useGetPressReviewQuery__
 *
 * To run a query within a React component, call `useGetPressReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPressReviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetPressReviewQuery, Generated.GetPressReviewQueryVariables> & ({ variables: Generated.GetPressReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetPressReviewQuery, Generated.GetPressReviewQueryVariables>(GetPressReviewDocument, options);
      }
export function useGetPressReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetPressReviewQuery, Generated.GetPressReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetPressReviewQuery, Generated.GetPressReviewQueryVariables>(GetPressReviewDocument, options);
        }
export function useGetPressReviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetPressReviewQuery, Generated.GetPressReviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetPressReviewQuery, Generated.GetPressReviewQueryVariables>(GetPressReviewDocument, options);
        }
export type GetPressReviewQueryHookResult = ReturnType<typeof useGetPressReviewQuery>;
export type GetPressReviewLazyQueryHookResult = ReturnType<typeof useGetPressReviewLazyQuery>;
export type GetPressReviewSuspenseQueryHookResult = ReturnType<typeof useGetPressReviewSuspenseQuery>;
export type GetPressReviewQueryResult = Apollo.QueryResult<Generated.GetPressReviewQuery, Generated.GetPressReviewQueryVariables>;
export const UpdateUserReviewDocument = /*#__PURE__*/ gql`
    mutation updateUserReview($id: ID!, $status: UserReviewStatus!) {
  updateUserReview(input: {id: $id, status: $status}) {
    id
    status
  }
}
    `;
export type UpdateUserReviewMutationFn = Apollo.MutationFunction<Generated.UpdateUserReviewMutation, Generated.UpdateUserReviewMutationVariables>;

/**
 * __useUpdateUserReviewMutation__
 *
 * To run a mutation, you first call `useUpdateUserReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserReviewMutation, { data, loading, error }] = useUpdateUserReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateUserReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateUserReviewMutation, Generated.UpdateUserReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateUserReviewMutation, Generated.UpdateUserReviewMutationVariables>(UpdateUserReviewDocument, options);
      }
export type UpdateUserReviewMutationHookResult = ReturnType<typeof useUpdateUserReviewMutation>;
export type UpdateUserReviewMutationResult = Apollo.MutationResult<Generated.UpdateUserReviewMutation>;
export type UpdateUserReviewMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateUserReviewMutation, Generated.UpdateUserReviewMutationVariables>;
export const GetRatingListDocument = /*#__PURE__*/ gql`
    query getRatingList($limit: Int, $brandId: ID!, $localeId: ID = "", $offset: Int, $entityIds: [ID!], $entityTypes: [SocialRatingsEntityType!], $search: String, $email: String, $nickname: String, $onlyReviews: Boolean, $from: DateTimeISO, $to: DateTimeISO, $ratings: [Int!], $statuses: [UserReviewStatus!], $active: Boolean, $orderBy: SocialRatingsOrder, $includeBrandData: Boolean = false, $includeLocaleData: Boolean = false) {
  userRatings(
    limit: $limit
    brandId: $brandId
    offset: $offset
    entityIds: $entityIds
    entityTypes: $entityTypes
    search: $search
    email: $email
    nickname: $nickname
    onlyReviews: $onlyReviews
    from: $from
    to: $to
    ratings: $ratings
    statuses: $statuses
    active: $active
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...RatingIdentity
    }
  }
}
    ${RatingIdentityFragmentDoc}`;

/**
 * __useGetRatingListQuery__
 *
 * To run a query within a React component, call `useGetRatingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatingListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      brandId: // value for 'brandId'
 *      localeId: // value for 'localeId'
 *      offset: // value for 'offset'
 *      entityIds: // value for 'entityIds'
 *      entityTypes: // value for 'entityTypes'
 *      search: // value for 'search'
 *      email: // value for 'email'
 *      nickname: // value for 'nickname'
 *      onlyReviews: // value for 'onlyReviews'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      ratings: // value for 'ratings'
 *      statuses: // value for 'statuses'
 *      active: // value for 'active'
 *      orderBy: // value for 'orderBy'
 *      includeBrandData: // value for 'includeBrandData'
 *      includeLocaleData: // value for 'includeLocaleData'
 *   },
 * });
 */
export function useGetRatingListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetRatingListQuery, Generated.GetRatingListQueryVariables> & ({ variables: Generated.GetRatingListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetRatingListQuery, Generated.GetRatingListQueryVariables>(GetRatingListDocument, options);
      }
export function useGetRatingListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetRatingListQuery, Generated.GetRatingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetRatingListQuery, Generated.GetRatingListQueryVariables>(GetRatingListDocument, options);
        }
export function useGetRatingListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetRatingListQuery, Generated.GetRatingListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetRatingListQuery, Generated.GetRatingListQueryVariables>(GetRatingListDocument, options);
        }
export type GetRatingListQueryHookResult = ReturnType<typeof useGetRatingListQuery>;
export type GetRatingListLazyQueryHookResult = ReturnType<typeof useGetRatingListLazyQuery>;
export type GetRatingListSuspenseQueryHookResult = ReturnType<typeof useGetRatingListSuspenseQuery>;
export type GetRatingListQueryResult = Apollo.QueryResult<Generated.GetRatingListQuery, Generated.GetRatingListQueryVariables>;
export const AddImageToCategoryDocument = /*#__PURE__*/ gql`
    mutation AddImageToCategory($input: AddImageToCategoryInput!) {
  addImageToCategory(input: $input) {
    ...ImageHasCategory
  }
}
    ${ImageHasCategoryFragmentDoc}`;
export type AddImageToCategoryMutationFn = Apollo.MutationFunction<Generated.AddImageToCategoryMutation, Generated.AddImageToCategoryMutationVariables>;

/**
 * __useAddImageToCategoryMutation__
 *
 * To run a mutation, you first call `useAddImageToCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddImageToCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addImageToCategoryMutation, { data, loading, error }] = useAddImageToCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddImageToCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.AddImageToCategoryMutation, Generated.AddImageToCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.AddImageToCategoryMutation, Generated.AddImageToCategoryMutationVariables>(AddImageToCategoryDocument, options);
      }
export type AddImageToCategoryMutationHookResult = ReturnType<typeof useAddImageToCategoryMutation>;
export type AddImageToCategoryMutationResult = Apollo.MutationResult<Generated.AddImageToCategoryMutation>;
export type AddImageToCategoryMutationOptions = Apollo.BaseMutationOptions<Generated.AddImageToCategoryMutation, Generated.AddImageToCategoryMutationVariables>;
export const GetSocialImagesListDocument = /*#__PURE__*/ gql`
    query GetSocialImagesList($categoryId: ID, $onlyUncategorizedAvatarsAndBanners: Boolean, $imageCategoryIds: [ID], $type: ImageType, $hasTTL: Boolean, $brandIds: [ID], $validityFrom: Date, $validityTo: Date, $limit: Int, $offset: Int) {
  socialImagesList(
    categoryId: $categoryId
    onlyUncategorizedAvatarsAndBanners: $onlyUncategorizedAvatarsAndBanners
    imageCategoryIds: $imageCategoryIds
    type: $type
    hasTTL: $hasTTL
    brandIds: $brandIds
    validityFrom: $validityFrom
    validityTo: $validityTo
    limit: $limit
    offset: $offset
  ) {
    totalCount
    maxRank
    nodes {
      ...ImageReferenceFromImageHasCategory
    }
  }
}
    ${ImageReferenceFromImageHasCategoryFragmentDoc}`;

/**
 * __useGetSocialImagesListQuery__
 *
 * To run a query within a React component, call `useGetSocialImagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialImagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialImagesListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      onlyUncategorizedAvatarsAndBanners: // value for 'onlyUncategorizedAvatarsAndBanners'
 *      imageCategoryIds: // value for 'imageCategoryIds'
 *      type: // value for 'type'
 *      hasTTL: // value for 'hasTTL'
 *      brandIds: // value for 'brandIds'
 *      validityFrom: // value for 'validityFrom'
 *      validityTo: // value for 'validityTo'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSocialImagesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetSocialImagesListQuery, Generated.GetSocialImagesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSocialImagesListQuery, Generated.GetSocialImagesListQueryVariables>(GetSocialImagesListDocument, options);
      }
export function useGetSocialImagesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSocialImagesListQuery, Generated.GetSocialImagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSocialImagesListQuery, Generated.GetSocialImagesListQueryVariables>(GetSocialImagesListDocument, options);
        }
export function useGetSocialImagesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSocialImagesListQuery, Generated.GetSocialImagesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSocialImagesListQuery, Generated.GetSocialImagesListQueryVariables>(GetSocialImagesListDocument, options);
        }
export type GetSocialImagesListQueryHookResult = ReturnType<typeof useGetSocialImagesListQuery>;
export type GetSocialImagesListLazyQueryHookResult = ReturnType<typeof useGetSocialImagesListLazyQuery>;
export type GetSocialImagesListSuspenseQueryHookResult = ReturnType<typeof useGetSocialImagesListSuspenseQuery>;
export type GetSocialImagesListQueryResult = Apollo.QueryResult<Generated.GetSocialImagesListQuery, Generated.GetSocialImagesListQueryVariables>;
export const RemoveImageFromCategoryDocument = /*#__PURE__*/ gql`
    mutation RemoveImageFromCategory($input: RemoveImageFromCategoryInput!) {
  removeImageFromCategory(input: $input) {
    ...ImageHasCategory
  }
}
    ${ImageHasCategoryFragmentDoc}`;
export type RemoveImageFromCategoryMutationFn = Apollo.MutationFunction<Generated.RemoveImageFromCategoryMutation, Generated.RemoveImageFromCategoryMutationVariables>;

/**
 * __useRemoveImageFromCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveImageFromCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveImageFromCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeImageFromCategoryMutation, { data, loading, error }] = useRemoveImageFromCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveImageFromCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.RemoveImageFromCategoryMutation, Generated.RemoveImageFromCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.RemoveImageFromCategoryMutation, Generated.RemoveImageFromCategoryMutationVariables>(RemoveImageFromCategoryDocument, options);
      }
export type RemoveImageFromCategoryMutationHookResult = ReturnType<typeof useRemoveImageFromCategoryMutation>;
export type RemoveImageFromCategoryMutationResult = Apollo.MutationResult<Generated.RemoveImageFromCategoryMutation>;
export type RemoveImageFromCategoryMutationOptions = Apollo.BaseMutationOptions<Generated.RemoveImageFromCategoryMutation, Generated.RemoveImageFromCategoryMutationVariables>;
export const UpdateImageInCategoryDocument = /*#__PURE__*/ gql`
    mutation UpdateImageInCategory($input: updateImageInCategoryInput!) {
  updateImageInCategory(input: $input) {
    ...ImageHasCategory
  }
}
    ${ImageHasCategoryFragmentDoc}`;
export type UpdateImageInCategoryMutationFn = Apollo.MutationFunction<Generated.UpdateImageInCategoryMutation, Generated.UpdateImageInCategoryMutationVariables>;

/**
 * __useUpdateImageInCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateImageInCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageInCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageInCategoryMutation, { data, loading, error }] = useUpdateImageInCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageInCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImageInCategoryMutation, Generated.UpdateImageInCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImageInCategoryMutation, Generated.UpdateImageInCategoryMutationVariables>(UpdateImageInCategoryDocument, options);
      }
export type UpdateImageInCategoryMutationHookResult = ReturnType<typeof useUpdateImageInCategoryMutation>;
export type UpdateImageInCategoryMutationResult = Apollo.MutationResult<Generated.UpdateImageInCategoryMutation>;
export type UpdateImageInCategoryMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImageInCategoryMutation, Generated.UpdateImageInCategoryMutationVariables>;
export const DeleteOrAnonymizeSocialUserDocument = /*#__PURE__*/ gql`
    mutation deleteOrAnonymizeSocialUser($input: DeleteOrAnonymizeSocialUserInput!) {
  deleteOrAnonymizeSocialUser(input: $input) {
    id
  }
}
    `;
export type DeleteOrAnonymizeSocialUserMutationFn = Apollo.MutationFunction<Generated.DeleteOrAnonymizeSocialUserMutation, Generated.DeleteOrAnonymizeSocialUserMutationVariables>;

/**
 * __useDeleteOrAnonymizeSocialUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrAnonymizeSocialUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrAnonymizeSocialUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrAnonymizeSocialUserMutation, { data, loading, error }] = useDeleteOrAnonymizeSocialUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrAnonymizeSocialUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteOrAnonymizeSocialUserMutation, Generated.DeleteOrAnonymizeSocialUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteOrAnonymizeSocialUserMutation, Generated.DeleteOrAnonymizeSocialUserMutationVariables>(DeleteOrAnonymizeSocialUserDocument, options);
      }
export type DeleteOrAnonymizeSocialUserMutationHookResult = ReturnType<typeof useDeleteOrAnonymizeSocialUserMutation>;
export type DeleteOrAnonymizeSocialUserMutationResult = Apollo.MutationResult<Generated.DeleteOrAnonymizeSocialUserMutation>;
export type DeleteOrAnonymizeSocialUserMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteOrAnonymizeSocialUserMutation, Generated.DeleteOrAnonymizeSocialUserMutationVariables>;
export const CreateActitoProfileDocument = /*#__PURE__*/ gql`
    mutation createActitoProfile($input: CreateActitoProfileInput!) {
  createActitoProfile(input: $input) {
    ...SocialUserIdentity
    ...SocialMetadata
  }
}
    ${SocialUserIdentityFragmentDoc}
${SocialMetadataFragmentDoc}`;
export type CreateActitoProfileMutationFn = Apollo.MutationFunction<Generated.CreateActitoProfileMutation, Generated.CreateActitoProfileMutationVariables>;

/**
 * __useCreateActitoProfileMutation__
 *
 * To run a mutation, you first call `useCreateActitoProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActitoProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActitoProfileMutation, { data, loading, error }] = useCreateActitoProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActitoProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateActitoProfileMutation, Generated.CreateActitoProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateActitoProfileMutation, Generated.CreateActitoProfileMutationVariables>(CreateActitoProfileDocument, options);
      }
export type CreateActitoProfileMutationHookResult = ReturnType<typeof useCreateActitoProfileMutation>;
export type CreateActitoProfileMutationResult = Apollo.MutationResult<Generated.CreateActitoProfileMutation>;
export type CreateActitoProfileMutationOptions = Apollo.BaseMutationOptions<Generated.CreateActitoProfileMutation, Generated.CreateActitoProfileMutationVariables>;
export const GetSocialUsersDocument = /*#__PURE__*/ gql`
    query getSocialUsers($search: String!) {
  socialUsers(search: $search, limit: 30) {
    totalCount
    nodes {
      id
      ref
      active
      legacyID
      email
      metadata {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetSocialUsersQuery__
 *
 * To run a query within a React component, call `useGetSocialUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSocialUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSocialUsersQuery, Generated.GetSocialUsersQueryVariables> & ({ variables: Generated.GetSocialUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSocialUsersQuery, Generated.GetSocialUsersQueryVariables>(GetSocialUsersDocument, options);
      }
export function useGetSocialUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSocialUsersQuery, Generated.GetSocialUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSocialUsersQuery, Generated.GetSocialUsersQueryVariables>(GetSocialUsersDocument, options);
        }
export function useGetSocialUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSocialUsersQuery, Generated.GetSocialUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSocialUsersQuery, Generated.GetSocialUsersQueryVariables>(GetSocialUsersDocument, options);
        }
export type GetSocialUsersQueryHookResult = ReturnType<typeof useGetSocialUsersQuery>;
export type GetSocialUsersLazyQueryHookResult = ReturnType<typeof useGetSocialUsersLazyQuery>;
export type GetSocialUsersSuspenseQueryHookResult = ReturnType<typeof useGetSocialUsersSuspenseQuery>;
export type GetSocialUsersQueryResult = Apollo.QueryResult<Generated.GetSocialUsersQuery, Generated.GetSocialUsersQueryVariables>;
export const GetSocialUserDocument = /*#__PURE__*/ gql`
    query getSocialUser($ref: ID!) {
  entityByRef(type: SOCIAL_USER, ref: $ref) {
    ... on SocialUser {
      ...SocialMetadata
      ...SocialStats
      ...SocialUserFullIdentity
    }
  }
}
    ${SocialMetadataFragmentDoc}
${SocialStatsFragmentDoc}
${SocialUserFullIdentityFragmentDoc}`;

/**
 * __useGetSocialUserQuery__
 *
 * To run a query within a React component, call `useGetSocialUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialUserQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetSocialUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetSocialUserQuery, Generated.GetSocialUserQueryVariables> & ({ variables: Generated.GetSocialUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetSocialUserQuery, Generated.GetSocialUserQueryVariables>(GetSocialUserDocument, options);
      }
export function useGetSocialUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetSocialUserQuery, Generated.GetSocialUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetSocialUserQuery, Generated.GetSocialUserQueryVariables>(GetSocialUserDocument, options);
        }
export function useGetSocialUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetSocialUserQuery, Generated.GetSocialUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetSocialUserQuery, Generated.GetSocialUserQueryVariables>(GetSocialUserDocument, options);
        }
export type GetSocialUserQueryHookResult = ReturnType<typeof useGetSocialUserQuery>;
export type GetSocialUserLazyQueryHookResult = ReturnType<typeof useGetSocialUserLazyQuery>;
export type GetSocialUserSuspenseQueryHookResult = ReturnType<typeof useGetSocialUserSuspenseQuery>;
export type GetSocialUserQueryResult = Apollo.QueryResult<Generated.GetSocialUserQuery, Generated.GetSocialUserQueryVariables>;
export const UpdateSocialUserDocument = /*#__PURE__*/ gql`
    mutation updateSocialUser($input: UpdateSocialUserInput!) {
  updateSocialUser(input: $input) {
    ...SocialUserFullIdentity
    ...SocialMetadata
  }
}
    ${SocialUserFullIdentityFragmentDoc}
${SocialMetadataFragmentDoc}`;
export type UpdateSocialUserMutationFn = Apollo.MutationFunction<Generated.UpdateSocialUserMutation, Generated.UpdateSocialUserMutationVariables>;

/**
 * __useUpdateSocialUserMutation__
 *
 * To run a mutation, you first call `useUpdateSocialUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialUserMutation, { data, loading, error }] = useUpdateSocialUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocialUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateSocialUserMutation, Generated.UpdateSocialUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateSocialUserMutation, Generated.UpdateSocialUserMutationVariables>(UpdateSocialUserDocument, options);
      }
export type UpdateSocialUserMutationHookResult = ReturnType<typeof useUpdateSocialUserMutation>;
export type UpdateSocialUserMutationResult = Apollo.MutationResult<Generated.UpdateSocialUserMutation>;
export type UpdateSocialUserMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateSocialUserMutation, Generated.UpdateSocialUserMutationVariables>;
export const GetEntityItemEntityDocument = /*#__PURE__*/ gql`
    query getEntityItemEntity($ref: ID!, $type: EntityType!, $brandId: ID! = "", $includeBrandData: Boolean! = false, $withSeoAttributes: Boolean! = false) {
  entityByRef(ref: $ref, type: $type) {
    ... on Movie {
      ...SearchMovie
    }
    ... on Person {
      ...SearchPerson
    }
    ... on Series {
      ...SearchSeries
    }
    ... on SeriesSeason {
      ...SearchSeriesSeason
    }
  }
}
    ${SearchMovieFragmentDoc}
${SearchPersonFragmentDoc}
${SearchSeriesFragmentDoc}
${SearchSeriesSeasonFragmentDoc}`;

/**
 * __useGetEntityItemEntityQuery__
 *
 * To run a query within a React component, call `useGetEntityItemEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityItemEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityItemEntityQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      type: // value for 'type'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useGetEntityItemEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityItemEntityQuery, Generated.GetEntityItemEntityQueryVariables> & ({ variables: Generated.GetEntityItemEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityItemEntityQuery, Generated.GetEntityItemEntityQueryVariables>(GetEntityItemEntityDocument, options);
      }
export function useGetEntityItemEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityItemEntityQuery, Generated.GetEntityItemEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityItemEntityQuery, Generated.GetEntityItemEntityQueryVariables>(GetEntityItemEntityDocument, options);
        }
export function useGetEntityItemEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityItemEntityQuery, Generated.GetEntityItemEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityItemEntityQuery, Generated.GetEntityItemEntityQueryVariables>(GetEntityItemEntityDocument, options);
        }
export type GetEntityItemEntityQueryHookResult = ReturnType<typeof useGetEntityItemEntityQuery>;
export type GetEntityItemEntityLazyQueryHookResult = ReturnType<typeof useGetEntityItemEntityLazyQuery>;
export type GetEntityItemEntitySuspenseQueryHookResult = ReturnType<typeof useGetEntityItemEntitySuspenseQuery>;
export type GetEntityItemEntityQueryResult = Apollo.QueryResult<Generated.GetEntityItemEntityQuery, Generated.GetEntityItemEntityQueryVariables>;
export const GetBrandCountryDocument = /*#__PURE__*/ gql`
    query getBrandCountry($brandId: ID!) {
  brand(id: $brandId) {
    id
    country {
      ...CountryOption
    }
  }
}
    ${CountryOptionFragmentDoc}`;

/**
 * __useGetBrandCountryQuery__
 *
 * To run a query within a React component, call `useGetBrandCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCountryQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandCountryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetBrandCountryQuery, Generated.GetBrandCountryQueryVariables> & ({ variables: Generated.GetBrandCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetBrandCountryQuery, Generated.GetBrandCountryQueryVariables>(GetBrandCountryDocument, options);
      }
export function useGetBrandCountryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetBrandCountryQuery, Generated.GetBrandCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetBrandCountryQuery, Generated.GetBrandCountryQueryVariables>(GetBrandCountryDocument, options);
        }
export function useGetBrandCountrySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetBrandCountryQuery, Generated.GetBrandCountryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetBrandCountryQuery, Generated.GetBrandCountryQueryVariables>(GetBrandCountryDocument, options);
        }
export type GetBrandCountryQueryHookResult = ReturnType<typeof useGetBrandCountryQuery>;
export type GetBrandCountryLazyQueryHookResult = ReturnType<typeof useGetBrandCountryLazyQuery>;
export type GetBrandCountrySuspenseQueryHookResult = ReturnType<typeof useGetBrandCountrySuspenseQuery>;
export type GetBrandCountryQueryResult = Apollo.QueryResult<Generated.GetBrandCountryQuery, Generated.GetBrandCountryQueryVariables>;
export const GetBoxofficeDataListDocument = /*#__PURE__*/ gql`
    query getBoxofficeDataList($limit: Int, $countryId: ID!, $movieId: ID, $range: DateRangeInput, $rangeOperator: RangeOperator, $orderBy: TemporalBoxofficeOrder) {
  temporalBoxoffices(
    limit: $limit
    countryId: $countryId
    movieId: $movieId
    range: $range
    rangeOperator: $rangeOperator
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...BoxofficeRelease
    }
  }
}
    ${BoxofficeReleaseFragmentDoc}`;

/**
 * __useGetBoxofficeDataListQuery__
 *
 * To run a query within a React component, call `useGetBoxofficeDataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoxofficeDataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoxofficeDataListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      countryId: // value for 'countryId'
 *      movieId: // value for 'movieId'
 *      range: // value for 'range'
 *      rangeOperator: // value for 'rangeOperator'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetBoxofficeDataListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetBoxofficeDataListQuery, Generated.GetBoxofficeDataListQueryVariables> & ({ variables: Generated.GetBoxofficeDataListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetBoxofficeDataListQuery, Generated.GetBoxofficeDataListQueryVariables>(GetBoxofficeDataListDocument, options);
      }
export function useGetBoxofficeDataListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetBoxofficeDataListQuery, Generated.GetBoxofficeDataListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetBoxofficeDataListQuery, Generated.GetBoxofficeDataListQueryVariables>(GetBoxofficeDataListDocument, options);
        }
export function useGetBoxofficeDataListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetBoxofficeDataListQuery, Generated.GetBoxofficeDataListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetBoxofficeDataListQuery, Generated.GetBoxofficeDataListQueryVariables>(GetBoxofficeDataListDocument, options);
        }
export type GetBoxofficeDataListQueryHookResult = ReturnType<typeof useGetBoxofficeDataListQuery>;
export type GetBoxofficeDataListLazyQueryHookResult = ReturnType<typeof useGetBoxofficeDataListLazyQuery>;
export type GetBoxofficeDataListSuspenseQueryHookResult = ReturnType<typeof useGetBoxofficeDataListSuspenseQuery>;
export type GetBoxofficeDataListQueryResult = Apollo.QueryResult<Generated.GetBoxofficeDataListQuery, Generated.GetBoxofficeDataListQueryVariables>;
export const GetEntityWellKnownRoutesDocument = /*#__PURE__*/ gql`
    query getEntityWellKnownRoutes($brandId: ID!, $entityId: ID!) {
  wysiwyg {
    wellKnownRoutes(brandId: $brandId, entityId: $entityId) {
      ...SelectWellKnownRoute
    }
  }
}
    ${SelectWellKnownRouteFragmentDoc}`;

/**
 * __useGetEntityWellKnownRoutesQuery__
 *
 * To run a query within a React component, call `useGetEntityWellKnownRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityWellKnownRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityWellKnownRoutesQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityWellKnownRoutesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetEntityWellKnownRoutesQuery, Generated.GetEntityWellKnownRoutesQueryVariables> & ({ variables: Generated.GetEntityWellKnownRoutesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetEntityWellKnownRoutesQuery, Generated.GetEntityWellKnownRoutesQueryVariables>(GetEntityWellKnownRoutesDocument, options);
      }
export function useGetEntityWellKnownRoutesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetEntityWellKnownRoutesQuery, Generated.GetEntityWellKnownRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetEntityWellKnownRoutesQuery, Generated.GetEntityWellKnownRoutesQueryVariables>(GetEntityWellKnownRoutesDocument, options);
        }
export function useGetEntityWellKnownRoutesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetEntityWellKnownRoutesQuery, Generated.GetEntityWellKnownRoutesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetEntityWellKnownRoutesQuery, Generated.GetEntityWellKnownRoutesQueryVariables>(GetEntityWellKnownRoutesDocument, options);
        }
export type GetEntityWellKnownRoutesQueryHookResult = ReturnType<typeof useGetEntityWellKnownRoutesQuery>;
export type GetEntityWellKnownRoutesLazyQueryHookResult = ReturnType<typeof useGetEntityWellKnownRoutesLazyQuery>;
export type GetEntityWellKnownRoutesSuspenseQueryHookResult = ReturnType<typeof useGetEntityWellKnownRoutesSuspenseQuery>;
export type GetEntityWellKnownRoutesQueryResult = Apollo.QueryResult<Generated.GetEntityWellKnownRoutesQuery, Generated.GetEntityWellKnownRoutesQueryVariables>;
export const GetLinkableEntityDocument = /*#__PURE__*/ gql`
    query getLinkableEntity($type: EntityType!, $ref: ID!, $brandId: ID! = "", $includeBrandData: Boolean! = false, $withSeoAttributes: Boolean! = false) {
  entityByRef(type: $type, ref: $ref) {
    ... on Company {
      ...SearchCompany
    }
    ... on Movie {
      ...SearchMovie
    }
    ... on News {
      ...SearchNews
    }
    ... on Person {
      ...SearchPerson
    }
    ... on Series {
      ...SearchSeries
    }
    ... on SeriesSeason {
      ...SearchSeriesSeason
    }
  }
}
    ${SearchCompanyFragmentDoc}
${SearchMovieFragmentDoc}
${SearchNewsFragmentDoc}
${SearchPersonFragmentDoc}
${SearchSeriesFragmentDoc}
${SearchSeriesSeasonFragmentDoc}`;

/**
 * __useGetLinkableEntityQuery__
 *
 * To run a query within a React component, call `useGetLinkableEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkableEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkableEntityQuery({
 *   variables: {
 *      type: // value for 'type'
 *      ref: // value for 'ref'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useGetLinkableEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetLinkableEntityQuery, Generated.GetLinkableEntityQueryVariables> & ({ variables: Generated.GetLinkableEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetLinkableEntityQuery, Generated.GetLinkableEntityQueryVariables>(GetLinkableEntityDocument, options);
      }
export function useGetLinkableEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetLinkableEntityQuery, Generated.GetLinkableEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetLinkableEntityQuery, Generated.GetLinkableEntityQueryVariables>(GetLinkableEntityDocument, options);
        }
export function useGetLinkableEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetLinkableEntityQuery, Generated.GetLinkableEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetLinkableEntityQuery, Generated.GetLinkableEntityQueryVariables>(GetLinkableEntityDocument, options);
        }
export type GetLinkableEntityQueryHookResult = ReturnType<typeof useGetLinkableEntityQuery>;
export type GetLinkableEntityLazyQueryHookResult = ReturnType<typeof useGetLinkableEntityLazyQuery>;
export type GetLinkableEntitySuspenseQueryHookResult = ReturnType<typeof useGetLinkableEntitySuspenseQuery>;
export type GetLinkableEntityQueryResult = Apollo.QueryResult<Generated.GetLinkableEntityQuery, Generated.GetLinkableEntityQueryVariables>;
export const RetroengineerUrlDocument = /*#__PURE__*/ gql`
    mutation retroengineerUrl($input: RetroengineerUrlInput!) {
  retroengineerUrl(input: $input) {
    name
    params {
      name
      value
    }
  }
}
    `;
export type RetroengineerUrlMutationFn = Apollo.MutationFunction<Generated.RetroengineerUrlMutation, Generated.RetroengineerUrlMutationVariables>;

/**
 * __useRetroengineerUrlMutation__
 *
 * To run a mutation, you first call `useRetroengineerUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetroengineerUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retroengineerUrlMutation, { data, loading, error }] = useRetroengineerUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetroengineerUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.RetroengineerUrlMutation, Generated.RetroengineerUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.RetroengineerUrlMutation, Generated.RetroengineerUrlMutationVariables>(RetroengineerUrlDocument, options);
      }
export type RetroengineerUrlMutationHookResult = ReturnType<typeof useRetroengineerUrlMutation>;
export type RetroengineerUrlMutationResult = Apollo.MutationResult<Generated.RetroengineerUrlMutation>;
export type RetroengineerUrlMutationOptions = Apollo.BaseMutationOptions<Generated.RetroengineerUrlMutation, Generated.RetroengineerUrlMutationVariables>;
export const GetWellKnownRouteDocument = /*#__PURE__*/ gql`
    query getWellKnownRoute($route: String!, $params: [WebsiteRouteParamInput!]!, $brandId: ID! = "", $includeBrandData: Boolean! = false, $withSeoAttributes: Boolean! = false) {
  wysiwyg {
    wellKnownRoute(route: $route, brandId: $brandId, params: $params) {
      ...WellKnownRoute
    }
  }
}
    ${WellKnownRouteFragmentDoc}`;

/**
 * __useGetWellKnownRouteQuery__
 *
 * To run a query within a React component, call `useGetWellKnownRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWellKnownRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWellKnownRouteQuery({
 *   variables: {
 *      route: // value for 'route'
 *      params: // value for 'params'
 *      brandId: // value for 'brandId'
 *      includeBrandData: // value for 'includeBrandData'
 *      withSeoAttributes: // value for 'withSeoAttributes'
 *   },
 * });
 */
export function useGetWellKnownRouteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetWellKnownRouteQuery, Generated.GetWellKnownRouteQueryVariables> & ({ variables: Generated.GetWellKnownRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetWellKnownRouteQuery, Generated.GetWellKnownRouteQueryVariables>(GetWellKnownRouteDocument, options);
      }
export function useGetWellKnownRouteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetWellKnownRouteQuery, Generated.GetWellKnownRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetWellKnownRouteQuery, Generated.GetWellKnownRouteQueryVariables>(GetWellKnownRouteDocument, options);
        }
export function useGetWellKnownRouteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetWellKnownRouteQuery, Generated.GetWellKnownRouteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetWellKnownRouteQuery, Generated.GetWellKnownRouteQueryVariables>(GetWellKnownRouteDocument, options);
        }
export type GetWellKnownRouteQueryHookResult = ReturnType<typeof useGetWellKnownRouteQuery>;
export type GetWellKnownRouteLazyQueryHookResult = ReturnType<typeof useGetWellKnownRouteLazyQuery>;
export type GetWellKnownRouteSuspenseQueryHookResult = ReturnType<typeof useGetWellKnownRouteSuspenseQuery>;
export type GetWellKnownRouteQueryResult = Apollo.QueryResult<Generated.GetWellKnownRouteQuery, Generated.GetWellKnownRouteQueryVariables>;
export const GetWysiwygVideoDocument = /*#__PURE__*/ gql`
    query getWysiwygVideo($videoRef: ID!) {
  entityByRef(ref: $videoRef, type: VIDEO_LEGACY) {
    ... on VideoLegacy {
      ...SearchVideo
    }
  }
}
    ${SearchVideoFragmentDoc}`;

/**
 * __useGetWysiwygVideoQuery__
 *
 * To run a query within a React component, call `useGetWysiwygVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWysiwygVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWysiwygVideoQuery({
 *   variables: {
 *      videoRef: // value for 'videoRef'
 *   },
 * });
 */
export function useGetWysiwygVideoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Generated.GetWysiwygVideoQuery, Generated.GetWysiwygVideoQueryVariables> & ({ variables: Generated.GetWysiwygVideoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetWysiwygVideoQuery, Generated.GetWysiwygVideoQueryVariables>(GetWysiwygVideoDocument, options);
      }
export function useGetWysiwygVideoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetWysiwygVideoQuery, Generated.GetWysiwygVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetWysiwygVideoQuery, Generated.GetWysiwygVideoQueryVariables>(GetWysiwygVideoDocument, options);
        }
export function useGetWysiwygVideoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetWysiwygVideoQuery, Generated.GetWysiwygVideoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetWysiwygVideoQuery, Generated.GetWysiwygVideoQueryVariables>(GetWysiwygVideoDocument, options);
        }
export type GetWysiwygVideoQueryHookResult = ReturnType<typeof useGetWysiwygVideoQuery>;
export type GetWysiwygVideoLazyQueryHookResult = ReturnType<typeof useGetWysiwygVideoLazyQuery>;
export type GetWysiwygVideoSuspenseQueryHookResult = ReturnType<typeof useGetWysiwygVideoSuspenseQuery>;
export type GetWysiwygVideoQueryResult = Apollo.QueryResult<Generated.GetWysiwygVideoQuery, Generated.GetWysiwygVideoQueryVariables>;
export const CreateImageCategoryDocument = /*#__PURE__*/ gql`
    mutation CreateImageCategory($input: CreateImageCategoryInput!) {
  createImageCategory(input: $input) {
    ...ImageCategory
  }
}
    ${ImageCategoryFragmentDoc}`;
export type CreateImageCategoryMutationFn = Apollo.MutationFunction<Generated.CreateImageCategoryMutation, Generated.CreateImageCategoryMutationVariables>;

/**
 * __useCreateImageCategoryMutation__
 *
 * To run a mutation, you first call `useCreateImageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageCategoryMutation, { data, loading, error }] = useCreateImageCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImageCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.CreateImageCategoryMutation, Generated.CreateImageCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.CreateImageCategoryMutation, Generated.CreateImageCategoryMutationVariables>(CreateImageCategoryDocument, options);
      }
export type CreateImageCategoryMutationHookResult = ReturnType<typeof useCreateImageCategoryMutation>;
export type CreateImageCategoryMutationResult = Apollo.MutationResult<Generated.CreateImageCategoryMutation>;
export type CreateImageCategoryMutationOptions = Apollo.BaseMutationOptions<Generated.CreateImageCategoryMutation, Generated.CreateImageCategoryMutationVariables>;
export const DeleteImageCategoryDocument = /*#__PURE__*/ gql`
    mutation DeleteImageCategory($id: ID!, $brandId: ID!) {
  deleteImageCategory(input: {id: $id, brandId: $brandId})
}
    `;
export type DeleteImageCategoryMutationFn = Apollo.MutationFunction<Generated.DeleteImageCategoryMutation, Generated.DeleteImageCategoryMutationVariables>;

/**
 * __useDeleteImageCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteImageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageCategoryMutation, { data, loading, error }] = useDeleteImageCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useDeleteImageCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.DeleteImageCategoryMutation, Generated.DeleteImageCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.DeleteImageCategoryMutation, Generated.DeleteImageCategoryMutationVariables>(DeleteImageCategoryDocument, options);
      }
export type DeleteImageCategoryMutationHookResult = ReturnType<typeof useDeleteImageCategoryMutation>;
export type DeleteImageCategoryMutationResult = Apollo.MutationResult<Generated.DeleteImageCategoryMutation>;
export type DeleteImageCategoryMutationOptions = Apollo.BaseMutationOptions<Generated.DeleteImageCategoryMutation, Generated.DeleteImageCategoryMutationVariables>;
export const GetImageCategoriesListDocument = /*#__PURE__*/ gql`
    query GetImageCategoriesList($active: Boolean, $brandIds: [ID], $categoryId: ID, $imageTypes: [ImageType], $limit: Int, $offset: Int, $search: String, $orderBy: ImageCategoryOrder) {
  imageCategories(
    active: $active
    brandIds: $brandIds
    categoryId: $categoryId
    imageTypes: $imageTypes
    limit: $limit
    offset: $offset
    search: $search
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      ...ImageCategory
    }
  }
}
    ${ImageCategoryFragmentDoc}`;

/**
 * __useGetImageCategoriesListQuery__
 *
 * To run a query within a React component, call `useGetImageCategoriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageCategoriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageCategoriesListQuery({
 *   variables: {
 *      active: // value for 'active'
 *      brandIds: // value for 'brandIds'
 *      categoryId: // value for 'categoryId'
 *      imageTypes: // value for 'imageTypes'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetImageCategoriesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Generated.GetImageCategoriesListQuery, Generated.GetImageCategoriesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Generated.GetImageCategoriesListQuery, Generated.GetImageCategoriesListQueryVariables>(GetImageCategoriesListDocument, options);
      }
export function useGetImageCategoriesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Generated.GetImageCategoriesListQuery, Generated.GetImageCategoriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Generated.GetImageCategoriesListQuery, Generated.GetImageCategoriesListQueryVariables>(GetImageCategoriesListDocument, options);
        }
export function useGetImageCategoriesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Generated.GetImageCategoriesListQuery, Generated.GetImageCategoriesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Generated.GetImageCategoriesListQuery, Generated.GetImageCategoriesListQueryVariables>(GetImageCategoriesListDocument, options);
        }
export type GetImageCategoriesListQueryHookResult = ReturnType<typeof useGetImageCategoriesListQuery>;
export type GetImageCategoriesListLazyQueryHookResult = ReturnType<typeof useGetImageCategoriesListLazyQuery>;
export type GetImageCategoriesListSuspenseQueryHookResult = ReturnType<typeof useGetImageCategoriesListSuspenseQuery>;
export type GetImageCategoriesListQueryResult = Apollo.QueryResult<Generated.GetImageCategoriesListQuery, Generated.GetImageCategoriesListQueryVariables>;
export const UpdateImageCategoryDocument = /*#__PURE__*/ gql`
    mutation UpdateImageCategory($input: UpdateImageCategoryInput!) {
  updateImageCategory(input: $input) {
    id
    ref
    name
    imageType
    brand {
      id
      name
    }
    sponsored
    rank
    active
  }
}
    `;
export type UpdateImageCategoryMutationFn = Apollo.MutationFunction<Generated.UpdateImageCategoryMutation, Generated.UpdateImageCategoryMutationVariables>;

/**
 * __useUpdateImageCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateImageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageCategoryMutation, { data, loading, error }] = useUpdateImageCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Generated.UpdateImageCategoryMutation, Generated.UpdateImageCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Generated.UpdateImageCategoryMutation, Generated.UpdateImageCategoryMutationVariables>(UpdateImageCategoryDocument, options);
      }
export type UpdateImageCategoryMutationHookResult = ReturnType<typeof useUpdateImageCategoryMutation>;
export type UpdateImageCategoryMutationResult = Apollo.MutationResult<Generated.UpdateImageCategoryMutation>;
export type UpdateImageCategoryMutationOptions = Apollo.BaseMutationOptions<Generated.UpdateImageCategoryMutation, Generated.UpdateImageCategoryMutationVariables>;